{
  "about": [
    "ADV"
  ],
  "search": [
    "NOUN",
    "PROPN"
  ],
  "other": [
    "ADJ"
  ],
  "information": [
    "NOUN",
    "PROPN"
  ],
  "which": [
    "DET"
  ],
  "their": [
    "PRON"
  ],
  "there": [
    "ADV"
  ],
  "contact": [
    "NOUN",
    "VERB"
  ],
  "business": [
    "NOUN",
    "PROPN"
  ],
  "first": [
    "ADV"
  ],
  "would": [
    "AUX"
  ],
  "these": [
    "DET"
  ],
  "click": [
    "VERB"
  ],
  "service": [
    "NOUN",
    "PROPN"
  ],
  "price": [
    "NOUN",
    "PROPN"
  ],
  "people": [
    "NOUN",
    "PROPN"
  ],
  "state": [
    "NOUN",
    "PROPN"
  ],
  "health": [
    "PROPN",
    "NOUN"
  ],
  "world": [
    "NOUN",
    "PROPN"
  ],
  "music": [
    "NOUN",
    "PROPN"
  ],
  "should": [
    "AUX"
  ],
  "product": [
    "NOUN",
    "PROPN"
  ],
  "system": [
    "NOUN",
    "PROPN"
  ],
  "policy": [
    "NOUN",
    "PROPN"
  ],
  "number": [
    "NOUN",
    "PROPN"
  ],
  "please": [
    "INTJ"
  ],
  "available": [
    "ADJ",
    "PROPN"
  ],
  "copyright": [
    "NOUN"
  ],
  "support": [
    "NOUN",
    "VERB"
  ],
  "message": [
    "NOUN",
    "PROPN"
  ],
  "after": [
    "ADP"
  ],
  "video": [
    "NOUN",
    "PROPN"
  ],
  "where": [
    "SCONJ"
  ],
  "public": [
    "ADJ",
    "PROPN"
  ],
  "school": [
    "NOUN"
  ],
  "through": [
    "ADP"
  ],
  "links": [
    "NOUN",
    "PROPN"
  ],
  "review": [
    "NOUN",
    "PROPN"
  ],
  "order": [
    "NOUN",
    "PROPN"
  ],
  "privacy": [
    "NOUN",
    "PROPN"
  ],
  "company": [
    "NOUN",
    "PROPN"
  ],
  "group": [
    "NOUN",
    "PROPN"
  ],
  "under": [
    "ADP"
  ],
  "general": [
    "ADJ",
    "PROPN"
  ],
  "research": [
    "NOUN",
    "PROPN"
  ],
  "university": [
    "PROPN",
    "NOUN"
  ],
  "january": [
    "PROPN"
  ],
  "program": [
    "PROPN",
    "NOUN"
  ],
  "management": [
    "PROPN",
    "NOUN"
  ],
  "could": [
    "AUX"
  ],
  "great": [
    "ADJ",
    "PROPN"
  ],
  "united": [
    "PROPN"
  ],
  "hotel": [
    "PROPN",
    "NOUN"
  ],
  "international": [
    "PROPN",
    "ADJ"
  ],
  "center": [
    "PROPN",
    "NOUN"
  ],
  "store": [
    "NOUN",
    "VERB"
  ],
  "travel": [
    "NOUN",
    "PROPN"
  ],
  "development": [
    "NOUN",
    "PROPN"
  ],
  "report": [
    "NOUN",
    "PROPN"
  ],
  "member": [
    "NOUN",
    "PROPN"
  ],
  "before": [
    "ADP"
  ],
  "right": [
    "ADJ",
    "NOUN"
  ],
  "because": [
    "SCONJ"
  ],
  "local": [
    "ADJ",
    "PROPN"
  ],
  "those": [
    "DET"
  ],
  "office": [
    "NOUN",
    "PROPN"
  ],
  "education": [
    "NOUN",
    "PROPN"
  ],
  "national": [
    "PROPN",
    "ADJ"
  ],
  "design": [
    "NOUN",
    "PROPN"
  ],
  "posted": [
    "VERB"
  ],
  "address": [
    "VERB",
    "NOUN"
  ],
  "community": [
    "NOUN",
    "PROPN"
  ],
  "within": [
    "ADP"
  ],
  "phone": [
    "NOUN",
    "PROPN"
  ],
  "shipping": [
    "VERB",
    "NOUN"
  ],
  "reserved": [
    "VERB"
  ],
  "subject": [
    "ADJ",
    "NOUN"
  ],
  "between": [
    "ADP"
  ],
  "forum": [
    "NOUN",
    "PROPN"
  ],
  "family": [
    "NOUN",
    "PROPN"
  ],
  "based": [
    "VERB"
  ],
  "black": [
    "ADJ",
    "PROPN"
  ],
  "check": [
    "VERB",
    "NOUN"
  ],
  "special": [
    "ADJ",
    "PROPN"
  ],
  "index": [
    "NOUN",
    "PROPN"
  ],
  "being": [
    "AUX"
  ],
  "today": [
    "NOUN",
    "PROPN"
  ],
  "technology": [
    "NOUN",
    "PROPN"
  ],
  "south": [
    "PROPN"
  ],
  "project": [
    "NOUN",
    "PROPN"
  ],
  "version": [
    "NOUN",
    "PROPN"
  ],
  "section": [
    "NOUN",
    "PROPN"
  ],
  "found": [
    "VERB"
  ],
  "sports": [
    "NOUN",
    "PROPN"
  ],
  "house": [
    "NOUN",
    "PROPN"
  ],
  "related": [
    "VERB"
  ],
  "security": [
    "NOUN",
    "PROPN"
  ],
  "county": [
    "NOUN"
  ],
  "american": [
    "PROPN",
    "ADJ"
  ],
  "photo": [
    "NOUN",
    "PROPN"
  ],
  "power": [
    "NOUN",
    "PROPN"
  ],
  "while": [
    "SCONJ"
  ],
  "network": [
    "NOUN",
    "PROPN"
  ],
  "computer": [
    "NOUN",
    "PROPN"
  ],
  "three": [
    "PROPN"
  ],
  "total": [
    "ADJ",
    "PROPN"
  ],
  "place": [
    "NOUN",
    "VERB"
  ],
  "following": [
    "VERB",
    "NOUN"
  ],
  "without": [
    "ADP"
  ],
  "access": [
    "NOUN",
    "PROPN"
  ],
  "think": [
    "VERB",
    "NOUN"
  ],
  "north": [
    "PROPN",
    "NOUN"
  ],
  "current": [
    "ADJ",
    "PROPN"
  ],
  "media": [
    "NOUN",
    "PROPN"
  ],
  "control": [
    "NOUN",
    "PROPN"
  ],
  "water": [
    "NOUN"
  ],
  "history": [
    "NOUN",
    "PROPN"
  ],
  "personal": [
    "ADJ",
    "PROPN"
  ],
  "since": [
    "SCONJ"
  ],
  "guide": [
    "NOUN",
    "PROPN"
  ],
  "directory": [
    "NOUN",
    "PROPN"
  ],
  "board": [
    "NOUN",
    "PROPN"
  ],
  "location": [
    "NOUN",
    "PROPN"
  ],
  "change": [
    "NOUN",
    "VERB"
  ],
  "white": [
    "ADJ",
    "PROPN"
  ],
  "small": [
    "ADJ",
    "PROPN"
  ],
  "rating": [
    "NOUN",
    "PROPN"
  ],
  "government": [
    "NOUN",
    "PROPN"
  ],
  "during": [
    "ADP"
  ],
  "return": [
    "VERB",
    "NOUN"
  ],
  "shopping": [
    "PROPN"
  ],
  "account": [
    "NOUN",
    "PROPN"
  ],
  "times": [
    "NOUN",
    "PROPN"
  ],
  "level": [
    "NOUN",
    "PROPN"
  ],
  "digital": [
    "ADJ",
    "PROPN"
  ],
  "profile": [
    "NOUN",
    "PROPN"
  ],
  "previous": [
    "ADJ",
    "PROPN"
  ],
  "image": [
    "NOUN",
    "PROPN"
  ],
  "department": [
    "NOUN",
    "PROPN"
  ],
  "title": [
    "NOUN",
    "PROPN"
  ],
  "description": [
    "PROPN",
    "NOUN"
  ],
  "insurance": [
    "NOUN",
    "PROPN"
  ],
  "another": [
    "DET"
  ],
  "shall": [
    "AUX"
  ],
  "property": [
    "NOUN",
    "PROPN"
  ],
  "class": [
    "NOUN",
    "PROPN"
  ],
  "still": [
    "ADV"
  ],
  "money": [
    "NOUN",
    "PROPN"
  ],
  "quality": [
    "NOUN",
    "PROPN"
  ],
  "every": [
    "DET"
  ],
  "listing": [
    "VERB",
    "NOUN"
  ],
  "content": [
    "NOUN"
  ],
  "country": [
    "NOUN",
    "PROPN"
  ],
  "private": [
    "ADJ",
    "PROPN"
  ],
  "little": [
    "ADJ"
  ],
  "visit": [
    "VERB"
  ],
  "reply": [
    "NOUN",
    "VERB"
  ],
  "customer": [
    "NOUN",
    "PROPN"
  ],
  "december": [
    "PROPN"
  ],
  "compare": [
    "VERB",
    "PROPN"
  ],
  "include": [
    "VERB",
    "PROPN"
  ],
  "college": [
    "NOUN"
  ],
  "value": [
    "NOUN",
    "PROPN"
  ],
  "article": [
    "NOUN",
    "PROPN"
  ],
  "provide": [
    "VERB",
    "PROPN"
  ],
  "source": [
    "NOUN",
    "PROPN"
  ],
  "author": [
    "NOUN",
    "PROPN"
  ],
  "different": [
    "ADJ"
  ],
  "press": [
    "PROPN",
    "NOUN"
  ],
  "learn": [
    "VERB",
    "PROPN"
  ],
  "around": [
    "ADV"
  ],
  "print": [
    "NOUN",
    "PROPN"
  ],
  "course": [
    "NOUN",
    "PROPN"
  ],
  "canada": [
    "PROPN"
  ],
  "process": [
    "NOUN",
    "PROPN"
  ],
  "stock": [
    "NOUN",
    "PROPN"
  ],
  "training": [
    "NOUN",
    "PROPN"
  ],
  "credit": [
    "NOUN",
    "PROPN"
  ],
  "point": [
    "NOUN",
    "PROPN"
  ],
  "science": [
    "PROPN",
    "NOUN"
  ],
  "advanced": [
    "ADJ",
    "PROPN"
  ],
  "english": [
    "PROPN",
    "ADJ"
  ],
  "estate": [
    "NOUN"
  ],
  "select": [
    "ADJ"
  ],
  "thread": [
    "NOUN",
    "PROPN"
  ],
  "category": [
    "NOUN",
    "PROPN"
  ],
  "large": [
    "ADJ",
    "PROPN"
  ],
  "gallery": [
    "NOUN"
  ],
  "table": [
    "NOUN"
  ],
  "register": [
    "VERB",
    "PROPN"
  ],
  "however": [
    "ADV"
  ],
  "october": [
    "PROPN"
  ],
  "november": [
    "PROPN"
  ],
  "market": [
    "NOUN",
    "PROPN"
  ],
  "library": [
    "NOUN",
    "PROPN"
  ],
  "really": [
    "ADV"
  ],
  "action": [
    "NOUN",
    "PROPN"
  ],
  "start": [
    "VERB",
    "NOUN"
  ],
  "series": [
    "NOUN",
    "PROPN"
  ],
  "model": [
    "NOUN",
    "PROPN"
  ],
  "industry": [
    "NOUN",
    "PROPN"
  ],
  "human": [
    "ADJ",
    "PROPN"
  ],
  "provided": [
    "VERB"
  ],
  "second": [
    "ADJ",
    "NOUN"
  ],
  "movie": [
    "NOUN"
  ],
  "march": [
    "PROPN"
  ],
  "september": [
    "PROPN"
  ],
  "better": [
    "ADJ",
    "PROPN"
  ],
  "yahoo": [
    "PROPN"
  ],
  "going": [
    "VERB"
  ],
  "medical": [
    "ADJ",
    "PROPN"
  ],
  "friend": [
    "NOUN"
  ],
  "server": [
    "PROPN",
    "NOUN"
  ],
  "study": [
    "NOUN",
    "PROPN"
  ],
  "application": [
    "NOUN",
    "PROPN"
  ],
  "staff": [
    "NOUN",
    "PROPN"
  ],
  "feedback": [
    "NOUN",
    "PROPN"
  ],
  "again": [
    "ADV"
  ],
  "looking": [
    "VERB"
  ],
  "april": [
    "PROPN"
  ],
  "never": [
    "ADV"
  ],
  "complete": [
    "VERB",
    "ADJ"
  ],
  "street": [
    "PROPN",
    "NOUN"
  ],
  "topic": [
    "NOUN",
    "PROPN"
  ],
  "comment": [
    "NOUN",
    "VERB"
  ],
  "financial": [
    "ADJ",
    "PROPN"
  ],
  "working": [
    "VERB",
    "NOUN"
  ],
  "against": [
    "ADP"
  ],
  "standard": [
    "PROPN",
    "ADJ"
  ],
  "person": [
    "NOUN",
    "PROPN"
  ],
  "below": [
    "ADP"
  ],
  "mobile": [
    "PROPN",
    "ADJ"
  ],
  "party": [
    "NOUN",
    "PROPN"
  ],
  "payment": [
    "NOUN",
    "PROPN"
  ],
  "equipment": [
    "NOUN",
    "PROPN"
  ],
  "login": [
    "NOUN",
    "VERB"
  ],
  "student": [
    "NOUN"
  ],
  "legal": [
    "ADJ",
    "PROPN"
  ],
  "above": [
    "ADP"
  ],
  "recent": [
    "ADJ",
    "PROPN"
  ],
  "problem": [
    "NOUN",
    "PROPN"
  ],
  "memory": [
    "NOUN",
    "PROPN"
  ],
  "performance": [
    "PROPN",
    "NOUN"
  ],
  "social": [
    "ADJ",
    "PROPN"
  ],
  "august": [
    "PROPN"
  ],
  "quote": [
    "NOUN",
    "PROPN"
  ],
  "language": [
    "NOUN",
    "PROPN"
  ],
  "story": [
    "NOUN",
    "PROPN"
  ],
  "experience": [
    "NOUN",
    "PROPN"
  ],
  "create": [
    "VERB",
    "PROPN"
  ],
  "young": [
    "ADJ",
    "PROPN"
  ],
  "america": [
    "PROPN"
  ],
  "important": [
    "ADJ",
    "PROPN"
  ],
  "field": [
    "NOUN",
    "PROPN"
  ],
  "paper": [
    "NOUN",
    "PROPN"
  ],
  "single": [
    "ADJ",
    "PROPN"
  ],
  "example": [
    "NOUN",
    "PROPN"
  ],
  "additional": [
    "ADJ",
    "PROPN"
  ],
  "password": [
    "NOUN",
    "PROPN"
  ],
  "latest": [
    "ADJ",
    "PROPN"
  ],
  "something": [
    "PRON"
  ],
  "question": [
    "NOUN",
    "PROPN"
  ],
  "night": [
    "NOUN"
  ],
  "texas": [
    "PROPN"
  ],
  "poker": [
    "NOUN"
  ],
  "status": [
    "NOUN",
    "PROPN"
  ],
  "browse": [
    "VERB",
    "PROPN"
  ],
  "issue": [
    "NOUN",
    "PROPN"
  ],
  "range": [
    "NOUN",
    "PROPN"
  ],
  "building": [
    "VERB",
    "NOUN"
  ],
  "seller": [
    "NOUN"
  ],
  "court": [
    "NOUN"
  ],
  "february": [
    "PROPN"
  ],
  "always": [
    "ADV"
  ],
  "result": [
    "NOUN",
    "PROPN"
  ],
  "audio": [
    "NOUN",
    "ADJ"
  ],
  "light": [
    "NOUN",
    "ADJ"
  ],
  "write": [
    "VERB",
    "PROPN"
  ],
  "offer": [
    "VERB",
    "NOUN"
  ],
  "given": [
    "VERB"
  ],
  "event": [
    "NOUN",
    "PROPN"
  ],
  "release": [
    "NOUN",
    "PROPN"
  ],
  "analysis": [
    "NOUN",
    "PROPN"
  ],
  "request": [
    "NOUN",
    "PROPN"
  ],
  "china": [
    "PROPN"
  ],
  "making": [
    "VERB",
    "NOUN"
  ],
  "picture": [
    "NOUN",
    "PROPN"
  ],
  "needs": [
    "VERB",
    "NOUN"
  ],
  "possible": [
    "ADJ",
    "PROPN"
  ],
  "might": [
    "AUX"
  ],
  "professional": [
    "ADJ",
    "PROPN"
  ],
  "month": [
    "NOUN",
    "PROPN"
  ],
  "major": [
    "ADJ",
    "PROPN"
  ],
  "future": [
    "ADJ",
    "NOUN"
  ],
  "space": [
    "NOUN",
    "PROPN"
  ],
  "committee": [
    "PROPN",
    "NOUN"
  ],
  "washington": [
    "PROPN"
  ],
  "meeting": [
    "NOUN",
    "PROPN"
  ],
  "become": [
    "VERB"
  ],
  "interest": [
    "NOUN",
    "PROPN"
  ],
  "child": [
    "NOUN",
    "PROPN"
  ],
  "enter": [
    "VERB",
    "PROPN"
  ],
  "california": [
    "PROPN"
  ],
  "share": [
    "VERB",
    "NOUN"
  ],
  "similar": [
    "ADJ",
    "PROPN"
  ],
  "garden": [
    "NOUN",
    "PROPN"
  ],
  "million": [
    "NUM"
  ],
  "added": [
    "VERB",
    "PROPN"
  ],
  "reference": [
    "NOUN",
    "PROPN"
  ],
  "listed": [
    "VERB"
  ],
  "learning": [
    "VERB",
    "NOUN"
  ],
  "energy": [
    "NOUN",
    "PROPN"
  ],
  "delivery": [
    "NOUN",
    "PROPN"
  ],
  "popular": [
    "ADJ",
    "PROPN"
  ],
  "journal": [
    "PROPN",
    "NOUN"
  ],
  "welcome": [
    "VERB",
    "PROPN"
  ],
  "central": [
    "PROPN",
    "ADJ"
  ],
  "president": [
    "PROPN"
  ],
  "notice": [
    "NOUN",
    "VERB"
  ],
  "original": [
    "ADJ",
    "PROPN"
  ],
  "radio": [
    "NOUN",
    "PROPN"
  ],
  "until": [
    "ADP"
  ],
  "color": [
    "NOUN",
    "PROPN"
  ],
  "council": [
    "PROPN",
    "NOUN"
  ],
  "track": [
    "PROPN",
    "VERB"
  ],
  "australia": [
    "PROPN"
  ],
  "discussion": [
    "NOUN",
    "PROPN"
  ],
  "archive": [
    "PROPN",
    "ADJ"
  ],
  "entertainment": [
    "NOUN"
  ],
  "agreement": [
    "PROPN",
    "NOUN"
  ],
  "format": [
    "NOUN",
    "PROPN"
  ],
  "least": [
    "ADJ"
  ],
  "society": [
    "NOUN"
  ],
  "safety": [
    "NOUN",
    "PROPN"
  ],
  "trade": [
    "NOUN",
    "PROPN"
  ],
  "edition": [
    "NOUN",
    "PROPN"
  ],
  "marketing": [
    "NOUN",
    "PROPN"
  ],
  "further": [
    "ADV"
  ],
  "association": [
    "NOUN",
    "PROPN"
  ],
  "david": [
    "PROPN"
  ],
  "already": [
    "ADV"
  ],
  "green": [
    "ADJ",
    "PROPN"
  ],
  "close": [
    "VERB",
    "ADJ"
  ],
  "common": [
    "ADJ",
    "PROPN"
  ],
  "drive": [
    "VERB",
    "PROPN"
  ],
  "specific": [
    "ADJ",
    "PROPN"
  ],
  "several": [
    "ADJ"
  ],
  "living": [
    "VERB",
    "NOUN"
  ],
  "collection": [
    "NOUN",
    "PROPN"
  ],
  "short": [
    "ADJ",
    "PROPN"
  ],
  "display": [
    "VERB",
    "NOUN"
  ],
  "limited": [
    "VERB",
    "ADJ"
  ],
  "powered": [
    "VERB",
    "ADJ"
  ],
  "director": [
    "PROPN",
    "NOUN"
  ],
  "daily": [
    "ADJ",
    "PROPN"
  ],
  "beach": [
    "NOUN",
    "PROPN"
  ],
  "natural": [
    "ADJ",
    "PROPN"
  ],
  "whether": [
    "SCONJ"
  ],
  "electronics": [
    "NOUN"
  ],
  "period": [
    "NOUN",
    "PROPN"
  ],
  "official": [
    "ADJ",
    "PROPN"
  ],
  "weather": [
    "NOUN"
  ],
  "average": [
    "ADJ",
    "NOUN"
  ],
  "technical": [
    "ADJ",
    "PROPN"
  ],
  "window": [
    "NOUN",
    "PROPN"
  ],
  "region": [
    "NOUN",
    "PROPN"
  ],
  "island": [
    "PROPN"
  ],
  "record": [
    "NOUN",
    "VERB"
  ],
  "direct": [
    "ADJ",
    "PROPN"
  ],
  "conference": [
    "NOUN",
    "PROPN"
  ],
  "environment": [
    "NOUN",
    "PROPN"
  ],
  "district": [
    "NOUN"
  ],
  "calendar": [
    "NOUN",
    "PROPN"
  ],
  "style": [
    "NOUN",
    "PROPN"
  ],
  "front": [
    "ADJ",
    "NOUN"
  ],
  "statement": [
    "NOUN",
    "PROPN"
  ],
  "update": [
    "VERB",
    "NOUN"
  ],
  "early": [
    "ADJ",
    "PROPN"
  ],
  "miles": [
    "NOUN"
  ],
  "sound": [
    "VERB",
    "NOUN"
  ],
  "resource": [
    "NOUN",
    "PROPN"
  ],
  "present": [
    "ADJ",
    "VERB"
  ],
  "either": [
    "ADV"
  ],
  "document": [
    "NOUN",
    "VERB"
  ],
  "works": [
    "VERB",
    "NOUN"
  ],
  "material": [
    "NOUN",
    "PROPN"
  ],
  "written": [
    "VERB"
  ],
  "federal": [
    "ADJ",
    "PROPN"
  ],
  "hosting": [
    "VERB",
    "PROPN"
  ],
  "final": [
    "ADJ",
    "PROPN"
  ],
  "adult": [
    "NOUN"
  ],
  "thing": [
    "NOUN"
  ],
  "cheap": [
    "ADJ"
  ],
  "finance": [
    "PROPN",
    "NOUN"
  ],
  "third": [
    "ADJ",
    "PROPN"
  ],
  "reading": [
    "VERB",
    "NOUN"
  ],
  "individual": [
    "ADJ",
    "NOUN"
  ],
  "cover": [
    "VERB",
    "NOUN"
  ],
  "usually": [
    "ADV"
  ],
  "together": [
    "PROPN",
    "NOUN"
  ],
  "percent": [
    "NOUN",
    "PROPN"
  ],
  "function": [
    "NOUN",
    "PROPN"
  ],
  "getting": [
    "VERB",
    "NOUN"
  ],
  "global": [
    "ADJ",
    "PROPN"
  ],
  "economic": [
    "ADJ",
    "PROPN"
  ],
  "player": [
    "NOUN"
  ],
  "often": [
    "ADV"
  ],
  "subscribe": [
    "VERB",
    "PROPN"
  ],
  "submit": [
    "VERB",
    "PROPN"
  ],
  "amount": [
    "NOUN",
    "PROPN"
  ],
  "watch": [
    "VERB",
    "PROPN"
  ],
  "included": [
    "VERB"
  ],
  "though": [
    "SCONJ"
  ],
  "thanks": [
    "NOUN"
  ],
  "everything": [
    "PRON"
  ],
  "various": [
    "ADJ"
  ],
  "production": [
    "NOUN",
    "PROPN"
  ],
  "commercial": [
    "ADJ",
    "PROPN"
  ],
  "james": [
    "PROPN"
  ],
  "weight": [
    "PROPN",
    "NOUN"
  ],
  "heart": [
    "NOUN",
    "PROPN"
  ],
  "advertising": [
    "NOUN",
    "PROPN"
  ],
  "received": [
    "VERB"
  ],
  "choose": [
    "VERB"
  ],
  "treatment": [
    "NOUN",
    "PROPN"
  ],
  "newsletter": [
    "NOUN",
    "PROPN"
  ],
  "knowledge": [
    "NOUN",
    "PROPN"
  ],
  "magazine": [
    "NOUN"
  ],
  "error": [
    "NOUN",
    "PROPN"
  ],
  "camera": [
    "NOUN"
  ],
  "currently": [
    "PROPN"
  ],
  "construction": [
    "NOUN"
  ],
  "registered": [
    "VERB",
    "PROPN"
  ],
  "clear": [
    "ADJ",
    "PROPN"
  ],
  "receive": [
    "VERB"
  ],
  "domain": [
    "NOUN",
    "PROPN"
  ],
  "chapter": [
    "NOUN"
  ],
  "protection": [
    "NOUN",
    "PROPN"
  ],
  "beauty": [
    "NOUN"
  ],
  "manager": [
    "PROPN",
    "NOUN"
  ],
  "india": [
    "PROPN"
  ],
  "position": [
    "NOUN",
    "VERB"
  ],
  "taken": [
    "VERB"
  ],
  "michael": [
    "PROPN"
  ],
  "known": [
    "VERB",
    "ADJ"
  ],
  "engineering": [
    "PROPN",
    "NOUN"
  ],
  "florida": [
    "PROPN"
  ],
  "simple": [
    "ADJ",
    "PROPN"
  ],
  "quick": [
    "ADJ",
    "PROPN"
  ],
  "wireless": [
    "NOUN"
  ],
  "license": [
    "NOUN",
    "PROPN"
  ],
  "friday": [
    "PROPN"
  ],
  "whole": [
    "ADJ",
    "NOUN"
  ],
  "annual": [
    "ADJ",
    "PROPN"
  ],
  "later": [
    "ADV"
  ],
  "basic": [
    "ADJ",
    "PROPN"
  ],
  "corporate": [
    "ADJ",
    "PROPN"
  ],
  "church": [
    "NOUN"
  ],
  "method": [
    "NOUN",
    "PROPN"
  ],
  "purchase": [
    "NOUN",
    "VERB"
  ],
  "active": [
    "ADJ",
    "PROPN"
  ],
  "response": [
    "NOUN",
    "PROPN"
  ],
  "practice": [
    "NOUN",
    "VERB"
  ],
  "hardware": [
    "NOUN",
    "PROPN"
  ],
  "figure": [
    "VERB",
    "NOUN"
  ],
  "holiday": [
    "NOUN",
    "PROPN"
  ],
  "enough": [
    "ADV"
  ],
  "designed": [
    "VERB"
  ],
  "along": [
    "ADP"
  ],
  "among": [
    "ADP"
  ],
  "death": [
    "NOUN"
  ],
  "writing": [
    "VERB",
    "NOUN"
  ],
  "speed": [
    "NOUN",
    "VERB"
  ],
  "brand": [
    "NOUN",
    "PROPN"
  ],
  "discount": [
    "NOUN",
    "PROPN"
  ],
  "higher": [
    "ADJ"
  ],
  "effects": [
    "NOUN"
  ],
  "remember": [
    "VERB"
  ],
  "yellow": [
    "ADJ",
    "PROPN"
  ],
  "political": [
    "ADJ"
  ],
  "increase": [
    "VERB",
    "NOUN"
  ],
  "advertise": [
    "VERB"
  ],
  "kingdom": [
    "PROPN"
  ],
  "environmental": [
    "ADJ"
  ],
  "thought": [
    "VERB",
    "NOUN"
  ],
  "stuff": [
    "NOUN"
  ],
  "french": [
    "ADJ",
    "PROPN"
  ],
  "storage": [
    "NOUN",
    "PROPN"
  ],
  "japan": [
    "PROPN"
  ],
  "doing": [
    "VERB"
  ],
  "entry": [
    "NOUN",
    "PROPN"
  ],
  "nature": [
    "NOUN",
    "PROPN"
  ],
  "availability": [
    "NOUN",
    "PROPN"
  ],
  "summary": [
    "PROPN",
    "NOUN"
  ],
  "growth": [
    "NOUN",
    "PROPN"
  ],
  "agency": [
    "NOUN",
    "PROPN"
  ],
  "monday": [
    "PROPN"
  ],
  "european": [
    "ADJ"
  ],
  "activity": [
    "NOUN",
    "PROPN"
  ],
  "although": [
    "SCONJ"
  ],
  "western": [
    "PROPN"
  ],
  "income": [
    "NOUN",
    "PROPN"
  ],
  "force": [
    "NOUN",
    "VERB"
  ],
  "employment": [
    "NOUN",
    "PROPN"
  ],
  "overall": [
    "ADJ",
    "PROPN"
  ],
  "river": [
    "NOUN"
  ],
  "commission": [
    "PROPN"
  ],
  "package": [
    "NOUN",
    "PROPN"
  ],
  "contents": [
    "NOUN",
    "PROPN"
  ],
  "engine": [
    "NOUN",
    "PROPN"
  ],
  "album": [
    "NOUN"
  ],
  "regional": [
    "ADJ",
    "PROPN"
  ],
  "administration": [
    "PROPN",
    "NOUN"
  ],
  "institute": [
    "PROPN"
  ],
  "double": [
    "ADJ",
    "VERB"
  ],
  "build": [
    "VERB",
    "NOUN"
  ],
  "screen": [
    "NOUN",
    "PROPN"
  ],
  "exchange": [
    "PROPN",
    "NOUN"
  ],
  "electronic": [
    "ADJ"
  ],
  "continue": [
    "VERB",
    "PROPN"
  ],
  "across": [
    "ADP"
  ],
  "season": [
    "NOUN"
  ],
  "apply": [
    "VERB"
  ],
  "someone": [
    "PRON"
  ],
  "anything": [
    "PRON"
  ],
  "printer": [
    "NOUN"
  ],
  "condition": [
    "NOUN",
    "PROPN"
  ],
  "effective": [
    "ADJ",
    "PROPN"
  ],
  "believe": [
    "VERB"
  ],
  "organization": [
    "NOUN",
    "PROPN"
  ],
  "effect": [
    "NOUN",
    "PROPN"
  ],
  "sunday": [
    "PROPN"
  ],
  "selection": [
    "NOUN",
    "PROPN"
  ],
  "casino": [
    "NOUN"
  ],
  "volume": [
    "NOUN",
    "PROPN"
  ],
  "cross": [
    "ADJ",
    "NOUN"
  ],
  "anyone": [
    "PRON"
  ],
  "mortgage": [
    "NOUN"
  ],
  "silver": [
    "PROPN",
    "NOUN"
  ],
  "corporation": [
    "PROPN"
  ],
  "inside": [
    "ADP"
  ],
  "solution": [
    "NOUN",
    "PROPN"
  ],
  "mature": [
    "ADJ",
    "VERB"
  ],
  "rather": [
    "ADV"
  ],
  "addition": [
    "NOUN",
    "PROPN"
  ],
  "supply": [
    "NOUN",
    "PROPN"
  ],
  "nothing": [
    "PRON"
  ],
  "certain": [
    "ADJ"
  ],
  "executive": [
    "PROPN",
    "ADJ"
  ],
  "running": [
    "VERB",
    "NOUN"
  ],
  "lower": [
    "ADJ",
    "VERB"
  ],
  "necessary": [
    "ADJ"
  ],
  "union": [
    "NOUN",
    "PROPN"
  ],
  "jewelry": [
    "NOUN"
  ],
  "according": [
    "VERB"
  ],
  "clothing": [
    "NOUN"
  ],
  "particular": [
    "ADJ"
  ],
  "robert": [
    "PROPN"
  ],
  "advice": [
    "NOUN"
  ],
  "career": [
    "NOUN",
    "PROPN"
  ],
  "military": [
    "NOUN"
  ],
  "rental": [
    "VERB"
  ],
  "decision": [
    "NOUN",
    "PROPN"
  ],
  "leave": [
    "VERB",
    "NOUN"
  ],
  "british": [
    "PROPN"
  ],
  "teens": [
    "NOUN"
  ],
  "woman": [
    "NOUN"
  ],
  "middle": [
    "NOUN",
    "ADJ"
  ],
  "cable": [
    "NOUN"
  ],
  "taking": [
    "VERB",
    "NOUN"
  ],
  "division": [
    "NOUN",
    "PROPN"
  ],
  "coming": [
    "VERB"
  ],
  "tuesday": [
    "PROPN"
  ],
  "object": [
    "NOUN",
    "PROPN"
  ],
  "lesbian": [
    "PROPN"
  ],
  "appropriate": [
    "ADJ"
  ],
  "machine": [
    "NOUN",
    "PROPN"
  ],
  "length": [
    "NOUN",
    "PROPN"
  ],
  "actually": [
    "ADV"
  ],
  "score": [
    "NOUN",
    "PROPN"
  ],
  "statistics": [
    "NOUN",
    "PROPN"
  ],
  "client": [
    "NOUN",
    "PROPN"
  ],
  "capital": [
    "NOUN",
    "PROPN"
  ],
  "follow": [
    "VERB",
    "NOUN"
  ],
  "sample": [
    "NOUN",
    "PROPN"
  ],
  "investment": [
    "NOUN",
    "PROPN"
  ],
  "shown": [
    "VERB"
  ],
  "saturday": [
    "PROPN"
  ],
  "christmas": [
    "PROPN"
  ],
  "culture": [
    "NOUN",
    "PROPN"
  ],
  "flash": [
    "VERB"
  ],
  "george": [
    "PROPN"
  ],
  "choice": [
    "NOUN",
    "PROPN"
  ],
  "starting": [
    "VERB",
    "NOUN"
  ],
  "registration": [
    "NOUN",
    "PROPN"
  ],
  "thursday": [
    "PROPN"
  ],
  "consumer": [
    "NOUN",
    "PROPN"
  ],
  "airport": [
    "NOUN"
  ],
  "foreign": [
    "ADJ"
  ],
  "artist": [
    "NOUN"
  ],
  "outside": [
    "ADV"
  ],
  "furniture": [
    "NOUN"
  ],
  "channel": [
    "NOUN",
    "PROPN"
  ],
  "letter": [
    "NOUN",
    "PROPN"
  ],
  "wednesday": [
    "PROPN"
  ],
  "structure": [
    "NOUN",
    "PROPN"
  ],
  "summer": [
    "NOUN",
    "PROPN"
  ],
  "allow": [
    "VERB",
    "PROPN"
  ],
  "degree": [
    "NOUN"
  ],
  "contract": [
    "NOUN",
    "PROPN"
  ],
  "button": [
    "PROPN"
  ],
  "super": [
    "ADJ",
    "PROPN"
  ],
  "matter": [
    "NOUN",
    "VERB"
  ],
  "custom": [
    "NOUN",
    "PROPN"
  ],
  "virginia": [
    "PROPN"
  ],
  "almost": [
    "ADV"
  ],
  "multiple": [
    "ADJ",
    "PROPN"
  ],
  "asian": [
    "PROPN"
  ],
  "distribution": [
    "NOUN",
    "PROPN"
  ],
  "editor": [
    "NOUN",
    "PROPN"
  ],
  "industrial": [
    "ADJ"
  ],
  "cause": [
    "PROPN",
    "NOUN"
  ],
  "potential": [
    "ADJ",
    "NOUN"
  ],
  "focus": [
    "NOUN",
    "VERB"
  ],
  "featured": [
    "VERB",
    "ADJ"
  ],
  "female": [
    "NOUN"
  ],
  "responsible": [
    "ADJ",
    "PROPN"
  ],
  "associated": [
    "VERB",
    "ADJ"
  ],
  "thomas": [
    "PROPN"
  ],
  "primary": [
    "ADJ",
    "PROPN"
  ],
  "cancer": [
    "NOUN"
  ],
  "reason": [
    "NOUN",
    "PROPN"
  ],
  "browser": [
    "NOUN",
    "PROPN"
  ],
  "spring": [
    "PROPN",
    "NOUN"
  ],
  "foundation": [
    "PROPN",
    "NOUN"
  ],
  "answer": [
    "VERB",
    "NOUN"
  ],
  "voice": [
    "NOUN",
    "PROPN"
  ],
  "friendly": [
    "ADJ"
  ],
  "schedule": [
    "NOUN",
    "VERB"
  ],
  "communication": [
    "NOUN",
    "PROPN"
  ],
  "purpose": [
    "NOUN",
    "PROPN"
  ],
  "feature": [
    "NOUN",
    "PROPN"
  ],
  "comes": [
    "VERB"
  ],
  "police": [
    "NOUN"
  ],
  "everyone": [
    "PRON"
  ],
  "independent": [
    "ADJ",
    "PROPN"
  ],
  "approach": [
    "NOUN",
    "PROPN"
  ],
  "brown": [
    "PROPN",
    "ADJ"
  ],
  "physical": [
    "ADJ"
  ],
  "operating": [
    "NOUN",
    "VERB"
  ],
  "medicine": [
    "NOUN"
  ],
  "glass": [
    "NOUN"
  ],
  "happy": [
    "ADJ",
    "PROPN"
  ],
  "smith": [
    "PROPN"
  ],
  "thank": [
    "VERB"
  ],
  "unique": [
    "ADJ",
    "PROPN"
  ],
  "survey": [
    "NOUN",
    "PROPN"
  ],
  "prior": [
    "ADJ",
    "PROPN"
  ],
  "telephone": [
    "NOUN"
  ],
  "sport": [
    "NOUN"
  ],
  "ready": [
    "ADJ",
    "PROPN"
  ],
  "animal": [
    "NOUN"
  ],
  "population": [
    "NOUN"
  ],
  "regular": [
    "ADJ",
    "PROPN"
  ],
  "secure": [
    "PROPN",
    "ADJ"
  ],
  "navigation": [
    "NOUN",
    "PROPN"
  ],
  "therefore": [
    "ADV"
  ],
  "simply": [
    "ADV"
  ],
  "evidence": [
    "NOUN",
    "PROPN"
  ],
  "station": [
    "NOUN"
  ],
  "christian": [
    "PROPN"
  ],
  "round": [
    "NOUN",
    "PROPN"
  ],
  "favorite": [
    "ADJ"
  ],
  "understand": [
    "VERB",
    "PROPN"
  ],
  "option": [
    "NOUN",
    "PROPN"
  ],
  "master": [
    "NOUN",
    "PROPN"
  ],
  "valley": [
    "PROPN"
  ],
  "recently": [
    "ADV"
  ],
  "probably": [
    "ADV"
  ],
  "built": [
    "VERB"
  ],
  "blood": [
    "NOUN"
  ],
  "improve": [
    "VERB",
    "PROPN"
  ],
  "connection": [
    "NOUN",
    "PROPN"
  ],
  "publisher": [
    "NOUN"
  ],
  "earth": [
    "NOUN"
  ],
  "impact": [
    "NOUN",
    "PROPN"
  ],
  "transfer": [
    "NOUN",
    "VERB"
  ],
  "introduction": [
    "NOUN",
    "PROPN"
  ],
  "kitchen": [
    "NOUN"
  ],
  "strong": [
    "ADJ",
    "PROPN"
  ],
  "carolina": [
    "PROPN"
  ],
  "wedding": [
    "NOUN"
  ],
  "hospital": [
    "NOUN"
  ],
  "ground": [
    "NOUN",
    "PROPN"
  ],
  "overview": [
    "NOUN",
    "PROPN"
  ],
  "accommodation": [
    "NOUN"
  ],
  "disease": [
    "NOUN"
  ],
  "excellent": [
    "ADJ",
    "PROPN"
  ],
  "perfect": [
    "ADJ",
    "PROPN"
  ],
  "opportunity": [
    "NOUN",
    "PROPN"
  ],
  "classic": [
    "ADJ",
    "NOUN"
  ],
  "basis": [
    "NOUN"
  ],
  "command": [
    "NOUN",
    "PROPN"
  ],
  "william": [
    "PROPN"
  ],
  "express": [
    "PROPN",
    "VERB"
  ],
  "award": [
    "NOUN"
  ],
  "distance": [
    "NOUN"
  ],
  "peter": [
    "PROPN"
  ],
  "assessment": [
    "NOUN",
    "PROPN"
  ],
  "ensure": [
    "VERB",
    "PROPN"
  ],
  "involved": [
    "VERB",
    "ADJ"
  ],
  "extra": [
    "ADJ"
  ],
  "especially": [
    "ADV"
  ],
  "interface": [
    "NOUN",
    "PROPN"
  ],
  "budget": [
    "PROPN",
    "NOUN"
  ],
  "rated": [
    "VERB"
  ],
  "success": [
    "NOUN",
    "PROPN"
  ],
  "maximum": [
    "ADJ",
    "NOUN"
  ],
  "operation": [
    "NOUN",
    "PROPN"
  ],
  "quite": [
    "ADV"
  ],
  "selected": [
    "VERB",
    "PROPN"
  ],
  "amazon": [
    "PROPN"
  ],
  "beautiful": [
    "ADJ"
  ],
  "warning": [
    "VERB",
    "NOUN"
  ],
  "horse": [
    "NOUN"
  ],
  "forward": [
    "PROPN",
    "ADJ"
  ],
  "significant": [
    "ADJ",
    "PROPN"
  ],
  "owner": [
    "NOUN",
    "PROPN"
  ],
  "retail": [
    "ADJ",
    "PROPN"
  ],
  "useful": [
    "ADJ",
    "PROPN"
  ],
  "directly": [
    "ADV"
  ],
  "manufacturer": [
    "NOUN"
  ],
  "providing": [
    "VERB"
  ],
  "housing": [
    "NOUN"
  ],
  "bring": [
    "VERB"
  ],
  "trying": [
    "VERB"
  ],
  "mother": [
    "NOUN"
  ],
  "authority": [
    "PROPN",
    "NOUN"
  ],
  "considered": [
    "VERB"
  ],
  "traffic": [
    "NOUN",
    "PROPN"
  ],
  "input": [
    "NOUN",
    "PROPN"
  ],
  "strategy": [
    "NOUN",
    "PROPN"
  ],
  "agent": [
    "NOUN",
    "PROPN"
  ],
  "valid": [
    "ADJ",
    "PROPN"
  ],
  "modern": [
    "ADJ",
    "PROPN"
  ],
  "senior": [
    "PROPN",
    "ADJ"
  ],
  "teaching": [
    "VERB"
  ],
  "grand": [
    "PROPN",
    "ADJ"
  ],
  "testing": [
    "NOUN",
    "PROPN"
  ],
  "trial": [
    "NOUN",
    "PROPN"
  ],
  "charge": [
    "NOUN",
    "VERB"
  ],
  "instead": [
    "ADV"
  ],
  "canadian": [
    "PROPN"
  ],
  "normal": [
    "ADJ",
    "PROPN"
  ],
  "wrote": [
    "VERB"
  ],
  "enterprise": [
    "PROPN",
    "NOUN"
  ],
  "entire": [
    "ADJ"
  ],
  "educational": [
    "ADJ"
  ],
  "leading": [
    "VERB",
    "PROPN"
  ],
  "metal": [
    "NOUN"
  ],
  "positive": [
    "ADJ",
    "PROPN"
  ],
  "fitness": [
    "PROPN"
  ],
  "chinese": [
    "ADJ"
  ],
  "opinion": [
    "NOUN"
  ],
  "football": [
    "NOUN"
  ],
  "abstract": [
    "ADJ",
    "PROPN"
  ],
  "output": [
    "NOUN",
    "PROPN"
  ],
  "funds": [
    "NOUN"
  ],
  "greater": [
    "ADJ",
    "PROPN"
  ],
  "likely": [
    "ADJ",
    "PROPN"
  ],
  "develop": [
    "VERB",
    "PROPN"
  ],
  "alternative": [
    "ADJ",
    "NOUN"
  ],
  "responsibility": [
    "NOUN",
    "PROPN"
  ],
  "resolution": [
    "NOUN",
    "PROPN"
  ],
  "guest": [
    "NOUN",
    "PROPN"
  ],
  "publication": [
    "NOUN",
    "PROPN"
  ],
  "trust": [
    "PROPN",
    "NOUN"
  ],
  "session": [
    "NOUN",
    "PROPN"
  ],
  "photography": [
    "NOUN"
  ],
  "republic": [
    "NOUN"
  ],
  "vacation": [
    "NOUN"
  ],
  "century": [
    "NOUN"
  ],
  "academic": [
    "ADJ",
    "PROPN"
  ],
  "assistance": [
    "NOUN",
    "PROPN"
  ],
  "graphics": [
    "NOUN"
  ],
  "indian": [
    "ADJ"
  ],
  "grade": [
    "NOUN",
    "PROPN"
  ],
  "dating": [
    "VERB"
  ],
  "pacific": [
    "PROPN"
  ],
  "mountain": [
    "PROPN",
    "NOUN"
  ],
  "filter": [
    "NOUN",
    "PROPN"
  ],
  "vehicle": [
    "NOUN"
  ],
  "longer": [
    "ADJ"
  ],
  "consider": [
    "VERB"
  ],
  "northern": [
    "PROPN"
  ],
  "behind": [
    "ADP"
  ],
  "panel": [
    "NOUN",
    "PROPN"
  ],
  "floor": [
    "NOUN",
    "PROPN"
  ],
  "german": [
    "ADJ",
    "PROPN"
  ],
  "match": [
    "VERB",
    "NOUN"
  ],
  "default": [
    "NOUN",
    "PROPN"
  ],
  "require": [
    "VERB",
    "PROPN"
  ],
  "outdoor": [
    "ADJ"
  ],
  "morning": [
    "NOUN",
    "PROPN"
  ],
  "otherwise": [
    "ADV"
  ],
  "protein": [
    "NOUN"
  ],
  "plant": [
    "NOUN"
  ],
  "transportation": [
    "NOUN"
  ],
  "politics": [
    "NOUN"
  ],
  "partner": [
    "PROPN",
    "NOUN"
  ],
  "disclaimer": [
    "PROPN",
    "NOUN"
  ],
  "faculty": [
    "NOUN"
  ],
  "membership": [
    "NOUN",
    "PROPN"
  ],
  "mission": [
    "NOUN",
    "PROPN"
  ],
  "string": [
    "NOUN",
    "PROPN"
  ],
  "sense": [
    "NOUN"
  ],
  "stage": [
    "NOUN",
    "PROPN"
  ],
  "internal": [
    "ADJ",
    "PROPN"
  ],
  "goods": [
    "NOUN"
  ],
  "unless": [
    "SCONJ"
  ],
  "richard": [
    "PROPN"
  ],
  "detailed": [
    "ADJ",
    "VERB"
  ],
  "japanese": [
    "ADJ"
  ],
  "background": [
    "NOUN",
    "PROPN"
  ],
  "target": [
    "NOUN",
    "PROPN"
  ],
  "except": [
    "SCONJ"
  ],
  "character": [
    "NOUN",
    "PROPN"
  ],
  "maintenance": [
    "NOUN",
    "PROPN"
  ],
  "ability": [
    "NOUN"
  ],
  "maybe": [
    "ADV"
  ],
  "moving": [
    "VERB",
    "PROPN"
  ],
  "pretty": [
    "ADV"
  ],
  "southern": [
    "ADJ"
  ],
  "yourself": [
    "PRON"
  ],
  "winter": [
    "NOUN"
  ],
  "battery": [
    "NOUN"
  ],
  "youth": [
    "NOUN"
  ],
  "pressure": [
    "NOUN"
  ],
  "boston": [
    "PROPN"
  ],
  "medium": [
    "PROPN",
    "NOUN"
  ],
  "television": [
    "NOUN"
  ],
  "interested": [
    "ADJ",
    "PROPN"
  ],
  "break": [
    "VERB",
    "NOUN"
  ],
  "throughout": [
    "ADP"
  ],
  "dance": [
    "NOUN"
  ],
  "itself": [
    "PRON"
  ],
  "defined": [
    "VERB"
  ],
  "studio": [
    "PROPN",
    "NOUN"
  ],
  "reader": [
    "NOUN",
    "PROPN"
  ],
  "virtual": [
    "ADJ",
    "PROPN"
  ],
  "device": [
    "NOUN",
    "PROPN"
  ],
  "established": [
    "VERB"
  ],
  "remote": [
    "ADJ",
    "PROPN"
  ],
  "external": [
    "ADJ",
    "PROPN"
  ],
  "apple": [
    "PROPN",
    "NOUN"
  ],
  "regarding": [
    "VERB"
  ],
  "theory": [
    "NOUN",
    "PROPN"
  ],
  "enjoy": [
    "VERB"
  ],
  "remove": [
    "VERB",
    "PROPN"
  ],
  "surface": [
    "NOUN",
    "VERB"
  ],
  "minimum": [
    "NOUN",
    "ADJ"
  ],
  "visual": [
    "ADJ",
    "PROPN"
  ],
  "variety": [
    "NOUN"
  ],
  "martin": [
    "PROPN"
  ],
  "manual": [
    "ADJ",
    "PROPN"
  ],
  "block": [
    "NOUN",
    "VERB"
  ],
  "repair": [
    "NOUN",
    "PROPN"
  ],
  "civil": [
    "ADJ"
  ],
  "steel": [
    "NOUN"
  ],
  "understanding": [
    "NOUN",
    "VERB"
  ],
  "fixed": [
    "VERB",
    "PROPN"
  ],
  "wrong": [
    "ADJ"
  ],
  "beginning": [
    "NOUN",
    "VERB"
  ],
  "finally": [
    "ADV"
  ],
  "classes": [
    "NOUN"
  ],
  "paris": [
    "PROPN"
  ],
  "sector": [
    "NOUN",
    "PROPN"
  ],
  "capacity": [
    "NOUN",
    "PROPN"
  ],
  "jersey": [
    "PROPN"
  ],
  "fully": [
    "ADV"
  ],
  "father": [
    "NOUN"
  ],
  "electric": [
    "PROPN"
  ],
  "officer": [
    "PROPN",
    "NOUN"
  ],
  "driver": [
    "PROPN",
    "NOUN"
  ],
  "respect": [
    "NOUN",
    "VERB"
  ],
  "unknown": [
    "ADJ",
    "PROPN"
  ],
  "restaurant": [
    "NOUN"
  ],
  "worth": [
    "ADJ",
    "NOUN"
  ],
  "teacher": [
    "NOUN"
  ],
  "relationship": [
    "NOUN",
    "PROPN"
  ],
  "georgia": [
    "PROPN"
  ],
  "peace": [
    "NOUN"
  ],
  "traditional": [
    "ADJ"
  ],
  "campus": [
    "PROPN",
    "NOUN"
  ],
  "showing": [
    "VERB"
  ],
  "creative": [
    "ADJ",
    "PROPN"
  ],
  "coast": [
    "PROPN",
    "NOUN"
  ],
  "benefit": [
    "NOUN",
    "VERB"
  ],
  "progress": [
    "NOUN",
    "PROPN"
  ],
  "grant": [
    "VERB",
    "NOUN"
  ],
  "agree": [
    "VERB",
    "PROPN"
  ],
  "fiction": [
    "NOUN"
  ],
  "sometimes": [
    "ADV"
  ],
  "beyond": [
    "ADP"
  ],
  "museum": [
    "NOUN"
  ],
  "themselves": [
    "PRON"
  ],
  "transport": [
    "NOUN",
    "PROPN"
  ],
  "interesting": [
    "ADJ"
  ],
  "evaluation": [
    "NOUN",
    "PROPN"
  ],
  "accepted": [
    "VERB",
    "PROPN"
  ],
  "former": [
    "ADJ"
  ],
  "implementation": [
    "NOUN",
    "PROPN"
  ],
  "complex": [
    "ADJ",
    "PROPN"
  ],
  "literature": [
    "NOUN"
  ],
  "respective": [
    "ADJ"
  ],
  "parent": [
    "NOUN",
    "PROPN"
  ],
  "spanish": [
    "PROPN"
  ],
  "michigan": [
    "PROPN"
  ],
  "columbia": [
    "PROPN"
  ],
  "setting": [
    "VERB",
    "NOUN"
  ],
  "scale": [
    "NOUN",
    "PROPN"
  ],
  "stand": [
    "VERB",
    "NOUN"
  ],
  "economy": [
    "PROPN",
    "NOUN"
  ],
  "highest": [
    "ADJ",
    "PROPN"
  ],
  "helpful": [
    "ADJ",
    "PROPN"
  ],
  "monthly": [
    "ADJ",
    "PROPN"
  ],
  "critical": [
    "ADJ",
    "PROPN"
  ],
  "frame": [
    "NOUN",
    "VERB"
  ],
  "musical": [
    "ADJ"
  ],
  "definition": [
    "NOUN",
    "PROPN"
  ],
  "secretary": [
    "NOUN"
  ],
  "australian": [
    "ADJ",
    "PROPN"
  ],
  "employee": [
    "NOUN",
    "PROPN"
  ],
  "chief": [
    "PROPN"
  ],
  "bottom": [
    "NOUN",
    "ADJ"
  ],
  "detail": [
    "NOUN",
    "PROPN"
  ],
  "francisco": [
    "PROPN"
  ],
  "begin": [
    "VERB"
  ],
  "colorado": [
    "PROPN"
  ],
  "royal": [
    "PROPN"
  ],
  "clean": [
    "VERB",
    "ADJ"
  ],
  "switch": [
    "VERB",
    "NOUN"
  ],
  "russian": [
    "PROPN"
  ],
  "african": [
    "PROPN"
  ],
  "relevant": [
    "ADJ",
    "PROPN"
  ],
  "justice": [
    "NOUN"
  ],
  "connect": [
    "VERB",
    "PROPN"
  ],
  "bible": [
    "PROPN"
  ],
  "basket": [
    "NOUN"
  ],
  "applied": [
    "VERB"
  ],
  "weekly": [
    "ADJ",
    "PROPN"
  ],
  "installation": [
    "NOUN",
    "PROPN"
  ],
  "demand": [
    "NOUN",
    "PROPN"
  ],
  "suite": [
    "NOUN",
    "PROPN"
  ],
  "square": [
    "ADJ",
    "PROPN"
  ],
  "chris": [
    "PROPN"
  ],
  "attention": [
    "NOUN",
    "PROPN"
  ],
  "advance": [
    "NOUN",
    "VERB"
  ],
  "auction": [
    "NOUN"
  ],
  "difference": [
    "NOUN",
    "PROPN"
  ],
  "correct": [
    "ADJ",
    "VERB"
  ],
  "charles": [
    "PROPN"
  ],
  "nation": [
    "NOUN"
  ],
  "selling": [
    "VERB",
    "NOUN"
  ],
  "piece": [
    "NOUN"
  ],
  "sheet": [
    "NOUN",
    "PROPN"
  ],
  "seven": [
    "NUM"
  ],
  "older": [
    "ADJ"
  ],
  "illinois": [
    "PROPN"
  ],
  "species": [
    "NOUN"
  ],
  "module": [
    "NOUN",
    "PROPN"
  ],
  "resort": [
    "NOUN"
  ],
  "facility": [
    "NOUN"
  ],
  "random": [
    "ADJ",
    "PROPN"
  ],
  "certificate": [
    "NOUN",
    "PROPN"
  ],
  "minister": [
    "NOUN"
  ],
  "motion": [
    "NOUN",
    "PROPN"
  ],
  "fashion": [
    "NOUN"
  ],
  "documentation": [
    "NOUN",
    "PROPN"
  ],
  "monitor": [
    "VERB",
    "PROPN"
  ],
  "trading": [
    "NOUN"
  ],
  "forest": [
    "NOUN"
  ],
  "whose": [
    "DET"
  ],
  "coverage": [
    "PROPN",
    "NOUN"
  ],
  "couple": [
    "NOUN"
  ],
  "giving": [
    "VERB"
  ],
  "chance": [
    "NOUN"
  ],
  "vision": [
    "NOUN",
    "PROPN"
  ],
  "ending": [
    "VERB"
  ],
  "listen": [
    "VERB"
  ],
  "discuss": [
    "VERB",
    "PROPN"
  ],
  "accept": [
    "VERB",
    "PROPN"
  ],
  "automotive": [
    "ADJ",
    "PROPN"
  ],
  "successful": [
    "ADJ",
    "PROPN"
  ],
  "clinical": [
    "ADJ"
  ],
  "situation": [
    "NOUN",
    "PROPN"
  ],
  "highly": [
    "ADV"
  ],
  "appear": [
    "VERB"
  ],
  "emergency": [
    "NOUN",
    "PROPN"
  ],
  "currency": [
    "NOUN",
    "PROPN"
  ],
  "leather": [
    "NOUN"
  ],
  "determine": [
    "VERB",
    "NOUN"
  ],
  "temperature": [
    "NOUN"
  ],
  "patient": [
    "ADJ"
  ],
  "actual": [
    "ADJ",
    "PROPN"
  ],
  "historical": [
    "ADJ",
    "PROPN"
  ],
  "stone": [
    "NOUN"
  ],
  "commerce": [
    "PROPN",
    "NOUN"
  ],
  "perhaps": [
    "ADV"
  ],
  "difficult": [
    "ADJ"
  ],
  "scientific": [
    "ADJ"
  ],
  "satellite": [
    "NOUN"
  ],
  "village": [
    "NOUN"
  ],
  "amateur": [
    "ADJ"
  ],
  "particularly": [
    "ADV"
  ],
  "coffee": [
    "NOUN",
    "PROPN"
  ],
  "buyer": [
    "NOUN",
    "PROPN"
  ],
  "cultural": [
    "ADJ",
    "PROPN"
  ],
  "steve": [
    "PROPN"
  ],
  "easily": [
    "ADV"
  ],
  "poster": [
    "NOUN",
    "PROPN"
  ],
  "functional": [
    "ADJ",
    "PROPN"
  ],
  "closed": [
    "PROPN",
    "VERB"
  ],
  "balance": [
    "NOUN",
    "PROPN"
  ],
  "graduate": [
    "PROPN"
  ],
  "architecture": [
    "NOUN",
    "PROPN"
  ],
  "initial": [
    "ADJ",
    "PROPN"
  ],
  "label": [
    "NOUN",
    "PROPN"
  ],
  "thinking": [
    "VERB",
    "NOUN"
  ],
  "scott": [
    "PROPN"
  ],
  "recommend": [
    "VERB",
    "PROPN"
  ],
  "canon": [
    "NOUN"
  ],
  "league": [
    "NOUN"
  ],
  "waste": [
    "NOUN",
    "VERB"
  ],
  "minute": [
    "NOUN",
    "PROPN"
  ],
  "provider": [
    "NOUN",
    "PROPN"
  ],
  "optional": [
    "ADJ",
    "PROPN"
  ],
  "dictionary": [
    "ADJ",
    "PROPN"
  ],
  "accounting": [
    "PROPN",
    "NOUN"
  ],
  "chair": [
    "NOUN"
  ],
  "fishing": [
    "VERB"
  ],
  "effort": [
    "NOUN",
    "PROPN"
  ],
  "phase": [
    "NOUN",
    "PROPN"
  ],
  "fantasy": [
    "NOUN"
  ],
  "motor": [
    "NOUN"
  ],
  "professor": [
    "NOUN"
  ],
  "context": [
    "NOUN",
    "PROPN"
  ],
  "install": [
    "VERB",
    "NOUN"
  ],
  "shirt": [
    "NOUN",
    "PROPN"
  ],
  "apparel": [
    "NOUN"
  ],
  "generally": [
    "ADV"
  ],
  "continued": [
    "VERB",
    "ADJ"
  ],
  "crime": [
    "NOUN"
  ],
  "count": [
    "NOUN",
    "PROPN"
  ],
  "breast": [
    "NOUN"
  ],
  "quickly": [
    "ADV"
  ],
  "religion": [
    "NOUN"
  ],
  "claim": [
    "NOUN",
    "VERB"
  ],
  "driving": [
    "VERB",
    "NOUN"
  ],
  "permission": [
    "NOUN",
    "PROPN"
  ],
  "surgery": [
    "NOUN"
  ],
  "patch": [
    "PROPN",
    "NOUN"
  ],
  "generation": [
    "NOUN",
    "PROPN"
  ],
  "chemical": [
    "PROPN"
  ],
  "doctor": [
    "NOUN"
  ],
  "reduce": [
    "VERB",
    "PROPN"
  ],
  "brought": [
    "VERB"
  ],
  "himself": [
    "PRON"
  ],
  "component": [
    "NOUN",
    "PROPN"
  ],
  "enable": [
    "VERB",
    "ADJ"
  ],
  "exercise": [
    "NOUN",
    "PROPN"
  ],
  "santa": [
    "PROPN"
  ],
  "guarantee": [
    "VERB",
    "NOUN"
  ],
  "leader": [
    "NOUN",
    "PROPN"
  ],
  "diamond": [
    "NOUN"
  ],
  "israel": [
    "PROPN"
  ],
  "alone": [
    "ADJ"
  ],
  "jones": [
    "PROPN"
  ],
  "arizona": [
    "PROPN"
  ],
  "flight": [
    "NOUN",
    "PROPN"
  ],
  "congress": [
    "PROPN"
  ],
  "produced": [
    "VERB"
  ],
  "italian": [
    "ADJ"
  ],
  "paperback": [
    "VERB"
  ],
  "pocket": [
    "NOUN"
  ],
  "saint": [
    "NOUN"
  ],
  "freedom": [
    "NOUN"
  ],
  "argument": [
    "NOUN"
  ],
  "competition": [
    "NOUN",
    "PROPN"
  ],
  "joint": [
    "ADJ",
    "PROPN"
  ],
  "premium": [
    "PROPN",
    "NOUN"
  ],
  "fresh": [
    "ADJ"
  ],
  "attorney": [
    "NOUN"
  ],
  "upgrade": [
    "NOUN",
    "VERB"
  ],
  "factor": [
    "NOUN",
    "PROPN"
  ],
  "growing": [
    "VERB"
  ],
  "stream": [
    "NOUN",
    "PROPN"
  ],
  "hearing": [
    "VERB"
  ],
  "eastern": [
    "PROPN"
  ],
  "therapy": [
    "NOUN"
  ],
  "upper": [
    "ADJ"
  ],
  "administrative": [
    "ADJ",
    "PROPN"
  ],
  "serious": [
    "ADJ"
  ],
  "prime": [
    "PROPN",
    "ADJ"
  ],
  "limit": [
    "NOUN",
    "VERB"
  ],
  "louis": [
    "NOUN"
  ],
  "informed": [
    "VERB",
    "PROPN"
  ],
  "creek": [
    "PROPN"
  ],
  "worked": [
    "VERB"
  ],
  "quantity": [
    "NOUN",
    "PROPN"
  ],
  "urban": [
    "ADJ"
  ],
  "sorted": [
    "VERB"
  ],
  "essential": [
    "ADJ",
    "PROPN"
  ],
  "myself": [
    "PRON"
  ],
  "platform": [
    "NOUN",
    "PROPN"
  ],
  "affiliate": [
    "NOUN"
  ],
  "labor": [
    "NOUN"
  ],
  "immediately": [
    "ADV"
  ],
  "nursing": [
    "NOUN"
  ],
  "defense": [
    "NOUN",
    "PROPN"
  ],
  "heavy": [
    "ADJ"
  ],
  "covered": [
    "VERB",
    "PROPN"
  ],
  "recovery": [
    "NOUN",
    "PROPN"
  ],
  "configuration": [
    "NOUN",
    "PROPN"
  ],
  "merchant": [
    "NOUN"
  ],
  "comprehensive": [
    "ADJ",
    "PROPN"
  ],
  "expert": [
    "NOUN",
    "PROPN"
  ],
  "universal": [
    "PROPN",
    "ADJ"
  ],
  "protect": [
    "VERB"
  ],
  "solid": [
    "ADJ"
  ],
  "presentation": [
    "NOUN",
    "PROPN"
  ],
  "orange": [
    "PROPN",
    "NOUN"
  ],
  "compliance": [
    "NOUN",
    "PROPN"
  ],
  "prevent": [
    "VERB",
    "PROPN"
  ],
  "theme": [
    "NOUN",
    "PROPN"
  ],
  "campaign": [
    "NOUN",
    "PROPN"
  ],
  "marine": [
    "NOUN"
  ],
  "improvement": [
    "NOUN",
    "PROPN"
  ],
  "guitar": [
    "PROPN"
  ],
  "finding": [
    "VERB",
    "NOUN"
  ],
  "pennsylvania": [
    "PROPN"
  ],
  "saying": [
    "VERB"
  ],
  "spirit": [
    "NOUN"
  ],
  "challenge": [
    "NOUN",
    "VERB"
  ],
  "acceptance": [
    "PROPN",
    "NOUN"
  ],
  "touch": [
    "NOUN",
    "PROPN"
  ],
  "intended": [
    "VERB"
  ],
  "towards": [
    "ADP"
  ],
  "election": [
    "NOUN"
  ],
  "suggest": [
    "VERB"
  ],
  "branch": [
    "NOUN",
    "PROPN"
  ],
  "serve": [
    "VERB",
    "NOUN"
  ],
  "magic": [
    "PROPN",
    "NOUN"
  ],
  "mount": [
    "PROPN"
  ],
  "smart": [
    "PROPN",
    "ADJ"
  ],
  "talking": [
    "VERB",
    "NOUN"
  ],
  "latin": [
    "PROPN"
  ],
  "avoid": [
    "VERB"
  ],
  "certified": [
    "VERB",
    "PROPN"
  ],
  "manage": [
    "VERB",
    "PROPN"
  ],
  "corner": [
    "NOUN",
    "PROPN"
  ],
  "element": [
    "NOUN",
    "PROPN"
  ],
  "birth": [
    "NOUN"
  ],
  "virus": [
    "NOUN"
  ],
  "abuse": [
    "PROPN",
    "NOUN"
  ],
  "interactive": [
    "ADJ",
    "PROPN"
  ],
  "separate": [
    "ADJ",
    "VERB"
  ],
  "quarter": [
    "NOUN",
    "PROPN"
  ],
  "procedure": [
    "NOUN",
    "PROPN"
  ],
  "leadership": [
    "NOUN",
    "PROPN"
  ],
  "tables": [
    "NOUN",
    "PROPN"
  ],
  "define": [
    "VERB",
    "PROPN"
  ],
  "racing": [
    "VERB"
  ],
  "religious": [
    "ADJ"
  ],
  "breakfast": [
    "NOUN",
    "PROPN"
  ],
  "column": [
    "NOUN"
  ],
  "faith": [
    "NOUN"
  ],
  "chain": [
    "NOUN",
    "PROPN"
  ],
  "developer": [
    "NOUN",
    "PROPN"
  ],
  "identify": [
    "VERB",
    "PROPN"
  ],
  "avenue": [
    "NOUN"
  ],
  "missing": [
    "VERB",
    "PROPN"
  ],
  "approximately": [
    "ADV"
  ],
  "domestic": [
    "ADJ"
  ],
  "reach": [
    "VERB",
    "NOUN"
  ],
  "comparison": [
    "NOUN",
    "PROPN"
  ],
  "mental": [
    "ADJ"
  ],
  "moment": [
    "NOUN"
  ],
  "extended": [
    "VERB",
    "ADJ"
  ],
  "sequence": [
    "NOUN",
    "PROPN"
  ],
  "attack": [
    "NOUN",
    "PROPN"
  ],
  "sorry": [
    "ADJ"
  ],
  "opening": [
    "VERB",
    "NOUN"
  ],
  "damage": [
    "NOUN"
  ],
  "reserve": [
    "VERB",
    "NOUN"
  ],
  "gamma": [
    "NOUN"
  ],
  "plastic": [
    "NOUN"
  ],
  "produce": [
    "VERB"
  ],
  "truth": [
    "NOUN",
    "PROPN"
  ],
  "counter": [
    "NOUN",
    "PROPN"
  ],
  "failure": [
    "NOUN",
    "PROPN"
  ],
  "weekend": [
    "NOUN",
    "PROPN"
  ],
  "dollar": [
    "NOUN"
  ],
  "automatically": [
    "ADV"
  ],
  "bridge": [
    "NOUN",
    "PROPN"
  ],
  "native": [
    "ADJ",
    "PROPN"
  ],
  "movement": [
    "NOUN"
  ],
  "printing": [
    "VERB"
  ],
  "baseball": [
    "NOUN"
  ],
  "approval": [
    "NOUN",
    "PROPN"
  ],
  "draft": [
    "VERB",
    "NOUN"
  ],
  "chart": [
    "NOUN",
    "PROPN"
  ],
  "jesus": [
    "PROPN"
  ],
  "jackson": [
    "PROPN"
  ],
  "equal": [
    "ADJ"
  ],
  "adventure": [
    "NOUN"
  ],
  "matching": [
    "VERB",
    "NOUN"
  ],
  "offering": [
    "NOUN",
    "VERB"
  ],
  "profit": [
    "NOUN",
    "PROPN"
  ],
  "assistant": [
    "PROPN",
    "NOUN"
  ],
  "variable": [
    "NOUN",
    "ADJ"
  ],
  "advertisement": [
    "NOUN"
  ],
  "expect": [
    "VERB"
  ],
  "parking": [
    "NOUN",
    "PROPN"
  ],
  "yesterday": [
    "NOUN"
  ],
  "determined": [
    "VERB",
    "ADJ"
  ],
  "wholesale": [
    "ADJ"
  ],
  "workshop": [
    "NOUN",
    "PROPN"
  ],
  "russia": [
    "PROPN"
  ],
  "extension": [
    "NOUN",
    "PROPN"
  ],
  "golden": [
    "PROPN",
    "ADJ"
  ],
  "completely": [
    "ADV"
  ],
  "lighting": [
    "VERB"
  ],
  "senate": [
    "PROPN"
  ],
  "funny": [
    "ADJ"
  ],
  "brother": [
    "NOUN"
  ],
  "turned": [
    "VERB"
  ],
  "portable": [
    "ADJ"
  ],
  "tried": [
    "VERB"
  ],
  "electrical": [
    "ADJ"
  ],
  "applicable": [
    "ADJ",
    "PROPN"
  ],
  "returned": [
    "VERB"
  ],
  "pattern": [
    "NOUN",
    "PROPN"
  ],
  "laser": [
    "NOUN"
  ],
  "sponsor": [
    "PROPN",
    "NOUN"
  ],
  "classical": [
    "ADJ"
  ],
  "warranty": [
    "NOUN",
    "PROPN"
  ],
  "indiana": [
    "PROPN"
  ],
  "direction": [
    "NOUN",
    "PROPN"
  ],
  "harry": [
    "PROPN"
  ],
  "basketball": [
    "NOUN"
  ],
  "delete": [
    "PROPN",
    "VERB"
  ],
  "evening": [
    "NOUN"
  ],
  "assembly": [
    "NOUN"
  ],
  "nuclear": [
    "ADJ"
  ],
  "mouse": [
    "NOUN"
  ],
  "signal": [
    "NOUN",
    "PROPN"
  ],
  "criminal": [
    "ADJ"
  ],
  "brain": [
    "NOUN",
    "PROPN"
  ],
  "powerful": [
    "ADJ"
  ],
  "dream": [
    "NOUN",
    "PROPN"
  ],
  "false": [
    "ADJ",
    "PROPN"
  ],
  "flower": [
    "NOUN"
  ],
  "personnel": [
    "NOUN"
  ],
  "promote": [
    "VERB",
    "PROPN"
  ],
  "stated": [
    "VERB"
  ],
  "carry": [
    "VERB"
  ],
  "decided": [
    "VERB",
    "NOUN"
  ],
  "advantage": [
    "NOUN"
  ],
  "hello": [
    "INTJ"
  ],
  "maintain": [
    "VERB"
  ],
  "tourism": [
    "NOUN"
  ],
  "priority": [
    "PROPN",
    "NOUN"
  ],
  "clips": [
    "NOUN"
  ],
  "graphic": [
    "PROPN",
    "NOUN"
  ],
  "binding": [
    "VERB"
  ],
  "brief": [
    "ADJ",
    "PROPN"
  ],
  "ended": [
    "VERB"
  ],
  "winning": [
    "VERB"
  ],
  "eight": [
    "NUM"
  ],
  "anonymous": [
    "ADJ",
    "PROPN"
  ],
  "straight": [
    "ADJ"
  ],
  "script": [
    "NOUN",
    "PROPN"
  ],
  "miscellaneous": [
    "PROPN",
    "ADJ"
  ],
  "prepared": [
    "VERB",
    "ADJ"
  ],
  "dining": [
    "VERB"
  ],
  "alert": [
    "ADJ",
    "PROPN"
  ],
  "integration": [
    "NOUN",
    "PROPN"
  ],
  "atlanta": [
    "PROPN"
  ],
  "dakota": [
    "PROPN"
  ],
  "interview": [
    "NOUN",
    "PROPN"
  ],
  "framework": [
    "NOUN",
    "PROPN"
  ],
  "queen": [
    "NOUN"
  ],
  "clearly": [
    "ADV"
  ],
  "handle": [
    "VERB",
    "NOUN"
  ],
  "sweet": [
    "ADJ"
  ],
  "criteria": [
    "NOUN",
    "PROPN"
  ],
  "diego": [
    "PROPN"
  ],
  "associate": [
    "VERB",
    "PROPN"
  ],
  "truck": [
    "NOUN"
  ],
  "behavior": [
    "NOUN",
    "PROPN"
  ],
  "enlarge": [
    "VERB"
  ],
  "frequently": [
    "ADV"
  ],
  "revenue": [
    "NOUN",
    "PROPN"
  ],
  "measure": [
    "VERB",
    "NOUN"
  ],
  "festival": [
    "NOUN"
  ],
  "laboratory": [
    "NOUN"
  ],
  "ocean": [
    "NOUN"
  ],
  "depth": [
    "NOUN"
  ],
  "whatever": [
    "DET"
  ],
  "logged": [
    "VERB",
    "PROPN"
  ],
  "vintage": [
    "NOUN"
  ],
  "train": [
    "VERB",
    "NOUN"
  ],
  "exactly": [
    "ADV"
  ],
  "explore": [
    "VERB",
    "PROPN"
  ],
  "maryland": [
    "VERB"
  ],
  "concept": [
    "NOUN",
    "PROPN"
  ],
  "nearly": [
    "ADV"
  ],
  "eligible": [
    "ADJ",
    "PROPN"
  ],
  "reality": [
    "NOUN"
  ],
  "forgot": [
    "VERB"
  ],
  "handling": [
    "VERB",
    "NOUN"
  ],
  "origin": [
    "PROPN",
    "NOUN"
  ],
  "gaming": [
    "NOUN"
  ],
  "billion": [
    "NUM"
  ],
  "destination": [
    "NOUN",
    "PROPN"
  ],
  "faster": [
    "ADJ",
    "PROPN"
  ],
  "intelligence": [
    "PROPN",
    "NOUN"
  ],
  "bought": [
    "VERB"
  ],
  "route": [
    "NOUN",
    "VERB"
  ],
  "broken": [
    "VERB",
    "ADJ"
  ],
  "frank": [
    "PROPN"
  ],
  "alaska": [
    "PROPN"
  ],
  "battle": [
    "NOUN"
  ],
  "residential": [
    "ADJ"
  ],
  "anime": [
    "NOUN"
  ],
  "speak": [
    "VERB"
  ],
  "protocol": [
    "NOUN",
    "PROPN"
  ],
  "query": [
    "NOUN",
    "PROPN"
  ],
  "partnership": [
    "NOUN",
    "PROPN"
  ],
  "editorial": [
    "ADJ"
  ],
  "expression": [
    "NOUN",
    "PROPN"
  ],
  "equity": [
    "NOUN",
    "PROPN"
  ],
  "speech": [
    "NOUN"
  ],
  "rural": [
    "ADJ"
  ],
  "replacement": [
    "NOUN",
    "PROPN"
  ],
  "strategic": [
    "ADJ",
    "PROPN"
  ],
  "judge": [
    "VERB"
  ],
  "economics": [
    "NOUN"
  ],
  "forced": [
    "VERB"
  ],
  "compatible": [
    "ADJ"
  ],
  "fight": [
    "VERB"
  ],
  "apartment": [
    "NOUN"
  ],
  "height": [
    "NOUN"
  ],
  "speaker": [
    "PROPN",
    "NOUN"
  ],
  "obtain": [
    "VERB",
    "PROPN"
  ],
  "consulting": [
    "NOUN",
    "PROPN"
  ],
  "recreation": [
    "NOUN"
  ],
  "designer": [
    "NOUN",
    "PROPN"
  ],
  "remain": [
    "VERB"
  ],
  "marriage": [
    "NOUN"
  ],
  "secret": [
    "ADJ",
    "NOUN"
  ],
  "kelly": [
    "PROPN"
  ],
  "leads": [
    "VERB",
    "NOUN"
  ],
  "negative": [
    "ADJ",
    "PROPN"
  ],
  "austin": [
    "PROPN"
  ],
  "theater": [
    "NOUN"
  ],
  "missouri": [
    "PROPN"
  ],
  "andrew": [
    "PROPN"
  ],
  "perform": [
    "VERB",
    "PROPN"
  ],
  "healthy": [
    "ADJ",
    "PROPN"
  ],
  "translation": [
    "NOUN",
    "PROPN"
  ],
  "assets": [
    "NOUN",
    "PROPN"
  ],
  "injury": [
    "NOUN"
  ],
  "joseph": [
    "PROPN"
  ],
  "ministry": [
    "NOUN"
  ],
  "lawyer": [
    "NOUN"
  ],
  "married": [
    "VERB"
  ],
  "proposal": [
    "NOUN",
    "PROPN"
  ],
  "portal": [
    "PROPN",
    "ADJ"
  ],
  "waiting": [
    "VERB",
    "PROPN"
  ],
  "birthday": [
    "NOUN"
  ],
  "gratis": [
    "NOUN"
  ],
  "banking": [
    "NOUN",
    "PROPN"
  ],
  "brian": [
    "PROPN"
  ],
  "toward": [
    "ADP"
  ],
  "slightly": [
    "ADV"
  ],
  "assist": [
    "VERB",
    "NOUN"
  ],
  "conduct": [
    "PROPN",
    "VERB"
  ],
  "lingerie": [
    "NOUN"
  ],
  "legislation": [
    "NOUN"
  ],
  "calling": [
    "VERB"
  ],
  "serving": [
    "VERB"
  ],
  "miami": [
    "PROPN"
  ],
  "postal": [
    "ADJ"
  ],
  "breaking": [
    "VERB",
    "PROPN"
  ],
  "combined": [
    "VERB",
    "ADJ"
  ],
  "ultimate": [
    "ADJ",
    "PROPN"
  ],
  "representative": [
    "NOUN",
    "PROPN"
  ],
  "frequency": [
    "NOUN",
    "PROPN"
  ],
  "minor": [
    "PROPN",
    "ADJ"
  ],
  "finish": [
    "VERB",
    "PROPN"
  ],
  "noted": [
    "VERB"
  ],
  "displayed": [
    "VERB"
  ],
  "reduced": [
    "VERB",
    "ADJ"
  ],
  "physics": [
    "NOUN"
  ],
  "spent": [
    "VERB"
  ],
  "extreme": [
    "ADJ"
  ],
  "daniel": [
    "PROPN"
  ],
  "forecast": [
    "PROPN",
    "NOUN"
  ],
  "removed": [
    "VERB",
    "PROPN"
  ],
  "singles": [
    "VERB"
  ],
  "administrator": [
    "NOUN",
    "PROPN"
  ],
  "cycle": [
    "NOUN",
    "PROPN"
  ],
  "contain": [
    "VERB"
  ],
  "accuracy": [
    "NOUN",
    "PROPN"
  ],
  "sleep": [
    "NOUN",
    "VERB"
  ],
  "pharmacy": [
    "NOUN"
  ],
  "brazil": [
    "PROPN"
  ],
  "creation": [
    "NOUN",
    "PROPN"
  ],
  "static": [
    "ADJ",
    "PROPN"
  ],
  "scene": [
    "NOUN"
  ],
  "hunter": [
    "NOUN"
  ],
  "crystal": [
    "PROPN"
  ],
  "famous": [
    "ADJ"
  ],
  "writer": [
    "NOUN",
    "PROPN"
  ],
  "chairman": [
    "NOUN"
  ],
  "violence": [
    "NOUN"
  ],
  "oklahoma": [
    "PROPN"
  ],
  "drink": [
    "NOUN"
  ],
  "academy": [
    "PROPN"
  ],
  "dynamic": [
    "ADJ",
    "PROPN"
  ],
  "gender": [
    "NOUN"
  ],
  "permanent": [
    "ADJ",
    "PROPN"
  ],
  "agriculture": [
    "NOUN"
  ],
  "cleaning": [
    "VERB",
    "NOUN"
  ],
  "portfolio": [
    "NOUN",
    "PROPN"
  ],
  "practical": [
    "ADJ"
  ],
  "infrastructure": [
    "PROPN",
    "NOUN"
  ],
  "exclusive": [
    "ADJ"
  ],
  "colour": [
    "NOUN",
    "PROPN"
  ],
  "vendor": [
    "NOUN",
    "PROPN"
  ],
  "originally": [
    "ADV"
  ],
  "philosophy": [
    "NOUN"
  ],
  "regulation": [
    "NOUN",
    "PROPN"
  ],
  "reduction": [
    "NOUN",
    "PROPN"
  ],
  "nutrition": [
    "NOUN"
  ],
  "recording": [
    "NOUN",
    "PROPN"
  ],
  "junior": [
    "ADJ",
    "PROPN"
  ],
  "meaning": [
    "VERB",
    "NOUN"
  ],
  "secondary": [
    "ADJ",
    "PROPN"
  ],
  "wonderful": [
    "ADJ"
  ],
  "ladies": [
    "NOUN"
  ],
  "henry": [
    "PROPN"
  ],
  "ticket": [
    "NOUN",
    "PROPN"
  ],
  "guess": [
    "VERB",
    "NOUN"
  ],
  "agreed": [
    "VERB"
  ],
  "prevention": [
    "PROPN",
    "NOUN"
  ],
  "soccer": [
    "NOUN"
  ],
  "import": [
    "NOUN",
    "PROPN"
  ],
  "posting": [
    "VERB",
    "NOUN"
  ],
  "presence": [
    "NOUN",
    "PROPN"
  ],
  "instant": [
    "ADJ",
    "PROPN"
  ],
  "automatic": [
    "ADJ",
    "PROPN"
  ],
  "increasing": [
    "VERB"
  ],
  "majority": [
    "NOUN",
    "PROPN"
  ],
  "connected": [
    "VERB",
    "ADJ"
  ],
  "christ": [
    "PROPN"
  ],
  "ahead": [
    "ADV"
  ],
  "participation": [
    "NOUN",
    "PROPN"
  ],
  "scheme": [
    "NOUN",
    "PROPN"
  ],
  "utility": [
    "NOUN",
    "PROPN"
  ],
  "preview": [
    "NOUN",
    "PROPN"
  ],
  "manner": [
    "NOUN"
  ],
  "matrix": [
    "NOUN",
    "PROPN"
  ],
  "combination": [
    "NOUN"
  ],
  "amendment": [
    "NOUN"
  ],
  "despite": [
    "SCONJ"
  ],
  "strength": [
    "NOUN",
    "PROPN"
  ],
  "turkey": [
    "PROPN"
  ],
  "proper": [
    "ADJ"
  ],
  "distributed": [
    "VERB"
  ],
  "delta": [
    "NOUN",
    "PROPN"
  ],
  "seeking": [
    "VERB"
  ],
  "phoenix": [
    "PROPN"
  ],
  "convention": [
    "NOUN"
  ],
  "principal": [
    "PROPN",
    "NOUN"
  ],
  "daughter": [
    "NOUN"
  ],
  "standing": [
    "VERB"
  ],
  "comfort": [
    "NOUN"
  ],
  "colors": [
    "NOUN"
  ],
  "cisco": [
    "PROPN"
  ],
  "alpha": [
    "NOUN",
    "PROPN"
  ],
  "appeal": [
    "VERB",
    "NOUN"
  ],
  "cruise": [
    "NOUN"
  ],
  "bonus": [
    "PROPN",
    "NOUN"
  ],
  "certification": [
    "NOUN",
    "PROPN"
  ],
  "previously": [
    "ADV"
  ],
  "bookmark": [
    "PROPN",
    "VERB"
  ],
  "household": [
    "NOUN"
  ],
  "adobe": [
    "PROPN"
  ],
  "smoking": [
    "VERB"
  ],
  "becomes": [
    "VERB"
  ],
  "alabama": [
    "PROPN"
  ],
  "achieve": [
    "VERB"
  ],
  "dress": [
    "NOUN"
  ],
  "subscription": [
    "NOUN",
    "PROPN"
  ],
  "dealer": [
    "NOUN"
  ],
  "contemporary": [
    "ADJ"
  ],
  "nearby": [
    "ADV"
  ],
  "carried": [
    "VERB"
  ],
  "happen": [
    "VERB"
  ],
  "exposure": [
    "NOUN",
    "PROPN"
  ],
  "signature": [
    "NOUN",
    "PROPN"
  ],
  "gambling": [
    "NOUN"
  ],
  "refer": [
    "VERB"
  ],
  "miller": [
    "PROPN"
  ],
  "provision": [
    "NOUN",
    "VERB"
  ],
  "outdoors": [
    "ADV"
  ],
  "clothes": [
    "NOUN"
  ],
  "luxury": [
    "NOUN"
  ],
  "certainly": [
    "ADV"
  ],
  "indeed": [
    "ADV"
  ],
  "newspaper": [
    "NOUN"
  ],
  "circuit": [
    "NOUN",
    "PROPN"
  ],
  "layer": [
    "NOUN",
    "PROPN"
  ],
  "printed": [
    "VERB"
  ],
  "removal": [
    "NOUN",
    "PROPN"
  ],
  "easier": [
    "ADJ"
  ],
  "liability": [
    "NOUN"
  ],
  "kentucky": [
    "PROPN"
  ],
  "mostly": [
    "ADV"
  ],
  "taylor": [
    "PROPN"
  ],
  "spend": [
    "VERB",
    "NOUN"
  ],
  "factory": [
    "NOUN",
    "PROPN"
  ],
  "interior": [
    "PROPN"
  ],
  "revised": [
    "VERB",
    "PROPN"
  ],
  "optical": [
    "ADJ"
  ],
  "promotion": [
    "NOUN",
    "PROPN"
  ],
  "relative": [
    "ADJ",
    "NOUN"
  ],
  "amazing": [
    "ADJ"
  ],
  "clock": [
    "NOUN"
  ],
  "identity": [
    "NOUN",
    "PROPN"
  ],
  "conversion": [
    "NOUN",
    "PROPN"
  ],
  "feeling": [
    "VERB",
    "NOUN"
  ],
  "hidden": [
    "VERB",
    "ADJ"
  ],
  "reasonable": [
    "ADJ"
  ],
  "victoria": [
    "PROPN"
  ],
  "serial": [
    "ADJ"
  ],
  "relief": [
    "NOUN"
  ],
  "revision": [
    "NOUN",
    "PROPN"
  ],
  "influence": [
    "VERB",
    "NOUN"
  ],
  "ratio": [
    "NOUN",
    "PROPN"
  ],
  "importance": [
    "NOUN",
    "PROPN"
  ],
  "planet": [
    "NOUN"
  ],
  "recipe": [
    "NOUN",
    "PROPN"
  ],
  "permit": [
    "VERB"
  ],
  "seeing": [
    "VERB"
  ],
  "proof": [
    "NOUN",
    "PROPN"
  ],
  "tennis": [
    "NOUN"
  ],
  "prescription": [
    "NOUN"
  ],
  "bedroom": [
    "NOUN"
  ],
  "empty": [
    "ADJ",
    "PROPN"
  ],
  "instance": [
    "NOUN",
    "PROPN"
  ],
  "licensed": [
    "VERB",
    "ADJ"
  ],
  "orlando": [
    "PROPN"
  ],
  "specifically": [
    "ADV"
  ],
  "bureau": [
    "NOUN"
  ],
  "maine": [
    "NOUN"
  ],
  "represent": [
    "VERB"
  ],
  "conservation": [
    "NOUN"
  ],
  "ideal": [
    "ADJ",
    "PROPN"
  ],
  "specs": [
    "NOUN",
    "PROPN"
  ],
  "finished": [
    "VERB",
    "ADJ"
  ],
  "dinner": [
    "NOUN",
    "PROPN"
  ],
  "stress": [
    "NOUN",
    "VERB"
  ],
  "cream": [
    "NOUN"
  ],
  "discover": [
    "VERB",
    "PROPN"
  ],
  "louisiana": [
    "PROPN"
  ],
  "fourth": [
    "ADJ"
  ],
  "advisor": [
    "NOUN",
    "PROPN"
  ],
  "aware": [
    "ADJ",
    "PROPN"
  ],
  "wilson": [
    "PROPN"
  ],
  "shape": [
    "NOUN",
    "VERB"
  ],
  "evolution": [
    "NOUN",
    "PROPN"
  ],
  "irish": [
    "PROPN"
  ],
  "remains": [
    "VERB"
  ],
  "concerned": [
    "ADJ",
    "VERB"
  ],
  "operator": [
    "NOUN"
  ],
  "generic": [
    "ADJ",
    "PROPN"
  ],
  "encyclopedia": [
    "NOUN"
  ],
  "usage": [
    "NOUN",
    "PROPN"
  ],
  "mixed": [
    "VERB",
    "ADJ"
  ],
  "census": [
    "NOUN"
  ],
  "interracial": [
    "ADJ"
  ],
  "competitive": [
    "ADJ",
    "PROPN"
  ],
  "exist": [
    "VERB",
    "NOUN"
  ],
  "wheel": [
    "NOUN"
  ],
  "transit": [
    "NOUN",
    "PROPN"
  ],
  "compact": [
    "VERB"
  ],
  "poetry": [
    "NOUN"
  ],
  "angel": [
    "NOUN"
  ],
  "keeping": [
    "VERB",
    "NOUN"
  ],
  "preparation": [
    "NOUN",
    "PROPN"
  ],
  "attempt": [
    "NOUN",
    "VERB"
  ],
  "accordance": [
    "NOUN"
  ],
  "width": [
    "NOUN",
    "PROPN"
  ],
  "noise": [
    "NOUN",
    "PROPN"
  ],
  "forget": [
    "VERB"
  ],
  "array": [
    "NOUN",
    "PROPN"
  ],
  "accurate": [
    "ADJ"
  ],
  "stephen": [
    "PROPN"
  ],
  "elizabeth": [
    "PROPN"
  ],
  "climate": [
    "NOUN"
  ],
  "alcohol": [
    "PROPN"
  ],
  "greek": [
    "NOUN"
  ],
  "instruction": [
    "NOUN"
  ],
  "annotation": [
    "NOUN"
  ],
  "sister": [
    "NOUN"
  ],
  "walking": [
    "VERB"
  ],
  "explain": [
    "VERB",
    "PROPN"
  ],
  "smaller": [
    "ADJ"
  ],
  "establish": [
    "VERB",
    "PROPN"
  ],
  "expressed": [
    "VERB"
  ],
  "extent": [
    "NOUN"
  ],
  "sharp": [
    "ADJ"
  ],
  "paragraph": [
    "NOUN",
    "PROPN"
  ],
  "mathematics": [
    "NOUN"
  ],
  "compensation": [
    "NOUN",
    "PROPN"
  ],
  "export": [
    "NOUN",
    "PROPN"
  ],
  "aircraft": [
    "NOUN"
  ],
  "conflict": [
    "NOUN",
    "PROPN"
  ],
  "employer": [
    "NOUN"
  ],
  "occur": [
    "VERB"
  ],
  "percentage": [
    "NOUN",
    "PROPN"
  ],
  "mississippi": [
    "PROPN"
  ],
  "describe": [
    "VERB",
    "PROPN"
  ],
  "concern": [
    "NOUN",
    "PROPN"
  ],
  "backup": [
    "NOUN",
    "PROPN"
  ],
  "heritage": [
    "NOUN"
  ],
  "immediate": [
    "ADJ",
    "PROPN"
  ],
  "holding": [
    "VERB"
  ],
  "trouble": [
    "NOUN"
  ],
  "spread": [
    "VERB",
    "NOUN"
  ],
  "coach": [
    "VERB",
    "PROPN"
  ],
  "kevin": [
    "PROPN"
  ],
  "agricultural": [
    "ADJ"
  ],
  "expand": [
    "VERB",
    "PROPN"
  ],
  "supporting": [
    "VERB"
  ],
  "audience": [
    "NOUN",
    "PROPN"
  ],
  "assigned": [
    "VERB"
  ],
  "jordan": [
    "PROPN"
  ],
  "participate": [
    "VERB",
    "PROPN"
  ],
  "specialist": [
    "PROPN",
    "NOUN"
  ],
  "affect": [
    "VERB",
    "NOUN"
  ],
  "experienced": [
    "VERB",
    "ADJ"
  ],
  "investigation": [
    "NOUN",
    "PROPN"
  ],
  "raised": [
    "VERB"
  ],
  "institution": [
    "NOUN"
  ],
  "directed": [
    "VERB"
  ],
  "searching": [
    "VERB",
    "NOUN"
  ],
  "sporting": [
    "VERB"
  ],
  "helping": [
    "VERB"
  ],
  "affected": [
    "VERB",
    "PROPN"
  ],
  "totally": [
    "ADV"
  ],
  "plate": [
    "NOUN"
  ],
  "indicate": [
    "VERB"
  ],
  "blonde": [
    "ADJ"
  ],
  "transmission": [
    "NOUN"
  ],
  "anderson": [
    "PROPN"
  ],
  "organic": [
    "ADJ",
    "PROPN"
  ],
  "extremely": [
    "ADV"
  ],
  "concerning": [
    "VERB"
  ],
  "equivalent": [
    "ADJ",
    "NOUN"
  ],
  "chemistry": [
    "NOUN"
  ],
  "neighborhood": [
    "NOUN"
  ],
  "nevada": [
    "PROPN"
  ],
  "agenda": [
    "PROPN",
    "NOUN"
  ],
  "anyway": [
    "ADV"
  ],
  "advisory": [
    "PROPN",
    "ADJ"
  ],
  "curriculum": [
    "NOUN"
  ],
  "logic": [
    "NOUN",
    "PROPN"
  ],
  "template": [
    "NOUN",
    "PROPN"
  ],
  "prince": [
    "PROPN"
  ],
  "circle": [
    "NOUN",
    "PROPN"
  ],
  "anywhere": [
    "PROPN"
  ],
  "psychology": [
    "NOUN"
  ],
  "atlantic": [
    "PROPN"
  ],
  "edward": [
    "PROPN"
  ],
  "investor": [
    "NOUN",
    "PROPN"
  ],
  "identification": [
    "NOUN",
    "PROPN"
  ],
  "leaving": [
    "VERB"
  ],
  "wildlife": [
    "NOUN"
  ],
  "elementary": [
    "PROPN"
  ],
  "cooking": [
    "NOUN"
  ],
  "speaking": [
    "VERB",
    "NOUN"
  ],
  "unlimited": [
    "ADJ",
    "PROPN"
  ],
  "respond": [
    "VERB"
  ],
  "sizes": [
    "NOUN",
    "VERB"
  ],
  "plain": [
    "ADJ"
  ],
  "launch": [
    "NOUN",
    "PROPN"
  ],
  "costa": [
    "PROPN"
  ],
  "printable": [
    "ADJ"
  ],
  "guidance": [
    "NOUN",
    "PROPN"
  ],
  "trail": [
    "NOUN",
    "PROPN"
  ],
  "enforcement": [
    "NOUN",
    "PROPN"
  ],
  "symbol": [
    "NOUN"
  ],
  "highway": [
    "NOUN"
  ],
  "buddy": [
    "NOUN",
    "PROPN"
  ],
  "setup": [
    "NOUN",
    "PROPN"
  ],
  "booking": [
    "VERB",
    "NOUN"
  ],
  "glossary": [
    "PROPN"
  ],
  "fiscal": [
    "ADJ",
    "PROPN"
  ],
  "celebrity": [
    "NOUN"
  ],
  "filled": [
    "VERB",
    "ADJ"
  ],
  "appendix": [
    "PROPN"
  ],
  "notify": [
    "VERB",
    "PROPN"
  ],
  "blues": [
    "NOUN"
  ],
  "chocolate": [
    "NOUN"
  ],
  "portion": [
    "NOUN"
  ],
  "scope": [
    "NOUN",
    "PROPN"
  ],
  "hampshire": [
    "PROPN"
  ],
  "supplier": [
    "NOUN",
    "PROPN"
  ],
  "cotton": [
    "NOUN"
  ],
  "requirement": [
    "NOUN",
    "PROPN"
  ],
  "biology": [
    "NOUN"
  ],
  "dental": [
    "ADJ"
  ],
  "border": [
    "NOUN"
  ],
  "ancient": [
    "ADJ"
  ],
  "debate": [
    "NOUN"
  ],
  "pregnancy": [
    "NOUN"
  ],
  "arkansas": [
    "NOUN"
  ],
  "biography": [
    "NOUN"
  ],
  "leisure": [
    "NOUN"
  ],
  "learned": [
    "VERB"
  ],
  "notebook": [
    "NOUN",
    "PROPN"
  ],
  "explorer": [
    "NOUN"
  ],
  "historic": [
    "ADJ"
  ],
  "attached": [
    "VERB",
    "ADJ"
  ],
  "husband": [
    "NOUN"
  ],
  "disabled": [
    "VERB",
    "ADJ"
  ],
  "authorized": [
    "VERB",
    "ADJ"
  ],
  "crazy": [
    "ADJ"
  ],
  "upcoming": [
    "ADJ",
    "PROPN"
  ],
  "britain": [
    "PROPN"
  ],
  "concert": [
    "NOUN"
  ],
  "retirement": [
    "NOUN"
  ],
  "efficiency": [
    "NOUN",
    "PROPN"
  ],
  "comedy": [
    "NOUN"
  ],
  "adopted": [
    "VERB"
  ],
  "efficient": [
    "ADJ"
  ],
  "linear": [
    "ADJ",
    "PROPN"
  ],
  "commitment": [
    "NOUN",
    "PROPN"
  ],
  "specialty": [
    "PROPN"
  ],
  "carrier": [
    "NOUN"
  ],
  "constant": [
    "ADJ"
  ],
  "mouth": [
    "NOUN"
  ],
  "jewish": [
    "PROPN"
  ],
  "meter": [
    "NOUN"
  ],
  "linked": [
    "VERB",
    "PROPN"
  ],
  "reflect": [
    "VERB"
  ],
  "deliver": [
    "VERB",
    "PROPN"
  ],
  "wonder": [
    "PROPN",
    "NOUN"
  ],
  "fruit": [
    "NOUN"
  ],
  "qualified": [
    "ADJ",
    "PROPN"
  ],
  "reform": [
    "NOUN"
  ],
  "discovery": [
    "PROPN",
    "NOUN"
  ],
  "classified": [
    "VERB"
  ],
  "assume": [
    "VERB",
    "NOUN"
  ],
  "confidence": [
    "NOUN",
    "PROPN"
  ],
  "alliance": [
    "PROPN"
  ],
  "confirm": [
    "VERB",
    "PROPN"
  ],
  "neither": [
    "CCONJ"
  ],
  "lewis": [
    "VERB"
  ],
  "howard": [
    "PROPN"
  ],
  "leaves": [
    "VERB",
    "NOUN"
  ],
  "engineer": [
    "PROPN",
    "NOUN"
  ],
  "consistent": [
    "ADJ",
    "PROPN"
  ],
  "replace": [
    "VERB",
    "PROPN"
  ],
  "clearance": [
    "NOUN"
  ],
  "inventory": [
    "NOUN",
    "PROPN"
  ],
  "converter": [
    "NOUN"
  ],
  "becoming": [
    "VERB"
  ],
  "safari": [
    "PROPN"
  ],
  "objective": [
    "NOUN",
    "PROPN"
  ],
  "sugar": [
    "NOUN"
  ],
  "stick": [
    "VERB",
    "PROPN"
  ],
  "allen": [
    "VERB"
  ],
  "relation": [
    "NOUN"
  ],
  "genre": [
    "NOUN"
  ],
  "slide": [
    "NOUN",
    "PROPN"
  ],
  "montana": [
    "PROPN"
  ],
  "volunteer": [
    "NOUN",
    "VERB"
  ],
  "tested": [
    "VERB"
  ],
  "democratic": [
    "ADJ"
  ],
  "enhance": [
    "VERB",
    "PROPN"
  ],
  "exact": [
    "ADJ"
  ],
  "bound": [
    "VERB"
  ],
  "parameter": [
    "NOUN",
    "PROPN"
  ],
  "adapter": [
    "NOUN",
    "PROPN"
  ],
  "processor": [
    "NOUN",
    "PROPN"
  ],
  "formal": [
    "ADJ"
  ],
  "contribute": [
    "VERB",
    "PROPN"
  ],
  "hockey": [
    "NOUN"
  ],
  "storm": [
    "NOUN"
  ],
  "micro": [
    "PROPN",
    "NOUN"
  ],
  "supreme": [
    "PROPN"
  ],
  "recognition": [
    "NOUN",
    "PROPN"
  ],
  "submission": [
    "NOUN",
    "PROPN"
  ],
  "estimate": [
    "NOUN",
    "PROPN"
  ],
  "encourage": [
    "VERB",
    "PROPN"
  ],
  "regulatory": [
    "ADJ",
    "PROPN"
  ],
  "inspection": [
    "NOUN"
  ],
  "cancel": [
    "VERB",
    "PROPN"
  ],
  "territory": [
    "NOUN",
    "PROPN"
  ],
  "transaction": [
    "NOUN",
    "PROPN"
  ],
  "manchester": [
    "NOUN"
  ],
  "paint": [
    "VERB",
    "PROPN"
  ],
  "delay": [
    "NOUN",
    "VERB"
  ],
  "pilot": [
    "NOUN",
    "PROPN"
  ],
  "outlet": [
    "PROPN"
  ],
  "continuous": [
    "ADJ",
    "PROPN"
  ],
  "czech": [
    "PROPN"
  ],
  "resulting": [
    "VERB"
  ],
  "initiative": [
    "NOUN",
    "PROPN"
  ],
  "novel": [
    "ADJ"
  ],
  "execution": [
    "NOUN",
    "PROPN"
  ],
  "disability": [
    "NOUN"
  ],
  "ultra": [
    "ADJ"
  ],
  "winner": [
    "NOUN"
  ],
  "idaho": [
    "VERB"
  ],
  "contractor": [
    "NOUN",
    "PROPN"
  ],
  "episode": [
    "NOUN"
  ],
  "examination": [
    "NOUN"
  ],
  "potter": [
    "NOUN"
  ],
  "bulletin": [
    "NOUN"
  ],
  "modify": [
    "VERB"
  ],
  "oxford": [
    "PROPN"
  ],
  "truly": [
    "ADV"
  ],
  "painting": [
    "VERB"
  ],
  "extensive": [
    "ADJ"
  ],
  "affordable": [
    "ADJ"
  ],
  "universe": [
    "NOUN"
  ],
  "candidate": [
    "NOUN",
    "PROPN"
  ],
  "patent": [
    "NOUN"
  ],
  "outstanding": [
    "ADJ",
    "PROPN"
  ],
  "eating": [
    "VERB"
  ],
  "perspective": [
    "NOUN",
    "PROPN"
  ],
  "watching": [
    "VERB"
  ],
  "lodge": [
    "VERB"
  ],
  "messenger": [
    "NOUN"
  ],
  "mirror": [
    "NOUN",
    "PROPN"
  ],
  "tournament": [
    "NOUN"
  ],
  "consideration": [
    "NOUN"
  ],
  "sterling": [
    "NOUN"
  ],
  "sessions": [
    "NOUN",
    "PROPN"
  ],
  "kernel": [
    "NOUN"
  ],
  "stocks": [
    "NOUN"
  ],
  "catalogue": [
    "NOUN",
    "PROPN"
  ],
  "jennifer": [
    "PROPN"
  ],
  "antonio": [
    "VERB"
  ],
  "broad": [
    "ADJ"
  ],
  "chosen": [
    "VERB"
  ],
  "swiss": [
    "VERB"
  ],
  "sarah": [
    "PROPN"
  ],
  "clark": [
    "NOUN"
  ],
  "labour": [
    "NOUN"
  ],
  "terminal": [
    "ADJ",
    "NOUN"
  ],
  "nights": [
    "NOUN"
  ],
  "behalf": [
    "NOUN"
  ],
  "caribbean": [
    "ADJ"
  ],
  "liquid": [
    "NOUN"
  ],
  "salary": [
    "NOUN"
  ],
  "reservation": [
    "NOUN"
  ],
  "gourmet": [
    "NOUN"
  ],
  "guard": [
    "PROPN",
    "NOUN"
  ],
  "properly": [
    "ADV"
  ],
  "orleans": [
    "PROPN"
  ],
  "saving": [
    "VERB",
    "NOUN"
  ],
  "empire": [
    "NOUN"
  ],
  "resume": [
    "VERB",
    "NOUN"
  ],
  "twenty": [
    "NUM"
  ],
  "newly": [
    "ADV"
  ],
  "raise": [
    "VERB",
    "PROPN"
  ],
  "prepare": [
    "VERB",
    "PROPN"
  ],
  "depending": [
    "VERB"
  ],
  "illegal": [
    "ADJ"
  ],
  "expansion": [
    "NOUN",
    "PROPN"
  ],
  "lincoln": [
    "NOUN"
  ],
  "premier": [
    "PROPN"
  ],
  "tomorrow": [
    "NOUN"
  ],
  "decide": [
    "VERB",
    "PROPN"
  ],
  "consent": [
    "NOUN",
    "PROPN"
  ],
  "drama": [
    "NOUN"
  ],
  "visiting": [
    "VERB"
  ],
  "downtown": [
    "NOUN"
  ],
  "keyboard": [
    "NOUN",
    "PROPN"
  ],
  "contest": [
    "NOUN"
  ],
  "collected": [
    "VERB"
  ],
  "suitable": [
    "ADJ"
  ],
  "absolutely": [
    "ADV"
  ],
  "millions": [
    "NOUN"
  ],
  "lunch": [
    "NOUN",
    "PROPN"
  ],
  "audit": [
    "PROPN",
    "NOUN"
  ],
  "chamber": [
    "NOUN"
  ],
  "guinea": [
    "NOUN"
  ],
  "muscle": [
    "NOUN"
  ],
  "implement": [
    "VERB",
    "PROPN"
  ],
  "typical": [
    "ADJ"
  ],
  "tower": [
    "PROPN"
  ],
  "yours": [
    "NOUN"
  ],
  "calculator": [
    "NOUN",
    "PROPN"
  ],
  "significantly": [
    "ADV"
  ],
  "chicken": [
    "NOUN"
  ],
  "temporary": [
    "ADJ",
    "PROPN"
  ],
  "attend": [
    "VERB",
    "PROPN"
  ],
  "shower": [
    "VERB"
  ],
  "sending": [
    "VERB",
    "NOUN"
  ],
  "jason": [
    "PROPN"
  ],
  "tonight": [
    "NOUN"
  ],
  "sufficient": [
    "ADJ"
  ],
  "shell": [
    "NOUN",
    "PROPN"
  ],
  "province": [
    "NOUN"
  ],
  "catholic": [
    "ADJ"
  ],
  "awareness": [
    "PROPN",
    "NOUN"
  ],
  "governor": [
    "NOUN"
  ],
  "contribution": [
    "NOUN",
    "PROPN"
  ],
  "measurement": [
    "NOUN",
    "PROPN"
  ],
  "swimming": [
    "VERB"
  ],
  "formula": [
    "NOUN",
    "PROPN"
  ],
  "constitution": [
    "NOUN"
  ],
  "solar": [
    "ADJ"
  ],
  "catch": [
    "VERB",
    "NOUN"
  ],
  "reliable": [
    "ADJ"
  ],
  "consultation": [
    "NOUN"
  ],
  "northwest": [
    "NOUN"
  ],
  "doubt": [
    "NOUN"
  ],
  "finder": [
    "NOUN"
  ],
  "unable": [
    "ADJ"
  ],
  "classroom": [
    "NOUN"
  ],
  "democracy": [
    "NOUN"
  ],
  "wallpaper": [
    "NOUN"
  ],
  "merchandise": [
    "NOUN"
  ],
  "resistance": [
    "NOUN"
  ],
  "biggest": [
    "ADJ"
  ],
  "memorial": [
    "VERB"
  ],
  "visitor": [
    "NOUN"
  ],
  "forth": [
    "ADV"
  ],
  "insert": [
    "PROPN",
    "ADJ"
  ],
  "baltimore": [
    "PROPN"
  ],
  "gateway": [
    "NOUN",
    "PROPN"
  ],
  "alumni": [
    "NOUN"
  ],
  "drawing": [
    "VERB"
  ],
  "charlotte": [
    "PROPN"
  ],
  "ordered": [
    "VERB"
  ],
  "biological": [
    "ADJ"
  ],
  "fighting": [
    "VERB"
  ],
  "transition": [
    "NOUN",
    "PROPN"
  ],
  "romance": [
    "NOUN"
  ],
  "instrument": [
    "NOUN",
    "VERB"
  ],
  "bruce": [
    "NOUN"
  ],
  "split": [
    "VERB",
    "NOUN"
  ],
  "heaven": [
    "PROPN"
  ],
  "pregnant": [
    "ADJ"
  ],
  "twice": [
    "ADV"
  ],
  "classification": [
    "NOUN",
    "PROPN"
  ],
  "egypt": [
    "PROPN"
  ],
  "physician": [
    "NOUN"
  ],
  "hollywood": [
    "NOUN"
  ],
  "bargain": [
    "NOUN"
  ],
  "cellular": [
    "ADJ"
  ],
  "norway": [
    "PROPN"
  ],
  "vermont": [
    "PROPN"
  ],
  "normally": [
    "ADV"
  ],
  "spiritual": [
    "ADJ"
  ],
  "hunting": [
    "VERB"
  ],
  "diabetes": [
    "NOUN"
  ],
  "shift": [
    "NOUN",
    "VERB"
  ],
  "cutting": [
    "VERB",
    "NOUN"
  ],
  "simon": [
    "PROPN"
  ],
  "flexible": [
    "ADJ",
    "PROPN"
  ],
  "numerous": [
    "ADJ"
  ],
  "relatively": [
    "ADV"
  ],
  "satisfaction": [
    "NOUN",
    "PROPN"
  ],
  "indexed": [
    "VERB"
  ],
  "superior": [
    "ADJ"
  ],
  "preferred": [
    "ADJ",
    "VERB"
  ],
  "saved": [
    "VERB",
    "PROPN"
  ],
  "paying": [
    "VERB"
  ],
  "cartoon": [
    "NOUN"
  ],
  "intellectual": [
    "ADJ"
  ],
  "moore": [
    "PROPN"
  ],
  "carbon": [
    "NOUN",
    "PROPN"
  ],
  "spending": [
    "VERB",
    "NOUN"
  ],
  "comfortable": [
    "ADJ"
  ],
  "magnetic": [
    "ADJ"
  ],
  "interaction": [
    "NOUN",
    "PROPN"
  ],
  "listening": [
    "VERB",
    "NOUN"
  ],
  "effectively": [
    "ADV"
  ],
  "registry": [
    "NOUN",
    "PROPN"
  ],
  "crisis": [
    "NOUN",
    "PROPN"
  ],
  "outlook": [
    "NOUN",
    "PROPN"
  ],
  "massive": [
    "ADJ"
  ],
  "denmark": [
    "VERB"
  ],
  "employed": [
    "VERB"
  ],
  "bright": [
    "ADJ"
  ],
  "treat": [
    "VERB"
  ],
  "header": [
    "NOUN",
    "PROPN"
  ],
  "poverty": [
    "NOUN"
  ],
  "formed": [
    "VERB"
  ],
  "piano": [
    "NOUN"
  ],
  "patrick": [
    "PROPN"
  ],
  "experimental": [
    "ADJ",
    "NOUN"
  ],
  "revolution": [
    "NOUN"
  ],
  "consolidation": [
    "NOUN",
    "PROPN"
  ],
  "plasma": [
    "NOUN"
  ],
  "earnings": [
    "NOUN"
  ],
  "mystery": [
    "NOUN"
  ],
  "landscape": [
    "NOUN",
    "PROPN"
  ],
  "dependent": [
    "ADJ",
    "PROPN"
  ],
  "mechanical": [
    "PROPN"
  ],
  "journey": [
    "NOUN",
    "PROPN"
  ],
  "delaware": [
    "VERB"
  ],
  "bidding": [
    "VERB"
  ],
  "banner": [
    "NOUN",
    "PROPN"
  ],
  "applicant": [
    "ADJ"
  ],
  "charter": [
    "NOUN"
  ],
  "barbara": [
    "PROPN"
  ],
  "acquisition": [
    "NOUN",
    "PROPN"
  ],
  "notification": [
    "NOUN",
    "PROPN"
  ],
  "teach": [
    "VERB"
  ],
  "rapid": [
    "ADJ",
    "PROPN"
  ],
  "hairy": [
    "ADJ"
  ],
  "diversity": [
    "NOUN",
    "PROPN"
  ],
  "reverse": [
    "VERB",
    "ADJ"
  ],
  "deposit": [
    "NOUN"
  ],
  "seminar": [
    "NOUN"
  ],
  "specify": [
    "VERB"
  ],
  "accessibility": [
    "PROPN",
    "NOUN"
  ],
  "dutch": [
    "VERB"
  ],
  "sensitive": [
    "ADJ",
    "PROPN"
  ],
  "boots": [
    "NOUN"
  ],
  "router": [
    "NOUN",
    "PROPN"
  ],
  "concrete": [
    "ADJ"
  ],
  "folder": [
    "NOUN",
    "PROPN"
  ],
  "completion": [
    "PROPN",
    "NOUN"
  ],
  "pulse": [
    "PROPN",
    "NOUN"
  ],
  "technique": [
    "NOUN",
    "PROPN"
  ],
  "voting": [
    "NOUN",
    "PROPN"
  ],
  "calculate": [
    "VERB"
  ],
  "alexander": [
    "PROPN"
  ],
  "broadcast": [
    "NOUN",
    "VERB"
  ],
  "converted": [
    "VERB"
  ],
  "anniversary": [
    "NOUN"
  ],
  "specification": [
    "NOUN",
    "PROPN"
  ],
  "pearl": [
    "PROPN"
  ],
  "accident": [
    "NOUN"
  ],
  "accessible": [
    "ADJ"
  ],
  "accessory": [
    "NOUN"
  ],
  "resident": [
    "NOUN"
  ],
  "possibly": [
    "ADV"
  ],
  "typically": [
    "ADV"
  ],
  "representation": [
    "NOUN"
  ],
  "regard": [
    "NOUN"
  ],
  "smooth": [
    "ADJ",
    "VERB"
  ],
  "strike": [
    "VERB"
  ],
  "consumption": [
    "NOUN",
    "PROPN"
  ],
  "birmingham": [
    "PROPN"
  ],
  "flashing": [
    "VERB"
  ],
  "narrow": [
    "VERB",
    "ADJ"
  ],
  "afternoon": [
    "NOUN",
    "PROPN"
  ],
  "threat": [
    "NOUN",
    "PROPN"
  ],
  "sitting": [
    "VERB"
  ],
  "consultant": [
    "NOUN",
    "PROPN"
  ],
  "controller": [
    "NOUN",
    "PROPN"
  ],
  "ownership": [
    "NOUN",
    "PROPN"
  ],
  "legislative": [
    "ADJ"
  ],
  "trailer": [
    "NOUN"
  ],
  "castle": [
    "PROPN"
  ],
  "antique": [
    "NOUN"
  ],
  "willing": [
    "ADJ"
  ],
  "molecular": [
    "ADJ"
  ],
  "acting": [
    "VERB"
  ],
  "logos": [
    "NOUN"
  ],
  "residence": [
    "NOUN"
  ],
  "density": [
    "NOUN"
  ],
  "hundred": [
    "NUM"
  ],
  "strange": [
    "ADJ"
  ],
  "sustainable": [
    "ADJ"
  ],
  "philippines": [
    "PROPN"
  ],
  "statistical": [
    "ADJ"
  ],
  "mention": [
    "VERB",
    "NOUN"
  ],
  "innovation": [
    "NOUN",
    "PROPN"
  ],
  "parallel": [
    "NOUN",
    "ADJ"
  ],
  "honda": [
    "NOUN"
  ],
  "operate": [
    "VERB",
    "PROPN"
  ],
  "bathroom": [
    "NOUN"
  ],
  "stable": [
    "ADJ",
    "PROPN"
  ],
  "opera": [
    "PROPN"
  ],
  "lesson": [
    "NOUN",
    "PROPN"
  ],
  "cinema": [
    "NOUN"
  ],
  "asset": [
    "NOUN",
    "PROPN"
  ],
  "drinking": [
    "VERB"
  ],
  "reaction": [
    "NOUN"
  ],
  "blank": [
    "ADJ",
    "PROPN"
  ],
  "enhanced": [
    "VERB",
    "ADJ"
  ],
  "severe": [
    "ADJ"
  ],
  "generate": [
    "VERB",
    "PROPN"
  ],
  "stainless": [
    "ADJ"
  ],
  "deluxe": [
    "NOUN"
  ],
  "humor": [
    "NOUN"
  ],
  "exception": [
    "NOUN",
    "PROPN"
  ],
  "lived": [
    "VERB"
  ],
  "duration": [
    "NOUN",
    "PROPN"
  ],
  "successfully": [
    "ADV"
  ],
  "pursuant": [
    "ADJ"
  ],
  "fabric": [
    "PROPN",
    "NOUN"
  ],
  "primarily": [
    "ADV"
  ],
  "tight": [
    "ADJ"
  ],
  "contrast": [
    "NOUN"
  ],
  "recommendation": [
    "NOUN",
    "PROPN"
  ],
  "flying": [
    "VERB"
  ],
  "recruitment": [
    "NOUN",
    "PROPN"
  ],
  "berlin": [
    "PROPN"
  ],
  "organized": [
    "VERB",
    "ADJ"
  ],
  "adoption": [
    "NOUN",
    "PROPN"
  ],
  "improving": [
    "VERB",
    "PROPN"
  ],
  "expensive": [
    "ADJ"
  ],
  "meant": [
    "VERB"
  ],
  "capture": [
    "VERB",
    "PROPN"
  ],
  "buffalo": [
    "VERB"
  ],
  "plane": [
    "NOUN",
    "PROPN"
  ],
  "desire": [
    "NOUN",
    "VERB"
  ],
  "mechanism": [
    "NOUN",
    "PROPN"
  ],
  "welfare": [
    "NOUN"
  ],
  "caught": [
    "VERB"
  ],
  "eventually": [
    "ADV"
  ],
  "marked": [
    "VERB"
  ],
  "driven": [
    "VERB",
    "PROPN"
  ],
  "measured": [
    "VERB"
  ],
  "bottle": [
    "NOUN"
  ],
  "considering": [
    "VERB"
  ],
  "innovative": [
    "ADJ"
  ],
  "marshall": [
    "PROPN"
  ],
  "massage": [
    "NOUN"
  ],
  "rubber": [
    "NOUN"
  ],
  "conclusion": [
    "NOUN",
    "PROPN"
  ],
  "thousand": [
    "NUM"
  ],
  "legend": [
    "PROPN",
    "NOUN"
  ],
  "grace": [
    "PROPN",
    "NOUN"
  ],
  "susan": [
    "PROPN"
  ],
  "python": [
    "PROPN",
    "NOUN"
  ],
  "monster": [
    "NOUN"
  ],
  "villa": [
    "NOUN"
  ],
  "collaboration": [
    "NOUN",
    "PROPN"
  ],
  "hamilton": [
    "PROPN"
  ],
  "detection": [
    "NOUN",
    "PROPN"
  ],
  "inner": [
    "ADJ",
    "PROPN"
  ],
  "formation": [
    "NOUN"
  ],
  "tutorial": [
    "NOUN"
  ],
  "entity": [
    "NOUN",
    "PROPN"
  ],
  "holder": [
    "NOUN"
  ],
  "moderator": [
    "PROPN"
  ],
  "settlement": [
    "NOUN"
  ],
  "portugal": [
    "PROPN"
  ],
  "lawrence": [
    "PROPN"
  ],
  "roman": [
    "PROPN"
  ],
  "valuable": [
    "ADJ"
  ],
  "ethics": [
    "NOUN"
  ],
  "forever": [
    "ADV"
  ],
  "dragon": [
    "NOUN"
  ],
  "captain": [
    "NOUN"
  ],
  "fantastic": [
    "ADJ"
  ],
  "imagine": [
    "VERB"
  ],
  "heating": [
    "VERB"
  ],
  "stereo": [
    "VERB"
  ],
  "taste": [
    "VERB"
  ],
  "dealing": [
    "VERB"
  ],
  "commit": [
    "VERB",
    "NOUN"
  ],
  "operational": [
    "ADJ",
    "PROPN"
  ],
  "liberal": [
    "ADJ"
  ],
  "sides": [
    "NOUN"
  ],
  "turns": [
    "VERB",
    "NOUN"
  ],
  "corresponding": [
    "VERB",
    "ADJ"
  ],
  "cache": [
    "NOUN",
    "PROPN"
  ],
  "jacket": [
    "NOUN"
  ],
  "determination": [
    "NOUN"
  ],
  "animation": [
    "NOUN"
  ],
  "oracle": [
    "PROPN",
    "NOUN"
  ],
  "matthew": [
    "PROPN"
  ],
  "lease": [
    "VERB"
  ],
  "aviation": [
    "NOUN"
  ],
  "excess": [
    "ADJ"
  ],
  "disaster": [
    "NOUN",
    "PROPN"
  ],
  "console": [
    "NOUN",
    "PROPN"
  ],
  "instructor": [
    "PROPN",
    "NOUN"
  ],
  "giant": [
    "ADJ"
  ],
  "shipped": [
    "VERB",
    "PROPN"
  ],
  "alarm": [
    "PROPN",
    "NOUN"
  ],
  "voltage": [
    "NOUN"
  ],
  "anthony": [
    "PROPN"
  ],
  "usual": [
    "ADJ"
  ],
  "loading": [
    "NOUN",
    "VERB"
  ],
  "franklin": [
    "PROPN"
  ],
  "angle": [
    "NOUN"
  ],
  "vinyl": [
    "NOUN"
  ],
  "mining": [
    "NOUN"
  ],
  "ongoing": [
    "ADJ",
    "PROPN"
  ],
  "worst": [
    "ADJ"
  ],
  "betting": [
    "VERB"
  ],
  "liberty": [
    "PROPN"
  ],
  "blackjack": [
    "VERB"
  ],
  "argentina": [
    "PROPN"
  ],
  "convert": [
    "VERB",
    "PROPN"
  ],
  "possibility": [
    "NOUN",
    "PROPN"
  ],
  "analyst": [
    "NOUN",
    "PROPN"
  ],
  "commissioner": [
    "NOUN"
  ],
  "dangerous": [
    "ADJ"
  ],
  "garage": [
    "NOUN"
  ],
  "exciting": [
    "ADJ"
  ],
  "reliability": [
    "PROPN",
    "NOUN"
  ],
  "unfortunately": [
    "ADV"
  ],
  "respectively": [
    "ADV"
  ],
  "attachment": [
    "NOUN",
    "PROPN"
  ],
  "finland": [
    "NOUN"
  ],
  "morgan": [
    "PROPN"
  ],
  "derived": [
    "VERB"
  ],
  "pleasure": [
    "NOUN"
  ],
  "honor": [
    "VERB"
  ],
  "eagle": [
    "VERB"
  ],
  "pants": [
    "NOUN"
  ],
  "nurse": [
    "NOUN"
  ],
  "prayer": [
    "NOUN"
  ],
  "appointment": [
    "NOUN"
  ],
  "hurricane": [
    "NOUN"
  ],
  "quiet": [
    "ADJ"
  ],
  "postage": [
    "NOUN"
  ],
  "producer": [
    "NOUN",
    "PROPN"
  ],
  "cheese": [
    "NOUN"
  ],
  "comic": [
    "ADJ"
  ],
  "carefully": [
    "ADV"
  ],
  "productivity": [
    "NOUN",
    "PROPN"
  ],
  "crown": [
    "NOUN"
  ],
  "underground": [
    "ADV"
  ],
  "diagnosis": [
    "NOUN"
  ],
  "maker": [
    "NOUN",
    "PROPN"
  ],
  "crack": [
    "VERB"
  ],
  "principle": [
    "NOUN",
    "PROPN"
  ],
  "semester": [
    "NOUN"
  ],
  "calculated": [
    "VERB",
    "ADJ"
  ],
  "fetish": [
    "NOUN"
  ],
  "appearance": [
    "NOUN"
  ],
  "smoke": [
    "NOUN",
    "PROPN"
  ],
  "apache": [
    "PROPN"
  ],
  "incorporated": [
    "VERB"
  ],
  "craft": [
    "NOUN",
    "PROPN"
  ],
  "apart": [
    "ADV"
  ],
  "fellow": [
    "ADJ"
  ],
  "blind": [
    "ADJ"
  ],
  "lounge": [
    "NOUN"
  ],
  "algorithm": [
    "PROPN",
    "NOUN"
  ],
  "gross": [
    "ADJ",
    "PROPN"
  ],
  "strongly": [
    "ADV"
  ],
  "valentine": [
    "VERB"
  ],
  "horror": [
    "NOUN"
  ],
  "familiar": [
    "ADJ"
  ],
  "capable": [
    "ADJ"
  ],
  "douglas": [
    "PROPN"
  ],
  "christopher": [
    "PROPN"
  ],
  "admission": [
    "NOUN"
  ],
  "carrying": [
    "VERB"
  ],
  "victory": [
    "NOUN"
  ],
  "terrorism": [
    "NOUN"
  ],
  "mainly": [
    "ADV"
  ],
  "ethnic": [
    "ADJ"
  ],
  "parliament": [
    "NOUN"
  ],
  "actor": [
    "NOUN"
  ],
  "fifth": [
    "ADJ"
  ],
  "citizen": [
    "NOUN"
  ],
  "vertical": [
    "ADJ",
    "PROPN"
  ],
  "structural": [
    "ADJ"
  ],
  "municipal": [
    "ADJ"
  ],
  "prize": [
    "NOUN"
  ],
  "absolute": [
    "ADJ",
    "PROPN"
  ],
  "substance": [
    "NOUN"
  ],
  "guardian": [
    "NOUN"
  ],
  "lecture": [
    "NOUN"
  ],
  "simulation": [
    "NOUN"
  ],
  "layout": [
    "NOUN",
    "PROPN"
  ],
  "concentration": [
    "NOUN"
  ],
  "interpretation": [
    "NOUN",
    "PROPN"
  ],
  "dirty": [
    "ADJ"
  ],
  "wayne": [
    "PROPN"
  ],
  "donate": [
    "VERB"
  ],
  "taught": [
    "VERB"
  ],
  "bankruptcy": [
    "NOUN"
  ],
  "worker": [
    "NOUN",
    "PROPN"
  ],
  "optimization": [
    "NOUN",
    "PROPN"
  ],
  "alive": [
    "ADJ"
  ],
  "temple": [
    "PROPN"
  ],
  "prove": [
    "VERB"
  ],
  "discovered": [
    "VERB"
  ],
  "genetic": [
    "ADJ"
  ],
  "promise": [
    "NOUN",
    "PROPN"
  ],
  "exhibition": [
    "NOUN"
  ],
  "prefer": [
    "VERB"
  ],
  "ridge": [
    "NOUN"
  ],
  "cabinet": [
    "NOUN"
  ],
  "harris": [
    "PROPN"
  ],
  "evaluate": [
    "VERB",
    "PROPN"
  ],
  "tiffany": [
    "PROPN"
  ],
  "tropical": [
    "ADJ"
  ],
  "collect": [
    "VERB",
    "PROPN"
  ],
  "composition": [
    "NOUN"
  ],
  "streets": [
    "NOUN"
  ],
  "nationwide": [
    "ADJ"
  ],
  "vector": [
    "NOUN"
  ],
  "definitely": [
    "ADV"
  ],
  "shaved": [
    "VERB"
  ],
  "turning": [
    "VERB"
  ],
  "buffer": [
    "NOUN",
    "PROPN"
  ],
  "purple": [
    "NOUN",
    "ADJ"
  ],
  "existence": [
    "NOUN"
  ],
  "commentary": [
    "NOUN",
    "PROPN"
  ],
  "larry": [
    "PROPN"
  ],
  "immigration": [
    "NOUN"
  ],
  "mutual": [
    "ADJ",
    "PROPN"
  ],
  "pipeline": [
    "NOUN",
    "PROPN"
  ],
  "necessarily": [
    "ADV"
  ],
  "syntax": [
    "NOUN",
    "PROPN"
  ],
  "attribute": [
    "NOUN",
    "PROPN"
  ],
  "prison": [
    "NOUN"
  ],
  "skill": [
    "NOUN",
    "PROPN"
  ],
  "everyday": [
    "ADJ",
    "NOUN"
  ],
  "apparently": [
    "ADV"
  ],
  "surrounding": [
    "VERB"
  ],
  "popularity": [
    "NOUN"
  ],
  "inquiry": [
    "NOUN"
  ],
  "checked": [
    "VERB"
  ],
  "exhibit": [
    "VERB"
  ],
  "throw": [
    "VERB"
  ],
  "trend": [
    "NOUN",
    "PROPN"
  ],
  "sierra": [
    "PROPN"
  ],
  "visible": [
    "ADJ"
  ],
  "desert": [
    "NOUN"
  ],
  "obviously": [
    "ADV"
  ],
  "mercury": [
    "PROPN",
    "NOUN"
  ],
  "steven": [
    "PROPN"
  ],
  "handbook": [
    "PROPN"
  ],
  "navigate": [
    "VERB",
    "ADJ"
  ],
  "worse": [
    "ADJ"
  ],
  "summit": [
    "PROPN",
    "NOUN"
  ],
  "fundamental": [
    "ADJ",
    "PROPN"
  ],
  "burning": [
    "VERB"
  ],
  "escape": [
    "NOUN"
  ],
  "somewhat": [
    "ADV"
  ],
  "receiver": [
    "NOUN"
  ],
  "substantial": [
    "ADJ"
  ],
  "progressive": [
    "ADJ",
    "PROPN"
  ],
  "glance": [
    "NOUN",
    "PROPN"
  ],
  "scottish": [
    "ADJ"
  ],
  "championship": [
    "NOUN"
  ],
  "arcade": [
    "NOUN"
  ],
  "richmond": [
    "PROPN"
  ],
  "sacramento": [
    "PROPN"
  ],
  "impossible": [
    "ADJ"
  ],
  "russell": [
    "PROPN"
  ],
  "obvious": [
    "ADJ"
  ],
  "fiber": [
    "NOUN"
  ],
  "depression": [
    "NOUN"
  ],
  "graph": [
    "NOUN",
    "PROPN"
  ],
  "covering": [
    "VERB"
  ],
  "platinum": [
    "PROPN",
    "NOUN"
  ],
  "judgment": [
    "NOUN"
  ],
  "filing": [
    "VERB"
  ],
  "foster": [
    "VERB",
    "PROPN"
  ],
  "modeling": [
    "NOUN",
    "VERB"
  ],
  "passing": [
    "VERB"
  ],
  "tissue": [
    "NOUN"
  ],
  "memorabilia": [
    "NOUN"
  ],
  "clinton": [
    "PROPN"
  ],
  "cartridge": [
    "NOUN"
  ],
  "alberta": [
    "PROPN"
  ],
  "explanation": [
    "NOUN",
    "PROPN"
  ],
  "commons": [
    "PROPN",
    "NOUN"
  ],
  "cincinnati": [
    "PROPN"
  ],
  "subsection": [
    "NOUN"
  ],
  "fraud": [
    "NOUN",
    "PROPN"
  ],
  "electricity": [
    "NOUN"
  ],
  "permitted": [
    "VERB"
  ],
  "spectrum": [
    "NOUN"
  ],
  "arrival": [
    "NOUN"
  ],
  "pottery": [
    "NOUN"
  ],
  "emphasis": [
    "NOUN"
  ],
  "roger": [
    "PROPN"
  ],
  "aspect": [
    "NOUN"
  ],
  "workplace": [
    "PROPN",
    "NOUN"
  ],
  "awesome": [
    "ADJ",
    "PROPN"
  ],
  "mexican": [
    "PROPN"
  ],
  "confirmed": [
    "VERB",
    "PROPN"
  ],
  "priced": [
    "VERB"
  ],
  "crash": [
    "NOUN",
    "VERB"
  ],
  "desired": [
    "VERB"
  ],
  "inter": [
    "ADJ"
  ],
  "closer": [
    "ADJ"
  ],
  "shadow": [
    "PROPN",
    "NOUN"
  ],
  "riding": [
    "VERB"
  ],
  "infection": [
    "NOUN"
  ],
  "expense": [
    "NOUN",
    "PROPN"
  ],
  "grove": [
    "VERB"
  ],
  "eligibility": [
    "NOUN",
    "PROPN"
  ],
  "venture": [
    "NOUN"
  ],
  "clinic": [
    "NOUN"
  ],
  "korean": [
    "ADJ"
  ],
  "healing": [
    "VERB"
  ],
  "princess": [
    "VERB"
  ],
  "entering": [
    "VERB"
  ],
  "packet": [
    "NOUN",
    "ADJ"
  ],
  "spray": [
    "VERB"
  ],
  "involvement": [
    "NOUN",
    "PROPN"
  ],
  "buttons": [
    "NOUN",
    "PROPN"
  ],
  "placement": [
    "NOUN",
    "PROPN"
  ],
  "funded": [
    "VERB"
  ],
  "extend": [
    "VERB",
    "NOUN"
  ],
  "subsequent": [
    "ADJ"
  ],
  "rolling": [
    "VERB",
    "ADJ"
  ],
  "motorcycle": [
    "NOUN"
  ],
  "disclosure": [
    "NOUN",
    "PROPN"
  ],
  "establishment": [
    "NOUN"
  ],
  "nelson": [
    "PROPN"
  ],
  "tourist": [
    "NOUN"
  ],
  "mayor": [
    "NOUN"
  ],
  "adequate": [
    "ADJ"
  ],
  "senator": [
    "NOUN"
  ],
  "yield": [
    "VERB"
  ],
  "digest": [
    "NOUN",
    "PROPN"
  ],
  "lodging": [
    "VERB"
  ],
  "hence": [
    "ADV"
  ],
  "entirely": [
    "ADV"
  ],
  "radar": [
    "PROPN",
    "NOUN"
  ],
  "rescue": [
    "NOUN"
  ],
  "undergraduate": [
    "NOUN"
  ],
  "combat": [
    "NOUN"
  ],
  "reducing": [
    "VERB"
  ],
  "stopped": [
    "VERB"
  ],
  "occupation": [
    "NOUN"
  ],
  "closely": [
    "ADV"
  ],
  "radiation": [
    "NOUN"
  ],
  "diary": [
    "NOUN"
  ],
  "seriously": [
    "ADV"
  ],
  "shooting": [
    "VERB"
  ],
  "baker": [
    "PROPN"
  ],
  "elsewhere": [
    "ADV"
  ],
  "pollution": [
    "NOUN"
  ],
  "conservative": [
    "ADJ"
  ],
  "shock": [
    "NOUN"
  ],
  "effectiveness": [
    "NOUN",
    "PROPN"
  ],
  "abroad": [
    "ADV"
  ],
  "ebony": [
    "PROPN"
  ],
  "drawn": [
    "VERB"
  ],
  "arthur": [
    "PROPN"
  ],
  "walker": [
    "NOUN"
  ],
  "demonstrate": [
    "VERB"
  ],
  "atmosphere": [
    "NOUN"
  ],
  "beast": [
    "NOUN"
  ],
  "experiment": [
    "NOUN",
    "PROPN"
  ],
  "overseas": [
    "ADV"
  ],
  "dodge": [
    "VERB"
  ],
  "counsel": [
    "PROPN",
    "NOUN"
  ],
  "federation": [
    "NOUN",
    "PROPN"
  ],
  "pizza": [
    "NOUN"
  ],
  "assignment": [
    "NOUN",
    "PROPN"
  ],
  "gordon": [
    "PROPN"
  ],
  "absence": [
    "NOUN"
  ],
  "nearest": [
    "ADJ"
  ],
  "cluster": [
    "NOUN",
    "PROPN"
  ],
  "whereas": [
    "SCONJ"
  ],
  "surprise": [
    "NOUN"
  ],
  "partial": [
    "ADJ",
    "PROPN"
  ],
  "everybody": [
    "PRON"
  ],
  "sublime": [
    "ADV"
  ],
  "palace": [
    "NOUN"
  ],
  "acceptable": [
    "ADJ",
    "PROPN"
  ],
  "satisfied": [
    "ADJ"
  ],
  "verify": [
    "VERB",
    "PROPN"
  ],
  "globe": [
    "NOUN"
  ],
  "copper": [
    "NOUN"
  ],
  "medication": [
    "NOUN"
  ],
  "warehouse": [
    "NOUN"
  ],
  "kerry": [
    "VERB"
  ],
  "receipt": [
    "NOUN"
  ],
  "supposed": [
    "VERB"
  ],
  "ordinary": [
    "ADJ"
  ],
  "nobody": [
    "PRON"
  ],
  "ghost": [
    "NOUN"
  ],
  "violation": [
    "NOUN",
    "PROPN"
  ],
  "configure": [
    "VERB",
    "PROPN"
  ],
  "stability": [
    "NOUN",
    "PROPN"
  ],
  "southwest": [
    "NOUN"
  ],
  "pride": [
    "NOUN"
  ],
  "institutional": [
    "ADJ"
  ],
  "independence": [
    "NOUN"
  ],
  "knowing": [
    "VERB"
  ],
  "reporter": [
    "NOUN",
    "PROPN"
  ],
  "metabolism": [
    "NOUN"
  ],
  "keith": [
    "PROPN"
  ],
  "champion": [
    "PROPN",
    "NOUN"
  ],
  "cloudy": [
    "ADJ"
  ],
  "linda": [
    "PROPN"
  ],
  "personally": [
    "ADV"
  ],
  "chile": [
    "ADV"
  ],
  "plenty": [
    "NOUN"
  ],
  "sentence": [
    "NOUN"
  ],
  "throat": [
    "NOUN"
  ],
  "ignore": [
    "VERB",
    "PROPN"
  ],
  "maria": [
    "PROPN"
  ],
  "uniform": [
    "NOUN"
  ],
  "excellence": [
    "PROPN",
    "NOUN"
  ],
  "wealth": [
    "NOUN"
  ],
  "somewhere": [
    "ADV"
  ],
  "vacuum": [
    "NOUN"
  ],
  "dancing": [
    "VERB"
  ],
  "recognize": [
    "VERB"
  ],
  "brass": [
    "NOUN"
  ],
  "plaza": [
    "PROPN"
  ],
  "survival": [
    "NOUN"
  ],
  "quest": [
    "NOUN"
  ],
  "publish": [
    "VERB",
    "PROPN"
  ],
  "screening": [
    "VERB"
  ],
  "thumbnail": [
    "NOUN"
  ],
  "jonathan": [
    "PROPN"
  ],
  "whenever": [
    "SCONJ"
  ],
  "lifetime": [
    "NOUN"
  ],
  "pioneer": [
    "PROPN"
  ],
  "booty": [
    "PROPN"
  ],
  "forgotten": [
    "VERB"
  ],
  "acrobat": [
    "NOUN"
  ],
  "venue": [
    "NOUN",
    "PROPN"
  ],
  "athletic": [
    "ADJ"
  ],
  "thermal": [
    "ADJ"
  ],
  "behaviour": [
    "NOUN",
    "PROPN"
  ],
  "vital": [
    "ADJ"
  ],
  "telling": [
    "VERB"
  ],
  "fairly": [
    "ADV"
  ],
  "coastal": [
    "ADJ"
  ],
  "charity": [
    "NOUN"
  ],
  "intelligent": [
    "ADJ",
    "PROPN"
  ],
  "excel": [
    "PROPN",
    "VERB"
  ],
  "obligation": [
    "NOUN"
  ],
  "harbor": [
    "NOUN"
  ],
  "traveler": [
    "NOUN"
  ],
  "segment": [
    "NOUN",
    "PROPN"
  ],
  "realize": [
    "VERB"
  ],
  "regardless": [
    "ADV"
  ],
  "enemy": [
    "NOUN"
  ],
  "puzzle": [
    "NOUN"
  ],
  "rising": [
    "VERB"
  ],
  "aluminum": [
    "NOUN"
  ],
  "insight": [
    "NOUN",
    "PROPN"
  ],
  "restricted": [
    "VERB",
    "PROPN"
  ],
  "republican": [
    "PROPN"
  ],
  "lucky": [
    "ADJ"
  ],
  "latter": [
    "ADJ"
  ],
  "thick": [
    "ADJ"
  ],
  "repeat": [
    "VERB",
    "NOUN"
  ],
  "syndrome": [
    "NOUN"
  ],
  "attendance": [
    "NOUN",
    "PROPN"
  ],
  "penalty": [
    "NOUN"
  ],
  "glasses": [
    "NOUN"
  ],
  "iraqi": [
    "PROPN"
  ],
  "builder": [
    "NOUN",
    "PROPN"
  ],
  "vista": [
    "PROPN"
  ],
  "jessica": [
    "PROPN"
  ],
  "chips": [
    "NOUN"
  ],
  "terry": [
    "VERB"
  ],
  "flood": [
    "NOUN"
  ],
  "arena": [
    "NOUN"
  ],
  "stewart": [
    "ADJ"
  ],
  "announcement": [
    "NOUN",
    "PROPN"
  ],
  "outcome": [
    "NOUN",
    "VERB"
  ],
  "appreciate": [
    "VERB"
  ],
  "expanded": [
    "VERB"
  ],
  "casual": [
    "ADJ"
  ],
  "grown": [
    "VERB"
  ],
  "polish": [
    "ADJ"
  ],
  "lovely": [
    "ADJ"
  ],
  "jerry": [
    "NOUN"
  ],
  "clause": [
    "NOUN"
  ],
  "smile": [
    "NOUN"
  ],
  "indoor": [
    "ADJ"
  ],
  "armed": [
    "VERB"
  ],
  "broker": [
    "NOUN"
  ],
  "charger": [
    "NOUN"
  ],
  "regularly": [
    "ADV"
  ],
  "cooling": [
    "VERB"
  ],
  "trucks": [
    "NOUN"
  ],
  "divorce": [
    "NOUN"
  ],
  "laura": [
    "PROPN"
  ],
  "shopper": [
    "NOUN"
  ],
  "partly": [
    "ADV"
  ],
  "tradition": [
    "NOUN"
  ],
  "candy": [
    "NOUN"
  ],
  "tiger": [
    "PROPN",
    "NOUN"
  ],
  "donald": [
    "PROPN"
  ],
  "sensor": [
    "NOUN"
  ],
  "exposed": [
    "VERB"
  ],
  "deputy": [
    "NOUN"
  ],
  "sealed": [
    "VERB"
  ],
  "loaded": [
    "VERB",
    "ADJ"
  ],
  "complaint": [
    "NOUN"
  ],
  "boost": [
    "VERB",
    "NOUN"
  ],
  "spanking": [
    "VERB"
  ],
  "scholarship": [
    "NOUN"
  ],
  "governance": [
    "NOUN",
    "PROPN"
  ],
  "chronic": [
    "PROPN"
  ],
  "moral": [
    "ADJ"
  ],
  "finger": [
    "NOUN"
  ],
  "pound": [
    "NOUN"
  ],
  "locate": [
    "VERB"
  ],
  "trained": [
    "VERB"
  ],
  "ourselves": [
    "PRON"
  ],
  "bread": [
    "NOUN"
  ],
  "tobacco": [
    "NOUN"
  ],
  "wooden": [
    "ADJ"
  ],
  "tough": [
    "ADJ"
  ],
  "incident": [
    "NOUN",
    "PROPN"
  ],
  "dynamics": [
    "NOUN"
  ],
  "conversation": [
    "NOUN",
    "PROPN"
  ],
  "decrease": [
    "NOUN",
    "VERB"
  ],
  "chest": [
    "NOUN"
  ],
  "pension": [
    "NOUN"
  ],
  "billy": [
    "PROPN"
  ],
  "worship": [
    "VERB"
  ],
  "capability": [
    "NOUN",
    "PROPN"
  ],
  "craig": [
    "PROPN"
  ],
  "herself": [
    "PRON"
  ],
  "precision": [
    "NOUN"
  ],
  "damages": [
    "NOUN"
  ],
  "solve": [
    "VERB"
  ],
  "shorts": [
    "VERB"
  ],
  "reproduction": [
    "NOUN"
  ],
  "minority": [
    "NOUN"
  ],
  "diverse": [
    "ADJ"
  ],
  "johnny": [
    "PROPN"
  ],
  "franchise": [
    "NOUN"
  ],
  "recorder": [
    "NOUN"
  ],
  "facing": [
    "VERB",
    "NOUN"
  ],
  "nancy": [
    "PROPN"
  ],
  "passion": [
    "NOUN"
  ],
  "rehabilitation": [
    "NOUN"
  ],
  "sight": [
    "NOUN"
  ],
  "defence": [
    "NOUN"
  ],
  "refund": [
    "NOUN",
    "PROPN"
  ],
  "divided": [
    "VERB"
  ],
  "reception": [
    "NOUN"
  ],
  "correctly": [
    "ADV"
  ],
  "insider": [
    "NOUN",
    "PROPN"
  ],
  "hearts": [
    "NOUN"
  ],
  "geography": [
    "NOUN"
  ],
  "integrity": [
    "NOUN",
    "PROPN"
  ],
  "worry": [
    "VERB",
    "NOUN"
  ],
  "discrimination": [
    "NOUN"
  ],
  "carter": [
    "NOUN"
  ],
  "legacy": [
    "NOUN",
    "PROPN"
  ],
  "danger": [
    "NOUN"
  ],
  "vitamin": [
    "NOUN"
  ],
  "widely": [
    "ADV"
  ],
  "phrase": [
    "NOUN"
  ],
  "genuine": [
    "ADJ"
  ],
  "raising": [
    "VERB"
  ],
  "functionality": [
    "NOUN",
    "PROPN"
  ],
  "paradise": [
    "PROPN"
  ],
  "hybrid": [
    "ADJ",
    "PROPN"
  ],
  "intermediate": [
    "ADJ",
    "PROPN"
  ],
  "emotional": [
    "ADJ"
  ],
  "glory": [
    "NOUN"
  ],
  "bigger": [
    "ADJ"
  ],
  "billing": [
    "NOUN",
    "PROPN"
  ],
  "diesel": [
    "NOUN"
  ],
  "versus": [
    "ADP"
  ],
  "combine": [
    "VERB",
    "PROPN"
  ],
  "overnight": [
    "ADV"
  ],
  "geographic": [
    "ADJ"
  ],
  "exceed": [
    "VERB"
  ],
  "fault": [
    "NOUN",
    "PROPN"
  ],
  "preliminary": [
    "ADJ"
  ],
  "introduce": [
    "VERB",
    "PROPN"
  ],
  "promotional": [
    "ADJ"
  ],
  "karen": [
    "PROPN"
  ],
  "romantic": [
    "ADJ"
  ],
  "revealed": [
    "VERB"
  ],
  "generator": [
    "NOUN"
  ],
  "albert": [
    "PROPN"
  ],
  "examine": [
    "VERB"
  ],
  "jimmy": [
    "PROPN"
  ],
  "graham": [
    "PROPN"
  ],
  "suspension": [
    "NOUN"
  ],
  "bristol": [
    "PROPN"
  ],
  "margaret": [
    "PROPN"
  ],
  "correction": [
    "NOUN"
  ],
  "slowly": [
    "ADV"
  ],
  "authentication": [
    "NOUN",
    "PROPN"
  ],
  "communicate": [
    "VERB",
    "PROPN"
  ],
  "rugby": [
    "NOUN"
  ],
  "supplement": [
    "VERB"
  ],
  "infant": [
    "NOUN"
  ],
  "samuel": [
    "PROPN"
  ],
  "fluid": [
    "ADJ"
  ],
  "grounds": [
    "NOUN"
  ],
  "machinery": [
    "NOUN"
  ],
  "unlike": [
    "ADP"
  ],
  "equation": [
    "NOUN"
  ],
  "probability": [
    "NOUN"
  ],
  "dimension": [
    "NOUN",
    "PROPN"
  ],
  "wright": [
    "PROPN"
  ],
  "barry": [
    "VERB"
  ],
  "proven": [
    "VERB"
  ],
  "warren": [
    "PROPN"
  ],
  "studied": [
    "VERB"
  ],
  "reviewer": [
    "NOUN",
    "PROPN"
  ],
  "quarterly": [
    "ADJ",
    "PROPN"
  ],
  "devil": [
    "PROPN"
  ],
  "grass": [
    "NOUN"
  ],
  "comply": [
    "VERB"
  ],
  "marie": [
    "PROPN"
  ],
  "florist": [
    "NOUN"
  ],
  "cherry": [
    "NOUN"
  ],
  "continental": [
    "PROPN"
  ],
  "alternate": [
    "ADJ",
    "PROPN"
  ],
  "achievement": [
    "NOUN"
  ],
  "funeral": [
    "NOUN"
  ],
  "charlie": [
    "PROPN"
  ],
  "passenger": [
    "NOUN"
  ],
  "convenient": [
    "ADJ"
  ],
  "dennis": [
    "PROPN"
  ],
  "francis": [
    "NOUN"
  ],
  "sized": [
    "ADJ"
  ],
  "manga": [
    "NOUN"
  ],
  "socket": [
    "NOUN"
  ],
  "silent": [
    "ADJ"
  ],
  "literary": [
    "ADJ"
  ],
  "orientation": [
    "NOUN",
    "PROPN"
  ],
  "theft": [
    "NOUN"
  ],
  "childhood": [
    "NOUN"
  ],
  "swing": [
    "NOUN"
  ],
  "choosing": [
    "VERB"
  ],
  "talent": [
    "NOUN",
    "PROPN"
  ],
  "flexibility": [
    "NOUN",
    "PROPN"
  ],
  "seeker": [
    "NOUN"
  ],
  "wisdom": [
    "NOUN"
  ],
  "shoot": [
    "VERB"
  ],
  "boundary": [
    "NOUN",
    "ADJ"
  ],
  "offset": [
    "VERB",
    "NOUN"
  ],
  "payday": [
    "NOUN"
  ],
  "philip": [
    "PROPN"
  ],
  "elite": [
    "ADJ"
  ],
  "swedish": [
    "ADJ"
  ],
  "deadline": [
    "NOUN",
    "PROPN"
  ],
  "jurisdiction": [
    "NOUN"
  ],
  "robot": [
    "NOUN"
  ],
  "witness": [
    "NOUN"
  ],
  "collins": [
    "PROPN"
  ],
  "powder": [
    "NOUN"
  ],
  "broadway": [
    "ADV"
  ],
  "acquired": [
    "VERB"
  ],
  "assess": [
    "VERB",
    "PROPN"
  ],
  "entrance": [
    "NOUN"
  ],
  "gnome": [
    "VERB"
  ],
  "declaration": [
    "NOUN"
  ],
  "losing": [
    "VERB"
  ],
  "noble": [
    "ADJ"
  ],
  "gospel": [
    "NOUN"
  ],
  "shore": [
    "NOUN"
  ],
  "induced": [
    "VERB"
  ],
  "knight": [
    "PROPN"
  ],
  "loose": [
    "ADJ"
  ],
  "recipient": [
    "NOUN"
  ],
  "linking": [
    "VERB",
    "PROPN"
  ],
  "illness": [
    "VERB"
  ],
  "islamic": [
    "PROPN"
  ],
  "athletics": [
    "NOUN"
  ],
  "southeast": [
    "ADV"
  ],
  "pending": [
    "VERB",
    "NOUN"
  ],
  "parker": [
    "NOUN"
  ],
  "teenage": [
    "NOUN"
  ],
  "triple": [
    "PROPN",
    "ADJ"
  ],
  "cooper": [
    "PROPN"
  ],
  "vincent": [
    "PROPN"
  ],
  "unusual": [
    "ADJ"
  ],
  "destruction": [
    "NOUN"
  ],
  "increasingly": [
    "ADV"
  ],
  "migration": [
    "NOUN",
    "PROPN"
  ],
  "disorder": [
    "NOUN"
  ],
  "routine": [
    "ADJ",
    "NOUN"
  ],
  "basically": [
    "ADV"
  ],
  "conventional": [
    "ADJ"
  ],
  "wearing": [
    "VERB"
  ],
  "sought": [
    "VERB"
  ],
  "mounted": [
    "VERB"
  ],
  "habitat": [
    "PROPN"
  ],
  "median": [
    "ADJ",
    "PROPN"
  ],
  "scanner": [
    "NOUN",
    "PROPN"
  ],
  "herein": [
    "NOUN"
  ],
  "occupational": [
    "NOUN"
  ],
  "animated": [
    "VERB"
  ],
  "judicial": [
    "ADJ"
  ],
  "adjustment": [
    "NOUN",
    "PROPN"
  ],
  "integer": [
    "PROPN",
    "NOUN"
  ],
  "bachelor": [
    "PROPN"
  ],
  "attitude": [
    "NOUN"
  ],
  "engaged": [
    "VERB",
    "ADJ"
  ],
  "falling": [
    "VERB"
  ],
  "carpet": [
    "NOUN"
  ],
  "binary": [
    "ADJ",
    "NOUN"
  ],
  "genetics": [
    "NOUN"
  ],
  "difficulty": [
    "NOUN",
    "PROPN"
  ],
  "collective": [
    "ADJ"
  ],
  "coalition": [
    "NOUN"
  ],
  "enrollment": [
    "NOUN",
    "PROPN"
  ],
  "walter": [
    "NOUN"
  ],
  "besides": [
    "SCONJ"
  ],
  "collector": [
    "NOUN",
    "PROPN"
  ],
  "atlas": [
    "PROPN",
    "NOUN"
  ],
  "observation": [
    "NOUN",
    "PROPN"
  ],
  "torture": [
    "NOUN"
  ],
  "mitchell": [
    "PROPN"
  ],
  "restoration": [
    "PROPN",
    "NOUN"
  ],
  "convenience": [
    "NOUN"
  ],
  "ralph": [
    "PROPN"
  ],
  "opposition": [
    "NOUN"
  ],
  "container": [
    "NOUN",
    "PROPN"
  ],
  "defendant": [
    "NOUN"
  ],
  "warner": [
    "PROPN"
  ],
  "confirmation": [
    "NOUN",
    "PROPN"
  ],
  "supervisor": [
    "NOUN"
  ],
  "wizard": [
    "NOUN",
    "PROPN"
  ],
  "corps": [
    "NOUN"
  ],
  "liver": [
    "NOUN"
  ],
  "liable": [
    "ADJ"
  ],
  "brochure": [
    "NOUN"
  ],
  "morris": [
    "PROPN"
  ],
  "petition": [
    "NOUN"
  ],
  "recall": [
    "VERB",
    "PROPN"
  ],
  "antenna": [
    "NOUN"
  ],
  "picked": [
    "VERB"
  ],
  "assumed": [
    "VERB"
  ],
  "departure": [
    "NOUN"
  ],
  "belief": [
    "NOUN"
  ],
  "killing": [
    "VERB"
  ],
  "bikini": [
    "NOUN"
  ],
  "shoulder": [
    "NOUN"
  ],
  "harvard": [
    "PROPN"
  ],
  "diameter": [
    "VERB"
  ],
  "ottawa": [
    "PROPN"
  ],
  "refine": [
    "VERB",
    "PROPN"
  ],
  "bidder": [
    "PROPN"
  ],
  "singer": [
    "NOUN"
  ],
  "herald": [
    "PROPN"
  ],
  "literacy": [
    "NOUN"
  ],
  "aging": [
    "VERB"
  ],
  "intervention": [
    "NOUN"
  ],
  "attraction": [
    "NOUN"
  ],
  "diving": [
    "NOUN",
    "VERB"
  ],
  "invite": [
    "VERB",
    "NOUN"
  ],
  "modification": [
    "NOUN",
    "PROPN"
  ],
  "alice": [
    "PROPN"
  ],
  "suppose": [
    "VERB"
  ],
  "involve": [
    "VERB"
  ],
  "moderate": [
    "ADJ",
    "PROPN"
  ],
  "terror": [
    "NOUN"
  ],
  "younger": [
    "ADJ"
  ],
  "thirty": [
    "NUM"
  ],
  "opposite": [
    "ADJ",
    "NOUN"
  ],
  "understood": [
    "VERB"
  ],
  "rapidly": [
    "ADV"
  ],
  "mercedes": [
    "PROPN"
  ],
  "assurance": [
    "PROPN",
    "NOUN"
  ],
  "clerk": [
    "NOUN"
  ],
  "happening": [
    "VERB"
  ],
  "outline": [
    "NOUN",
    "PROPN"
  ],
  "holland": [
    "PROPN"
  ],
  "jeans": [
    "NOUN"
  ],
  "metropolitan": [
    "PROPN"
  ],
  "compilation": [
    "NOUN"
  ],
  "verification": [
    "NOUN",
    "PROPN"
  ],
  "favor": [
    "NOUN"
  ],
  "sigma": [
    "VERB"
  ],
  "attractive": [
    "ADJ"
  ],
  "occasion": [
    "NOUN"
  ],
  "victim": [
    "NOUN"
  ],
  "sleeping": [
    "VERB"
  ],
  "careful": [
    "ADJ"
  ],
  "gardening": [
    "VERB"
  ],
  "arrive": [
    "VERB"
  ],
  "orchestra": [
    "PROPN"
  ],
  "sunset": [
    "NOUN"
  ],
  "tracked": [
    "VERB"
  ],
  "moreover": [
    "ADV"
  ],
  "minimal": [
    "ADJ",
    "PROPN"
  ],
  "polyphonic": [
    "ADJ"
  ],
  "lottery": [
    "NOUN"
  ],
  "framed": [
    "VERB"
  ],
  "aside": [
    "ADV"
  ],
  "adjustable": [
    "ADJ"
  ],
  "allocation": [
    "NOUN",
    "PROPN"
  ],
  "michelle": [
    "PROPN"
  ],
  "essay": [
    "VERB"
  ],
  "discipline": [
    "NOUN"
  ],
  "dialogue": [
    "NOUN",
    "PROPN"
  ],
  "alphabetical": [
    "ADJ"
  ],
  "declared": [
    "VERB"
  ],
  "aaron": [
    "PROPN"
  ],
  "trace": [
    "NOUN",
    "PROPN"
  ],
  "disposal": [
    "NOUN"
  ],
  "voluntary": [
    "ADJ"
  ],
  "consult": [
    "VERB",
    "PROPN"
  ],
  "greatly": [
    "ADV"
  ],
  "cycling": [
    "VERB"
  ],
  "midnight": [
    "NOUN"
  ],
  "commonly": [
    "ADV"
  ],
  "photographer": [
    "NOUN"
  ],
  "inform": [
    "VERB",
    "PROPN"
  ],
  "turkish": [
    "PROPN"
  ],
  "quantum": [
    "NOUN"
  ],
  "murray": [
    "PROPN"
  ],
  "intent": [
    "NOUN",
    "ADJ"
  ],
  "largely": [
    "ADV"
  ],
  "pleasant": [
    "NOUN"
  ],
  "announce": [
    "VERB",
    "PROPN"
  ],
  "spoke": [
    "VERB"
  ],
  "arrow": [
    "NOUN"
  ],
  "engagement": [
    "NOUN",
    "PROPN"
  ],
  "sampling": [
    "VERB",
    "NOUN"
  ],
  "rough": [
    "ADJ",
    "PROPN"
  ],
  "weird": [
    "ADJ"
  ],
  "refinance": [
    "NOUN"
  ],
  "inspired": [
    "VERB"
  ],
  "blade": [
    "VERB"
  ],
  "suddenly": [
    "ADV"
  ],
  "oxygen": [
    "NOUN"
  ],
  "canyon": [
    "NOUN"
  ],
  "merely": [
    "ADV"
  ],
  "arrangement": [
    "NOUN"
  ],
  "bibliography": [
    "NOUN"
  ],
  "pointer": [
    "NOUN"
  ],
  "compatibility": [
    "NOUN",
    "PROPN"
  ],
  "stretch": [
    "NOUN",
    "PROPN"
  ],
  "durham": [
    "PROPN"
  ],
  "furthermore": [
    "ADV"
  ],
  "sleeve": [
    "VERB"
  ],
  "cleaner": [
    "ADJ"
  ],
  "cricket": [
    "NOUN"
  ],
  "feeding": [
    "VERB"
  ],
  "township": [
    "NOUN"
  ],
  "measuring": [
    "VERB"
  ],
  "robin": [
    "PROPN"
  ],
  "strap": [
    "NOUN"
  ],
  "headquarters": [
    "NOUN"
  ],
  "sharon": [
    "PROPN"
  ],
  "crowd": [
    "PROPN",
    "NOUN"
  ],
  "olympic": [
    "PROPN"
  ],
  "transformation": [
    "NOUN",
    "PROPN"
  ],
  "customs": [
    "NOUN"
  ],
  "personality": [
    "NOUN",
    "PROPN"
  ],
  "rainbow": [
    "VERB"
  ],
  "roulette": [
    "NOUN"
  ],
  "decline": [
    "NOUN",
    "VERB"
  ],
  "israeli": [
    "ADJ"
  ],
  "skiing": [
    "VERB"
  ],
  "cloud": [
    "PROPN",
    "NOUN"
  ],
  "facilitate": [
    "VERB",
    "PROPN"
  ],
  "subscriber": [
    "NOUN"
  ],
  "valve": [
    "VERB"
  ],
  "proceed": [
    "VERB",
    "NOUN"
  ],
  "knife": [
    "NOUN"
  ],
  "jamaica": [
    "PROPN"
  ],
  "shelf": [
    "NOUN"
  ],
  "bookstore": [
    "VERB"
  ],
  "timing": [
    "NOUN",
    "VERB"
  ],
  "adopt": [
    "VERB",
    "PROPN"
  ],
  "incredible": [
    "ADJ"
  ],
  "donation": [
    "NOUN"
  ],
  "outer": [
    "ADJ"
  ],
  "commonwealth": [
    "NOUN"
  ],
  "pharmaceutical": [
    "PROPN"
  ],
  "manhattan": [
    "PROPN"
  ],
  "tales": [
    "NOUN"
  ],
  "islam": [
    "PROPN"
  ],
  "targeted": [
    "VERB",
    "ADJ"
  ],
  "organizational": [
    "ADJ",
    "PROPN"
  ],
  "twelve": [
    "NUM"
  ],
  "founder": [
    "PROPN",
    "NOUN"
  ],
  "decade": [
    "NOUN"
  ],
  "dispute": [
    "VERB"
  ],
  "portuguese": [
    "PROPN"
  ],
  "tired": [
    "ADJ"
  ],
  "adverse": [
    "ADJ"
  ],
  "everywhere": [
    "ADV"
  ],
  "excerpt": [
    "PROPN",
    "NOUN"
  ],
  "steam": [
    "VERB"
  ],
  "discharge": [
    "VERB"
  ],
  "acute": [
    "VERB"
  ],
  "halloween": [
    "PROPN"
  ],
  "climbing": [
    "VERB"
  ],
  "stood": [
    "VERB"
  ],
  "perfume": [
    "NOUN"
  ],
  "carol": [
    "NOUN"
  ],
  "honest": [
    "ADJ"
  ],
  "albany": [
    "PROPN"
  ],
  "hazardous": [
    "ADJ"
  ],
  "restore": [
    "VERB",
    "NOUN"
  ],
  "stack": [
    "NOUN",
    "PROPN"
  ],
  "methodology": [
    "NOUN",
    "PROPN"
  ],
  "somebody": [
    "PRON"
  ],
  "housewares": [
    "NOUN"
  ],
  "reputation": [
    "NOUN"
  ],
  "resistant": [
    "ADJ"
  ],
  "curve": [
    "NOUN"
  ],
  "creator": [
    "NOUN",
    "PROPN"
  ],
  "amber": [
    "NOUN"
  ],
  "tracker": [
    "NOUN",
    "PROPN"
  ],
  "variation": [
    "NOUN",
    "PROPN"
  ],
  "passage": [
    "NOUN"
  ],
  "transferred": [
    "VERB"
  ],
  "trunk": [
    "NOUN"
  ],
  "pierre": [
    "NOUN"
  ],
  "headset": [
    "NOUN"
  ],
  "photograph": [
    "VERB"
  ],
  "camel": [
    "NOUN"
  ],
  "distributor": [
    "NOUN"
  ],
  "underlying": [
    "VERB",
    "ADJ"
  ],
  "wrestling": [
    "VERB"
  ],
  "suicide": [
    "NOUN"
  ],
  "gathering": [
    "VERB",
    "NOUN"
  ],
  "projection": [
    "NOUN"
  ],
  "juice": [
    "NOUN"
  ],
  "chase": [
    "PROPN",
    "VERB"
  ],
  "mathematical": [
    "PROPN"
  ],
  "logical": [
    "PROPN",
    "ADJ"
  ],
  "sauce": [
    "VERB"
  ],
  "extract": [
    "VERB",
    "NOUN"
  ],
  "specialized": [
    "PROPN",
    "ADJ"
  ],
  "diagnostic": [
    "ADJ"
  ],
  "panama": [
    "PROPN"
  ],
  "payable": [
    "ADJ",
    "PROPN"
  ],
  "courtesy": [
    "NOUN"
  ],
  "criticism": [
    "NOUN"
  ],
  "automobile": [
    "NOUN"
  ],
  "confidential": [
    "ADJ",
    "PROPN"
  ],
  "statutory": [
    "ADJ"
  ],
  "athens": [
    "NOUN"
  ],
  "northeast": [
    "ADJ"
  ],
  "retired": [
    "VERB"
  ],
  "bracelet": [
    "NOUN"
  ],
  "juvenile": [
    "ADJ"
  ],
  "injection": [
    "NOUN",
    "PROPN"
  ],
  "yorkshire": [
    "VERB"
  ],
  "protective": [
    "ADJ"
  ],
  "afraid": [
    "ADJ"
  ],
  "acoustic": [
    "ADJ"
  ],
  "railway": [
    "NOUN"
  ],
  "initially": [
    "ADV"
  ],
  "indicator": [
    "NOUN",
    "PROPN"
  ],
  "pointed": [
    "VERB"
  ],
  "causing": [
    "VERB"
  ],
  "mistake": [
    "NOUN"
  ],
  "locked": [
    "VERB",
    "ADJ"
  ],
  "eliminate": [
    "VERB"
  ],
  "fusion": [
    "PROPN",
    "NOUN"
  ],
  "mineral": [
    "NOUN"
  ],
  "steering": [
    "VERB"
  ],
  "fortune": [
    "PROPN"
  ],
  "preference": [
    "NOUN",
    "PROPN"
  ],
  "canvas": [
    "NOUN",
    "PROPN"
  ],
  "threshold": [
    "NOUN",
    "PROPN"
  ],
  "parish": [
    "VERB"
  ],
  "cemetery": [
    "NOUN"
  ],
  "planner": [
    "PROPN",
    "NOUN"
  ],
  "stadium": [
    "VERB"
  ],
  "exploration": [
    "NOUN",
    "PROPN"
  ],
  "coupon": [
    "NOUN"
  ],
  "proxy": [
    "NOUN",
    "PROPN"
  ],
  "astronomy": [
    "NOUN"
  ],
  "translate": [
    "VERB"
  ],
  "costume": [
    "NOUN"
  ],
  "tagged": [
    "VERB"
  ],
  "killer": [
    "NOUN"
  ],
  "bishop": [
    "PROPN"
  ],
  "shaped": [
    "VERB"
  ],
  "compression": [
    "NOUN"
  ],
  "seasonal": [
    "ADJ"
  ],
  "farmer": [
    "NOUN"
  ],
  "constitutional": [
    "ADJ"
  ],
  "perfectly": [
    "ADV"
  ],
  "instantly": [
    "ADV"
  ],
  "norfolk": [
    "PROPN"
  ],
  "coaching": [
    "VERB",
    "NOUN"
  ],
  "litigation": [
    "NOUN"
  ],
  "painted": [
    "VERB"
  ],
  "horizontal": [
    "ADJ",
    "PROPN"
  ],
  "cosmetic": [
    "ADJ"
  ],
  "portrait": [
    "NOUN"
  ],
  "terrorist": [
    "NOUN"
  ],
  "informational": [
    "ADJ",
    "PROPN"
  ],
  "ethical": [
    "ADJ"
  ],
  "mobility": [
    "NOUN",
    "PROPN"
  ],
  "floral": [
    "ADJ"
  ],
  "struggle": [
    "VERB",
    "NOUN"
  ],
  "suffering": [
    "VERB"
  ],
  "neutral": [
    "ADJ"
  ],
  "fisher": [
    "NOUN"
  ],
  "prospective": [
    "ADJ"
  ],
  "bedding": [
    "VERB"
  ],
  "ultimately": [
    "ADV"
  ],
  "joining": [
    "VERB"
  ],
  "heading": [
    "VERB",
    "NOUN"
  ],
  "equally": [
    "ADV"
  ],
  "artificial": [
    "ADJ",
    "PROPN"
  ],
  "bearing": [
    "VERB"
  ],
  "spectacular": [
    "ADJ"
  ],
  "connector": [
    "NOUN",
    "PROPN"
  ],
  "guilty": [
    "ADJ"
  ],
  "activation": [
    "NOUN",
    "PROPN"
  ],
  "naturally": [
    "ADV"
  ],
  "haven": [
    "VERB"
  ],
  "tablet": [
    "NOUN"
  ],
  "charm": [
    "NOUN"
  ],
  "violent": [
    "ADJ"
  ],
  "underwear": [
    "NOUN"
  ],
  "basin": [
    "NOUN"
  ],
  "potentially": [
    "ADV"
  ],
  "ranch": [
    "NOUN"
  ],
  "crossing": [
    "VERB"
  ],
  "inclusive": [
    "ADJ",
    "PROPN"
  ],
  "dimensional": [
    "ADJ"
  ],
  "cottage": [
    "NOUN"
  ],
  "considerable": [
    "ADJ"
  ],
  "resolved": [
    "VERB",
    "PROPN"
  ],
  "toner": [
    "NOUN"
  ],
  "latex": [
    "PROPN"
  ],
  "delhi": [
    "PROPN"
  ],
  "alien": [
    "VERB"
  ],
  "locator": [
    "NOUN"
  ],
  "broke": [
    "VERB"
  ],
  "nepal": [
    "PROPN"
  ],
  "zimbabwe": [
    "PROPN"
  ],
  "complexity": [
    "NOUN",
    "PROPN"
  ],
  "constantly": [
    "ADV"
  ],
  "browsing": [
    "VERB"
  ],
  "resolve": [
    "VERB",
    "PROPN"
  ],
  "barcelona": [
    "PROPN"
  ],
  "presidential": [
    "ADJ"
  ],
  "documentary": [
    "NOUN"
  ],
  "melissa": [
    "PROPN"
  ],
  "moscow": [
    "PROPN"
  ],
  "thesis": [
    "NOUN"
  ],
  "nylon": [
    "NOUN"
  ],
  "palestinian": [
    "PROPN"
  ],
  "rocky": [
    "ADJ"
  ],
  "frequent": [
    "ADJ"
  ],
  "ceiling": [
    "NOUN"
  ],
  "hispanic": [
    "ADJ"
  ],
  "legislature": [
    "NOUN"
  ],
  "hospitality": [
    "NOUN"
  ],
  "anybody": [
    "PRON"
  ],
  "procurement": [
    "NOUN",
    "PROPN"
  ],
  "fleet": [
    "NOUN",
    "PROPN"
  ],
  "untitled": [
    "ADJ"
  ],
  "bunch": [
    "NOUN"
  ],
  "singing": [
    "VERB"
  ],
  "theoretical": [
    "ADJ"
  ],
  "afford": [
    "VERB"
  ],
  "starring": [
    "VERB"
  ],
  "referral": [
    "PROPN",
    "ADJ"
  ],
  "surveillance": [
    "NOUN"
  ],
  "optimal": [
    "ADJ",
    "PROPN"
  ],
  "distinct": [
    "ADJ",
    "PROPN"
  ],
  "highlight": [
    "VERB",
    "PROPN"
  ],
  "substitute": [
    "VERB"
  ],
  "inclusion": [
    "NOUN",
    "PROPN"
  ],
  "hopefully": [
    "ADV"
  ],
  "brilliant": [
    "ADJ"
  ],
  "turner": [
    "PROPN"
  ],
  "spoken": [
    "VERB"
  ],
  "omega": [
    "NOUN"
  ],
  "stayed": [
    "VERB"
  ],
  "civic": [
    "ADJ"
  ],
  "termination": [
    "NOUN"
  ],
  "watched": [
    "VERB"
  ],
  "saver": [
    "NOUN"
  ],
  "thereof": [
    "ADV"
  ],
  "grill": [
    "NOUN"
  ],
  "redeem": [
    "VERB"
  ],
  "grain": [
    "NOUN"
  ],
  "authentic": [
    "ADJ"
  ],
  "regime": [
    "NOUN"
  ],
  "architectural": [
    "ADJ",
    "PROPN"
  ],
  "depend": [
    "VERB"
  ],
  "differ": [
    "VERB"
  ],
  "ranging": [
    "VERB"
  ],
  "monica": [
    "PROPN"
  ],
  "breath": [
    "NOUN"
  ],
  "virtually": [
    "ADV"
  ],
  "candle": [
    "NOUN"
  ],
  "hanging": [
    "VERB"
  ],
  "colored": [
    "VERB"
  ],
  "authorization": [
    "NOUN",
    "PROPN"
  ],
  "formerly": [
    "ADV"
  ],
  "projector": [
    "NOUN"
  ],
  "situated": [
    "VERB"
  ],
  "comparative": [
    "NOUN"
  ],
  "herbal": [
    "ADJ"
  ],
  "loving": [
    "VERB"
  ],
  "strictly": [
    "ADV"
  ],
  "routing": [
    "VERB",
    "NOUN"
  ],
  "stanley": [
    "PROPN"
  ],
  "psychological": [
    "ADJ"
  ],
  "retailer": [
    "NOUN"
  ],
  "elegant": [
    "ADJ"
  ],
  "gains": [
    "NOUN",
    "VERB"
  ],
  "renewal": [
    "NOUN",
    "PROPN"
  ],
  "genealogy": [
    "NOUN"
  ],
  "opposed": [
    "VERB"
  ],
  "scoring": [
    "NOUN",
    "PROPN"
  ],
  "expenditure": [
    "NOUN"
  ],
  "connectivity": [
    "NOUN",
    "PROPN"
  ],
  "hacker": [
    "NOUN"
  ],
  "madrid": [
    "PROPN"
  ],
  "similarly": [
    "ADV"
  ],
  "margin": [
    "NOUN",
    "PROPN"
  ],
  "solely": [
    "ADV"
  ],
  "salon": [
    "NOUN"
  ],
  "collaborative": [
    "ADJ",
    "PROPN"
  ],
  "norman": [
    "PROPN"
  ],
  "excluding": [
    "VERB"
  ],
  "turbo": [
    "NOUN"
  ],
  "headed": [
    "VERB"
  ],
  "madonna": [
    "PROPN"
  ],
  "commander": [
    "NOUN"
  ],
  "murphy": [
    "PROPN"
  ],
  "thats": [
    "DET"
  ],
  "suggestion": [
    "NOUN",
    "PROPN"
  ],
  "soldier": [
    "NOUN"
  ],
  "justin": [
    "PROPN"
  ],
  "interval": [
    "NOUN"
  ],
  "spotlight": [
    "NOUN",
    "PROPN"
  ],
  "reset": [
    "VERB",
    "PROPN"
  ],
  "brush": [
    "NOUN"
  ],
  "investigate": [
    "VERB",
    "PROPN"
  ],
  "repeated": [
    "VERB"
  ],
  "assault": [
    "NOUN"
  ],
  "spare": [
    "VERB",
    "ADJ"
  ],
  "logistics": [
    "NOUN",
    "PROPN"
  ],
  "kodak": [
    "PROPN"
  ],
  "tongue": [
    "NOUN"
  ],
  "bowling": [
    "NOUN"
  ],
  "danish": [
    "PROPN"
  ],
  "monkey": [
    "NOUN"
  ],
  "proportion": [
    "NOUN"
  ],
  "skirt": [
    "VERB"
  ],
  "florence": [
    "NOUN"
  ],
  "invest": [
    "VERB",
    "PROPN"
  ],
  "honey": [
    "NOUN"
  ],
  "analyses": [
    "NOUN",
    "VERB"
  ],
  "significance": [
    "NOUN"
  ],
  "scenario": [
    "NOUN",
    "PROPN"
  ],
  "atomic": [
    "ADJ"
  ],
  "symposium": [
    "NOUN"
  ],
  "arabic": [
    "ADJ"
  ],
  "gauge": [
    "VERB"
  ],
  "junction": [
    "NOUN"
  ],
  "protecting": [
    "VERB"
  ],
  "faced": [
    "VERB"
  ],
  "rachel": [
    "PROPN"
  ],
  "intensive": [
    "ADJ"
  ],
  "sixth": [
    "ADJ"
  ],
  "engage": [
    "VERB",
    "PROPN"
  ],
  "deviant": [
    "PROPN"
  ],
  "switching": [
    "VERB",
    "NOUN"
  ],
  "correspondence": [
    "NOUN"
  ],
  "supervision": [
    "NOUN"
  ],
  "cheat": [
    "NOUN"
  ],
  "bronze": [
    "PROPN",
    "NOUN"
  ],
  "sandy": [
    "ADJ"
  ],
  "separation": [
    "NOUN"
  ],
  "testimony": [
    "NOUN"
  ],
  "suspect": [
    "VERB"
  ],
  "macro": [
    "NOUN",
    "PROPN"
  ],
  "sender": [
    "PROPN",
    "NOUN"
  ],
  "mandatory": [
    "ADJ",
    "PROPN"
  ],
  "crucial": [
    "ADJ"
  ],
  "syndication": [
    "NOUN"
  ],
  "celebration": [
    "NOUN"
  ],
  "adjacent": [
    "ADJ"
  ],
  "filtering": [
    "NOUN",
    "PROPN"
  ],
  "tuition": [
    "NOUN"
  ],
  "spouse": [
    "NOUN"
  ],
  "exotic": [
    "ADJ"
  ],
  "viewer": [
    "NOUN",
    "PROPN"
  ],
  "reaching": [
    "VERB"
  ],
  "receptor": [
    "NOUN"
  ],
  "laugh": [
    "VERB"
  ],
  "surgical": [
    "ADJ"
  ],
  "destroy": [
    "NOUN",
    "VERB"
  ],
  "citation": [
    "NOUN"
  ],
  "pitch": [
    "NOUN",
    "PROPN"
  ],
  "perry": [
    "NOUN"
  ],
  "proved": [
    "VERB"
  ],
  "offensive": [
    "ADJ"
  ],
  "imperial": [
    "ADJ"
  ],
  "dozen": [
    "NOUN"
  ],
  "benjamin": [
    "PROPN"
  ],
  "deployment": [
    "NOUN",
    "PROPN"
  ],
  "teeth": [
    "NOUN"
  ],
  "cloth": [
    "NOUN"
  ],
  "stamp": [
    "NOUN"
  ],
  "lotus": [
    "PROPN"
  ],
  "salmon": [
    "NOUN"
  ],
  "olympus": [
    "PROPN"
  ],
  "cargo": [
    "NOUN"
  ],
  "directive": [
    "NOUN"
  ],
  "starter": [
    "NOUN",
    "PROPN"
  ],
  "butter": [
    "NOUN"
  ],
  "pepper": [
    "NOUN"
  ],
  "weapon": [
    "NOUN"
  ],
  "luggage": [
    "NOUN"
  ],
  "burden": [
    "NOUN"
  ],
  "stylish": [
    "PROPN"
  ],
  "maple": [
    "NOUN"
  ],
  "grocery": [
    "NOUN"
  ],
  "offshore": [
    "ADV"
  ],
  "governing": [
    "VERB"
  ],
  "depot": [
    "PROPN",
    "NOUN"
  ],
  "kenneth": [
    "PROPN"
  ],
  "blend": [
    "NOUN"
  ],
  "julie": [
    "PROPN"
  ],
  "occasionally": [
    "ADV"
  ],
  "emission": [
    "NOUN"
  ],
  "realty": [
    "PROPN"
  ],
  "janet": [
    "NOUN"
  ],
  "recruiting": [
    "NOUN",
    "PROPN"
  ],
  "apparent": [
    "ADJ"
  ],
  "instructional": [
    "ADJ"
  ],
  "autumn": [
    "NOUN"
  ],
  "traveling": [
    "VERB"
  ],
  "probe": [
    "VERB"
  ],
  "toilet": [
    "NOUN"
  ],
  "ranked": [
    "VERB",
    "ADJ"
  ],
  "excited": [
    "ADJ",
    "VERB"
  ],
  "outreach": [
    "PROPN",
    "NOUN"
  ],
  "helen": [
    "VERB"
  ],
  "mounting": [
    "VERB"
  ],
  "recover": [
    "VERB",
    "PROPN"
  ],
  "balanced": [
    "ADJ",
    "VERB"
  ],
  "catherine": [
    "PROPN"
  ],
  "timely": [
    "ADJ"
  ],
  "chuck": [
    "VERB"
  ],
  "explicit": [
    "ADJ"
  ],
  "calculation": [
    "NOUN",
    "PROPN"
  ],
  "consolidated": [
    "ADJ",
    "VERB"
  ],
  "exclude": [
    "VERB"
  ],
  "newton": [
    "PROPN"
  ],
  "exceptional": [
    "ADJ"
  ],
  "anxiety": [
    "NOUN"
  ],
  "bingo": [
    "X"
  ],
  "whilst": [
    "SCONJ"
  ],
  "spatial": [
    "NOUN"
  ],
  "ceramic": [
    "ADJ"
  ],
  "prompt": [
    "NOUN",
    "ADJ"
  ],
  "precious": [
    "ADJ"
  ],
  "annually": [
    "ADV"
  ],
  "sunny": [
    "ADJ"
  ],
  "necklace": [
    "NOUN"
  ],
  "composite": [
    "ADJ"
  ],
  "unavailable": [
    "ADJ",
    "PROPN"
  ],
  "cedar": [
    "NOUN"
  ],
  "advocacy": [
    "PROPN",
    "NOUN"
  ],
  "essentially": [
    "ADV"
  ],
  "designing": [
    "VERB",
    "PROPN"
  ],
  "threaded": [
    "VERB"
  ],
  "qualify": [
    "VERB",
    "PROPN"
  ],
  "blair": [
    "PROPN"
  ],
  "mason": [
    "PROPN"
  ],
  "diagram": [
    "NOUN",
    "PROPN"
  ],
  "footwear": [
    "NOUN"
  ],
  "victor": [
    "NOUN"
  ],
  "mario": [
    "PROPN"
  ],
  "attach": [
    "VERB",
    "PROPN"
  ],
  "removing": [
    "VERB"
  ],
  "advised": [
    "VERB"
  ],
  "brunswick": [
    "NOUN"
  ],
  "spider": [
    "VERB"
  ],
  "sensitivity": [
    "NOUN"
  ],
  "preservation": [
    "NOUN"
  ],
  "isolated": [
    "ADJ",
    "VERB"
  ],
  "interim": [
    "ADJ",
    "NOUN"
  ],
  "divine": [
    "VERB"
  ],
  "streaming": [
    "NOUN",
    "VERB"
  ],
  "approve": [
    "VERB",
    "PROPN"
  ],
  "chose": [
    "VERB"
  ],
  "compound": [
    "NOUN"
  ],
  "intensity": [
    "NOUN"
  ],
  "technological": [
    "ADJ"
  ],
  "syndicate": [
    "NOUN"
  ],
  "abortion": [
    "NOUN"
  ],
  "blast": [
    "NOUN"
  ],
  "wellness": [
    "PROPN",
    "NOUN"
  ],
  "calcium": [
    "NOUN"
  ],
  "newport": [
    "PROPN"
  ],
  "antivirus": [
    "VERB"
  ],
  "shield": [
    "PROPN",
    "NOUN"
  ],
  "harvest": [
    "NOUN"
  ],
  "membrane": [
    "NOUN"
  ],
  "constitute": [
    "VERB"
  ],
  "locally": [
    "ADV"
  ],
  "pickup": [
    "VERB"
  ],
  "desperate": [
    "ADJ"
  ],
  "iceland": [
    "NOUN"
  ],
  "demonstration": [
    "NOUN"
  ],
  "governmental": [
    "ADJ"
  ],
  "graduation": [
    "NOUN"
  ],
  "sailing": [
    "VERB"
  ],
  "sacred": [
    "ADJ"
  ],
  "addiction": [
    "NOUN"
  ],
  "morocco": [
    "PROPN"
  ],
  "chrome": [
    "PROPN",
    "NOUN"
  ],
  "tommy": [
    "PROPN"
  ],
  "brake": [
    "NOUN"
  ],
  "exterior": [
    "NOUN"
  ],
  "greeting": [
    "VERB"
  ],
  "ecology": [
    "NOUN"
  ],
  "oliver": [
    "PROPN"
  ],
  "congo": [
    "PROPN"
  ],
  "synthesis": [
    "NOUN"
  ],
  "olive": [
    "NOUN"
  ],
  "undefined": [
    "ADJ",
    "VERB"
  ],
  "unemployment": [
    "NOUN"
  ],
  "scored": [
    "VERB"
  ],
  "enhancement": [
    "NOUN",
    "PROPN"
  ],
  "newcastle": [
    "NOUN"
  ],
  "clone": [
    "VERB",
    "PROPN"
  ],
  "velocity": [
    "NOUN",
    "PROPN"
  ],
  "lambda": [
    "NOUN",
    "PROPN"
  ],
  "relay": [
    "NOUN",
    "PROPN"
  ],
  "composed": [
    "VERB"
  ],
  "oasis": [
    "PROPN",
    "NOUN"
  ],
  "angry": [
    "ADJ"
  ],
  "silicon": [
    "NOUN"
  ],
  "brazilian": [
    "PROPN"
  ],
  "identical": [
    "ADJ"
  ],
  "petroleum": [
    "NOUN"
  ],
  "compete": [
    "VERB"
  ],
  "norwegian": [
    "PROPN"
  ],
  "lover": [
    "PROPN"
  ],
  "belong": [
    "VERB"
  ],
  "escort": [
    "VERB"
  ],
  "retention": [
    "NOUN",
    "PROPN"
  ],
  "wondering": [
    "VERB"
  ],
  "daddy": [
    "NOUN"
  ],
  "ferry": [
    "VERB"
  ],
  "rabbit": [
    "NOUN"
  ],
  "profession": [
    "NOUN"
  ],
  "seating": [
    "VERB"
  ],
  "separately": [
    "ADV"
  ],
  "physiology": [
    "NOUN"
  ],
  "omaha": [
    "NOUN"
  ],
  "participant": [
    "NOUN",
    "PROPN"
  ],
  "recreational": [
    "ADJ"
  ],
  "dominican": [
    "PROPN"
  ],
  "electron": [
    "NOUN"
  ],
  "friendship": [
    "NOUN"
  ],
  "heather": [
    "PROPN"
  ],
  "passport": [
    "VERB"
  ],
  "motel": [
    "NOUN"
  ],
  "treasury": [
    "PROPN"
  ],
  "warrant": [
    "VERB"
  ],
  "frozen": [
    "ADJ"
  ],
  "royalty": [
    "NOUN"
  ],
  "scales": [
    "VERB",
    "NOUN"
  ],
  "rally": [
    "PROPN"
  ],
  "observer": [
    "PROPN"
  ],
  "sunshine": [
    "VERB"
  ],
  "strain": [
    "NOUN"
  ],
  "ceremony": [
    "NOUN"
  ],
  "somehow": [
    "ADV"
  ],
  "expanding": [
    "VERB"
  ],
  "provincial": [
    "ADJ"
  ],
  "hebrew": [
    "VERB"
  ],
  "dying": [
    "VERB"
  ],
  "laundry": [
    "PROPN"
  ],
  "stuck": [
    "VERB",
    "ADJ"
  ],
  "solomon": [
    "PROPN"
  ],
  "homework": [
    "NOUN"
  ],
  "adjust": [
    "VERB"
  ],
  "assessed": [
    "VERB"
  ],
  "advertiser": [
    "NOUN"
  ],
  "encryption": [
    "NOUN",
    "PROPN"
  ],
  "filling": [
    "VERB"
  ],
  "sophisticated": [
    "ADJ"
  ],
  "silence": [
    "NOUN"
  ],
  "soviet": [
    "PROPN"
  ],
  "possession": [
    "NOUN"
  ],
  "treaty": [
    "NOUN"
  ],
  "vocal": [
    "ADJ"
  ],
  "trainer": [
    "NOUN"
  ],
  "lemon": [
    "NOUN"
  ],
  "toxic": [
    "ADJ"
  ],
  "darkness": [
    "NOUN"
  ],
  "vienna": [
    "PROPN"
  ],
  "respondent": [
    "NOUN"
  ],
  "statute": [
    "NOUN"
  ],
  "satisfy": [
    "VERB"
  ],
  "shelter": [
    "NOUN"
  ],
  "chapel": [
    "NOUN"
  ],
  "manufacture": [
    "NOUN"
  ],
  "vulnerability": [
    "NOUN",
    "PROPN"
  ],
  "accountability": [
    "NOUN",
    "PROPN"
  ],
  "celebrate": [
    "VERB",
    "PROPN"
  ],
  "accredited": [
    "VERB"
  ],
  "appliance": [
    "NOUN"
  ],
  "compressed": [
    "VERB"
  ],
  "mixture": [
    "NOUN"
  ],
  "zoophilia": [
    "X"
  ],
  "bench": [
    "NOUN"
  ],
  "rider": [
    "NOUN"
  ],
  "radius": [
    "PROPN",
    "NOUN"
  ],
  "mortality": [
    "NOUN"
  ],
  "logging": [
    "VERB",
    "NOUN"
  ],
  "therapeutic": [
    "ADJ"
  ],
  "bobby": [
    "VERB"
  ],
  "impressive": [
    "ADJ"
  ],
  "sheep": [
    "NOUN"
  ],
  "accordingly": [
    "ADV"
  ],
  "architect": [
    "PROPN",
    "NOUN"
  ],
  "railroad": [
    "NOUN"
  ],
  "nursery": [
    "NOUN"
  ],
  "harder": [
    "ADJ"
  ],
  "microwave": [
    "VERB"
  ],
  "relocation": [
    "NOUN"
  ],
  "stuart": [
    "PROPN"
  ],
  "salad": [
    "VERB"
  ],
  "tender": [
    "VERB"
  ],
  "paste": [
    "VERB",
    "NOUN"
  ],
  "discretion": [
    "NOUN"
  ],
  "preserve": [
    "VERB"
  ],
  "vibrator": [
    "NOUN"
  ],
  "unsigned": [
    "ADJ"
  ],
  "easter": [
    "PROPN"
  ],
  "repository": [
    "NOUN",
    "PROPN"
  ],
  "praise": [
    "NOUN"
  ],
  "jeremy": [
    "PROPN"
  ],
  "venice": [
    "PROPN"
  ],
  "christianity": [
    "PROPN"
  ],
  "veteran": [
    "NOUN"
  ],
  "landing": [
    "NOUN",
    "VERB"
  ],
  "executed": [
    "VERB"
  ],
  "katie": [
    "PROPN"
  ],
  "realistic": [
    "ADJ"
  ],
  "showcase": [
    "VERB",
    "PROPN"
  ],
  "integral": [
    "ADJ"
  ],
  "relax": [
    "VERB"
  ],
  "generating": [
    "VERB",
    "PROPN"
  ],
  "christina": [
    "PROPN"
  ],
  "congressional": [
    "ADJ"
  ],
  "synopsis": [
    "NOUN"
  ],
  "hardly": [
    "ADV"
  ],
  "prairie": [
    "VERB"
  ],
  "reunion": [
    "NOUN"
  ],
  "composer": [
    "NOUN"
  ],
  "sword": [
    "NOUN"
  ],
  "absent": [
    "ADJ"
  ],
  "photographic": [
    "NOUN"
  ],
  "coral": [
    "NOUN"
  ],
  "float": [
    "NOUN"
  ],
  "colin": [
    "PROPN"
  ],
  "bubble": [
    "NOUN",
    "VERB"
  ],
  "acquire": [
    "VERB"
  ],
  "contrary": [
    "ADJ"
  ],
  "millennium": [
    "NOUN"
  ],
  "tribune": [
    "ADJ"
  ],
  "vessel": [
    "NOUN"
  ],
  "admitted": [
    "VERB"
  ],
  "dairy": [
    "NOUN"
  ],
  "admit": [
    "VERB"
  ],
  "fancy": [
    "ADJ"
  ],
  "equality": [
    "NOUN"
  ],
  "stickers": [
    "NOUN"
  ],
  "leasing": [
    "VERB"
  ],
  "companion": [
    "NOUN"
  ],
  "squad": [
    "NOUN",
    "PROPN"
  ],
  "analyze": [
    "VERB",
    "PROPN"
  ],
  "scroll": [
    "NOUN",
    "VERB"
  ],
  "relate": [
    "VERB"
  ],
  "wages": [
    "NOUN"
  ],
  "additionally": [
    "ADV"
  ],
  "suffer": [
    "VERB"
  ],
  "fellowship": [
    "NOUN"
  ],
  "invalid": [
    "ADJ",
    "PROPN"
  ],
  "martial": [
    "ADJ"
  ],
  "victorian": [
    "PROPN"
  ],
  "retain": [
    "VERB",
    "PROPN"
  ],
  "execute": [
    "VERB",
    "PROPN"
  ],
  "tunnel": [
    "NOUN",
    "PROPN"
  ],
  "chaos": [
    "NOUN",
    "PROPN"
  ],
  "wheat": [
    "NOUN"
  ],
  "beaver": [
    "PROPN"
  ],
  "distribute": [
    "VERB"
  ],
  "decorative": [
    "VERB"
  ],
  "confused": [
    "VERB",
    "ADJ"
  ],
  "compiler": [
    "NOUN"
  ],
  "bases": [
    "NOUN"
  ],
  "accused": [
    "VERB"
  ],
  "unity": [
    "NOUN"
  ],
  "conjunction": [
    "NOUN"
  ],
  "bride": [
    "NOUN"
  ],
  "indigenous": [
    "ADJ"
  ],
  "begun": [
    "VERB"
  ],
  "brunette": [
    "VERB"
  ],
  "anchor": [
    "NOUN",
    "PROPN"
  ],
  "validation": [
    "NOUN",
    "PROPN"
  ],
  "parade": [
    "NOUN"
  ],
  "corruption": [
    "NOUN"
  ],
  "trigger": [
    "NOUN",
    "VERB"
  ],
  "cholesterol": [
    "NOUN"
  ],
  "essex": [
    "NOUN"
  ],
  "notified": [
    "VERB"
  ],
  "differential": [
    "ADJ"
  ],
  "dramatic": [
    "ADJ"
  ],
  "terrible": [
    "ADJ"
  ],
  "pendant": [
    "ADJ"
  ],
  "baptist": [
    "NOUN"
  ],
  "scientist": [
    "PROPN",
    "NOUN"
  ],
  "arthritis": [
    "NOUN"
  ],
  "nevertheless": [
    "ADV"
  ],
  "taxation": [
    "NOUN"
  ],
  "fever": [
    "NOUN"
  ],
  "cuisine": [
    "NOUN"
  ],
  "surely": [
    "ADV"
  ],
  "transcript": [
    "NOUN",
    "PROPN"
  ],
  "theorem": [
    "VERB"
  ],
  "inflation": [
    "NOUN"
  ],
  "stylus": [
    "PROPN"
  ],
  "topless": [
    "NOUN"
  ],
  "arnold": [
    "VERB"
  ],
  "structured": [
    "ADJ",
    "VERB"
  ],
  "reasonably": [
    "ADV"
  ],
  "cattle": [
    "NOUN"
  ],
  "radical": [
    "ADJ"
  ],
  "rover": [
    "PROPN"
  ],
  "treasure": [
    "NOUN"
  ],
  "reload": [
    "NOUN",
    "VERB"
  ],
  "flame": [
    "NOUN"
  ],
  "assuming": [
    "VERB"
  ],
  "monetary": [
    "ADJ"
  ],
  "elderly": [
    "ADJ"
  ],
  "floating": [
    "VERB"
  ],
  "extraordinary": [
    "ADJ"
  ],
  "bolivia": [
    "PROPN"
  ],
  "spell": [
    "VERB"
  ],
  "exclusively": [
    "ADV"
  ],
  "emily": [
    "PROPN"
  ],
  "limitation": [
    "NOUN",
    "PROPN"
  ],
  "compile": [
    "VERB",
    "NOUN"
  ],
  "squirting": [
    "VERB"
  ],
  "webster": [
    "PROPN"
  ],
  "struck": [
    "VERB"
  ],
  "illustration": [
    "NOUN"
  ],
  "plymouth": [
    "PROPN"
  ],
  "construct": [
    "VERB",
    "NOUN"
  ],
  "bridal": [
    "NOUN"
  ],
  "annex": [
    "VERB"
  ],
  "inspiration": [
    "NOUN",
    "PROPN"
  ],
  "tribal": [
    "ADJ"
  ],
  "curious": [
    "ADJ"
  ],
  "affecting": [
    "VERB"
  ],
  "freight": [
    "NOUN"
  ],
  "rebate": [
    "NOUN"
  ],
  "eclipse": [
    "NOUN"
  ],
  "sudan": [
    "PROPN"
  ],
  "shuttle": [
    "VERB"
  ],
  "aggregate": [
    "ADJ",
    "VERB"
  ],
  "stunning": [
    "ADJ"
  ],
  "detect": [
    "VERB",
    "PROPN"
  ],
  "actively": [
    "ADV"
  ],
  "complicated": [
    "ADJ",
    "VERB"
  ],
  "butler": [
    "PROPN"
  ],
  "injured": [
    "VERB"
  ],
  "payroll": [
    "PROPN",
    "NOUN"
  ],
  "cookbook": [
    "VERB"
  ],
  "courier": [
    "NOUN"
  ],
  "collapse": [
    "NOUN",
    "VERB"
  ],
  "unlikely": [
    "ADJ"
  ],
  "beverage": [
    "NOUN"
  ],
  "tribute": [
    "VERB"
  ],
  "wired": [
    "VERB"
  ],
  "elvis": [
    "PROPN"
  ],
  "immune": [
    "PROPN"
  ],
  "forestry": [
    "NOUN"
  ],
  "rarely": [
    "ADV"
  ],
  "infected": [
    "VERB"
  ],
  "martha": [
    "PROPN"
  ],
  "genesis": [
    "VERB"
  ],
  "barrier": [
    "NOUN"
  ],
  "argue": [
    "VERB"
  ],
  "incorrect": [
    "ADJ",
    "PROPN"
  ],
  "bicycle": [
    "NOUN"
  ],
  "arise": [
    "VERB"
  ],
  "celtic": [
    "ADJ"
  ],
  "thereby": [
    "ADV"
  ],
  "jamie": [
    "PROPN"
  ],
  "particle": [
    "NOUN"
  ],
  "perception": [
    "NOUN"
  ],
  "advise": [
    "VERB",
    "PROPN"
  ],
  "humidity": [
    "NOUN"
  ],
  "boxing": [
    "VERB"
  ],
  "bangkok": [
    "PROPN"
  ],
  "renaissance": [
    "NOUN"
  ],
  "pathology": [
    "NOUN"
  ],
  "ordinance": [
    "NOUN"
  ],
  "hughes": [
    "NOUN"
  ],
  "jeffrey": [
    "PROPN"
  ],
  "chess": [
    "NOUN"
  ],
  "survive": [
    "VERB"
  ],
  "oscar": [
    "NOUN"
  ],
  "reveal": [
    "VERB"
  ],
  "canal": [
    "NOUN"
  ],
  "amino": [
    "NOUN"
  ],
  "analytical": [
    "ADJ",
    "PROPN"
  ],
  "lying": [
    "VERB"
  ],
  "strict": [
    "ADJ"
  ],
  "circulation": [
    "NOUN"
  ],
  "drill": [
    "VERB",
    "NOUN"
  ],
  "offense": [
    "NOUN"
  ],
  "bryan": [
    "PROPN"
  ],
  "protest": [
    "NOUN"
  ],
  "assumption": [
    "NOUN",
    "PROPN"
  ],
  "jerusalem": [
    "PROPN"
  ],
  "hobby": [
    "NOUN"
  ],
  "invention": [
    "NOUN"
  ],
  "nickname": [
    "VERB"
  ],
  "technician": [
    "PROPN"
  ],
  "washing": [
    "VERB"
  ],
  "cognitive": [
    "ADJ"
  ],
  "exploring": [
    "VERB"
  ],
  "trick": [
    "NOUN"
  ],
  "enquiry": [
    "NOUN"
  ],
  "closure": [
    "NOUN",
    "PROPN"
  ],
  "timber": [
    "NOUN"
  ],
  "intense": [
    "ADJ"
  ],
  "registrar": [
    "NOUN"
  ],
  "ruling": [
    "VERB"
  ],
  "steady": [
    "ADJ"
  ],
  "withdrawal": [
    "VERB"
  ],
  "cancellation": [
    "NOUN",
    "PROPN"
  ],
  "enrolled": [
    "VERB"
  ],
  "publicly": [
    "ADV"
  ],
  "hourly": [
    "ADJ"
  ],
  "blame": [
    "NOUN"
  ],
  "geneva": [
    "PROPN"
  ],
  "veterinary": [
    "ADJ"
  ],
  "reseller": [
    "NOUN",
    "PROPN"
  ],
  "handed": [
    "VERB"
  ],
  "intake": [
    "ADJ",
    "PROPN"
  ],
  "informal": [
    "ADJ"
  ],
  "relevance": [
    "NOUN",
    "PROPN"
  ],
  "incentive": [
    "NOUN",
    "PROPN"
  ],
  "butterfly": [
    "VERB"
  ],
  "mechanics": [
    "NOUN"
  ],
  "heavily": [
    "ADV"
  ],
  "fifty": [
    "NUM"
  ],
  "numerical": [
    "ADJ"
  ],
  "uncle": [
    "NOUN"
  ],
  "counting": [
    "VERB",
    "NOUN"
  ],
  "reflection": [
    "NOUN"
  ],
  "assure": [
    "VERB"
  ],
  "invitation": [
    "NOUN"
  ],
  "devoted": [
    "VERB"
  ],
  "jacob": [
    "PROPN"
  ],
  "sodium": [
    "NOUN"
  ],
  "randy": [
    "NOUN"
  ],
  "spirituality": [
    "NOUN"
  ],
  "hormone": [
    "NOUN"
  ],
  "meanwhile": [
    "ADV"
  ],
  "proprietary": [
    "ADJ"
  ],
  "timothy": [
    "PROPN"
  ],
  "brick": [
    "NOUN"
  ],
  "naval": [
    "ADJ"
  ],
  "medieval": [
    "ADJ"
  ],
  "porcelain": [
    "VERB"
  ],
  "decent": [
    "ADJ"
  ],
  "casting": [
    "VERB"
  ],
  "shortly": [
    "ADV"
  ],
  "carlos": [
    "PROPN"
  ],
  "donna": [
    "NOUN"
  ],
  "andreas": [
    "NOUN"
  ],
  "warrior": [
    "NOUN"
  ],
  "diploma": [
    "NOUN"
  ],
  "cabin": [
    "NOUN"
  ],
  "innocent": [
    "ADJ"
  ],
  "scanning": [
    "VERB",
    "NOUN"
  ],
  "consensus": [
    "NOUN",
    "PROPN"
  ],
  "patricia": [
    "PROPN"
  ],
  "eddie": [
    "PROPN"
  ],
  "fired": [
    "VERB"
  ],
  "journalism": [
    "NOUN"
  ],
  "trivia": [
    "NOUN"
  ],
  "grammar": [
    "NOUN",
    "PROPN"
  ],
  "intention": [
    "NOUN"
  ],
  "disagree": [
    "VERB"
  ],
  "harvey": [
    "VERB"
  ],
  "hazard": [
    "NOUN"
  ],
  "semiconductor": [
    "NOUN"
  ],
  "gregory": [
    "PROPN"
  ],
  "circular": [
    "ADJ"
  ],
  "anger": [
    "NOUN"
  ],
  "interact": [
    "VERB",
    "PROPN"
  ],
  "happiness": [
    "NOUN"
  ],
  "substantially": [
    "ADV"
  ],
  "bizarre": [
    "ADJ"
  ],
  "glenn": [
    "PROPN"
  ],
  "identifier": [
    "NOUN",
    "PROPN"
  ],
  "ribbon": [
    "NOUN"
  ],
  "kissing": [
    "VERB"
  ],
  "handy": [
    "ADJ"
  ],
  "exempt": [
    "ADJ"
  ],
  "accomplished": [
    "VERB"
  ],
  "geometry": [
    "NOUN"
  ],
  "impression": [
    "NOUN"
  ],
  "guild": [
    "NOUN",
    "PROPN"
  ],
  "correlation": [
    "NOUN"
  ],
  "gorgeous": [
    "ADJ"
  ],
  "capitol": [
    "PROPN"
  ],
  "barbados": [
    "VERB"
  ],
  "nervous": [
    "ADJ"
  ],
  "refuse": [
    "VERB"
  ],
  "fragrance": [
    "NOUN"
  ],
  "replica": [
    "NOUN",
    "PROPN"
  ],
  "plumbing": [
    "VERB"
  ],
  "brussels": [
    "PROPN"
  ],
  "tribe": [
    "VERB"
  ],
  "superb": [
    "NOUN"
  ],
  "transparent": [
    "ADJ",
    "PROPN"
  ],
  "trinity": [
    "NOUN"
  ],
  "charleston": [
    "PROPN"
  ],
  "handled": [
    "VERB"
  ],
  "inappropriate": [
    "ADJ"
  ],
  "exhaust": [
    "VERB"
  ],
  "shanghai": [
    "PROPN"
  ],
  "burton": [
    "PROPN"
  ],
  "vocational": [
    "ADJ"
  ],
  "copied": [
    "VERB"
  ],
  "scotia": [
    "PROPN"
  ],
  "farming": [
    "VERB"
  ],
  "gibson": [
    "PROPN"
  ],
  "roller": [
    "NOUN"
  ],
  "batch": [
    "NOUN",
    "PROPN"
  ],
  "organize": [
    "VERB"
  ],
  "alter": [
    "VERB"
  ],
  "skilled": [
    "ADJ"
  ],
  "fitted": [
    "VERB"
  ],
  "harmony": [
    "NOUN"
  ],
  "distinguished": [
    "VERB"
  ],
  "asthma": [
    "NOUN"
  ],
  "developmental": [
    "ADJ"
  ],
  "regulated": [
    "VERB",
    "PROPN"
  ],
  "triangle": [
    "NOUN"
  ],
  "amend": [
    "VERB"
  ],
  "oriental": [
    "ADJ"
  ],
  "reward": [
    "NOUN"
  ],
  "windsor": [
    "NOUN"
  ],
  "hydrogen": [
    "NOUN"
  ],
  "sprint": [
    "NOUN",
    "PROPN"
  ],
  "comparable": [
    "ADJ"
  ],
  "chick": [
    "NOUN"
  ],
  "advocate": [
    "PROPN",
    "NOUN"
  ],
  "confusion": [
    "NOUN",
    "PROPN"
  ],
  "genome": [
    "VERB"
  ],
  "thong": [
    "PROPN"
  ],
  "medal": [
    "NOUN"
  ],
  "harbour": [
    "VERB"
  ],
  "vulnerable": [
    "ADJ"
  ],
  "arrange": [
    "VERB"
  ],
  "artistic": [
    "ADJ"
  ],
  "booth": [
    "NOUN",
    "PROPN"
  ],
  "reflected": [
    "VERB"
  ],
  "unified": [
    "ADJ",
    "PROPN"
  ],
  "breed": [
    "NOUN"
  ],
  "detector": [
    "NOUN",
    "PROPN"
  ],
  "polar": [
    "ADJ"
  ],
  "fallen": [
    "VERB"
  ],
  "precise": [
    "ADJ"
  ],
  "sussex": [
    "NOUN"
  ],
  "respiratory": [
    "NOUN"
  ],
  "invoice": [
    "PROPN",
    "NOUN"
  ],
  "subcommittee": [
    "NOUN"
  ],
  "gather": [
    "VERB",
    "PROPN"
  ],
  "maternity": [
    "NOUN"
  ],
  "backed": [
    "VERB"
  ],
  "alfred": [
    "PROPN"
  ],
  "colonial": [
    "NOUN"
  ],
  "forming": [
    "VERB"
  ],
  "embassy": [
    "NOUN"
  ],
  "danny": [
    "PROPN"
  ],
  "rebecca": [
    "PROPN"
  ],
  "slight": [
    "ADJ"
  ],
  "proceeds": [
    "VERB"
  ],
  "indirect": [
    "ADJ"
  ],
  "amongst": [
    "ADP"
  ],
  "arrest": [
    "NOUN"
  ],
  "volleyball": [
    "NOUN"
  ],
  "horizon": [
    "PROPN",
    "NOUN"
  ],
  "deeply": [
    "ADV"
  ],
  "toolbox": [
    "PROPN"
  ],
  "marina": [
    "PROPN"
  ],
  "patio": [
    "NOUN"
  ],
  "tolerance": [
    "NOUN"
  ],
  "creativity": [
    "NOUN"
  ],
  "lloyd": [
    "PROPN"
  ],
  "optics": [
    "NOUN"
  ],
  "pursue": [
    "VERB"
  ],
  "lightning": [
    "PROPN",
    "NOUN"
  ],
  "overcome": [
    "VERB"
  ],
  "inspector": [
    "NOUN"
  ],
  "attract": [
    "VERB"
  ],
  "disable": [
    "ADJ",
    "VERB"
  ],
  "snake": [
    "NOUN"
  ],
  "succeed": [
    "VERB"
  ],
  "leonard": [
    "PROPN"
  ],
  "reminder": [
    "NOUN",
    "PROPN"
  ],
  "behavioral": [
    "ADJ"
  ],
  "riverside": [
    "NOUN"
  ],
  "raymond": [
    "PROPN"
  ],
  "midwest": [
    "PROPN"
  ],
  "karaoke": [
    "PROPN"
  ],
  "lonely": [
    "ADJ"
  ],
  "nonprofit": [
    "ADJ"
  ],
  "lancaster": [
    "NOUN"
  ],
  "suspended": [
    "VERB"
  ],
  "hereby": [
    "ADV"
  ],
  "observe": [
    "VERB",
    "PROPN"
  ],
  "julia": [
    "PROPN"
  ],
  "berry": [
    "VERB"
  ],
  "collar": [
    "NOUN"
  ],
  "simultaneously": [
    "ADV"
  ],
  "racial": [
    "ADJ"
  ],
  "integrate": [
    "VERB",
    "NOUN"
  ],
  "bermuda": [
    "NOUN"
  ],
  "amanda": [
    "PROPN"
  ],
  "sociology": [
    "NOUN"
  ],
  "confident": [
    "ADJ",
    "PROPN"
  ],
  "officially": [
    "ADV"
  ],
  "consortium": [
    "NOUN"
  ],
  "terrace": [
    "NOUN"
  ],
  "bacteria": [
    "NOUN"
  ],
  "ought": [
    "AUX"
  ],
  "delicious": [
    "ADJ"
  ],
  "safely": [
    "ADV"
  ],
  "finite": [
    "PROPN"
  ],
  "kidney": [
    "NOUN"
  ],
  "periodically": [
    "ADV"
  ],
  "durable": [
    "ADJ"
  ],
  "mazda": [
    "PROPN"
  ],
  "allied": [
    "VERB"
  ],
  "moisture": [
    "NOUN"
  ],
  "hungarian": [
    "PROPN"
  ],
  "roster": [
    "NOUN",
    "PROPN"
  ],
  "spencer": [
    "NOUN"
  ],
  "wichita": [
    "NOUN"
  ],
  "transform": [
    "VERB",
    "NOUN"
  ],
  "timer": [
    "NOUN"
  ],
  "tuning": [
    "VERB",
    "NOUN"
  ],
  "gotten": [
    "VERB"
  ],
  "tyler": [
    "PROPN"
  ],
  "vegetable": [
    "NOUN"
  ],
  "verse": [
    "NOUN"
  ],
  "independently": [
    "ADV"
  ],
  "wanting": [
    "VERB"
  ],
  "custody": [
    "NOUN"
  ],
  "scratch": [
    "NOUN"
  ],
  "alignment": [
    "NOUN",
    "PROPN"
  ],
  "ellen": [
    "VERB"
  ],
  "rocket": [
    "PROPN",
    "NOUN"
  ],
  "bullet": [
    "NOUN"
  ],
  "nasty": [
    "ADJ"
  ],
  "visibility": [
    "NOUN",
    "PROPN"
  ],
  "latitude": [
    "NOUN"
  ],
  "consciousness": [
    "NOUN"
  ],
  "tumor": [
    "NOUN"
  ],
  "beverly": [
    "ADV"
  ],
  "mistress": [
    "NOUN"
  ],
  "encounter": [
    "VERB"
  ],
  "duncan": [
    "PROPN"
  ],
  "bernard": [
    "NOUN"
  ],
  "forty": [
    "NUM"
  ],
  "priest": [
    "NOUN"
  ],
  "floyd": [
    "PROPN"
  ],
  "ronald": [
    "PROPN"
  ],
  "queue": [
    "NOUN",
    "PROPN"
  ],
  "trance": [
    "NOUN"
  ],
  "locale": [
    "NOUN"
  ],
  "nicholas": [
    "NOUN"
  ],
  "bundle": [
    "NOUN",
    "PROPN"
  ],
  "hammer": [
    "NOUN"
  ],
  "invasion": [
    "NOUN"
  ],
  "runner": [
    "NOUN",
    "PROPN"
  ],
  "notion": [
    "PROPN",
    "NOUN"
  ],
  "mailed": [
    "VERB"
  ],
  "spelling": [
    "NOUN"
  ],
  "arctic": [
    "PROPN"
  ],
  "beneath": [
    "ADP"
  ],
  "strengthen": [
    "VERB"
  ],
  "defend": [
    "VERB"
  ],
  "frederick": [
    "PROPN"
  ],
  "infrared": [
    "VERB"
  ],
  "seventh": [
    "ADJ"
  ],
  "welsh": [
    "NOUN"
  ],
  "belly": [
    "NOUN"
  ],
  "aggressive": [
    "ADJ"
  ],
  "quarters": [
    "NOUN",
    "PROPN"
  ],
  "stolen": [
    "VERB"
  ],
  "disturbed": [
    "VERB",
    "ADJ"
  ],
  "sculpture": [
    "NOUN"
  ],
  "motivation": [
    "NOUN",
    "PROPN"
  ],
  "pharmacology": [
    "NOUN"
  ],
  "fitting": [
    "PROPN"
  ],
  "consistently": [
    "ADV"
  ],
  "surplus": [
    "NOUN"
  ],
  "elder": [
    "VERB"
  ],
  "sonic": [
    "ADJ"
  ],
  "punishment": [
    "NOUN"
  ],
  "appreciation": [
    "NOUN"
  ],
  "subsequently": [
    "ADV"
  ],
  "zoning": [
    "VERB"
  ],
  "gravity": [
    "NOUN"
  ],
  "providence": [
    "NOUN"
  ],
  "thumb": [
    "NOUN"
  ],
  "restriction": [
    "NOUN",
    "PROPN"
  ],
  "incorporate": [
    "VERB",
    "ADJ"
  ],
  "treasurer": [
    "NOUN"
  ],
  "essence": [
    "NOUN"
  ],
  "flooring": [
    "VERB"
  ],
  "lightweight": [
    "ADJ",
    "PROPN"
  ],
  "ethiopia": [
    "PROPN"
  ],
  "mighty": [
    "ADV"
  ],
  "humanity": [
    "NOUN"
  ],
  "transcription": [
    "NOUN"
  ],
  "galaxy": [
    "VERB"
  ],
  "chester": [
    "NOUN"
  ],
  "snapshot": [
    "NOUN",
    "PROPN"
  ],
  "synthetic": [
    "ADJ",
    "PROPN"
  ],
  "testament": [
    "NOUN"
  ],
  "dominant": [
    "ADJ"
  ],
  "twist": [
    "NOUN"
  ],
  "stomach": [
    "NOUN"
  ],
  "partially": [
    "ADV"
  ],
  "buried": [
    "VERB"
  ],
  "minimize": [
    "VERB",
    "PROPN"
  ],
  "wilderness": [
    "NOUN"
  ],
  "debut": [
    "PROPN"
  ],
  "bradley": [
    "VERB"
  ],
  "anatomy": [
    "NOUN"
  ],
  "sponsorship": [
    "PROPN",
    "NOUN"
  ],
  "fraction": [
    "NOUN"
  ],
  "proceeding": [
    "VERB"
  ],
  "uncertainty": [
    "NOUN",
    "PROPN"
  ],
  "breakdown": [
    "PROPN",
    "NOUN"
  ],
  "marker": [
    "NOUN"
  ],
  "reconstruction": [
    "NOUN"
  ],
  "subsidiary": [
    "NOUN",
    "PROPN"
  ],
  "clarity": [
    "NOUN",
    "PROPN"
  ],
  "sandra": [
    "PROPN"
  ],
  "adelaide": [
    "NOUN"
  ],
  "encouraging": [
    "VERB"
  ],
  "furnished": [
    "VERB"
  ],
  "settled": [
    "VERB"
  ],
  "folding": [
    "VERB"
  ],
  "beneficial": [
    "ADJ"
  ],
  "vaccine": [
    "NOUN"
  ],
  "penny": [
    "NOUN"
  ],
  "robust": [
    "ADJ"
  ],
  "porter": [
    "NOUN"
  ],
  "jungle": [
    "NOUN"
  ],
  "ivory": [
    "NOUN"
  ],
  "alpine": [
    "NOUN"
  ],
  "prediction": [
    "NOUN"
  ],
  "fabulous": [
    "ADJ"
  ],
  "remix": [
    "NOUN"
  ],
  "alias": [
    "NOUN",
    "PROPN"
  ],
  "thesaurus": [
    "VERB"
  ],
  "individually": [
    "ADV"
  ],
  "battlefield": [
    "VERB"
  ],
  "literally": [
    "ADV"
  ],
  "ecological": [
    "ADJ"
  ],
  "spice": [
    "VERB"
  ],
  "cooler": [
    "NOUN"
  ],
  "appraisal": [
    "NOUN"
  ],
  "maritime": [
    "ADV"
  ],
  "periodic": [
    "ADJ"
  ],
  "overhead": [
    "NOUN",
    "ADJ"
  ],
  "ascii": [
    "NOUN"
  ],
  "prospect": [
    "PROPN",
    "NOUN"
  ],
  "shipment": [
    "NOUN"
  ],
  "breeding": [
    "VERB"
  ],
  "geographical": [
    "ADJ"
  ],
  "donor": [
    "NOUN"
  ],
  "mozambique": [
    "PROPN"
  ],
  "tension": [
    "NOUN"
  ],
  "trash": [
    "NOUN"
  ],
  "manor": [
    "NOUN"
  ],
  "envelope": [
    "NOUN"
  ],
  "diane": [
    "NOUN"
  ],
  "homeland": [
    "NOUN"
  ],
  "andrea": [
    "PROPN"
  ],
  "sheffield": [
    "VERB"
  ],
  "bailey": [
    "NOUN"
  ],
  "finishing": [
    "VERB"
  ],
  "wellington": [
    "PROPN"
  ],
  "incoming": [
    "ADJ",
    "PROPN"
  ],
  "bulgarian": [
    "PROPN"
  ],
  "eternal": [
    "ADJ"
  ],
  "aboriginal": [
    "ADJ"
  ],
  "remarkable": [
    "ADJ"
  ],
  "rotation": [
    "NOUN",
    "PROPN"
  ],
  "productive": [
    "ADJ"
  ],
  "boulevard": [
    "PROPN"
  ],
  "eugene": [
    "NOUN"
  ],
  "metric": [
    "ADJ",
    "PROPN"
  ],
  "compliant": [
    "ADJ",
    "PROPN"
  ],
  "minus": [
    "NOUN"
  ],
  "imagination": [
    "NOUN"
  ],
  "joshua": [
    "PROPN"
  ],
  "varied": [
    "ADJ"
  ],
  "actress": [
    "NOUN"
  ],
  "assign": [
    "VERB",
    "PROPN"
  ],
  "accommodate": [
    "VERB"
  ],
  "aurora": [
    "PROPN",
    "NOUN"
  ],
  "milan": [
    "PROPN"
  ],
  "premiere": [
    "NOUN"
  ],
  "lender": [
    "NOUN"
  ],
  "shade": [
    "NOUN"
  ],
  "chorus": [
    "NOUN"
  ],
  "christine": [
    "PROPN"
  ],
  "rhythm": [
    "NOUN"
  ],
  "digit": [
    "NOUN"
  ],
  "dietary": [
    "ADJ"
  ],
  "symphony": [
    "PROPN"
  ],
  "sudden": [
    "ADJ"
  ],
  "precipitation": [
    "NOUN"
  ],
  "marilyn": [
    "PROPN"
  ],
  "lyric": [
    "NOUN"
  ],
  "claire": [
    "PROPN"
  ],
  "isolation": [
    "NOUN",
    "PROPN"
  ],
  "sustained": [
    "VERB",
    "ADJ"
  ],
  "approximate": [
    "ADJ"
  ],
  "rational": [
    "ADJ"
  ],
  "programmer": [
    "NOUN"
  ],
  "warming": [
    "VERB"
  ],
  "incomplete": [
    "ADJ",
    "PROPN"
  ],
  "chronicle": [
    "NOUN"
  ],
  "fountain": [
    "NOUN"
  ],
  "chubby": [
    "PROPN"
  ],
  "grave": [
    "NOUN"
  ],
  "legitimate": [
    "ADJ"
  ],
  "burner": [
    "PROPN"
  ],
  "investigator": [
    "NOUN"
  ],
  "plaintiff": [
    "NOUN"
  ],
  "finnish": [
    "PROPN"
  ],
  "gentle": [
    "ADJ"
  ],
  "mediterranean": [
    "PROPN"
  ],
  "footage": [
    "NOUN"
  ],
  "worthy": [
    "ADJ"
  ],
  "entrepreneur": [
    "PROPN"
  ],
  "excessive": [
    "ADJ"
  ],
  "devon": [
    "PROPN"
  ],
  "helena": [
    "NOUN"
  ],
  "valuation": [
    "NOUN"
  ],
  "unexpected": [
    "ADJ"
  ],
  "cigarette": [
    "NOUN"
  ],
  "characteristic": [
    "ADJ"
  ],
  "marion": [
    "NOUN"
  ],
  "lobby": [
    "VERB"
  ],
  "egyptian": [
    "PROPN"
  ],
  "outlined": [
    "VERB"
  ],
  "consequently": [
    "ADV"
  ],
  "headline": [
    "PROPN",
    "NOUN"
  ],
  "treating": [
    "VERB"
  ],
  "punch": [
    "VERB"
  ],
  "cowboy": [
    "NOUN"
  ],
  "narrative": [
    "PROPN",
    "NOUN"
  ],
  "enormous": [
    "ADJ"
  ],
  "karma": [
    "PROPN",
    "NOUN"
  ],
  "consist": [
    "VERB"
  ],
  "betty": [
    "PROPN"
  ],
  "quantitative": [
    "ADJ"
  ],
  "subdivision": [
    "NOUN"
  ],
  "defeat": [
    "VERB"
  ],
  "distinction": [
    "NOUN"
  ],
  "naughty": [
    "NOUN"
  ],
  "insured": [
    "VERB"
  ],
  "harper": [
    "NOUN"
  ],
  "livestock": [
    "NOUN"
  ],
  "exemption": [
    "NOUN",
    "PROPN"
  ],
  "tenant": [
    "NOUN",
    "PROPN"
  ],
  "tattoo": [
    "ADV"
  ],
  "shake": [
    "VERB"
  ],
  "algebra": [
    "VERB"
  ],
  "holly": [
    "PROPN"
  ],
  "silly": [
    "ADJ"
  ],
  "nutritional": [
    "ADJ"
  ],
  "mercy": [
    "NOUN"
  ],
  "freely": [
    "ADV"
  ],
  "sunrise": [
    "NOUN"
  ],
  "wrapping": [
    "VERB"
  ],
  "nicaragua": [
    "PROPN"
  ],
  "readily": [
    "ADV"
  ],
  "affiliation": [
    "NOUN"
  ],
  "fence": [
    "NOUN"
  ],
  "nudist": [
    "PROPN"
  ],
  "infinite": [
    "ADJ"
  ],
  "diana": [
    "PROPN"
  ],
  "lindsay": [
    "VERB"
  ],
  "legally": [
    "ADV"
  ],
  "shame": [
    "NOUN"
  ],
  "satisfactory": [
    "ADJ"
  ],
  "revolutionary": [
    "ADJ"
  ],
  "civilian": [
    "PROPN"
  ],
  "telephony": [
    "PROPN"
  ],
  "fatal": [
    "ADJ",
    "PROPN"
  ],
  "remedy": [
    "NOUN"
  ],
  "breathing": [
    "VERB"
  ],
  "briefly": [
    "PROPN"
  ],
  "thickness": [
    "NOUN"
  ],
  "graphical": [
    "ADJ"
  ],
  "genius": [
    "NOUN"
  ],
  "fighter": [
    "NOUN"
  ],
  "meaningful": [
    "ADJ"
  ],
  "flesh": [
    "VERB"
  ],
  "retreat": [
    "NOUN"
  ],
  "barely": [
    "ADV"
  ],
  "wherever": [
    "SCONJ"
  ],
  "democrat": [
    "PROPN"
  ],
  "borough": [
    "NOUN"
  ],
  "failing": [
    "VERB",
    "PROPN"
  ],
  "pamela": [
    "PROPN"
  ],
  "marble": [
    "NOUN"
  ],
  "extending": [
    "VERB"
  ],
  "jesse": [
    "PROPN"
  ],
  "surrey": [
    "VERB"
  ],
  "briefing": [
    "PROPN",
    "NOUN"
  ],
  "accreditation": [
    "NOUN"
  ],
  "blackberry": [
    "NOUN"
  ],
  "highland": [
    "PROPN"
  ],
  "meditation": [
    "NOUN"
  ],
  "modular": [
    "ADJ"
  ],
  "microphone": [
    "NOUN"
  ],
  "combining": [
    "VERB"
  ],
  "brandon": [
    "PROPN"
  ],
  "instrumental": [
    "ADJ"
  ],
  "balloon": [
    "NOUN"
  ],
  "winston": [
    "PROPN"
  ],
  "hawaiian": [
    "PROPN"
  ],
  "partition": [
    "NOUN",
    "PROPN"
  ],
  "invisible": [
    "ADJ"
  ],
  "magnet": [
    "NOUN"
  ],
  "cayman": [
    "NOUN"
  ],
  "jaguar": [
    "VERB"
  ],
  "sheer": [
    "ADJ"
  ],
  "commodity": [
    "NOUN"
  ],
  "posing": [
    "VERB"
  ],
  "thanksgiving": [
    "PROPN"
  ],
  "urgent": [
    "ADJ",
    "PROPN"
  ],
  "gothic": [
    "PROPN"
  ],
  "cylinder": [
    "NOUN"
  ],
  "witch": [
    "NOUN"
  ],
  "indication": [
    "NOUN"
  ],
  "cohen": [
    "PROPN"
  ],
  "puppy": [
    "ADJ"
  ],
  "kathy": [
    "PROPN"
  ],
  "surround": [
    "VERB"
  ],
  "revenge": [
    "NOUN"
  ],
  "enjoying": [
    "VERB"
  ],
  "patrol": [
    "VERB"
  ],
  "smell": [
    "NOUN"
  ],
  "carnival": [
    "NOUN"
  ],
  "roughly": [
    "ADV"
  ],
  "sticker": [
    "NOUN"
  ],
  "physically": [
    "ADV"
  ],
  "divide": [
    "VERB",
    "NOUN"
  ],
  "consecutive": [
    "ADJ"
  ],
  "satin": [
    "NOUN"
  ],
  "deserve": [
    "VERB"
  ],
  "worried": [
    "ADJ"
  ],
  "garbage": [
    "NOUN"
  ],
  "bradford": [
    "PROPN"
  ],
  "peninsula": [
    "NOUN"
  ],
  "boring": [
    "ADJ"
  ],
  "accurately": [
    "ADV"
  ],
  "schema": [
    "PROPN",
    "NOUN"
  ],
  "parliamentary": [
    "ADJ"
  ],
  "prefix": [
    "NOUN",
    "VERB"
  ],
  "lucia": [
    "NOUN"
  ],
  "savannah": [
    "PROPN"
  ],
  "barrel": [
    "NOUN"
  ],
  "nerve": [
    "NOUN"
  ],
  "deficit": [
    "NOUN"
  ],
  "boulder": [
    "VERB"
  ],
  "pointing": [
    "VERB",
    "NOUN"
  ],
  "renew": [
    "VERB",
    "NOUN"
  ],
  "coupled": [
    "VERB"
  ],
  "harold": [
    "NOUN"
  ],
  "floppy": [
    "ADJ"
  ],
  "texture": [
    "NOUN"
  ],
  "somerset": [
    "VERB"
  ],
  "acknowledge": [
    "VERB"
  ],
  "thoroughly": [
    "ADV"
  ],
  "thunder": [
    "NOUN"
  ],
  "caution": [
    "NOUN"
  ],
  "questionnaire": [
    "NOUN",
    "PROPN"
  ],
  "qualification": [
    "PROPN",
    "NOUN"
  ],
  "namely": [
    "ADV"
  ],
  "miniature": [
    "ADJ"
  ],
  "interstate": [
    "PROPN"
  ],
  "aerial": [
    "ADJ"
  ],
  "consequence": [
    "NOUN"
  ],
  "rebel": [
    "VERB"
  ],
  "systematic": [
    "ADJ"
  ],
  "hired": [
    "VERB"
  ],
  "textile": [
    "NOUN"
  ],
  "madagascar": [
    "ADJ"
  ],
  "nathan": [
    "PROPN"
  ],
  "magnitude": [
    "NOUN"
  ],
  "hindu": [
    "NOUN"
  ],
  "vocabulary": [
    "ADJ"
  ],
  "licking": [
    "VERB"
  ],
  "earthquake": [
    "NOUN"
  ],
  "albania": [
    "PROPN"
  ],
  "geological": [
    "ADJ"
  ],
  "lasting": [
    "VERB"
  ],
  "wicked": [
    "ADJ"
  ],
  "roommate": [
    "VERB"
  ],
  "computational": [
    "ADJ"
  ],
  "conspiracy": [
    "NOUN"
  ],
  "surname": [
    "NOUN"
  ],
  "theology": [
    "NOUN"
  ],
  "evident": [
    "ADJ"
  ],
  "whats": [
    "PRON"
  ],
  "saturn": [
    "NOUN"
  ],
  "organizer": [
    "NOUN"
  ],
  "allergy": [
    "PROPN"
  ],
  "twisted": [
    "VERB"
  ],
  "preceding": [
    "VERB"
  ],
  "merit": [
    "NOUN"
  ],
  "enzyme": [
    "ADP"
  ],
  "cumulative": [
    "ADJ",
    "PROPN"
  ],
  "tackle": [
    "VERB"
  ],
  "amplifier": [
    "NOUN"
  ],
  "arbitrary": [
    "ADJ"
  ],
  "prominent": [
    "ADJ"
  ],
  "retrieve": [
    "VERB",
    "PROPN"
  ],
  "vernon": [
    "PROPN"
  ],
  "titanium": [
    "NOUN"
  ],
  "fairy": [
    "PROPN"
  ],
  "shaft": [
    "NOUN"
  ],
  "occasional": [
    "ADJ"
  ],
  "leslie": [
    "PROPN"
  ],
  "kitty": [
    "NOUN"
  ],
  "drain": [
    "VERB"
  ],
  "monte": [
    "PROPN"
  ],
  "blessed": [
    "VERB"
  ],
  "potato": [
    "NOUN"
  ],
  "panic": [
    "NOUN"
  ],
  "explicitly": [
    "ADV"
  ],
  "sticks": [
    "NOUN"
  ],
  "citizenship": [
    "NOUN"
  ],
  "excuse": [
    "VERB"
  ],
  "basement": [
    "NOUN"
  ],
  "onion": [
    "NOUN"
  ],
  "strand": [
    "VERB"
  ],
  "sandwich": [
    "NOUN"
  ],
  "lawsuit": [
    "NOUN"
  ],
  "informative": [
    "ADJ"
  ],
  "cheque": [
    "NOUN"
  ],
  "hierarchy": [
    "NOUN",
    "PROPN"
  ],
  "reject": [
    "VERB",
    "PROPN"
  ],
  "abandoned": [
    "VERB"
  ],
  "italic": [
    "NOUN"
  ],
  "merry": [
    "VERB"
  ],
  "complement": [
    "VERB"
  ],
  "passive": [
    "ADJ"
  ],
  "valued": [
    "VERB"
  ],
  "courage": [
    "NOUN"
  ],
  "gazette": [
    "VERB"
  ],
  "extraction": [
    "NOUN",
    "PROPN"
  ],
  "batman": [
    "PROPN"
  ],
  "elevation": [
    "NOUN"
  ],
  "utilization": [
    "NOUN",
    "PROPN"
  ],
  "calibration": [
    "NOUN",
    "PROPN"
  ],
  "efficiently": [
    "ADV"
  ],
  "textbook": [
    "NOUN"
  ],
  "dried": [
    "VERB"
  ],
  "entertaining": [
    "VERB"
  ],
  "prerequisite": [
    "NOUN"
  ],
  "luther": [
    "NOUN"
  ],
  "frontier": [
    "PROPN"
  ],
  "settle": [
    "VERB"
  ],
  "stopping": [
    "VERB"
  ],
  "hypothesis": [
    "NOUN",
    "PROPN"
  ],
  "palmer": [
    "NOUN"
  ],
  "derby": [
    "NOUN"
  ],
  "peaceful": [
    "ADJ"
  ],
  "regression": [
    "NOUN",
    "PROPN"
  ],
  "doctrine": [
    "NOUN"
  ],
  "scenic": [
    "ADJ"
  ],
  "renewable": [
    "ADJ"
  ],
  "intersection": [
    "NOUN"
  ],
  "sewing": [
    "VERB"
  ],
  "consistency": [
    "NOUN",
    "PROPN"
  ],
  "conclude": [
    "VERB"
  ],
  "munich": [
    "PROPN"
  ],
  "propose": [
    "VERB",
    "PROPN"
  ],
  "lighter": [
    "ADJ"
  ],
  "astrology": [
    "NOUN"
  ],
  "pavilion": [
    "NOUN"
  ],
  "tactics": [
    "NOUN",
    "PROPN"
  ],
  "supplemental": [
    "ADJ"
  ],
  "talented": [
    "ADJ"
  ],
  "annie": [
    "PROPN"
  ],
  "pillow": [
    "NOUN"
  ],
  "induction": [
    "NOUN"
  ],
  "derek": [
    "PROPN"
  ],
  "precisely": [
    "ADV"
  ],
  "shorter": [
    "ADJ"
  ],
  "spreading": [
    "VERB"
  ],
  "paraguay": [
    "NOUN"
  ],
  "steal": [
    "VERB"
  ],
  "parcel": [
    "NOUN"
  ],
  "refined": [
    "VERB",
    "ADJ"
  ],
  "fifteen": [
    "NUM"
  ],
  "widespread": [
    "ADJ"
  ],
  "incidence": [
    "NOUN"
  ],
  "predict": [
    "VERB"
  ],
  "acrylic": [
    "NOUN"
  ],
  "rolled": [
    "VERB"
  ],
  "tuner": [
    "NOUN"
  ],
  "shannon": [
    "PROPN"
  ],
  "toddler": [
    "X"
  ],
  "flavor": [
    "NOUN"
  ],
  "alike": [
    "ADV"
  ],
  "homeless": [
    "ADJ"
  ],
  "horrible": [
    "ADJ"
  ],
  "hungry": [
    "ADJ"
  ],
  "metallic": [
    "ADJ"
  ],
  "blocked": [
    "VERB",
    "PROPN"
  ],
  "interference": [
    "VERB"
  ],
  "atmospheric": [
    "PROPN"
  ],
  "curtis": [
    "NOUN"
  ],
  "parental": [
    "ADJ"
  ],
  "lesser": [
    "ADJ"
  ],
  "publicity": [
    "NOUN"
  ],
  "marathon": [
    "VERB"
  ],
  "proposition": [
    "NOUN",
    "PROPN"
  ],
  "pressing": [
    "VERB"
  ],
  "gasoline": [
    "NOUN"
  ],
  "dressed": [
    "VERB"
  ],
  "scout": [
    "NOUN"
  ],
  "dealt": [
    "VERB"
  ],
  "niagara": [
    "PROPN"
  ],
  "warcraft": [
    "NOUN"
  ],
  "catalyst": [
    "PROPN",
    "NOUN"
  ],
  "trader": [
    "NOUN"
  ],
  "allowance": [
    "NOUN"
  ],
  "denial": [
    "NOUN"
  ],
  "designation": [
    "NOUN"
  ],
  "thrown": [
    "VERB"
  ],
  "duplicate": [
    "ADJ",
    "PROPN"
  ],
  "electro": [
    "PROPN"
  ],
  "criterion": [
    "NOUN"
  ],
  "badge": [
    "NOUN",
    "PROPN"
  ],
  "wrist": [
    "NOUN"
  ],
  "civilization": [
    "NOUN"
  ],
  "vietnamese": [
    "NOUN"
  ],
  "heath": [
    "NOUN"
  ],
  "tremendous": [
    "ADJ"
  ],
  "ballot": [
    "NOUN"
  ],
  "validity": [
    "NOUN"
  ],
  "trustee": [
    "NOUN"
  ],
  "weighted": [
    "VERB"
  ],
  "angola": [
    "NOUN"
  ],
  "squirt": [
    "VERB"
  ],
  "plastics": [
    "NOUN"
  ],
  "realm": [
    "NOUN",
    "PROPN"
  ],
  "corrected": [
    "VERB"
  ],
  "jenny": [
    "PROPN"
  ],
  "helmet": [
    "VERB"
  ],
  "elephant": [
    "NOUN"
  ],
  "yemen": [
    "PROPN"
  ],
  "tsunami": [
    "PROPN"
  ],
  "scholar": [
    "NOUN"
  ],
  "nickel": [
    "NOUN"
  ],
  "internationally": [
    "ADV"
  ],
  "surrounded": [
    "VERB"
  ],
  "geology": [
    "NOUN"
  ],
  "coating": [
    "VERB"
  ],
  "wallet": [
    "NOUN"
  ],
  "accomplish": [
    "VERB"
  ],
  "boating": [
    "VERB"
  ],
  "drainage": [
    "NOUN"
  ],
  "vegetarian": [
    "PROPN"
  ],
  "rouge": [
    "PROPN"
  ],
  "yeast": [
    "NOUN"
  ],
  "newfoundland": [
    "VERB"
  ],
  "clearing": [
    "VERB"
  ],
  "ambassador": [
    "NOUN"
  ],
  "coated": [
    "VERB"
  ],
  "intend": [
    "VERB"
  ],
  "stephanie": [
    "PROPN"
  ],
  "vegetation": [
    "NOUN"
  ],
  "louise": [
    "NOUN"
  ],
  "specially": [
    "ADV"
  ],
  "aquatic": [
    "ADJ"
  ],
  "reliance": [
    "NOUN"
  ],
  "striking": [
    "VERB"
  ],
  "infectious": [
    "ADJ"
  ],
  "singh": [
    "PROPN"
  ],
  "gilbert": [
    "VERB"
  ],
  "continuity": [
    "NOUN",
    "PROPN"
  ],
  "brook": [
    "PROPN"
  ],
  "phenomenon": [
    "NOUN"
  ],
  "ensemble": [
    "ADJ"
  ],
  "insulin": [
    "NOUN"
  ],
  "assured": [
    "VERB"
  ],
  "biblical": [
    "ADJ"
  ],
  "conscious": [
    "ADJ"
  ],
  "accent": [
    "NOUN"
  ],
  "eleven": [
    "NUM"
  ],
  "ambient": [
    "NOUN"
  ],
  "utilize": [
    "VERB",
    "PROPN"
  ],
  "mileage": [
    "NOUN"
  ],
  "prostate": [
    "NOUN"
  ],
  "adaptor": [
    "NOUN"
  ],
  "auburn": [
    "NOUN"
  ],
  "unlock": [
    "VERB",
    "PROPN"
  ],
  "pledge": [
    "VERB"
  ],
  "vampire": [
    "VERB"
  ],
  "angela": [
    "PROPN"
  ],
  "nitrogen": [
    "NOUN"
  ],
  "merger": [
    "NOUN"
  ],
  "softball": [
    "NOUN"
  ],
  "differently": [
    "ADV"
  ],
  "framing": [
    "NOUN",
    "VERB"
  ],
  "musician": [
    "NOUN"
  ],
  "blocking": [
    "VERB",
    "NOUN"
  ],
  "limiting": [
    "VERB",
    "NOUN"
  ],
  "dispatch": [
    "NOUN"
  ],
  "armor": [
    "NOUN"
  ],
  "remark": [
    "NOUN"
  ],
  "reasoning": [
    "NOUN",
    "PROPN"
  ],
  "charitable": [
    "ADJ"
  ],
  "convinced": [
    "VERB"
  ],
  "burlington": [
    "PROPN"
  ],
  "researcher": [
    "NOUN"
  ],
  "watershed": [
    "VERB"
  ],
  "acknowledged": [
    "VERB"
  ],
  "nudity": [
    "NOUN"
  ],
  "granny": [
    "NOUN"
  ],
  "equilibrium": [
    "NOUN"
  ],
  "viral": [
    "ADJ"
  ],
  "inquire": [
    "VERB"
  ],
  "laden": [
    "PROPN"
  ],
  "realtor": [
    "NOUN"
  ],
  "merge": [
    "VERB",
    "NOUN"
  ],
  "privilege": [
    "NOUN"
  ],
  "edgar": [
    "VERB"
  ],
  "chassis": [
    "NOUN"
  ],
  "estimation": [
    "NOUN",
    "PROPN"
  ],
  "pushing": [
    "VERB"
  ],
  "fleece": [
    "ADV"
  ],
  "pediatric": [
    "ADJ"
  ],
  "pierce": [
    "VERB"
  ],
  "allan": [
    "PROPN"
  ],
  "dressing": [
    "VERB"
  ],
  "craps": [
    "NOUN"
  ],
  "frost": [
    "NOUN"
  ],
  "sally": [
    "ADV"
  ],
  "yacht": [
    "NOUN"
  ],
  "tracy": [
    "NOUN"
  ],
  "drilling": [
    "VERB"
  ],
  "breach": [
    "NOUN",
    "PROPN"
  ],
  "whale": [
    "PROPN"
  ],
  "traveller": [
    "NOUN"
  ],
  "suspected": [
    "VERB"
  ],
  "bedford": [
    "NOUN"
  ],
  "stationery": [
    "NOUN"
  ],
  "mustang": [
    "PROPN"
  ],
  "unauthorized": [
    "ADJ"
  ],
  "antibody": [
    "NOUN"
  ],
  "competent": [
    "ADJ"
  ],
  "momentum": [
    "NOUN"
  ],
  "wiring": [
    "VERB"
  ],
  "pastor": [
    "NOUN"
  ],
  "calvin": [
    "NOUN"
  ],
  "shark": [
    "NOUN"
  ],
  "contributor": [
    "NOUN",
    "PROPN"
  ],
  "phases": [
    "NOUN"
  ],
  "grateful": [
    "ADJ"
  ],
  "emerald": [
    "PROPN"
  ],
  "gradually": [
    "ADV"
  ],
  "laughing": [
    "VERB"
  ],
  "cliff": [
    "PROPN"
  ],
  "desirable": [
    "ADJ"
  ],
  "tract": [
    "VERB"
  ],
  "ballet": [
    "VERB"
  ],
  "journalist": [
    "NOUN"
  ],
  "abraham": [
    "PROPN"
  ],
  "bumper": [
    "NOUN"
  ],
  "afterwards": [
    "ADV"
  ],
  "garlic": [
    "NOUN"
  ],
  "shine": [
    "VERB"
  ],
  "senegal": [
    "PROPN"
  ],
  "explosion": [
    "NOUN"
  ],
  "wendy": [
    "NOUN"
  ],
  "briefs": [
    "NOUN"
  ],
  "ozone": [
    "NOUN"
  ],
  "tariff": [
    "NOUN"
  ],
  "opponent": [
    "NOUN"
  ],
  "simplified": [
    "VERB",
    "ADJ"
  ],
  "serum": [
    "NOUN"
  ],
  "wrapped": [
    "VERB"
  ],
  "swift": [
    "PROPN",
    "ADJ"
  ],
  "focal": [
    "ADJ"
  ],
  "bibliographic": [
    "ADJ"
  ],
  "distant": [
    "ADJ"
  ],
  "champagne": [
    "NOUN"
  ],
  "decimal": [
    "PROPN"
  ],
  "deviation": [
    "NOUN"
  ],
  "superintendent": [
    "NOUN"
  ],
  "samba": [
    "NOUN"
  ],
  "hostel": [
    "NOUN"
  ],
  "employ": [
    "VERB"
  ],
  "penguin": [
    "NOUN"
  ],
  "magical": [
    "ADJ"
  ],
  "irrigation": [
    "NOUN"
  ],
  "miracle": [
    "NOUN"
  ],
  "manually": [
    "PROPN"
  ],
  "reprint": [
    "VERB"
  ],
  "hydraulic": [
    "ADJ"
  ],
  "centered": [
    "VERB"
  ],
  "yearly": [
    "ADJ",
    "PROPN"
  ],
  "wound": [
    "VERB"
  ],
  "belle": [
    "PROPN"
  ],
  "conviction": [
    "NOUN"
  ],
  "retrieval": [
    "NOUN",
    "PROPN"
  ],
  "cindy": [
    "VERB"
  ],
  "charging": [
    "VERB"
  ],
  "marvel": [
    "VERB"
  ],
  "lined": [
    "VERB"
  ],
  "prototype": [
    "NOUN",
    "PROPN"
  ],
  "importantly": [
    "ADV"
  ],
  "petite": [
    "VERB"
  ],
  "apparatus": [
    "NOUN"
  ],
  "terrain": [
    "NOUN"
  ],
  "explaining": [
    "VERB"
  ],
  "gossip": [
    "NOUN"
  ],
  "nomination": [
    "NOUN"
  ],
  "empirical": [
    "ADJ"
  ],
  "rotary": [
    "NOUN"
  ],
  "dependence": [
    "NOUN"
  ],
  "discrete": [
    "ADJ"
  ],
  "beginner": [
    "NOUN"
  ],
  "sexuality": [
    "NOUN"
  ],
  "polyester": [
    "NOUN"
  ],
  "cubic": [
    "ADJ"
  ],
  "suggesting": [
    "VERB"
  ],
  "sapphire": [
    "NOUN"
  ],
  "kinase": [
    "NOUN"
  ],
  "remainder": [
    "NOUN"
  ],
  "marking": [
    "VERB"
  ],
  "sheriff": [
    "PROPN"
  ],
  "griffin": [
    "NOUN"
  ],
  "declined": [
    "VERB",
    "PROPN"
  ],
  "neighbor": [
    "NOUN"
  ],
  "elect": [
    "VERB"
  ],
  "concentrate": [
    "VERB"
  ],
  "intimate": [
    "VERB"
  ],
  "reproductive": [
    "PROPN"
  ],
  "deadly": [
    "ADJ"
  ],
  "bunny": [
    "NOUN"
  ],
  "chevy": [
    "NOUN"
  ],
  "refrigerator": [
    "NOUN"
  ],
  "exclusion": [
    "NOUN",
    "PROPN"
  ],
  "holocaust": [
    "ADV"
  ],
  "flyer": [
    "PROPN"
  ],
  "dosage": [
    "NOUN"
  ],
  "disposition": [
    "NOUN"
  ],
  "variance": [
    "NOUN"
  ],
  "navigator": [
    "NOUN",
    "PROPN"
  ],
  "baking": [
    "VERB"
  ],
  "marijuana": [
    "PROPN"
  ],
  "adaptive": [
    "ADJ"
  ],
  "needle": [
    "NOUN"
  ],
  "cathedral": [
    "NOUN"
  ],
  "nirvana": [
    "PROPN"
  ],
  "sticky": [
    "ADJ",
    "PROPN"
  ],
  "destiny": [
    "NOUN"
  ],
  "generous": [
    "ADJ"
  ],
  "madness": [
    "NOUN"
  ],
  "climb": [
    "VERB"
  ],
  "blowing": [
    "VERB"
  ],
  "fascinating": [
    "ADJ"
  ],
  "lafayette": [
    "NOUN"
  ],
  "computation": [
    "NOUN"
  ],
  "cardiovascular": [
    "ADJ"
  ],
  "cardiac": [
    "ADJ"
  ],
  "salvation": [
    "NOUN"
  ],
  "dover": [
    "PROPN"
  ],
  "adrian": [
    "PROPN"
  ],
  "vatican": [
    "PROPN"
  ],
  "brutal": [
    "NOUN"
  ],
  "selective": [
    "ADJ",
    "PROPN"
  ],
  "arbitration": [
    "NOUN"
  ],
  "token": [
    "VERB",
    "NOUN"
  ],
  "sacrifice": [
    "NOUN"
  ],
  "removable": [
    "PROPN"
  ],
  "convergence": [
    "NOUN"
  ],
  "gibraltar": [
    "NOUN"
  ],
  "anthropology": [
    "NOUN"
  ],
  "skating": [
    "VERB"
  ],
  "aberdeen": [
    "VERB"
  ],
  "emperor": [
    "NOUN",
    "PROPN"
  ],
  "malpractice": [
    "NOUN"
  ],
  "dylan": [
    "PROPN"
  ],
  "educated": [
    "VERB"
  ],
  "burke": [
    "PROPN"
  ],
  "proudly": [
    "ADV"
  ],
  "necessity": [
    "NOUN"
  ],
  "rendering": [
    "VERB",
    "NOUN"
  ],
  "inserted": [
    "VERB"
  ],
  "obesity": [
    "NOUN"
  ],
  "suburban": [
    "ADJ"
  ],
  "touring": [
    "VERB"
  ],
  "clara": [
    "VERB"
  ],
  "vertex": [
    "NOUN"
  ],
  "hepatitis": [
    "NOUN"
  ],
  "nationally": [
    "ADV"
  ],
  "tomato": [
    "PROPN"
  ],
  "waterproof": [
    "PROPN"
  ],
  "flush": [
    "ADJ"
  ],
  "waiver": [
    "VERB"
  ],
  "humanitarian": [
    "ADJ"
  ],
  "delight": [
    "PROPN",
    "NOUN"
  ],
  "survivor": [
    "VERB"
  ],
  "cingular": [
    "ADJ"
  ],
  "bacterial": [
    "ADJ"
  ],
  "moses": [
    "PROPN"
  ],
  "undertake": [
    "VERB"
  ],
  "declare": [
    "VERB"
  ],
  "continuously": [
    "ADV"
  ],
  "jewel": [
    "PROPN"
  ],
  "teddy": [
    "PROPN"
  ],
  "convertible": [
    "ADJ"
  ],
  "stranger": [
    "NOUN"
  ],
  "tragedy": [
    "NOUN"
  ],
  "julian": [
    "PROPN"
  ],
  "painful": [
    "ADJ"
  ],
  "velvet": [
    "NOUN"
  ],
  "tribunal": [
    "NOUN"
  ],
  "funky": [
    "ADJ"
  ],
  "secretariat": [
    "PROPN"
  ],
  "nowhere": [
    "ADV"
  ],
  "adolescent": [
    "ADJ"
  ],
  "lately": [
    "ADV"
  ],
  "scary": [
    "ADJ"
  ],
  "mattress": [
    "NOUN"
  ],
  "likewise": [
    "ADV"
  ],
  "banana": [
    "PROPN"
  ],
  "introductory": [
    "ADJ"
  ],
  "slovak": [
    "PROPN"
  ],
  "reservoir": [
    "PROPN"
  ],
  "occurrence": [
    "NOUN"
  ],
  "bloody": [
    "ADJ"
  ],
  "mixer": [
    "NOUN"
  ],
  "remind": [
    "VERB"
  ],
  "worcester": [
    "ADJ"
  ],
  "demographic": [
    "ADJ"
  ],
  "charming": [
    "PROPN"
  ],
  "tooth": [
    "VERB"
  ],
  "disciplinary": [
    "ADJ"
  ],
  "annoying": [
    "ADJ"
  ],
  "stays": [
    "VERB"
  ],
  "disclose": [
    "VERB"
  ],
  "affair": [
    "PROPN"
  ],
  "drove": [
    "VERB"
  ],
  "washer": [
    "NOUN"
  ],
  "upset": [
    "ADJ"
  ],
  "restrict": [
    "VERB",
    "PROPN"
  ],
  "springer": [
    "PROPN"
  ],
  "beside": [
    "ADP"
  ],
  "mines": [
    "NOUN"
  ],
  "rebound": [
    "VERB"
  ],
  "mentor": [
    "NOUN",
    "PROPN"
  ],
  "fought": [
    "VERB"
  ],
  "elimination": [
    "NOUN"
  ],
  "hypothetical": [
    "ADJ"
  ],
  "complimentary": [
    "ADJ"
  ],
  "helicopter": [
    "NOUN"
  ],
  "pencil": [
    "NOUN"
  ],
  "freeze": [
    "NOUN",
    "VERB"
  ],
  "performer": [
    "NOUN"
  ],
  "titled": [
    "VERB"
  ],
  "sphere": [
    "ADV"
  ],
  "concord": [
    "NOUN"
  ],
  "graduated": [
    "VERB"
  ],
  "endorsed": [
    "VERB"
  ],
  "surprising": [
    "ADJ"
  ],
  "walnut": [
    "PROPN"
  ],
  "lance": [
    "NOUN"
  ],
  "ladder": [
    "VERB",
    "NOUN"
  ],
  "unnecessary": [
    "ADJ"
  ],
  "dramatically": [
    "ADV"
  ],
  "liberia": [
    "PROPN"
  ],
  "sherman": [
    "NOUN"
  ],
  "maximize": [
    "VERB"
  ],
  "workout": [
    "NOUN"
  ],
  "bleeding": [
    "VERB"
  ],
  "characterization": [
    "NOUN"
  ],
  "colon": [
    "NOUN"
  ],
  "likelihood": [
    "NOUN",
    "PROPN"
  ],
  "purse": [
    "NOUN"
  ],
  "contamination": [
    "NOUN"
  ],
  "compromise": [
    "NOUN",
    "VERB"
  ],
  "optimize": [
    "VERB",
    "PROPN"
  ],
  "caroline": [
    "NOUN"
  ],
  "expiration": [
    "NOUN",
    "PROPN"
  ],
  "align": [
    "PROPN",
    "VERB"
  ],
  "peripheral": [
    "ADJ"
  ],
  "bless": [
    "VERB"
  ],
  "engaging": [
    "VERB",
    "ADJ"
  ],
  "negotiation": [
    "NOUN"
  ],
  "crest": [
    "PROPN"
  ],
  "triumph": [
    "NOUN"
  ],
  "nominated": [
    "VERB"
  ],
  "confidentiality": [
    "NOUN"
  ],
  "electoral": [
    "ADJ"
  ],
  "welding": [
    "VERB"
  ],
  "deferred": [
    "PROPN",
    "VERB"
  ],
  "alternatively": [
    "ADV"
  ],
  "alloy": [
    "NOUN"
  ],
  "polished": [
    "ADJ"
  ],
  "gently": [
    "ADV"
  ],
  "locking": [
    "VERB"
  ],
  "casey": [
    "NOUN"
  ],
  "controversial": [
    "ADJ"
  ],
  "blanket": [
    "NOUN"
  ],
  "bloom": [
    "NOUN"
  ],
  "elliott": [
    "PROPN"
  ],
  "justify": [
    "VERB"
  ],
  "surge": [
    "NOUN"
  ],
  "trauma": [
    "VERB"
  ],
  "advert": [
    "NOUN"
  ],
  "possess": [
    "VERB"
  ],
  "demanding": [
    "VERB"
  ],
  "defensive": [
    "ADJ"
  ],
  "forbidden": [
    "VERB"
  ],
  "vanilla": [
    "NOUN"
  ],
  "picnic": [
    "NOUN"
  ],
  "spank": [
    "VERB"
  ],
  "practitioner": [
    "NOUN"
  ],
  "smithsonian": [
    "PROPN"
  ],
  "hollow": [
    "VERB"
  ],
  "vault": [
    "PROPN",
    "NOUN"
  ],
  "securely": [
    "ADV"
  ],
  "examining": [
    "VERB"
  ],
  "groove": [
    "NOUN"
  ],
  "revelation": [
    "NOUN"
  ],
  "pursuit": [
    "NOUN"
  ],
  "delegation": [
    "NOUN"
  ],
  "backing": [
    "NOUN",
    "VERB"
  ],
  "greenhouse": [
    "NOUN"
  ],
  "blake": [
    "PROPN"
  ],
  "transparency": [
    "NOUN",
    "PROPN"
  ],
  "travis": [
    "PROPN"
  ],
  "endless": [
    "ADJ"
  ],
  "figured": [
    "VERB"
  ],
  "orbit": [
    "NOUN"
  ],
  "bacon": [
    "NOUN"
  ],
  "heater": [
    "NOUN"
  ],
  "colony": [
    "NOUN"
  ],
  "cannon": [
    "NOUN"
  ],
  "circus": [
    "NOUN"
  ],
  "descending": [
    "VERB"
  ],
  "spine": [
    "VERB"
  ],
  "trout": [
    "NOUN"
  ],
  "temporarily": [
    "ADV"
  ],
  "thriller": [
    "NOUN"
  ],
  "transmit": [
    "VERB"
  ],
  "fatty": [
    "PROPN"
  ],
  "gerald": [
    "PROPN"
  ],
  "hunger": [
    "NOUN"
  ],
  "municipality": [
    "NOUN"
  ],
  "joyce": [
    "PROPN"
  ],
  "detective": [
    "NOUN"
  ],
  "surgeon": [
    "VERB"
  ],
  "cement": [
    "NOUN"
  ],
  "fireplace": [
    "NOUN"
  ],
  "endorsement": [
    "NOUN"
  ],
  "missile": [
    "NOUN"
  ],
  "psychiatry": [
    "NOUN"
  ],
  "persistent": [
    "PROPN",
    "ADJ"
  ],
  "deborah": [
    "PROPN"
  ],
  "marco": [
    "PROPN"
  ],
  "gabriel": [
    "PROPN"
  ],
  "auditor": [
    "NOUN",
    "PROPN"
  ],
  "aquarium": [
    "NOUN"
  ],
  "violin": [
    "NOUN"
  ],
  "prophet": [
    "NOUN"
  ],
  "bracket": [
    "NOUN"
  ],
  "isaac": [
    "PROPN"
  ],
  "oxide": [
    "NOUN"
  ],
  "magnificent": [
    "VERB"
  ],
  "colleague": [
    "NOUN"
  ],
  "promptly": [
    "ADV"
  ],
  "adaptation": [
    "NOUN"
  ],
  "harmful": [
    "ADJ"
  ],
  "sexually": [
    "ADV"
  ],
  "enclosure": [
    "NOUN"
  ],
  "dividend": [
    "VERB"
  ],
  "glucose": [
    "NOUN"
  ],
  "phantom": [
    "NOUN"
  ],
  "playback": [
    "NOUN"
  ],
  "turtle": [
    "NOUN"
  ],
  "absorption": [
    "NOUN"
  ],
  "neural": [
    "ADJ"
  ],
  "fossil": [
    "NOUN"
  ],
  "badly": [
    "ADV"
  ],
  "apollo": [
    "PROPN"
  ],
  "disappointed": [
    "VERB"
  ],
  "persian": [
    "PROPN"
  ],
  "continually": [
    "ADV"
  ],
  "communist": [
    "NOUN"
  ],
  "collectible": [
    "ADJ"
  ],
  "handmade": [
    "VERB"
  ],
  "scoop": [
    "VERB"
  ],
  "earning": [
    "VERB"
  ],
  "mailman": [
    "NOUN"
  ],
  "excitement": [
    "NOUN"
  ],
  "verbal": [
    "ADJ"
  ],
  "blink": [
    "NOUN"
  ],
  "presently": [
    "ADV"
  ],
  "carlo": [
    "PROPN"
  ],
  "mysterious": [
    "ADJ"
  ],
  "novelty": [
    "NOUN"
  ],
  "librarian": [
    "PROPN"
  ],
  "switched": [
    "VERB"
  ],
  "tamil": [
    "PROPN"
  ],
  "fuzzy": [
    "ADJ"
  ],
  "indonesian": [
    "PROPN"
  ],
  "therapist": [
    "NOUN"
  ],
  "promising": [
    "ADJ",
    "VERB"
  ],
  "relaxation": [
    "NOUN"
  ],
  "render": [
    "VERB",
    "NOUN"
  ],
  "carmen": [
    "NOUN"
  ],
  "thereafter": [
    "ADV"
  ],
  "hardwood": [
    "NOUN"
  ],
  "erotica": [
    "PROPN"
  ],
  "temporal": [
    "ADJ"
  ],
  "forge": [
    "PROPN",
    "NOUN"
  ],
  "dense": [
    "ADJ"
  ],
  "brave": [
    "ADJ"
  ],
  "forwarding": [
    "VERB",
    "NOUN"
  ],
  "awful": [
    "ADJ"
  ],
  "nightmare": [
    "VERB"
  ],
  "airplane": [
    "NOUN"
  ],
  "impose": [
    "VERB"
  ],
  "telescope": [
    "NOUN"
  ],
  "asbestos": [
    "NOUN"
  ],
  "savage": [
    "VERB"
  ],
  "advancement": [
    "NOUN"
  ],
  "harassment": [
    "NOUN"
  ],
  "willow": [
    "VERB"
  ],
  "throwing": [
    "VERB"
  ],
  "wagon": [
    "PROPN"
  ],
  "knock": [
    "VERB"
  ],
  "potatoes": [
    "NOUN"
  ],
  "thorough": [
    "ADJ"
  ],
  "replication": [
    "NOUN",
    "PROPN"
  ],
  "inexpensive": [
    "ADJ"
  ],
  "roland": [
    "VERB"
  ],
  "optimum": [
    "ADJ"
  ],
  "quilt": [
    "NOUN"
  ],
  "creature": [
    "NOUN"
  ],
  "internship": [
    "NOUN",
    "PROPN"
  ],
  "refresh": [
    "PROPN",
    "ADJ"
  ],
  "aluminium": [
    "NOUN"
  ],
  "michel": [
    "PROPN"
  ],
  "evanescence": [
    "NOUN"
  ],
  "subtle": [
    "ADJ"
  ],
  "antarctica": [
    "PROPN"
  ],
  "shepherd": [
    "PROPN"
  ],
  "canberra": [
    "PROPN"
  ],
  "cradle": [
    "NOUN"
  ],
  "chancellor": [
    "PROPN"
  ],
  "mambo": [
    "NOUN"
  ],
  "flour": [
    "NOUN"
  ],
  "controversy": [
    "NOUN"
  ],
  "legendary": [
    "ADJ"
  ],
  "sympathy": [
    "NOUN"
  ],
  "choir": [
    "VERB"
  ],
  "beautifully": [
    "ADV"
  ],
  "polymer": [
    "NOUN"
  ],
  "hygiene": [
    "NOUN"
  ],
  "poultry": [
    "NOUN"
  ],
  "virtue": [
    "NOUN"
  ],
  "burst": [
    "NOUN"
  ],
  "bouquet": [
    "NOUN"
  ],
  "immunology": [
    "NOUN"
  ],
  "mandate": [
    "NOUN",
    "VERB"
  ],
  "departmental": [
    "ADJ"
  ],
  "corpus": [
    "PROPN"
  ],
  "terminology": [
    "NOUN",
    "PROPN"
  ],
  "gentleman": [
    "NOUN"
  ],
  "reproduce": [
    "VERB"
  ],
  "indices": [
    "NOUN"
  ],
  "threatening": [
    "VERB"
  ],
  "spokesman": [
    "NOUN"
  ],
  "prisoner": [
    "NOUN"
  ],
  "daisy": [
    "PROPN"
  ],
  "cursor": [
    "NOUN",
    "PROPN"
  ],
  "donated": [
    "VERB"
  ],
  "stuffed": [
    "VERB"
  ],
  "crude": [
    "NOUN"
  ],
  "maiden": [
    "VERB"
  ],
  "sufficiently": [
    "ADV"
  ],
  "viking": [
    "VERB"
  ],
  "myrtle": [
    "NOUN"
  ],
  "cleanup": [
    "NOUN",
    "PROPN"
  ],
  "conditional": [
    "ADJ",
    "PROPN"
  ],
  "crossword": [
    "PROPN"
  ],
  "bother": [
    "VERB"
  ],
  "conceptual": [
    "ADJ"
  ],
  "knitting": [
    "NOUN"
  ],
  "mating": [
    "VERB"
  ],
  "compute": [
    "PROPN",
    "NOUN"
  ],
  "redhead": [
    "VERB"
  ],
  "translator": [
    "NOUN"
  ],
  "tractor": [
    "NOUN"
  ],
  "allah": [
    "PROPN"
  ],
  "continent": [
    "NOUN"
  ],
  "unwrap": [
    "NOUN"
  ],
  "longitude": [
    "VERB"
  ],
  "resist": [
    "VERB"
  ],
  "hoped": [
    "VERB"
  ],
  "insertion": [
    "NOUN"
  ],
  "instrumentation": [
    "NOUN",
    "PROPN"
  ],
  "constraint": [
    "NOUN"
  ],
  "touched": [
    "VERB"
  ],
  "strengthening": [
    "VERB"
  ],
  "cologne": [
    "NOUN"
  ],
  "wishing": [
    "VERB"
  ],
  "ranger": [
    "NOUN"
  ],
  "insulation": [
    "NOUN"
  ],
  "marsh": [
    "PROPN"
  ],
  "ricky": [
    "ADJ"
  ],
  "theta": [
    "NOUN"
  ],
  "infringement": [
    "NOUN"
  ],
  "subjective": [
    "ADJ"
  ],
  "asylum": [
    "NOUN"
  ],
  "stake": [
    "NOUN"
  ],
  "cocktail": [
    "NOUN"
  ],
  "swaziland": [
    "NOUN"
  ],
  "arbor": [
    "NOUN"
  ],
  "poison": [
    "NOUN"
  ],
  "dominated": [
    "VERB"
  ],
  "costly": [
    "ADJ"
  ],
  "stitch": [
    "VERB"
  ],
  "rifle": [
    "NOUN"
  ],
  "severity": [
    "NOUN",
    "PROPN"
  ],
  "notable": [
    "ADJ",
    "PROPN"
  ],
  "warfare": [
    "NOUN"
  ],
  "judiciary": [
    "NOUN"
  ],
  "embroidery": [
    "NOUN"
  ],
  "inland": [
    "ADV"
  ],
  "nonfiction": [
    "NOUN"
  ],
  "racism": [
    "NOUN"
  ],
  "greenland": [
    "PROPN"
  ],
  "interpret": [
    "VERB"
  ],
  "accord": [
    "NOUN"
  ],
  "modest": [
    "ADJ"
  ],
  "licensee": [
    "VERB"
  ],
  "countryside": [
    "NOUN"
  ],
  "liaison": [
    "NOUN"
  ],
  "bisexual": [
    "PROPN"
  ],
  "unused": [
    "ADJ"
  ],
  "consuming": [
    "VERB",
    "NOUN"
  ],
  "installer": [
    "NOUN"
  ],
  "insure": [
    "VERB"
  ],
  "clarify": [
    "VERB",
    "PROPN"
  ],
  "activate": [
    "VERB",
    "NOUN"
  ],
  "waist": [
    "NOUN"
  ],
  "fatigue": [
    "NOUN"
  ],
  "patriot": [
    "NOUN"
  ],
  "sewer": [
    "NOUN"
  ],
  "kathleen": [
    "VERB"
  ],
  "bosch": [
    "PROPN"
  ],
  "forthcoming": [
    "ADJ"
  ],
  "detention": [
    "NOUN"
  ],
  "complementary": [
    "ADJ"
  ],
  "gallon": [
    "NOUN"
  ],
  "bitter": [
    "ADJ"
  ],
  "memorandum": [
    "VERB"
  ],
  "burned": [
    "VERB"
  ],
  "cardinal": [
    "PROPN"
  ],
  "converting": [
    "VERB"
  ],
  "romeo": [
    "NOUN"
  ],
  "incredibly": [
    "ADV"
  ],
  "demos": [
    "PROPN",
    "NOUN"
  ],
  "balancing": [
    "VERB",
    "NOUN"
  ],
  "sided": [
    "VERB"
  ],
  "psychiatric": [
    "ADJ"
  ],
  "courtyard": [
    "NOUN"
  ],
  "depart": [
    "VERB"
  ],
  "grading": [
    "VERB"
  ],
  "cuban": [
    "ADJ"
  ],
  "expressly": [
    "ADV"
  ],
  "distinctive": [
    "ADJ"
  ],
  "unofficial": [
    "ADJ"
  ],
  "oversight": [
    "NOUN"
  ],
  "privately": [
    "ADV"
  ],
  "minded": [
    "ADJ"
  ],
  "resin": [
    "NOUN"
  ],
  "allies": [
    "NOUN"
  ],
  "twilight": [
    "NOUN"
  ],
  "crossed": [
    "VERB"
  ],
  "kensington": [
    "PROPN"
  ],
  "monterey": [
    "NOUN"
  ],
  "linen": [
    "NOUN"
  ],
  "ascending": [
    "VERB"
  ],
  "nominal": [
    "PROPN"
  ],
  "alicia": [
    "PROPN"
  ],
  "decay": [
    "VERB"
  ],
  "underwater": [
    "ADJ"
  ],
  "quartz": [
    "NOUN"
  ],
  "eighth": [
    "ADJ"
  ],
  "usher": [
    "ADJ"
  ],
  "herbert": [
    "PROPN"
  ],
  "phenomena": [
    "NOUN"
  ],
  "buffet": [
    "PROPN"
  ],
  "skate": [
    "VERB"
  ],
  "supportive": [
    "ADJ"
  ],
  "granite": [
    "NOUN"
  ],
  "repeatedly": [
    "ADV"
  ],
  "lynch": [
    "PROPN"
  ],
  "athlete": [
    "NOUN"
  ],
  "franc": [
    "NOUN"
  ],
  "enforce": [
    "PROPN",
    "VERB"
  ],
  "preschool": [
    "VERB"
  ],
  "similarity": [
    "NOUN"
  ],
  "landlord": [
    "NOUN"
  ],
  "timor": [
    "NOUN"
  ],
  "assorted": [
    "VERB"
  ],
  "adviser": [
    "NOUN"
  ],
  "compelling": [
    "ADJ"
  ],
  "booklet": [
    "PROPN"
  ],
  "voter": [
    "NOUN"
  ],
  "reimbursement": [
    "NOUN"
  ],
  "turnover": [
    "NOUN"
  ],
  "capri": [
    "NOUN"
  ],
  "towel": [
    "VERB"
  ],
  "ginger": [
    "NOUN"
  ],
  "imagery": [
    "NOUN"
  ],
  "chromosome": [
    "VERB"
  ],
  "competence": [
    "NOUN"
  ],
  "colorful": [
    "ADJ"
  ],
  "inadequate": [
    "ADJ"
  ],
  "crying": [
    "VERB"
  ],
  "crane": [
    "NOUN"
  ],
  "considerably": [
    "ADV"
  ],
  "investigating": [
    "VERB"
  ],
  "rotten": [
    "ADJ"
  ],
  "garnet": [
    "NOUN"
  ],
  "habit": [
    "NOUN"
  ],
  "scattered": [
    "VERB"
  ],
  "useless": [
    "ADJ"
  ],
  "northwestern": [
    "ADJ"
  ],
  "coupe": [
    "PROPN"
  ],
  "benin": [
    "NOUN"
  ],
  "erosion": [
    "NOUN"
  ],
  "abundance": [
    "NOUN"
  ],
  "carpenter": [
    "NOUN"
  ],
  "insufficient": [
    "ADJ",
    "PROPN"
  ],
  "fertility": [
    "NOUN"
  ],
  "formulation": [
    "NOUN"
  ],
  "clever": [
    "ADJ"
  ],
  "primer": [
    "NOUN"
  ],
  "fresno": [
    "NOUN"
  ],
  "enjoyable": [
    "ADJ"
  ],
  "handbag": [
    "PROPN"
  ],
  "crescent": [
    "NOUN"
  ],
  "bypass": [
    "VERB",
    "NOUN"
  ],
  "freshman": [
    "NOUN"
  ],
  "playground": [
    "NOUN",
    "PROPN"
  ],
  "negotiate": [
    "VERB"
  ],
  "sixty": [
    "NUM"
  ],
  "exploit": [
    "VERB"
  ],
  "permanently": [
    "ADV"
  ],
  "concentrated": [
    "VERB"
  ],
  "distinguish": [
    "VERB"
  ],
  "spark": [
    "NOUN",
    "PROPN"
  ],
  "illustrate": [
    "VERB"
  ],
  "patience": [
    "NOUN"
  ],
  "pathway": [
    "NOUN"
  ],
  "shallow": [
    "VERB"
  ],
  "spike": [
    "NOUN",
    "PROPN"
  ],
  "plated": [
    "VERB"
  ],
  "jacques": [
    "VERB"
  ],
  "drawer": [
    "NOUN"
  ],
  "ingredient": [
    "NOUN"
  ],
  "spectra": [
    "PROPN"
  ],
  "lifting": [
    "NOUN"
  ],
  "judith": [
    "PROPN"
  ],
  "curtain": [
    "NOUN"
  ],
  "disclosed": [
    "VERB"
  ],
  "tactical": [
    "ADJ"
  ],
  "mailbox": [
    "NOUN"
  ],
  "expedition": [
    "NOUN"
  ],
  "operative": [
    "NOUN"
  ],
  "humour": [
    "NOUN"
  ],
  "maturity": [
    "NOUN",
    "PROPN"
  ],
  "caller": [
    "NOUN"
  ],
  "distortion": [
    "NOUN"
  ],
  "prosecution": [
    "NOUN"
  ],
  "tonga": [
    "ADV"
  ],
  "imprint": [
    "VERB"
  ],
  "natalie": [
    "PROPN"
  ],
  "receipts": [
    "NOUN"
  ],
  "shirley": [
    "NOUN"
  ],
  "viable": [
    "ADJ"
  ],
  "defect": [
    "PROPN"
  ],
  "poorly": [
    "ADV"
  ],
  "goddess": [
    "NOUN"
  ],
  "spacious": [
    "ADJ"
  ],
  "chapman": [
    "NOUN"
  ],
  "loyalty": [
    "NOUN",
    "PROPN"
  ],
  "beloved": [
    "VERB"
  ],
  "sometime": [
    "ADV"
  ],
  "beating": [
    "VERB"
  ],
  "faithful": [
    "ADJ"
  ],
  "hunks": [
    "VERB"
  ],
  "appellant": [
    "NOUN"
  ],
  "whatsoever": [
    "ADV"
  ],
  "lithium": [
    "PROPN",
    "NOUN"
  ],
  "sedan": [
    "NOUN"
  ],
  "founding": [
    "VERB"
  ],
  "planting": [
    "VERB"
  ],
  "alphabetically": [
    "ADV"
  ],
  "covenant": [
    "NOUN"
  ],
  "dropping": [
    "VERB"
  ],
  "archaeology": [
    "NOUN"
  ],
  "refill": [
    "NOUN"
  ],
  "sailor": [
    "PROPN"
  ],
  "lining": [
    "VERB"
  ],
  "banquet": [
    "NOUN"
  ],
  "sanctuary": [
    "ADJ"
  ],
  "flora": [
    "PROPN"
  ],
  "statue": [
    "NOUN"
  ],
  "hilary": [
    "VERB"
  ],
  "quotation": [
    "NOUN"
  ],
  "hardy": [
    "ADJ"
  ],
  "jumper": [
    "PROPN"
  ],
  "caravan": [
    "PROPN"
  ],
  "harness": [
    "VERB"
  ],
  "manipulation": [
    "NOUN"
  ],
  "vascular": [
    "ADJ"
  ],
  "alongside": [
    "ADP"
  ],
  "toxicity": [
    "NOUN"
  ],
  "transmitter": [
    "PROPN"
  ],
  "dorothy": [
    "ADJ"
  ],
  "freeman": [
    "PROPN"
  ],
  "denim": [
    "PROPN"
  ],
  "andre": [
    "PROPN"
  ],
  "trophy": [
    "NOUN"
  ],
  "emotion": [
    "NOUN"
  ],
  "slipknot": [
    "VERB"
  ],
  "residual": [
    "ADJ"
  ],
  "asterisk": [
    "NOUN"
  ],
  "versatile": [
    "ADJ"
  ],
  "liquor": [
    "NOUN"
  ],
  "kindergarten": [
    "NOUN"
  ],
  "profitable": [
    "ADJ"
  ],
  "wounded": [
    "VERB"
  ],
  "clayton": [
    "PROPN"
  ],
  "derivative": [
    "ADJ"
  ],
  "suffolk": [
    "NOUN"
  ],
  "occupancy": [
    "NOUN"
  ],
  "postgraduate": [
    "NOUN"
  ],
  "educate": [
    "VERB",
    "PROPN"
  ],
  "baked": [
    "VERB"
  ],
  "glove": [
    "VERB"
  ],
  "prejudice": [
    "NOUN"
  ],
  "constructor": [
    "NOUN"
  ],
  "debbie": [
    "PROPN"
  ],
  "probable": [
    "ADJ"
  ],
  "issuance": [
    "NOUN"
  ],
  "baldwin": [
    "VERB"
  ],
  "incorporation": [
    "NOUN"
  ],
  "evolutionary": [
    "ADJ"
  ],
  "decoration": [
    "NOUN"
  ],
  "trojan": [
    "PROPN"
  ],
  "counselor": [
    "NOUN"
  ],
  "spinal": [
    "NOUN"
  ],
  "sooner": [
    "ADV"
  ],
  "struggling": [
    "VERB"
  ],
  "waterfront": [
    "NOUN"
  ],
  "tenure": [
    "NOUN",
    "PROPN"
  ],
  "plush": [
    "VERB"
  ],
  "weber": [
    "PROPN"
  ],
  "unstable": [
    "ADJ"
  ],
  "woodland": [
    "PROPN"
  ],
  "iranian": [
    "PROPN"
  ],
  "nelly": [
    "ADV"
  ],
  "fulfill": [
    "VERB"
  ],
  "reflecting": [
    "VERB"
  ],
  "unsecured": [
    "ADJ"
  ],
  "brent": [
    "NOUN"
  ],
  "gaining": [
    "VERB"
  ],
  "definitive": [
    "ADJ"
  ],
  "appropriately": [
    "ADV"
  ],
  "inactive": [
    "ADJ",
    "PROPN"
  ],
  "traveled": [
    "VERB"
  ],
  "adapt": [
    "VERB"
  ],
  "extracted": [
    "VERB"
  ],
  "accession": [
    "NOUN"
  ],
  "regulator": [
    "NOUN"
  ],
  "carriage": [
    "VERB"
  ],
  "therein": [
    "ADV"
  ],
  "terminate": [
    "VERB"
  ],
  "traditionally": [
    "ADV"
  ],
  "withdraw": [
    "VERB"
  ],
  "brett": [
    "PROPN"
  ],
  "anchorage": [
    "NOUN"
  ],
  "paula": [
    "PROPN"
  ],
  "landmark": [
    "PROPN"
  ],
  "naming": [
    "NOUN",
    "VERB"
  ],
  "stern": [
    "ADJ"
  ],
  "shawn": [
    "NOUN"
  ],
  "lacrosse": [
    "X"
  ],
  "dentist": [
    "NOUN"
  ],
  "tutor": [
    "NOUN"
  ],
  "idiot": [
    "NOUN"
  ],
  "comprised": [
    "VERB"
  ],
  "mickey": [
    "NOUN"
  ],
  "debit": [
    "NOUN"
  ],
  "sebastian": [
    "PROPN"
  ],
  "domino": [
    "NOUN"
  ],
  "unwanted": [
    "ADJ"
  ],
  "raven": [
    "VERB"
  ],
  "dwelling": [
    "VERB"
  ],
  "slice": [
    "NOUN",
    "VERB"
  ],
  "tanning": [
    "VERB"
  ],
  "gambia": [
    "PROPN"
  ],
  "aspen": [
    "VERB"
  ],
  "symbolic": [
    "ADJ"
  ],
  "objectionable": [
    "ADJ"
  ],
  "angles": [
    "NOUN"
  ],
  "lemma": [
    "PROPN"
  ],
  "mediation": [
    "NOUN"
  ],
  "venus": [
    "PROPN"
  ],
  "primitive": [
    "ADJ"
  ],
  "stocking": [
    "VERB"
  ],
  "ecosystem": [
    "PROPN",
    "NOUN"
  ],
  "dashboard": [
    "NOUN",
    "PROPN"
  ],
  "malcolm": [
    "PROPN"
  ],
  "pause": [
    "VERB",
    "NOUN"
  ],
  "simplicity": [
    "NOUN"
  ],
  "postscript": [
    "NOUN"
  ],
  "relaxed": [
    "VERB"
  ],
  "demon": [
    "NOUN"
  ],
  "infinity": [
    "NOUN"
  ],
  "handler": [
    "NOUN",
    "PROPN"
  ],
  "notation": [
    "NOUN"
  ],
  "chandler": [
    "NOUN"
  ],
  "semantic": [
    "ADJ",
    "PROPN"
  ],
  "concurrent": [
    "ADJ",
    "PROPN"
  ],
  "caption": [
    "NOUN"
  ],
  "complain": [
    "VERB"
  ],
  "pulmonary": [
    "ADJ"
  ],
  "adhesive": [
    "NOUN"
  ],
  "toledo": [
    "PROPN"
  ],
  "altitude": [
    "VERB"
  ],
  "compass": [
    "PROPN",
    "NOUN"
  ],
  "closet": [
    "NOUN"
  ],
  "couch": [
    "NOUN"
  ],
  "exceeding": [
    "VERB"
  ],
  "rogue": [
    "NOUN"
  ],
  "unfair": [
    "ADJ"
  ],
  "inspirational": [
    "ADJ"
  ],
  "augusta": [
    "VERB"
  ],
  "infantry": [
    "NOUN"
  ],
  "renowned": [
    "ADJ"
  ],
  "corridor": [
    "NOUN"
  ],
  "philosophical": [
    "ADJ"
  ],
  "scripture": [
    "NOUN"
  ],
  "sahara": [
    "PROPN"
  ],
  "justification": [
    "NOUN",
    "PROPN"
  ],
  "rebuild": [
    "VERB"
  ],
  "vacant": [
    "ADJ"
  ],
  "manuscript": [
    "PROPN"
  ],
  "fixing": [
    "VERB",
    "NOUN"
  ],
  "methodist": [
    "PROPN"
  ],
  "inherent": [
    "ADJ"
  ],
  "alphabet": [
    "NOUN"
  ],
  "optic": [
    "NOUN"
  ],
  "insect": [
    "PROPN"
  ],
  "frances": [
    "NOUN"
  ],
  "chili": [
    "NOUN"
  ],
  "grief": [
    "NOUN"
  ],
  "leicester": [
    "VERB"
  ],
  "sweat": [
    "VERB"
  ],
  "dolphin": [
    "VERB"
  ],
  "romanian": [
    "PROPN"
  ],
  "ventilation": [
    "NOUN"
  ],
  "lateral": [
    "ADJ"
  ],
  "quake": [
    "NOUN"
  ],
  "usability": [
    "NOUN",
    "PROPN"
  ],
  "alley": [
    "NOUN"
  ],
  "sanders": [
    "NOUN"
  ],
  "telegraph": [
    "NOUN"
  ],
  "pertaining": [
    "VERB"
  ],
  "memorable": [
    "ADJ"
  ],
  "newsroom": [
    "NOUN"
  ],
  "monument": [
    "NOUN"
  ],
  "taxpayer": [
    "NOUN"
  ],
  "formally": [
    "ADV"
  ],
  "twain": [
    "VERB"
  ],
  "lavender": [
    "PROPN"
  ],
  "withdrawn": [
    "VERB"
  ],
  "breeze": [
    "PROPN"
  ],
  "buffy": [
    "VERB"
  ],
  "doctoral": [
    "ADJ"
  ],
  "outgoing": [
    "ADJ",
    "PROPN"
  ],
  "yankee": [
    "PROPN"
  ],
  "sheraton": [
    "PROPN"
  ],
  "deficiency": [
    "NOUN"
  ],
  "booster": [
    "NOUN"
  ],
  "taxable": [
    "ADJ"
  ],
  "progression": [
    "NOUN"
  ],
  "saddle": [
    "VERB"
  ],
  "malaria": [
    "NOUN"
  ],
  "loyal": [
    "ADJ"
  ],
  "torrent": [
    "NOUN"
  ],
  "dentistry": [
    "NOUN"
  ],
  "renal": [
    "ADJ"
  ],
  "fedora": [
    "PUNCT"
  ],
  "odyssey": [
    "NOUN"
  ],
  "spite": [
    "VERB"
  ],
  "guideline": [
    "PROPN",
    "NOUN"
  ],
  "imply": [
    "VERB"
  ],
  "tendency": [
    "NOUN"
  ],
  "caledonia": [
    "PROPN"
  ],
  "freezer": [
    "NOUN"
  ],
  "wholly": [
    "ADV"
  ],
  "chill": [
    "NOUN"
  ],
  "embrace": [
    "VERB"
  ],
  "liner": [
    "NOUN"
  ],
  "manila": [
    "PROPN"
  ],
  "auxiliary": [
    "ADJ"
  ],
  "initiate": [
    "VERB",
    "PROPN"
  ],
  "elevated": [
    "ADJ",
    "VERB"
  ],
  "purely": [
    "ADV"
  ],
  "vivid": [
    "ADJ"
  ],
  "enroll": [
    "VERB",
    "PROPN"
  ],
  "stationary": [
    "PROPN"
  ],
  "daemon": [
    "NOUN"
  ],
  "celebrated": [
    "VERB"
  ],
  "byron": [
    "PROPN"
  ],
  "critique": [
    "NOUN"
  ],
  "coefficient": [
    "VERB"
  ],
  "honestly": [
    "ADV"
  ],
  "transvestite": [
    "ADJ"
  ],
  "upstream": [
    "ADJ",
    "NOUN"
  ],
  "skull": [
    "PROPN"
  ],
  "continuation": [
    "NOUN"
  ],
  "carnegie": [
    "NOUN"
  ],
  "servant": [
    "NOUN"
  ],
  "falcon": [
    "PROPN"
  ],
  "jointly": [
    "ADV"
  ],
  "terrier": [
    "ADJ"
  ],
  "variant": [
    "NOUN",
    "ADJ"
  ],
  "riley": [
    "ADJ"
  ],
  "biochemistry": [
    "NOUN"
  ],
  "duplication": [
    "NOUN",
    "PROPN"
  ],
  "equatorial": [
    "NOUN"
  ],
  "critic": [
    "NOUN"
  ],
  "sediment": [
    "NOUN"
  ],
  "ninja": [
    "VERB"
  ],
  "voucher": [
    "ADV"
  ],
  "honeymoon": [
    "NOUN"
  ],
  "percussion": [
    "NOUN"
  ],
  "spinning": [
    "VERB"
  ],
  "epidemiology": [
    "NOUN"
  ],
  "adequately": [
    "ADV"
  ],
  "pentagon": [
    "PROPN"
  ],
  "spectral": [
    "ADJ"
  ],
  "diabetic": [
    "ADJ"
  ],
  "prevalence": [
    "NOUN"
  ],
  "fragment": [
    "NOUN",
    "PROPN"
  ],
  "lecturer": [
    "NOUN"
  ],
  "bucket": [
    "NOUN",
    "PROPN"
  ],
  "steak": [
    "NOUN"
  ],
  "cobra": [
    "PROPN"
  ],
  "subset": [
    "NOUN"
  ],
  "threw": [
    "VERB"
  ],
  "authorize": [
    "VERB"
  ],
  "cheney": [
    "PROPN"
  ],
  "zombie": [
    "NOUN"
  ],
  "decorated": [
    "VERB"
  ],
  "cherokee": [
    "PROPN"
  ],
  "recruit": [
    "PROPN",
    "VERB"
  ],
  "wherein": [
    "SCONJ"
  ],
  "simulator": [
    "NOUN"
  ],
  "dessert": [
    "NOUN"
  ],
  "dissertation": [
    "NOUN"
  ],
  "walsh": [
    "PROPN"
  ],
  "ninth": [
    "ADJ"
  ],
  "mutant": [
    "ADJ"
  ],
  "marry": [
    "VERB"
  ],
  "enthusiasm": [
    "NOUN"
  ],
  "approaching": [
    "VERB"
  ],
  "bounce": [
    "NOUN",
    "PROPN"
  ],
  "spiral": [
    "VERB"
  ],
  "weakness": [
    "NOUN"
  ],
  "drake": [
    "NOUN"
  ],
  "cynthia": [
    "NOUN"
  ],
  "roosevelt": [
    "NOUN"
  ],
  "nicely": [
    "ADV"
  ],
  "surprisingly": [
    "ADV"
  ],
  "della": [
    "PROPN"
  ],
  "laurel": [
    "PROPN"
  ],
  "carolyn": [
    "X"
  ],
  "fried": [
    "VERB"
  ],
  "cairo": [
    "PROPN"
  ],
  "ambulance": [
    "NOUN"
  ],
  "practically": [
    "ADV"
  ],
  "domination": [
    "NOUN"
  ],
  "shrimp": [
    "NOUN"
  ],
  "impairment": [
    "VERB"
  ],
  "scooter": [
    "NOUN"
  ],
  "molecule": [
    "NOUN"
  ],
  "dedication": [
    "NOUN"
  ],
  "cheerleader": [
    "NOUN"
  ],
  "cried": [
    "VERB"
  ],
  "psychic": [
    "ADJ"
  ],
  "lotion": [
    "NOUN"
  ],
  "substrate": [
    "NOUN"
  ],
  "sincerely": [
    "ADV"
  ],
  "beaten": [
    "VERB"
  ],
  "piercing": [
    "VERB"
  ],
  "ashanti": [
    "NOUN"
  ],
  "homemade": [
    "PROPN"
  ],
  "ukrainian": [
    "ADJ"
  ],
  "marginal": [
    "ADJ"
  ],
  "efficacy": [
    "NOUN"
  ],
  "topical": [
    "ADJ"
  ],
  "prestige": [
    "NOUN"
  ],
  "cocaine": [
    "NOUN"
  ],
  "accelerated": [
    "VERB",
    "ADJ"
  ],
  "pinnacle": [
    "PROPN"
  ],
  "tucker": [
    "NOUN"
  ],
  "responsive": [
    "ADJ"
  ],
  "molly": [
    "PROPN"
  ],
  "proximity": [
    "NOUN"
  ],
  "belonging": [
    "VERB"
  ],
  "unbiased": [
    "ADJ"
  ],
  "collision": [
    "NOUN"
  ],
  "supplementary": [
    "PROPN"
  ],
  "parkway": [
    "NOUN"
  ],
  "palau": [
    "PROPN"
  ],
  "scandal": [
    "NOUN"
  ],
  "scream": [
    "VERB"
  ],
  "pirate": [
    "NOUN"
  ],
  "willie": [
    "NOUN"
  ],
  "rival": [
    "NOUN"
  ],
  "culinary": [
    "ADJ"
  ],
  "semantics": [
    "NOUN"
  ],
  "scarface": [
    "NOUN"
  ],
  "accountant": [
    "NOUN"
  ],
  "beige": [
    "VERB"
  ],
  "propaganda": [
    "NOUN"
  ],
  "offender": [
    "NOUN"
  ],
  "waterloo": [
    "PROPN"
  ],
  "warwick": [
    "VERB"
  ],
  "executable": [
    "ADJ"
  ],
  "restart": [
    "NOUN",
    "VERB"
  ],
  "rounded": [
    "ADJ"
  ],
  "boarding": [
    "NOUN",
    "PROPN"
  ],
  "vanity": [
    "NOUN"
  ],
  "mitigation": [
    "NOUN",
    "PROPN"
  ],
  "overstock": [
    "VERB"
  ],
  "homer": [
    "NOUN"
  ],
  "daylight": [
    "NOUN"
  ],
  "dependency": [
    "NOUN",
    "PROPN"
  ],
  "dioxide": [
    "VERB"
  ],
  "genus": [
    "NOUN"
  ],
  "catching": [
    "VERB"
  ],
  "cutter": [
    "NOUN"
  ],
  "aperture": [
    "ADV"
  ],
  "roofing": [
    "VERB"
  ],
  "elastic": [
    "ADJ",
    "PROPN"
  ],
  "melody": [
    "NOUN"
  ],
  "cousin": [
    "NOUN"
  ],
  "torque": [
    "NOUN"
  ],
  "phillip": [
    "NOUN"
  ],
  "burial": [
    "NOUN"
  ],
  "balcony": [
    "ADV"
  ],
  "coupling": [
    "NOUN"
  ],
  "oncology": [
    "NOUN"
  ],
  "neglect": [
    "VERB"
  ],
  "emerge": [
    "VERB"
  ],
  "winchester": [
    "NOUN"
  ],
  "clutch": [
    "VERB"
  ],
  "woven": [
    "VERB"
  ],
  "auditorium": [
    "NOUN"
  ],
  "pedro": [
    "NOUN"
  ],
  "carrie": [
    "PROPN"
  ],
  "canterbury": [
    "PROPN"
  ],
  "trent": [
    "ADJ"
  ],
  "barber": [
    "NOUN"
  ],
  "intuitive": [
    "ADJ"
  ],
  "rigid": [
    "ADJ"
  ],
  "degradation": [
    "NOUN"
  ],
  "orthodox": [
    "ADJ"
  ],
  "ferguson": [
    "PROPN"
  ],
  "holistic": [
    "ADJ"
  ],
  "mariana": [
    "PROPN"
  ],
  "qualitative": [
    "ADJ",
    "PROPN"
  ],
  "claude": [
    "PROPN"
  ],
  "blown": [
    "VERB"
  ],
  "diffusion": [
    "NOUN"
  ],
  "baton": [
    "PROPN"
  ],
  "barton": [
    "PROPN"
  ],
  "umbrella": [
    "NOUN"
  ],
  "stimulation": [
    "NOUN"
  ],
  "abbey": [
    "VERB"
  ],
  "olivia": [
    "PROPN"
  ],
  "refugee": [
    "NOUN"
  ],
  "discourse": [
    "VERB"
  ],
  "headache": [
    "PROPN"
  ],
  "marital": [
    "ADJ"
  ],
  "socialist": [
    "NOUN"
  ],
  "bruno": [
    "PROPN"
  ],
  "undertaking": [
    "VERB"
  ],
  "slavery": [
    "NOUN"
  ],
  "notwithstanding": [
    "ADP"
  ],
  "feasible": [
    "ADJ"
  ],
  "credibility": [
    "NOUN"
  ],
  "flowing": [
    "VERB"
  ],
  "sauna": [
    "PROPN"
  ],
  "whirlpool": [
    "ADJ"
  ],
  "sustain": [
    "VERB"
  ],
  "mechanic": [
    "NOUN"
  ],
  "rejection": [
    "NOUN"
  ],
  "bowls": [
    "NOUN"
  ],
  "dissemination": [
    "NOUN"
  ],
  "shareholder": [
    "NOUN"
  ],
  "cosmic": [
    "ADJ"
  ],
  "dawson": [
    "NOUN"
  ],
  "defective": [
    "ADJ"
  ],
  "deletion": [
    "NOUN",
    "PROPN"
  ],
  "beacon": [
    "PROPN",
    "NOUN"
  ],
  "politically": [
    "ADV"
  ],
  "elective": [
    "ADJ"
  ],
  "forensic": [
    "ADJ"
  ],
  "botanical": [
    "PROPN"
  ],
  "quartet": [
    "NOUN"
  ],
  "ceramics": [
    "NOUN"
  ],
  "suspense": [
    "NOUN"
  ],
  "drafting": [
    "VERB",
    "NOUN"
  ],
  "cruel": [
    "ADJ"
  ],
  "observing": [
    "VERB"
  ],
  "commencement": [
    "NOUN"
  ],
  "southwestern": [
    "ADJ"
  ],
  "conform": [
    "VERB"
  ],
  "firing": [
    "VERB"
  ],
  "eager": [
    "ADJ"
  ],
  "hypertension": [
    "NOUN"
  ],
  "searchable": [
    "ADJ"
  ],
  "touching": [
    "VERB"
  ],
  "vacancy": [
    "NOUN"
  ],
  "strawberry": [
    "VERB"
  ],
  "chang": [
    "PROPN"
  ],
  "gloria": [
    "NOUN"
  ],
  "elevator": [
    "NOUN"
  ],
  "pupil": [
    "NOUN"
  ],
  "feast": [
    "NOUN"
  ],
  "maggie": [
    "PROPN"
  ],
  "redemption": [
    "NOUN"
  ],
  "profound": [
    "ADJ"
  ],
  "canton": [
    "PROPN"
  ],
  "bonnie": [
    "PROPN"
  ],
  "laying": [
    "VERB"
  ],
  "provisional": [
    "ADJ"
  ],
  "strive": [
    "VERB"
  ],
  "painter": [
    "NOUN"
  ],
  "cooker": [
    "NOUN"
  ],
  "ankle": [
    "NOUN"
  ],
  "historically": [
    "ADV"
  ],
  "banker": [
    "NOUN"
  ],
  "easiest": [
    "ADJ"
  ],
  "microbiology": [
    "NOUN"
  ],
  "borrow": [
    "VERB"
  ],
  "bamboo": [
    "PROPN",
    "NOUN"
  ],
  "communicating": [
    "VERB",
    "PROPN"
  ],
  "vibration": [
    "NOUN"
  ],
  "stepped": [
    "VERB"
  ],
  "blunt": [
    "NOUN"
  ],
  "protector": [
    "NOUN"
  ],
  "react": [
    "PROPN",
    "NOUN"
  ],
  "shane": [
    "PROPN"
  ],
  "issuing": [
    "VERB"
  ],
  "insane": [
    "ADJ"
  ],
  "buddha": [
    "NOUN"
  ],
  "voyage": [
    "NOUN"
  ],
  "colonel": [
    "NOUN"
  ],
  "transitional": [
    "ADJ"
  ],
  "acceleration": [
    "PROPN",
    "NOUN"
  ],
  "sketch": [
    "ADJ"
  ],
  "nightly": [
    "ADV"
  ],
  "visualization": [
    "NOUN",
    "PROPN"
  ],
  "deduction": [
    "NOUN"
  ],
  "dancer": [
    "NOUN"
  ],
  "firmly": [
    "ADV"
  ],
  "brokerage": [
    "NOUN"
  ],
  "washed": [
    "VERB"
  ],
  "overtime": [
    "NOUN"
  ],
  "resonance": [
    "NOUN"
  ],
  "mosaic": [
    "PROPN"
  ],
  "rhodes": [
    "VERB"
  ],
  "fiesta": [
    "PROPN"
  ],
  "filings": [
    "NOUN"
  ],
  "forcing": [
    "VERB"
  ],
  "flute": [
    "NOUN"
  ],
  "durability": [
    "NOUN"
  ],
  "sizing": [
    "NOUN",
    "VERB"
  ],
  "hindi": [
    "PROPN"
  ],
  "presley": [
    "NOUN"
  ],
  "harsh": [
    "ADJ"
  ],
  "outfit": [
    "VERB"
  ],
  "substitution": [
    "NOUN"
  ],
  "cease": [
    "VERB"
  ],
  "aboard": [
    "ADP"
  ],
  "paradigm": [
    "NOUN"
  ],
  "irving": [
    "VERB"
  ],
  "perfection": [
    "NOUN"
  ],
  "overwhelming": [
    "ADJ"
  ],
  "linguistics": [
    "NOUN"
  ],
  "standardized": [
    "ADJ",
    "VERB"
  ],
  "santiago": [
    "PROPN"
  ],
  "altogether": [
    "ADV"
  ],
  "dignity": [
    "NOUN"
  ],
  "europa": [
    "ADV"
  ],
  "cheshire": [
    "INTJ"
  ],
  "sliding": [
    "VERB"
  ],
  "accumulation": [
    "NOUN"
  ],
  "descriptive": [
    "ADJ"
  ],
  "feasibility": [
    "NOUN",
    "PROPN"
  ],
  "sioux": [
    "VERB"
  ],
  "jenna": [
    "PROPN"
  ],
  "lutheran": [
    "PROPN"
  ],
  "syllabus": [
    "NOUN"
  ],
  "valencia": [
    "PROPN"
  ],
  "superman": [
    "NOUN"
  ],
  "ideally": [
    "ADV"
  ],
  "activism": [
    "NOUN"
  ],
  "splash": [
    "VERB"
  ],
  "equip": [
    "PROPN",
    "VERB"
  ],
  "leverage": [
    "VERB",
    "NOUN"
  ],
  "probation": [
    "NOUN"
  ],
  "hedge": [
    "NOUN"
  ],
  "anguilla": [
    "PROPN"
  ],
  "fender": [
    "NOUN"
  ],
  "violet": [
    "NOUN"
  ],
  "mutation": [
    "NOUN",
    "PROPN"
  ],
  "compulsory": [
    "ADJ"
  ],
  "favorable": [
    "ADJ"
  ],
  "handset": [
    "NOUN"
  ],
  "maxwell": [
    "PROPN"
  ],
  "inheritance": [
    "NOUN"
  ],
  "curry": [
    "VERB"
  ],
  "oblique": [
    "ADJ"
  ],
  "activist": [
    "NOUN"
  ],
  "satisfying": [
    "VERB"
  ],
  "maintainer": [
    "PROPN"
  ],
  "dewey": [
    "PROPN"
  ],
  "surviving": [
    "VERB"
  ],
  "pouch": [
    "VERB"
  ],
  "advent": [
    "NOUN"
  ],
  "exploitation": [
    "NOUN"
  ],
  "mansion": [
    "NOUN"
  ],
  "surrender": [
    "VERB"
  ],
  "schneider": [
    "NOUN"
  ],
  "arsenal": [
    "NOUN"
  ],
  "pyramid": [
    "NOUN"
  ],
  "hacking": [
    "VERB"
  ],
  "stripe": [
    "PROPN",
    "NOUN"
  ],
  "knoxville": [
    "PROPN"
  ],
  "limousine": [
    "NOUN"
  ],
  "affirmative": [
    "ADJ"
  ],
  "keynote": [
    "PROPN",
    "NOUN"
  ],
  "didnt": [
    "AUX"
  ],
  "petitioner": [
    "NOUN"
  ],
  "residency": [
    "NOUN",
    "PROPN"
  ],
  "spoon": [
    "VERB"
  ],
  "niche": [
    "NOUN"
  ],
  "fortunately": [
    "ADV"
  ],
  "cigar": [
    "NOUN"
  ],
  "calculating": [
    "VERB"
  ],
  "berkshire": [
    "NOUN"
  ],
  "bookshop": [
    "NOUN"
  ],
  "proportional": [
    "ADJ"
  ],
  "nonetheless": [
    "ADV"
  ],
  "locker": [
    "NOUN"
  ],
  "squash": [
    "VERB"
  ],
  "expectation": [
    "NOUN",
    "PROPN"
  ],
  "severely": [
    "ADV"
  ],
  "spotted": [
    "VERB"
  ],
  "curse": [
    "VERB"
  ],
  "coconut": [
    "NOUN"
  ],
  "interrupt": [
    "VERB"
  ],
  "conductor": [
    "NOUN"
  ],
  "liberation": [
    "NOUN"
  ],
  "diagnostics": [
    "NOUN"
  ],
  "grandfather": [
    "NOUN"
  ],
  "luxurious": [
    "ADJ"
  ],
  "titan": [
    "PROPN"
  ],
  "booked": [
    "VERB"
  ],
  "anita": [
    "PROPN"
  ],
  "indirectly": [
    "ADV"
  ],
  "blessing": [
    "NOUN"
  ],
  "lumber": [
    "NOUN"
  ],
  "illustrator": [
    "NOUN"
  ],
  "asleep": [
    "ADJ"
  ],
  "potassium": [
    "NOUN"
  ],
  "shout": [
    "VERB",
    "NOUN"
  ],
  "rationale": [
    "NOUN",
    "PROPN"
  ],
  "presidency": [
    "NOUN"
  ],
  "abnormal": [
    "ADJ"
  ],
  "delicate": [
    "ADJ"
  ],
  "convince": [
    "VERB"
  ],
  "whoever": [
    "PRON"
  ],
  "subway": [
    "NOUN"
  ],
  "straw": [
    "NOUN"
  ],
  "mankind": [
    "NOUN"
  ],
  "uncertain": [
    "ADJ"
  ],
  "citrus": [
    "NOUN"
  ],
  "paramount": [
    "ADJ"
  ],
  "upright": [
    "ADJ"
  ],
  "reuse": [
    "VERB",
    "NOUN"
  ],
  "ernest": [
    "VERB"
  ],
  "alcoholic": [
    "VERB"
  ],
  "bakery": [
    "VERB"
  ],
  "lieutenant": [
    "NOUN"
  ],
  "orchid": [
    "NOUN"
  ],
  "variability": [
    "NOUN"
  ],
  "suede": [
    "VERB"
  ],
  "observatory": [
    "NOUN"
  ],
  "preventive": [
    "ADJ"
  ],
  "peach": [
    "VERB"
  ],
  "calculus": [
    "NOUN"
  ],
  "stefan": [
    "PROPN"
  ],
  "selector": [
    "NOUN"
  ],
  "breathe": [
    "VERB"
  ],
  "diaper": [
    "NOUN"
  ],
  "smiling": [
    "VERB"
  ],
  "economically": [
    "ADV"
  ],
  "uncut": [
    "VERB"
  ],
  "intact": [
    "ADJ"
  ],
  "shifting": [
    "VERB"
  ],
  "samurai": [
    "PROPN"
  ],
  "subtotal": [
    "NOUN"
  ],
  "duplex": [
    "NOUN"
  ],
  "delegate": [
    "VERB",
    "NOUN"
  ],
  "lightly": [
    "ADV"
  ],
  "analyzer": [
    "NOUN",
    "PROPN"
  ],
  "herman": [
    "NOUN"
  ],
  "congestion": [
    "NOUN"
  ],
  "stove": [
    "VERB"
  ],
  "accidental": [
    "ADJ"
  ],
  "refuge": [
    "NOUN"
  ],
  "nutrient": [
    "NOUN"
  ],
  "underway": [
    "ADJ"
  ],
  "freak": [
    "NOUN"
  ],
  "preferably": [
    "ADV"
  ],
  "bluff": [
    "PROPN"
  ],
  "jasper": [
    "NOUN"
  ],
  "sadly": [
    "ADV"
  ],
  "avail": [
    "NOUN"
  ],
  "regulate": [
    "NOUN"
  ],
  "orchard": [
    "NOUN"
  ],
  "mythology": [
    "NOUN"
  ],
  "prestigious": [
    "ADJ"
  ],
  "deploy": [
    "VERB",
    "NOUN"
  ],
  "trousers": [
    "NOUN"
  ],
  "hatch": [
    "VERB"
  ],
  "stein": [
    "VERB"
  ],
  "shortage": [
    "NOUN"
  ],
  "privileged": [
    "ADJ",
    "PROPN"
  ],
  "spill": [
    "NOUN"
  ],
  "goodness": [
    "INTJ"
  ],
  "drift": [
    "NOUN"
  ],
  "autism": [
    "NOUN"
  ],
  "fuller": [
    "ADJ"
  ],
  "martinez": [
    "PROPN"
  ],
  "metrics": [
    "NOUN",
    "PROPN"
  ],
  "crisp": [
    "ADJ"
  ],
  "inability": [
    "NOUN"
  ],
  "coronary": [
    "ADJ"
  ],
  "keeper": [
    "NOUN"
  ],
  "vaginal": [
    "ADJ"
  ],
  "buddhist": [
    "NOUN"
  ],
  "inevitable": [
    "ADJ"
  ],
  "etiquette": [
    "VERB"
  ],
  "rookie": [
    "PROPN"
  ],
  "environ": [
    "ADJ"
  ],
  "theatrical": [
    "ADJ"
  ],
  "wheeler": [
    "NOUN"
  ],
  "ritual": [
    "ADJ",
    "NOUN"
  ],
  "miguel": [
    "PROPN"
  ],
  "onset": [
    "NOUN"
  ],
  "interpreter": [
    "NOUN"
  ],
  "initiation": [
    "NOUN",
    "PROPN"
  ],
  "analytics": [
    "NOUN",
    "PROPN"
  ],
  "assay": [
    "VERB"
  ],
  "reconciliation": [
    "NOUN",
    "PROPN"
  ],
  "parser": [
    "NOUN"
  ],
  "leigh": [
    "PROPN"
  ],
  "plaque": [
    "NOUN"
  ],
  "styling": [
    "NOUN"
  ],
  "snack": [
    "NOUN"
  ],
  "autonomous": [
    "ADJ"
  ],
  "motoring": [
    "VERB"
  ],
  "appropriation": [
    "NOUN"
  ],
  "randomly": [
    "ADV"
  ],
  "condensed": [
    "VERB"
  ],
  "philippine": [
    "NOUN"
  ],
  "theological": [
    "PROPN"
  ],
  "quietly": [
    "ADV"
  ],
  "scenery": [
    "NOUN"
  ],
  "mentally": [
    "ADV"
  ],
  "drying": [
    "VERB"
  ],
  "silicone": [
    "NOUN"
  ],
  "collateral": [
    "NOUN"
  ],
  "learner": [
    "NOUN"
  ],
  "swallow": [
    "VERB"
  ],
  "transplant": [
    "NOUN"
  ],
  "scoreboard": [
    "ADJ"
  ],
  "proliferation": [
    "NOUN"
  ],
  "squid": [
    "PROPN"
  ],
  "lighthouse": [
    "PROPN",
    "NOUN"
  ],
  "trilogy": [
    "NOUN"
  ],
  "brightness": [
    "NOUN"
  ],
  "maurice": [
    "NOUN"
  ],
  "brooke": [
    "PROPN"
  ],
  "maxim": [
    "NOUN"
  ],
  "depreciation": [
    "NOUN"
  ],
  "technically": [
    "ADV"
  ],
  "pharmacist": [
    "NOUN"
  ],
  "enjoyment": [
    "NOUN"
  ],
  "austrian": [
    "PROPN"
  ],
  "correspond": [
    "VERB"
  ],
  "slate": [
    "NOUN"
  ],
  "suzanne": [
    "PROPN"
  ],
  "confined": [
    "VERB"
  ],
  "screaming": [
    "VERB"
  ],
  "straightforward": [
    "ADJ"
  ],
  "delighted": [
    "ADJ"
  ],
  "morton": [
    "PROPN"
  ],
  "jupiter": [
    "PROPN"
  ],
  "simultaneous": [
    "ADJ"
  ],
  "monopoly": [
    "NOUN"
  ],
  "debris": [
    "NOUN"
  ],
  "pagan": [
    "PROPN"
  ],
  "chopped": [
    "VERB"
  ],
  "widow": [
    "NOUN"
  ],
  "randall": [
    "VERB"
  ],
  "benson": [
    "PROPN"
  ],
  "footnote": [
    "NOUN"
  ],
  "vibrant": [
    "ADJ"
  ],
  "sweater": [
    "NOUN"
  ],
  "approximation": [
    "NOUN"
  ],
  "skies": [
    "NOUN"
  ],
  "barrett": [
    "PROPN"
  ],
  "alison": [
    "PROPN"
  ],
  "canoe": [
    "PROPN"
  ],
  "sovereign": [
    "VERB"
  ],
  "organism": [
    "NOUN"
  ],
  "corrupt": [
    "ADJ"
  ],
  "correspondent": [
    "NOUN"
  ],
  "drought": [
    "NOUN"
  ],
  "symptom": [
    "PROPN"
  ],
  "laughter": [
    "NOUN"
  ],
  "propagation": [
    "NOUN"
  ],
  "ignorance": [
    "NOUN"
  ],
  "explosive": [
    "NOUN"
  ],
  "inventor": [
    "NOUN"
  ],
  "scaling": [
    "VERB",
    "NOUN"
  ],
  "juicy": [
    "PROPN"
  ],
  "moody": [
    "ADJ"
  ],
  "fashioned": [
    "VERB"
  ],
  "vicinity": [
    "NOUN"
  ],
  "thyroid": [
    "NOUN"
  ],
  "purification": [
    "NOUN"
  ],
  "southeastern": [
    "ADJ"
  ],
  "horoscope": [
    "NOUN"
  ],
  "invasive": [
    "ADJ"
  ],
  "prosperity": [
    "NOUN"
  ],
  "rainfall": [
    "NOUN"
  ],
  "hardback": [
    "VERB"
  ],
  "pedal": [
    "NOUN"
  ],
  "inconsistent": [
    "ADJ",
    "PROPN"
  ],
  "plantation": [
    "NOUN"
  ],
  "seemingly": [
    "ADV"
  ],
  "tuned": [
    "VERB"
  ],
  "passionate": [
    "ADJ",
    "VERB"
  ],
  "mayer": [
    "NOUN"
  ],
  "backward": [
    "ADJ"
  ],
  "geoff": [
    "NOUN"
  ],
  "rename": [
    "PROPN",
    "VERB"
  ],
  "markup": [
    "VERB"
  ],
  "combustion": [
    "NOUN"
  ],
  "breakthrough": [
    "VERB"
  ],
  "scrap": [
    "NOUN"
  ],
  "administer": [
    "VERB",
    "PROPN"
  ],
  "bilateral": [
    "ADJ"
  ],
  "bella": [
    "PROPN"
  ],
  "disposable": [
    "ADJ"
  ],
  "copier": [
    "ADJ"
  ],
  "uncategorized": [
    "VERB"
  ],
  "literal": [
    "VERB"
  ],
  "charcoal": [
    "NOUN"
  ],
  "vapor": [
    "NOUN"
  ],
  "beware": [
    "VERB"
  ],
  "aloud": [
    "ADV"
  ],
  "glorious": [
    "PROPN"
  ],
  "overlap": [
    "NOUN",
    "VERB"
  ],
  "handsome": [
    "ADJ"
  ],
  "foreclosure": [
    "NOUN"
  ],
  "clarification": [
    "NOUN",
    "PROPN"
  ],
  "grounded": [
    "VERB"
  ],
  "goose": [
    "VERB"
  ],
  "cruiser": [
    "PROPN"
  ],
  "gifted": [
    "VERB"
  ],
  "esteem": [
    "VERB"
  ],
  "cascade": [
    "NOUN"
  ],
  "endorse": [
    "VERB"
  ],
  "homeowner": [
    "NOUN"
  ],
  "ancestry": [
    "NOUN"
  ],
  "landed": [
    "VERB"
  ],
  "nucleus": [
    "PROPN"
  ],
  "detached": [
    "VERB"
  ],
  "warsaw": [
    "PROPN"
  ],
  "hydro": [
    "NOUN"
  ],
  "nonlinear": [
    "VERB"
  ],
  "objection": [
    "NOUN",
    "PROPN"
  ],
  "phosphate": [
    "NOUN"
  ],
  "playa": [
    "NOUN"
  ],
  "noisy": [
    "ADJ"
  ],
  "abide": [
    "VERB"
  ],
  "radioactive": [
    "ADJ"
  ],
  "sentinel": [
    "PROPN"
  ],
  "economist": [
    "NOUN"
  ],
  "meridian": [
    "PROPN"
  ],
  "regret": [
    "PROPN"
  ],
  "validate": [
    "VERB",
    "PROPN"
  ],
  "rotating": [
    "VERB"
  ],
  "nederlands": [
    "NOUN"
  ],
  "brigade": [
    "NOUN"
  ],
  "movable": [
    "ADJ"
  ],
  "bliss": [
    "VERB"
  ],
  "humiliation": [
    "NOUN"
  ],
  "litter": [
    "NOUN"
  ],
  "reflective": [
    "ADJ"
  ],
  "outerwear": [
    "VERB"
  ],
  "greenwich": [
    "PROPN"
  ],
  "flooding": [
    "VERB"
  ],
  "parse": [
    "VERB",
    "NOUN"
  ],
  "rugged": [
    "ADJ"
  ],
  "jelly": [
    "ADV"
  ],
  "grandmother": [
    "NOUN"
  ],
  "renovation": [
    "NOUN"
  ],
  "appoint": [
    "VERB"
  ],
  "greenwood": [
    "PROPN"
  ],
  "ignition": [
    "NOUN"
  ],
  "humble": [
    "ADJ"
  ],
  "downstream": [
    "ADJ",
    "PROPN"
  ],
  "petrol": [
    "NOUN"
  ],
  "midway": [
    "PROPN"
  ],
  "mania": [
    "PROPN"
  ],
  "edwin": [
    "PROPN"
  ],
  "accelerator": [
    "NOUN"
  ],
  "clare": [
    "NOUN"
  ],
  "hostile": [
    "ADJ"
  ],
  "aphrodite": [
    "VERB"
  ],
  "radiology": [
    "NOUN"
  ],
  "whites": [
    "NOUN"
  ],
  "trapped": [
    "VERB"
  ],
  "diplomatic": [
    "ADJ"
  ],
  "fringe": [
    "NOUN"
  ],
  "linguistic": [
    "ADJ"
  ],
  "internally": [
    "PROPN"
  ],
  "planetary": [
    "ADJ"
  ],
  "tungsten": [
    "VERB"
  ],
  "laurent": [
    "NOUN"
  ],
  "shutdown": [
    "NOUN"
  ],
  "manuel": [
    "PROPN"
  ],
  "influenza": [
    "NOUN"
  ],
  "viewpoint": [
    "NOUN"
  ],
  "peptide": [
    "ADV"
  ],
  "hassle": [
    "NOUN"
  ],
  "conception": [
    "NOUN"
  ],
  "unemployed": [
    "VERB"
  ],
  "heavenly": [
    "ADV"
  ],
  "docket": [
    "NOUN"
  ],
  "amusement": [
    "NOUN"
  ],
  "nordic": [
    "ADJ"
  ],
  "albanian": [
    "PROPN"
  ],
  "overflow": [
    "NOUN"
  ],
  "geometric": [
    "ADJ"
  ],
  "hastings": [
    "PROPN"
  ],
  "taxonomy": [
    "NOUN",
    "PROPN"
  ],
  "willingness": [
    "NOUN"
  ],
  "intern": [
    "PROPN",
    "NOUN"
  ],
  "implicit": [
    "ADJ"
  ],
  "patriotic": [
    "ADJ"
  ],
  "simplify": [
    "VERB",
    "PROPN"
  ],
  "darling": [
    "NOUN"
  ],
  "satan": [
    "PROPN"
  ],
  "oppose": [
    "VERB"
  ],
  "terrific": [
    "ADJ"
  ],
  "definite": [
    "ADJ"
  ],
  "congregation": [
    "NOUN"
  ],
  "regiment": [
    "NOUN"
  ],
  "cheer": [
    "NOUN"
  ],
  "everett": [
    "PROPN"
  ],
  "clutter": [
    "NOUN"
  ],
  "misleading": [
    "ADJ"
  ],
  "marty": [
    "NOUN"
  ],
  "predator": [
    "NOUN"
  ],
  "whereby": [
    "SCONJ"
  ],
  "deceased": [
    "VERB"
  ],
  "sparks": [
    "VERB"
  ],
  "belgian": [
    "ADJ"
  ],
  "simpler": [
    "ADJ",
    "PROPN"
  ],
  "coventry": [
    "NOUN"
  ],
  "capitalism": [
    "NOUN"
  ],
  "falkland": [
    "NOUN"
  ],
  "clamp": [
    "VERB"
  ],
  "grape": [
    "NOUN"
  ],
  "madden": [
    "PROPN"
  ],
  "lively": [
    "ADJ"
  ],
  "inequality": [
    "NOUN"
  ],
  "educator": [
    "NOUN"
  ],
  "premature": [
    "ADJ"
  ],
  "visually": [
    "ADV"
  ],
  "tripod": [
    "PROPN"
  ],
  "immigrant": [
    "NOUN"
  ],
  "alright": [
    "INTJ"
  ],
  "obsolete": [
    "ADJ"
  ],
  "pesticide": [
    "NOUN"
  ],
  "interfere": [
    "VERB"
  ],
  "traps": [
    "NOUN"
  ],
  "shuffle": [
    "VERB"
  ],
  "wardrobe": [
    "VERB"
  ],
  "racer": [
    "NOUN"
  ],
  "fabrication": [
    "NOUN"
  ],
  "guilt": [
    "NOUN"
  ],
  "sweep": [
    "VERB"
  ],
  "outpatient": [
    "NOUN"
  ],
  "bladder": [
    "NOUN"
  ],
  "inflammatory": [
    "ADJ"
  ],
  "immunity": [
    "NOUN"
  ],
  "doyle": [
    "NOUN"
  ],
  "shooter": [
    "ADJ"
  ],
  "switchboard": [
    "NOUN"
  ],
  "vince": [
    "NOUN"
  ],
  "cheating": [
    "VERB"
  ],
  "fluorescent": [
    "NOUN"
  ],
  "param": [
    "NOUN"
  ],
  "scrutiny": [
    "NOUN"
  ],
  "regeneration": [
    "NOUN"
  ],
  "lunar": [
    "ADJ"
  ],
  "differentiation": [
    "NOUN",
    "PROPN"
  ],
  "environmentally": [
    "ADV"
  ],
  "nonsense": [
    "NOUN"
  ],
  "gradient": [
    "NOUN"
  ],
  "elaine": [
    "ADJ"
  ],
  "subjected": [
    "VERB"
  ],
  "tasting": [
    "VERB"
  ],
  "chemotherapy": [
    "NOUN"
  ],
  "expose": [
    "VERB",
    "PROPN"
  ],
  "borrowing": [
    "VERB"
  ],
  "branded": [
    "VERB"
  ],
  "dysfunction": [
    "NOUN"
  ],
  "manning": [
    "VERB"
  ],
  "lisbon": [
    "PROPN"
  ],
  "boxer": [
    "NOUN"
  ],
  "shining": [
    "VERB"
  ],
  "weigh": [
    "VERB"
  ],
  "rodeo": [
    "NOUN"
  ],
  "clerical": [
    "ADJ"
  ],
  "voyager": [
    "PROPN"
  ],
  "sampler": [
    "NOUN"
  ],
  "moose": [
    "NOUN"
  ],
  "timetable": [
    "NOUN"
  ],
  "corrosion": [
    "NOUN"
  ],
  "positioned": [
    "VERB"
  ],
  "checker": [
    "NOUN"
  ],
  "conscience": [
    "NOUN"
  ],
  "crush": [
    "NOUN"
  ],
  "cathy": [
    "ADJ"
  ],
  "mystic": [
    "ADJ"
  ],
  "solicitation": [
    "NOUN"
  ],
  "darren": [
    "NOUN"
  ],
  "rectangular": [
    "ADJ"
  ],
  "enthusiast": [
    "NOUN"
  ],
  "positively": [
    "ADV"
  ],
  "shaping": [
    "VERB"
  ],
  "afghan": [
    "PROPN"
  ],
  "inspire": [
    "VERB",
    "PROPN"
  ],
  "revival": [
    "NOUN"
  ],
  "disappear": [
    "VERB"
  ],
  "lever": [
    "PROPN",
    "NOUN"
  ],
  "redundant": [
    "ADJ"
  ],
  "regency": [
    "NOUN"
  ],
  "tasty": [
    "NOUN"
  ],
  "midland": [
    "PROPN"
  ],
  "synchronization": [
    "NOUN"
  ],
  "tarot": [
    "NOUN"
  ],
  "brenda": [
    "PROPN"
  ],
  "wasted": [
    "VERB"
  ],
  "cocoa": [
    "NOUN"
  ],
  "cushion": [
    "NOUN"
  ],
  "reversed": [
    "VERB"
  ],
  "footer": [
    "NOUN",
    "PROPN"
  ],
  "maternal": [
    "ADJ"
  ],
  "specimen": [
    "NOUN"
  ],
  "seamless": [
    "ADJ",
    "PROPN"
  ],
  "panther": [
    "NOUN"
  ],
  "graves": [
    "NOUN"
  ],
  "ghetto": [
    "NOUN"
  ],
  "examiner": [
    "PROPN"
  ],
  "vineyard": [
    "NOUN"
  ],
  "meadow": [
    "NOUN"
  ],
  "feeder": [
    "NOUN"
  ],
  "mercer": [
    "VERB"
  ],
  "goodman": [
    "PROPN"
  ],
  "listener": [
    "NOUN"
  ],
  "subunit": [
    "NOUN"
  ],
  "chloride": [
    "PROPN"
  ],
  "becker": [
    "X"
  ],
  "orion": [
    "NOUN"
  ],
  "hurry": [
    "VERB"
  ],
  "influential": [
    "ADJ"
  ],
  "beneficiary": [
    "NOUN"
  ],
  "offspring": [
    "VERB"
  ],
  "panorama": [
    "NOUN"
  ],
  "reactor": [
    "PROPN"
  ],
  "clash": [
    "VERB"
  ],
  "fidelity": [
    "NOUN",
    "PROPN"
  ],
  "peanut": [
    "NOUN"
  ],
  "holden": [
    "ADJ"
  ],
  "rhapsody": [
    "NOUN"
  ],
  "trumpet": [
    "NOUN"
  ],
  "solitaire": [
    "NOUN"
  ],
  "decreasing": [
    "VERB"
  ],
  "freezing": [
    "VERB"
  ],
  "kaiser": [
    "NOUN"
  ],
  "dishwasher": [
    "NOUN"
  ],
  "retire": [
    "VERB",
    "PROPN"
  ],
  "emergence": [
    "NOUN"
  ],
  "feminist": [
    "NOUN"
  ],
  "crimson": [
    "NOUN"
  ],
  "compassion": [
    "NOUN"
  ],
  "needing": [
    "VERB"
  ],
  "twentieth": [
    "PROPN"
  ],
  "pronounced": [
    "VERB"
  ],
  "extensively": [
    "ADV"
  ],
  "stain": [
    "NOUN"
  ],
  "conrad": [
    "PROPN"
  ],
  "wished": [
    "VERB"
  ],
  "transient": [
    "ADJ"
  ],
  "coloring": [
    "VERB"
  ],
  "gadget": [
    "NOUN",
    "PROPN"
  ],
  "leukemia": [
    "VERB"
  ],
  "reign": [
    "NOUN"
  ],
  "trivial": [
    "ADJ"
  ],
  "ticker": [
    "PROPN"
  ],
  "baron": [
    "PROPN"
  ],
  "remover": [
    "NOUN"
  ],
  "sensible": [
    "ADJ"
  ],
  "unlawful": [
    "ADJ"
  ],
  "swinging": [
    "VERB"
  ],
  "accountable": [
    "ADJ",
    "PROPN"
  ],
  "proving": [
    "VERB"
  ],
  "opposing": [
    "VERB"
  ],
  "novice": [
    "NOUN"
  ],
  "lowering": [
    "VERB"
  ],
  "delightful": [
    "ADJ"
  ],
  "discography": [
    "NOUN"
  ],
  "stiff": [
    "ADJ"
  ],
  "pediatrics": [
    "NOUN"
  ],
  "rabbi": [
    "VERB"
  ],
  "puffy": [
    "ADJ"
  ],
  "ridiculous": [
    "ADJ"
  ],
  "scattering": [
    "VERB"
  ],
  "contracted": [
    "VERB"
  ],
  "elbow": [
    "NOUN"
  ],
  "appealing": [
    "ADJ",
    "VERB"
  ],
  "scholarly": [
    "ADV"
  ],
  "stark": [
    "ADJ"
  ],
  "roberto": [
    "NOUN"
  ],
  "circa": [
    "VERB"
  ],
  "revise": [
    "VERB",
    "PROPN"
  ],
  "surroundings": [
    "NOUN"
  ],
  "proficiency": [
    "NOUN",
    "PROPN"
  ],
  "uranium": [
    "NOUN"
  ],
  "consolidate": [
    "VERB",
    "ADJ"
  ],
  "antigen": [
    "PROPN"
  ],
  "procedural": [
    "ADJ"
  ],
  "labrador": [
    "PROPN"
  ],
  "refusal": [
    "NOUN"
  ],
  "suppression": [
    "NOUN"
  ],
  "weaver": [
    "PROPN"
  ],
  "readiness": [
    "PROPN",
    "NOUN"
  ],
  "secular": [
    "ADJ"
  ],
  "majesty": [
    "PROPN"
  ],
  "fishery": [
    "NOUN"
  ],
  "teresa": [
    "NOUN"
  ],
  "outdated": [
    "ADJ",
    "VERB"
  ],
  "aussie": [
    "PROPN"
  ],
  "pewter": [
    "PROPN"
  ],
  "distress": [
    "VERB"
  ],
  "pumpkin": [
    "NOUN"
  ],
  "notably": [
    "ADV"
  ],
  "trevor": [
    "PROPN"
  ],
  "homosexual": [
    "PROPN"
  ],
  "garment": [
    "NOUN"
  ],
  "bilingual": [
    "ADJ"
  ],
  "barbecue": [
    "PROPN"
  ],
  "localization": [
    "NOUN",
    "PROPN"
  ],
  "secondly": [
    "ADV"
  ],
  "razor": [
    "NOUN"
  ],
  "cough": [
    "NOUN"
  ],
  "cerebral": [
    "PROPN"
  ],
  "grandma": [
    "NOUN"
  ],
  "indexing": [
    "NOUN",
    "PROPN"
  ],
  "displacement": [
    "NOUN"
  ],
  "backwards": [
    "ADV"
  ],
  "telecommunication": [
    "NOUN"
  ],
  "presumably": [
    "ADV"
  ],
  "eureka": [
    "NOUN"
  ],
  "constructive": [
    "ADJ"
  ],
  "tibet": [
    "PROPN"
  ],
  "preparedness": [
    "NOUN"
  ],
  "systemic": [
    "ADJ"
  ],
  "esther": [
    "VERB"
  ],
  "abundant": [
    "ADJ"
  ],
  "deductible": [
    "ADJ"
  ],
  "accompany": [
    "NOUN"
  ],
  "forecasting": [
    "NOUN",
    "PROPN"
  ],
  "hesitate": [
    "VERB"
  ],
  "inspiring": [
    "VERB",
    "ADJ"
  ],
  "specialize": [
    "VERB"
  ],
  "deposition": [
    "NOUN"
  ],
  "laurie": [
    "PROPN"
  ],
  "zodiac": [
    "NOUN"
  ],
  "pavement": [
    "NOUN"
  ],
  "tubing": [
    "VERB"
  ],
  "pedestrian": [
    "NOUN"
  ],
  "fencing": [
    "VERB"
  ],
  "artery": [
    "NOUN"
  ],
  "conditioner": [
    "NOUN"
  ],
  "inlet": [
    "PROPN"
  ],
  "violate": [
    "VERB"
  ],
  "stimulate": [
    "VERB"
  ],
  "conveniently": [
    "ADV"
  ],
  "vanessa": [
    "ADV"
  ],
  "stealth": [
    "PROPN"
  ],
  "nucleotide": [
    "NOUN"
  ],
  "bronx": [
    "NOUN"
  ],
  "repayment": [
    "NOUN"
  ],
  "canopy": [
    "PROPN"
  ],
  "gloss": [
    "VERB"
  ],
  "panda": [
    "NOUN"
  ],
  "porch": [
    "NOUN"
  ],
  "pertinent": [
    "ADJ"
  ],
  "lifelong": [
    "ADJ"
  ],
  "promoter": [
    "NOUN"
  ],
  "collegiate": [
    "ADJ"
  ],
  "interchange": [
    "NOUN"
  ],
  "remotely": [
    "ADV"
  ],
  "fletcher": [
    "PROPN"
  ],
  "concise": [
    "ADJ",
    "NOUN"
  ],
  "handful": [
    "NOUN"
  ],
  "brains": [
    "NOUN"
  ],
  "eaten": [
    "VERB"
  ],
  "indigo": [
    "PROPN"
  ],
  "retaining": [
    "VERB"
  ],
  "autobiography": [
    "NOUN"
  ],
  "conditioned": [
    "VERB"
  ],
  "prohibition": [
    "NOUN"
  ],
  "redirect": [
    "VERB",
    "NOUN"
  ],
  "shampoo": [
    "NOUN"
  ],
  "emphasize": [
    "VERB"
  ],
  "excite": [
    "ADJ"
  ],
  "believing": [
    "VERB"
  ],
  "hilarious": [
    "ADJ"
  ],
  "pseudo": [
    "NOUN"
  ],
  "steep": [
    "ADJ",
    "PROPN"
  ],
  "dinar": [
    "PROPN"
  ],
  "dynasty": [
    "NOUN"
  ],
  "creed": [
    "NOUN"
  ],
  "carat": [
    "PROPN"
  ],
  "elegance": [
    "NOUN"
  ],
  "volatile": [
    "ADJ"
  ],
  "sensory": [
    "NOUN"
  ],
  "scrapbook": [
    "PROPN"
  ],
  "throne": [
    "NOUN"
  ],
  "magnesium": [
    "NOUN"
  ],
  "pagina": [
    "PROPN"
  ],
  "chartered": [
    "VERB"
  ],
  "socially": [
    "ADV"
  ],
  "unfortunate": [
    "ADJ"
  ],
  "roundup": [
    "ADJ"
  ],
  "territorial": [
    "ADJ"
  ],
  "randolph": [
    "PROPN"
  ],
  "plump": [
    "NOUN"
  ],
  "alkaline": [
    "NOUN"
  ],
  "expire": [
    "VERB"
  ],
  "midst": [
    "NOUN"
  ],
  "methyl": [
    "NOUN"
  ],
  "borne": [
    "VERB"
  ],
  "forgive": [
    "VERB"
  ],
  "ramada": [
    "PROPN"
  ],
  "competitor": [
    "NOUN",
    "PROPN"
  ],
  "marvin": [
    "PROPN"
  ],
  "usable": [
    "ADJ"
  ],
  "tempo": [
    "PROPN"
  ],
  "readable": [
    "ADJ"
  ],
  "almanac": [
    "NOUN"
  ],
  "denote": [
    "VERB"
  ],
  "slayer": [
    "NOUN"
  ],
  "tester": [
    "NOUN",
    "PROPN"
  ],
  "polling": [
    "NOUN",
    "VERB"
  ],
  "purchaser": [
    "NOUN"
  ],
  "tibetan": [
    "PROPN"
  ],
  "rodney": [
    "NOUN"
  ],
  "nationality": [
    "NOUN"
  ],
  "statistically": [
    "ADV"
  ],
  "torch": [
    "NOUN"
  ],
  "depressed": [
    "VERB"
  ],
  "symmetry": [
    "NOUN"
  ],
  "lohan": [
    "PROPN"
  ],
  "olympia": [
    "NOUN"
  ],
  "negligence": [
    "NOUN"
  ],
  "unclear": [
    "ADJ",
    "PROPN"
  ],
  "screened": [
    "VERB"
  ],
  "helper": [
    "NOUN",
    "PROPN"
  ],
  "carlisle": [
    "NOUN"
  ],
  "rancho": [
    "NOUN"
  ],
  "transferring": [
    "VERB"
  ],
  "stockton": [
    "PROPN"
  ],
  "stepping": [
    "VERB"
  ],
  "attic": [
    "NOUN"
  ],
  "topology": [
    "NOUN"
  ],
  "appetite": [
    "NOUN"
  ],
  "sensation": [
    "NOUN"
  ],
  "piper": [
    "NOUN"
  ],
  "morality": [
    "NOUN"
  ],
  "honorable": [
    "ADJ"
  ],
  "wealthy": [
    "ADJ"
  ],
  "handicap": [
    "ADJ"
  ],
  "skinny": [
    "ADJ"
  ],
  "sewage": [
    "NOUN"
  ],
  "endowment": [
    "NOUN"
  ],
  "trucking": [
    "NOUN"
  ],
  "defender": [
    "NOUN"
  ],
  "wretch": [
    "VERB"
  ],
  "sunlight": [
    "NOUN"
  ],
  "racist": [
    "NOUN"
  ],
  "profitability": [
    "NOUN"
  ],
  "convey": [
    "VERB"
  ],
  "evergreen": [
    "PROPN",
    "NOUN"
  ],
  "globally": [
    "ADV"
  ],
  "govern": [
    "VERB"
  ],
  "feather": [
    "PROPN"
  ],
  "sixteen": [
    "NUM"
  ],
  "tightly": [
    "ADV"
  ],
  "graded": [
    "VERB"
  ],
  "successor": [
    "NOUN"
  ],
  "intrusion": [
    "NOUN"
  ],
  "sickness": [
    "NOUN"
  ],
  "guiana": [
    "PROPN"
  ],
  "underneath": [
    "ADV"
  ],
  "prohibit": [
    "VERB"
  ],
  "metabolic": [
    "NOUN"
  ],
  "billed": [
    "VERB"
  ],
  "avery": [
    "NOUN"
  ],
  "danielle": [
    "PROPN"
  ],
  "brushes": [
    "NOUN"
  ],
  "tenth": [
    "ADV"
  ],
  "anthology": [
    "NOUN"
  ],
  "prosecutor": [
    "NOUN"
  ],
  "capsule": [
    "PROPN"
  ],
  "suspend": [
    "VERB",
    "NOUN"
  ],
  "eternity": [
    "NOUN"
  ],
  "weighing": [
    "VERB"
  ],
  "kindly": [
    "ADV"
  ],
  "cutie": [
    "NOUN"
  ],
  "notch": [
    "NOUN"
  ],
  "revealing": [
    "VERB"
  ],
  "fernando": [
    "NOUN"
  ],
  "resurrection": [
    "NOUN"
  ],
  "decree": [
    "VERB"
  ],
  "columnist": [
    "NOUN"
  ],
  "tuberculosis": [
    "NOUN"
  ],
  "transplantation": [
    "NOUN"
  ],
  "jerome": [
    "ADJ"
  ],
  "daytime": [
    "ADV"
  ],
  "elaborate": [
    "VERB"
  ],
  "contour": [
    "ADJ"
  ],
  "gamble": [
    "NOUN"
  ],
  "descent": [
    "NOUN"
  ],
  "gravel": [
    "NOUN"
  ],
  "analyse": [
    "PROPN",
    "VERB"
  ],
  "disturbing": [
    "VERB"
  ],
  "shutter": [
    "NOUN"
  ],
  "illusion": [
    "NOUN"
  ],
  "ambitious": [
    "ADJ"
  ],
  "notorious": [
    "ADJ"
  ],
  "residue": [
    "NOUN"
  ],
  "enlarged": [
    "VERB"
  ],
  "transforming": [
    "VERB"
  ],
  "sequential": [
    "ADJ"
  ],
  "stripping": [
    "VERB"
  ],
  "uniquely": [
    "ADV"
  ],
  "assert": [
    "VERB"
  ],
  "bowie": [
    "PROPN"
  ],
  "archaeological": [
    "ADJ"
  ],
  "inspect": [
    "VERB"
  ],
  "thrice": [
    "VERB"
  ],
  "babylon": [
    "NOUN"
  ],
  "casualty": [
    "NOUN"
  ],
  "whistler": [
    "NOUN"
  ],
  "mushroom": [
    "NOUN"
  ],
  "designate": [
    "VERB"
  ],
  "scent": [
    "NOUN"
  ],
  "sequel": [
    "NOUN"
  ],
  "gymnastics": [
    "NOUN"
  ],
  "titanic": [
    "ADJ"
  ],
  "exquisite": [
    "VERB"
  ],
  "upward": [
    "ADV"
  ],
  "contractual": [
    "ADJ"
  ],
  "unchanged": [
    "ADJ"
  ],
  "kicking": [
    "VERB"
  ],
  "grasp": [
    "VERB",
    "NOUN"
  ],
  "streak": [
    "VERB"
  ],
  "ounce": [
    "NOUN"
  ],
  "thirteen": [
    "NUM"
  ],
  "tragic": [
    "ADJ"
  ],
  "theodore": [
    "NOUN"
  ],
  "irrelevant": [
    "ADJ"
  ],
  "professionally": [
    "ADV"
  ],
  "sounding": [
    "VERB"
  ],
  "compressor": [
    "VERB"
  ],
  "toast": [
    "NOUN"
  ],
  "happily": [
    "ADV"
  ],
  "hooked": [
    "VERB"
  ],
  "samantha": [
    "VERB"
  ],
  "shrink": [
    "VERB"
  ],
  "carcinoma": [
    "NOUN"
  ],
  "unesco": [
    "PROPN"
  ],
  "mutually": [
    "ADV"
  ],
  "stance": [
    "NOUN"
  ],
  "beaded": [
    "VERB"
  ],
  "exodus": [
    "NOUN"
  ],
  "compartment": [
    "NOUN"
  ],
  "gemini": [
    "PROPN"
  ],
  "brittany": [
    "VERB"
  ],
  "derive": [
    "VERB"
  ],
  "affinity": [
    "NOUN"
  ],
  "presbyterian": [
    "PROPN"
  ],
  "supervisory": [
    "ADJ"
  ],
  "pretend": [
    "VERB"
  ],
  "buddhism": [
    "NOUN"
  ],
  "amnesty": [
    "PROPN"
  ],
  "chiropractic": [
    "ADJ"
  ],
  "borrower": [
    "NOUN"
  ],
  "gloucester": [
    "NOUN"
  ],
  "fairness": [
    "NOUN"
  ],
  "needles": [
    "NOUN"
  ],
  "throughput": [
    "NOUN",
    "PROPN"
  ],
  "quota": [
    "NOUN",
    "PROPN"
  ],
  "discreet": [
    "VERB"
  ],
  "misplace": [
    "NOUN"
  ],
  "lowell": [
    "NOUN"
  ],
  "whichever": [
    "DET"
  ],
  "elliot": [
    "NOUN"
  ],
  "opener": [
    "NOUN"
  ],
  "tuscany": [
    "NOUN"
  ],
  "jumbo": [
    "PROPN"
  ],
  "crowded": [
    "VERB"
  ],
  "tickling": [
    "VERB"
  ],
  "unspecified": [
    "ADJ"
  ],
  "turbine": [
    "VERB"
  ],
  "unreal": [
    "ADJ"
  ],
  "wounds": [
    "NOUN"
  ],
  "physiological": [
    "ADJ"
  ],
  "generalized": [
    "VERB"
  ],
  "unprecedented": [
    "ADJ"
  ],
  "frustration": [
    "NOUN"
  ],
  "flint": [
    "VERB"
  ],
  "financially": [
    "ADV"
  ],
  "awake": [
    "ADJ"
  ],
  "sanitation": [
    "NOUN"
  ],
  "americana": [
    "NOUN"
  ],
  "swivel": [
    "VERB"
  ],
  "cleanliness": [
    "NOUN"
  ],
  "varsity": [
    "NOUN"
  ],
  "collectively": [
    "ADV"
  ],
  "insurer": [
    "NOUN"
  ],
  "croatian": [
    "NOUN"
  ],
  "inhibition": [
    "NOUN"
  ],
  "burnt": [
    "VERB"
  ],
  "solidarity": [
    "NOUN"
  ],
  "inverse": [
    "NOUN"
  ],
  "verdict": [
    "NOUN"
  ],
  "nominee": [
    "NOUN"
  ],
  "proton": [
    "NOUN"
  ],
  "lister": [
    "ADV"
  ],
  "recurring": [
    "VERB"
  ],
  "allegedly": [
    "ADV"
  ],
  "rhetoric": [
    "NOUN"
  ],
  "incubus": [
    "PROPN"
  ],
  "impulse": [
    "PROPN"
  ],
  "ballroom": [
    "NOUN"
  ],
  "coherent": [
    "ADJ"
  ],
  "beetle": [
    "VERB"
  ],
  "majestic": [
    "ADJ"
  ],
  "roast": [
    "VERB"
  ],
  "complainant": [
    "VERB"
  ],
  "inhibitor": [
    "NOUN"
  ],
  "clifford": [
    "PROPN"
  ],
  "knowledgeable": [
    "ADJ"
  ],
  "critically": [
    "ADV"
  ],
  "hummer": [
    "PROPN"
  ],
  "reciprocal": [
    "ADJ"
  ],
  "accelerate": [
    "VERB",
    "PROPN"
  ],
  "hatred": [
    "NOUN"
  ],
  "putative": [
    "VERB"
  ],
  "manifest": [
    "NOUN",
    "ADJ"
  ],
  "petty": [
    "ADJ"
  ],
  "behave": [
    "VERB"
  ],
  "getaway": [
    "NOUN"
  ],
  "zeppelin": [
    "PUNCT"
  ],
  "felix": [
    "PROPN"
  ],
  "shiny": [
    "ADJ"
  ],
  "carmel": [
    "PROPN"
  ],
  "encore": [
    "PROPN"
  ],
  "smash": [
    "VERB"
  ],
  "angelina": [
    "NOUN"
  ],
  "kimberly": [
    "ADV"
  ],
  "unsure": [
    "ADJ",
    "PROPN"
  ],
  "destructive": [
    "ADJ"
  ],
  "claimant": [
    "NOUN"
  ],
  "dinosaur": [
    "NOUN"
  ],
  "ample": [
    "ADJ"
  ],
  "countless": [
    "ADJ"
  ],
  "abusive": [
    "ADJ"
  ],
  "sophomore": [
    "NOUN"
  ],
  "scarf": [
    "PROPN"
  ],
  "garland": [
    "VERB"
  ],
  "apprentice": [
    "NOUN"
  ],
  "obscure": [
    "VERB"
  ],
  "napoleon": [
    "PROPN"
  ],
  "glamour": [
    "NOUN"
  ],
  "trolley": [
    "NOUN"
  ],
  "sidney": [
    "PROPN"
  ],
  "spicy": [
    "NOUN"
  ],
  "blocker": [
    "NOUN",
    "PROPN"
  ],
  "frankly": [
    "ADV"
  ],
  "chronological": [
    "ADJ"
  ],
  "entrepreneurship": [
    "NOUN"
  ],
  "itinerary": [
    "ADJ"
  ],
  "beard": [
    "PROPN"
  ],
  "percentile": [
    "NOUN"
  ],
  "linkage": [
    "NOUN"
  ],
  "economical": [
    "ADJ"
  ],
  "wedge": [
    "NOUN"
  ],
  "peggy": [
    "ADJ"
  ],
  "sheila": [
    "VERB"
  ],
  "ripper": [
    "VERB"
  ],
  "benton": [
    "PROPN"
  ],
  "chateau": [
    "NOUN"
  ],
  "denis": [
    "PROPN"
  ],
  "homestead": [
    "PROPN"
  ],
  "competitiveness": [
    "VERB"
  ],
  "microscopy": [
    "PROPN"
  ],
  "changer": [
    "NOUN"
  ],
  "sergeant": [
    "NOUN"
  ],
  "syrian": [
    "ADJ"
  ],
  "hyper": [
    "VERB"
  ],
  "cypress": [
    "PROPN",
    "NOUN"
  ],
  "courtney": [
    "NOUN"
  ],
  "prospectus": [
    "NOUN"
  ],
  "reactive": [
    "NOUN",
    "ADJ"
  ],
  "encouragement": [
    "NOUN"
  ],
  "tailor": [
    "VERB",
    "NOUN"
  ],
  "directorate": [
    "NOUN"
  ],
  "savvy": [
    "PROPN"
  ],
  "pascal": [
    "PROPN"
  ],
  "serenity": [
    "NOUN"
  ],
  "attainment": [
    "PROPN",
    "ADJ"
  ],
  "sanitary": [
    "PROPN"
  ],
  "terri": [
    "NOUN"
  ],
  "fortunate": [
    "ADJ"
  ],
  "geoffrey": [
    "NOUN"
  ],
  "silva": [
    "NOUN"
  ],
  "grease": [
    "NOUN"
  ],
  "urinary": [
    "ADJ"
  ],
  "premise": [
    "NOUN",
    "PROPN"
  ],
  "epidemic": [
    "NOUN"
  ],
  "prima": [
    "NOUN"
  ],
  "cinnamon": [
    "PROPN"
  ],
  "underworld": [
    "NOUN"
  ],
  "fetal": [
    "ADJ"
  ],
  "seated": [
    "VERB"
  ],
  "lattice": [
    "NOUN"
  ],
  "realization": [
    "NOUN"
  ],
  "reportedly": [
    "ADV"
  ],
  "absorbed": [
    "VERB"
  ],
  "sirius": [
    "NOUN"
  ],
  "chord": [
    "NOUN"
  ],
  "asphalt": [
    "VERB"
  ],
  "replay": [
    "NOUN",
    "VERB"
  ],
  "improper": [
    "ADJ"
  ],
  "dilemma": [
    "NOUN"
  ],
  "tangible": [
    "ADJ"
  ],
  "smoked": [
    "VERB"
  ],
  "placebo": [
    "NOUN"
  ],
  "comet": [
    "PROPN"
  ],
  "baltic": [
    "ADJ"
  ],
  "corrective": [
    "ADJ"
  ],
  "competency": [
    "NOUN",
    "PROPN"
  ],
  "lotto": [
    "ADJ"
  ],
  "fowler": [
    "ADJ"
  ],
  "contingent": [
    "NOUN"
  ],
  "refreshing": [
    "ADJ",
    "VERB"
  ],
  "syrup": [
    "VERB"
  ],
  "warmth": [
    "NOUN"
  ],
  "correlated": [
    "VERB"
  ],
  "dominion": [
    "NOUN"
  ],
  "astronomical": [
    "ADJ"
  ],
  "solvent": [
    "NOUN"
  ],
  "toggle": [
    "NOUN",
    "PROPN"
  ],
  "amplitude": [
    "PROPN",
    "NOUN"
  ],
  "aesthetic": [
    "ADJ"
  ],
  "commercially": [
    "ADV"
  ],
  "wolfgang": [
    "PROPN"
  ],
  "spacing": [
    "VERB",
    "ADJ"
  ],
  "completeness": [
    "NOUN"
  ],
  "irregular": [
    "ADJ"
  ],
  "barker": [
    "PROPN"
  ],
  "filtration": [
    "NOUN"
  ],
  "certify": [
    "VERB"
  ],
  "eighteen": [
    "NUM"
  ],
  "singular": [
    "ADJ"
  ],
  "incremental": [
    "ADJ",
    "PROPN"
  ],
  "unacceptable": [
    "ADJ"
  ],
  "redistribute": [
    "VERB"
  ],
  "coping": [
    "VERB"
  ],
  "baxter": [
    "NOUN"
  ],
  "outbreak": [
    "VERB"
  ],
  "abdominal": [
    "ADJ"
  ],
  "curved": [
    "VERB"
  ],
  "milestone": [
    "PROPN",
    "NOUN"
  ],
  "erase": [
    "NOUN"
  ],
  "prose": [
    "VERB"
  ],
  "incidental": [
    "ADJ"
  ],
  "scalable": [
    "ADJ",
    "PROPN"
  ],
  "swear": [
    "VERB"
  ],
  "clown": [
    "ADP"
  ],
  "spontaneous": [
    "ADJ"
  ],
  "taboo": [
    "VERB"
  ],
  "equestrian": [
    "PROPN"
  ],
  "olson": [
    "PROPN"
  ],
  "malicious": [
    "ADJ"
  ],
  "consume": [
    "VERB"
  ],
  "amazed": [
    "VERB"
  ],
  "fourteen": [
    "NUM"
  ],
  "volcano": [
    "NOUN"
  ],
  "skeleton": [
    "PROPN",
    "NOUN"
  ],
  "someday": [
    "ADV"
  ],
  "exporter": [
    "NOUN"
  ],
  "honesty": [
    "NOUN"
  ],
  "dwarf": [
    "NOUN"
  ],
  "northeastern": [
    "ADJ"
  ],
  "rewarding": [
    "ADJ"
  ],
  "battalion": [
    "NOUN"
  ],
  "candid": [
    "ADJ"
  ],
  "schooling": [
    "VERB"
  ],
  "schoolgirl": [
    "ADJ"
  ],
  "caesar": [
    "PROPN"
  ],
  "stellar": [
    "ADJ"
  ],
  "davenport": [
    "NOUN"
  ],
  "monogram": [
    "NOUN"
  ],
  "philippe": [
    "PROPN"
  ],
  "relational": [
    "ADJ"
  ],
  "ornament": [
    "ADJ"
  ],
  "doesnt": [
    "AUX"
  ],
  "refrigeration": [
    "NOUN"
  ],
  "microscope": [
    "PROPN",
    "NOUN"
  ],
  "houghton": [
    "PROPN"
  ],
  "threaten": [
    "VERB"
  ],
  "decker": [
    "NOUN"
  ],
  "extern": [
    "PROPN"
  ],
  "kitten": [
    "VERB"
  ],
  "stealing": [
    "VERB"
  ],
  "glossy": [
    "ADJ"
  ],
  "haired": [
    "ADJ"
  ],
  "directional": [
    "ADJ"
  ],
  "pablo": [
    "NOUN"
  ],
  "lethal": [
    "VERB"
  ],
  "biographical": [
    "PROPN"
  ],
  "cavity": [
    "NOUN"
  ],
  "vladimir": [
    "NOUN"
  ],
  "probate": [
    "NOUN"
  ],
  "terrestrial": [
    "ADJ"
  ],
  "props": [
    "NOUN"
  ],
  "incense": [
    "NOUN"
  ],
  "dough": [
    "NOUN"
  ],
  "stool": [
    "PROPN"
  ],
  "towing": [
    "VERB"
  ],
  "rosemary": [
    "PROPN"
  ],
  "millionaire": [
    "NOUN"
  ],
  "turquoise": [
    "VERB"
  ],
  "archival": [
    "NOUN",
    "PROPN"
  ],
  "seismic": [
    "ADJ"
  ],
  "baccarat": [
    "PROPN"
  ],
  "boone": [
    "ADJ"
  ],
  "substituted": [
    "VERB"
  ],
  "horde": [
    "PROPN"
  ],
  "mommy": [
    "NOUN"
  ],
  "nanny": [
    "NOUN"
  ],
  "suburb": [
    "NOUN"
  ],
  "cohort": [
    "NOUN",
    "PROPN"
  ],
  "succession": [
    "NOUN"
  ],
  "glacier": [
    "ADJ"
  ],
  "pueblo": [
    "ADJ"
  ],
  "rigorous": [
    "ADJ"
  ],
  "allocate": [
    "VERB"
  ],
  "relieve": [
    "VERB"
  ],
  "aftermath": [
    "NOUN"
  ],
  "roach": [
    "VERB"
  ],
  "clarion": [
    "NOUN"
  ],
  "override": [
    "NOUN",
    "VERB"
  ],
  "angus": [
    "ADJ"
  ],
  "enthusiastic": [
    "ADJ"
  ],
  "continuum": [
    "VERB"
  ],
  "squeeze": [
    "NOUN"
  ],
  "burgundy": [
    "NOUN"
  ],
  "farewell": [
    "INTJ"
  ],
  "ashes": [
    "NOUN"
  ],
  "vanguard": [
    "PROPN"
  ],
  "natal": [
    "PROPN"
  ],
  "locus": [
    "NOUN"
  ],
  "hillary": [
    "PROPN"
  ],
  "factual": [
    "ADJ"
  ],
  "spectroscopy": [
    "VERB"
  ],
  "purity": [
    "NOUN"
  ],
  "shaking": [
    "VERB"
  ],
  "unregistered": [
    "VERB"
  ],
  "cellar": [
    "VERB"
  ],
  "friction": [
    "NOUN",
    "PROPN"
  ],
  "prone": [
    "ADJ"
  ],
  "valerie": [
    "PROPN"
  ],
  "equitable": [
    "ADJ"
  ],
  "lobster": [
    "PROPN"
  ],
  "judaism": [
    "NOUN"
  ],
  "bonding": [
    "VERB"
  ],
  "issuer": [
    "NOUN",
    "PROPN"
  ],
  "uncomfortable": [
    "ADJ"
  ],
  "sylvia": [
    "PROPN"
  ],
  "furnace": [
    "NOUN"
  ],
  "poisoning": [
    "VERB"
  ],
  "doubled": [
    "VERB"
  ],
  "malaysian": [
    "PROPN"
  ],
  "inflammation": [
    "NOUN"
  ],
  "transported": [
    "VERB"
  ],
  "goodwill": [
    "NOUN"
  ],
  "ideology": [
    "NOUN"
  ],
  "anxious": [
    "ADJ"
  ],
  "cervical": [
    "ADJ"
  ],
  "baptism": [
    "NOUN"
  ],
  "cutlery": [
    "NOUN"
  ],
  "attribution": [
    "NOUN",
    "PROPN"
  ],
  "advancing": [
    "VERB"
  ],
  "timed": [
    "VERB"
  ],
  "evolve": [
    "VERB",
    "PROPN"
  ],
  "suspicious": [
    "ADJ"
  ],
  "brewing": [
    "VERB"
  ],
  "blossom": [
    "NOUN"
  ],
  "scare": [
    "NOUN"
  ],
  "thief": [
    "NOUN"
  ],
  "pictured": [
    "VERB"
  ],
  "feminine": [
    "ADJ"
  ],
  "rocking": [
    "VERB"
  ],
  "nautical": [
    "ADJ"
  ],
  "imprisonment": [
    "NOUN"
  ],
  "pitcher": [
    "NOUN"
  ],
  "muscular": [
    "ADJ"
  ],
  "motif": [
    "NOUN"
  ],
  "saloon": [
    "ADV"
  ],
  "prophecy": [
    "NOUN"
  ],
  "historian": [
    "PROPN"
  ],
  "identifiable": [
    "ADJ"
  ],
  "facsimile": [
    "ADJ"
  ],
  "ethanol": [
    "NOUN"
  ],
  "cannabis": [
    "NOUN"
  ],
  "folded": [
    "VERB"
  ],
  "sofia": [
    "NOUN"
  ],
  "dynamically": [
    "ADV"
  ],
  "comprise": [
    "VERB"
  ],
  "disposed": [
    "VERB"
  ],
  "subtitle": [
    "VERB"
  ],
  "chestnut": [
    "NOUN"
  ],
  "engraved": [
    "VERB"
  ],
  "pastoral": [
    "PROPN"
  ],
  "unpaid": [
    "ADJ"
  ],
  "locality": [
    "NOUN"
  ],
  "substantive": [
    "ADJ"
  ],
  "spear": [
    "NOUN"
  ],
  "nigel": [
    "PROPN"
  ],
  "referee": [
    "VERB"
  ],
  "transporter": [
    "NOUN"
  ],
  "swinger": [
    "NOUN"
  ],
  "broadly": [
    "ADV"
  ],
  "ethereal": [
    "ADJ"
  ],
  "crossroads": [
    "NOUN"
  ],
  "smoothly": [
    "ADV"
  ],
  "blanc": [
    "NOUN"
  ],
  "autonomy": [
    "NOUN",
    "PROPN"
  ],
  "bounded": [
    "VERB"
  ],
  "insist": [
    "VERB"
  ],
  "birch": [
    "NOUN"
  ],
  "slash": [
    "NOUN"
  ],
  "resale": [
    "NOUN"
  ],
  "digestive": [
    "ADJ"
  ],
  "scalar": [
    "ADJ"
  ],
  "entertain": [
    "NOUN"
  ],
  "cinderella": [
    "NOUN"
  ],
  "unresolved": [
    "ADJ",
    "PROPN"
  ],
  "sesame": [
    "VERB"
  ],
  "electromagnetic": [
    "VERB"
  ],
  "joanne": [
    "NOUN"
  ],
  "housewife": [
    "NOUN"
  ],
  "corvette": [
    "PROPN"
  ],
  "stacy": [
    "NOUN"
  ],
  "christie": [
    "NOUN"
  ],
  "unrelated": [
    "ADJ"
  ],
  "annotate": [
    "PROPN"
  ],
  "misuse": [
    "NOUN"
  ],
  "helix": [
    "PROPN",
    "NOUN"
  ],
  "cosmos": [
    "PROPN"
  ],
  "speculation": [
    "NOUN"
  ],
  "dixie": [
    "PROPN"
  ],
  "enforced": [
    "VERB"
  ],
  "legion": [
    "PROPN"
  ],
  "fulfillment": [
    "NOUN"
  ],
  "assertion": [
    "NOUN"
  ],
  "hierarchical": [
    "ADJ"
  ],
  "shook": [
    "VERB"
  ],
  "dismissal": [
    "NOUN"
  ],
  "shocking": [
    "ADJ"
  ],
  "allergic": [
    "ADJ"
  ],
  "overland": [
    "NOUN"
  ],
  "isaiah": [
    "PROPN"
  ],
  "backbone": [
    "NOUN",
    "PROPN"
  ],
  "unanimously": [
    "ADV"
  ],
  "sausage": [
    "NOUN"
  ],
  "addict": [
    "NOUN"
  ],
  "matte": [
    "NOUN"
  ],
  "neighboring": [
    "VERB"
  ],
  "uncommon": [
    "ADJ"
  ],
  "heidi": [
    "PROPN"
  ],
  "unpublished": [
    "ADJ"
  ],
  "slaughter": [
    "NOUN"
  ],
  "enlightenment": [
    "PROPN"
  ],
  "pistol": [
    "NOUN"
  ],
  "seymour": [
    "VERB"
  ],
  "genetically": [
    "ADV"
  ],
  "zebra": [
    "NOUN"
  ],
  "runway": [
    "NOUN"
  ],
  "arithmetic": [
    "ADJ"
  ],
  "supposedly": [
    "ADV"
  ],
  "bombay": [
    "PROPN"
  ],
  "enrichment": [
    "NOUN"
  ],
  "buckle": [
    "VERB"
  ],
  "bartlett": [
    "PROPN"
  ],
  "fetch": [
    "VERB",
    "NOUN"
  ],
  "divers": [
    "NOUN"
  ],
  "speedway": [
    "PROPN"
  ],
  "upside": [
    "PROPN",
    "NOUN"
  ],
  "admiral": [
    "ADJ"
  ],
  "patron": [
    "NOUN"
  ],
  "boiler": [
    "NOUN"
  ],
  "anticipate": [
    "VERB"
  ],
  "induce": [
    "VERB"
  ],
  "padding": [
    "NOUN"
  ],
  "recruiter": [
    "PROPN",
    "NOUN"
  ],
  "popcorn": [
    "NOUN"
  ],
  "diagonal": [
    "ADJ"
  ],
  "unite": [
    "VERB"
  ],
  "cracked": [
    "VERB"
  ],
  "debtor": [
    "NOUN"
  ],
  "shear": [
    "NOUN"
  ],
  "mortal": [
    "ADJ"
  ],
  "sovereignty": [
    "NOUN"
  ],
  "supermarket": [
    "NOUN"
  ],
  "cleansing": [
    "VERB"
  ],
  "genomic": [
    "PROPN"
  ],
  "archery": [
    "NOUN"
  ],
  "sabbath": [
    "NOUN"
  ],
  "trump": [
    "NOUN"
  ],
  "precursor": [
    "NOUN"
  ],
  "avian": [
    "PROPN"
  ],
  "stella": [
    "NOUN"
  ],
  "matrices": [
    "NOUN"
  ],
  "anyways": [
    "ADV"
  ],
  "etiology": [
    "NOUN"
  ],
  "cereal": [
    "NOUN"
  ],
  "comprehension": [
    "NOUN"
  ],
  "mellon": [
    "PROPN"
  ],
  "alexandra": [
    "NOUN"
  ],
  "champ": [
    "NOUN"
  ],
  "hospice": [
    "NOUN"
  ],
  "agreeing": [
    "VERB"
  ],
  "exhibitor": [
    "NOUN"
  ],
  "rented": [
    "VERB"
  ],
  "brushed": [
    "VERB"
  ],
  "augmentation": [
    "NOUN"
  ],
  "annuity": [
    "NOUN"
  ],
  "assortment": [
    "NOUN"
  ],
  "credible": [
    "ADJ"
  ],
  "sportswear": [
    "PROPN"
  ],
  "cultured": [
    "VERB"
  ],
  "deliberately": [
    "ADV"
  ],
  "recap": [
    "NOUN",
    "PROPN"
  ],
  "openly": [
    "ADV"
  ],
  "crawl": [
    "NOUN"
  ],
  "sparkling": [
    "VERB"
  ],
  "jabber": [
    "NOUN"
  ],
  "convincing": [
    "ADJ"
  ],
  "rotate": [
    "VERB",
    "PROPN"
  ],
  "tracing": [
    "NOUN",
    "VERB"
  ],
  "amortization": [
    "NOUN"
  ],
  "neurology": [
    "NOUN"
  ],
  "fragile": [
    "ADJ"
  ],
  "jeremiah": [
    "PROPN"
  ],
  "serbian": [
    "PROPN"
  ],
  "radiator": [
    "NOUN"
  ],
  "rushing": [
    "VERB"
  ],
  "behold": [
    "VERB"
  ],
  "alteration": [
    "NOUN"
  ],
  "trainee": [
    "NOUN"
  ],
  "centennial": [
    "NOUN"
  ],
  "bluegrass": [
    "ADP"
  ],
  "hazel": [
    "ADJ"
  ],
  "ledger": [
    "PROPN"
  ],
  "scarlet": [
    "ADJ"
  ],
  "crushed": [
    "VERB"
  ],
  "connie": [
    "PROPN"
  ],
  "referendum": [
    "PROPN"
  ],
  "modulation": [
    "NOUN"
  ],
  "communion": [
    "NOUN"
  ],
  "loader": [
    "NOUN",
    "PROPN"
  ],
  "latency": [
    "PROPN",
    "NOUN"
  ],
  "messy": [
    "ADJ"
  ],
  "squadron": [
    "NOUN"
  ],
  "rupee": [
    "NOUN"
  ],
  "subsidy": [
    "NOUN"
  ],
  "demolition": [
    "NOUN"
  ],
  "irene": [
    "PROPN"
  ],
  "empowerment": [
    "NOUN"
  ],
  "felony": [
    "NOUN"
  ],
  "veronica": [
    "PROPN"
  ],
  "acupuncture": [
    "NOUN"
  ],
  "inviting": [
    "VERB"
  ],
  "gentoo": [
    "NOUN"
  ],
  "redevelopment": [
    "NOUN"
  ],
  "mustard": [
    "NOUN"
  ],
  "strait": [
    "ADJ"
  ],
  "masterpiece": [
    "NOUN"
  ],
  "donkey": [
    "NOUN"
  ],
  "triggered": [
    "VERB"
  ],
  "praying": [
    "VERB"
  ],
  "multiply": [
    "VERB"
  ],
  "intercourse": [
    "NOUN"
  ],
  "radial": [
    "ADJ"
  ],
  "routinely": [
    "ADV"
  ],
  "instructed": [
    "VERB"
  ],
  "stole": [
    "VERB"
  ],
  "avalanche": [
    "PROPN"
  ],
  "managerial": [
    "ADJ"
  ],
  "shaving": [
    "NOUN"
  ],
  "humorous": [
    "ADJ"
  ],
  "thunderbird": [
    "PROPN"
  ],
  "corona": [
    "NOUN"
  ],
  "griffith": [
    "ADP"
  ],
  "investigative": [
    "ADJ"
  ],
  "quasi": [
    "PROPN"
  ],
  "energetic": [
    "ADJ"
  ],
  "disturbance": [
    "NOUN"
  ],
  "saunders": [
    "NOUN"
  ],
  "exile": [
    "NOUN"
  ],
  "breastfeeding": [
    "VERB"
  ],
  "reside": [
    "VERB"
  ],
  "cashier": [
    "NOUN"
  ],
  "kathryn": [
    "PROPN"
  ],
  "motivational": [
    "NOUN"
  ],
  "anton": [
    "PROPN"
  ],
  "armenian": [
    "PROPN"
  ],
  "longitudinal": [
    "ADJ"
  ],
  "kappa": [
    "PROPN"
  ],
  "samson": [
    "NOUN"
  ],
  "blender": [
    "VERB"
  ],
  "fleming": [
    "NOUN"
  ],
  "blaster": [
    "NOUN"
  ],
  "optimistic": [
    "ADJ"
  ],
  "remediation": [
    "NOUN",
    "PROPN"
  ],
  "wasting": [
    "VERB"
  ],
  "genocide": [
    "NOUN"
  ],
  "seldom": [
    "ADV"
  ],
  "morrow": [
    "NOUN"
  ],
  "glitter": [
    "NOUN"
  ],
  "giovanni": [
    "PROPN"
  ],
  "snoop": [
    "NOUN"
  ],
  "awhile": [
    "ADV"
  ],
  "winery": [
    "NOUN"
  ],
  "scaled": [
    "VERB",
    "PROPN"
  ],
  "contingency": [
    "NOUN"
  ],
  "photon": [
    "NOUN"
  ],
  "wiltshire": [
    "PROPN"
  ],
  "vague": [
    "ADJ"
  ],
  "overlay": [
    "NOUN"
  ],
  "rusty": [
    "PROPN"
  ],
  "handicapped": [
    "VERB"
  ],
  "champaign": [
    "ADJ"
  ],
  "pakistani": [
    "ADJ"
  ],
  "harmless": [
    "ADJ"
  ],
  "sting": [
    "VERB"
  ],
  "bravo": [
    "PROPN"
  ],
  "diagnose": [
    "VERB",
    "NOUN"
  ],
  "franco": [
    "PROPN"
  ],
  "dispersion": [
    "NOUN"
  ],
  "curiosity": [
    "NOUN"
  ],
  "trivium": [
    "NOUN"
  ],
  "showroom": [
    "NOUN"
  ],
  "resting": [
    "VERB"
  ],
  "persistence": [
    "NOUN",
    "PROPN"
  ],
  "coarse": [
    "ADV"
  ],
  "liter": [
    "NOUN"
  ],
  "submarine": [
    "NOUN"
  ],
  "brendan": [
    "PROPN"
  ],
  "intrinsic": [
    "ADJ"
  ],
  "thoughtful": [
    "ADJ"
  ],
  "archer": [
    "PROPN"
  ],
  "warmer": [
    "ADJ"
  ],
  "basil": [
    "NOUN"
  ],
  "hallmark": [
    "NOUN"
  ],
  "paced": [
    "VERB"
  ],
  "grouped": [
    "VERB"
  ],
  "dominate": [
    "VERB"
  ],
  "orient": [
    "NOUN"
  ],
  "contra": [
    "PROPN"
  ],
  "boiling": [
    "VERB"
  ],
  "splitting": [
    "VERB",
    "NOUN"
  ],
  "abandon": [
    "VERB"
  ],
  "islander": [
    "NOUN"
  ],
  "nicolas": [
    "PROPN"
  ],
  "inference": [
    "NOUN"
  ],
  "transformer": [
    "NOUN",
    "PROPN"
  ],
  "chattanooga": [
    "NOUN"
  ],
  "giles": [
    "NOUN"
  ],
  "maroon": [
    "NOUN"
  ],
  "shack": [
    "VERB"
  ],
  "marrow": [
    "NOUN"
  ],
  "tavern": [
    "ADV"
  ],
  "bathing": [
    "VERB"
  ],
  "lambert": [
    "NOUN"
  ],
  "epilepsy": [
    "PROPN"
  ],
  "unhappy": [
    "ADJ"
  ],
  "foregoing": [
    "VERB"
  ],
  "crossover": [
    "NOUN"
  ],
  "specificity": [
    "NOUN"
  ],
  "certainty": [
    "NOUN"
  ],
  "sleek": [
    "VERB"
  ],
  "gerard": [
    "NOUN"
  ],
  "runoff": [
    "NOUN"
  ],
  "osteoporosis": [
    "NOUN"
  ],
  "antarctic": [
    "ADJ"
  ],
  "successive": [
    "ADJ"
  ],
  "ariel": [
    "PROPN"
  ],
  "monty": [
    "ADJ"
  ],
  "jukebox": [
    "PROPN"
  ],
  "hitch": [
    "PROPN"
  ],
  "fracture": [
    "VERB"
  ],
  "nexus": [
    "PROPN"
  ],
  "foremost": [
    "ADV"
  ],
  "nineteenth": [
    "PROPN"
  ],
  "chesapeake": [
    "VERB"
  ],
  "tango": [
    "PROPN"
  ],
  "melting": [
    "VERB"
  ],
  "mahogany": [
    "NOUN"
  ],
  "clarence": [
    "NOUN"
  ],
  "ernst": [
    "VERB"
  ],
  "garner": [
    "NOUN"
  ],
  "buster": [
    "NOUN"
  ],
  "nassau": [
    "PROPN"
  ],
  "ignorant": [
    "ADJ"
  ],
  "allowable": [
    "ADJ"
  ],
  "karate": [
    "VERB"
  ],
  "marcos": [
    "PROPN"
  ],
  "sorrow": [
    "NOUN"
  ],
  "carte": [
    "NOUN"
  ],
  "canned": [
    "VERB"
  ],
  "endurance": [
    "NOUN"
  ],
  "teaspoon": [
    "NOUN"
  ],
  "insulated": [
    "VERB"
  ],
  "philosopher": [
    "NOUN"
  ],
  "rectangle": [
    "VERB"
  ],
  "wrapper": [
    "NOUN",
    "PROPN"
  ],
  "ahmed": [
    "VERB"
  ],
  "buchanan": [
    "PROPN"
  ],
  "drummer": [
    "NOUN"
  ],
  "guitarist": [
    "NOUN"
  ],
  "symmetric": [
    "PROPN"
  ],
  "appellate": [
    "ADJ"
  ],
  "comma": [
    "NOUN"
  ],
  "conformity": [
    "NOUN"
  ],
  "insightful": [
    "ADJ"
  ],
  "supper": [
    "VERB"
  ],
  "hooded": [
    "VERB"
  ],
  "unrated": [
    "ADJ"
  ],
  "instability": [
    "NOUN"
  ],
  "seminary": [
    "ADJ"
  ],
  "presenter": [
    "PROPN",
    "NOUN"
  ],
  "emulation": [
    "NOUN"
  ],
  "lengthy": [
    "ADJ"
  ],
  "sonata": [
    "NOUN"
  ],
  "fortress": [
    "PROPN"
  ],
  "contiguous": [
    "ADJ"
  ],
  "inaccurate": [
    "ADJ"
  ],
  "explanatory": [
    "ADJ"
  ],
  "ministerial": [
    "ADJ"
  ],
  "torah": [
    "PROPN"
  ],
  "bipolar": [
    "ADJ"
  ],
  "sermon": [
    "PROPN"
  ],
  "thrill": [
    "NOUN"
  ],
  "lagoon": [
    "NOUN"
  ],
  "undoubtedly": [
    "ADV"
  ],
  "menopause": [
    "PROPN"
  ],
  "inbound": [
    "ADJ",
    "PROPN"
  ],
  "withheld": [
    "VERB"
  ],
  "eclectic": [
    "ADJ"
  ],
  "reluctant": [
    "ADJ"
  ],
  "headphone": [
    "NOUN"
  ],
  "ramsey": [
    "NOUN"
  ],
  "pigeon": [
    "NOUN"
  ],
  "freed": [
    "VERB"
  ],
  "binder": [
    "NOUN"
  ],
  "constrained": [
    "VERB"
  ],
  "parrot": [
    "ADV"
  ],
  "magnum": [
    "PROPN"
  ],
  "invaluable": [
    "ADJ"
  ],
  "keystone": [
    "NOUN"
  ],
  "intercontinental": [
    "ADJ"
  ],
  "cheek": [
    "VERB"
  ],
  "traction": [
    "NOUN"
  ],
  "utterly": [
    "ADV"
  ],
  "illuminated": [
    "ADJ"
  ],
  "psychologist": [
    "NOUN"
  ],
  "claudia": [
    "NOUN"
  ],
  "perpetual": [
    "ADJ"
  ],
  "subsystem": [
    "NOUN"
  ],
  "kinetic": [
    "PROPN"
  ],
  "caffeine": [
    "NOUN"
  ],
  "solicitor": [
    "NOUN"
  ],
  "clustering": [
    "NOUN",
    "VERB"
  ],
  "glimpse": [
    "NOUN"
  ],
  "verbatim": [
    "ADV"
  ],
  "innocence": [
    "NOUN"
  ],
  "cardboard": [
    "NOUN"
  ],
  "attributable": [
    "ADJ"
  ],
  "angelo": [
    "PROPN"
  ],
  "tertiary": [
    "ADJ"
  ],
  "exhausted": [
    "VERB"
  ],
  "attain": [
    "VERB"
  ],
  "calorie": [
    "NOUN"
  ],
  "inconvenience": [
    "NOUN"
  ],
  "graphite": [
    "NOUN"
  ],
  "vaccination": [
    "NOUN"
  ],
  "stroller": [
    "NOUN"
  ],
  "farther": [
    "ADV"
  ],
  "bowel": [
    "VERB"
  ],
  "mandarin": [
    "NOUN"
  ],
  "dungeon": [
    "PROPN"
  ],
  "predictable": [
    "ADJ"
  ],
  "shire": [
    "VERB"
  ],
  "susceptible": [
    "ADJ"
  ],
  "mosquito": [
    "PROPN"
  ],
  "corpse": [
    "NOUN"
  ],
  "speedy": [
    "ADJ"
  ],
  "cabling": [
    "VERB"
  ],
  "analogue": [
    "NOUN"
  ],
  "werner": [
    "NOUN"
  ],
  "clyde": [
    "PROPN"
  ],
  "perimeter": [
    "NOUN"
  ],
  "cardiology": [
    "NOUN"
  ],
  "honorary": [
    "PROPN"
  ],
  "irwin": [
    "PROPN"
  ],
  "brewer": [
    "NOUN"
  ],
  "adhere": [
    "VERB"
  ],
  "grilled": [
    "VERB"
  ],
  "rafael": [
    "PROPN"
  ],
  "enquire": [
    "VERB"
  ],
  "mains": [
    "NOUN"
  ],
  "misty": [
    "PROPN"
  ],
  "lindsey": [
    "NOUN"
  ],
  "parity": [
    "NOUN",
    "PROPN"
  ],
  "rewrite": [
    "VERB"
  ],
  "vending": [
    "VERB"
  ],
  "prism": [
    "NOUN"
  ],
  "chasing": [
    "VERB"
  ],
  "aggregation": [
    "NOUN",
    "PROPN"
  ],
  "batting": [
    "VERB"
  ],
  "prentice": [
    "NOUN"
  ],
  "winding": [
    "VERB"
  ],
  "congressman": [
    "NOUN"
  ],
  "cobalt": [
    "NOUN"
  ],
  "downward": [
    "ADJ"
  ],
  "synergy": [
    "NOUN"
  ],
  "aspire": [
    "NOUN"
  ],
  "groom": [
    "VERB"
  ],
  "saturated": [
    "VERB"
  ],
  "accidentally": [
    "ADV"
  ],
  "doughty": [
    "ADV"
  ],
  "bonded": [
    "VERB"
  ],
  "sticking": [
    "VERB"
  ],
  "dudley": [
    "PROPN"
  ],
  "stripped": [
    "VERB"
  ],
  "inflatable": [
    "ADJ"
  ],
  "clive": [
    "ADJ"
  ],
  "fixture": [
    "NOUN"
  ],
  "glassware": [
    "VERB"
  ],
  "canary": [
    "NOUN",
    "PROPN"
  ],
  "steadily": [
    "ADV"
  ],
  "darby": [
    "PROPN"
  ],
  "clergy": [
    "PROPN"
  ],
  "kayak": [
    "NOUN"
  ],
  "moderately": [
    "ADV"
  ],
  "altar": [
    "NOUN"
  ],
  "salvage": [
    "NOUN"
  ],
  "repetitive": [
    "ADJ"
  ],
  "orbital": [
    "ADJ"
  ],
  "lithuanian": [
    "PROPN"
  ],
  "oyster": [
    "VERB"
  ],
  "sturdy": [
    "ADJ"
  ],
  "massacre": [
    "NOUN"
  ],
  "undergo": [
    "VERB"
  ],
  "panoramic": [
    "NOUN"
  ],
  "risen": [
    "VERB"
  ],
  "blended": [
    "PROPN"
  ],
  "rhino": [
    "NOUN"
  ],
  "polynomial": [
    "ADJ"
  ],
  "imperative": [
    "ADJ"
  ],
  "stakeholder": [
    "NOUN",
    "PROPN"
  ],
  "digging": [
    "VERB"
  ],
  "lantern": [
    "VERB"
  ],
  "evangelical": [
    "ADJ"
  ],
  "ruler": [
    "NOUN"
  ],
  "stochastic": [
    "NOUN"
  ],
  "piping": [
    "VERB"
  ],
  "swept": [
    "VERB"
  ],
  "airmail": [
    "VERB"
  ],
  "staring": [
    "VERB"
  ],
  "seventy": [
    "NUM"
  ],
  "problematic": [
    "ADJ"
  ],
  "troop": [
    "NOUN"
  ],
  "arose": [
    "VERB"
  ],
  "decomposition": [
    "NOUN",
    "PROPN"
  ],
  "becky": [
    "PROPN"
  ],
  "supporter": [
    "NOUN"
  ],
  "klaus": [
    "NOUN"
  ],
  "conquest": [
    "NOUN"
  ],
  "workbook": [
    "PROPN"
  ],
  "assemble": [
    "VERB"
  ],
  "hogan": [
    "PROPN"
  ],
  "whistle": [
    "PROPN"
  ],
  "diversified": [
    "VERB"
  ],
  "fertilizer": [
    "NOUN"
  ],
  "analytic": [
    "ADJ"
  ],
  "predominantly": [
    "ADV"
  ],
  "amethyst": [
    "NOUN"
  ],
  "woodward": [
    "PROPN"
  ],
  "concerto": [
    "NOUN"
  ],
  "adorable": [
    "ADJ"
  ],
  "ambition": [
    "NOUN"
  ],
  "apologize": [
    "VERB"
  ],
  "restraint": [
    "NOUN"
  ],
  "condemned": [
    "VERB"
  ],
  "berger": [
    "PROPN"
  ],
  "timeless": [
    "NOUN"
  ],
  "parole": [
    "NOUN"
  ],
  "corey": [
    "PROPN"
  ],
  "ninety": [
    "NUM"
  ],
  "stewardship": [
    "NOUN"
  ],
  "flock": [
    "NOUN"
  ],
  "arabian": [
    "PROPN"
  ],
  "subpart": [
    "VERB"
  ],
  "bending": [
    "VERB"
  ],
  "boris": [
    "PROPN"
  ],
  "hypnosis": [
    "NOUN"
  ],
  "ammunition": [
    "NOUN"
  ],
  "cornerstone": [
    "NOUN"
  ],
  "recycle": [
    "NOUN"
  ],
  "shave": [
    "VERB"
  ],
  "disruption": [
    "NOUN"
  ],
  "artillery": [
    "NOUN"
  ],
  "furnish": [
    "VERB"
  ],
  "precedence": [
    "NOUN"
  ],
  "applicability": [
    "NOUN"
  ],
  "volatility": [
    "NOUN"
  ],
  "grinding": [
    "VERB"
  ],
  "rubbish": [
    "PROPN"
  ],
  "missionary": [
    "VERB"
  ],
  "swamp": [
    "NOUN"
  ],
  "pitching": [
    "VERB"
  ],
  "bordeaux": [
    "PROPN"
  ],
  "manifold": [
    "PROPN",
    "ADJ"
  ],
  "tornado": [
    "PROPN"
  ],
  "possessed": [
    "VERB"
  ],
  "upstairs": [
    "ADV"
  ],
  "vauxhall": [
    "NOUN"
  ],
  "welcoming": [
    "VERB"
  ],
  "manipulate": [
    "VERB"
  ],
  "dividing": [
    "VERB"
  ],
  "hickory": [
    "ADV"
  ],
  "tokelau": [
    "VERB"
  ],
  "conformance": [
    "PROPN",
    "NOUN"
  ],
  "lawson": [
    "PROPN"
  ],
  "damned": [
    "VERB"
  ],
  "faint": [
    "NOUN"
  ],
  "rebuilt": [
    "VERB"
  ],
  "collaborate": [
    "VERB",
    "NOUN"
  ],
  "tentative": [
    "ADJ",
    "PROPN"
  ],
  "fierce": [
    "ADJ"
  ],
  "authenticity": [
    "NOUN"
  ],
  "gland": [
    "CCONJ"
  ],
  "resignation": [
    "NOUN"
  ],
  "striped": [
    "VERB"
  ],
  "fraternity": [
    "NOUN"
  ],
  "lymphoma": [
    "PROPN"
  ],
  "tapestry": [
    "NOUN"
  ],
  "inevitably": [
    "ADV"
  ],
  "converse": [
    "VERB"
  ],
  "gardener": [
    "NOUN"
  ],
  "winnie": [
    "PROPN"
  ],
  "stoke": [
    "NOUN"
  ],
  "escrow": [
    "VERB"
  ],
  "anthem": [
    "NOUN"
  ],
  "nowadays": [
    "ADV"
  ],
  "inferior": [
    "ADJ"
  ],
  "jockey": [
    "NOUN"
  ],
  "indicative": [
    "ADJ"
  ],
  "incumbent": [
    "ADJ"
  ],
  "ithaca": [
    "PROPN"
  ],
  "edmund": [
    "ADV"
  ],
  "peoria": [
    "PROPN"
  ],
  "upholstery": [
    "NOUN"
  ],
  "aggression": [
    "NOUN"
  ],
  "practiced": [
    "VERB"
  ],
  "monarch": [
    "NOUN",
    "PROPN"
  ],
  "temptation": [
    "NOUN"
  ],
  "havana": [
    "PROPN"
  ],
  "campground": [
    "NOUN"
  ],
  "nasal": [
    "PROPN"
  ],
  "restrictive": [
    "ADJ"
  ],
  "costing": [
    "VERB"
  ],
  "ranged": [
    "VERB"
  ],
  "predictive": [
    "ADJ",
    "PROPN"
  ],
  "aquaculture": [
    "NOUN"
  ],
  "spruce": [
    "VERB"
  ],
  "paradox": [
    "NOUN"
  ],
  "redesign": [
    "NOUN",
    "VERB"
  ],
  "jeanne": [
    "PROPN"
  ],
  "nitro": [
    "PROPN"
  ],
  "oxidation": [
    "NOUN"
  ],
  "halfway": [
    "ADV"
  ],
  "cortex": [
    "NOUN"
  ],
  "entitlement": [
    "NOUN",
    "PROPN"
  ],
  "conflicting": [
    "VERB",
    "ADJ"
  ],
  "georgian": [
    "PROPN"
  ],
  "compensate": [
    "VERB"
  ],
  "recherche": [
    "NOUN"
  ],
  "loser": [
    "NOUN"
  ],
  "accountancy": [
    "NOUN"
  ],
  "cracking": [
    "VERB"
  ],
  "interrupted": [
    "VERB"
  ],
  "hemisphere": [
    "VERB"
  ],
  "miranda": [
    "NOUN"
  ],
  "clover": [
    "NOUN"
  ],
  "kindness": [
    "NOUN"
  ],
  "porto": [
    "PROPN"
  ],
  "neutron": [
    "NOUN"
  ],
  "jolly": [
    "ADV"
  ],
  "swelling": [
    "VERB"
  ],
  "politician": [
    "NOUN"
  ],
  "unanimous": [
    "ADJ"
  ],
  "misconduct": [
    "NOUN"
  ],
  "lester": [
    "NOUN"
  ],
  "folklore": [
    "VERB"
  ],
  "wording": [
    "NOUN"
  ],
  "obliged": [
    "VERB"
  ],
  "perceive": [
    "VERB"
  ],
  "rockies": [
    "NOUN"
  ],
  "siege": [
    "NOUN"
  ],
  "acoustics": [
    "NOUN"
  ],
  "voluntarily": [
    "ADV"
  ],
  "pensacola": [
    "PROPN"
  ],
  "condominium": [
    "NOUN"
  ],
  "grouping": [
    "VERB",
    "NOUN"
  ],
  "redwood": [
    "NOUN"
  ],
  "thereto": [
    "VERB"
  ],
  "enamel": [
    "PROPN"
  ],
  "radiant": [
    "NOUN"
  ],
  "estonian": [
    "PROPN"
  ],
  "firstly": [
    "ADV"
  ],
  "butte": [
    "PROPN"
  ],
  "bomber": [
    "NOUN"
  ],
  "suspicion": [
    "NOUN"
  ],
  "disadvantage": [
    "NOUN"
  ],
  "coaster": [
    "NOUN"
  ],
  "pratt": [
    "PROPN"
  ],
  "pedigree": [
    "VERB"
  ],
  "fraudulent": [
    "ADJ"
  ],
  "woodworking": [
    "VERB"
  ],
  "forgiveness": [
    "NOUN"
  ],
  "almond": [
    "NOUN"
  ],
  "catalytic": [
    "ADJ"
  ],
  "trenton": [
    "INTJ"
  ],
  "chalk": [
    "VERB"
  ],
  "alexis": [
    "PROPN"
  ],
  "bethesda": [
    "NOUN"
  ],
  "sanford": [
    "PROPN"
  ],
  "puppet": [
    "NOUN"
  ],
  "testosterone": [
    "NOUN"
  ],
  "cultivation": [
    "NOUN"
  ],
  "surveying": [
    "VERB"
  ],
  "grazing": [
    "VERB"
  ],
  "biochemical": [
    "ADJ"
  ],
  "pillar": [
    "NOUN",
    "PROPN"
  ],
  "mirage": [
    "NOUN"
  ],
  "questionable": [
    "ADJ"
  ],
  "seaside": [
    "NOUN"
  ],
  "suitability": [
    "NOUN"
  ],
  "precinct": [
    "ADJ"
  ],
  "unbelievable": [
    "ADJ"
  ],
  "soluble": [
    "ADJ"
  ],
  "piracy": [
    "NOUN"
  ],
  "rowing": [
    "VERB"
  ],
  "siding": [
    "VERB"
  ],
  "invitational": [
    "NOUN"
  ],
  "blanca": [
    "PROPN"
  ],
  "johann": [
    "PROPN"
  ],
  "pineapple": [
    "NOUN"
  ],
  "freeway": [
    "NOUN"
  ],
  "wrath": [
    "NOUN"
  ],
  "peculiar": [
    "ADJ"
  ],
  "commence": [
    "VERB"
  ],
  "safeguard": [
    "VERB"
  ],
  "digitally": [
    "ADV"
  ],
  "obsession": [
    "NOUN"
  ],
  "grind": [
    "NOUN"
  ],
  "albeit": [
    "SCONJ"
  ],
  "billiards": [
    "NOUN"
  ],
  "clint": [
    "NOUN"
  ],
  "righteous": [
    "ADJ"
  ],
  "redistribution": [
    "NOUN"
  ],
  "subclass": [
    "NOUN"
  ],
  "sincere": [
    "ADJ"
  ],
  "roanoke": [
    "VERB"
  ],
  "intentionally": [
    "ADV"
  ],
  "blitz": [
    "PROPN",
    "NOUN"
  ],
  "censorship": [
    "NOUN"
  ],
  "cactus": [
    "NOUN"
  ],
  "treadmill": [
    "NOUN"
  ],
  "splendid": [
    "VERB"
  ],
  "janice": [
    "PROPN"
  ],
  "personalize": [
    "VERB"
  ],
  "scissors": [
    "NOUN"
  ],
  "jorge": [
    "VERB"
  ],
  "sharply": [
    "ADV"
  ],
  "granada": [
    "NOUN"
  ],
  "laurence": [
    "NOUN"
  ],
  "rebellion": [
    "NOUN"
  ],
  "rainy": [
    "ADJ"
  ],
  "regent": [
    "VERB"
  ],
  "evelyn": [
    "VERB"
  ],
  "vinegar": [
    "NOUN"
  ],
  "pluto": [
    "NOUN"
  ],
  "fisherman": [
    "NOUN"
  ],
  "misery": [
    "NOUN"
  ],
  "undergoing": [
    "VERB"
  ],
  "limerick": [
    "VERB"
  ],
  "mitch": [
    "NOUN"
  ],
  "sweeping": [
    "VERB"
  ],
  "mailer": [
    "NOUN"
  ],
  "preface": [
    "NOUN"
  ],
  "grievance": [
    "NOUN"
  ],
  "unread": [
    "VERB"
  ],
  "sentiment": [
    "NOUN",
    "PROPN"
  ],
  "galloway": [
    "NOUN"
  ],
  "kristin": [
    "PROPN"
  ],
  "forged": [
    "VERB"
  ],
  "bistro": [
    "VERB"
  ],
  "viola": [
    "PROPN"
  ],
  "voodoo": [
    "PROPN"
  ],
  "provence": [
    "NOUN"
  ],
  "rustic": [
    "ADJ"
  ],
  "rumor": [
    "NOUN"
  ],
  "eleanor": [
    "NOUN"
  ],
  "deception": [
    "NOUN"
  ],
  "rushed": [
    "VERB"
  ],
  "excalibur": [
    "PROPN"
  ],
  "magnolia": [
    "PROPN"
  ],
  "diver": [
    "NOUN"
  ],
  "disappointment": [
    "NOUN"
  ],
  "plateau": [
    "NOUN"
  ],
  "interpersonal": [
    "ADJ"
  ],
  "dexter": [
    "NOUN"
  ],
  "traumatic": [
    "NOUN"
  ],
  "ringer": [
    "VERB"
  ],
  "zipper": [
    "X"
  ],
  "palette": [
    "NOUN",
    "PROPN"
  ],
  "blaze": [
    "VERB"
  ],
  "wreck": [
    "NOUN"
  ],
  "sammy": [
    "PROPN"
  ],
  "adversely": [
    "ADV"
  ],
  "devastating": [
    "ADJ"
  ],
  "robbery": [
    "NOUN"
  ],
  "jasmine": [
    "NOUN"
  ],
  "crochet": [
    "PROPN"
  ],
  "brock": [
    "NOUN"
  ],
  "macon": [
    "NOUN"
  ],
  "lynne": [
    "PROPN"
  ],
  "invariant": [
    "ADJ"
  ],
  "challenger": [
    "VERB"
  ],
  "increment": [
    "PROPN",
    "NOUN"
  ],
  "uptake": [
    "NOUN"
  ],
  "geared": [
    "VERB"
  ],
  "chloe": [
    "PROPN"
  ],
  "tycoon": [
    "NOUN"
  ],
  "malignant": [
    "ADJ"
  ],
  "dismiss": [
    "VERB"
  ],
  "lawful": [
    "ADJ"
  ],
  "crosby": [
    "NOUN"
  ],
  "antibiotic": [
    "ADJ"
  ],
  "diversion": [
    "NOUN"
  ],
  "overweight": [
    "ADJ"
  ],
  "maureen": [
    "PROPN"
  ],
  "reversal": [
    "PROPN"
  ],
  "ordination": [
    "NOUN"
  ],
  "tandem": [
    "NOUN"
  ],
  "deliberate": [
    "ADJ"
  ],
  "dementia": [
    "PROPN"
  ],
  "barley": [
    "NOUN"
  ],
  "potent": [
    "VERB"
  ],
  "amusing": [
    "ADJ"
  ],
  "shoppy": [
    "ADJ"
  ],
  "guidebook": [
    "NOUN"
  ],
  "chimney": [
    "NOUN"
  ],
  "naomi": [
    "NOUN"
  ],
  "risky": [
    "ADJ"
  ],
  "mistaken": [
    "VERB"
  ],
  "carving": [
    "VERB"
  ],
  "slipped": [
    "VERB"
  ],
  "realism": [
    "NOUN"
  ],
  "crete": [
    "ADJ"
  ],
  "disconnect": [
    "NOUN"
  ],
  "bloodhound": [
    "VERB"
  ],
  "multilingual": [
    "ADJ"
  ],
  "sherry": [
    "PROPN"
  ],
  "desperately": [
    "ADV"
  ],
  "indies": [
    "NOUN"
  ],
  "tulip": [
    "VERB"
  ],
  "madame": [
    "NOUN"
  ],
  "remedial": [
    "ADJ"
  ],
  "immunization": [
    "NOUN"
  ],
  "dalton": [
    "PROPN"
  ],
  "bologna": [
    "NOUN"
  ],
  "barefoot": [
    "VERB"
  ],
  "remuneration": [
    "NOUN"
  ],
  "bohemian": [
    "PROPN"
  ],
  "imposing": [
    "VERB"
  ],
  "damon": [
    "PROPN"
  ],
  "tivoli": [
    "NOUN"
  ],
  "receivable": [
    "ADJ",
    "PROPN"
  ],
  "evacuation": [
    "NOUN"
  ],
  "owing": [
    "VERB"
  ],
  "implant": [
    "ADJ"
  ],
  "thematic": [
    "ADJ"
  ],
  "correctional": [
    "ADJ"
  ],
  "reinforce": [
    "VERB"
  ],
  "inception": [
    "NOUN"
  ],
  "draper": [
    "VERB"
  ],
  "bowman": [
    "PROPN"
  ],
  "subversion": [
    "NOUN"
  ],
  "benny": [
    "NOUN"
  ],
  "barney": [
    "PROPN"
  ],
  "dinnerware": [
    "VERB"
  ],
  "sclerosis": [
    "NOUN"
  ],
  "homosexuality": [
    "NOUN"
  ],
  "emotionally": [
    "ADV"
  ],
  "masonry": [
    "NOUN"
  ],
  "carbohydrate": [
    "NOUN"
  ],
  "medicinal": [
    "ADJ"
  ],
  "estrogen": [
    "VERB"
  ],
  "realizing": [
    "VERB"
  ],
  "indoors": [
    "NOUN"
  ],
  "magellan": [
    "PROPN"
  ],
  "addicted": [
    "VERB"
  ],
  "flashlight": [
    "NOUN"
  ],
  "disappointing": [
    "ADJ"
  ],
  "eighty": [
    "NUM"
  ],
  "staging": [
    "NOUN",
    "PROPN"
  ],
  "unlocked": [
    "VERB",
    "ADJ"
  ],
  "scarce": [
    "ADJ"
  ],
  "statistic": [
    "NOUN"
  ],
  "ropes": [
    "NOUN"
  ],
  "obedience": [
    "NOUN"
  ],
  "plague": [
    "NOUN"
  ],
  "diluted": [
    "VERB"
  ],
  "canine": [
    "VERB"
  ],
  "gladly": [
    "ADV"
  ],
  "schizophrenia": [
    "NOUN"
  ],
  "brewery": [
    "NOUN"
  ],
  "lineage": [
    "NOUN"
  ],
  "julius": [
    "PROPN"
  ],
  "morse": [
    "VERB"
  ],
  "dominance": [
    "NOUN"
  ],
  "piston": [
    "NOUN"
  ],
  "sealing": [
    "VERB"
  ],
  "topped": [
    "VERB"
  ],
  "despair": [
    "NOUN"
  ],
  "absorb": [
    "VERB",
    "PROPN"
  ],
  "commodore": [
    "NOUN"
  ],
  "dumping": [
    "VERB"
  ],
  "enlisted": [
    "VERB"
  ],
  "supernatural": [
    "ADJ"
  ],
  "magenta": [
    "NOUN"
  ],
  "ditch": [
    "NOUN"
  ],
  "feared": [
    "VERB"
  ],
  "prelude": [
    "VERB"
  ],
  "slick": [
    "ADJ"
  ],
  "overly": [
    "ADV"
  ],
  "limestone": [
    "NOUN"
  ],
  "impedance": [
    "NOUN"
  ],
  "dragonfly": [
    "PROPN"
  ],
  "chunk": [
    "NOUN",
    "PROPN"
  ],
  "slept": [
    "VERB"
  ],
  "gregg": [
    "NOUN"
  ],
  "billboard": [
    "NOUN"
  ],
  "chalet": [
    "ADJ"
  ],
  "layered": [
    "VERB"
  ],
  "hopper": [
    "NOUN"
  ],
  "neurological": [
    "ADJ"
  ],
  "specialization": [
    "PROPN",
    "NOUN"
  ],
  "abstraction": [
    "NOUN"
  ],
  "ludwig": [
    "PROPN"
  ],
  "watchdog": [
    "NOUN"
  ],
  "scandinavian": [
    "PROPN"
  ],
  "viability": [
    "NOUN"
  ],
  "luncheon": [
    "PROPN"
  ],
  "filler": [
    "NOUN"
  ],
  "zenith": [
    "PROPN"
  ],
  "tenor": [
    "NOUN"
  ],
  "ovarian": [
    "PROPN"
  ],
  "softly": [
    "ADV"
  ],
  "plenary": [
    "ADJ"
  ],
  "scrub": [
    "PROPN"
  ],
  "wilkinson": [
    "NOUN"
  ],
  "intestinal": [
    "ADJ"
  ],
  "cello": [
    "PROPN"
  ],
  "refusing": [
    "VERB"
  ],
  "occupy": [
    "VERB"
  ],
  "bethlehem": [
    "PROPN"
  ],
  "stabilization": [
    "NOUN"
  ],
  "authoritative": [
    "ADJ"
  ],
  "celestial": [
    "NOUN"
  ],
  "immense": [
    "ADJ"
  ],
  "audrey": [
    "NOUN"
  ],
  "merlin": [
    "NOUN"
  ],
  "kinetics": [
    "NOUN"
  ],
  "cocos": [
    "PROPN"
  ],
  "aiming": [
    "VERB"
  ],
  "seizure": [
    "VERB"
  ],
  "diplomacy": [
    "NOUN"
  ],
  "impacted": [
    "VERB"
  ],
  "capitalist": [
    "NOUN"
  ],
  "beanie": [
    "PROPN"
  ],
  "protestant": [
    "NOUN"
  ],
  "tricky": [
    "ADJ"
  ],
  "spaced": [
    "VERB"
  ],
  "topaz": [
    "NOUN"
  ],
  "segmentation": [
    "NOUN",
    "PROPN"
  ],
  "imaginary": [
    "NOUN"
  ],
  "albion": [
    "NOUN"
  ],
  "courthouse": [
    "NOUN"
  ],
  "entrepreneurial": [
    "ADJ"
  ],
  "lebanese": [
    "NOUN"
  ],
  "wrought": [
    "PROPN"
  ],
  "theresa": [
    "PROPN"
  ],
  "multitude": [
    "VERB"
  ],
  "housekeeping": [
    "VERB"
  ],
  "captive": [
    "ADJ"
  ],
  "kettle": [
    "NOUN"
  ],
  "visitation": [
    "NOUN"
  ],
  "baggage": [
    "NOUN"
  ],
  "dusty": [
    "ADJ"
  ],
  "patty": [
    "PROPN"
  ],
  "serena": [
    "NOUN"
  ],
  "satire": [
    "NOUN"
  ],
  "overload": [
    "NOUN",
    "PROPN"
  ],
  "tortured": [
    "VERB"
  ],
  "crate": [
    "NOUN"
  ],
  "bootstrap": [
    "NOUN",
    "PROPN"
  ],
  "episcopal": [
    "NOUN"
  ],
  "humane": [
    "NOUN"
  ],
  "moonlight": [
    "NOUN"
  ],
  "unfinished": [
    "ADJ"
  ],
  "affection": [
    "NOUN"
  ],
  "sworn": [
    "VERB"
  ],
  "twink": [
    "VERB"
  ],
  "vicious": [
    "ADJ"
  ],
  "pussycat": [
    "PROPN"
  ],
  "escherichia": [
    "PROPN"
  ],
  "reversible": [
    "ADJ"
  ],
  "unclassified": [
    "VERB"
  ],
  "bookshelf": [
    "PRON"
  ],
  "hayward": [
    "PROPN"
  ],
  "wandering": [
    "VERB"
  ],
  "beech": [
    "PROPN"
  ],
  "consequential": [
    "NOUN"
  ],
  "unreasonable": [
    "ADJ"
  ],
  "raider": [
    "NOUN"
  ],
  "stimulus": [
    "NOUN"
  ],
  "agnes": [
    "NOUN"
  ],
  "constituency": [
    "NOUN"
  ],
  "rocker": [
    "NOUN"
  ],
  "enrolment": [
    "NOUN"
  ],
  "sawyer": [
    "PROPN"
  ],
  "maori": [
    "VERB"
  ],
  "tense": [
    "ADJ"
  ],
  "filipino": [
    "NOUN"
  ],
  "prudential": [
    "PROPN"
  ],
  "migrant": [
    "NOUN"
  ],
  "devotion": [
    "NOUN"
  ],
  "invoke": [
    "VERB",
    "PROPN"
  ],
  "leaning": [
    "VERB"
  ],
  "centrally": [
    "ADV"
  ],
  "paddle": [
    "NOUN"
  ],
  "anterior": [
    "ADJ"
  ],
  "dealership": [
    "NOUN"
  ],
  "eyewear": [
    "VERB"
  ],
  "rooted": [
    "VERB"
  ],
  "illumination": [
    "NOUN"
  ],
  "foolish": [
    "ADJ"
  ],
  "finale": [
    "NOUN"
  ],
  "moran": [
    "PROPN"
  ],
  "decal": [
    "ADJ"
  ],
  "compose": [
    "VERB",
    "PROPN"
  ],
  "nausea": [
    "NOUN"
  ],
  "comfortably": [
    "ADV"
  ],
  "clarinet": [
    "NOUN"
  ],
  "clearer": [
    "ADJ"
  ],
  "fritz": [
    "NOUN"
  ],
  "mover": [
    "ADV"
  ],
  "erica": [
    "PROPN"
  ],
  "malaga": [
    "VERB"
  ],
  "federally": [
    "ADV"
  ],
  "sustaining": [
    "VERB"
  ],
  "diocese": [
    "NOUN"
  ],
  "francois": [
    "NOUN"
  ],
  "obituary": [
    "PROPN"
  ],
  "multinational": [
    "ADJ"
  ],
  "thistle": [
    "ADV"
  ],
  "sleepy": [
    "ADJ"
  ],
  "rupert": [
    "NOUN"
  ],
  "shrine": [
    "NOUN"
  ],
  "aspirin": [
    "NOUN"
  ],
  "striving": [
    "VERB"
  ],
  "attendant": [
    "NOUN"
  ],
  "memoir": [
    "PROPN"
  ],
  "betsy": [
    "PROPN"
  ],
  "redundancy": [
    "NOUN"
  ],
  "fauna": [
    "NOUN"
  ],
  "roadside": [
    "NOUN"
  ],
  "dispose": [
    "VERB"
  ],
  "waking": [
    "VERB"
  ],
  "reflex": [
    "NOUN"
  ],
  "drosophila": [
    "PROPN"
  ],
  "ortho": [
    "PROPN"
  ],
  "travelled": [
    "VERB"
  ],
  "urgency": [
    "PROPN",
    "NOUN"
  ],
  "drupal": [
    "PROPN"
  ],
  "eliza": [
    "VERB"
  ],
  "graduating": [
    "VERB"
  ],
  "harmonic": [
    "ADJ"
  ],
  "darts": [
    "NOUN"
  ],
  "intriguing": [
    "ADJ"
  ],
  "emulator": [
    "NOUN"
  ],
  "microbial": [
    "ADJ"
  ],
  "joanna": [
    "PROPN"
  ],
  "quark": [
    "ADJ"
  ],
  "mitochondrial": [
    "ADJ"
  ],
  "hercules": [
    "NOUN"
  ],
  "browning": [
    "VERB"
  ],
  "angular": [
    "ADJ"
  ],
  "grinder": [
    "NOUN"
  ],
  "angie": [
    "PROPN"
  ],
  "sneak": [
    "VERB"
  ],
  "octet": [
    "ADV"
  ],
  "incorrectly": [
    "ADV"
  ],
  "avoidance": [
    "NOUN"
  ],
  "conquer": [
    "NOUN"
  ],
  "immortal": [
    "ADJ"
  ],
  "endeavor": [
    "VERB"
  ],
  "creole": [
    "NOUN"
  ],
  "settling": [
    "VERB"
  ],
  "inpatient": [
    "ADJ"
  ],
  "badger": [
    "NOUN"
  ],
  "partisan": [
    "NOUN"
  ],
  "gratitude": [
    "NOUN"
  ],
  "impress": [
    "VERB"
  ],
  "eminent": [
    "ADJ"
  ],
  "exceptionally": [
    "ADV"
  ],
  "cartier": [
    "NOUN"
  ],
  "containment": [
    "NOUN"
  ],
  "edith": [
    "ADP"
  ],
  "tomcat": [
    "PROPN",
    "NOUN"
  ],
  "sectional": [
    "ADJ"
  ],
  "interestingly": [
    "ADV"
  ],
  "fashionable": [
    "ADJ"
  ],
  "polly": [
    "ADV"
  ],
  "tidal": [
    "ADJ"
  ],
  "jules": [
    "NOUN"
  ],
  "ernie": [
    "PROPN"
  ],
  "testify": [
    "VERB"
  ],
  "boycott": [
    "NOUN"
  ],
  "vitality": [
    "NOUN"
  ],
  "crust": [
    "NOUN"
  ],
  "traverse": [
    "VERB"
  ],
  "vengeance": [
    "NOUN"
  ],
  "dolly": [
    "ADV"
  ],
  "garrison": [
    "NOUN"
  ],
  "miner": [
    "PROPN"
  ],
  "genital": [
    "ADJ"
  ],
  "analogy": [
    "NOUN"
  ],
  "insomnia": [
    "VERB"
  ],
  "constituent": [
    "NOUN"
  ],
  "cecil": [
    "NOUN"
  ],
  "sponge": [
    "NOUN"
  ],
  "cajun": [
    "PROPN"
  ],
  "algebraic": [
    "ADV"
  ],
  "diner": [
    "X"
  ],
  "anticipation": [
    "NOUN"
  ],
  "enduring": [
    "VERB"
  ],
  "kristen": [
    "PROPN"
  ],
  "mound": [
    "VERB"
  ],
  "backgammon": [
    "PROPN"
  ],
  "chromatography": [
    "NOUN"
  ],
  "overdose": [
    "ADV"
  ],
  "ethan": [
    "PROPN"
  ],
  "butcher": [
    "VERB"
  ],
  "reese": [
    "PROPN"
  ],
  "engraving": [
    "VERB"
  ],
  "gastrointestinal": [
    "ADJ"
  ],
  "hamlet": [
    "NOUN"
  ],
  "excursion": [
    "NOUN"
  ],
  "inverness": [
    "NOUN"
  ],
  "grange": [
    "NOUN"
  ],
  "resigned": [
    "VERB"
  ],
  "retriever": [
    "PROPN"
  ],
  "brandy": [
    "NOUN"
  ],
  "scion": [
    "NOUN"
  ],
  "vortex": [
    "PROPN",
    "NOUN"
  ],
  "bodily": [
    "ADV"
  ],
  "antitrust": [
    "ADJ"
  ],
  "equine": [
    "PROPN"
  ],
  "proto": [
    "NOUN"
  ],
  "jared": [
    "VERB"
  ],
  "requisite": [
    "ADJ"
  ],
  "retrospective": [
    "PROPN",
    "ADJ"
  ],
  "lizard": [
    "NOUN"
  ],
  "anesthesia": [
    "PROPN"
  ],
  "shropshire": [
    "NOUN"
  ],
  "filemaker": [
    "NOUN"
  ],
  "regal": [
    "PROPN"
  ],
  "cabbage": [
    "NOUN"
  ],
  "wrongful": [
    "ADJ"
  ],
  "spectator": [
    "NOUN"
  ],
  "circumstance": [
    "NOUN"
  ],
  "encode": [
    "ADJ"
  ],
  "alvin": [
    "PROPN"
  ],
  "sliced": [
    "VERB"
  ],
  "infertility": [
    "NOUN"
  ],
  "sidewalk": [
    "NOUN"
  ],
  "breaker": [
    "NOUN"
  ],
  "curly": [
    "ADV"
  ],
  "alberto": [
    "NOUN"
  ],
  "collage": [
    "NOUN"
  ],
  "jealous": [
    "ADJ"
  ],
  "refinement": [
    "PROPN",
    "NOUN"
  ],
  "durban": [
    "PROPN"
  ],
  "learnt": [
    "VERB"
  ],
  "hound": [
    "NOUN"
  ],
  "squirrel": [
    "NOUN"
  ],
  "concealed": [
    "VERB"
  ],
  "blueprint": [
    "NOUN",
    "PROPN"
  ],
  "bridging": [
    "VERB"
  ],
  "wharf": [
    "NOUN"
  ],
  "flick": [
    "VERB"
  ],
  "datum": [
    "PROPN"
  ],
  "shotgun": [
    "VERB"
  ],
  "briggs": [
    "NOUN"
  ],
  "cheyenne": [
    "NOUN"
  ],
  "surveyor": [
    "NOUN"
  ],
  "facilitator": [
    "PROPN",
    "NOUN"
  ],
  "maize": [
    "NOUN"
  ],
  "extinction": [
    "NOUN"
  ],
  "unaware": [
    "ADJ"
  ],
  "banff": [
    "VERB"
  ],
  "discretionary": [
    "ADJ"
  ],
  "psalm": [
    "NOUN"
  ],
  "scented": [
    "VERB"
  ],
  "dermatology": [
    "NOUN"
  ],
  "sandbox": [
    "NOUN",
    "PROPN"
  ],
  "premiership": [
    "NOUN"
  ],
  "recurrent": [
    "NOUN"
  ],
  "talbot": [
    "PROPN"
  ],
  "recursive": [
    "ADJ"
  ],
  "swell": [
    "VERB"
  ],
  "obstacle": [
    "NOUN"
  ],
  "ville": [
    "PROPN"
  ],
  "fluorescence": [
    "VERB"
  ],
  "kosher": [
    "PROPN"
  ],
  "mantle": [
    "PROPN"
  ],
  "chico": [
    "PROPN"
  ],
  "driveway": [
    "NOUN"
  ],
  "irony": [
    "NOUN"
  ],
  "gesture": [
    "VERB"
  ],
  "santos": [
    "NOUN"
  ],
  "mandrake": [
    "VERB"
  ],
  "camper": [
    "PROPN"
  ],
  "breadth": [
    "NOUN"
  ],
  "mammoth": [
    "NOUN"
  ],
  "liquidity": [
    "NOUN"
  ],
  "intentional": [
    "ADJ",
    "PROPN"
  ],
  "galactic": [
    "NOUN"
  ],
  "sophia": [
    "VERB"
  ],
  "ombudsman": [
    "NOUN"
  ],
  "registrant": [
    "ADJ"
  ],
  "reorganization": [
    "NOUN"
  ],
  "pronunciation": [
    "NOUN"
  ],
  "concession": [
    "NOUN"
  ],
  "measurable": [
    "ADJ"
  ],
  "pastry": [
    "NOUN"
  ],
  "manners": [
    "NOUN"
  ],
  "levin": [
    "ADV"
  ],
  "phosphorus": [
    "NOUN"
  ],
  "viper": [
    "NOUN"
  ],
  "volcanic": [
    "NOUN"
  ],
  "gypsy": [
    "ADJ"
  ],
  "preaching": [
    "VERB"
  ],
  "repeal": [
    "NOUN"
  ],
  "uncovered": [
    "VERB"
  ],
  "eileen": [
    "PROPN"
  ],
  "proficient": [
    "ADJ"
  ],
  "pelican": [
    "PROPN"
  ],
  "cyclic": [
    "NOUN"
  ],
  "swimsuit": [
    "VERB"
  ],
  "apocalypse": [
    "NOUN"
  ],
  "morphology": [
    "NOUN"
  ],
  "admire": [
    "NOUN"
  ],
  "usefulness": [
    "NOUN"
  ],
  "unsolicited": [
    "VERB"
  ],
  "unveiled": [
    "VERB"
  ],
  "titus": [
    "NOUN"
  ],
  "textual": [
    "ADJ"
  ],
  "suffix": [
    "PROPN",
    "NOUN"
  ],
  "installment": [
    "NOUN"
  ],
  "spindle": [
    "NOUN"
  ],
  "heavens": [
    "NOUN"
  ],
  "diarrhea": [
    "NOUN"
  ],
  "mister": [
    "PROPN"
  ],
  "rounding": [
    "VERB"
  ],
  "inorganic": [
    "NOUN"
  ],
  "flare": [
    "VERB"
  ],
  "scholastic": [
    "NOUN"
  ],
  "wight": [
    "NOUN"
  ],
  "foliage": [
    "NOUN"
  ],
  "crank": [
    "PROPN"
  ],
  "summarize": [
    "VERB"
  ],
  "fundamentally": [
    "ADV"
  ],
  "creamy": [
    "NOUN"
  ],
  "exposition": [
    "NOUN"
  ],
  "laminated": [
    "VERB"
  ],
  "brace": [
    "NOUN"
  ],
  "gigantic": [
    "ADJ"
  ],
  "ryder": [
    "NOUN"
  ],
  "mayhem": [
    "NOUN"
  ],
  "octave": [
    "VERB"
  ],
  "suppress": [
    "VERB"
  ],
  "deserved": [
    "VERB"
  ],
  "rutherford": [
    "NOUN"
  ],
  "separates": [
    "VERB"
  ],
  "precedent": [
    "NOUN"
  ],
  "biosynthesis": [
    "NOUN"
  ],
  "confirming": [
    "VERB"
  ],
  "garth": [
    "PROPN"
  ],
  "paolo": [
    "PROPN"
  ],
  "metaphor": [
    "NOUN"
  ],
  "bridget": [
    "VERB"
  ],
  "wonderland": [
    "VERB"
  ],
  "infusion": [
    "NOUN"
  ],
  "jessie": [
    "PROPN"
  ],
  "argus": [
    "ADJ"
  ],
  "mango": [
    "PROPN"
  ],
  "jubilee": [
    "PROPN"
  ],
  "polite": [
    "ADJ"
  ],
  "thigh": [
    "NOUN"
  ],
  "asynchronous": [
    "ADJ",
    "PROPN"
  ],
  "paving": [
    "VERB"
  ],
  "cyclone": [
    "NOUN"
  ],
  "perennial": [
    "ADJ"
  ],
  "seventeen": [
    "X"
  ],
  "clearinghouse": [
    "VERB"
  ],
  "bulldog": [
    "PROPN"
  ],
  "cleavage": [
    "NOUN"
  ],
  "gradual": [
    "ADJ"
  ],
  "brethren": [
    "NOUN"
  ],
  "embodiment": [
    "ADJ"
  ],
  "toilette": [
    "PROPN"
  ],
  "trailing": [
    "VERB"
  ],
  "lipstick": [
    "NOUN"
  ],
  "windy": [
    "ADJ"
  ],
  "saturation": [
    "NOUN"
  ],
  "alamo": [
    "PROPN"
  ],
  "chronology": [
    "NOUN"
  ],
  "mastery": [
    "PROPN",
    "NOUN"
  ],
  "thermometer": [
    "NOUN"
  ],
  "cranberry": [
    "PROPN"
  ],
  "downhill": [
    "ADV"
  ],
  "steer": [
    "VERB"
  ],
  "vogue": [
    "NOUN"
  ],
  "spaghetti": [
    "NOUN"
  ],
  "outward": [
    "ADV"
  ],
  "whisper": [
    "NOUN"
  ],
  "confession": [
    "NOUN"
  ],
  "benedict": [
    "PROPN"
  ],
  "molding": [
    "VERB"
  ],
  "communism": [
    "NOUN"
  ],
  "leopard": [
    "NOUN"
  ],
  "sakai": [
    "NOUN"
  ],
  "flowering": [
    "VERB"
  ],
  "jingle": [
    "PROPN"
  ],
  "bounty": [
    "PROPN",
    "NOUN"
  ],
  "arcadia": [
    "PROPN"
  ],
  "ringing": [
    "VERB"
  ],
  "taurus": [
    "NOUN"
  ],
  "whiskey": [
    "NOUN"
  ],
  "absurd": [
    "ADJ"
  ],
  "tolerant": [
    "ADJ"
  ],
  "enactment": [
    "PROPN"
  ],
  "laminate": [
    "VERB"
  ],
  "earring": [
    "NOUN"
  ],
  "aggregator": [
    "NOUN",
    "PROPN"
  ],
  "embryo": [
    "NOUN"
  ],
  "furious": [
    "ADJ"
  ],
  "iteration": [
    "NOUN",
    "PROPN"
  ],
  "dispenser": [
    "NOUN"
  ],
  "respecting": [
    "VERB"
  ],
  "unsafe": [
    "ADJ"
  ],
  "separating": [
    "VERB"
  ],
  "unidentified": [
    "ADJ"
  ],
  "moist": [
    "NOUN"
  ],
  "drained": [
    "VERB"
  ],
  "cessation": [
    "NOUN"
  ],
  "append": [
    "VERB"
  ],
  "motive": [
    "NOUN"
  ],
  "acreage": [
    "NOUN"
  ],
  "seasoned": [
    "VERB"
  ],
  "sunflower": [
    "NOUN"
  ],
  "fingerprint": [
    "VERB"
  ],
  "sorority": [
    "NOUN"
  ],
  "bethel": [
    "PROPN"
  ],
  "audition": [
    "NOUN"
  ],
  "doris": [
    "PROPN"
  ],
  "reinforcement": [
    "NOUN"
  ],
  "dwight": [
    "NOUN"
  ],
  "psychotherapy": [
    "NOUN"
  ],
  "provost": [
    "NOUN"
  ],
  "guessing": [
    "VERB"
  ],
  "saxophone": [
    "NOUN"
  ],
  "throttle": [
    "VERB"
  ],
  "steroid": [
    "NOUN"
  ],
  "communicator": [
    "NOUN"
  ],
  "horticulture": [
    "NOUN"
  ],
  "sympathetic": [
    "ADJ"
  ],
  "ordinator": [
    "NOUN"
  ],
  "isolate": [
    "VERB"
  ],
  "unconscious": [
    "ADJ"
  ],
  "acronym": [
    "NOUN"
  ],
  "faulty": [
    "ADJ",
    "PROPN"
  ],
  "affidavit": [
    "NOUN"
  ],
  "streamline": [
    "VERB",
    "PROPN"
  ],
  "messiah": [
    "PROPN"
  ],
  "brunch": [
    "NOUN"
  ],
  "infamous": [
    "ADJ"
  ],
  "pundit": [
    "NOUN"
  ],
  "pleasing": [
    "ADJ"
  ],
  "figurine": [
    "ADJ"
  ],
  "tenacious": [
    "ADJ"
  ],
  "expiry": [
    "NOUN",
    "PROPN"
  ],
  "waterfall": [
    "PROPN",
    "NOUN"
  ],
  "sensual": [
    "ADJ"
  ],
  "persecution": [
    "NOUN"
  ],
  "petit": [
    "NOUN"
  ],
  "burgess": [
    "NOUN"
  ],
  "inning": [
    "VERB"
  ],
  "chlorine": [
    "NOUN"
  ],
  "freshly": [
    "ADV"
  ],
  "initialize": [
    "VERB"
  ],
  "saxon": [
    "VERB"
  ],
  "isabella": [
    "NOUN"
  ],
  "foundry": [
    "NOUN"
  ],
  "toxicology": [
    "NOUN"
  ],
  "assassination": [
    "NOUN"
  ],
  "nostalgia": [
    "NOUN"
  ],
  "remarkably": [
    "ADV"
  ],
  "acetate": [
    "VERB"
  ],
  "stall": [
    "VERB"
  ],
  "saratoga": [
    "PROPN"
  ],
  "entirety": [
    "NOUN"
  ],
  "marcel": [
    "VERB"
  ],
  "terminator": [
    "PROPN"
  ],
  "badminton": [
    "PROPN"
  ],
  "flores": [
    "NOUN"
  ],
  "olivier": [
    "ADJ"
  ],
  "portage": [
    "NOUN"
  ],
  "stacey": [
    "NOUN"
  ],
  "serif": [
    "PROPN"
  ],
  "portability": [
    "PROPN"
  ],
  "characterize": [
    "VERB"
  ],
  "ricardo": [
    "NOUN"
  ],
  "yourselves": [
    "NOUN"
  ],
  "yearbook": [
    "NOUN"
  ],
  "alameda": [
    "PROPN"
  ],
  "aerosol": [
    "VERB"
  ],
  "hostage": [
    "NOUN"
  ],
  "cracker": [
    "NOUN"
  ],
  "anglican": [
    "ADV"
  ],
  "compliment": [
    "NOUN"
  ],
  "scotch": [
    "VERB"
  ],
  "multilateral": [
    "ADJ"
  ],
  "freddie": [
    "VERB"
  ],
  "contention": [
    "NOUN"
  ],
  "juliet": [
    "PROPN"
  ],
  "adjunct": [
    "ADJ"
  ],
  "guernsey": [
    "PROPN"
  ],
  "galore": [
    "NOUN"
  ],
  "dehydrogenase": [
    "VERB"
  ],
  "postfix": [
    "VERB"
  ],
  "stirring": [
    "VERB"
  ],
  "exponential": [
    "ADJ"
  ],
  "utter": [
    "ADJ"
  ],
  "bottled": [
    "ADJ"
  ],
  "gastric": [
    "PROPN"
  ],
  "secretarial": [
    "ADJ"
  ],
  "theirs": [
    "PRON"
  ],
  "donovan": [
    "PROPN"
  ],
  "toaster": [
    "VERB"
  ],
  "cater": [
    "VERB"
  ],
  "rehearsal": [
    "NOUN"
  ],
  "reputable": [
    "ADJ"
  ],
  "archbishop": [
    "NOUN"
  ],
  "incompatible": [
    "ADJ"
  ],
  "emblem": [
    "NOUN"
  ],
  "roadway": [
    "NOUN"
  ],
  "equivalence": [
    "NOUN"
  ],
  "vaughn": [
    "PROPN"
  ],
  "miserable": [
    "ADJ"
  ],
  "unsuccessful": [
    "ADJ"
  ],
  "decorate": [
    "VERB"
  ],
  "revocation": [
    "NOUN",
    "PROPN"
  ],
  "vomiting": [
    "VERB"
  ],
  "chesterfield": [
    "VERB"
  ],
  "simulate": [
    "VERB"
  ],
  "schematic": [
    "ADJ"
  ],
  "medina": [
    "PROPN"
  ],
  "thankful": [
    "ADJ"
  ],
  "pneumatic": [
    "ADJ"
  ],
  "alaskan": [
    "ADJ"
  ],
  "vertices": [
    "VERB"
  ],
  "pinch": [
    "VERB"
  ],
  "additive": [
    "ADJ"
  ],
  "professionalism": [
    "NOUN"
  ],
  "libertarian": [
    "PROPN"
  ],
  "washable": [
    "ADJ"
  ],
  "braces": [
    "NOUN"
  ],
  "troll": [
    "NOUN"
  ],
  "teamwork": [
    "PROPN",
    "NOUN"
  ],
  "deficient": [
    "VERB"
  ],
  "filth": [
    "NOUN"
  ],
  "moderation": [
    "NOUN"
  ],
  "worrying": [
    "VERB"
  ],
  "ontology": [
    "NOUN"
  ],
  "timberland": [
    "VERB"
  ],
  "outrageous": [
    "ADJ"
  ],
  "kraft": [
    "NOUN"
  ],
  "concluding": [
    "VERB"
  ],
  "blackboard": [
    "PROPN"
  ],
  "chopper": [
    "PROPN",
    "NOUN"
  ],
  "nitrate": [
    "ADJ"
  ],
  "pinball": [
    "VERB"
  ],
  "surcharge": [
    "VERB"
  ],
  "latvian": [
    "PROPN"
  ],
  "footprint": [
    "NOUN",
    "PROPN"
  ],
  "crises": [
    "NOUN"
  ],
  "trillion": [
    "NUM"
  ],
  "comforter": [
    "NOUN"
  ],
  "cashmere": [
    "ADV"
  ],
  "nguyen": [
    "PROPN"
  ],
  "meteorological": [
    "ADJ"
  ],
  "salomon": [
    "PROPN"
  ],
  "horsepower": [
    "NOUN"
  ],
  "algae": [
    "NOUN"
  ],
  "alcoholism": [
    "NOUN"
  ],
  "dissent": [
    "NOUN"
  ],
  "maximal": [
    "ADJ"
  ],
  "prenatal": [
    "ADJ"
  ],
  "choral": [
    "ADJ"
  ],
  "unrestricted": [
    "ADJ"
  ],
  "contempt": [
    "NOUN"
  ],
  "socialism": [
    "NOUN"
  ],
  "edible": [
    "ADJ"
  ],
  "anarchy": [
    "NOUN"
  ],
  "ineffective": [
    "ADJ"
  ],
  "drawers": [
    "NOUN"
  ],
  "leakage": [
    "NOUN"
  ],
  "culturally": [
    "ADV"
  ],
  "shady": [
    "ADJ"
  ],
  "chemist": [
    "NOUN"
  ],
  "evenly": [
    "ADV"
  ],
  "janitorial": [
    "ADJ"
  ],
  "reclamation": [
    "NOUN"
  ],
  "propane": [
    "NOUN"
  ],
  "appendices": [
    "NOUN"
  ],
  "collagen": [
    "NOUN"
  ],
  "lionel": [
    "NOUN"
  ],
  "blizzard": [
    "NOUN"
  ],
  "nigerian": [
    "PROPN"
  ],
  "refining": [
    "VERB",
    "NOUN"
  ],
  "confront": [
    "PROPN"
  ],
  "lydia": [
    "VERB"
  ],
  "coyote": [
    "VERB"
  ],
  "breeder": [
    "NOUN"
  ],
  "electrode": [
    "ADJ"
  ],
  "pollen": [
    "NOUN"
  ],
  "drunken": [
    "VERB"
  ],
  "valet": [
    "PROPN"
  ],
  "spoiler": [
    "NOUN"
  ],
  "cheng": [
    "PROPN"
  ],
  "watering": [
    "VERB"
  ],
  "baroque": [
    "NOUN"
  ],
  "barrow": [
    "VERB"
  ],
  "eliot": [
    "PROPN"
  ],
  "jihad": [
    "PROPN"
  ],
  "transporting": [
    "VERB"
  ],
  "posterior": [
    "ADJ"
  ],
  "excise": [
    "VERB"
  ],
  "poetic": [
    "ADJ"
  ],
  "mortar": [
    "NOUN"
  ],
  "blamed": [
    "VERB"
  ],
  "inmate": [
    "NOUN"
  ],
  "posture": [
    "NOUN",
    "PROPN"
  ],
  "thereon": [
    "PROPN"
  ],
  "septic": [
    "ADJ"
  ],
  "armada": [
    "PROPN"
  ],
  "wrench": [
    "NOUN"
  ],
  "amelia": [
    "NOUN"
  ],
  "jonah": [
    "PROPN"
  ],
  "expedited": [
    "VERB"
  ],
  "discomfort": [
    "NOUN"
  ],
  "curricula": [
    "NOUN"
  ],
  "indictment": [
    "NOUN"
  ],
  "apology": [
    "NOUN"
  ],
  "sloan": [
    "VERB"
  ],
  "pudding": [
    "VERB"
  ],
  "flawed": [
    "VERB"
  ],
  "squared": [
    "VERB"
  ],
  "needless": [
    "ADJ"
  ],
  "lakeside": [
    "NOUN"
  ],
  "palma": [
    "NOUN"
  ],
  "interconnection": [
    "NOUN"
  ],
  "heterogeneous": [
    "ADJ"
  ],
  "taxis": [
    "NOUN"
  ],
  "excavation": [
    "NOUN"
  ],
  "luckily": [
    "ADV"
  ],
  "ultraviolet": [
    "ADJ"
  ],
  "pneumonia": [
    "NOUN"
  ],
  "monastery": [
    "VERB"
  ],
  "haitian": [
    "PROPN"
  ],
  "dialing": [
    "VERB"
  ],
  "migrate": [
    "VERB",
    "PROPN"
  ],
  "carton": [
    "PROPN"
  ],
  "lorraine": [
    "VERB"
  ],
  "ammonia": [
    "NOUN"
  ],
  "licensure": [
    "NOUN"
  ],
  "outlaw": [
    "NOUN"
  ],
  "tammy": [
    "NOUN"
  ],
  "bovine": [
    "PROPN"
  ],
  "dislike": [
    "VERB"
  ],
  "systematically": [
    "ADV"
  ],
  "interruption": [
    "NOUN"
  ],
  "imminent": [
    "ADJ"
  ],
  "madam": [
    "NOUN"
  ],
  "tights": [
    "NOUN"
  ],
  "soybean": [
    "NOUN"
  ],
  "electra": [
    "PROPN"
  ],
  "communal": [
    "ADJ"
  ],
  "libby": [
    "PROPN"
  ],
  "dynamite": [
    "NOUN"
  ],
  "tease": [
    "NOUN"
  ],
  "motley": [
    "ADJ"
  ],
  "aroma": [
    "NOUN"
  ],
  "pierced": [
    "VERB"
  ],
  "retractable": [
    "NOUN"
  ],
  "cognition": [
    "NOUN"
  ],
  "verona": [
    "NOUN"
  ],
  "chatting": [
    "VERB"
  ],
  "punish": [
    "VERB"
  ],
  "causal": [
    "ADJ",
    "PROPN"
  ],
  "stringent": [
    "ADJ"
  ],
  "rowan": [
    "PROPN"
  ],
  "dwell": [
    "NOUN"
  ],
  "hacked": [
    "VERB"
  ],
  "inaugural": [
    "ADJ"
  ],
  "awkward": [
    "ADJ"
  ],
  "weaving": [
    "VERB"
  ],
  "metropolis": [
    "VERB"
  ],
  "diligence": [
    "NOUN"
  ],
  "stair": [
    "NOUN"
  ],
  "splitter": [
    "NOUN"
  ],
  "standardization": [
    "NOUN",
    "PROPN"
  ],
  "lakeland": [
    "PROPN"
  ],
  "classy": [
    "ADJ"
  ],
  "lookout": [
    "NOUN"
  ],
  "arterial": [
    "ADJ"
  ],
  "injustice": [
    "NOUN"
  ],
  "mystical": [
    "ADJ"
  ],
  "manifesto": [
    "PROPN"
  ],
  "doppler": [
    "NOUN"
  ],
  "pedestal": [
    "ADJ"
  ],
  "entropy": [
    "PROPN"
  ],
  "snooker": [
    "PROPN"
  ],
  "unleashed": [
    "ADJ"
  ],
  "underwood": [
    "PROPN"
  ],
  "saline": [
    "NOUN"
  ],
  "sonny": [
    "ADJ"
  ],
  "longevity": [
    "NOUN"
  ],
  "isabel": [
    "VERB"
  ],
  "sterile": [
    "ADJ"
  ],
  "importer": [
    "NOUN",
    "PROPN"
  ],
  "botany": [
    "NOUN"
  ],
  "dissolution": [
    "NOUN"
  ],
  "rotor": [
    "NOUN"
  ],
  "pauline": [
    "VERB"
  ],
  "quart": [
    "ADJ"
  ],
  "theres": [
    "PRON"
  ],
  "bison": [
    "NOUN"
  ],
  "suppressed": [
    "VERB"
  ],
  "allegro": [
    "NOUN"
  ],
  "materially": [
    "ADV"
  ],
  "fungi": [
    "NOUN"
  ],
  "phyllis": [
    "VERB"
  ],
  "dreamy": [
    "ADJ"
  ],
  "bengal": [
    "ADJ"
  ],
  "backstage": [
    "NOUN"
  ],
  "awakening": [
    "NOUN"
  ],
  "prescribe": [
    "VERB"
  ],
  "greed": [
    "NOUN"
  ],
  "nominate": [
    "VERB"
  ],
  "sparkle": [
    "NOUN"
  ],
  "autograph": [
    "NOUN"
  ],
  "gasket": [
    "NOUN"
  ],
  "refrain": [
    "VERB"
  ],
  "lastly": [
    "ADV"
  ],
  "wander": [
    "VERB"
  ],
  "relieved": [
    "VERB"
  ],
  "firearm": [
    "NOUN"
  ],
  "participatory": [
    "PROPN"
  ],
  "intermittent": [
    "ADJ"
  ],
  "micron": [
    "NOUN"
  ],
  "budgetary": [
    "ADJ"
  ],
  "revolving": [
    "VERB"
  ],
  "covert": [
    "ADJ"
  ],
  "crater": [
    "NOUN"
  ],
  "favored": [
    "VERB"
  ],
  "fractional": [
    "ADJ"
  ],
  "markus": [
    "PROPN"
  ],
  "ideological": [
    "ADJ"
  ],
  "fostering": [
    "VERB"
  ],
  "rheumatoid": [
    "VERB"
  ],
  "thence": [
    "NOUN"
  ],
  "birthplace": [
    "NOUN"
  ],
  "bleed": [
    "VERB"
  ],
  "reverend": [
    "VERB"
  ],
  "cabernet": [
    "NOUN"
  ],
  "neptune": [
    "NOUN"
  ],
  "caucasian": [
    "ADJ"
  ],
  "understandable": [
    "ADJ"
  ],
  "goblet": [
    "VERB"
  ],
  "doctorate": [
    "VERB"
  ],
  "slovenian": [
    "PROPN"
  ],
  "practicable": [
    "PROPN"
  ],
  "showdown": [
    "PROPN"
  ],
  "ancestor": [
    "NOUN"
  ],
  "incur": [
    "VERB"
  ],
  "tempe": [
    "ADP"
  ],
  "canonical": [
    "ADJ"
  ],
  "believer": [
    "NOUN"
  ],
  "nifty": [
    "ADJ"
  ],
  "peacock": [
    "NOUN"
  ],
  "utmost": [
    "ADV"
  ],
  "skeletal": [
    "ADJ"
  ],
  "anthrax": [
    "NOUN"
  ],
  "imitation": [
    "NOUN"
  ],
  "hopeful": [
    "ADJ"
  ],
  "furnishing": [
    "VERB"
  ],
  "negatively": [
    "ADV"
  ],
  "spinach": [
    "NOUN"
  ],
  "liquidation": [
    "NOUN"
  ],
  "predecessor": [
    "NOUN"
  ],
  "touchdown": [
    "PROPN"
  ],
  "planar": [
    "PROPN"
  ],
  "philanthropy": [
    "NOUN"
  ],
  "adequacy": [
    "NOUN"
  ],
  "discard": [
    "NOUN"
  ],
  "cavalry": [
    "NOUN"
  ],
  "quorum": [
    "NOUN"
  ],
  "forwards": [
    "VERB"
  ],
  "prevalent": [
    "PROPN"
  ],
  "offended": [
    "VERB"
  ],
  "muller": [
    "NOUN"
  ],
  "prostitution": [
    "NOUN"
  ],
  "mosque": [
    "NOUN"
  ],
  "fudge": [
    "VERB"
  ],
  "extractor": [
    "NOUN"
  ],
  "horseback": [
    "VERB"
  ],
  "terribly": [
    "ADV"
  ],
  "earnest": [
    "ADJ"
  ],
  "myocardial": [
    "ADJ"
  ],
  "sander": [
    "ADJ"
  ],
  "conductivity": [
    "NOUN"
  ],
  "confederate": [
    "VERB"
  ],
  "annette": [
    "VERB"
  ],
  "climax": [
    "PROPN"
  ],
  "blending": [
    "VERB"
  ],
  "weave": [
    "VERB"
  ],
  "vicki": [
    "PROPN"
  ],
  "speeding": [
    "VERB"
  ],
  "creditor": [
    "NOUN"
  ],
  "pardon": [
    "PROPN"
  ],
  "outback": [
    "NOUN"
  ],
  "teller": [
    "NOUN"
  ],
  "siena": [
    "NOUN"
  ],
  "biopsy": [
    "PROPN"
  ],
  "custodian": [
    "PROPN"
  ],
  "quarry": [
    "NOUN"
  ],
  "seneca": [
    "NOUN"
  ],
  "oceanic": [
    "NOUN"
  ],
  "burbank": [
    "VERB"
  ],
  "festive": [
    "ADJ"
  ],
  "appraiser": [
    "NOUN"
  ],
  "ingram": [
    "PROPN"
  ],
  "gaussian": [
    "PROPN"
  ],
  "hustler": [
    "NOUN"
  ],
  "secretion": [
    "NOUN"
  ],
  "separator": [
    "NOUN"
  ],
  "insult": [
    "NOUN"
  ],
  "buggy": [
    "ADJ"
  ],
  "recon": [
    "PROPN"
  ],
  "kennel": [
    "PROPN"
  ],
  "slack": [
    "PROPN",
    "NOUN"
  ],
  "pastel": [
    "PROPN"
  ],
  "differentiate": [
    "VERB",
    "PROPN"
  ],
  "uninsured": [
    "ADJ"
  ],
  "pilgrim": [
    "NOUN"
  ],
  "susceptibility": [
    "NOUN"
  ],
  "ambiguous": [
    "ADJ"
  ],
  "scouting": [
    "VERB"
  ],
  "royale": [
    "NOUN"
  ],
  "instinct": [
    "NOUN"
  ],
  "gorge": [
    "NOUN"
  ],
  "righteousness": [
    "NOUN"
  ],
  "carrot": [
    "NOUN"
  ],
  "discriminatory": [
    "ADJ"
  ],
  "opaque": [
    "NOUN"
  ],
  "bullying": [
    "VERB"
  ],
  "flaming": [
    "VERB"
  ],
  "empower": [
    "VERB",
    "PROPN"
  ],
  "marian": [
    "PROPN"
  ],
  "caterpillar": [
    "NOUN"
  ],
  "hurley": [
    "NOUN"
  ],
  "prevail": [
    "VERB"
  ],
  "migraine": [
    "NOUN"
  ],
  "undermine": [
    "VERB"
  ],
  "omission": [
    "NOUN"
  ],
  "jonas": [
    "NOUN"
  ],
  "methane": [
    "NOUN"
  ],
  "pager": [
    "NOUN",
    "PROPN"
  ],
  "correctness": [
    "NOUN"
  ],
  "implication": [
    "NOUN"
  ],
  "banjo": [
    "NOUN"
  ],
  "shaker": [
    "PROPN"
  ],
  "quilting": [
    "VERB"
  ],
  "stout": [
    "ADJ"
  ],
  "athena": [
    "PROPN"
  ],
  "matthias": [
    "NOUN"
  ],
  "duane": [
    "VERB"
  ],
  "turnaround": [
    "NOUN"
  ],
  "corrupted": [
    "VERB"
  ],
  "navigational": [
    "ADJ"
  ],
  "hanna": [
    "PROPN"
  ],
  "saskatoon": [
    "ADV"
  ],
  "fading": [
    "VERB"
  ],
  "persuade": [
    "NOUN"
  ],
  "roaming": [
    "VERB"
  ],
  "oversized": [
    "VERB"
  ],
  "sibling": [
    "VERB"
  ],
  "burberry": [
    "VERB"
  ],
  "weighed": [
    "VERB"
  ],
  "ashamed": [
    "ADJ"
  ],
  "concierge": [
    "NOUN"
  ],
  "gorilla": [
    "NOUN"
  ],
  "endure": [
    "VERB"
  ],
  "inhibit": [
    "VERB"
  ],
  "cheltenham": [
    "PROPN"
  ],
  "screenplay": [
    "VERB"
  ],
  "unabridged": [
    "VERB"
  ],
  "dickens": [
    "VERB"
  ],
  "juniper": [
    "NOUN"
  ],
  "repetition": [
    "NOUN"
  ],
  "siberian": [
    "PROPN"
  ],
  "synchronous": [
    "ADJ"
  ],
  "heartland": [
    "NOUN"
  ],
  "preparatory": [
    "NOUN"
  ],
  "cafeteria": [
    "PROPN"
  ],
  "homelessness": [
    "VERB"
  ],
  "cursed": [
    "VERB"
  ],
  "blowout": [
    "NOUN"
  ],
  "tumble": [
    "NOUN"
  ],
  "oversee": [
    "VERB"
  ],
  "stare": [
    "NOUN"
  ],
  "unlocking": [
    "VERB"
  ],
  "missy": [
    "ADJ"
  ],
  "contradiction": [
    "NOUN"
  ],
  "flair": [
    "NOUN"
  ],
  "helium": [
    "NOUN"
  ],
  "wonderfully": [
    "ADV"
  ],
  "tableware": [
    "ADJ"
  ],
  "bernie": [
    "PROPN"
  ],
  "congenital": [
    "ADJ"
  ],
  "insanity": [
    "NOUN"
  ],
  "clement": [
    "NOUN"
  ],
  "finely": [
    "ADV"
  ],
  "reformed": [
    "VERB"
  ],
  "tolerate": [
    "VERB"
  ],
  "adhesion": [
    "NOUN"
  ],
  "dialysis": [
    "NOUN"
  ],
  "carole": [
    "PROPN"
  ],
  "noticeable": [
    "ADJ"
  ],
  "aesthetics": [
    "NOUN"
  ],
  "smoker": [
    "NOUN"
  ],
  "benign": [
    "ADJ"
  ],
  "hypotheses": [
    "NOUN"
  ],
  "aisle": [
    "NOUN"
  ],
  "evidently": [
    "ADV"
  ],
  "unforgettable": [
    "ADJ"
  ],
  "sludge": [
    "NOUN"
  ],
  "tanned": [
    "VERB"
  ],
  "bunker": [
    "PROPN"
  ],
  "multiplication": [
    "NOUN"
  ],
  "heavyweight": [
    "NOUN"
  ],
  "pasture": [
    "NOUN"
  ],
  "cruelty": [
    "NOUN"
  ],
  "comptroller": [
    "NOUN"
  ],
  "creatine": [
    "VERB"
  ],
  "mormon": [
    "PROPN"
  ],
  "scots": [
    "NOUN"
  ],
  "genuinely": [
    "ADV"
  ],
  "plugged": [
    "VERB"
  ],
  "souvenir": [
    "NOUN"
  ],
  "relativity": [
    "NOUN"
  ],
  "cucumber": [
    "NOUN"
  ],
  "marshal": [
    "PROPN"
  ],
  "seize": [
    "VERB"
  ],
  "decisive": [
    "ADJ"
  ],
  "spawn": [
    "NOUN"
  ],
  "uncensored": [
    "ADJ"
  ],
  "stony": [
    "PROPN"
  ],
  "shelving": [
    "VERB"
  ],
  "effluent": [
    "NOUN"
  ],
  "annals": [
    "NOUN"
  ],
  "storytelling": [
    "NOUN",
    "VERB"
  ],
  "sadness": [
    "NOUN"
  ],
  "periodical": [
    "ADJ"
  ],
  "polarization": [
    "NOUN"
  ],
  "punta": [
    "NOUN"
  ],
  "flavour": [
    "NOUN"
  ],
  "crypt": [
    "X"
  ],
  "accomplishment": [
    "NOUN"
  ],
  "onwards": [
    "ADV"
  ],
  "bogus": [
    "ADJ"
  ],
  "barred": [
    "VERB"
  ],
  "skinner": [
    "PROPN"
  ],
  "customary": [
    "ADJ"
  ],
  "vertically": [
    "ADV"
  ],
  "cautious": [
    "ADJ"
  ],
  "urging": [
    "VERB"
  ],
  "faded": [
    "VERB"
  ],
  "counterpart": [
    "NOUN"
  ],
  "secretly": [
    "ADV"
  ],
  "tying": [
    "VERB"
  ],
  "diode": [
    "NOUN"
  ],
  "magician": [
    "PROPN"
  ],
  "indulgence": [
    "NOUN"
  ],
  "johan": [
    "PROPN"
  ],
  "melted": [
    "VERB"
  ],
  "flavored": [
    "VERB"
  ],
  "motto": [
    "NOUN"
  ],
  "singled": [
    "VERB"
  ],
  "appalachian": [
    "PROPN"
  ],
  "staple": [
    "NOUN"
  ],
  "pathetic": [
    "ADJ"
  ],
  "craftsman": [
    "NOUN"
  ],
  "irritation": [
    "NOUN"
  ],
  "centric": [
    "ADJ",
    "NOUN"
  ],
  "militia": [
    "NOUN"
  ],
  "optionally": [
    "PROPN"
  ],
  "conservatory": [
    "NOUN"
  ],
  "geophysical": [
    "ADJ"
  ],
  "fictional": [
    "ADJ"
  ],
  "adherence": [
    "NOUN"
  ],
  "grille": [
    "PROPN"
  ],
  "elisabeth": [
    "PROPN"
  ],
  "alain": [
    "NOUN"
  ],
  "flagship": [
    "NOUN"
  ],
  "illegally": [
    "ADV"
  ],
  "deter": [
    "NOUN"
  ],
  "furry": [
    "NOUN"
  ],
  "bouncing": [
    "VERB"
  ],
  "linus": [
    "NOUN"
  ],
  "cavalier": [
    "NOUN"
  ],
  "rinse": [
    "NOUN"
  ],
  "repertoire": [
    "NOUN"
  ],
  "respectfully": [
    "ADV"
  ],
  "emeritus": [
    "NOUN"
  ],
  "ulster": [
    "PROPN"
  ],
  "venom": [
    "PROPN"
  ],
  "tailed": [
    "VERB"
  ],
  "tapping": [
    "VERB"
  ],
  "immersion": [
    "NOUN"
  ],
  "explode": [
    "PROPN"
  ],
  "happier": [
    "ADJ"
  ],
  "mummy": [
    "PROPN"
  ],
  "winged": [
    "VERB"
  ],
  "speciality": [
    "NOUN"
  ],
  "warranted": [
    "VERB"
  ],
  "attacker": [
    "NOUN"
  ],
  "ruined": [
    "VERB"
  ],
  "catcher": [
    "NOUN"
  ],
  "sanity": [
    "NOUN"
  ],
  "ether": [
    "ADV"
  ],
  "suction": [
    "NOUN"
  ],
  "crusade": [
    "VERB"
  ],
  "rumble": [
    "ADJ"
  ],
  "inverter": [
    "NOUN"
  ],
  "correcting": [
    "VERB"
  ],
  "heroic": [
    "ADJ"
  ],
  "motivate": [
    "VERB"
  ],
  "formulate": [
    "VERB"
  ],
  "assessor": [
    "NOUN"
  ],
  "blockbuster": [
    "NOUN"
  ],
  "amarillo": [
    "ADV"
  ],
  "pathfinder": [
    "NOUN"
  ],
  "homogeneous": [
    "ADJ"
  ],
  "bonsai": [
    "PROPN"
  ],
  "windshield": [
    "NOUN"
  ],
  "humphrey": [
    "PROPN"
  ],
  "croydon": [
    "ADP"
  ],
  "convection": [
    "NOUN"
  ],
  "ancillary": [
    "ADJ"
  ],
  "pointless": [
    "ADJ"
  ],
  "whipped": [
    "VERB"
  ],
  "genealogical": [
    "ADJ"
  ],
  "inhalation": [
    "NOUN"
  ],
  "selfish": [
    "ADJ"
  ],
  "eventual": [
    "ADJ"
  ],
  "faucet": [
    "PROPN"
  ],
  "mitigate": [
    "VERB",
    "PROPN"
  ],
  "midget": [
    "NOUN"
  ],
  "boiled": [
    "VERB"
  ],
  "neville": [
    "PROPN"
  ],
  "experimentation": [
    "NOUN",
    "PROPN"
  ],
  "herring": [
    "VERB"
  ],
  "unfamiliar": [
    "ADJ"
  ],
  "wacky": [
    "ADJ"
  ],
  "expectancy": [
    "NOUN"
  ],
  "deterioration": [
    "NOUN"
  ],
  "anemia": [
    "NOUN"
  ],
  "biting": [
    "VERB"
  ],
  "coincidence": [
    "NOUN"
  ],
  "muddy": [
    "ADJ"
  ],
  "savanna": [
    "NOUN"
  ],
  "raspberry": [
    "VERB"
  ],
  "enumeration": [
    "NOUN"
  ],
  "keeling": [
    "VERB"
  ],
  "permissible": [
    "ADJ"
  ],
  "nuisance": [
    "NOUN"
  ],
  "latent": [
    "NOUN"
  ],
  "marcia": [
    "PROPN"
  ],
  "casper": [
    "ADV"
  ],
  "shalt": [
    "VERB"
  ],
  "commanding": [
    "VERB"
  ],
  "sparrow": [
    "VERB"
  ],
  "hector": [
    "NOUN"
  ],
  "nicotine": [
    "NOUN"
  ],
  "comeback": [
    "NOUN"
  ],
  "brotherhood": [
    "NOUN"
  ],
  "milling": [
    "VERB"
  ],
  "sinking": [
    "VERB"
  ],
  "sulphur": [
    "NOUN"
  ],
  "curricular": [
    "NOUN"
  ],
  "wicker": [
    "PROPN"
  ],
  "nephew": [
    "NOUN"
  ],
  "confess": [
    "VERB"
  ],
  "chaotic": [
    "ADJ"
  ],
  "principally": [
    "ADV"
  ],
  "visor": [
    "NOUN"
  ],
  "transistor": [
    "NOUN"
  ],
  "jarvis": [
    "PROPN"
  ],
  "outright": [
    "ADV"
  ],
  "spotting": [
    "VERB"
  ],
  "myriad": [
    "ADJ"
  ],
  "sandal": [
    "NOUN"
  ],
  "rubbing": [
    "VERB"
  ],
  "naive": [
    "ADJ"
  ],
  "skeptical": [
    "ADJ"
  ],
  "wagering": [
    "VERB"
  ],
  "remembrance": [
    "NOUN"
  ],
  "disregard": [
    "NOUN"
  ],
  "hanger": [
    "PROPN"
  ],
  "dragged": [
    "VERB"
  ],
  "foreman": [
    "PROPN"
  ],
  "allegiance": [
    "NOUN"
  ],
  "conduit": [
    "NOUN"
  ],
  "dependable": [
    "ADJ"
  ],
  "prudent": [
    "ADJ"
  ],
  "glowing": [
    "VERB"
  ],
  "heartbeat": [
    "NOUN",
    "PROPN"
  ],
  "blazer": [
    "NOUN"
  ],
  "alchemy": [
    "ADJ"
  ],
  "linden": [
    "PROPN"
  ],
  "tanya": [
    "PROPN"
  ],
  "geographically": [
    "ADV"
  ],
  "alternating": [
    "VERB"
  ],
  "tristan": [
    "PROPN"
  ],
  "audible": [
    "ADJ"
  ],
  "folio": [
    "PROPN"
  ],
  "colleen": [
    "VERB"
  ],
  "lexicon": [
    "PROPN"
  ],
  "apprenticeship": [
    "NOUN"
  ],
  "childbirth": [
    "ADV"
  ],
  "zirconia": [
    "PROPN"
  ],
  "johannes": [
    "NOUN"
  ],
  "fiery": [
    "NOUN"
  ],
  "convex": [
    "NOUN"
  ],
  "soleil": [
    "NOUN"
  ],
  "surfer": [
    "VERB"
  ],
  "outbound": [
    "NOUN",
    "PROPN"
  ],
  "breakout": [
    "PROPN",
    "ADJ"
  ],
  "restless": [
    "ADJ"
  ],
  "unanswered": [
    "ADJ"
  ],
  "paired": [
    "VERB"
  ],
  "remortgage": [
    "VERB"
  ],
  "caucus": [
    "NOUN"
  ],
  "polytechnic": [
    "ADJ"
  ],
  "salute": [
    "NOUN"
  ],
  "shoppe": [
    "PROPN"
  ],
  "parody": [
    "NOUN"
  ],
  "penthouse": [
    "VERB"
  ],
  "maltese": [
    "ADJ"
  ],
  "acorn": [
    "VERB"
  ],
  "ascension": [
    "NOUN"
  ],
  "mornings": [
    "NOUN"
  ],
  "cation": [
    "NOUN"
  ],
  "flagstaff": [
    "NOUN"
  ],
  "thrive": [
    "VERB"
  ],
  "feminism": [
    "NOUN"
  ],
  "rightly": [
    "ADV"
  ],
  "paragon": [
    "PROPN"
  ],
  "basal": [
    "NOUN"
  ],
  "turnout": [
    "NOUN"
  ],
  "persist": [
    "VERB"
  ],
  "indispensable": [
    "ADJ"
  ],
  "illicit": [
    "NOUN"
  ],
  "firefly": [
    "NOUN"
  ],
  "pictorial": [
    "ADJ"
  ],
  "curling": [
    "VERB"
  ],
  "wholesaler": [
    "PROPN"
  ],
  "smoky": [
    "VERB"
  ],
  "aromatic": [
    "ADJ"
  ],
  "flirt": [
    "NOUN"
  ],
  "slang": [
    "PROPN"
  ],
  "emporium": [
    "VERB"
  ],
  "soothing": [
    "VERB"
  ],
  "departed": [
    "VERB"
  ],
  "finch": [
    "NOUN"
  ],
  "inherently": [
    "ADV"
  ],
  "krishna": [
    "NOUN"
  ],
  "forefront": [
    "NOUN"
  ],
  "monophonic": [
    "ADJ"
  ],
  "largo": [
    "NOUN"
  ],
  "amazingly": [
    "ADV"
  ],
  "plural": [
    "NOUN"
  ],
  "dominic": [
    "ADJ"
  ],
  "sergio": [
    "NOUN"
  ],
  "swapping": [
    "VERB"
  ],
  "hereinafter": [
    "VERB"
  ],
  "analogous": [
    "ADJ"
  ],
  "particulate": [
    "NOUN"
  ],
  "tally": [
    "ADV"
  ],
  "unpleasant": [
    "ADJ"
  ],
  "blindness": [
    "NOUN"
  ],
  "creep": [
    "VERB"
  ],
  "staining": [
    "VERB"
  ],
  "shaded": [
    "VERB"
  ],
  "plaster": [
    "NOUN"
  ],
  "negotiable": [
    "ADJ"
  ],
  "hearted": [
    "VERB"
  ],
  "quarterback": [
    "NOUN"
  ],
  "obstruction": [
    "NOUN"
  ],
  "agility": [
    "PROPN",
    "NOUN"
  ],
  "overture": [
    "NOUN"
  ],
  "upscale": [
    "NOUN"
  ],
  "scrabble": [
    "ADJ"
  ],
  "noteworthy": [
    "ADJ"
  ],
  "agile": [
    "PROPN",
    "ADJ"
  ],
  "kiosk": [
    "PROPN"
  ],
  "ionic": [
    "ADJ"
  ],
  "stray": [
    "VERB"
  ],
  "runaway": [
    "ADJ"
  ],
  "hoodie": [
    "PROPN"
  ],
  "clinically": [
    "ADV"
  ],
  "poppy": [
    "ADJ"
  ],
  "monmouth": [
    "NOUN"
  ],
  "frenzy": [
    "NOUN"
  ],
  "jargon": [
    "PROPN"
  ],
  "kangaroo": [
    "PROPN"
  ],
  "sleeper": [
    "ADJ"
  ],
  "elemental": [
    "ADJ"
  ],
  "unnamed": [
    "ADJ"
  ],
  "bungalow": [
    "VERB"
  ],
  "bazaar": [
    "VERB"
  ],
  "interconnect": [
    "VERB"
  ],
  "predicate": [
    "NOUN"
  ],
  "recurrence": [
    "NOUN"
  ],
  "chinatown": [
    "NOUN"
  ],
  "mindless": [
    "ADJ"
  ],
  "purifier": [
    "NOUN"
  ],
  "sharper": [
    "ADJ"
  ],
  "greedy": [
    "ADJ"
  ],
  "supervise": [
    "VERB"
  ],
  "stamping": [
    "VERB"
  ],
  "downing": [
    "VERB"
  ],
  "basque": [
    "NOUN"
  ],
  "societal": [
    "NOUN"
  ],
  "halogen": [
    "PROPN"
  ],
  "pegasus": [
    "NOUN"
  ],
  "silhouette": [
    "NOUN"
  ],
  "dorado": [
    "PROPN"
  ],
  "daring": [
    "VERB"
  ],
  "maestro": [
    "PROPN"
  ],
  "forte": [
    "NOUN"
  ],
  "coaxial": [
    "ADJ"
  ],
  "tipping": [
    "VERB"
  ],
  "holster": [
    "ADV"
  ],
  "fiddle": [
    "NOUN"
  ],
  "crunch": [
    "NOUN"
  ],
  "arabidopsis": [
    "NOUN"
  ],
  "ballistic": [
    "ADJ"
  ],
  "exemplary": [
    "VERB"
  ],
  "caliber": [
    "NOUN"
  ],
  "apostle": [
    "VERB"
  ],
  "playful": [
    "ADJ"
  ],
  "icelandic": [
    "ADJ"
  ],
  "belgrade": [
    "VERB"
  ],
  "waive": [
    "VERB"
  ],
  "contraception": [
    "NOUN"
  ],
  "polaroid": [
    "PROPN"
  ],
  "vance": [
    "NOUN"
  ],
  "soprano": [
    "NOUN"
  ],
  "marquis": [
    "NOUN"
  ],
  "underage": [
    "ADJ"
  ],
  "logger": [
    "NOUN",
    "PROPN"
  ],
  "adjoining": [
    "VERB"
  ],
  "greet": [
    "VERB"
  ],
  "acclaim": [
    "NOUN"
  ],
  "birding": [
    "VERB"
  ],
  "hardship": [
    "NOUN"
  ],
  "lymph": [
    "NOUN"
  ],
  "pollutant": [
    "ADJ"
  ],
  "miriam": [
    "NOUN"
  ],
  "almighty": [
    "ADV"
  ],
  "weekday": [
    "NOUN"
  ],
  "kurdish": [
    "PROPN"
  ],
  "intuition": [
    "NOUN"
  ],
  "openness": [
    "NOUN"
  ],
  "chromium": [
    "NOUN"
  ],
  "bryce": [
    "NOUN"
  ],
  "latch": [
    "VERB"
  ],
  "drank": [
    "VERB"
  ],
  "confrontation": [
    "NOUN"
  ],
  "grower": [
    "NOUN"
  ],
  "frederic": [
    "PROPN"
  ],
  "slippery": [
    "ADJ"
  ],
  "unpredictable": [
    "ADJ"
  ],
  "capacitor": [
    "NOUN"
  ],
  "outpost": [
    "NOUN"
  ],
  "moroccan": [
    "PROPN"
  ],
  "chatter": [
    "NOUN"
  ],
  "santo": [
    "DET"
  ],
  "lettuce": [
    "VERB"
  ],
  "raging": [
    "VERB"
  ],
  "subgroup": [
    "NOUN"
  ],
  "oppression": [
    "NOUN"
  ],
  "yielding": [
    "VERB"
  ],
  "torso": [
    "NOUN"
  ],
  "occult": [
    "NOUN"
  ],
  "ramon": [
    "NOUN"
  ],
  "longhorn": [
    "VERB"
  ],
  "lorenzo": [
    "NOUN"
  ],
  "backdrop": [
    "PROPN"
  ],
  "subordinate": [
    "NOUN"
  ],
  "aerobic": [
    "ADJ"
  ],
  "articulate": [
    "VERB"
  ],
  "ecstasy": [
    "VERB"
  ],
  "sweetheart": [
    "NOUN"
  ],
  "mediator": [
    "NOUN"
  ],
  "dunlop": [
    "VERB"
  ],
  "modernization": [
    "NOUN",
    "PROPN"
  ],
  "cultivated": [
    "VERB"
  ],
  "disconnected": [
    "VERB",
    "ADJ"
  ],
  "consulate": [
    "NOUN"
  ],
  "businessman": [
    "NOUN"
  ],
  "lucent": [
    "NOUN"
  ],
  "commuter": [
    "VERB"
  ],
  "orthopedic": [
    "NOUN"
  ],
  "disagreement": [
    "NOUN"
  ],
  "tyrosine": [
    "NOUN"
  ],
  "compost": [
    "NOUN"
  ],
  "familiarity": [
    "NOUN",
    "PROPN"
  ],
  "erroneous": [
    "ADJ"
  ],
  "marlin": [
    "PROPN"
  ],
  "theses": [
    "VERB"
  ],
  "stuffing": [
    "VERB"
  ],
  "casserole": [
    "NOUN"
  ],
  "canoeing": [
    "VERB"
  ],
  "wilton": [
    "PROPN"
  ],
  "ophthalmology": [
    "NOUN"
  ],
  "flooded": [
    "VERB"
  ],
  "clubhouse": [
    "NOUN"
  ],
  "crackers": [
    "NOUN"
  ],
  "greyhound": [
    "VERB"
  ],
  "corsair": [
    "PROPN"
  ],
  "unsupported": [
    "ADJ"
  ],
  "hinge": [
    "VERB"
  ],
  "ultima": [
    "ADJ"
  ],
  "cockpit": [
    "PROPN"
  ],
  "venetian": [
    "PROPN"
  ],
  "conversely": [
    "ADV"
  ],
  "stunt": [
    "NOUN"
  ],
  "commute": [
    "NOUN"
  ],
  "staged": [
    "VERB"
  ],
  "hustle": [
    "ADV"
  ],
  "stimuli": [
    "NOUN"
  ],
  "upwards": [
    "ADV"
  ],
  "witty": [
    "ADJ"
  ],
  "transcend": [
    "VERB"
  ],
  "loosely": [
    "ADV"
  ],
  "hertz": [
    "NOUN"
  ],
  "atheist": [
    "PROPN"
  ],
  "capped": [
    "VERB"
  ],
  "liking": [
    "VERB"
  ],
  "preacher": [
    "ADV"
  ],
  "propulsion": [
    "NOUN"
  ],
  "intangible": [
    "ADJ"
  ],
  "compassionate": [
    "VERB"
  ],
  "catastrophic": [
    "ADJ"
  ],
  "blower": [
    "NOUN"
  ],
  "flown": [
    "VERB"
  ],
  "silky": [
    "VERB"
  ],
  "groovy": [
    "NOUN"
  ],
  "actuarial": [
    "NOUN"
  ],
  "distorted": [
    "VERB"
  ],
  "nathaniel": [
    "NOUN"
  ],
  "grizzly": [
    "PROPN"
  ],
  "micah": [
    "NOUN"
  ],
  "erectile": [
    "ADJ"
  ],
  "timeliness": [
    "NOUN"
  ],
  "obstetrics": [
    "NOUN"
  ],
  "repay": [
    "PROPN"
  ],
  "hurting": [
    "VERB"
  ],
  "homicide": [
    "VERB"
  ],
  "prognosis": [
    "VERB"
  ],
  "colombian": [
    "PROPN"
  ],
  "pandemic": [
    "ADJ"
  ],
  "await": [
    "VERB",
    "PROPN"
  ],
  "sparse": [
    "ADV"
  ],
  "chemically": [
    "ADV"
  ],
  "fetus": [
    "NOUN"
  ],
  "durango": [
    "NOUN"
  ],
  "cider": [
    "NOUN"
  ],
  "noncommercial": [
    "ADJ"
  ],
  "crooked": [
    "VERB"
  ],
  "segregation": [
    "NOUN"
  ],
  "superannuation": [
    "NOUN"
  ],
  "overcast": [
    "ADJ"
  ],
  "inverted": [
    "VERB"
  ],
  "lenny": [
    "PROPN"
  ],
  "remake": [
    "NOUN"
  ],
  "braille": [
    "PROPN"
  ],
  "forehead": [
    "PROPN"
  ],
  "percy": [
    "PROPN"
  ],
  "scratches": [
    "VERB"
  ],
  "lilac": [
    "PROPN"
  ],
  "sinus": [
    "NOUN"
  ],
  "maverick": [
    "PROPN"
  ],
  "intellect": [
    "NOUN"
  ],
  "harman": [
    "NOUN"
  ],
  "wilhelm": [
    "PROPN"
  ],
  "nationalism": [
    "NOUN"
  ],
  "pervasive": [
    "ADJ"
  ],
  "anabolic": [
    "NOUN"
  ],
  "knowingly": [
    "ADV"
  ],
  "pivot": [
    "VERB",
    "NOUN"
  ],
  "amplification": [
    "NOUN"
  ],
  "huron": [
    "NOUN"
  ],
  "digestion": [
    "NOUN"
  ],
  "dustin": [
    "VERB"
  ],
  "soaring": [
    "VERB"
  ],
  "dragging": [
    "VERB"
  ],
  "banning": [
    "VERB"
  ],
  "flushing": [
    "VERB"
  ],
  "deprivation": [
    "NOUN"
  ],
  "foreword": [
    "NOUN"
  ],
  "glide": [
    "NOUN"
  ],
  "transverse": [
    "VERB"
  ],
  "withstand": [
    "VERB"
  ],
  "uniformly": [
    "ADV"
  ],
  "piedmont": [
    "PROPN"
  ],
  "outlying": [
    "ADJ"
  ],
  "slogan": [
    "NOUN"
  ],
  "ezekiel": [
    "PROPN"
  ],
  "elijah": [
    "PROPN"
  ],
  "marvelous": [
    "ADJ"
  ],
  "vigorous": [
    "ADJ"
  ],
  "biloxi": [
    "NOUN"
  ],
  "biscuit": [
    "VERB"
  ],
  "waltz": [
    "NOUN"
  ],
  "menace": [
    "NOUN"
  ],
  "downstairs": [
    "NOUN"
  ],
  "statesman": [
    "NOUN"
  ],
  "cheerful": [
    "ADJ"
  ],
  "blush": [
    "NOUN"
  ],
  "leaflet": [
    "PROPN"
  ],
  "spherical": [
    "ADJ"
  ],
  "intracellular": [
    "ADJ"
  ],
  "geisha": [
    "VERB"
  ],
  "billiard": [
    "PROPN"
  ],
  "malay": [
    "NOUN"
  ],
  "unseen": [
    "ADJ"
  ],
  "optimism": [
    "NOUN"
  ],
  "silica": [
    "PROPN"
  ],
  "modal": [
    "NOUN",
    "PROPN"
  ],
  "unusually": [
    "ADV"
  ],
  "addendum": [
    "PROPN"
  ],
  "impotence": [
    "NOUN"
  ],
  "medley": [
    "PROPN"
  ],
  "cadet": [
    "NOUN"
  ],
  "kirsten": [
    "VERB"
  ],
  "temper": [
    "NOUN"
  ],
  "yorker": [
    "PROPN"
  ],
  "intravenous": [
    "ADJ"
  ],
  "loren": [
    "PROPN"
  ],
  "hereafter": [
    "VERB"
  ],
  "retiring": [
    "VERB"
  ],
  "smashing": [
    "VERB"
  ],
  "yakima": [
    "PROPN"
  ],
  "accumulate": [
    "VERB"
  ],
  "tahiti": [
    "PROPN"
  ],
  "tracey": [
    "PROPN"
  ],
  "mariner": [
    "NOUN"
  ],
  "collier": [
    "ADJ"
  ],
  "fragmentation": [
    "NOUN"
  ],
  "paranormal": [
    "NOUN"
  ],
  "whispered": [
    "VERB"
  ],
  "generosity": [
    "NOUN"
  ],
  "vibrating": [
    "VERB"
  ],
  "artisan": [
    "NOUN"
  ],
  "raphael": [
    "PROPN"
  ],
  "embarrassing": [
    "VERB"
  ],
  "aqueous": [
    "ADJ"
  ],
  "pembroke": [
    "VERB"
  ],
  "splinter": [
    "VERB"
  ],
  "preferable": [
    "ADJ"
  ],
  "ironically": [
    "ADV"
  ],
  "morale": [
    "NOUN"
  ],
  "solder": [
    "PROPN"
  ],
  "trench": [
    "NOUN"
  ],
  "persuasion": [
    "NOUN"
  ],
  "stripper": [
    "PROPN"
  ],
  "adrenaline": [
    "NOUN"
  ],
  "mammalian": [
    "PROPN"
  ],
  "lodged": [
    "VERB"
  ],
  "revolt": [
    "NOUN"
  ],
  "meteorology": [
    "NOUN"
  ],
  "pristine": [
    "ADJ"
  ],
  "catalan": [
    "PROPN"
  ],
  "regain": [
    "VERB"
  ],
  "resize": [
    "NOUN"
  ],
  "auditory": [
    "ADJ"
  ],
  "applause": [
    "NOUN"
  ],
  "medically": [
    "ADV"
  ],
  "tweak": [
    "VERB"
  ],
  "trait": [
    "NOUN",
    "PROPN"
  ],
  "busted": [
    "VERB"
  ],
  "farmhouse": [
    "NOUN"
  ],
  "pounding": [
    "VERB"
  ],
  "picturesque": [
    "ADJ"
  ],
  "ottoman": [
    "NOUN"
  ],
  "eater": [
    "NOUN"
  ],
  "utopia": [
    "NOUN"
  ],
  "slider": [
    "NOUN"
  ],
  "lettering": [
    "VERB"
  ],
  "pouring": [
    "VERB"
  ],
  "cyrus": [
    "PROPN"
  ],
  "courtroom": [
    "NOUN"
  ],
  "manure": [
    "NOUN"
  ],
  "savior": [
    "PROPN"
  ],
  "secrecy": [
    "NOUN"
  ],
  "wesleyan": [
    "PROPN"
  ],
  "fertile": [
    "ADJ"
  ],
  "plausible": [
    "ADJ"
  ],
  "creepy": [
    "PROPN"
  ],
  "filthy": [
    "ADJ"
  ],
  "subchapter": [
    "NOUN"
  ],
  "narrator": [
    "NOUN"
  ],
  "augustus": [
    "PROPN"
  ],
  "fahrenheit": [
    "VERB"
  ],
  "hillside": [
    "NOUN"
  ],
  "standpoint": [
    "NOUN"
  ],
  "nationalist": [
    "ADJ"
  ],
  "piazza": [
    "VERB"
  ],
  "oneself": [
    "PRON"
  ],
  "piles": [
    "NOUN"
  ],
  "abbreviation": [
    "NOUN"
  ],
  "blanco": [
    "PROPN"
  ],
  "stroll": [
    "NOUN"
  ],
  "anomaly": [
    "PROPN",
    "NOUN"
  ],
  "expressive": [
    "ADJ"
  ],
  "infect": [
    "VERB"
  ],
  "bezel": [
    "NOUN"
  ],
  "dotted": [
    "VERB"
  ],
  "frontal": [
    "ADJ"
  ],
  "havoc": [
    "NOUN"
  ],
  "ubiquitous": [
    "ADJ"
  ],
  "arsenic": [
    "PROPN"
  ],
  "synonym": [
    "NOUN"
  ],
  "facilitation": [
    "NOUN"
  ],
  "ballad": [
    "PROPN"
  ],
  "sling": [
    "VERB"
  ],
  "contraction": [
    "NOUN"
  ],
  "billie": [
    "PROPN"
  ],
  "undercover": [
    "ADJ"
  ],
  "ravens": [
    "VERB"
  ],
  "underline": [
    "NOUN"
  ],
  "obscene": [
    "VERB"
  ],
  "continual": [
    "ADJ"
  ],
  "nuclei": [
    "PROPN"
  ],
  "tummy": [
    "ADV"
  ],
  "axial": [
    "NOUN"
  ],
  "aladdin": [
    "VERB"
  ],
  "outing": [
    "VERB"
  ],
  "instruct": [
    "VERB"
  ],
  "topographic": [
    "ADJ"
  ],
  "overhaul": [
    "NOUN"
  ],
  "peruvian": [
    "NOUN"
  ],
  "indemnity": [
    "NOUN"
  ],
  "imaginative": [
    "ADJ"
  ],
  "clarendon": [
    "PROPN"
  ],
  "phenotype": [
    "NOUN"
  ],
  "julio": [
    "PROPN"
  ],
  "affirm": [
    "ADJ"
  ],
  "epoch": [
    "PROPN"
  ],
  "mourning": [
    "VERB"
  ],
  "resistor": [
    "NOUN"
  ],
  "plaid": [
    "NOUN"
  ],
  "fable": [
    "ADJ"
  ],
  "snowmobile": [
    "VERB"
  ],
  "exploded": [
    "VERB"
  ],
  "whisky": [
    "NOUN"
  ],
  "uptown": [
    "VERB"
  ],
  "susie": [
    "PROPN"
  ],
  "subparagraph": [
    "NOUN"
  ],
  "batter": [
    "VERB"
  ],
  "weighting": [
    "PROPN",
    "NOUN"
  ],
  "silently": [
    "ADV"
  ],
  "impartial": [
    "ADJ"
  ],
  "punctuation": [
    "NOUN"
  ],
  "pallet": [
    "VERB"
  ],
  "tanner": [
    "NOUN"
  ],
  "urology": [
    "NOUN"
  ],
  "tackling": [
    "VERB"
  ],
  "obese": [
    "PROPN"
  ],
  "compress": [
    "VERB"
  ],
  "sober": [
    "ADJ"
  ],
  "tread": [
    "VERB"
  ],
  "legitimacy": [
    "PROPN"
  ],
  "zoology": [
    "NOUN"
  ],
  "unwilling": [
    "ADJ"
  ],
  "wigan": [
    "PROPN"
  ],
  "plunge": [
    "VERB"
  ],
  "sinister": [
    "NOUN"
  ],
  "chaser": [
    "NOUN"
  ],
  "vantage": [
    "NOUN"
  ],
  "diffuse": [
    "VERB"
  ],
  "boredom": [
    "PROPN"
  ],
  "norma": [
    "VERB"
  ],
  "crosse": [
    "PROPN"
  ],
  "overdrive": [
    "ADJ"
  ],
  "phosphorylation": [
    "NOUN"
  ],
  "helpless": [
    "ADJ"
  ],
  "depletion": [
    "NOUN"
  ],
  "neonatal": [
    "ADJ"
  ],
  "visionary": [
    "NOUN"
  ],
  "coffin": [
    "NOUN"
  ],
  "otter": [
    "NOUN"
  ],
  "navajo": [
    "PROPN"
  ],
  "recess": [
    "NOUN"
  ],
  "dispersed": [
    "VERB"
  ],
  "technics": [
    "NOUN"
  ],
  "shilling": [
    "VERB"
  ],
  "resemble": [
    "VERB"
  ],
  "spirited": [
    "VERB"
  ],
  "carbonate": [
    "PROPN"
  ],
  "discriminate": [
    "VERB"
  ],
  "recharge": [
    "VERB"
  ],
  "crocodile": [
    "NOUN"
  ],
  "sassy": [
    "ADJ"
  ],
  "ratification": [
    "NOUN"
  ],
  "transnational": [
    "ADJ"
  ],
  "coward": [
    "ADV"
  ],
  "preset": [
    "ADJ"
  ],
  "pancreatic": [
    "ADJ"
  ],
  "turbulence": [
    "NOUN"
  ],
  "underwriting": [
    "VERB"
  ],
  "dresser": [
    "NOUN"
  ],
  "ornamental": [
    "ADJ"
  ],
  "riches": [
    "NOUN"
  ],
  "resign": [
    "NOUN"
  ],
  "collectable": [
    "ADJ"
  ],
  "stephan": [
    "VERB"
  ],
  "aries": [
    "NOUN"
  ],
  "injunction": [
    "NOUN"
  ],
  "intervene": [
    "VERB"
  ],
  "poised": [
    "VERB"
  ],
  "barking": [
    "VERB"
  ],
  "josephine": [
    "PROPN"
  ],
  "dread": [
    "NOUN"
  ],
  "catchment": [
    "NOUN"
  ],
  "tactic": [
    "NOUN"
  ],
  "partitioning": [
    "VERB"
  ],
  "handwriting": [
    "NOUN"
  ],
  "serpent": [
    "NOUN"
  ],
  "articulated": [
    "VERB"
  ],
  "parentheses": [
    "VERB"
  ],
  "contextual": [
    "ADJ"
  ],
  "wisely": [
    "ADV"
  ],
  "accustomed": [
    "VERB"
  ],
  "playhouse": [
    "NOUN"
  ],
  "superficial": [
    "ADJ"
  ],
  "cryptography": [
    "NOUN"
  ],
  "sanction": [
    "NOUN"
  ],
  "tubular": [
    "ADJ"
  ],
  "scorpio": [
    "NOUN"
  ],
  "ultrasonic": [
    "ADJ"
  ],
  "heinz": [
    "PROPN"
  ],
  "larvae": [
    "PROPN"
  ],
  "intergovernmental": [
    "ADJ"
  ],
  "paranoid": [
    "ADJ"
  ],
  "mobilization": [
    "NOUN"
  ],
  "chilean": [
    "VERB"
  ],
  "qualifier": [
    "ADJ"
  ],
  "alleviate": [
    "VERB"
  ],
  "fungal": [
    "NOUN"
  ],
  "riddle": [
    "NOUN"
  ],
  "fainter": [
    "NOUN"
  ],
  "respectful": [
    "ADJ"
  ],
  "flamingo": [
    "PROPN"
  ],
  "cabaret": [
    "VERB"
  ],
  "deformation": [
    "NOUN"
  ],
  "recession": [
    "NOUN"
  ],
  "assembler": [
    "NOUN"
  ],
  "nozzle": [
    "VERB"
  ],
  "externally": [
    "ADV"
  ],
  "needy": [
    "ADJ"
  ],
  "employability": [
    "NOUN"
  ],
  "wheeled": [
    "VERB"
  ],
  "retardation": [
    "NOUN"
  ],
  "corning": [
    "VERB"
  ],
  "armored": [
    "VERB"
  ],
  "weary": [
    "ADJ"
  ],
  "solitary": [
    "ADJ"
  ],
  "tweed": [
    "VERB"
  ],
  "snowy": [
    "PROPN"
  ],
  "pianist": [
    "NOUN"
  ],
  "emmanuel": [
    "PROPN"
  ],
  "acapulco": [
    "NOUN"
  ],
  "knocking": [
    "VERB"
  ],
  "cosmopolitan": [
    "PROPN"
  ],
  "magistrate": [
    "PROPN"
  ],
  "everlasting": [
    "VERB"
  ],
  "pigment": [
    "NOUN"
  ],
  "faction": [
    "NOUN"
  ],
  "argentine": [
    "ADJ"
  ],
  "endocrine": [
    "NOUN"
  ],
  "scandinavia": [
    "PROPN"
  ],
  "minnie": [
    "PROPN"
  ],
  "genie": [
    "PROPN"
  ],
  "geophysics": [
    "NOUN"
  ],
  "microscopic": [
    "ADJ"
  ],
  "coherence": [
    "NOUN"
  ],
  "slater": [
    "ADP"
  ],
  "broccoli": [
    "NOUN"
  ],
  "oakwood": [
    "PROPN"
  ],
  "orphan": [
    "NOUN"
  ],
  "chandelier": [
    "NOUN"
  ],
  "linker": [
    "NOUN"
  ],
  "embryonic": [
    "ADJ"
  ],
  "carver": [
    "NOUN"
  ],
  "graceful": [
    "ADJ"
  ],
  "synchronized": [
    "VERB"
  ],
  "intercept": [
    "VERB"
  ],
  "shellfish": [
    "VERB"
  ],
  "ascertain": [
    "VERB"
  ],
  "trajectory": [
    "NOUN"
  ],
  "epsilon": [
    "NOUN"
  ],
  "exhaustive": [
    "ADJ"
  ],
  "bureaucracy": [
    "NOUN"
  ],
  "astrophysics": [
    "NOUN"
  ],
  "hansard": [
    "NOUN"
  ],
  "inward": [
    "ADV"
  ],
  "reflector": [
    "NOUN"
  ],
  "meaningless": [
    "ADJ"
  ],
  "relocate": [
    "VERB"
  ],
  "negligible": [
    "ADJ"
  ],
  "starch": [
    "NOUN"
  ],
  "melinda": [
    "PROPN"
  ],
  "godfather": [
    "ADV"
  ],
  "apron": [
    "PROPN"
  ],
  "glazing": [
    "VERB"
  ],
  "pragmatic": [
    "ADJ"
  ],
  "tyranny": [
    "NOUN"
  ],
  "regimen": [
    "NOUN"
  ],
  "antony": [
    "PROPN"
  ],
  "fluffy": [
    "PROPN"
  ],
  "marianne": [
    "PROPN"
  ],
  "slender": [
    "ADJ"
  ],
  "hereford": [
    "PROPN"
  ],
  "bender": [
    "NOUN"
  ],
  "reliably": [
    "ADV"
  ],
  "aides": [
    "NOUN"
  ],
  "absorbing": [
    "VERB"
  ],
  "gaelic": [
    "ADJ"
  ],
  "distinguishing": [
    "VERB"
  ],
  "ventricular": [
    "ADJ"
  ],
  "glazed": [
    "VERB"
  ],
  "dashed": [
    "VERB"
  ],
  "libyan": [
    "ADJ"
  ],
  "distressed": [
    "VERB"
  ],
  "shouting": [
    "VERB"
  ],
  "bullock": [
    "PROPN"
  ],
  "transferable": [
    "ADJ"
  ],
  "yummy": [
    "ADV"
  ],
  "ethiopian": [
    "PROPN"
  ],
  "mermaid": [
    "VERB"
  ],
  "concordance": [
    "NOUN"
  ],
  "wilder": [
    "VERB"
  ],
  "confinement": [
    "NOUN"
  ],
  "uncover": [
    "VERB"
  ],
  "husky": [
    "NOUN"
  ],
  "conserve": [
    "VERB"
  ],
  "bland": [
    "VERB"
  ],
  "abatement": [
    "NOUN"
  ],
  "originator": [
    "NOUN"
  ],
  "ching": [
    "VERB"
  ],
  "whipping": [
    "VERB"
  ],
  "skipping": [
    "VERB"
  ],
  "melanoma": [
    "VERB"
  ],
  "rudolph": [
    "VERB"
  ],
  "abigail": [
    "VERB"
  ],
  "yugoslav": [
    "ADJ"
  ],
  "householder": [
    "PROPN"
  ],
  "plotting": [
    "VERB"
  ],
  "succeeding": [
    "VERB"
  ],
  "shaver": [
    "NOUN"
  ],
  "elmer": [
    "NOUN"
  ],
  "fibrosis": [
    "NOUN"
  ],
  "hummingbird": [
    "PROPN"
  ],
  "overlook": [
    "VERB"
  ],
  "ported": [
    "VERB"
  ],
  "fungus": [
    "NOUN"
  ],
  "astonishing": [
    "VERB"
  ],
  "polyethylene": [
    "NOUN"
  ],
  "graveyard": [
    "NOUN"
  ],
  "revert": [
    "PROPN",
    "VERB"
  ],
  "parametric": [
    "ADJ"
  ],
  "pandora": [
    "PROPN"
  ],
  "flatware": [
    "PROPN"
  ],
  "polaris": [
    "PROPN",
    "ADJ"
  ],
  "enigma": [
    "NOUN"
  ],
  "parenthood": [
    "NOUN"
  ],
  "militant": [
    "NOUN"
  ],
  "inferno": [
    "PROPN"
  ],
  "allegheny": [
    "PROPN"
  ],
  "outset": [
    "NOUN"
  ],
  "confuse": [
    "VERB"
  ],
  "yvonne": [
    "NOUN"
  ],
  "adept": [
    "ADJ"
  ],
  "doubtful": [
    "ADJ"
  ],
  "consultative": [
    "ADJ"
  ],
  "insecure": [
    "NOUN",
    "ADJ"
  ],
  "normative": [
    "ADJ"
  ],
  "versatility": [
    "NOUN"
  ],
  "mckay": [
    "VERB"
  ],
  "intricate": [
    "ADJ"
  ],
  "strata": [
    "VERB"
  ],
  "solver": [
    "VERB"
  ],
  "depository": [
    "NOUN"
  ],
  "hubert": [
    "PROPN"
  ],
  "proclamation": [
    "NOUN"
  ],
  "kudos": [
    "NOUN",
    "PROPN"
  ],
  "gillian": [
    "NOUN"
  ],
  "darrell": [
    "VERB"
  ],
  "irrespective": [
    "ADV"
  ],
  "imposition": [
    "NOUN"
  ],
  "shawnee": [
    "ADJ"
  ],
  "outrage": [
    "NOUN"
  ],
  "orchestral": [
    "ADJ"
  ],
  "artifact": [
    "NOUN",
    "PROPN"
  ],
  "veterinarian": [
    "PROPN"
  ],
  "dripping": [
    "VERB"
  ],
  "krona": [
    "PROPN"
  ],
  "afterward": [
    "ADV"
  ],
  "disseminate": [
    "VERB"
  ],
  "devote": [
    "VERB"
  ],
  "frightened": [
    "VERB"
  ],
  "ambiguity": [
    "NOUN"
  ],
  "discourage": [
    "VERB"
  ],
  "elusive": [
    "ADJ"
  ],
  "speculative": [
    "VERB"
  ],
  "madeira": [
    "PROPN"
  ],
  "intimacy": [
    "NOUN"
  ],
  "geologic": [
    "NOUN"
  ],
  "hallway": [
    "ADJ"
  ],
  "ripping": [
    "VERB"
  ],
  "endocrinology": [
    "NOUN"
  ],
  "polygon": [
    "PROPN"
  ],
  "ester": [
    "NOUN"
  ],
  "servo": [
    "VERB"
  ],
  "riparian": [
    "PROPN"
  ],
  "thriving": [
    "VERB"
  ],
  "gracious": [
    "ADJ"
  ],
  "guelph": [
    "PROPN"
  ],
  "tenuate": [
    "VERB"
  ],
  "snail": [
    "NOUN"
  ],
  "curator": [
    "NOUN"
  ],
  "jaime": [
    "NOUN"
  ],
  "demise": [
    "NOUN"
  ],
  "theoretically": [
    "ADV"
  ],
  "sutra": [
    "NOUN"
  ],
  "mower": [
    "NOUN"
  ],
  "swine": [
    "PROPN"
  ],
  "typographical": [
    "ADJ"
  ],
  "quicken": [
    "VERB"
  ],
  "stressful": [
    "ADJ"
  ],
  "heron": [
    "PROPN"
  ],
  "graft": [
    "NOUN"
  ],
  "derrick": [
    "PROPN"
  ],
  "handspring": [
    "VERB"
  ],
  "envoy": [
    "NOUN",
    "PROPN"
  ],
  "aquarius": [
    "NOUN"
  ],
  "stencil": [
    "VERB"
  ],
  "doorway": [
    "NOUN"
  ],
  "grandson": [
    "PROPN"
  ],
  "catalina": [
    "PROPN"
  ],
  "redding": [
    "VERB"
  ],
  "redirection": [
    "NOUN"
  ],
  "accompaniment": [
    "NOUN"
  ],
  "derivation": [
    "NOUN"
  ],
  "warden": [
    "VERB"
  ],
  "refinery": [
    "NOUN"
  ],
  "margarita": [
    "PROPN"
  ],
  "notary": [
    "PROPN"
  ],
  "abort": [
    "ADJ"
  ],
  "indent": [
    "NOUN"
  ],
  "sociological": [
    "ADJ"
  ],
  "forgetting": [
    "VERB"
  ],
  "macedonian": [
    "PROPN"
  ],
  "guesthouse": [
    "VERB"
  ],
  "barlow": [
    "VERB"
  ],
  "tyrone": [
    "NOUN"
  ],
  "edged": [
    "VERB"
  ],
  "encompass": [
    "VERB"
  ],
  "duvet": [
    "NOUN"
  ],
  "spade": [
    "VERB"
  ],
  "hermes": [
    "PROPN"
  ],
  "glare": [
    "NOUN"
  ],
  "metaphysical": [
    "ADJ"
  ],
  "decode": [
    "PROPN"
  ],
  "looney": [
    "PROPN"
  ],
  "insignificant": [
    "ADJ"
  ],
  "mentality": [
    "NOUN"
  ],
  "turbulent": [
    "ADJ"
  ],
  "dilution": [
    "NOUN"
  ],
  "sultan": [
    "PROPN"
  ],
  "masked": [
    "VERB"
  ],
  "casing": [
    "VERB"
  ],
  "plotted": [
    "VERB"
  ],
  "spacer": [
    "NOUN"
  ],
  "claiborne": [
    "PROPN"
  ],
  "generously": [
    "ADV"
  ],
  "assistive": [
    "ADJ"
  ],
  "chronograph": [
    "NOUN"
  ],
  "repression": [
    "NOUN"
  ],
  "reaper": [
    "NOUN"
  ],
  "embracing": [
    "VERB"
  ],
  "climatic": [
    "PROPN"
  ],
  "broaden": [
    "VERB"
  ],
  "salinity": [
    "NOUN"
  ],
  "begging": [
    "VERB"
  ],
  "handout": [
    "NOUN"
  ],
  "freddy": [
    "ADJ"
  ],
  "paisley": [
    "NOUN"
  ],
  "cutoff": [
    "NOUN"
  ],
  "truncated": [
    "VERB"
  ],
  "nitric": [
    "NOUN"
  ],
  "glover": [
    "ADJ"
  ],
  "unicorn": [
    "PROPN"
  ],
  "headlight": [
    "VERB"
  ],
  "orderly": [
    "ADV"
  ],
  "wafer": [
    "VERB"
  ],
  "stash": [
    "PROPN",
    "NOUN"
  ],
  "jamaican": [
    "PROPN"
  ],
  "hover": [
    "VERB",
    "ADJ"
  ],
  "endogenous": [
    "ADJ"
  ],
  "quarantine": [
    "NOUN"
  ],
  "detrimental": [
    "NOUN"
  ],
  "elias": [
    "NOUN"
  ],
  "subsistence": [
    "NOUN"
  ],
  "chilled": [
    "VERB"
  ],
  "citadel": [
    "PROPN"
  ],
  "topography": [
    "NOUN"
  ],
  "romero": [
    "PROPN"
  ],
  "wrinkle": [
    "NOUN"
  ],
  "adolescence": [
    "NOUN"
  ],
  "harmon": [
    "PROPN"
  ],
  "indulge": [
    "VERB"
  ],
  "hearth": [
    "PROPN"
  ],
  "embarrassed": [
    "ADJ"
  ],
  "aggressively": [
    "ADV"
  ],
  "melodic": [
    "ADJ"
  ],
  "coincide": [
    "VERB"
  ],
  "genoa": [
    "PROPN"
  ],
  "enlightened": [
    "VERB"
  ],
  "viscosity": [
    "NOUN"
  ],
  "estimator": [
    "NOUN"
  ],
  "concurrently": [
    "ADV"
  ],
  "stride": [
    "PROPN",
    "NOUN"
  ],
  "catastrophe": [
    "NOUN"
  ],
  "greatness": [
    "NOUN"
  ],
  "electrician": [
    "PROPN"
  ],
  "archie": [
    "NOUN"
  ],
  "bleach": [
    "NOUN"
  ],
  "ferret": [
    "VERB"
  ],
  "louisa": [
    "NOUN"
  ],
  "agony": [
    "NOUN"
  ],
  "wolverine": [
    "NOUN"
  ],
  "taller": [
    "ADJ"
  ],
  "doubling": [
    "VERB"
  ],
  "stupidity": [
    "NOUN"
  ],
  "enrich": [
    "VERB"
  ],
  "foreground": [
    "NOUN"
  ],
  "raffle": [
    "AUX"
  ],
  "shredder": [
    "NOUN"
  ],
  "incapable": [
    "ADJ"
  ],
  "hydrology": [
    "NOUN"
  ],
  "mascot": [
    "NOUN"
  ],
  "launcher": [
    "NOUN"
  ],
  "labyrinth": [
    "NOUN"
  ],
  "preach": [
    "VERB"
  ],
  "triangular": [
    "NOUN"
  ],
  "cones": [
    "NOUN"
  ],
  "lupus": [
    "X"
  ],
  "inversion": [
    "NOUN"
  ],
  "thankfully": [
    "ADV"
  ],
  "taxed": [
    "VERB"
  ],
  "presumption": [
    "NOUN"
  ],
  "excitation": [
    "NOUN"
  ],
  "salesman": [
    "NOUN"
  ],
  "constantine": [
    "NOUN"
  ],
  "confederation": [
    "NOUN"
  ],
  "gator": [
    "NOUN"
  ],
  "heller": [
    "NOUN"
  ],
  "replicate": [
    "VERB"
  ],
  "biometric": [
    "ADJ"
  ],
  "incubation": [
    "NOUN"
  ],
  "wrangler": [
    "NOUN"
  ],
  "defiance": [
    "NOUN"
  ],
  "asymmetric": [
    "NOUN"
  ],
  "bully": [
    "ADV"
  ],
  "cytochrome": [
    "VERB"
  ],
  "valiant": [
    "NOUN"
  ],
  "shure": [
    "NOUN"
  ],
  "breasted": [
    "VERB"
  ],
  "banging": [
    "VERB"
  ],
  "vertigo": [
    "PROPN",
    "ADJ"
  ],
  "unsatisfactory": [
    "ADJ"
  ],
  "fluent": [
    "ADJ"
  ],
  "rhyme": [
    "NOUN"
  ],
  "giveaway": [
    "NOUN"
  ],
  "renter": [
    "NOUN"
  ],
  "patel": [
    "PROPN"
  ],
  "mcintosh": [
    "PROPN"
  ],
  "suffice": [
    "VERB"
  ],
  "barrington": [
    "X"
  ],
  "stallion": [
    "NOUN"
  ],
  "booker": [
    "NOUN"
  ],
  "deserted": [
    "VERB"
  ],
  "diversification": [
    "NOUN"
  ],
  "antioxidant": [
    "VERB"
  ],
  "logically": [
    "ADV"
  ],
  "snort": [
    "NOUN"
  ],
  "streamlined": [
    "ADJ",
    "VERB"
  ],
  "airway": [
    "NOUN"
  ],
  "vicky": [
    "ADJ"
  ],
  "luminous": [
    "ADJ"
  ],
  "submitter": [
    "NOUN"
  ],
  "unparalleled": [
    "ADJ"
  ],
  "anyhow": [
    "ADV"
  ],
  "antwerp": [
    "PROPN"
  ],
  "primal": [
    "ADJ"
  ],
  "upheld": [
    "VERB"
  ],
  "manifestation": [
    "NOUN"
  ],
  "triad": [
    "PROPN",
    "NOUN"
  ],
  "fitch": [
    "VERB"
  ],
  "charting": [
    "VERB"
  ],
  "fixation": [
    "NOUN"
  ],
  "cameo": [
    "NOUN"
  ],
  "attire": [
    "NOUN"
  ],
  "blaine": [
    "VERB"
  ],
  "leach": [
    "VERB"
  ],
  "gravitational": [
    "ADJ"
  ],
  "typewriter": [
    "NOUN"
  ],
  "cyrillic": [
    "ADJ"
  ],
  "pomona": [
    "NOUN"
  ],
  "goddard": [
    "NOUN"
  ],
  "designee": [
    "NOUN"
  ],
  "sunni": [
    "PROPN"
  ],
  "plagiarism": [
    "NOUN"
  ],
  "milky": [
    "ADJ"
  ],
  "monoxide": [
    "NOUN"
  ],
  "upland": [
    "VERB"
  ],
  "outage": [
    "NOUN",
    "PROPN"
  ],
  "unconstitutional": [
    "ADJ"
  ],
  "chunky": [
    "NOUN"
  ],
  "raptor": [
    "NOUN"
  ],
  "macao": [
    "PROPN"
  ],
  "snaps": [
    "NOUN"
  ],
  "pilgrimage": [
    "NOUN"
  ],
  "quantify": [
    "VERB"
  ],
  "galleria": [
    "NOUN"
  ],
  "gluten": [
    "VERB"
  ],
  "eighteenth": [
    "VERB"
  ],
  "hurst": [
    "VERB"
  ],
  "inscription": [
    "NOUN"
  ],
  "ascent": [
    "NOUN"
  ],
  "obispo": [
    "NOUN"
  ],
  "turbines": [
    "NOUN"
  ],
  "tedious": [
    "ADJ"
  ],
  "universally": [
    "ADV"
  ],
  "golfer": [
    "VERB"
  ],
  "receivables": [
    "NOUN"
  ],
  "rowland": [
    "PROPN"
  ],
  "cirque": [
    "NOUN"
  ],
  "marxism": [
    "NOUN"
  ],
  "reggie": [
    "NOUN"
  ],
  "diffraction": [
    "NOUN"
  ],
  "subtract": [
    "VERB"
  ],
  "bosnian": [
    "PROPN"
  ],
  "depict": [
    "PROPN"
  ],
  "hydration": [
    "NOUN",
    "PROPN"
  ],
  "havent": [
    "AUX"
  ],
  "preferential": [
    "ADJ"
  ],
  "navel": [
    "NOUN"
  ],
  "arbitrator": [
    "NOUN"
  ],
  "prolific": [
    "NOUN"
  ],
  "methodological": [
    "ADJ"
  ],
  "indefinitely": [
    "ADV"
  ],
  "sucker": [
    "NOUN"
  ],
  "frightening": [
    "ADJ"
  ],
  "wildly": [
    "ADV"
  ],
  "sable": [
    "ADJ"
  ],
  "epithelial": [
    "ADJ"
  ],
  "drastically": [
    "ADV"
  ],
  "neatly": [
    "ADV"
  ],
  "singleton": [
    "NOUN"
  ],
  "spaniel": [
    "PROPN"
  ],
  "worthless": [
    "ADJ"
  ],
  "spool": [
    "NOUN"
  ],
  "matchmaking": [
    "VERB"
  ],
  "jeopardy": [
    "NOUN"
  ],
  "voiced": [
    "VERB"
  ],
  "aeronautics": [
    "NOUN"
  ],
  "radiography": [
    "NOUN"
  ],
  "norsk": [
    "PROPN"
  ],
  "annoy": [
    "VERB"
  ],
  "aspiring": [
    "VERB"
  ],
  "cornelius": [
    "NOUN"
  ],
  "scientifically": [
    "ADV"
  ],
  "grandpa": [
    "NOUN"
  ],
  "cornish": [
    "PROPN"
  ],
  "toxin": [
    "NOUN"
  ],
  "axiom": [
    "PROPN"
  ],
  "stamina": [
    "NOUN"
  ],
  "hardness": [
    "NOUN"
  ],
  "abound": [
    "PROPN"
  ],
  "curing": [
    "VERB"
  ],
  "aztec": [
    "VERB"
  ],
  "mater": [
    "NOUN"
  ],
  "oneida": [
    "PROPN"
  ],
  "crowned": [
    "VERB"
  ],
  "sandstone": [
    "NOUN"
  ],
  "grounding": [
    "VERB"
  ],
  "fiduciary": [
    "ADJ"
  ],
  "rooster": [
    "NOUN"
  ],
  "saccharomyces": [
    "NOUN"
  ],
  "proctor": [
    "NOUN"
  ],
  "prehistoric": [
    "ADJ"
  ],
  "dictate": [
    "VERB"
  ],
  "joker": [
    "PROPN"
  ],
  "trimmer": [
    "NOUN"
  ],
  "bookkeeping": [
    "VERB"
  ],
  "kickoff": [
    "PROPN",
    "NOUN"
  ],
  "abdomen": [
    "PROPN"
  ],
  "tudor": [
    "PROPN"
  ],
  "inefficient": [
    "ADJ"
  ],
  "parasite": [
    "VERB"
  ],
  "twill": [
    "NOUN"
  ],
  "therapeutics": [
    "NOUN"
  ],
  "disruptive": [
    "ADJ"
  ],
  "kicker": [
    "NOUN"
  ],
  "protease": [
    "NOUN"
  ],
  "preclude": [
    "VERB"
  ],
  "fasting": [
    "VERB"
  ],
  "loudly": [
    "ADV"
  ],
  "horseshoe": [
    "NOUN"
  ],
  "constellation": [
    "PROPN"
  ],
  "recital": [
    "NOUN"
  ],
  "utrecht": [
    "PROPN"
  ],
  "bedtime": [
    "NOUN"
  ],
  "reminiscent": [
    "ADJ"
  ],
  "rapport": [
    "NOUN"
  ],
  "catfish": [
    "NOUN"
  ],
  "doubletree": [
    "NOUN"
  ],
  "brink": [
    "NOUN"
  ],
  "truss": [
    "ADV"
  ],
  "depressing": [
    "VERB"
  ],
  "strangely": [
    "ADV"
  ],
  "skipper": [
    "NOUN"
  ],
  "anonymity": [
    "NOUN"
  ],
  "gotham": [
    "PROPN"
  ],
  "maxima": [
    "PROPN"
  ],
  "unification": [
    "NOUN"
  ],
  "responsiveness": [
    "NOUN",
    "PROPN"
  ],
  "testimonial": [
    "ADJ"
  ],
  "khaki": [
    "PROPN"
  ],
  "gazetteer": [
    "PROPN"
  ],
  "jacobson": [
    "PROPN"
  ],
  "homology": [
    "NOUN"
  ],
  "slough": [
    "ADJ"
  ],
  "prodigy": [
    "NOUN"
  ],
  "mould": [
    "AUX"
  ],
  "rhinestone": [
    "NOUN"
  ],
  "quadratic": [
    "ADJ"
  ],
  "dissatisfied": [
    "ADJ"
  ],
  "philharmonic": [
    "PROPN"
  ],
  "dynamical": [
    "ADJ"
  ],
  "cantonese": [
    "NOUN"
  ],
  "shakers": [
    "NOUN"
  ],
  "bourbon": [
    "NOUN"
  ],
  "staggering": [
    "VERB"
  ],
  "bismarck": [
    "VERB"
  ],
  "rubbed": [
    "VERB"
  ],
  "bookseller": [
    "PROPN"
  ],
  "lexical": [
    "ADJ"
  ],
  "webber": [
    "NOUN"
  ],
  "strategically": [
    "ADV"
  ],
  "emergent": [
    "ADJ"
  ],
  "erika": [
    "PROPN"
  ],
  "authenticate": [
    "VERB"
  ],
  "beaufort": [
    "NOUN"
  ],
  "nautilus": [
    "PROPN"
  ],
  "radically": [
    "ADV"
  ],
  "platter": [
    "NOUN"
  ],
  "chamberlain": [
    "VERB"
  ],
  "steamboat": [
    "NOUN"
  ],
  "brewster": [
    "VERB"
  ],
  "shaman": [
    "NOUN"
  ],
  "croft": [
    "NOUN"
  ],
  "uplifting": [
    "VERB"
  ],
  "extracellular": [
    "ADJ"
  ],
  "penal": [
    "ADJ"
  ],
  "pageant": [
    "NOUN"
  ],
  "plywood": [
    "NOUN"
  ],
  "morbidity": [
    "NOUN"
  ],
  "custodial": [
    "ADJ"
  ],
  "integrator": [
    "NOUN"
  ],
  "sectoral": [
    "ADJ"
  ],
  "trombone": [
    "VERB"
  ],
  "morally": [
    "ADV"
  ],
  "hosiery": [
    "NOUN"
  ],
  "ambulatory": [
    "ADJ"
  ],
  "reptile": [
    "NOUN"
  ],
  "camouflage": [
    "VERB"
  ],
  "overdue": [
    "ADJ",
    "PROPN"
  ],
  "cowan": [
    "PROPN"
  ],
  "firebird": [
    "PROPN"
  ],
  "mohawk": [
    "PROPN"
  ],
  "schwarz": [
    "NOUN"
  ],
  "persuaded": [
    "VERB"
  ],
  "teasing": [
    "VERB"
  ],
  "unbound": [
    "NOUN"
  ],
  "antiqua": [
    "NOUN"
  ],
  "delinquent": [
    "ADJ"
  ],
  "nestle": [
    "VERB"
  ],
  "imperfect": [
    "VERB"
  ],
  "disguise": [
    "VERB"
  ],
  "eleventh": [
    "VERB"
  ],
  "lapse": [
    "NOUN"
  ],
  "seamlessly": [
    "ADV"
  ],
  "wally": [
    "ADV"
  ],
  "phenomenal": [
    "ADJ"
  ],
  "songbook": [
    "ADJ"
  ],
  "hepatic": [
    "PROPN"
  ],
  "marjorie": [
    "PROPN"
  ],
  "shrub": [
    "PROPN"
  ],
  "kindred": [
    "VERB"
  ],
  "reconsider": [
    "NOUN"
  ],
  "aquifer": [
    "VERB"
  ],
  "condemn": [
    "PROPN"
  ],
  "renegade": [
    "VERB"
  ],
  "augmented": [
    "VERB"
  ],
  "amends": [
    "VERB"
  ],
  "finer": [
    "ADJ"
  ],
  "invocation": [
    "NOUN",
    "PROPN"
  ],
  "shelly": [
    "ADV"
  ],
  "brooch": [
    "PROPN"
  ],
  "nineteen": [
    "NUM"
  ],
  "hamburger": [
    "NOUN"
  ],
  "reactivity": [
    "NOUN"
  ],
  "edmond": [
    "NOUN"
  ],
  "swollen": [
    "VERB"
  ],
  "scatter": [
    "NOUN"
  ],
  "steward": [
    "ADV"
  ],
  "smack": [
    "VERB"
  ],
  "incidentally": [
    "ADV"
  ],
  "codeine": [
    "NOUN"
  ],
  "holiness": [
    "NOUN"
  ],
  "divinity": [
    "NOUN"
  ],
  "sherlock": [
    "NOUN"
  ],
  "punitive": [
    "ADJ"
  ],
  "comprehend": [
    "VERB"
  ],
  "cloak": [
    "NOUN"
  ],
  "pamphlet": [
    "NOUN"
  ],
  "clipper": [
    "NOUN"
  ],
  "priceless": [
    "ADJ"
  ],
  "assassin": [
    "PROPN"
  ],
  "cynical": [
    "ADJ"
  ],
  "manic": [
    "ADJ"
  ],
  "choke": [
    "PROPN"
  ],
  "underwent": [
    "NOUN"
  ],
  "tuxedo": [
    "NOUN"
  ],
  "blueberry": [
    "NOUN"
  ],
  "imperialism": [
    "NOUN"
  ],
  "socioeconomic": [
    "PROPN"
  ],
  "halter": [
    "NOUN"
  ],
  "hamster": [
    "PROPN"
  ],
  "finalize": [
    "VERB",
    "PROPN"
  ],
  "sudanese": [
    "ADJ"
  ],
  "shrinking": [
    "VERB"
  ],
  "novelist": [
    "NOUN"
  ],
  "faceplate": [
    "NOUN"
  ],
  "packer": [
    "NOUN"
  ],
  "arroyo": [
    "NOUN"
  ],
  "tipped": [
    "VERB"
  ],
  "amidst": [
    "ADP"
  ],
  "etching": [
    "VERB"
  ],
  "oblivion": [
    "NOUN"
  ],
  "gravy": [
    "PROPN"
  ],
  "inherit": [
    "VERB"
  ],
  "sprinkle": [
    "VERB"
  ],
  "stitching": [
    "VERB"
  ],
  "advisable": [
    "ADJ"
  ],
  "gladstone": [
    "NOUN"
  ],
  "payer": [
    "NOUN"
  ],
  "beforehand": [
    "ADV"
  ],
  "laborer": [
    "NOUN"
  ],
  "watcher": [
    "NOUN"
  ],
  "abbas": [
    "PROPN"
  ],
  "cougar": [
    "VERB"
  ],
  "dobson": [
    "PROPN"
  ],
  "soaked": [
    "VERB"
  ],
  "irradiation": [
    "NOUN"
  ],
  "raster": [
    "NOUN"
  ],
  "abridged": [
    "VERB"
  ],
  "credential": [
    "NOUN",
    "ADJ"
  ],
  "quirky": [
    "ADJ"
  ],
  "oscillator": [
    "NOUN"
  ],
  "palate": [
    "NOUN"
  ],
  "encrypt": [
    "VERB",
    "PROPN"
  ],
  "thierry": [
    "PROPN"
  ],
  "incontinence": [
    "NOUN"
  ],
  "masculine": [
    "NOUN"
  ],
  "lubricant": [
    "NOUN"
  ],
  "constable": [
    "ADJ"
  ],
  "unconditional": [
    "ADJ"
  ],
  "unbeatable": [
    "ADJ"
  ],
  "progressively": [
    "ADV"
  ],
  "upstate": [
    "ADJ"
  ],
  "topping": [
    "VERB"
  ],
  "chilling": [
    "VERB"
  ],
  "translucent": [
    "NOUN"
  ],
  "glaze": [
    "VERB"
  ],
  "newcomer": [
    "NOUN"
  ],
  "branching": [
    "VERB"
  ],
  "unmarried": [
    "ADJ"
  ],
  "extrait": [
    "ADJ"
  ],
  "pelvic": [
    "ADJ"
  ],
  "monochrome": [
    "NOUN"
  ],
  "gynecology": [
    "NOUN"
  ],
  "unexpectedly": [
    "ADV"
  ],
  "probabilistic": [
    "ADJ"
  ],
  "scorpion": [
    "NOUN"
  ],
  "mirrored": [
    "VERB"
  ],
  "anatomical": [
    "ADJ"
  ],
  "simplex": [
    "NOUN"
  ],
  "misdemeanor": [
    "NOUN"
  ],
  "sabrina": [
    "PROPN"
  ],
  "tobias": [
    "VERB"
  ],
  "salle": [
    "PROPN"
  ],
  "infra": [
    "PROPN",
    "NOUN"
  ],
  "commemorative": [
    "ADJ"
  ],
  "condor": [
    "NOUN"
  ],
  "gated": [
    "VERB"
  ],
  "implicitly": [
    "ADV"
  ],
  "comedian": [
    "PROPN"
  ],
  "rascal": [
    "PROPN"
  ],
  "amish": [
    "NOUN"
  ],
  "roberta": [
    "PROPN"
  ],
  "dizzy": [
    "ADJ"
  ],
  "whitening": [
    "VERB"
  ],
  "reliant": [
    "ADJ"
  ],
  "subcontractor": [
    "NOUN"
  ],
  "ordnance": [
    "NOUN"
  ],
  "psych": [
    "PROPN"
  ],
  "hydrochloride": [
    "NOUN"
  ],
  "verge": [
    "VERB"
  ],
  "ransom": [
    "VERB"
  ],
  "magnification": [
    "NOUN"
  ],
  "nomad": [
    "PROPN"
  ],
  "twelfth": [
    "ADV"
  ],
  "dagger": [
    "PROPN"
  ],
  "thorn": [
    "NOUN"
  ],
  "preamble": [
    "VERB"
  ],
  "solicit": [
    "PROPN"
  ],
  "provoking": [
    "VERB"
  ],
  "spoil": [
    "VERB"
  ],
  "psychiatrist": [
    "NOUN"
  ],
  "lauder": [
    "PROPN"
  ],
  "soldering": [
    "VERB"
  ],
  "phono": [
    "VERB"
  ],
  "daryl": [
    "VERB"
  ],
  "blazing": [
    "VERB"
  ],
  "palermo": [
    "NOUN"
  ],
  "grantee": [
    "NOUN"
  ],
  "enhancer": [
    "NOUN"
  ],
  "snapped": [
    "VERB"
  ],
  "alligator": [
    "NOUN"
  ],
  "rochelle": [
    "PROPN"
  ],
  "nomenclature": [
    "NOUN"
  ],
  "invade": [
    "VERB"
  ],
  "visualize": [
    "VERB",
    "PROPN"
  ],
  "rendezvous": [
    "ADJ"
  ],
  "trapping": [
    "VERB"
  ],
  "turntable": [
    "ADJ"
  ],
  "deuteronomy": [
    "NOUN"
  ],
  "diminish": [
    "VERB"
  ],
  "britannia": [
    "PROPN"
  ],
  "pivotal": [
    "ADJ"
  ],
  "mediocre": [
    "NOUN"
  ],
  "ayrshire": [
    "NOUN"
  ],
  "plating": [
    "VERB"
  ],
  "invent": [
    "VERB"
  ],
  "eagerly": [
    "ADV"
  ],
  "damascus": [
    "PROPN"
  ],
  "reformation": [
    "NOUN"
  ],
  "hypocrisy": [
    "NOUN"
  ],
  "fluoride": [
    "NOUN"
  ],
  "suomi": [
    "PROPN"
  ],
  "trooper": [
    "NOUN"
  ],
  "compendium": [
    "NOUN"
  ],
  "transcriptional": [
    "ADJ"
  ],
  "monotone": [
    "NOUN"
  ],
  "palsy": [
    "PROPN"
  ],
  "locomotive": [
    "ADJ"
  ],
  "debating": [
    "VERB"
  ],
  "conservancy": [
    "NOUN"
  ],
  "prosperous": [
    "ADJ"
  ],
  "famine": [
    "NOUN"
  ],
  "dielectric": [
    "PROPN"
  ],
  "elliptical": [
    "ADJ"
  ],
  "electrophoresis": [
    "NOUN"
  ],
  "sprinkler": [
    "PROPN"
  ],
  "imbalance": [
    "NOUN"
  ],
  "persuasive": [
    "ADJ"
  ],
  "bearer": [
    "PROPN"
  ],
  "acquainted": [
    "VERB"
  ],
  "dizziness": [
    "NOUN"
  ],
  "outboard": [
    "PROPN"
  ],
  "brilliance": [
    "NOUN"
  ],
  "nicky": [
    "ADJ"
  ],
  "originate": [
    "VERB"
  ],
  "respectable": [
    "ADJ"
  ],
  "disappearance": [
    "NOUN"
  ],
  "morals": [
    "NOUN"
  ],
  "unmatched": [
    "ADJ"
  ],
  "spoiled": [
    "VERB"
  ],
  "pinpoint": [
    "VERB"
  ],
  "pickle": [
    "NOUN"
  ],
  "andhra": [
    "NOUN"
  ],
  "quaker": [
    "NOUN"
  ],
  "tangent": [
    "NOUN"
  ],
  "tempest": [
    "NOUN"
  ],
  "xenon": [
    "PROPN"
  ],
  "dominique": [
    "NOUN"
  ],
  "hybridization": [
    "VERB"
  ],
  "waving": [
    "VERB"
  ],
  "uneven": [
    "ADJ"
  ],
  "plurality": [
    "NOUN"
  ],
  "adventurous": [
    "ADJ"
  ],
  "palliative": [
    "NOUN"
  ],
  "luigi": [
    "PROPN"
  ],
  "bayou": [
    "NOUN"
  ],
  "confluence": [
    "PROPN",
    "NOUN"
  ],
  "staffed": [
    "VERB"
  ],
  "yelling": [
    "VERB"
  ],
  "trough": [
    "NOUN"
  ],
  "quadrant": [
    "PROPN"
  ],
  "discrepancy": [
    "NOUN"
  ],
  "untreated": [
    "ADJ"
  ],
  "divisional": [
    "ADJ"
  ],
  "chihuahua": [
    "PROPN"
  ],
  "tonic": [
    "NOUN"
  ],
  "resell": [
    "VERB"
  ],
  "magnus": [
    "PROPN"
  ],
  "burnout": [
    "NOUN"
  ],
  "harrow": [
    "PROPN"
  ],
  "reckless": [
    "ADJ"
  ],
  "peasant": [
    "NOUN"
  ],
  "coliseum": [
    "NOUN"
  ],
  "ephedra": [
    "NOUN"
  ],
  "spawning": [
    "VERB"
  ],
  "endothelial": [
    "PROPN"
  ],
  "citrate": [
    "NOUN"
  ],
  "eduardo": [
    "NOUN"
  ],
  "crushing": [
    "VERB"
  ],
  "saucer": [
    "NOUN"
  ],
  "chinook": [
    "NOUN"
  ],
  "passover": [
    "PROPN"
  ],
  "bacillus": [
    "NOUN"
  ],
  "byzantine": [
    "VERB"
  ],
  "tomas": [
    "NOUN"
  ],
  "spooky": [
    "ADJ"
  ],
  "curvature": [
    "NOUN"
  ],
  "sideways": [
    "ADV"
  ],
  "devious": [
    "ADJ"
  ],
  "venezuelan": [
    "ADV"
  ],
  "dreamer": [
    "PROPN"
  ],
  "estuary": [
    "VERB"
  ],
  "burglary": [
    "NOUN"
  ],
  "subpoena": [
    "NOUN"
  ],
  "thrilling": [
    "VERB"
  ],
  "spectacle": [
    "NOUN"
  ],
  "interpretive": [
    "ADJ"
  ],
  "ditto": [
    "NOUN"
  ],
  "bareback": [
    "NOUN"
  ],
  "extender": [
    "NOUN"
  ],
  "waiter": [
    "NOUN"
  ],
  "glucosamine": [
    "NOUN"
  ],
  "oddly": [
    "ADV"
  ],
  "typhoon": [
    "NOUN"
  ],
  "referrer": [
    "NOUN"
  ],
  "nutshell": [
    "NOUN"
  ],
  "arrogant": [
    "ADJ"
  ],
  "superhero": [
    "NOUN"
  ],
  "tooling": [
    "NOUN",
    "PROPN"
  ],
  "tomography": [
    "NOUN"
  ],
  "thrift": [
    "NOUN"
  ],
  "vocalist": [
    "NOUN"
  ],
  "admired": [
    "VERB"
  ],
  "cystic": [
    "ADJ"
  ],
  "youthful": [
    "ADJ"
  ],
  "fairway": [
    "INTJ"
  ],
  "postdoctoral": [
    "NOUN"
  ],
  "spinner": [
    "NOUN"
  ],
  "homeopathic": [
    "ADJ"
  ],
  "ordinarily": [
    "ADV"
  ],
  "sufficiency": [
    "NOUN"
  ],
  "tempered": [
    "VERB"
  ],
  "slipping": [
    "VERB"
  ],
  "solitude": [
    "NOUN"
  ],
  "cylindrical": [
    "ADJ"
  ],
  "destroyer": [
    "NOUN"
  ],
  "undesirable": [
    "ADJ"
  ],
  "platelet": [
    "ADJ"
  ],
  "mongolian": [
    "PROPN"
  ],
  "weakly": [
    "ADJ"
  ],
  "parsley": [
    "NOUN"
  ],
  "undue": [
    "ADJ"
  ],
  "setback": [
    "NOUN"
  ],
  "magyar": [
    "NOUN"
  ],
  "hostility": [
    "NOUN"
  ],
  "subcategory": [
    "ADJ"
  ],
  "reflux": [
    "NOUN"
  ],
  "jurisprudence": [
    "NOUN"
  ],
  "culver": [
    "VERB"
  ],
  "invariably": [
    "ADV"
  ],
  "elves": [
    "NOUN"
  ],
  "graeme": [
    "PROPN"
  ],
  "chant": [
    "NOUN"
  ],
  "turnkey": [
    "NOUN"
  ],
  "tighten": [
    "VERB"
  ],
  "revolver": [
    "PROPN"
  ],
  "screwdriver": [
    "PROPN"
  ],
  "hutch": [
    "VERB"
  ],
  "intermediary": [
    "NOUN"
  ],
  "matted": [
    "VERB"
  ],
  "apricot": [
    "PROPN"
  ],
  "cuckold": [
    "NOUN"
  ],
  "unreliable": [
    "ADJ"
  ],
  "rosewood": [
    "NOUN"
  ],
  "parry": [
    "VERB"
  ],
  "existent": [
    "ADJ"
  ],
  "phosphatase": [
    "NOUN"
  ],
  "dictator": [
    "NOUN"
  ],
  "jehovah": [
    "PROPN"
  ],
  "adirondack": [
    "ADV"
  ],
  "perpendicular": [
    "ADJ"
  ],
  "mantra": [
    "ADJ"
  ],
  "hedgehog": [
    "ADV"
  ],
  "mamma": [
    "PROPN"
  ],
  "folly": [
    "NOUN"
  ],
  "thermostat": [
    "VERB"
  ],
  "wheeling": [
    "VERB"
  ],
  "infarction": [
    "NOUN"
  ],
  "hawthorn": [
    "ADJ"
  ],
  "mural": [
    "PROPN"
  ],
  "bankrupt": [
    "ADJ"
  ],
  "wager": [
    "NOUN"
  ],
  "tundra": [
    "VERB"
  ],
  "purge": [
    "VERB"
  ],
  "skater": [
    "ADV"
  ],
  "interpolation": [
    "NOUN"
  ],
  "adjournment": [
    "NOUN"
  ],
  "disrupt": [
    "VERB"
  ],
  "ambrose": [
    "VERB"
  ],
  "rampage": [
    "NOUN"
  ],
  "jurassic": [
    "PROPN"
  ],
  "cavern": [
    "VERB"
  ],
  "sumner": [
    "NOUN"
  ],
  "disgusting": [
    "VERB"
  ],
  "guerrilla": [
    "NOUN"
  ],
  "persona": [
    "PROPN",
    "NOUN"
  ],
  "poser": [
    "NOUN"
  ],
  "powerhouse": [
    "PROPN"
  ],
  "deodorant": [
    "PROPN"
  ],
  "compulsive": [
    "ADJ"
  ],
  "perky": [
    "VERB"
  ],
  "scarcely": [
    "ADV"
  ],
  "extensible": [
    "ADJ"
  ],
  "fused": [
    "VERB"
  ],
  "catheter": [
    "VERB"
  ],
  "roaring": [
    "VERB"
  ],
  "practicum": [
    "NOUN"
  ],
  "witchcraft": [
    "NOUN"
  ],
  "stopper": [
    "NOUN"
  ],
  "photocopy": [
    "NOUN"
  ],
  "cullen": [
    "VERB"
  ],
  "saharan": [
    "PROPN"
  ],
  "crested": [
    "VERB"
  ],
  "stump": [
    "NOUN"
  ],
  "scalp": [
    "PROPN"
  ],
  "disarmament": [
    "VERB"
  ],
  "actin": [
    "NOUN"
  ],
  "erwin": [
    "VERB"
  ],
  "interviewer": [
    "PROPN",
    "NOUN"
  ],
  "gastroenterology": [
    "NOUN"
  ],
  "diplomat": [
    "NOUN"
  ],
  "sylvester": [
    "NOUN"
  ],
  "melon": [
    "NOUN"
  ],
  "tablespoon": [
    "NOUN"
  ],
  "manganese": [
    "PROPN"
  ],
  "siren": [
    "ADJ"
  ],
  "oceanography": [
    "NOUN"
  ],
  "vastly": [
    "ADV"
  ],
  "clasp": [
    "VERB"
  ],
  "radiological": [
    "ADJ"
  ],
  "commando": [
    "NOUN"
  ],
  "summons": [
    "NOUN"
  ],
  "lucrative": [
    "ADJ"
  ],
  "porous": [
    "ADJ"
  ],
  "bathtub": [
    "PROPN"
  ],
  "motorway": [
    "NOUN"
  ],
  "hinduism": [
    "NOUN"
  ],
  "freaky": [
    "PROPN"
  ],
  "thirst": [
    "NOUN"
  ],
  "sportsman": [
    "NOUN"
  ],
  "scratching": [
    "VERB"
  ],
  "iodine": [
    "NOUN"
  ],
  "phoebe": [
    "NOUN"
  ],
  "legged": [
    "VERB"
  ],
  "unilateral": [
    "NOUN"
  ],
  "krone": [
    "NOUN"
  ],
  "urgently": [
    "ADV"
  ],
  "aegis": [
    "PROPN"
  ],
  "colloquium": [
    "NOUN"
  ],
  "liberalism": [
    "PROPN"
  ],
  "supplementation": [
    "NOUN"
  ],
  "derry": [
    "VERB"
  ],
  "mohammad": [
    "NOUN"
  ],
  "frankenstein": [
    "ADJ"
  ],
  "verbose": [
    "ADJ"
  ],
  "eccentric": [
    "ADJ"
  ],
  "amour": [
    "VERB"
  ],
  "deterministic": [
    "ADJ"
  ],
  "predictor": [
    "NOUN"
  ],
  "salmonella": [
    "NOUN"
  ],
  "viewable": [
    "ADJ"
  ],
  "illustrative": [
    "ADJ"
  ],
  "sailed": [
    "VERB"
  ],
  "craving": [
    "VERB"
  ],
  "watermark": [
    "NOUN"
  ],
  "possessing": [
    "VERB"
  ],
  "suicidal": [
    "PROPN"
  ],
  "masonic": [
    "VERB"
  ],
  "forage": [
    "NOUN"
  ],
  "dyslexia": [
    "PROPN"
  ],
  "hubble": [
    "ADJ"
  ],
  "hellenic": [
    "ADJ"
  ],
  "dearborn": [
    "PROPN"
  ],
  "ethel": [
    "NOUN"
  ],
  "yiddish": [
    "ADJ"
  ],
  "multiplier": [
    "ADJ"
  ],
  "payoff": [
    "NOUN"
  ],
  "distinctly": [
    "ADV"
  ],
  "sonar": [
    "PROPN"
  ],
  "pebble": [
    "ADJ"
  ],
  "flasher": [
    "NOUN"
  ],
  "evangelism": [
    "NOUN"
  ],
  "denomination": [
    "NOUN"
  ],
  "patriotism": [
    "NOUN"
  ],
  "lesion": [
    "NOUN"
  ],
  "tickle": [
    "NOUN"
  ],
  "bandit": [
    "NOUN"
  ],
  "progesterone": [
    "NOUN"
  ],
  "acquaintance": [
    "NOUN"
  ],
  "ethyl": [
    "PROPN"
  ],
  "caramel": [
    "NOUN"
  ],
  "maint": [
    "NOUN"
  ],
  "pancreas": [
    "NOUN"
  ],
  "blouse": [
    "NOUN"
  ],
  "octopus": [
    "PROPN"
  ],
  "receptionist": [
    "NOUN"
  ],
  "feline": [
    "PROPN"
  ],
  "ulcer": [
    "NOUN"
  ],
  "cambodian": [
    "PROPN"
  ],
  "interagency": [
    "NOUN"
  ],
  "synchronize": [
    "VERB"
  ],
  "menstrual": [
    "ADJ"
  ],
  "intolerance": [
    "NOUN"
  ],
  "ammonium": [
    "NOUN"
  ],
  "zephyr": [
    "PROPN"
  ],
  "tamara": [
    "PROPN"
  ],
  "tearing": [
    "VERB"
  ],
  "ethic": [
    "ADJ"
  ],
  "taxon": [
    "VERB"
  ],
  "indefinite": [
    "NOUN"
  ],
  "atrium": [
    "NOUN"
  ],
  "thine": [
    "NOUN"
  ],
  "superiority": [
    "NOUN"
  ],
  "ambience": [
    "NOUN"
  ],
  "genet": [
    "NOUN"
  ],
  "nemesis": [
    "NOUN"
  ],
  "confessional": [
    "ADJ"
  ],
  "cardigan": [
    "VERB"
  ],
  "neuronal": [
    "ADJ"
  ],
  "taunton": [
    "PROPN"
  ],
  "evaporation": [
    "NOUN"
  ],
  "devise": [
    "VERB"
  ],
  "sorrento": [
    "PROPN"
  ],
  "checkers": [
    "NOUN"
  ],
  "toying": [
    "VERB"
  ],
  "parma": [
    "NOUN"
  ],
  "spokeswoman": [
    "NOUN"
  ],
  "baccalaureate": [
    "VERB"
  ],
  "wreath": [
    "NOUN"
  ],
  "plight": [
    "NOUN"
  ],
  "logistic": [
    "ADJ"
  ],
  "personalization": [
    "NOUN",
    "PROPN"
  ],
  "enema": [
    "NOUN"
  ],
  "easement": [
    "NOUN"
  ],
  "goalie": [
    "VERB"
  ],
  "darkroom": [
    "NOUN"
  ],
  "irrational": [
    "ADJ"
  ],
  "arches": [
    "NOUN"
  ],
  "naturalist": [
    "NOUN"
  ],
  "penetrating": [
    "VERB"
  ],
  "cookery": [
    "NOUN"
  ],
  "uniqueness": [
    "NOUN"
  ],
  "beatrice": [
    "NOUN"
  ],
  "policeman": [
    "NOUN"
  ],
  "cartilage": [
    "NOUN"
  ],
  "broadcaster": [
    "NOUN"
  ],
  "turnpike": [
    "VERB"
  ],
  "migratory": [
    "NOUN"
  ],
  "sheltered": [
    "VERB"
  ],
  "degraded": [
    "ADJ",
    "VERB"
  ],
  "elasticity": [
    "NOUN"
  ],
  "gutter": [
    "NOUN"
  ],
  "sloppy": [
    "ADJ"
  ],
  "flannel": [
    "NOUN"
  ],
  "ridden": [
    "VERB"
  ],
  "grapefruit": [
    "NOUN"
  ],
  "contradictory": [
    "VERB"
  ],
  "misunderstood": [
    "NOUN"
  ],
  "steamer": [
    "NOUN"
  ],
  "barometer": [
    "NOUN"
  ],
  "barge": [
    "VERB"
  ],
  "psoriasis": [
    "NOUN"
  ],
  "spartan": [
    "PROPN"
  ],
  "crystalline": [
    "VERB"
  ],
  "bengali": [
    "PROPN"
  ],
  "lessee": [
    "VERB"
  ],
  "respite": [
    "NOUN"
  ],
  "goodyear": [
    "NOUN"
  ],
  "shetland": [
    "VERB"
  ],
  "provocative": [
    "ADJ"
  ],
  "selectable": [
    "ADJ"
  ],
  "tasted": [
    "VERB"
  ],
  "capitalization": [
    "NOUN"
  ],
  "responder": [
    "PROPN",
    "NOUN"
  ],
  "rufus": [
    "PROPN"
  ],
  "thoracic": [
    "VERB"
  ],
  "hopeless": [
    "ADJ"
  ],
  "infiltration": [
    "NOUN"
  ],
  "daphne": [
    "VERB"
  ],
  "serine": [
    "NOUN"
  ],
  "meteor": [
    "PROPN"
  ],
  "granville": [
    "PROPN"
  ],
  "orthogonal": [
    "ADJ"
  ],
  "veneer": [
    "VERB"
  ],
  "anonymously": [
    "ADV"
  ],
  "manageable": [
    "ADJ"
  ],
  "slant": [
    "NOUN"
  ],
  "selenium": [
    "NOUN"
  ],
  "pollard": [
    "PROPN"
  ],
  "broom": [
    "PROPN"
  ],
  "plainly": [
    "ADV"
  ],
  "snare": [
    "VERB"
  ],
  "shank": [
    "VERB"
  ],
  "parachute": [
    "VERB"
  ],
  "uphold": [
    "VERB"
  ],
  "glider": [
    "NOUN"
  ],
  "insignia": [
    "PROPN"
  ],
  "nurture": [
    "NOUN",
    "PROPN"
  ],
  "leash": [
    "VERB"
  ],
  "adrenal": [
    "ADJ"
  ],
  "humility": [
    "NOUN"
  ],
  "impeachment": [
    "NOUN"
  ],
  "acton": [
    "PROPN"
  ],
  "booting": [
    "VERB"
  ],
  "carbide": [
    "VERB"
  ],
  "pullman": [
    "NOUN"
  ],
  "dissolve": [
    "VERB"
  ],
  "adrienne": [
    "PROPN"
  ],
  "deduct": [
    "NOUN"
  ],
  "crawling": [
    "VERB"
  ],
  "postoperative": [
    "ADJ"
  ],
  "modifier": [
    "NOUN"
  ],
  "cytology": [
    "NOUN"
  ],
  "biennial": [
    "ADJ"
  ],
  "readership": [
    "NOUN"
  ],
  "cohesion": [
    "NOUN"
  ],
  "reconnaissance": [
    "NOUN"
  ],
  "transducer": [
    "NOUN"
  ],
  "corporal": [
    "NOUN"
  ],
  "ligne": [
    "PROPN"
  ],
  "beagle": [
    "NOUN"
  ],
  "cadmium": [
    "NOUN"
  ],
  "bodoni": [
    "ADJ"
  ],
  "locust": [
    "NOUN"
  ],
  "detachable": [
    "ADJ"
  ],
  "condenser": [
    "PROPN"
  ],
  "articulation": [
    "NOUN"
  ],
  "sleeveless": [
    "ADV"
  ],
  "villain": [
    "VERB"
  ],
  "leviticus": [
    "PROPN"
  ],
  "impending": [
    "VERB"
  ],
  "rejoice": [
    "VERB"
  ],
  "pickering": [
    "VERB"
  ],
  "plumper": [
    "X"
  ],
  "uterine": [
    "VERB"
  ],
  "apartheid": [
    "NOUN"
  ],
  "morphological": [
    "ADJ"
  ],
  "condemnation": [
    "NOUN"
  ],
  "polio": [
    "NOUN"
  ],
  "formidable": [
    "ADJ"
  ],
  "mecca": [
    "VERB"
  ],
  "regatta": [
    "NOUN"
  ],
  "macbeth": [
    "PROPN"
  ],
  "polarity": [
    "NOUN"
  ],
  "abandonment": [
    "NOUN"
  ],
  "attenuation": [
    "NOUN"
  ],
  "bertrand": [
    "ADV"
  ],
  "broth": [
    "NOUN"
  ],
  "telford": [
    "NOUN"
  ],
  "seduction": [
    "NOUN"
  ],
  "grapevine": [
    "NOUN"
  ],
  "daunting": [
    "VERB",
    "ADJ"
  ],
  "giuseppe": [
    "NOUN"
  ],
  "improperly": [
    "ADV"
  ],
  "futuristic": [
    "ADJ"
  ],
  "nebula": [
    "NOUN"
  ],
  "obsessive": [
    "NOUN"
  ],
  "blooming": [
    "VERB"
  ],
  "seminole": [
    "PROPN"
  ],
  "taper": [
    "NOUN"
  ],
  "rotational": [
    "ADJ"
  ],
  "synagogue": [
    "VERB"
  ],
  "finalist": [
    "NOUN"
  ],
  "pornographic": [
    "VERB"
  ],
  "armageddon": [
    "PROPN"
  ],
  "selectively": [
    "ADV"
  ],
  "allure": [
    "NOUN"
  ],
  "intestine": [
    "VERB"
  ],
  "stalker": [
    "NOUN"
  ],
  "reclaim": [
    "VERB"
  ],
  "richness": [
    "NOUN"
  ],
  "converge": [
    "VERB"
  ],
  "penelope": [
    "PROPN"
  ],
  "sophistication": [
    "NOUN"
  ],
  "extinct": [
    "PROPN"
  ],
  "ponder": [
    "VERB"
  ],
  "oceanside": [
    "ADV"
  ],
  "smear": [
    "NOUN"
  ],
  "rigging": [
    "VERB"
  ],
  "detachment": [
    "NOUN"
  ],
  "fulham": [
    "PROPN"
  ],
  "radiance": [
    "NOUN"
  ],
  "downside": [
    "NOUN"
  ],
  "reissue": [
    "VERB"
  ],
  "striker": [
    "NOUN"
  ],
  "tensor": [
    "NOUN"
  ],
  "whitehead": [
    "NOUN"
  ],
  "patchwork": [
    "NOUN"
  ],
  "heinrich": [
    "NOUN"
  ],
  "breton": [
    "PROPN"
  ],
  "tracer": [
    "NOUN"
  ],
  "frist": [
    "NOUN"
  ],
  "involuntary": [
    "ADJ"
  ],
  "allegation": [
    "NOUN"
  ],
  "infinitely": [
    "ADV"
  ],
  "synthesizer": [
    "NOUN"
  ],
  "serge": [
    "VERB"
  ],
  "morphine": [
    "PROPN"
  ],
  "gymnasium": [
    "NOUN"
  ],
  "microfilm": [
    "NOUN"
  ],
  "chiefly": [
    "ADV"
  ],
  "judah": [
    "PROPN"
  ],
  "conjecture": [
    "NOUN"
  ],
  "restitution": [
    "NOUN"
  ],
  "blasting": [
    "VERB"
  ],
  "pituitary": [
    "ADJ"
  ],
  "repeater": [
    "NOUN"
  ],
  "autopsy": [
    "ADJ"
  ],
  "slain": [
    "VERB"
  ],
  "horticultural": [
    "ADJ"
  ],
  "ancestral": [
    "ADJ"
  ],
  "wartime": [
    "NOUN"
  ],
  "faithfully": [
    "ADV"
  ],
  "geriatric": [
    "PROPN"
  ],
  "quail": [
    "NOUN"
  ],
  "tanker": [
    "NOUN"
  ],
  "mayan": [
    "ADJ"
  ],
  "rector": [
    "NOUN"
  ],
  "ballast": [
    "NOUN"
  ],
  "immature": [
    "ADJ"
  ],
  "taxing": [
    "VERB"
  ],
  "icing": [
    "VERB"
  ],
  "substituting": [
    "VERB"
  ],
  "originality": [
    "NOUN"
  ],
  "pinned": [
    "VERB"
  ],
  "cryptographic": [
    "ADJ"
  ],
  "discontinue": [
    "VERB"
  ],
  "disparate": [
    "ADJ"
  ],
  "bantam": [
    "NOUN"
  ],
  "boardwalk": [
    "VERB"
  ],
  "ineligible": [
    "ADJ"
  ],
  "homeopathy": [
    "VERB"
  ],
  "simplification": [
    "NOUN"
  ],
  "insolvency": [
    "NOUN"
  ],
  "bianca": [
    "PROPN"
  ],
  "earthly": [
    "ADV"
  ],
  "affective": [
    "NOUN"
  ],
  "histogram": [
    "NOUN"
  ],
  "conceive": [
    "VERB"
  ],
  "liberalization": [
    "NOUN"
  ],
  "insensitive": [
    "ADJ"
  ],
  "forfeiture": [
    "NOUN"
  ],
  "genotype": [
    "NOUN"
  ],
  "contaminant": [
    "NOUN"
  ],
  "disastrous": [
    "ADJ"
  ],
  "rewind": [
    "NOUN"
  ],
  "gladiator": [
    "NOUN"
  ],
  "poplar": [
    "ADJ"
  ],
  "recourse": [
    "VERB"
  ],
  "martian": [
    "PROPN"
  ],
  "equinox": [
    "PROPN"
  ],
  "hinder": [
    "VERB",
    "NOUN"
  ],
  "presume": [
    "VERB"
  ],
  "astronaut": [
    "PROPN"
  ],
  "armchair": [
    "NOUN"
  ],
  "cecilia": [
    "NOUN"
  ],
  "constipation": [
    "NOUN"
  ],
  "nashua": [
    "PROPN"
  ],
  "strut": [
    "PROPN"
  ],
  "appropriateness": [
    "VERB"
  ],
  "solstice": [
    "NOUN"
  ],
  "eudora": [
    "PROPN"
  ],
  "plume": [
    "VERB"
  ],
  "calypso": [
    "NOUN"
  ],
  "cheesecake": [
    "NOUN"
  ],
  "pantry": [
    "NOUN"
  ],
  "italics": [
    "NOUN"
  ],
  "reversing": [
    "VERB"
  ],
  "murderer": [
    "NOUN"
  ],
  "courteous": [
    "ADJ"
  ],
  "smoothing": [
    "VERB"
  ],
  "billet": [
    "NOUN"
  ],
  "lubrication": [
    "NOUN"
  ],
  "hammock": [
    "NOUN"
  ],
  "fragmented": [
    "ADJ",
    "VERB"
  ],
  "revoke": [
    "VERB"
  ],
  "intruder": [
    "NOUN"
  ],
  "chevron": [
    "PROPN"
  ],
  "reinsurance": [
    "NOUN"
  ],
  "jennie": [
    "PROPN"
  ],
  "reina": [
    "NOUN"
  ],
  "energizer": [
    "PROPN"
  ],
  "vandalism": [
    "NOUN"
  ],
  "plank": [
    "NOUN"
  ],
  "paddling": [
    "VERB"
  ],
  "wolfram": [
    "NOUN"
  ],
  "contraceptive": [
    "NOUN"
  ],
  "necrosis": [
    "NOUN"
  ],
  "interrogation": [
    "NOUN"
  ],
  "bonanza": [
    "PROPN"
  ],
  "lumbar": [
    "PROPN"
  ],
  "longing": [
    "VERB"
  ],
  "irresistible": [
    "ADJ"
  ],
  "flamenco": [
    "PROPN"
  ],
  "osprey": [
    "PROPN"
  ],
  "disappearing": [
    "VERB"
  ],
  "enact": [
    "VERB"
  ],
  "flammable": [
    "ADJ"
  ],
  "biometrics": [
    "NOUN"
  ],
  "inertia": [
    "VERB"
  ],
  "misunderstanding": [
    "NOUN"
  ],
  "wasnt": [
    "AUX"
  ],
  "deity": [
    "NOUN"
  ],
  "pruning": [
    "VERB"
  ],
  "alchemist": [
    "NOUN"
  ],
  "hormonal": [
    "ADJ"
  ],
  "mandolin": [
    "PROPN"
  ],
  "calender": [
    "NOUN"
  ],
  "brightly": [
    "ADV"
  ],
  "virgo": [
    "NOUN"
  ],
  "manly": [
    "ADV"
  ],
  "unrealistic": [
    "ADJ"
  ],
  "rhonda": [
    "PROPN"
  ],
  "fearful": [
    "ADJ"
  ],
  "potency": [
    "NOUN"
  ],
  "flawless": [
    "NOUN"
  ],
  "peril": [
    "NOUN"
  ],
  "teaser": [
    "PROPN"
  ],
  "resultant": [
    "ADJ"
  ],
  "drastic": [
    "ADJ"
  ],
  "courageous": [
    "ADJ"
  ],
  "transceiver": [
    "NOUN"
  ],
  "iterative": [
    "ADJ",
    "PROPN"
  ],
  "guarded": [
    "VERB"
  ],
  "neuron": [
    "PROPN"
  ],
  "celery": [
    "NOUN"
  ],
  "pedagogy": [
    "NOUN"
  ],
  "reconcile": [
    "VERB",
    "ADJ"
  ],
  "grammatical": [
    "ADJ"
  ],
  "collin": [
    "PROPN"
  ],
  "afrikaans": [
    "NOUN"
  ],
  "cinematic": [
    "NOUN"
  ],
  "admiration": [
    "NOUN"
  ],
  "malik": [
    "NOUN"
  ],
  "offend": [
    "VERB"
  ],
  "severance": [
    "NOUN"
  ],
  "somali": [
    "PROPN"
  ],
  "caviar": [
    "NOUN"
  ],
  "retina": [
    "NOUN"
  ],
  "tempting": [
    "VERB"
  ],
  "enforceable": [
    "ADJ"
  ],
  "retinal": [
    "ADJ"
  ],
  "sheath": [
    "NOUN"
  ],
  "louie": [
    "VERB"
  ],
  "chaplain": [
    "NOUN"
  ],
  "dubious": [
    "ADJ"
  ],
  "screenwriter": [
    "VERB"
  ],
  "mammal": [
    "ADJ"
  ],
  "shielded": [
    "VERB"
  ],
  "degeneration": [
    "NOUN"
  ],
  "swirl": [
    "NOUN"
  ],
  "emery": [
    "NOUN"
  ],
  "allele": [
    "PROPN"
  ],
  "commuting": [
    "VERB"
  ],
  "intrigue": [
    "VERB"
  ],
  "eczema": [
    "PROPN"
  ],
  "northland": [
    "VERB"
  ],
  "roadster": [
    "NOUN"
  ],
  "dialect": [
    "PROPN"
  ],
  "fanatic": [
    "ADJ"
  ],
  "revive": [
    "VERB"
  ],
  "corolla": [
    "NOUN"
  ],
  "dharma": [
    "PROPN"
  ],
  "chameleon": [
    "NOUN"
  ],
  "hooper": [
    "NOUN"
  ],
  "predominant": [
    "VERB"
  ],
  "abode": [
    "VERB"
  ],
  "savoy": [
    "NOUN"
  ],
  "abrasive": [
    "VERB"
  ],
  "insecurity": [
    "NOUN"
  ],
  "koruna": [
    "PROPN"
  ],
  "trustworthy": [
    "ADJ"
  ],
  "uniformity": [
    "NOUN"
  ],
  "comfy": [
    "ADJ"
  ],
  "assuring": [
    "VERB"
  ],
  "alarming": [
    "ADJ"
  ],
  "eradication": [
    "NOUN"
  ],
  "amused": [
    "VERB"
  ],
  "horizontally": [
    "ADV"
  ],
  "knitted": [
    "VERB"
  ],
  "narrowly": [
    "ADV"
  ],
  "campo": [
    "VERB"
  ],
  "quintet": [
    "NOUN"
  ],
  "groupwise": [
    "NOUN"
  ],
  "rampant": [
    "ADJ"
  ],
  "suitcase": [
    "NOUN"
  ],
  "polka": [
    "PROPN"
  ],
  "embarrassment": [
    "NOUN"
  ],
  "wiper": [
    "NOUN"
  ],
  "mismatch": [
    "NOUN",
    "VERB"
  ],
  "retaliation": [
    "NOUN"
  ],
  "inquirer": [
    "NOUN"
  ],
  "battered": [
    "VERB"
  ],
  "dreadful": [
    "ADJ"
  ],
  "metaphysics": [
    "NOUN"
  ],
  "drifting": [
    "VERB"
  ],
  "mellow": [
    "VERB"
  ],
  "boast": [
    "VERB"
  ],
  "respiration": [
    "NOUN"
  ],
  "rapper": [
    "VERB"
  ],
  "absentee": [
    "NOUN"
  ],
  "calligraphy": [
    "NOUN"
  ],
  "advantageous": [
    "ADJ"
  ],
  "corollary": [
    "ADJ"
  ],
  "asparagus": [
    "VERB"
  ],
  "fearless": [
    "ADJ"
  ],
  "canister": [
    "NOUN"
  ],
  "stiffness": [
    "VERB"
  ],
  "thrifty": [
    "ADJ"
  ],
  "canning": [
    "VERB"
  ],
  "workmanship": [
    "NOUN"
  ],
  "palladium": [
    "NOUN"
  ],
  "shipper": [
    "NOUN"
  ],
  "darryl": [
    "NOUN"
  ],
  "reductase": [
    "NOUN"
  ],
  "perch": [
    "NOUN"
  ],
  "craven": [
    "ADJ"
  ],
  "divergence": [
    "NOUN"
  ],
  "kitchenware": [
    "NOUN"
  ],
  "homage": [
    "NOUN"
  ],
  "unitary": [
    "ADJ"
  ],
  "admittedly": [
    "ADV"
  ],
  "hospitalization": [
    "NOUN"
  ],
  "clubbing": [
    "VERB"
  ],
  "observational": [
    "ADJ"
  ],
  "angst": [
    "NOUN"
  ],
  "liturgy": [
    "PROPN"
  ],
  "nativity": [
    "NOUN"
  ],
  "surety": [
    "NOUN"
  ],
  "tranquil": [
    "NOUN"
  ],
  "carpentry": [
    "NOUN"
  ],
  "staircase": [
    "VERB"
  ],
  "cutler": [
    "PROPN"
  ],
  "sweetie": [
    "VERB"
  ],
  "electorate": [
    "VERB"
  ],
  "reconstructed": [
    "VERB"
  ],
  "resent": [
    "VERB"
  ],
  "podium": [
    "VERB"
  ],
  "paranoia": [
    "NOUN"
  ],
  "faceted": [
    "VERB"
  ],
  "silvia": [
    "PROPN"
  ],
  "distraction": [
    "NOUN"
  ],
  "gecko": [
    "PROPN"
  ],
  "fugitive": [
    "NOUN"
  ],
  "interchangeable": [
    "ADJ"
  ],
  "starship": [
    "NOUN"
  ],
  "turmoil": [
    "NOUN"
  ],
  "seeded": [
    "VERB"
  ],
  "gilles": [
    "NOUN"
  ],
  "unjust": [
    "ADJ"
  ],
  "markedly": [
    "ADV"
  ],
  "fascinated": [
    "VERB"
  ],
  "disturb": [
    "NOUN"
  ],
  "enzymology": [
    "NOUN"
  ],
  "scotsman": [
    "NOUN"
  ],
  "gushing": [
    "VERB"
  ],
  "picker": [
    "NOUN",
    "PROPN"
  ],
  "distracted": [
    "VERB"
  ],
  "secluded": [
    "VERB"
  ],
  "criticize": [
    "VERB"
  ],
  "livelihood": [
    "NOUN"
  ],
  "mulder": [
    "NOUN"
  ],
  "godfrey": [
    "NOUN"
  ],
  "dialer": [
    "NOUN"
  ],
  "minerva": [
    "PROPN"
  ],
  "iceberg": [
    "PROPN"
  ],
  "caleb": [
    "NOUN"
  ],
  "christening": [
    "VERB"
  ],
  "jealousy": [
    "NOUN"
  ],
  "syntactic": [
    "ADJ"
  ],
  "plumber": [
    "PROPN"
  ],
  "envision": [
    "VERB",
    "PROPN"
  ],
  "codex": [
    "NOUN"
  ],
  "judas": [
    "NOUN"
  ],
  "cosmology": [
    "NOUN"
  ],
  "gertrude": [
    "VERB"
  ],
  "noodle": [
    "VERB"
  ],
  "bangle": [
    "PROPN"
  ],
  "bertha": [
    "VERB"
  ],
  "donnie": [
    "PROPN"
  ],
  "proprietor": [
    "NOUN"
  ],
  "lizzie": [
    "NOUN"
  ],
  "intuit": [
    "NOUN"
  ],
  "adoptive": [
    "ADJ"
  ],
  "filibuster": [
    "NOUN"
  ],
  "facet": [
    "PROPN"
  ],
  "importation": [
    "NOUN"
  ],
  "encapsulation": [
    "NOUN"
  ],
  "samsonite": [
    "VERB"
  ],
  "accordion": [
    "NOUN"
  ],
  "planter": [
    "NOUN"
  ],
  "minimally": [
    "ADV"
  ],
  "immaculate": [
    "VERB"
  ],
  "reindeer": [
    "NOUN"
  ],
  "telegram": [
    "PROPN"
  ],
  "shaken": [
    "VERB"
  ],
  "integrative": [
    "ADJ"
  ],
  "rivalry": [
    "NOUN"
  ],
  "verve": [
    "VERB"
  ],
  "charley": [
    "PROPN"
  ],
  "spree": [
    "NOUN"
  ],
  "embed": [
    "VERB",
    "NOUN"
  ],
  "bespoke": [
    "NOUN",
    "ADJ"
  ],
  "brute": [
    "VERB"
  ],
  "trimester": [
    "NOUN"
  ],
  "warbler": [
    "PROPN"
  ],
  "onward": [
    "ADV"
  ],
  "capricorn": [
    "PROPN"
  ],
  "dipped": [
    "VERB"
  ],
  "lancet": [
    "PROPN"
  ],
  "antelope": [
    "PROPN"
  ],
  "terminus": [
    "VERB"
  ],
  "spectrometry": [
    "NOUN"
  ],
  "snippet": [
    "NOUN"
  ],
  "permeability": [
    "NOUN"
  ],
  "starred": [
    "VERB"
  ],
  "deacon": [
    "NOUN"
  ],
  "butch": [
    "VERB"
  ],
  "scart": [
    "NOUN"
  ],
  "normalization": [
    "NOUN"
  ],
  "skillet": [
    "PROPN"
  ],
  "bookcase": [
    "VERB"
  ],
  "neoprene": [
    "NOUN"
  ],
  "offeror": [
    "NOUN"
  ],
  "thermo": [
    "PROPN"
  ],
  "diaphragm": [
    "PROPN"
  ],
  "consignment": [
    "NOUN"
  ],
  "maarten": [
    "VERB"
  ],
  "ginseng": [
    "PROPN"
  ],
  "blackout": [
    "NOUN"
  ],
  "detergent": [
    "NOUN"
  ],
  "rosetta": [
    "PROPN"
  ],
  "reconsideration": [
    "NOUN"
  ],
  "barnard": [
    "VERB"
  ],
  "grenade": [
    "VERB"
  ],
  "profoundly": [
    "ADV"
  ],
  "bartender": [
    "NOUN"
  ],
  "mayfair": [
    "NOUN"
  ],
  "maneuver": [
    "NOUN"
  ],
  "ridder": [
    "PROPN"
  ],
  "enclose": [
    "VERB"
  ],
  "sienna": [
    "PROPN"
  ],
  "calves": [
    "NOUN"
  ],
  "defer": [
    "VERB"
  ],
  "pharaoh": [
    "PROPN"
  ],
  "itching": [
    "VERB"
  ],
  "reimburse": [
    "VERB"
  ],
  "devotional": [
    "ADJ"
  ],
  "esperanto": [
    "VERB"
  ],
  "comparatively": [
    "ADV"
  ],
  "shutting": [
    "VERB"
  ],
  "endemic": [
    "NOUN"
  ],
  "tourney": [
    "NOUN"
  ],
  "reasoned": [
    "VERB"
  ],
  "lawton": [
    "PROPN"
  ],
  "hydrologic": [
    "NOUN"
  ],
  "astral": [
    "NOUN"
  ],
  "aimee": [
    "NOUN"
  ],
  "terence": [
    "NOUN"
  ],
  "hamper": [
    "VERB"
  ],
  "balkan": [
    "PROPN"
  ],
  "transduction": [
    "VERB"
  ],
  "blurred": [
    "VERB"
  ],
  "aortic": [
    "ADJ"
  ],
  "smuggling": [
    "VERB"
  ],
  "starcraft": [
    "NOUN"
  ],
  "masquerade": [
    "NOUN"
  ],
  "duality": [
    "NOUN"
  ],
  "sensational": [
    "ADJ"
  ],
  "jurisdictional": [
    "ADJ"
  ],
  "smoother": [
    "ADJ"
  ],
  "expulsion": [
    "NOUN"
  ],
  "cordoba": [
    "PROPN"
  ],
  "withhold": [
    "PROPN"
  ],
  "binocular": [
    "ADJ"
  ],
  "joyful": [
    "ADJ"
  ],
  "generalization": [
    "NOUN"
  ],
  "crave": [
    "VERB"
  ],
  "waffle": [
    "NOUN"
  ],
  "detectable": [
    "ADJ"
  ],
  "arrowhead": [
    "ADV"
  ],
  "ripple": [
    "NOUN"
  ],
  "sweeper": [
    "NOUN"
  ],
  "goldsmith": [
    "PROPN"
  ],
  "inclination": [
    "NOUN"
  ],
  "keepsake": [
    "VERB"
  ],
  "measles": [
    "NOUN"
  ],
  "upbeat": [
    "ADJ"
  ],
  "portman": [
    "NOUN"
  ],
  "amenity": [
    "NOUN"
  ],
  "salty": [
    "ADJ"
  ],
  "estradiol": [
    "PROPN"
  ],
  "betrayal": [
    "NOUN"
  ],
  "flourish": [
    "VERB"
  ],
  "sporty": [
    "NOUN"
  ],
  "hawking": [
    "VERB"
  ],
  "stabilize": [
    "VERB"
  ],
  "burmese": [
    "PROPN"
  ],
  "valor": [
    "PROPN"
  ],
  "woodruff": [
    "PROPN"
  ],
  "radiotherapy": [
    "NOUN"
  ],
  "dorsal": [
    "NOUN"
  ],
  "transfusion": [
    "NOUN"
  ],
  "collie": [
    "NOUN"
  ],
  "hereditary": [
    "ADJ"
  ],
  "exaggerated": [
    "VERB"
  ],
  "spleen": [
    "VERB"
  ],
  "allotment": [
    "NOUN"
  ],
  "recombination": [
    "NOUN"
  ],
  "messing": [
    "VERB"
  ],
  "multiplying": [
    "VERB"
  ],
  "empress": [
    "ADJ"
  ],
  "whence": [
    "NOUN"
  ],
  "trusting": [
    "VERB"
  ],
  "photometry": [
    "NOUN"
  ],
  "stigma": [
    "NOUN"
  ],
  "abduction": [
    "NOUN"
  ],
  "ingestion": [
    "NOUN",
    "PROPN"
  ],
  "banda": [
    "PROPN"
  ],
  "adulthood": [
    "NOUN"
  ],
  "inject": [
    "VERB"
  ],
  "tartan": [
    "PROPN"
  ],
  "twisting": [
    "VERB"
  ],
  "goofy": [
    "PROPN"
  ],
  "mimic": [
    "VERB"
  ],
  "shielding": [
    "VERB"
  ],
  "stormy": [
    "PROPN"
  ],
  "raglan": [
    "PROPN"
  ],
  "heterosexual": [
    "ADJ"
  ],
  "pathological": [
    "ADJ"
  ],
  "fascism": [
    "NOUN"
  ],
  "trimming": [
    "VERB"
  ],
  "serene": [
    "NOUN"
  ],
  "neutrino": [
    "NOUN"
  ],
  "obligatory": [
    "ADJ"
  ],
  "wouldnt": [
    "AUX"
  ],
  "corrugated": [
    "VERB"
  ],
  "forbid": [
    "VERB"
  ],
  "unhealthy": [
    "ADJ"
  ],
  "felicity": [
    "NOUN"
  ],
  "asymptotic": [
    "ADJ"
  ],
  "fascination": [
    "NOUN"
  ],
  "isotope": [
    "NOUN"
  ],
  "preventative": [
    "ADJ"
  ],
  "splendor": [
    "NOUN"
  ],
  "vigil": [
    "NOUN"
  ],
  "temperate": [
    "NOUN"
  ],
  "crore": [
    "VERB"
  ],
  "rebirth": [
    "NOUN"
  ],
  "winona": [
    "PROPN"
  ],
  "fragrant": [
    "NOUN"
  ],
  "deserving": [
    "VERB"
  ],
  "banco": [
    "PROPN"
  ],
  "diagnoses": [
    "NOUN"
  ],
  "cortical": [
    "ADJ"
  ],
  "hotter": [
    "ADV"
  ],
  "itchy": [
    "ADJ"
  ],
  "instantaneous": [
    "ADJ"
  ],
  "bulky": [
    "ADJ"
  ],
  "exponent": [
    "PROPN"
  ],
  "desperation": [
    "NOUN"
  ],
  "glaucoma": [
    "PROPN"
  ],
  "parlor": [
    "NOUN"
  ],
  "setter": [
    "PROPN"
  ],
  "monumental": [
    "ADJ"
  ],
  "subtype": [
    "VERB"
  ],
  "facade": [
    "NOUN"
  ],
  "monograph": [
    "NOUN"
  ],
  "literate": [
    "VERB"
  ],
  "booze": [
    "VERB"
  ],
  "widen": [
    "VERB"
  ],
  "adjective": [
    "ADJ"
  ],
  "disciple": [
    "ADV"
  ],
  "cipher": [
    "PROPN"
  ],
  "rhythmic": [
    "ADJ"
  ],
  "unaffected": [
    "ADJ"
  ],
  "cleanser": [
    "NOUN"
  ],
  "hearty": [
    "ADJ"
  ],
  "triton": [
    "PROPN"
  ],
  "adore": [
    "VERB"
  ],
  "entertainer": [
    "NOUN"
  ],
  "weeping": [
    "VERB"
  ],
  "ephedrine": [
    "NOUN"
  ],
  "venous": [
    "ADJ"
  ],
  "hereunder": [
    "PROPN"
  ],
  "infancy": [
    "NOUN"
  ],
  "yachting": [
    "VERB"
  ],
  "cleanse": [
    "NOUN"
  ],
  "chilly": [
    "ADV"
  ],
  "herbicide": [
    "NOUN"
  ],
  "bolivar": [
    "PROPN"
  ],
  "irritating": [
    "VERB"
  ],
  "monarchy": [
    "NOUN"
  ],
  "corset": [
    "VERB"
  ],
  "gopher": [
    "NOUN"
  ],
  "distal": [
    "NOUN"
  ],
  "booming": [
    "VERB"
  ],
  "shortfall": [
    "NOUN"
  ],
  "harmonica": [
    "PROPN"
  ],
  "geothermal": [
    "ADJ"
  ],
  "digger": [
    "PROPN"
  ],
  "fluke": [
    "NOUN"
  ],
  "espionage": [
    "NOUN"
  ],
  "stomp": [
    "ADJ"
  ],
  "glade": [
    "VERB"
  ],
  "acidic": [
    "ADJ"
  ],
  "pendulum": [
    "NOUN"
  ],
  "gangster": [
    "NOUN"
  ],
  "fascist": [
    "ADJ"
  ],
  "nehemiah": [
    "PROPN"
  ],
  "matchbox": [
    "NOUN"
  ],
  "thinner": [
    "ADJ"
  ],
  "caste": [
    "NOUN"
  ],
  "incubator": [
    "NOUN"
  ],
  "experiential": [
    "ADJ"
  ],
  "psyche": [
    "NOUN"
  ],
  "eraser": [
    "NOUN"
  ],
  "rudolf": [
    "NOUN"
  ],
  "angling": [
    "VERB"
  ],
  "jordanian": [
    "PROPN"
  ],
  "libra": [
    "VERB"
  ],
  "stubborn": [
    "ADJ"
  ],
  "physicist": [
    "NOUN"
  ],
  "tagalog": [
    "NOUN"
  ],
  "requiem": [
    "NOUN"
  ],
  "ethylene": [
    "NOUN"
  ],
  "slows": [
    "VERB"
  ],
  "devastation": [
    "NOUN"
  ],
  "exploratory": [
    "ADJ"
  ],
  "spectrometer": [
    "NOUN"
  ],
  "heroine": [
    "NOUN"
  ],
  "outsole": [
    "NOUN"
  ],
  "inset": [
    "VERB"
  ],
  "indifferent": [
    "ADJ"
  ],
  "cadence": [
    "NOUN",
    "PROPN"
  ],
  "frosted": [
    "VERB"
  ],
  "rhine": [
    "NOUN"
  ],
  "manifested": [
    "VERB"
  ],
  "rattle": [
    "PROPN"
  ],
  "shasta": [
    "PROPN"
  ],
  "oatmeal": [
    "ADJ"
  ],
  "distilled": [
    "VERB"
  ],
  "stricken": [
    "VERB"
  ],
  "bahama": [
    "NOUN"
  ],
  "unrest": [
    "NOUN"
  ],
  "druid": [
    "PROPN",
    "ADJ"
  ],
  "outsider": [
    "PROPN"
  ],
  "abstinence": [
    "NOUN"
  ],
  "poodle": [
    "VERB"
  ],
  "sitter": [
    "PROPN"
  ],
  "colder": [
    "ADV"
  ],
  "tasmanian": [
    "NOUN"
  ],
  "hydrocarbon": [
    "NOUN"
  ],
  "lobbyist": [
    "NOUN"
  ],
  "kelvin": [
    "PROPN"
  ],
  "secondhand": [
    "PROPN"
  ],
  "swarm": [
    "NOUN"
  ],
  "clientele": [
    "PROPN"
  ],
  "ledge": [
    "NOUN"
  ],
  "technica": [
    "PROPN"
  ],
  "nectar": [
    "PROPN"
  ],
  "bureaucratic": [
    "ADJ"
  ],
  "raceway": [
    "PROPN"
  ],
  "symbolism": [
    "NOUN"
  ],
  "monsoon": [
    "NOUN"
  ],
  "drown": [
    "VERB"
  ],
  "strife": [
    "NOUN"
  ],
  "consular": [
    "ADJ"
  ],
  "tunneling": [
    "NOUN"
  ],
  "treason": [
    "VERB"
  ],
  "reckon": [
    "VERB"
  ],
  "prosper": [
    "VERB"
  ],
  "supremacy": [
    "NOUN"
  ],
  "capillary": [
    "ADJ"
  ],
  "knockout": [
    "NOUN"
  ],
  "radon": [
    "PROPN"
  ],
  "anchored": [
    "VERB"
  ],
  "mulberry": [
    "VERB"
  ],
  "sinful": [
    "ADJ"
  ],
  "bradshaw": [
    "NOUN"
  ],
  "mythical": [
    "ADJ"
  ],
  "abyss": [
    "PROPN"
  ],
  "cristina": [
    "PROPN"
  ],
  "coder": [
    "NOUN"
  ],
  "replicated": [
    "VERB"
  ],
  "anorexia": [
    "PROPN"
  ],
  "clipping": [
    "VERB"
  ],
  "niece": [
    "NOUN"
  ],
  "irresponsible": [
    "ADJ"
  ],
  "paralysis": [
    "NOUN"
  ],
  "heartburn": [
    "VERB"
  ],
  "empathy": [
    "NOUN",
    "PROPN"
  ],
  "tarzan": [
    "NOUN"
  ],
  "clockwise": [
    "NOUN"
  ],
  "flask": [
    "PROPN"
  ],
  "arisen": [
    "VERB"
  ],
  "relentless": [
    "NOUN"
  ],
  "ribbed": [
    "VERB"
  ],
  "omnibus": [
    "NOUN"
  ],
  "inhabited": [
    "VERB"
  ],
  "hereof": [
    "VERB"
  ],
  "untold": [
    "ADJ"
  ],
  "observable": [
    "ADJ"
  ],
  "gretchen": [
    "VERB"
  ],
  "vigorously": [
    "ADV"
  ],
  "interfering": [
    "VERB"
  ],
  "denominator": [
    "NOUN"
  ],
  "nugget": [
    "VERB"
  ],
  "freestanding": [
    "VERB"
  ],
  "resilient": [
    "ADJ"
  ],
  "procession": [
    "NOUN"
  ],
  "eyewitness": [
    "NOUN"
  ],
  "spiritually": [
    "ADV"
  ],
  "hippo": [
    "PROPN"
  ],
  "tenancy": [
    "NOUN",
    "ADJ"
  ],
  "attentive": [
    "ADJ"
  ],
  "rupture": [
    "VERB"
  ],
  "assimilation": [
    "NOUN"
  ],
  "lyrical": [
    "ADJ"
  ],
  "angelica": [
    "PROPN"
  ],
  "braided": [
    "VERB"
  ],
  "ticketing": [
    "NOUN",
    "VERB"
  ],
  "heterogeneity": [
    "NOUN"
  ],
  "wooded": [
    "VERB"
  ],
  "bodied": [
    "VERB"
  ],
  "intensely": [
    "ADV"
  ],
  "sleeved": [
    "VERB"
  ],
  "aspiration": [
    "NOUN"
  ],
  "cellulose": [
    "VERB"
  ],
  "cathode": [
    "NOUN"
  ],
  "aviator": [
    "NOUN"
  ],
  "seriousness": [
    "NOUN"
  ],
  "conformation": [
    "NOUN"
  ],
  "intimidation": [
    "NOUN"
  ],
  "paladin": [
    "VERB"
  ],
  "civilized": [
    "VERB"
  ],
  "rotated": [
    "VERB"
  ],
  "cassandra": [
    "NOUN"
  ],
  "sighted": [
    "VERB"
  ],
  "rosary": [
    "NOUN"
  ],
  "scotty": [
    "NOUN"
  ],
  "platoon": [
    "NOUN"
  ],
  "loneliness": [
    "PROPN"
  ],
  "pulley": [
    "PROPN"
  ],
  "unhelpful": [
    "ADJ"
  ],
  "synonymous": [
    "ADJ"
  ],
  "confectionery": [
    "NOUN"
  ],
  "consciously": [
    "ADV"
  ],
  "cours": [
    "NOUN"
  ],
  "twister": [
    "NOUN"
  ],
  "sequoia": [
    "PROPN"
  ],
  "activator": [
    "NOUN"
  ],
  "priscilla": [
    "NOUN"
  ],
  "familial": [
    "ADJ"
  ],
  "marquee": [
    "PROPN"
  ],
  "conducive": [
    "ADJ"
  ],
  "resilience": [
    "NOUN",
    "PROPN"
  ],
  "thermodynamics": [
    "NOUN"
  ],
  "uncontrolled": [
    "VERB"
  ],
  "seton": [
    "NOUN"
  ],
  "catchy": [
    "VERB"
  ],
  "synaptic": [
    "NOUN"
  ],
  "hugely": [
    "ADV"
  ],
  "swahili": [
    "NOUN"
  ],
  "rosario": [
    "PROPN"
  ],
  "fruitful": [
    "ADJ"
  ],
  "commercialization": [
    "NOUN"
  ],
  "indemnify": [
    "VERB"
  ],
  "satisfactorily": [
    "ADV"
  ],
  "thinker": [
    "NOUN"
  ],
  "influx": [
    "NOUN"
  ],
  "convoy": [
    "NOUN"
  ],
  "unleaded": [
    "VERB"
  ],
  "conveyance": [
    "NOUN"
  ],
  "mesquite": [
    "NOUN"
  ],
  "kroner": [
    "NOUN"
  ],
  "tortoise": [
    "VERB"
  ],
  "cultivate": [
    "VERB"
  ],
  "inhibitory": [
    "NOUN"
  ],
  "phonics": [
    "NOUN"
  ],
  "crocker": [
    "PROPN"
  ],
  "meningitis": [
    "PROPN"
  ],
  "asteroid": [
    "NOUN"
  ],
  "abolition": [
    "NOUN"
  ],
  "padre": [
    "PROPN"
  ],
  "unlisted": [
    "ADJ"
  ],
  "conductive": [
    "ADJ"
  ],
  "foresight": [
    "NOUN"
  ],
  "peppermint": [
    "NOUN"
  ],
  "reagent": [
    "ADJ"
  ],
  "achievable": [
    "ADJ"
  ],
  "glamorous": [
    "ADJ"
  ],
  "frantic": [
    "ADJ"
  ],
  "cocoon": [
    "NOUN"
  ],
  "gladys": [
    "VERB"
  ],
  "interception": [
    "NOUN"
  ],
  "assignee": [
    "NOUN",
    "PROPN"
  ],
  "dictatorship": [
    "NOUN"
  ],
  "valance": [
    "NOUN"
  ],
  "breezy": [
    "PROPN"
  ],
  "pisces": [
    "NOUN"
  ],
  "mundane": [
    "VERB"
  ],
  "rendition": [
    "NOUN"
  ],
  "matador": [
    "PROPN"
  ],
  "adjudication": [
    "NOUN"
  ],
  "lombard": [
    "PROPN"
  ],
  "barren": [
    "NOUN"
  ],
  "plead": [
    "NOUN"
  ],
  "embargo": [
    "NOUN"
  ],
  "condensation": [
    "NOUN"
  ],
  "unplugged": [
    "ADJ"
  ],
  "claudio": [
    "NOUN"
  ],
  "commentator": [
    "NOUN"
  ],
  "patterned": [
    "VERB"
  ],
  "sheen": [
    "VERB"
  ],
  "specter": [
    "NOUN"
  ],
  "assent": [
    "NOUN"
  ],
  "shading": [
    "VERB"
  ],
  "polymorphism": [
    "NOUN"
  ],
  "semitism": [
    "NOUN"
  ],
  "sevenfold": [
    "VERB"
  ],
  "scrubbed": [
    "VERB"
  ],
  "epidemiological": [
    "ADJ"
  ],
  "medic": [
    "NOUN"
  ],
  "roundabout": [
    "VERB"
  ],
  "paternity": [
    "NOUN"
  ],
  "conceal": [
    "NOUN"
  ],
  "grail": [
    "NOUN"
  ],
  "starvation": [
    "NOUN"
  ],
  "nostalgic": [
    "ADJ"
  ],
  "tabled": [
    "VERB"
  ],
  "farsi": [
    "NOUN"
  ],
  "excelsior": [
    "NOUN"
  ],
  "seine": [
    "NOUN"
  ],
  "criminology": [
    "NOUN"
  ],
  "jeanette": [
    "NOUN"
  ],
  "saviour": [
    "NOUN"
  ],
  "lapel": [
    "NOUN"
  ],
  "permittee": [
    "NOUN"
  ],
  "capitalize": [
    "VERB"
  ],
  "wedgwood": [
    "PROPN"
  ],
  "cupboard": [
    "NOUN"
  ],
  "archipelago": [
    "PROPN"
  ],
  "deceptive": [
    "VERB"
  ],
  "pecan": [
    "PROPN"
  ],
  "tinted": [
    "VERB"
  ],
  "congratulate": [
    "VERB"
  ],
  "benzene": [
    "PROPN"
  ],
  "topper": [
    "NOUN"
  ],
  "constance": [
    "NOUN"
  ],
  "manny": [
    "NOUN"
  ],
  "osteoarthritis": [
    "NOUN"
  ],
  "vanishing": [
    "VERB"
  ],
  "legislator": [
    "NOUN"
  ],
  "taxonomic": [
    "NOUN"
  ],
  "palmetto": [
    "NOUN"
  ],
  "kitchener": [
    "NOUN"
  ],
  "genera": [
    "NOUN"
  ],
  "sparked": [
    "VERB"
  ],
  "poisonous": [
    "ADJ"
  ],
  "chime": [
    "NOUN"
  ],
  "spence": [
    "NOUN"
  ],
  "conner": [
    "PROPN"
  ],
  "mischief": [
    "PROPN"
  ],
  "argent": [
    "VERB"
  ],
  "delinquency": [
    "NOUN"
  ],
  "sentimental": [
    "ADJ"
  ],
  "unsuitable": [
    "ADJ"
  ],
  "mildly": [
    "ADV"
  ],
  "forging": [
    "VERB"
  ],
  "electrostatic": [
    "ADJ"
  ],
  "topological": [
    "ADJ"
  ],
  "waitress": [
    "NOUN"
  ],
  "oversize": [
    "VERB"
  ],
  "caribou": [
    "PROPN"
  ],
  "expansive": [
    "ADJ"
  ],
  "footing": [
    "VERB"
  ],
  "craftsmanship": [
    "NOUN"
  ],
  "cheetah": [
    "PROPN"
  ],
  "remit": [
    "VERB"
  ],
  "bonnet": [
    "NOUN"
  ],
  "stumble": [
    "VERB"
  ],
  "undertook": [
    "VERB"
  ],
  "hatchery": [
    "NOUN"
  ],
  "promenade": [
    "PROPN"
  ],
  "exhaustion": [
    "NOUN"
  ],
  "unborn": [
    "ADJ"
  ],
  "wendell": [
    "PROPN"
  ],
  "cheesy": [
    "NOUN"
  ],
  "concur": [
    "PROPN"
  ],
  "exert": [
    "VERB"
  ],
  "madeline": [
    "PROPN"
  ],
  "sanskrit": [
    "NOUN"
  ],
  "pinto": [
    "NOUN"
  ],
  "worldly": [
    "ADV"
  ],
  "corded": [
    "VERB"
  ],
  "heirloom": [
    "NOUN"
  ],
  "pleasantly": [
    "ADV"
  ],
  "portray": [
    "VERB"
  ],
  "esoteric": [
    "ADJ"
  ],
  "graphically": [
    "ADV"
  ],
  "shameless": [
    "VERB"
  ],
  "hematology": [
    "NOUN"
  ],
  "bourgeois": [
    "NOUN"
  ],
  "expressway": [
    "NOUN"
  ],
  "steelhead": [
    "ADJ"
  ],
  "lucid": [
    "PROPN"
  ],
  "canaan": [
    "NOUN"
  ],
  "oppressed": [
    "VERB"
  ],
  "infer": [
    "VERB"
  ],
  "prosecute": [
    "VERB"
  ],
  "thatcher": [
    "PROPN"
  ],
  "sergei": [
    "VERB"
  ],
  "indebtedness": [
    "NOUN"
  ],
  "scramble": [
    "VERB"
  ],
  "adversary": [
    "NOUN"
  ],
  "quaint": [
    "VERB"
  ],
  "oswald": [
    "PROPN"
  ],
  "dipping": [
    "VERB"
  ],
  "revere": [
    "VERB"
  ],
  "solemn": [
    "PROPN"
  ],
  "eruption": [
    "NOUN"
  ],
  "celeste": [
    "NOUN"
  ],
  "gentry": [
    "NOUN"
  ],
  "insurgency": [
    "NOUN"
  ],
  "boyer": [
    "NOUN"
  ],
  "perceptual": [
    "ADJ"
  ],
  "enchanting": [
    "VERB"
  ],
  "rambler": [
    "NOUN"
  ],
  "fermentation": [
    "NOUN"
  ],
  "careless": [
    "VERB"
  ],
  "julien": [
    "PROPN"
  ],
  "dandy": [
    "ADJ"
  ],
  "refurbishment": [
    "NOUN"
  ],
  "grassland": [
    "VERB"
  ],
  "jeffery": [
    "PROPN"
  ],
  "narcotic": [
    "ADJ"
  ],
  "councilman": [
    "PROPN"
  ],
  "moulin": [
    "NOUN"
  ],
  "unbranded": [
    "ADJ"
  ],
  "incompetent": [
    "ADJ"
  ],
  "actuator": [
    "NOUN"
  ],
  "reinstall": [
    "VERB"
  ],
  "lander": [
    "PROPN"
  ],
  "lancer": [
    "NOUN"
  ],
  "sorcerer": [
    "NOUN"
  ],
  "muffin": [
    "PROPN"
  ],
  "motherhood": [
    "NOUN"
  ],
  "miscellany": [
    "NOUN"
  ],
  "slowdown": [
    "NOUN"
  ],
  "bridesmaid": [
    "VERB"
  ],
  "partridge": [
    "NOUN"
  ],
  "synod": [
    "PROPN"
  ],
  "lousy": [
    "ADJ"
  ],
  "foreseeable": [
    "ADJ"
  ],
  "newmarket": [
    "NOUN"
  ],
  "amigo": [
    "NOUN"
  ],
  "discerning": [
    "VERB"
  ],
  "caddy": [
    "VERB"
  ],
  "occupant": [
    "NOUN"
  ],
  "villanova": [
    "NOUN"
  ],
  "juggling": [
    "VERB"
  ],
  "wildfire": [
    "NOUN"
  ],
  "seductive": [
    "VERB"
  ],
  "scala": [
    "VERB"
  ],
  "rambling": [
    "VERB"
  ],
  "bedside": [
    "NOUN"
  ],
  "heuristic": [
    "NOUN"
  ],
  "archivist": [
    "PROPN"
  ],
  "legality": [
    "NOUN"
  ],
  "arbitrarily": [
    "ADV"
  ],
  "biologist": [
    "NOUN"
  ],
  "fruity": [
    "NOUN"
  ],
  "stratus": [
    "NOUN"
  ],
  "mysticism": [
    "NOUN"
  ],
  "summed": [
    "VERB"
  ],
  "chopin": [
    "VERB"
  ],
  "joiner": [
    "VERB"
  ],
  "guaranty": [
    "NOUN"
  ],
  "procure": [
    "VERB"
  ],
  "oxidative": [
    "NOUN"
  ],
  "stillwater": [
    "VERB"
  ],
  "pliers": [
    "NOUN"
  ],
  "anastasia": [
    "NOUN"
  ],
  "arrogance": [
    "NOUN"
  ],
  "marxist": [
    "ADJ"
  ],
  "bleak": [
    "ADJ"
  ],
  "fieldwork": [
    "NOUN"
  ],
  "christophe": [
    "NOUN"
  ],
  "damping": [
    "VERB"
  ],
  "drudge": [
    "VERB"
  ],
  "dolores": [
    "NOUN"
  ],
  "saliva": [
    "NOUN"
  ],
  "bootleg": [
    "NOUN"
  ],
  "artemis": [
    "PROPN"
  ],
  "lessen": [
    "PROPN"
  ],
  "syringe": [
    "VERB"
  ],
  "leftist": [
    "ADJ"
  ],
  "tequila": [
    "PROPN"
  ],
  "admiralty": [
    "NOUN"
  ],
  "powdered": [
    "VERB"
  ],
  "granger": [
    "NOUN"
  ],
  "germantown": [
    "VERB"
  ],
  "glacial": [
    "ADJ"
  ],
  "tapered": [
    "VERB"
  ],
  "toothbrush": [
    "VERB"
  ],
  "plutonium": [
    "NOUN"
  ],
  "antiquity": [
    "NOUN"
  ],
  "subsurface": [
    "NOUN"
  ],
  "blaming": [
    "VERB"
  ],
  "embark": [
    "VERB"
  ],
  "johanna": [
    "PROPN"
  ],
  "granular": [
    "ADJ",
    "PROPN"
  ],
  "underscore": [
    "VERB"
  ],
  "glutamine": [
    "NOUN"
  ],
  "slutty": [
    "PROPN"
  ],
  "sphinx": [
    "VERB"
  ],
  "tablature": [
    "ADJ"
  ],
  "spiegel": [
    "PROPN"
  ],
  "fertilization": [
    "NOUN"
  ],
  "gearbox": [
    "PROPN"
  ],
  "ceremonial": [
    "PROPN"
  ],
  "sonnet": [
    "NOUN"
  ],
  "stang": [
    "PROPN"
  ],
  "alejandro": [
    "NOUN"
  ],
  "sprung": [
    "VERB"
  ],
  "tensile": [
    "NOUN"
  ],
  "inflated": [
    "VERB"
  ],
  "intercom": [
    "PROPN"
  ],
  "splice": [
    "NOUN"
  ],
  "splicing": [
    "VERB"
  ],
  "campfire": [
    "VERB"
  ],
  "hubby": [
    "NOUN"
  ],
  "quilted": [
    "VERB"
  ],
  "walled": [
    "VERB"
  ],
  "immensely": [
    "ADV"
  ],
  "relapse": [
    "NOUN"
  ],
  "commend": [
    "VERB"
  ],
  "descend": [
    "VERB"
  ],
  "contender": [
    "NOUN"
  ],
  "jakob": [
    "PROPN"
  ],
  "southland": [
    "NOUN"
  ],
  "bolster": [
    "VERB"
  ],
  "diaspora": [
    "PROPN"
  ],
  "moratorium": [
    "NOUN"
  ],
  "rancid": [
    "NOUN"
  ],
  "disparity": [
    "NOUN"
  ],
  "malice": [
    "NOUN"
  ],
  "syllable": [
    "PROPN"
  ],
  "painfully": [
    "ADV"
  ],
  "sweating": [
    "VERB"
  ],
  "unclaimed": [
    "ADJ"
  ],
  "cytoplasmic": [
    "ADJ"
  ],
  "catholicism": [
    "NOUN"
  ],
  "trident": [
    "ADJ"
  ],
  "lemonade": [
    "VERB"
  ],
  "josie": [
    "PROPN"
  ],
  "solarium": [
    "NOUN"
  ],
  "propeller": [
    "NOUN"
  ],
  "anarchist": [
    "NOUN"
  ],
  "submerged": [
    "VERB"
  ],
  "intending": [
    "VERB"
  ],
  "cromwell": [
    "NOUN"
  ],
  "highlander": [
    "PROPN"
  ],
  "capacitance": [
    "NOUN"
  ],
  "birthstone": [
    "NOUN"
  ],
  "lingual": [
    "ADJ"
  ],
  "unframed": [
    "VERB"
  ],
  "punto": [
    "VERB"
  ],
  "funnel": [
    "NOUN",
    "PROPN"
  ],
  "thirsty": [
    "ADJ"
  ],
  "republication": [
    "NOUN"
  ],
  "freshness": [
    "NOUN"
  ],
  "lathe": [
    "NOUN"
  ],
  "shabby": [
    "PROPN"
  ],
  "unaudited": [
    "ADJ"
  ],
  "summertime": [
    "NOUN"
  ],
  "marbles": [
    "NOUN"
  ],
  "cottonwood": [
    "NOUN"
  ],
  "mildred": [
    "VERB"
  ],
  "sweetwater": [
    "NOUN"
  ],
  "cleopatra": [
    "PROPN"
  ],
  "undecided": [
    "ADJ"
  ],
  "startling": [
    "ADJ"
  ],
  "inductive": [
    "ADJ"
  ],
  "inadvertently": [
    "ADV"
  ],
  "correlate": [
    "VERB"
  ],
  "bylaw": [
    "VERB"
  ],
  "epiphany": [
    "NOUN"
  ],
  "halves": [
    "NOUN"
  ],
  "melancholy": [
    "ADJ"
  ],
  "observance": [
    "NOUN"
  ],
  "galvanized": [
    "VERB"
  ],
  "teapot": [
    "NOUN"
  ],
  "squire": [
    "NOUN"
  ],
  "counterfeit": [
    "ADJ"
  ],
  "waller": [
    "NOUN"
  ],
  "pathogen": [
    "VERB"
  ],
  "overwrite": [
    "VERB"
  ],
  "revitalization": [
    "NOUN"
  ],
  "resonant": [
    "NOUN"
  ],
  "expedite": [
    "VERB"
  ],
  "sweetness": [
    "VERB"
  ],
  "crook": [
    "PROPN"
  ],
  "indifference": [
    "NOUN"
  ],
  "melton": [
    "PROPN"
  ],
  "mikey": [
    "NOUN"
  ],
  "telephoto": [
    "NOUN"
  ],
  "stale": [
    "ADJ",
    "PROPN"
  ],
  "levers": [
    "NOUN"
  ],
  "borderline": [
    "NOUN"
  ],
  "incarnation": [
    "NOUN"
  ],
  "strained": [
    "VERB"
  ],
  "zionist": [
    "PROPN"
  ],
  "putty": [
    "PROPN"
  ],
  "admissible": [
    "ADJ"
  ],
  "sunless": [
    "VERB"
  ],
  "puzzled": [
    "VERB"
  ],
  "unexplained": [
    "ADJ"
  ],
  "patsy": [
    "PROPN"
  ],
  "fourteenth": [
    "PROPN"
  ],
  "eldest": [
    "ADJ"
  ],
  "terrifying": [
    "VERB"
  ],
  "uprising": [
    "VERB"
  ],
  "nonstop": [
    "ADJ"
  ],
  "hummel": [
    "NOUN"
  ],
  "corgi": [
    "PROPN"
  ],
  "seasonally": [
    "ADV"
  ],
  "remnant": [
    "NOUN"
  ],
  "immoral": [
    "ADJ"
  ],
  "malkin": [
    "NOUN"
  ],
  "unequal": [
    "ADJ"
  ],
  "weaken": [
    "VERB"
  ],
  "psychosocial": [
    "NOUN"
  ],
  "categorical": [
    "ADJ"
  ],
  "cupid": [
    "NOUN"
  ],
  "cline": [
    "NOUN"
  ],
  "backlog": [
    "NOUN",
    "PROPN"
  ],
  "thema": [
    "PROPN"
  ],
  "stalking": [
    "VERB"
  ],
  "sturgeon": [
    "NOUN"
  ],
  "joachim": [
    "PROPN"
  ],
  "hodgkin": [
    "PROPN"
  ],
  "earle": [
    "PROPN"
  ],
  "haste": [
    "NOUN"
  ],
  "alfalfa": [
    "NOUN"
  ],
  "argyll": [
    "NOUN"
  ],
  "electrically": [
    "ADV"
  ],
  "ophthalmic": [
    "ADJ"
  ],
  "rhetorical": [
    "ADJ"
  ],
  "prong": [
    "PROPN"
  ],
  "unreleased": [
    "VERB"
  ],
  "simmer": [
    "PROPN"
  ],
  "smallpox": [
    "VERB"
  ],
  "histology": [
    "NOUN"
  ],
  "overwhelmingly": [
    "ADV"
  ],
  "waterway": [
    "NOUN"
  ],
  "klamath": [
    "NOUN"
  ],
  "atrial": [
    "ADJ"
  ],
  "equalizer": [
    "NOUN"
  ],
  "norbert": [
    "PROPN"
  ],
  "complication": [
    "NOUN"
  ],
  "aubrey": [
    "VERB"
  ],
  "adaptable": [
    "ADJ"
  ],
  "cherish": [
    "PROPN"
  ],
  "undead": [
    "NOUN"
  ],
  "berth": [
    "PROPN"
  ],
  "uninterrupted": [
    "ADJ"
  ],
  "tuscan": [
    "ADV"
  ],
  "lingo": [
    "NOUN"
  ],
  "fundamentalist": [
    "NOUN"
  ],
  "subtraction": [
    "NOUN"
  ],
  "budding": [
    "VERB"
  ],
  "resemblance": [
    "NOUN"
  ],
  "hackney": [
    "PROPN"
  ],
  "leveling": [
    "VERB"
  ],
  "piggy": [
    "PROPN"
  ],
  "saber": [
    "PROPN"
  ],
  "cataract": [
    "VERB"
  ],
  "playable": [
    "ADJ"
  ],
  "midday": [
    "NOUN"
  ],
  "innate": [
    "VERB"
  ],
  "medallion": [
    "NOUN"
  ],
  "prominently": [
    "ADV"
  ],
  "platt": [
    "NOUN"
  ],
  "virology": [
    "NOUN"
  ],
  "calais": [
    "PROPN"
  ],
  "rapture": [
    "NOUN"
  ],
  "sunbeam": [
    "VERB"
  ],
  "abruptly": [
    "ADV"
  ],
  "caspian": [
    "PROPN"
  ],
  "impair": [
    "NOUN"
  ],
  "susanna": [
    "NOUN"
  ],
  "beading": [
    "VERB"
  ],
  "robustness": [
    "NOUN"
  ],
  "interplay": [
    "NOUN"
  ],
  "lager": [
    "NOUN"
  ],
  "projecting": [
    "VERB"
  ],
  "goblin": [
    "NOUN"
  ],
  "ratchet": [
    "NOUN"
  ],
  "cygnus": [
    "VERB"
  ],
  "depiction": [
    "NOUN"
  ],
  "tiered": [
    "VERB"
  ],
  "nocturnal": [
    "ADJ"
  ],
  "transactional": [
    "ADJ",
    "PROPN"
  ],
  "emulate": [
    "ADJ"
  ],
  "accuse": [
    "VERB"
  ],
  "doggy": [
    "PROPN"
  ],
  "hurdle": [
    "NOUN"
  ],
  "metastatic": [
    "PROPN"
  ],
  "errata": [
    "NOUN"
  ],
  "intrepid": [
    "ADJ"
  ],
  "babel": [
    "NOUN"
  ],
  "clustered": [
    "VERB"
  ],
  "insofar": [
    "ADV"
  ],
  "primate": [
    "VERB"
  ],
  "surrogate": [
    "ADJ"
  ],
  "breathable": [
    "ADJ"
  ],
  "compromising": [
    "VERB"
  ],
  "programmatic": [
    "ADJ"
  ],
  "willingly": [
    "ADV"
  ],
  "harlequin": [
    "NOUN"
  ],
  "barracuda": [
    "ADJ"
  ],
  "revisit": [
    "VERB",
    "PROPN"
  ],
  "insulting": [
    "VERB"
  ],
  "prominence": [
    "NOUN"
  ],
  "cuckoo": [
    "NOUN"
  ],
  "acacia": [
    "PROPN"
  ],
  "whiting": [
    "VERB"
  ],
  "netting": [
    "VERB"
  ],
  "methadone": [
    "NOUN"
  ],
  "erasmus": [
    "NOUN"
  ],
  "hermitage": [
    "NOUN"
  ],
  "starlight": [
    "ADP"
  ],
  "coauthor": [
    "NOUN"
  ],
  "foyer": [
    "PROPN"
  ],
  "brood": [
    "NOUN"
  ],
  "azure": [
    "PROPN",
    "ADJ"
  ],
  "compel": [
    "PROPN"
  ],
  "sabine": [
    "VERB"
  ],
  "doorstep": [
    "NOUN"
  ],
  "sniff": [
    "NOUN"
  ],
  "dangling": [
    "VERB"
  ],
  "unattached": [
    "VERB"
  ],
  "negligent": [
    "ADJ"
  ],
  "gliding": [
    "VERB"
  ],
  "dieter": [
    "VERB"
  ],
  "centerpiece": [
    "NOUN"
  ],
  "tranquility": [
    "NOUN"
  ],
  "unwind": [
    "ADV"
  ],
  "wavelet": [
    "NOUN"
  ],
  "drawback": [
    "NOUN"
  ],
  "smyrna": [
    "PROPN"
  ],
  "pathogenesis": [
    "NOUN"
  ],
  "reinstatement": [
    "NOUN"
  ],
  "hostess": [
    "NOUN"
  ],
  "dipole": [
    "NOUN"
  ],
  "posse": [
    "NOUN"
  ],
  "hesitation": [
    "NOUN"
  ],
  "pixie": [
    "NOUN"
  ],
  "proofing": [
    "VERB"
  ],
  "bereavement": [
    "NOUN"
  ],
  "vehicular": [
    "ADJ"
  ],
  "workbench": [
    "PROPN",
    "NOUN"
  ],
  "westward": [
    "ADV"
  ],
  "impala": [
    "NOUN"
  ],
  "commenter": [
    "NOUN"
  ],
  "celsius": [
    "NOUN"
  ],
  "leopold": [
    "VERB"
  ],
  "recognizable": [
    "ADJ"
  ],
  "ludlow": [
    "VERB"
  ],
  "unset": [
    "VERB"
  ],
  "waxing": [
    "VERB"
  ],
  "hitchhiker": [
    "NOUN"
  ],
  "sinner": [
    "PROPN"
  ],
  "auspices": [
    "NOUN"
  ],
  "dissenting": [
    "VERB"
  ],
  "melee": [
    "PROPN"
  ],
  "conduction": [
    "NOUN"
  ],
  "countess": [
    "NOUN"
  ],
  "pleading": [
    "VERB"
  ],
  "grabber": [
    "PROPN"
  ],
  "crafty": [
    "INTJ"
  ],
  "llama": [
    "PROPN"
  ],
  "peridot": [
    "NOUN"
  ],
  "troubling": [
    "ADJ"
  ],
  "vowel": [
    "VERB"
  ],
  "reuben": [
    "PROPN"
  ],
  "coronation": [
    "NOUN"
  ],
  "isabelle": [
    "PROPN"
  ],
  "dermatitis": [
    "NOUN"
  ],
  "reluctance": [
    "NOUN"
  ],
  "snowfall": [
    "VERB"
  ],
  "inconsistency": [
    "NOUN"
  ],
  "fecal": [
    "ADJ"
  ],
  "apostolic": [
    "ADJ"
  ],
  "newsstand": [
    "PROPN"
  ],
  "dossier": [
    "NOUN"
  ],
  "treble": [
    "ADJ"
  ],
  "galley": [
    "NOUN"
  ],
  "shovel": [
    "NOUN"
  ],
  "entail": [
    "VERB"
  ],
  "nighttime": [
    "NOUN"
  ],
  "proximal": [
    "ADJ"
  ],
  "unfolding": [
    "VERB"
  ],
  "milking": [
    "VERB"
  ],
  "wilbur": [
    "NOUN"
  ],
  "suitably": [
    "ADV"
  ],
  "enormously": [
    "ADV"
  ],
  "peroxide": [
    "VERB"
  ],
  "scribe": [
    "VERB"
  ],
  "nellie": [
    "PROPN"
  ],
  "sleigh": [
    "PROPN"
  ],
  "formulae": [
    "ADJ"
  ],
  "backlash": [
    "NOUN"
  ],
  "frontage": [
    "VERB"
  ],
  "blister": [
    "NOUN"
  ],
  "opacity": [
    "NOUN"
  ],
  "ration": [
    "NOUN"
  ],
  "humid": [
    "PROPN"
  ],
  "portrayal": [
    "VERB"
  ],
  "centenary": [
    "PROPN"
  ],
  "guile": [
    "ADJ"
  ],
  "lacquer": [
    "PROPN"
  ],
  "unfold": [
    "NOUN"
  ],
  "pedagogical": [
    "ADJ"
  ],
  "tutti": [
    "PROPN"
  ],
  "combinatorial": [
    "NOUN"
  ],
  "therefor": [
    "ADP"
  ],
  "unintended": [
    "ADJ"
  ],
  "raman": [
    "NOUN"
  ],
  "unattended": [
    "VERB"
  ],
  "playwright": [
    "PROPN"
  ],
  "punjabi": [
    "NOUN"
  ],
  "naturalization": [
    "NOUN"
  ],
  "whispering": [
    "VERB"
  ],
  "dissipation": [
    "NOUN"
  ],
  "sprite": [
    "NOUN"
  ],
  "oxidase": [
    "VERB"
  ],
  "leighton": [
    "PROPN"
  ],
  "atheism": [
    "NOUN"
  ],
  "gripping": [
    "VERB"
  ],
  "caterer": [
    "NOUN"
  ],
  "remission": [
    "NOUN"
  ],
  "praxis": [
    "VERB"
  ],
  "affirmation": [
    "NOUN"
  ],
  "perturbation": [
    "NOUN"
  ],
  "unassigned": [
    "ADJ",
    "PROPN"
  ],
  "adriana": [
    "PROPN"
  ],
  "lyndon": [
    "PROPN"
  ],
  "angler": [
    "NOUN"
  ],
  "astounding": [
    "ADJ"
  ],
  "marketer": [
    "NOUN"
  ],
  "resend": [
    "VERB"
  ],
  "augment": [
    "VERB"
  ],
  "gelatin": [
    "NOUN"
  ],
  "shedding": [
    "VERB"
  ],
  "adenosine": [
    "NOUN"
  ],
  "swatch": [
    "VERB"
  ],
  "eucalyptus": [
    "NOUN"
  ],
  "redefine": [
    "NOUN"
  ],
  "conservatism": [
    "NOUN"
  ],
  "backdoor": [
    "NOUN"
  ],
  "cripple": [
    "PROPN"
  ],
  "divert": [
    "VERB"
  ],
  "lofty": [
    "ADJ"
  ],
  "proclaim": [
    "VERB"
  ],
  "kanji": [
    "X"
  ],
  "recreate": [
    "VERB"
  ],
  "dropout": [
    "NOUN"
  ],
  "lockout": [
    "NOUN"
  ],
  "merton": [
    "PROPN"
  ],
  "horrific": [
    "ADJ"
  ],
  "abacus": [
    "NOUN"
  ],
  "lifeline": [
    "NOUN"
  ],
  "richly": [
    "ADV"
  ],
  "conjugate": [
    "VERB"
  ],
  "dogma": [
    "VERB"
  ],
  "vaguely": [
    "ADV"
  ],
  "winch": [
    "NOUN"
  ],
  "spontaneously": [
    "ADV"
  ],
  "sabotage": [
    "NOUN"
  ],
  "unavoidable": [
    "ADJ"
  ],
  "suppressor": [
    "NOUN"
  ],
  "ruthless": [
    "ADJ"
  ],
  "ecclesiastes": [
    "NOUN"
  ],
  "aptitude": [
    "VERB"
  ],
  "seniority": [
    "NOUN"
  ],
  "equator": [
    "NOUN"
  ],
  "blatant": [
    "ADJ"
  ],
  "floss": [
    "VERB"
  ],
  "telugu": [
    "NOUN"
  ],
  "midwifery": [
    "ADJ"
  ],
  "primates": [
    "NOUN"
  ],
  "receptacle": [
    "NOUN"
  ],
  "tangerine": [
    "VERB"
  ],
  "puberty": [
    "VERB"
  ],
  "crawler": [
    "NOUN"
  ],
  "angled": [
    "VERB"
  ],
  "shorten": [
    "VERB"
  ],
  "shawl": [
    "NOUN"
  ],
  "samaritan": [
    "PROPN"
  ],
  "unison": [
    "NOUN"
  ],
  "tabular": [
    "PROPN"
  ],
  "groff": [
    "NOUN"
  ],
  "dormant": [
    "ADJ"
  ],
  "restrained": [
    "VERB"
  ],
  "concerted": [
    "VERB"
  ],
  "ecumenical": [
    "ADJ"
  ],
  "tanaka": [
    "PROPN"
  ],
  "crouch": [
    "VERB"
  ],
  "pence": [
    "NOUN"
  ],
  "placid": [
    "ADJ"
  ],
  "napkin": [
    "NOUN"
  ],
  "contagious": [
    "ADJ"
  ],
  "inaccessible": [
    "ADJ"
  ],
  "marsha": [
    "PROPN"
  ],
  "conspicuous": [
    "ADJ"
  ],
  "barbarian": [
    "PROPN"
  ],
  "soaking": [
    "VERB",
    "NOUN"
  ],
  "ferrous": [
    "ADJ"
  ],
  "intrusive": [
    "ADJ"
  ],
  "thyme": [
    "NOUN"
  ],
  "parasitic": [
    "ADJ"
  ],
  "chino": [
    "PROPN"
  ],
  "caveat": [
    "NOUN"
  ],
  "receptive": [
    "ADJ"
  ],
  "bedrock": [
    "NOUN"
  ],
  "vulcan": [
    "PROPN"
  ],
  "guarding": [
    "VERB"
  ],
  "repurchase": [
    "PROPN"
  ],
  "windmill": [
    "ADV"
  ],
  "orthopedics": [
    "NOUN"
  ],
  "garter": [
    "NOUN"
  ],
  "appetizer": [
    "NOUN"
  ],
  "disbursement": [
    "NOUN"
  ],
  "telemetry": [
    "NOUN"
  ],
  "footed": [
    "VERB"
  ],
  "dedicate": [
    "VERB"
  ],
  "consumable": [
    "ADJ"
  ],
  "depressive": [
    "VERB"
  ],
  "stabilizer": [
    "VERB"
  ],
  "accrual": [
    "ADJ"
  ],
  "creatively": [
    "ADV"
  ],
  "euclid": [
    "ADJ"
  ],
  "tremendously": [
    "ADV"
  ],
  "oscillation": [
    "NOUN"
  ],
  "automata": [
    "NOUN"
  ],
  "thunderstorm": [
    "VERB"
  ],
  "gritty": [
    "ADJ"
  ],
  "retrospect": [
    "VERB"
  ],
  "miraculous": [
    "ADJ"
  ],
  "sensibility": [
    "NOUN"
  ],
  "reborn": [
    "ADJ"
  ],
  "punching": [
    "VERB"
  ],
  "bebop": [
    "PROPN"
  ],
  "dazzle": [
    "VERB"
  ],
  "ulysses": [
    "NOUN"
  ],
  "dangle": [
    "NOUN"
  ],
  "botanic": [
    "NOUN"
  ],
  "bronco": [
    "PROPN"
  ],
  "exceedingly": [
    "ADV"
  ],
  "inauguration": [
    "NOUN"
  ],
  "repentance": [
    "NOUN"
  ],
  "moodle": [
    "PROPN"
  ],
  "unprotected": [
    "VERB"
  ],
  "merle": [
    "NOUN"
  ],
  "savory": [
    "ADJ"
  ],
  "prefecture": [
    "NOUN"
  ],
  "crawley": [
    "NOUN"
  ],
  "murine": [
    "PROPN"
  ],
  "entomology": [
    "NOUN"
  ],
  "rodent": [
    "NOUN"
  ],
  "racket": [
    "NOUN"
  ],
  "hannibal": [
    "PROPN"
  ],
  "putter": [
    "NOUN"
  ],
  "recursion": [
    "NOUN"
  ],
  "sickle": [
    "VERB"
  ],
  "violently": [
    "ADV"
  ],
  "attest": [
    "PROPN"
  ],
  "untouched": [
    "ADJ"
  ],
  "initiator": [
    "NOUN"
  ],
  "comforting": [
    "VERB"
  ],
  "creeping": [
    "VERB"
  ],
  "kerosene": [
    "PROPN"
  ],
  "restorative": [
    "ADJ"
  ],
  "peacefully": [
    "ADV"
  ],
  "bassist": [
    "NOUN"
  ],
  "stature": [
    "VERB"
  ],
  "sentry": [
    "PROPN",
    "NOUN"
  ],
  "luminosity": [
    "NOUN"
  ],
  "ginny": [
    "PROPN"
  ],
  "degrading": [
    "VERB"
  ],
  "submittal": [
    "ADJ"
  ],
  "fireman": [
    "NOUN"
  ],
  "zorro": [
    "PROPN"
  ],
  "maniac": [
    "PROPN"
  ],
  "ozark": [
    "PROPN"
  ],
  "formative": [
    "ADJ"
  ],
  "interactivity": [
    "NOUN"
  ],
  "wrongly": [
    "ADV"
  ],
  "malfunction": [
    "NOUN"
  ],
  "falsely": [
    "ADV"
  ],
  "abbot": [
    "NOUN"
  ],
  "magma": [
    "NOUN"
  ],
  "hammersmith": [
    "ADP"
  ],
  "consul": [
    "NOUN"
  ],
  "plagued": [
    "VERB"
  ],
  "werewolf": [
    "NOUN"
  ],
  "midwestern": [
    "NOUN"
  ],
  "charisma": [
    "NOUN"
  ],
  "patronage": [
    "NOUN"
  ],
  "fodder": [
    "VERB"
  ],
  "impetus": [
    "NOUN"
  ],
  "peeled": [
    "VERB"
  ],
  "malnutrition": [
    "NOUN"
  ],
  "intercultural": [
    "ADJ"
  ],
  "goshen": [
    "PROPN"
  ],
  "functionally": [
    "ADV"
  ],
  "rabies": [
    "NOUN"
  ],
  "arson": [
    "NOUN"
  ],
  "readability": [
    "NOUN"
  ],
  "modulus": [
    "VERB"
  ],
  "transatlantic": [
    "ADJ"
  ],
  "gearing": [
    "VERB"
  ],
  "glutathione": [
    "NOUN"
  ],
  "freeing": [
    "VERB"
  ],
  "redress": [
    "NOUN"
  ],
  "angina": [
    "PROPN"
  ],
  "coupler": [
    "NOUN"
  ],
  "cayenne": [
    "NOUN"
  ],
  "balboa": [
    "PROPN"
  ],
  "treatise": [
    "NOUN"
  ],
  "wainwright": [
    "ADV"
  ],
  "withdrawing": [
    "VERB"
  ],
  "solicited": [
    "VERB"
  ],
  "chipping": [
    "VERB"
  ],
  "montage": [
    "NOUN"
  ],
  "brilliantly": [
    "ADV"
  ],
  "ionization": [
    "NOUN"
  ],
  "spalding": [
    "VERB"
  ],
  "sprawl": [
    "NOUN"
  ],
  "reopen": [
    "VERB"
  ],
  "haunt": [
    "VERB"
  ],
  "hedging": [
    "VERB"
  ],
  "erased": [
    "VERB"
  ],
  "insulating": [
    "VERB"
  ],
  "resisting": [
    "VERB"
  ],
  "congregational": [
    "ADJ"
  ],
  "waterfowl": [
    "NOUN"
  ],
  "monsieur": [
    "VERB"
  ],
  "collide": [
    "VERB"
  ],
  "blinded": [
    "VERB"
  ],
  "technologist": [
    "NOUN"
  ],
  "madras": [
    "NOUN"
  ],
  "sacrificing": [
    "VERB"
  ],
  "tinker": [
    "PROPN"
  ],
  "elisha": [
    "PROPN"
  ],
  "gazing": [
    "VERB"
  ],
  "arginine": [
    "NOUN"
  ],
  "skepticism": [
    "NOUN"
  ],
  "simplistic": [
    "ADJ"
  ],
  "freehold": [
    "NOUN"
  ],
  "braid": [
    "VERB"
  ],
  "forester": [
    "NOUN"
  ],
  "injector": [
    "NOUN"
  ],
  "leung": [
    "PROPN"
  ],
  "grained": [
    "VERB"
  ],
  "shiraz": [
    "PROPN"
  ],
  "announcer": [
    "NOUN"
  ],
  "disgrace": [
    "NOUN"
  ],
  "mediate": [
    "VERB"
  ],
  "irritable": [
    "ADJ"
  ],
  "cunning": [
    "VERB"
  ],
  "divider": [
    "ADV"
  ],
  "cortez": [
    "NOUN"
  ],
  "associative": [
    "ADJ"
  ],
  "giraffe": [
    "PROPN"
  ],
  "hemorrhage": [
    "NOUN"
  ],
  "awning": [
    "ADJ"
  ],
  "ointment": [
    "ADJ"
  ],
  "stroud": [
    "PROPN"
  ],
  "tripping": [
    "VERB"
  ],
  "azimuth": [
    "PROPN"
  ],
  "logistical": [
    "ADJ"
  ],
  "occidental": [
    "NOUN"
  ],
  "vigor": [
    "VERB"
  ],
  "chariot": [
    "NOUN"
  ],
  "geraldine": [
    "NOUN"
  ],
  "matrimonial": [
    "NOUN"
  ],
  "tween": [
    "NOUN"
  ],
  "hydraulics": [
    "NOUN"
  ],
  "masthead": [
    "PROPN"
  ],
  "ursula": [
    "NOUN"
  ],
  "boucher": [
    "ADJ"
  ],
  "candidacy": [
    "NOUN"
  ],
  "hypnotic": [
    "ADJ"
  ],
  "adultery": [
    "NOUN"
  ],
  "quantification": [
    "NOUN"
  ],
  "coolant": [
    "NOUN"
  ],
  "seventeenth": [
    "X"
  ],
  "nanaimo": [
    "PROPN"
  ],
  "temperament": [
    "NOUN"
  ],
  "shamrock": [
    "NOUN"
  ],
  "healer": [
    "PROPN"
  ],
  "circulate": [
    "VERB"
  ],
  "glued": [
    "VERB"
  ],
  "sycamore": [
    "NOUN"
  ],
  "belinda": [
    "PROPN"
  ],
  "albright": [
    "ADJ"
  ],
  "tenderness": [
    "NOUN"
  ],
  "ocular": [
    "ADJ"
  ],
  "sandman": [
    "NOUN"
  ],
  "smelling": [
    "VERB"
  ],
  "conclusive": [
    "VERB"
  ],
  "alder": [
    "PROPN"
  ],
  "polluted": [
    "VERB"
  ],
  "airbrush": [
    "NOUN"
  ],
  "lullaby": [
    "PROPN"
  ],
  "trucker": [
    "NOUN"
  ],
  "choking": [
    "VERB"
  ],
  "castor": [
    "NOUN"
  ],
  "plentiful": [
    "ADJ"
  ],
  "massively": [
    "ADV"
  ],
  "stately": [
    "ADJ"
  ],
  "aeronautical": [
    "ADJ"
  ],
  "deuce": [
    "VERB"
  ],
  "exhibitionism": [
    "NOUN"
  ],
  "riser": [
    "NOUN"
  ],
  "redux": [
    "PROPN"
  ],
  "compensatory": [
    "ADJ"
  ],
  "cleric": [
    "NOUN"
  ],
  "individuality": [
    "NOUN"
  ],
  "californian": [
    "NOUN"
  ],
  "brownie": [
    "PROPN"
  ],
  "quits": [
    "VERB"
  ],
  "ensign": [
    "VERB"
  ],
  "restraining": [
    "VERB"
  ],
  "charismatic": [
    "PROPN"
  ],
  "blockade": [
    "NOUN"
  ],
  "burglar": [
    "ADJ"
  ],
  "asymmetry": [
    "NOUN"
  ],
  "warped": [
    "VERB"
  ],
  "hamiltonian": [
    "NOUN"
  ],
  "quotient": [
    "NOUN"
  ],
  "knoll": [
    "NOUN"
  ],
  "wildcat": [
    "PROPN"
  ],
  "thinning": [
    "VERB"
  ],
  "inlay": [
    "NOUN"
  ],
  "reddy": [
    "NOUN"
  ],
  "primrose": [
    "VERB"
  ],
  "corduroy": [
    "VERB"
  ],
  "avocado": [
    "VERB"
  ],
  "torpedo": [
    "NOUN"
  ],
  "muffler": [
    "NOUN"
  ],
  "troublesome": [
    "ADJ"
  ],
  "eucharist": [
    "NOUN"
  ],
  "objectivity": [
    "NOUN"
  ],
  "massager": [
    "PROPN"
  ],
  "hereto": [
    "NOUN"
  ],
  "magnetism": [
    "NOUN"
  ],
  "inventive": [
    "VERB"
  ],
  "speculate": [
    "VERB"
  ],
  "clinician": [
    "NOUN"
  ],
  "craze": [
    "NOUN"
  ],
  "curacao": [
    "NOUN"
  ],
  "texan": [
    "ADJ"
  ],
  "chromosomal": [
    "ADJ"
  ],
  "provoke": [
    "VERB"
  ],
  "salesperson": [
    "PROPN"
  ],
  "superfamily": [
    "ADV"
  ],
  "accommodating": [
    "VERB"
  ],
  "calvary": [
    "NOUN"
  ],
  "banded": [
    "VERB"
  ],
  "deportation": [
    "NOUN"
  ],
  "hibernate": [
    "VERB"
  ],
  "sculptor": [
    "NOUN"
  ],
  "roper": [
    "NOUN"
  ],
  "cyclical": [
    "ADJ"
  ],
  "mechanically": [
    "ADV"
  ],
  "improvisation": [
    "PROPN"
  ],
  "profanity": [
    "NOUN"
  ],
  "rainer": [
    "NOUN"
  ],
  "playmate": [
    "PROPN"
  ],
  "covariance": [
    "NOUN"
  ],
  "bobble": [
    "NOUN"
  ],
  "seasoning": [
    "VERB"
  ],
  "airfield": [
    "NOUN"
  ],
  "adjourn": [
    "VERB"
  ],
  "citrine": [
    "NOUN"
  ],
  "neoplasm": [
    "NOUN"
  ],
  "volta": [
    "NOUN"
  ],
  "calumet": [
    "PROPN"
  ],
  "pellet": [
    "NOUN"
  ],
  "discern": [
    "NOUN"
  ],
  "inflow": [
    "NOUN"
  ],
  "lymphocyte": [
    "NOUN"
  ],
  "futile": [
    "PROPN"
  ],
  "animate": [
    "VERB"
  ],
  "totem": [
    "NOUN"
  ],
  "elliptic": [
    "ADJ"
  ],
  "agonist": [
    "NOUN"
  ],
  "experimentally": [
    "ADV"
  ],
  "hermione": [
    "NOUN"
  ],
  "indus": [
    "NOUN"
  ],
  "rethink": [
    "VERB"
  ],
  "affluent": [
    "ADJ"
  ],
  "lonesome": [
    "ADJ"
  ],
  "unconventional": [
    "ADJ"
  ],
  "determinant": [
    "ADJ"
  ],
  "reckoning": [
    "VERB"
  ],
  "fabian": [
    "PROPN"
  ],
  "concurrence": [
    "NOUN"
  ],
  "morpheus": [
    "PROPN"
  ],
  "carve": [
    "VERB"
  ],
  "muster": [
    "VERB"
  ],
  "heartfelt": [
    "VERB"
  ],
  "pertain": [
    "NOUN"
  ],
  "gideon": [
    "PROPN"
  ],
  "gauntlet": [
    "PROPN"
  ],
  "hitter": [
    "NOUN"
  ],
  "telluride": [
    "VERB"
  ],
  "apnea": [
    "VERB"
  ],
  "victorious": [
    "ADJ"
  ],
  "sylvan": [
    "PROPN"
  ],
  "crusader": [
    "NOUN"
  ],
  "unnatural": [
    "ADJ"
  ],
  "alphabetic": [
    "ADJ"
  ],
  "tailoring": [
    "VERB"
  ],
  "swish": [
    "PROPN"
  ],
  "aborted": [
    "VERB"
  ],
  "symphonic": [
    "PROPN"
  ],
  "asker": [
    "NOUN"
  ],
  "drumming": [
    "VERB"
  ],
  "modernity": [
    "NOUN"
  ],
  "abiding": [
    "VERB"
  ],
  "luscious": [
    "ADJ"
  ],
  "sighting": [
    "VERB"
  ],
  "relic": [
    "PROPN"
  ],
  "teton": [
    "PROPN"
  ],
  "slipper": [
    "NOUN"
  ],
  "ethos": [
    "NOUN"
  ],
  "solenoid": [
    "VERB"
  ],
  "argyle": [
    "PROPN"
  ],
  "cling": [
    "VERB"
  ],
  "underdog": [
    "VERB"
  ],
  "prophetic": [
    "ADJ"
  ],
  "commune": [
    "NOUN"
  ],
  "agatha": [
    "ADJ"
  ],
  "circumcision": [
    "NOUN"
  ],
  "neutrality": [
    "NOUN"
  ],
  "ovulation": [
    "NOUN"
  ],
  "snoring": [
    "VERB"
  ],
  "euthanasia": [
    "NOUN"
  ],
  "trembling": [
    "VERB"
  ],
  "unitarian": [
    "PROPN"
  ],
  "goldfish": [
    "PROPN"
  ],
  "delaying": [
    "VERB"
  ],
  "reconstruct": [
    "NOUN"
  ],
  "animator": [
    "NOUN"
  ],
  "barbra": [
    "PROPN"
  ],
  "toned": [
    "VERB"
  ],
  "irreversible": [
    "ADJ"
  ],
  "expiring": [
    "VERB"
  ],
  "mabel": [
    "VERB"
  ],
  "nudge": [
    "VERB",
    "NOUN"
  ],
  "seeming": [
    "VERB"
  ],
  "rosebud": [
    "NOUN"
  ],
  "hemoglobin": [
    "NOUN"
  ],
  "andromeda": [
    "PROPN"
  ],
  "sixteenth": [
    "ADJ"
  ],
  "origination": [
    "NOUN"
  ],
  "landowner": [
    "NOUN"
  ],
  "trampoline": [
    "VERB"
  ],
  "ramona": [
    "VERB"
  ],
  "brutality": [
    "NOUN"
  ],
  "fictitious": [
    "ADJ"
  ],
  "immortality": [
    "NOUN"
  ],
  "saffron": [
    "PROPN"
  ],
  "ragged": [
    "VERB"
  ],
  "peerless": [
    "VERB"
  ],
  "psychotic": [
    "ADJ"
  ],
  "improbable": [
    "ADJ"
  ],
  "ignite": [
    "VERB"
  ],
  "reiterated": [
    "VERB"
  ],
  "hornet": [
    "NOUN"
  ],
  "jesuit": [
    "NOUN"
  ],
  "atypical": [
    "ADJ"
  ],
  "excessively": [
    "ADV"
  ],
  "dispatcher": [
    "ADV"
  ],
  "devoid": [
    "ADJ"
  ],
  "extraordinarily": [
    "ADV"
  ],
  "parted": [
    "VERB"
  ],
  "skunk": [
    "NOUN"
  ],
  "placer": [
    "NOUN"
  ],
  "heaps": [
    "NOUN"
  ],
  "hydra": [
    "PROPN",
    "NOUN"
  ],
  "anvil": [
    "NOUN"
  ],
  "mandalay": [
    "NOUN"
  ],
  "blinking": [
    "VERB"
  ],
  "dishonest": [
    "VERB"
  ],
  "stalk": [
    "NOUN"
  ],
  "mailbag": [
    "PROPN"
  ],
  "inert": [
    "ADJ"
  ],
  "favorably": [
    "ADV"
  ],
  "vocation": [
    "NOUN"
  ],
  "cedric": [
    "ADJ"
  ],
  "postwar": [
    "ADJ"
  ],
  "barebone": [
    "ADJ"
  ],
  "thrombosis": [
    "NOUN"
  ],
  "smarty": [
    "NOUN"
  ],
  "eject": [
    "VERB"
  ],
  "rayon": [
    "VERB"
  ],
  "edwardian": [
    "PROPN"
  ],
  "foreigner": [
    "NOUN"
  ],
  "unfavorable": [
    "ADJ"
  ],
  "undergrad": [
    "NOUN"
  ],
  "mocha": [
    "PROPN"
  ],
  "anomalous": [
    "ADJ"
  ],
  "katharine": [
    "PROPN"
  ],
  "jitter": [
    "NOUN"
  ],
  "barter": [
    "NOUN"
  ],
  "supernova": [
    "PROPN"
  ],
  "rowley": [
    "NOUN"
  ],
  "feminization": [
    "NOUN"
  ],
  "frugal": [
    "PROPN"
  ],
  "extremist": [
    "NOUN"
  ],
  "starry": [
    "VERB"
  ],
  "consequent": [
    "NOUN"
  ],
  "danube": [
    "NOUN"
  ],
  "evasion": [
    "NOUN"
  ],
  "cohesive": [
    "ADJ"
  ],
  "caster": [
    "NOUN"
  ],
  "wicket": [
    "NOUN"
  ],
  "glycol": [
    "NOUN"
  ],
  "manicure": [
    "NOUN"
  ],
  "medial": [
    "ADJ"
  ],
  "lazarus": [
    "PROPN"
  ],
  "bloomsbury": [
    "PROPN"
  ],
  "misguided": [
    "VERB"
  ],
  "colossal": [
    "VERB"
  ],
  "conversational": [
    "ADJ",
    "PROPN"
  ],
  "blasted": [
    "VERB"
  ],
  "baskerville": [
    "PROPN"
  ],
  "shingles": [
    "NOUN"
  ],
  "screener": [
    "NOUN",
    "PROPN"
  ],
  "hanukkah": [
    "PROPN"
  ],
  "adsorption": [
    "NOUN"
  ],
  "cumbersome": [
    "ADJ"
  ],
  "internationalization": [
    "PROPN"
  ],
  "roasting": [
    "VERB"
  ],
  "pancake": [
    "VERB"
  ],
  "accrue": [
    "ADJ"
  ],
  "firth": [
    "NOUN"
  ],
  "consolation": [
    "NOUN"
  ],
  "frazer": [
    "NOUN"
  ],
  "outlay": [
    "NOUN"
  ],
  "airing": [
    "VERB"
  ],
  "looping": [
    "VERB"
  ],
  "undated": [
    "ADJ"
  ],
  "alternately": [
    "ADV"
  ],
  "technologically": [
    "ADV"
  ],
  "gracefully": [
    "ADV"
  ],
  "anaerobic": [
    "PROPN"
  ],
  "antagonist": [
    "NOUN"
  ],
  "exalted": [
    "VERB"
  ],
  "cadre": [
    "VERB"
  ],
  "tabloid": [
    "VERB"
  ],
  "jaeger": [
    "NOUN"
  ],
  "solubility": [
    "NOUN"
  ],
  "overthrow": [
    "VERB"
  ],
  "patiently": [
    "ADV"
  ],
  "cabot": [
    "PROPN"
  ],
  "hatcher": [
    "NOUN"
  ],
  "squat": [
    "NOUN"
  ],
  "electrolyte": [
    "VERB"
  ],
  "firestone": [
    "PROPN"
  ],
  "letterhead": [
    "VERB"
  ],
  "polypeptide": [
    "ADP"
  ],
  "illuminating": [
    "VERB"
  ],
  "artificially": [
    "ADV"
  ],
  "saucepan": [
    "PROPN"
  ],
  "martyr": [
    "NOUN"
  ],
  "hacienda": [
    "PROPN"
  ],
  "koran": [
    "PROPN"
  ],
  "zoned": [
    "VERB"
  ],
  "pizzeria": [
    "PROPN"
  ],
  "nitrous": [
    "ADJ"
  ],
  "tiara": [
    "VERB"
  ],
  "elegantly": [
    "ADV"
  ],
  "convertor": [
    "NOUN"
  ],
  "workable": [
    "ADJ"
  ],
  "skinned": [
    "VERB"
  ],
  "hives": [
    "VERB"
  ],
  "ordinate": [
    "VERB"
  ],
  "groundwork": [
    "VERB"
  ],
  "cyril": [
    "VERB"
  ],
  "seminal": [
    "ADJ"
  ],
  "resentment": [
    "NOUN"
  ],
  "relevancy": [
    "NOUN"
  ],
  "koala": [
    "PROPN"
  ],
  "discus": [
    "NOUN"
  ],
  "giftware": [
    "VERB"
  ],
  "manfred": [
    "VERB"
  ],
  "realistically": [
    "ADV"
  ],
  "polska": [
    "VERB"
  ],
  "gaping": [
    "VERB"
  ],
  "infringe": [
    "NOUN"
  ],
  "porta": [
    "PROPN"
  ],
  "laramie": [
    "NOUN"
  ],
  "mennonite": [
    "NOUN"
  ],
  "abrupt": [
    "ADJ"
  ],
  "fastener": [
    "NOUN"
  ],
  "gambler": [
    "NOUN"
  ],
  "dissection": [
    "NOUN"
  ],
  "categorization": [
    "NOUN"
  ],
  "nightingale": [
    "NOUN"
  ],
  "landau": [
    "NOUN"
  ],
  "contemplate": [
    "VERB"
  ],
  "cassie": [
    "NOUN"
  ],
  "symposia": [
    "PROPN"
  ],
  "colonization": [
    "NOUN"
  ],
  "crock": [
    "NOUN"
  ],
  "disagreed": [
    "VERB"
  ],
  "boldly": [
    "ADV"
  ],
  "narration": [
    "NOUN"
  ],
  "typography": [
    "NOUN",
    "PROPN"
  ],
  "unopened": [
    "ADJ"
  ],
  "brushing": [
    "VERB"
  ],
  "sacrament": [
    "NOUN"
  ],
  "eliminator": [
    "NOUN"
  ],
  "gazebo": [
    "PROPN"
  ],
  "shortening": [
    "VERB"
  ],
  "preprint": [
    "VERB"
  ],
  "cocker": [
    "NOUN"
  ],
  "marketable": [
    "ADJ"
  ],
  "presto": [
    "NOUN"
  ],
  "retry": [
    "NOUN",
    "VERB"
  ],
  "hiram": [
    "VERB"
  ],
  "implantation": [
    "NOUN"
  ],
  "detoxification": [
    "NOUN"
  ],
  "bowed": [
    "VERB"
  ],
  "whimsical": [
    "ADJ"
  ],
  "harden": [
    "VERB"
  ],
  "molten": [
    "VERB"
  ],
  "aureus": [
    "NOUN"
  ],
  "warmly": [
    "ADV"
  ],
  "penang": [
    "PROPN"
  ],
  "sporadic": [
    "ADJ"
  ],
  "eyebrow": [
    "VERB"
  ],
  "lessor": [
    "NOUN"
  ],
  "charlene": [
    "NOUN"
  ],
  "autistic": [
    "ADJ"
  ],
  "unnecessarily": [
    "ADV"
  ],
  "equalization": [
    "NOUN"
  ],
  "painless": [
    "ADJ"
  ],
  "annexation": [
    "NOUN"
  ],
  "hydroxy": [
    "NOUN"
  ],
  "dissatisfaction": [
    "NOUN"
  ],
  "applaud": [
    "PROPN"
  ],
  "abolish": [
    "VERB"
  ],
  "uneasy": [
    "ADJ"
  ],
  "shalom": [
    "NOUN"
  ],
  "khmer": [
    "PROPN"
  ],
  "recordable": [
    "ADJ"
  ],
  "dredging": [
    "VERB"
  ],
  "florian": [
    "PROPN"
  ],
  "extrusion": [
    "NOUN"
  ],
  "defamation": [
    "NOUN"
  ],
  "flank": [
    "PROPN"
  ],
  "theron": [
    "PROPN"
  ],
  "cartel": [
    "NOUN"
  ],
  "wiener": [
    "PROPN"
  ],
  "numerically": [
    "ADV"
  ],
  "perforated": [
    "VERB"
  ],
  "tamworth": [
    "NOUN"
  ],
  "sexton": [
    "PROPN"
  ],
  "postmaster": [
    "NOUN"
  ],
  "crackdown": [
    "NOUN"
  ],
  "mindful": [
    "ADJ"
  ],
  "hitherto": [
    "PROPN"
  ],
  "cysteine": [
    "NOUN"
  ],
  "responsibly": [
    "ADV"
  ],
  "downright": [
    "ADV"
  ],
  "fantasia": [
    "NOUN"
  ],
  "camisole": [
    "PROPN"
  ],
  "refractory": [
    "NOUN"
  ],
  "atoll": [
    "NOUN"
  ],
  "inexperienced": [
    "ADJ"
  ],
  "smother": [
    "VERB"
  ],
  "ironman": [
    "NOUN"
  ],
  "frosty": [
    "PROPN"
  ],
  "marmot": [
    "NOUN"
  ],
  "remand": [
    "NOUN"
  ],
  "spoof": [
    "NOUN"
  ],
  "moaning": [
    "VERB"
  ],
  "penicillin": [
    "NOUN"
  ],
  "amman": [
    "PROPN"
  ],
  "blight": [
    "VERB"
  ],
  "physique": [
    "NOUN"
  ],
  "maturation": [
    "NOUN"
  ],
  "internals": [
    "NOUN"
  ],
  "refractive": [
    "ADJ"
  ],
  "grader": [
    "NOUN"
  ],
  "contentious": [
    "ADJ"
  ],
  "cheering": [
    "VERB"
  ],
  "intercollegiate": [
    "VERB"
  ],
  "archibald": [
    "PROPN"
  ],
  "emancipation": [
    "PROPN"
  ],
  "duchess": [
    "NOUN"
  ],
  "commemorate": [
    "NOUN"
  ],
  "spout": [
    "NOUN"
  ],
  "perish": [
    "NOUN"
  ],
  "snapper": [
    "ADJ"
  ],
  "hefty": [
    "ADJ"
  ],
  "hoist": [
    "VERB"
  ],
  "narrower": [
    "ADJ"
  ],
  "captivity": [
    "NOUN"
  ],
  "peyton": [
    "PROPN"
  ],
  "shorthand": [
    "NOUN"
  ],
  "bravery": [
    "NOUN"
  ],
  "fergus": [
    "ADJ"
  ],
  "sincerity": [
    "NOUN"
  ],
  "hairless": [
    "NOUN"
  ],
  "lactation": [
    "NOUN"
  ],
  "offbeat": [
    "NOUN"
  ],
  "relish": [
    "VERB"
  ],
  "eviction": [
    "NOUN"
  ],
  "unchecked": [
    "ADJ"
  ],
  "regionally": [
    "ADV"
  ],
  "alfonso": [
    "PROPN"
  ],
  "contradict": [
    "VERB"
  ],
  "scarcity": [
    "NOUN"
  ],
  "filament": [
    "NOUN"
  ],
  "liturgical": [
    "ADJ"
  ],
  "celia": [
    "PROPN"
  ],
  "disguised": [
    "VERB"
  ],
  "exogenous": [
    "ADJ"
  ],
  "sault": [
    "VERB"
  ],
  "thrash": [
    "VERB"
  ],
  "antiquarian": [
    "PROPN"
  ],
  "fluency": [
    "NOUN"
  ],
  "uniting": [
    "VERB"
  ],
  "conceivable": [
    "ADJ"
  ],
  "agate": [
    "NOUN"
  ],
  "incline": [
    "VERB"
  ],
  "hartmann": [
    "VERB"
  ],
  "scorer": [
    "NOUN"
  ],
  "swami": [
    "PROPN"
  ],
  "soliciting": [
    "VERB"
  ],
  "thoroughbred": [
    "PROPN"
  ],
  "arlene": [
    "NOUN"
  ],
  "oneness": [
    "VERB"
  ],
  "climber": [
    "VERB"
  ],
  "recoverable": [
    "ADJ"
  ],
  "commonplace": [
    "NOUN"
  ],
  "intellectually": [
    "ADV"
  ],
  "cruces": [
    "NOUN"
  ],
  "himalayan": [
    "PROPN"
  ],
  "lactose": [
    "VERB"
  ],
  "competitively": [
    "ADV"
  ],
  "downfall": [
    "VERB"
  ],
  "nahum": [
    "PROPN"
  ],
  "vanish": [
    "VERB"
  ],
  "feral": [
    "ADJ"
  ],
  "neurosurgery": [
    "NOUN"
  ],
  "impatient": [
    "NOUN"
  ],
  "aforesaid": [
    "VERB"
  ],
  "truce": [
    "VERB"
  ],
  "parmesan": [
    "PROPN"
  ],
  "stairway": [
    "NOUN"
  ],
  "woodrow": [
    "VERB"
  ],
  "vertebrate": [
    "VERB"
  ],
  "physiotherapy": [
    "NOUN"
  ],
  "laird": [
    "PROPN"
  ],
  "multiplicity": [
    "NOUN"
  ],
  "objectively": [
    "ADV"
  ],
  "billabong": [
    "ADJ"
  ],
  "prepayment": [
    "NOUN"
  ],
  "anguish": [
    "PROPN"
  ],
  "petal": [
    "ADJ"
  ],
  "perfected": [
    "VERB"
  ],
  "handgun": [
    "NOUN"
  ],
  "clipped": [
    "VERB"
  ],
  "innovator": [
    "NOUN"
  ],
  "mitochondria": [
    "PROPN"
  ],
  "vijay": [
    "NOUN"
  ],
  "cervix": [
    "NOUN"
  ],
  "annoyance": [
    "NOUN"
  ],
  "grating": [
    "VERB"
  ],
  "elixir": [
    "NOUN"
  ],
  "sewerage": [
    "VERB"
  ],
  "guardianship": [
    "NOUN"
  ],
  "mantis": [
    "NOUN"
  ],
  "reverence": [
    "NOUN"
  ],
  "remodel": [
    "PROPN"
  ],
  "carpal": [
    "PROPN"
  ],
  "natalia": [
    "PROPN"
  ],
  "outweigh": [
    "VERB"
  ],
  "adventist": [
    "NOUN"
  ],
  "eggplant": [
    "NOUN"
  ],
  "bunting": [
    "VERB"
  ],
  "avenger": [
    "NOUN"
  ],
  "undocumented": [
    "ADJ"
  ],
  "waugh": [
    "VERB"
  ],
  "captivating": [
    "VERB"
  ],
  "centurion": [
    "NOUN"
  ],
  "propagate": [
    "VERB"
  ],
  "needham": [
    "PROPN"
  ],
  "slavic": [
    "PROPN"
  ],
  "nutritious": [
    "ADJ"
  ],
  "marguerite": [
    "PROPN"
  ],
  "pluck": [
    "VERB"
  ],
  "cautiously": [
    "ADV"
  ],
  "dressage": [
    "VERB"
  ],
  "phylogenetic": [
    "ADJ"
  ],
  "coercion": [
    "NOUN"
  ],
  "morbid": [
    "VERB"
  ],
  "refresher": [
    "NOUN"
  ],
  "picard": [
    "NOUN"
  ],
  "rubble": [
    "NOUN"
  ],
  "cheeky": [
    "ADJ"
  ],
  "agitation": [
    "NOUN"
  ],
  "proponent": [
    "NOUN"
  ],
  "truthful": [
    "ADJ"
  ],
  "woodpecker": [
    "NOUN"
  ],
  "piranha": [
    "NOUN"
  ],
  "uncompressed": [
    "ADJ"
  ],
  "pseudomonas": [
    "NOUN"
  ],
  "adder": [
    "PROPN"
  ],
  "weakening": [
    "VERB"
  ],
  "minimization": [
    "NOUN"
  ],
  "ascot": [
    "NOUN"
  ],
  "linearly": [
    "ADV"
  ],
  "genesee": [
    "PROPN"
  ],
  "poignant": [
    "NOUN"
  ],
  "punishable": [
    "ADJ"
  ],
  "waterman": [
    "NOUN"
  ],
  "uranus": [
    "ADJ"
  ],
  "multiplex": [
    "PROPN"
  ],
  "salient": [
    "NOUN"
  ],
  "bradbury": [
    "NOUN"
  ],
  "beehive": [
    "NOUN"
  ],
  "censor": [
    "NOUN"
  ],
  "discontinuity": [
    "NOUN"
  ],
  "semitic": [
    "ADJ"
  ],
  "enquirer": [
    "NOUN"
  ],
  "perverted": [
    "VERB"
  ],
  "downturn": [
    "VERB"
  ],
  "bordering": [
    "VERB"
  ],
  "fission": [
    "NOUN"
  ],
  "modulator": [
    "NOUN"
  ],
  "widowed": [
    "VERB"
  ],
  "tombstone": [
    "VERB"
  ],
  "choreography": [
    "NOUN"
  ],
  "killarney": [
    "NOUN"
  ],
  "lavish": [
    "ADJ"
  ],
  "brighten": [
    "VERB"
  ],
  "nepalese": [
    "ADJ"
  ],
  "communicable": [
    "NOUN"
  ],
  "enzymatic": [
    "ADJ"
  ],
  "melanogaster": [
    "VERB"
  ],
  "extravaganza": [
    "NOUN"
  ],
  "commandment": [
    "NOUN"
  ],
  "undetermined": [
    "ADJ"
  ],
  "horner": [
    "PROPN"
  ],
  "conceded": [
    "VERB"
  ],
  "circumference": [
    "NOUN"
  ],
  "postpone": [
    "VERB"
  ],
  "underestimate": [
    "VERB"
  ],
  "disproportionate": [
    "VERB"
  ],
  "pheasant": [
    "NOUN"
  ],
  "alonso": [
    "PROPN"
  ],
  "bally": [
    "ADV"
  ],
  "marrying": [
    "VERB"
  ],
  "exponentially": [
    "ADV"
  ],
  "chechen": [
    "PROPN"
  ],
  "outflow": [
    "NOUN"
  ],
  "scarab": [
    "NOUN"
  ],
  "weasel": [
    "NOUN"
  ],
  "biologically": [
    "ADV"
  ],
  "venerable": [
    "ADJ"
  ],
  "admirable": [
    "ADJ"
  ],
  "illuminate": [
    "VERB"
  ],
  "octane": [
    "VERB"
  ],
  "bulge": [
    "PROPN"
  ],
  "lucinda": [
    "NOUN"
  ],
  "brittle": [
    "VERB"
  ],
  "politely": [
    "ADV"
  ],
  "soapbox": [
    "PROPN"
  ],
  "watermelon": [
    "NOUN"
  ],
  "ingenious": [
    "ADJ"
  ],
  "elongation": [
    "NOUN"
  ],
  "obadiah": [
    "PROPN"
  ],
  "somatic": [
    "ADJ"
  ],
  "fetched": [
    "VERB",
    "ADJ"
  ],
  "alderman": [
    "PROPN"
  ],
  "slump": [
    "VERB"
  ],
  "hiatus": [
    "PROPN"
  ],
  "enrol": [
    "VERB"
  ],
  "upholstered": [
    "ADJ"
  ],
  "evangelist": [
    "NOUN"
  ],
  "louvre": [
    "ADV"
  ],
  "spurious": [
    "ADJ"
  ],
  "gloom": [
    "NOUN"
  ],
  "angelic": [
    "ADJ"
  ],
  "astrological": [
    "ADJ"
  ],
  "nobility": [
    "NOUN"
  ],
  "noncompliance": [
    "NOUN"
  ],
  "afternoons": [
    "NOUN"
  ],
  "wakes": [
    "NOUN"
  ],
  "ashore": [
    "ADV"
  ],
  "workman": [
    "NOUN"
  ],
  "swimmer": [
    "PROPN"
  ],
  "sitio": [
    "NOUN"
  ],
  "unload": [
    "NOUN"
  ],
  "linotype": [
    "NOUN"
  ],
  "marge": [
    "VERB"
  ],
  "seater": [
    "VERB"
  ],
  "deliverable": [
    "PROPN",
    "ADJ"
  ],
  "badness": [
    "ADV"
  ],
  "sanding": [
    "VERB"
  ],
  "miscarriage": [
    "NOUN"
  ],
  "vulgate": [
    "VERB"
  ],
  "aland": [
    "NOUN"
  ],
  "edema": [
    "NOUN"
  ],
  "confidently": [
    "ADV"
  ],
  "dispense": [
    "NOUN"
  ],
  "dangerously": [
    "ADV"
  ],
  "figaro": [
    "NOUN"
  ],
  "sadie": [
    "PROPN"
  ],
  "carotid": [
    "PROPN"
  ],
  "stink": [
    "VERB"
  ],
  "convent": [
    "NOUN"
  ],
  "childish": [
    "ADJ"
  ],
  "squish": [
    "PROPN"
  ],
  "priesthood": [
    "NOUN"
  ],
  "jagged": [
    "VERB"
  ],
  "dispersal": [
    "PROPN"
  ],
  "overt": [
    "NOUN"
  ],
  "snowflake": [
    "NOUN"
  ],
  "verbally": [
    "ADV"
  ],
  "squeak": [
    "NOUN"
  ],
  "sterilization": [
    "NOUN"
  ],
  "chenille": [
    "PROPN"
  ],
  "dehydration": [
    "NOUN"
  ],
  "haircut": [
    "VERB"
  ],
  "undeclared": [
    "ADJ"
  ],
  "incarceration": [
    "NOUN"
  ],
  "pronounce": [
    "NOUN"
  ],
  "incompleteness": [
    "VERB"
  ],
  "aquamarine": [
    "NOUN"
  ],
  "dearly": [
    "ADV"
  ],
  "suggestive": [
    "ADJ"
  ],
  "sedimentation": [
    "NOUN"
  ],
  "optometry": [
    "NOUN"
  ],
  "mobilize": [
    "VERB"
  ],
  "unbalanced": [
    "ADJ"
  ],
  "gypsum": [
    "VERB"
  ],
  "slime": [
    "NOUN"
  ],
  "baroness": [
    "NOUN"
  ],
  "winnings": [
    "NOUN"
  ],
  "imaginable": [
    "ADJ"
  ],
  "bromide": [
    "ADV"
  ],
  "leapfrog": [
    "NOUN"
  ],
  "thermoplastic": [
    "ADJ"
  ],
  "lament": [
    "NOUN"
  ],
  "gregor": [
    "PROPN"
  ],
  "predatory": [
    "NOUN"
  ],
  "descendant": [
    "NOUN"
  ],
  "disgust": [
    "VERB"
  ],
  "deterrent": [
    "NOUN"
  ],
  "banked": [
    "VERB"
  ],
  "rationality": [
    "NOUN"
  ],
  "dismal": [
    "ADJ"
  ],
  "cochin": [
    "NOUN"
  ],
  "prologue": [
    "VERB"
  ],
  "whaling": [
    "VERB"
  ],
  "garamond": [
    "ADV"
  ],
  "cirrus": [
    "NOUN"
  ],
  "kilometer": [
    "NOUN"
  ],
  "stumbling": [
    "VERB"
  ],
  "swung": [
    "PROPN"
  ],
  "waved": [
    "VERB"
  ],
  "hijack": [
    "VERB"
  ],
  "libel": [
    "NOUN"
  ],
  "ellipse": [
    "NOUN"
  ],
  "alarmed": [
    "VERB"
  ],
  "justine": [
    "PROPN"
  ],
  "fryer": [
    "NOUN"
  ],
  "eskimo": [
    "VERB"
  ],
  "boron": [
    "NOUN"
  ],
  "strapped": [
    "VERB"
  ],
  "bolivian": [
    "PROPN"
  ],
  "reluctantly": [
    "ADV"
  ],
  "woodwork": [
    "NOUN"
  ],
  "centrifugal": [
    "ADJ"
  ],
  "authorship": [
    "NOUN"
  ],
  "decidedly": [
    "ADV"
  ],
  "apathy": [
    "ADJ"
  ],
  "mercantile": [
    "NOUN"
  ],
  "peaked": [
    "VERB"
  ],
  "stronghold": [
    "VERB"
  ],
  "tetra": [
    "NOUN"
  ],
  "bearded": [
    "ADJ"
  ],
  "greasy": [
    "NOUN"
  ],
  "tactile": [
    "ADJ"
  ],
  "vowed": [
    "VERB"
  ],
  "cinematography": [
    "NOUN"
  ],
  "carnage": [
    "NOUN"
  ],
  "asher": [
    "PROPN"
  ],
  "skier": [
    "PRON"
  ],
  "storyteller": [
    "NOUN"
  ],
  "ingenuity": [
    "NOUN"
  ],
  "ischemia": [
    "NOUN"
  ],
  "bessie": [
    "VERB"
  ],
  "hibiscus": [
    "VERB"
  ],
  "somers": [
    "NOUN"
  ],
  "rattan": [
    "PROPN"
  ],
  "coroner": [
    "NOUN"
  ],
  "tiled": [
    "VERB"
  ],
  "selectivity": [
    "NOUN"
  ],
  "elaboration": [
    "NOUN"
  ],
  "hectic": [
    "ADJ"
  ],
  "raiser": [
    "NOUN"
  ],
  "sanger": [
    "PROPN"
  ],
  "periphery": [
    "NOUN"
  ],
  "convene": [
    "NOUN"
  ],
  "calmly": [
    "ADV"
  ],
  "horribly": [
    "ADV"
  ],
  "dilute": [
    "VERB"
  ],
  "contemplation": [
    "NOUN"
  ],
  "woodside": [
    "ADJ"
  ],
  "gaseous": [
    "ADJ"
  ],
  "afflicted": [
    "VERB"
  ],
  "gloomy": [
    "ADJ"
  ],
  "naturist": [
    "ADJ"
  ],
  "plethora": [
    "NOUN"
  ],
  "cabriolet": [
    "ADJ"
  ],
  "anthropological": [
    "PROPN"
  ],
  "buckeye": [
    "PROPN"
  ],
  "dollhouse": [
    "NOUN"
  ],
  "stereotype": [
    "NOUN"
  ],
  "escalade": [
    "NOUN"
  ],
  "breakaway": [
    "NOUN"
  ],
  "septuagint": [
    "VERB"
  ],
  "dinghy": [
    "NOUN"
  ],
  "melia": [
    "PROPN"
  ],
  "concurrency": [
    "NOUN"
  ],
  "plummer": [
    "PROPN"
  ],
  "talon": [
    "NOUN"
  ],
  "repellent": [
    "NOUN"
  ],
  "sorcery": [
    "NOUN"
  ],
  "abstain": [
    "VERB"
  ],
  "barring": [
    "VERB"
  ],
  "situational": [
    "ADJ"
  ],
  "chakra": [
    "PROPN"
  ],
  "habeas": [
    "NOUN"
  ],
  "inactivity": [
    "NOUN"
  ],
  "grassy": [
    "NOUN"
  ],
  "clumsy": [
    "ADJ"
  ],
  "columbian": [
    "PROPN"
  ],
  "emulsion": [
    "NOUN"
  ],
  "fielder": [
    "NOUN"
  ],
  "biosphere": [
    "ADV"
  ],
  "ollie": [
    "PROPN"
  ],
  "stint": [
    "VERB"
  ],
  "federalism": [
    "NOUN"
  ],
  "rousseau": [
    "NOUN"
  ],
  "sarcasm": [
    "NOUN"
  ],
  "colitis": [
    "NOUN"
  ],
  "unincorporated": [
    "VERB"
  ],
  "liang": [
    "PROPN"
  ],
  "cryogenic": [
    "ADJ"
  ],
  "homologous": [
    "ADJ"
  ],
  "uphill": [
    "ADJ"
  ],
  "maximus": [
    "PROPN"
  ],
  "symptomatic": [
    "ADJ"
  ],
  "warmed": [
    "VERB"
  ],
  "parable": [
    "ADJ"
  ],
  "bipartisan": [
    "ADJ"
  ],
  "rhodium": [
    "NOUN"
  ],
  "exchanger": [
    "ADJ"
  ],
  "preseason": [
    "NOUN"
  ],
  "bumble": [
    "ADJ"
  ],
  "deadlock": [
    "VERB"
  ],
  "placenta": [
    "PROPN"
  ],
  "sarcoma": [
    "PROPN"
  ],
  "sniffer": [
    "NOUN"
  ],
  "quadrangle": [
    "VERB"
  ],
  "eradicate": [
    "VERB"
  ],
  "tricia": [
    "PROPN"
  ],
  "likeness": [
    "VERB"
  ],
  "alpaca": [
    "PROPN"
  ],
  "degrade": [
    "VERB"
  ],
  "flemish": [
    "ADJ"
  ],
  "shred": [
    "VERB"
  ],
  "tented": [
    "VERB"
  ],
  "hollands": [
    "NOUN"
  ],
  "modernism": [
    "PROPN"
  ],
  "remittance": [
    "NOUN"
  ],
  "sieve": [
    "ADV"
  ],
  "alienation": [
    "NOUN"
  ],
  "reddish": [
    "PROPN"
  ],
  "binge": [
    "NOUN"
  ],
  "scissor": [
    "NOUN"
  ],
  "goliath": [
    "PROPN"
  ],
  "smyth": [
    "NOUN"
  ],
  "caprice": [
    "VERB"
  ],
  "horned": [
    "VERB"
  ],
  "jazzy": [
    "PROPN"
  ],
  "headboard": [
    "ADV"
  ],
  "janus": [
    "NOUN"
  ],
  "hester": [
    "NOUN"
  ],
  "benevolent": [
    "ADJ"
  ],
  "superstition": [
    "NOUN"
  ],
  "ecole": [
    "NOUN"
  ],
  "hysterectomy": [
    "VERB"
  ],
  "camilla": [
    "NOUN"
  ],
  "torsion": [
    "NOUN"
  ],
  "rarity": [
    "NOUN"
  ],
  "limbo": [
    "NOUN"
  ],
  "lucida": [
    "PROPN"
  ],
  "shove": [
    "VERB"
  ],
  "leftover": [
    "NOUN"
  ],
  "anecdotal": [
    "ADJ"
  ],
  "accusation": [
    "NOUN"
  ],
  "arboretum": [
    "NOUN"
  ],
  "flake": [
    "VERB"
  ],
  "ischemic": [
    "ADJ"
  ],
  "plugging": [
    "VERB"
  ],
  "mahmoud": [
    "PROPN"
  ],
  "arent": [
    "AUX"
  ],
  "vignette": [
    "NOUN"
  ],
  "shears": [
    "NOUN"
  ],
  "fireball": [
    "NOUN"
  ],
  "tabernacle": [
    "NOUN"
  ],
  "decorator": [
    "NOUN"
  ],
  "harmonious": [
    "ADJ"
  ],
  "westerly": [
    "ADV"
  ],
  "munitions": [
    "NOUN"
  ],
  "symmetrical": [
    "ADJ"
  ],
  "modality": [
    "NOUN"
  ],
  "ornate": [
    "VERB"
  ],
  "midwife": [
    "PROPN"
  ],
  "appellee": [
    "PROPN"
  ],
  "uniformed": [
    "VERB"
  ],
  "multidimensional": [
    "ADJ"
  ],
  "esophageal": [
    "ADJ"
  ],
  "moulded": [
    "VERB"
  ],
  "convict": [
    "PROPN"
  ],
  "albumin": [
    "VERB"
  ],
  "tossing": [
    "VERB"
  ],
  "regularity": [
    "NOUN"
  ],
  "lawfully": [
    "ADV"
  ],
  "slade": [
    "VERB"
  ],
  "potable": [
    "ADJ"
  ],
  "jester": [
    "X"
  ],
  "recount": [
    "NOUN"
  ],
  "mascara": [
    "PROPN"
  ],
  "proline": [
    "NOUN"
  ],
  "snoopy": [
    "VERB"
  ],
  "commensurate": [
    "VERB"
  ],
  "schiller": [
    "NOUN"
  ],
  "bowler": [
    "NOUN"
  ],
  "unleash": [
    "VERB",
    "PROPN"
  ],
  "wiser": [
    "PROPN"
  ],
  "gallant": [
    "NOUN"
  ],
  "disbelief": [
    "NOUN"
  ],
  "baritone": [
    "NOUN"
  ],
  "unqualified": [
    "ADJ"
  ],
  "recollection": [
    "NOUN"
  ],
  "relativistic": [
    "ADJ"
  ],
  "fastening": [
    "VERB"
  ],
  "jeweler": [
    "NOUN"
  ],
  "subliminal": [
    "ADJ"
  ],
  "insecticide": [
    "ADV"
  ],
  "ostrich": [
    "NOUN"
  ],
  "spline": [
    "PROPN"
  ],
  "undisclosed": [
    "ADJ"
  ],
  "flirting": [
    "VERB"
  ],
  "malayalam": [
    "PROPN"
  ],
  "discriminating": [
    "VERB"
  ],
  "exclamation": [
    "NOUN"
  ],
  "terrence": [
    "NOUN"
  ],
  "ascendant": [
    "ADJ"
  ],
  "flung": [
    "VERB"
  ],
  "probationary": [
    "ADJ"
  ],
  "warlock": [
    "NOUN"
  ],
  "breakup": [
    "NOUN"
  ],
  "fiche": [
    "PROPN"
  ],
  "juror": [
    "NOUN"
  ],
  "goggle": [
    "VERB"
  ],
  "railing": [
    "VERB"
  ],
  "cremation": [
    "NOUN"
  ],
  "banter": [
    "NOUN"
  ],
  "awaken": [
    "VERB"
  ],
  "bateman": [
    "NOUN"
  ],
  "coffeehouse": [
    "NOUN"
  ],
  "singularity": [
    "NOUN"
  ],
  "signify": [
    "VERB"
  ],
  "granddaughter": [
    "NOUN"
  ],
  "trolling": [
    "VERB"
  ],
  "progeny": [
    "VERB"
  ],
  "gratefully": [
    "ADV"
  ],
  "divergent": [
    "ADJ"
  ],
  "dorian": [
    "PROPN"
  ],
  "libido": [
    "NOUN"
  ],
  "fuselage": [
    "NOUN"
  ],
  "tackled": [
    "VERB"
  ],
  "ballerina": [
    "PROPN"
  ],
  "tributary": [
    "NOUN"
  ],
  "clique": [
    "PROPN"
  ],
  "satanic": [
    "ADJ"
  ],
  "torment": [
    "VERB"
  ],
  "emigration": [
    "NOUN"
  ],
  "conscientious": [
    "ADJ"
  ],
  "ecclesiastical": [
    "ADJ"
  ],
  "belvedere": [
    "ADV"
  ],
  "hilltop": [
    "VERB"
  ],
  "tabor": [
    "PROPN"
  ],
  "tenet": [
    "NOUN"
  ],
  "acetyl": [
    "VERB"
  ],
  "boomer": [
    "NOUN"
  ],
  "fifteenth": [
    "NOUN"
  ],
  "chute": [
    "VERB"
  ],
  "bohemia": [
    "NOUN"
  ],
  "daredevil": [
    "NOUN"
  ],
  "mountainous": [
    "ADJ"
  ],
  "unforeseen": [
    "ADJ"
  ],
  "submissive": [
    "PROPN"
  ],
  "mulch": [
    "PROPN"
  ],
  "stampede": [
    "VERB"
  ],
  "whine": [
    "VERB"
  ],
  "streptococcus": [
    "NOUN"
  ],
  "fatality": [
    "NOUN"
  ],
  "looming": [
    "VERB"
  ],
  "prepay": [
    "NOUN"
  ],
  "nonresident": [
    "ADJ"
  ],
  "soulful": [
    "ADJ"
  ],
  "squeezing": [
    "VERB"
  ],
  "serendipity": [
    "NOUN"
  ],
  "follower": [
    "NOUN"
  ],
  "sequentially": [
    "ADV"
  ],
  "landslide": [
    "NOUN"
  ],
  "alumina": [
    "PROPN"
  ],
  "degenerate": [
    "VERB"
  ],
  "spiked": [
    "VERB"
  ],
  "misrepresentation": [
    "NOUN"
  ],
  "iberia": [
    "PROPN"
  ],
  "duffel": [
    "VERB"
  ],
  "strung": [
    "VERB"
  ],
  "subfamily": [
    "ADV"
  ],
  "chanting": [
    "VERB"
  ],
  "wrestler": [
    "NOUN"
  ],
  "hermit": [
    "VERB"
  ],
  "matchmaker": [
    "PROPN"
  ],
  "sagittarius": [
    "NOUN"
  ],
  "bulletproof": [
    "PROPN"
  ],
  "josiah": [
    "PROPN"
  ],
  "deepen": [
    "VERB"
  ],
  "stenosis": [
    "NOUN"
  ],
  "acadia": [
    "PROPN"
  ],
  "abrasion": [
    "NOUN"
  ],
  "valentin": [
    "PROPN"
  ],
  "reciprocity": [
    "NOUN"
  ],
  "opportunistic": [
    "ADJ"
  ],
  "crease": [
    "NOUN"
  ],
  "cantor": [
    "NOUN"
  ],
  "econometric": [
    "ADJ"
  ],
  "bartholomew": [
    "NOUN"
  ],
  "perseverance": [
    "NOUN"
  ],
  "pharmacological": [
    "VERB"
  ],
  "headwear": [
    "ADJ"
  ],
  "genitals": [
    "NOUN"
  ],
  "impede": [
    "VERB"
  ],
  "academically": [
    "ADV"
  ],
  "vicar": [
    "NOUN"
  ],
  "prank": [
    "VERB"
  ],
  "repent": [
    "NOUN"
  ],
  "agreeable": [
    "NOUN"
  ],
  "centrum": [
    "VERB"
  ],
  "pulpit": [
    "NOUN"
  ],
  "corrosive": [
    "ADJ"
  ],
  "ambush": [
    "NOUN"
  ],
  "franciscan": [
    "PROPN"
  ],
  "heparin": [
    "NOUN"
  ],
  "figurative": [
    "ADJ"
  ],
  "connective": [
    "ADJ"
  ],
  "bonfire": [
    "NOUN"
  ],
  "aversion": [
    "NOUN"
  ],
  "dunlap": [
    "NOUN"
  ],
  "biophysics": [
    "NOUN"
  ],
  "chromatin": [
    "NOUN"
  ],
  "roxanne": [
    "NOUN"
  ],
  "chauffeur": [
    "NOUN"
  ],
  "wasteland": [
    "NOUN"
  ],
  "elicit": [
    "ADJ"
  ],
  "plotter": [
    "NOUN"
  ],
  "henrietta": [
    "NOUN"
  ],
  "bitten": [
    "VERB"
  ],
  "cymraeg": [
    "PROPN"
  ],
  "doodle": [
    "VERB"
  ],
  "martyn": [
    "NOUN"
  ],
  "dynamo": [
    "PROPN",
    "NOUN"
  ],
  "chronologically": [
    "ADV"
  ],
  "summon": [
    "NOUN"
  ],
  "parchment": [
    "NOUN"
  ],
  "lingua": [
    "PRON"
  ],
  "stacker": [
    "NOUN"
  ],
  "forfeit": [
    "PROPN"
  ],
  "unpopular": [
    "ADJ"
  ],
  "retainer": [
    "PROPN"
  ],
  "hardening": [
    "VERB"
  ],
  "loosen": [
    "VERB"
  ],
  "beowulf": [
    "PROPN"
  ],
  "sneaky": [
    "ADJ"
  ],
  "undiscovered": [
    "ADJ"
  ],
  "spatially": [
    "ADV"
  ],
  "delft": [
    "NOUN"
  ],
  "marginally": [
    "ADV"
  ],
  "communicative": [
    "ADJ"
  ],
  "grieving": [
    "VERB"
  ],
  "chastity": [
    "NOUN"
  ],
  "carney": [
    "NOUN"
  ],
  "faust": [
    "VERB"
  ],
  "fright": [
    "ADV"
  ],
  "obnoxious": [
    "ADJ"
  ],
  "diligently": [
    "ADV"
  ],
  "surfaced": [
    "VERB"
  ],
  "mortimer": [
    "NOUN"
  ],
  "easing": [
    "VERB"
  ],
  "picket": [
    "NOUN"
  ],
  "emilia": [
    "NOUN"
  ],
  "maturing": [
    "VERB"
  ],
  "margarine": [
    "VERB"
  ],
  "illogical": [
    "ADJ"
  ],
  "suing": [
    "VERB"
  ],
  "brine": [
    "NOUN"
  ],
  "sneaker": [
    "PROPN"
  ],
  "waning": [
    "VERB"
  ],
  "cartwright": [
    "ADV"
  ],
  "glycoprotein": [
    "VERB"
  ],
  "armoire": [
    "NOUN"
  ],
  "hydroxide": [
    "ADV"
  ],
  "piled": [
    "VERB"
  ],
  "twinkle": [
    "NOUN"
  ],
  "lodgings": [
    "NOUN"
  ],
  "fluff": [
    "NOUN"
  ],
  "shifter": [
    "ADJ"
  ],
  "cartography": [
    "NOUN"
  ],
  "supple": [
    "NOUN"
  ],
  "unfit": [
    "ADJ"
  ],
  "rumanian": [
    "PROPN"
  ],
  "nickelodeon": [
    "NOUN"
  ],
  "tending": [
    "VERB"
  ],
  "shaggy": [
    "PROPN"
  ],
  "elongated": [
    "VERB"
  ],
  "ordeal": [
    "NOUN"
  ],
  "astronomer": [
    "NOUN"
  ],
  "hernia": [
    "PROPN"
  ],
  "incompetence": [
    "NOUN"
  ],
  "flicker": [
    "PROPN"
  ],
  "relieving": [
    "VERB"
  ],
  "towering": [
    "VERB"
  ],
  "beastie": [
    "PROPN"
  ],
  "rouse": [
    "NOUN"
  ],
  "yucca": [
    "VERB"
  ],
  "harvester": [
    "NOUN"
  ],
  "emmett": [
    "PROPN"
  ],
  "spiel": [
    "VERB"
  ],
  "stemming": [
    "VERB"
  ],
  "obstructive": [
    "ADJ"
  ],
  "tentatively": [
    "ADV"
  ],
  "interlude": [
    "VERB"
  ],
  "retroactive": [
    "VERB"
  ],
  "carcass": [
    "NOUN"
  ],
  "atherosclerosis": [
    "NOUN"
  ],
  "casually": [
    "ADV"
  ],
  "scamp": [
    "NOUN"
  ],
  "demography": [
    "NOUN"
  ],
  "freedman": [
    "NOUN"
  ],
  "reprise": [
    "NOUN"
  ],
  "populate": [
    "VERB",
    "PROPN"
  ],
  "arcane": [
    "ADJ"
  ],
  "impractical": [
    "ADJ"
  ],
  "decentralization": [
    "NOUN"
  ],
  "authoritarian": [
    "PROPN"
  ],
  "judaica": [
    "PROPN"
  ],
  "cardholder": [
    "VERB"
  ],
  "peavey": [
    "NOUN"
  ],
  "quicksilver": [
    "ADV"
  ],
  "sacked": [
    "VERB"
  ],
  "effortlessly": [
    "ADV"
  ],
  "stipend": [
    "NOUN"
  ],
  "snorkel": [
    "NOUN"
  ],
  "iridium": [
    "NOUN"
  ],
  "amulet": [
    "NOUN"
  ],
  "informally": [
    "ADV"
  ],
  "alternator": [
    "NOUN"
  ],
  "underwriter": [
    "NOUN"
  ],
  "panhandle": [
    "NOUN"
  ],
  "sarcastic": [
    "ADJ"
  ],
  "indemnification": [
    "NOUN"
  ],
  "bombed": [
    "VERB"
  ],
  "complexion": [
    "NOUN"
  ],
  "informant": [
    "VERB"
  ],
  "aegean": [
    "ADJ"
  ],
  "sluggish": [
    "PROPN"
  ],
  "sherpa": [
    "VERB"
  ],
  "sorghum": [
    "NOUN"
  ],
  "grouse": [
    "VERB"
  ],
  "reginald": [
    "NOUN"
  ],
  "pasted": [
    "VERB"
  ],
  "evoke": [
    "NOUN"
  ],
  "slotted": [
    "VERB"
  ],
  "decking": [
    "VERB"
  ],
  "amorphous": [
    "ADJ"
  ],
  "hideaway": [
    "PROPN"
  ],
  "dwayne": [
    "PROPN"
  ],
  "cyanide": [
    "NOUN"
  ],
  "assam": [
    "ADV"
  ],
  "marek": [
    "NOUN"
  ],
  "interlibrary": [
    "ADJ"
  ],
  "mousse": [
    "NOUN"
  ],
  "provenance": [
    "NOUN"
  ],
  "shameful": [
    "ADJ"
  ],
  "chiffon": [
    "NOUN"
  ],
  "fanfare": [
    "VERB"
  ],
  "mapper": [
    "NOUN",
    "PROPN"
  ],
  "boyce": [
    "NOUN"
  ],
  "dystrophy": [
    "NOUN"
  ],
  "archaic": [
    "ADJ"
  ],
  "elevate": [
    "PROPN",
    "VERB"
  ],
  "deafness": [
    "NOUN"
  ],
  "laureate": [
    "NOUN"
  ],
  "syphilis": [
    "ADJ"
  ],
  "vigilance": [
    "NOUN"
  ],
  "appalling": [
    "ADJ"
  ],
  "palmyra": [
    "VERB"
  ],
  "ticking": [
    "VERB"
  ],
  "pantheon": [
    "NOUN"
  ],
  "gully": [
    "ADV"
  ],
  "epithelium": [
    "VERB"
  ],
  "bitterness": [
    "NOUN"
  ],
  "brill": [
    "VERB"
  ],
  "webbing": [
    "VERB"
  ],
  "lovingly": [
    "ADV"
  ],
  "thrush": [
    "NOUN"
  ],
  "bribery": [
    "NOUN"
  ],
  "untested": [
    "ADJ"
  ],
  "ascend": [
    "VERB"
  ],
  "hearst": [
    "ADV"
  ],
  "reverb": [
    "VERB"
  ],
  "nutmeg": [
    "NOUN"
  ],
  "chained": [
    "VERB"
  ],
  "magnify": [
    "VERB"
  ],
  "gauss": [
    "PROPN"
  ],
  "precautionary": [
    "ADJ"
  ],
  "artistry": [
    "NOUN"
  ],
  "travail": [
    "NOUN"
  ],
  "fiddler": [
    "NOUN"
  ],
  "wholesome": [
    "ADJ"
  ],
  "rubric": [
    "PROPN",
    "NOUN"
  ],
  "operand": [
    "VERB"
  ],
  "puddle": [
    "NOUN"
  ],
  "kristi": [
    "PROPN"
  ],
  "vegetative": [
    "ADJ"
  ],
  "agora": [
    "PROPN"
  ],
  "reeve": [
    "VERB"
  ],
  "willful": [
    "ADJ"
  ],
  "grandeur": [
    "PROPN"
  ],
  "plough": [
    "NOUN"
  ],
  "staphylococcus": [
    "NOUN"
  ],
  "whereabouts": [
    "NOUN"
  ],
  "smelly": [
    "ADV"
  ],
  "bounding": [
    "VERB"
  ],
  "hangar": [
    "NOUN"
  ],
  "ephemera": [
    "NOUN"
  ],
  "umpire": [
    "NOUN"
  ],
  "testicular": [
    "ADJ"
  ],
  "orthodoxy": [
    "PROPN"
  ],
  "doubtless": [
    "NOUN"
  ],
  "wearable": [
    "ADJ"
  ],
  "carling": [
    "VERB"
  ],
  "buildup": [
    "PROPN"
  ],
  "weaponry": [
    "NOUN"
  ],
  "keyed": [
    "VERB"
  ],
  "esquire": [
    "NOUN"
  ],
  "cryptic": [
    "ADJ"
  ],
  "primus": [
    "NOUN"
  ],
  "landline": [
    "VERB"
  ],
  "wherefore": [
    "ADV"
  ],
  "corpora": [
    "PROPN"
  ],
  "cholera": [
    "NOUN"
  ],
  "antiviral": [
    "ADJ"
  ],
  "midsummer": [
    "ADJ"
  ],
  "profiler": [
    "NOUN"
  ],
  "intoxicated": [
    "VERB"
  ],
  "minimalist": [
    "NOUN"
  ],
  "mysore": [
    "VERB"
  ],
  "protagonist": [
    "NOUN"
  ],
  "darius": [
    "NOUN"
  ],
  "bullion": [
    "NOUN"
  ],
  "deflection": [
    "NOUN"
  ],
  "hateful": [
    "ADJ"
  ],
  "propensity": [
    "NOUN"
  ],
  "journalistic": [
    "ADJ"
  ],
  "kingfisher": [
    "NOUN"
  ],
  "moline": [
    "NOUN"
  ],
  "hiroyuki": [
    "PROPN"
  ],
  "walleye": [
    "PROPN"
  ],
  "bagel": [
    "PROPN"
  ],
  "stratum": [
    "VERB"
  ],
  "vendetta": [
    "ADP"
  ],
  "restrain": [
    "VERB"
  ],
  "walkway": [
    "NOUN"
  ],
  "amaze": [
    "VERB"
  ],
  "petrochemical": [
    "VERB"
  ],
  "rembrandt": [
    "ADV"
  ],
  "estado": [
    "ADJ"
  ],
  "easel": [
    "NOUN"
  ],
  "carer": [
    "NOUN"
  ],
  "humankind": [
    "VERB"
  ],
  "potion": [
    "NOUN"
  ],
  "ovation": [
    "NOUN"
  ],
  "paddock": [
    "NOUN"
  ],
  "gable": [
    "ADJ"
  ],
  "johnnie": [
    "PROPN"
  ],
  "thirteenth": [
    "NOUN"
  ],
  "laced": [
    "VERB"
  ],
  "quill": [
    "NOUN"
  ],
  "zucchini": [
    "NOUN"
  ],
  "enthusiastically": [
    "ADV"
  ],
  "fetching": [
    "VERB",
    "NOUN"
  ],
  "chaps": [
    "NOUN"
  ],
  "tendon": [
    "PROPN"
  ],
  "chiral": [
    "ADJ"
  ],
  "newsreader": [
    "ADP"
  ],
  "bellows": [
    "VERB"
  ],
  "cuddly": [
    "ADV"
  ],
  "deceit": [
    "NOUN"
  ],
  "unmarked": [
    "VERB"
  ],
  "joyous": [
    "ADJ"
  ],
  "shekel": [
    "NOUN"
  ],
  "diocesan": [
    "PROPN"
  ],
  "gunner": [
    "PROPN"
  ],
  "verso": [
    "VERB"
  ],
  "samoan": [
    "PROPN"
  ],
  "absorbent": [
    "VERB"
  ],
  "grossly": [
    "ADV"
  ],
  "cranky": [
    "ADJ"
  ],
  "cleft": [
    "NOUN"
  ],
  "merida": [
    "PROPN"
  ],
  "interceptor": [
    "NOUN"
  ],
  "banding": [
    "VERB"
  ],
  "umbilical": [
    "ADJ"
  ],
  "foursome": [
    "ADJ"
  ],
  "lucknow": [
    "VERB"
  ],
  "bleaching": [
    "VERB"
  ],
  "isolde": [
    "PROPN"
  ],
  "mathematician": [
    "PROPN"
  ],
  "untrue": [
    "ADJ"
  ],
  "algonquin": [
    "PROPN"
  ],
  "hurried": [
    "VERB"
  ],
  "disqualification": [
    "NOUN"
  ],
  "spitfire": [
    "NOUN"
  ],
  "summation": [
    "NOUN"
  ],
  "querying": [
    "VERB"
  ],
  "autonomic": [
    "PROPN"
  ],
  "fingered": [
    "VERB"
  ],
  "manatee": [
    "NOUN"
  ],
  "larval": [
    "NOUN"
  ],
  "resettlement": [
    "NOUN"
  ],
  "mistakenly": [
    "ADV"
  ],
  "radiative": [
    "VERB"
  ],
  "intimately": [
    "ADV"
  ],
  "groin": [
    "NOUN"
  ],
  "booted": [
    "VERB"
  ],
  "allie": [
    "NOUN"
  ],
  "algerian": [
    "PROPN"
  ],
  "electrics": [
    "NOUN"
  ],
  "bower": [
    "NOUN"
  ],
  "extremity": [
    "NOUN"
  ],
  "prudence": [
    "NOUN"
  ],
  "hypnotherapy": [
    "NOUN"
  ],
  "gingerbread": [
    "VERB"
  ],
  "tasteful": [
    "ADJ"
  ],
  "puritan": [
    "PROPN"
  ],
  "osiris": [
    "PROPN"
  ],
  "pieter": [
    "NOUN"
  ],
  "forearm": [
    "VERB"
  ],
  "distract": [
    "NOUN"
  ],
  "seaport": [
    "NOUN"
  ],
  "longs": [
    "NOUN"
  ],
  "classifier": [
    "PROPN"
  ],
  "deceive": [
    "VERB"
  ],
  "colonialism": [
    "NOUN"
  ],
  "starved": [
    "VERB"
  ],
  "colosseum": [
    "NOUN"
  ],
  "stipulation": [
    "NOUN"
  ],
  "emptiness": [
    "VERB"
  ],
  "neuropathy": [
    "ADJ"
  ],
  "shoemaker": [
    "NOUN"
  ],
  "cushioned": [
    "VERB"
  ],
  "hastily": [
    "ADV"
  ],
  "invader": [
    "PROPN"
  ],
  "patriarch": [
    "NOUN"
  ],
  "conjugated": [
    "VERB"
  ],
  "unethical": [
    "ADJ"
  ],
  "polynesian": [
    "NOUN"
  ],
  "swain": [
    "PROPN"
  ],
  "grumpy": [
    "ADJ"
  ],
  "mourn": [
    "VERB"
  ],
  "benelux": [
    "ADJ"
  ],
  "soften": [
    "VERB"
  ],
  "troupe": [
    "NOUN"
  ],
  "blacksmith": [
    "ADP"
  ],
  "coagulation": [
    "NOUN"
  ],
  "girly": [
    "ADV"
  ],
  "powerfully": [
    "ADV"
  ],
  "archdiocese": [
    "ADJ"
  ],
  "thirdly": [
    "ADV"
  ],
  "deepening": [
    "VERB"
  ],
  "keyless": [
    "PROPN"
  ],
  "repatriation": [
    "NOUN"
  ],
  "tortilla": [
    "NOUN"
  ],
  "dissociation": [
    "NOUN"
  ],
  "unfairly": [
    "ADV"
  ],
  "calico": [
    "PROPN"
  ],
  "bottleneck": [
    "NOUN"
  ],
  "undermining": [
    "VERB"
  ],
  "burnside": [
    "VERB"
  ],
  "colossus": [
    "NOUN"
  ],
  "bodywork": [
    "NOUN"
  ],
  "applique": [
    "ADJ"
  ],
  "frivolous": [
    "ADJ"
  ],
  "indecent": [
    "NOUN"
  ],
  "oiled": [
    "VERB"
  ],
  "sharpen": [
    "VERB"
  ],
  "goalkeeper": [
    "NOUN"
  ],
  "phonetic": [
    "ADJ"
  ],
  "blurb": [
    "NOUN",
    "PROPN"
  ],
  "oppressive": [
    "ADJ"
  ],
  "boomerang": [
    "VERB"
  ],
  "structurally": [
    "ADV"
  ],
  "moray": [
    "NOUN"
  ],
  "simeon": [
    "PROPN"
  ],
  "onslaught": [
    "NOUN"
  ],
  "birdie": [
    "PROPN"
  ],
  "lanyard": [
    "PROPN"
  ],
  "horst": [
    "ADV"
  ],
  "interlock": [
    "NOUN"
  ],
  "sharpness": [
    "NOUN"
  ],
  "esophagus": [
    "ADJ"
  ],
  "corral": [
    "PROPN"
  ],
  "fortnight": [
    "NOUN"
  ],
  "hickey": [
    "PROPN"
  ],
  "erode": [
    "VERB"
  ],
  "unlicensed": [
    "ADJ"
  ],
  "defiant": [
    "ADJ"
  ],
  "termite": [
    "VERB"
  ],
  "drugstore": [
    "NOUN"
  ],
  "brisk": [
    "ADJ"
  ],
  "audiology": [
    "NOUN"
  ],
  "lysine": [
    "NOUN"
  ],
  "sizzling": [
    "VERB"
  ],
  "thule": [
    "VERB"
  ],
  "ponce": [
    "NOUN"
  ],
  "perjury": [
    "NOUN"
  ],
  "kaleidoscope": [
    "VERB"
  ],
  "generality": [
    "NOUN"
  ],
  "absorber": [
    "VERB"
  ],
  "vigilant": [
    "ADJ"
  ],
  "pronto": [
    "ADP"
  ],
  "imager": [
    "ADV"
  ],
  "eerie": [
    "VERB"
  ],
  "sailboat": [
    "NOUN"
  ],
  "hectare": [
    "NOUN"
  ],
  "netball": [
    "NOUN"
  ],
  "holographic": [
    "ADJ"
  ],
  "stonewall": [
    "ADJ"
  ],
  "salaam": [
    "PROPN"
  ],
  "respirator": [
    "NOUN"
  ],
  "geometrical": [
    "ADJ"
  ],
  "crispy": [
    "NOUN"
  ],
  "priory": [
    "NOUN"
  ],
  "sequin": [
    "PROPN"
  ],
  "epsom": [
    "VERB"
  ],
  "bronchitis": [
    "VERB"
  ],
  "polymerization": [
    "NOUN"
  ],
  "therese": [
    "NOUN"
  ],
  "whirlwind": [
    "NOUN"
  ],
  "howling": [
    "VERB"
  ],
  "apprehension": [
    "NOUN"
  ],
  "unbelievably": [
    "ADV"
  ],
  "pasting": [
    "VERB"
  ],
  "butyl": [
    "VERB"
  ],
  "forested": [
    "VERB"
  ],
  "unrivaled": [
    "VERB"
  ],
  "bobbie": [
    "VERB"
  ],
  "shale": [
    "NOUN"
  ],
  "diligent": [
    "ADJ"
  ],
  "varna": [
    "PROPN"
  ],
  "maidenhead": [
    "PROPN"
  ],
  "adversity": [
    "NOUN"
  ],
  "randomness": [
    "VERB"
  ],
  "caliper": [
    "ADV"
  ],
  "anode": [
    "VERB"
  ],
  "misinformation": [
    "NOUN"
  ],
  "aneurysm": [
    "PROPN"
  ],
  "egress": [
    "NOUN",
    "PROPN"
  ],
  "eroded": [
    "VERB"
  ],
  "crepe": [
    "NOUN"
  ],
  "alastair": [
    "NOUN"
  ],
  "sheepskin": [
    "NOUN"
  ],
  "concave": [
    "VERB"
  ],
  "heresy": [
    "NOUN"
  ],
  "armory": [
    "NOUN"
  ],
  "contestant": [
    "PROPN"
  ],
  "snell": [
    "NOUN"
  ],
  "believable": [
    "ADJ"
  ],
  "anesthesiology": [
    "NOUN"
  ],
  "forthwith": [
    "ADP"
  ],
  "avert": [
    "VERB"
  ],
  "guise": [
    "ADJ"
  ],
  "curiously": [
    "ADV"
  ],
  "fullness": [
    "VERB"
  ],
  "bongo": [
    "PROPN"
  ],
  "compounding": [
    "VERB"
  ],
  "shaky": [
    "ADJ"
  ],
  "bloke": [
    "VERB"
  ],
  "brutally": [
    "ADV"
  ],
  "pennant": [
    "NOUN"
  ],
  "electrochemical": [
    "ADJ"
  ],
  "levee": [
    "NOUN"
  ],
  "lurker": [
    "NOUN"
  ],
  "phony": [
    "PROPN"
  ],
  "powerless": [
    "NOUN"
  ],
  "nikko": [
    "PROPN"
  ],
  "populace": [
    "NOUN"
  ],
  "deliberation": [
    "NOUN"
  ],
  "soles": [
    "NOUN"
  ],
  "monolithic": [
    "ADJ"
  ],
  "jetty": [
    "PROPN"
  ],
  "luster": [
    "NOUN"
  ],
  "subcontract": [
    "ADP"
  ],
  "overrun": [
    "NOUN"
  ],
  "undone": [
    "VERB"
  ],
  "prophylaxis": [
    "NOUN"
  ],
  "delia": [
    "PROPN"
  ],
  "guillermo": [
    "PROPN"
  ],
  "habitual": [
    "ADJ"
  ],
  "alhambra": [
    "NOUN"
  ],
  "uplift": [
    "NOUN",
    "VERB"
  ],
  "causeway": [
    "NOUN"
  ],
  "duplicator": [
    "NOUN"
  ],
  "fundamentalism": [
    "NOUN"
  ],
  "australasian": [
    "PROPN"
  ],
  "inhabit": [
    "NOUN"
  ],
  "conglomerate": [
    "NOUN"
  ],
  "rerun": [
    "VERB",
    "NOUN"
  ],
  "segmented": [
    "VERB"
  ],
  "handshake": [
    "VERB"
  ],
  "extradition": [
    "NOUN"
  ],
  "innovate": [
    "VERB"
  ],
  "jerky": [
    "PROPN"
  ],
  "proportionate": [
    "VERB"
  ],
  "deliverance": [
    "NOUN"
  ],
  "subdued": [
    "VERB"
  ],
  "codon": [
    "PROPN"
  ],
  "acidity": [
    "NOUN"
  ],
  "formaldehyde": [
    "NOUN"
  ],
  "detriment": [
    "NOUN"
  ],
  "welder": [
    "NOUN"
  ],
  "switcher": [
    "NOUN",
    "PROPN"
  ],
  "goldie": [
    "VERB"
  ],
  "mockingbird": [
    "ADV"
  ],
  "mangrove": [
    "VERB"
  ],
  "echelon": [
    "NOUN"
  ],
  "arranger": [
    "PROPN"
  ],
  "scaffolding": [
    "VERB"
  ],
  "metallurgy": [
    "PROPN"
  ],
  "sensed": [
    "VERB"
  ],
  "babcock": [
    "PROPN"
  ],
  "boasting": [
    "VERB"
  ],
  "shiite": [
    "VERB"
  ],
  "argon": [
    "PROPN"
  ],
  "norah": [
    "PROPN"
  ],
  "carefree": [
    "NOUN"
  ],
  "biotin": [
    "NOUN"
  ],
  "salter": [
    "PROPN"
  ],
  "morph": [
    "VERB"
  ],
  "econometrics": [
    "NOUN"
  ],
  "marconi": [
    "NOUN"
  ],
  "fluctuation": [
    "NOUN"
  ],
  "jeannie": [
    "PROPN"
  ],
  "expatriate": [
    "NOUN"
  ],
  "tantra": [
    "VERB"
  ],
  "thingy": [
    "VERB"
  ],
  "monstrous": [
    "ADJ"
  ],
  "ruskin": [
    "PROPN"
  ],
  "calibre": [
    "PROPN"
  ],
  "germination": [
    "NOUN"
  ],
  "lipoprotein": [
    "PROPN"
  ],
  "planetarium": [
    "NOUN"
  ],
  "fumble": [
    "ADJ"
  ],
  "attrition": [
    "NOUN"
  ],
  "proverb": [
    "NOUN"
  ],
  "darin": [
    "NOUN"
  ],
  "mercenary": [
    "NOUN"
  ],
  "speck": [
    "VERB"
  ],
  "searcher": [
    "PROPN"
  ],
  "tourmaline": [
    "VERB"
  ],
  "murderous": [
    "ADJ"
  ],
  "rudder": [
    "NOUN"
  ],
  "anaesthesia": [
    "PROPN"
  ],
  "bluebird": [
    "ADP"
  ],
  "deformed": [
    "VERB"
  ],
  "wretched": [
    "VERB"
  ],
  "interstellar": [
    "NOUN"
  ],
  "kenton": [
    "PROPN"
  ],
  "decadent": [
    "NOUN"
  ],
  "unsurpassed": [
    "ADJ"
  ],
  "surpass": [
    "NOUN"
  ],
  "annihilation": [
    "NOUN"
  ],
  "snowshoeing": [
    "VERB"
  ],
  "memoranda": [
    "NOUN"
  ],
  "steaming": [
    "VERB"
  ],
  "serra": [
    "NOUN"
  ],
  "cirrhosis": [
    "NOUN"
  ],
  "metrology": [
    "NOUN"
  ],
  "hideous": [
    "ADJ"
  ],
  "abreast": [
    "NOUN"
  ],
  "intuitively": [
    "ADV"
  ],
  "connexion": [
    "NOUN"
  ],
  "stoneware": [
    "VERB"
  ],
  "pathogenic": [
    "ADJ"
  ],
  "humanist": [
    "NOUN"
  ],
  "pompano": [
    "PROPN"
  ],
  "tyrant": [
    "NOUN"
  ],
  "skewed": [
    "VERB"
  ],
  "decency": [
    "NOUN"
  ],
  "papal": [
    "NOUN"
  ],
  "sprang": [
    "PROPN"
  ],
  "teaming": [
    "VERB"
  ],
  "positional": [
    "ADJ"
  ],
  "glycine": [
    "NOUN"
  ],
  "throwback": [
    "ADV"
  ],
  "gestation": [
    "NOUN"
  ],
  "plenum": [
    "NOUN"
  ],
  "aotearoa": [
    "NOUN"
  ],
  "geologist": [
    "NOUN"
  ],
  "piccadilly": [
    "ADV"
  ],
  "hydrolysis": [
    "VERB"
  ],
  "existential": [
    "ADJ"
  ],
  "sweaty": [
    "PROPN"
  ],
  "mogul": [
    "PROPN"
  ],
  "fiercely": [
    "ADV"
  ],
  "varnish": [
    "NOUN"
  ],
  "hysteria": [
    "PROPN"
  ],
  "rounder": [
    "NOUN"
  ],
  "cytoplasm": [
    "NOUN"
  ],
  "insistence": [
    "NOUN"
  ],
  "sedimentary": [
    "NOUN"
  ],
  "clockwork": [
    "NOUN"
  ],
  "chlorophyll": [
    "NOUN"
  ],
  "shipyard": [
    "NOUN",
    "PROPN"
  ],
  "centering": [
    "VERB"
  ],
  "answerer": [
    "NOUN"
  ],
  "intelligently": [
    "ADV"
  ],
  "bogart": [
    "PROPN"
  ],
  "imputation": [
    "NOUN"
  ],
  "albrecht": [
    "PROPN"
  ],
  "densely": [
    "ADV"
  ],
  "untranslated": [
    "ADJ"
  ],
  "droit": [
    "PROPN"
  ],
  "reconnect": [
    "VERB"
  ],
  "teeny": [
    "PROPN"
  ],
  "distrust": [
    "VERB"
  ],
  "fraternal": [
    "ADJ"
  ],
  "benthic": [
    "ADJ"
  ],
  "carlin": [
    "NOUN"
  ],
  "lithograph": [
    "NOUN"
  ],
  "stoner": [
    "NOUN"
  ],
  "repost": [
    "VERB"
  ],
  "eloquent": [
    "ADJ"
  ],
  "silas": [
    "NOUN"
  ],
  "wondrous": [
    "ADJ"
  ],
  "dunne": [
    "PROPN"
  ],
  "hyperbolic": [
    "ADJ"
  ],
  "bisque": [
    "NOUN"
  ],
  "touchstone": [
    "NOUN"
  ],
  "standoff": [
    "PROPN"
  ],
  "acoustical": [
    "ADJ"
  ],
  "photovoltaic": [
    "VERB"
  ],
  "grieve": [
    "VERB"
  ],
  "pleasurable": [
    "ADJ"
  ],
  "bustling": [
    "VERB"
  ],
  "lucerne": [
    "PROPN"
  ],
  "fiasco": [
    "NOUN"
  ],
  "evangelion": [
    "NOUN"
  ],
  "excretion": [
    "NOUN"
  ],
  "breakage": [
    "NOUN"
  ],
  "apportionment": [
    "NOUN"
  ],
  "reins": [
    "NOUN"
  ],
  "homemaker": [
    "NOUN"
  ],
  "scrambling": [
    "VERB"
  ],
  "misfortune": [
    "PROPN"
  ],
  "categorize": [
    "VERB"
  ],
  "reflexology": [
    "NOUN"
  ],
  "subconscious": [
    "ADJ"
  ],
  "incandescent": [
    "NOUN"
  ],
  "disappoint": [
    "VERB"
  ],
  "capstone": [
    "NOUN"
  ],
  "federalist": [
    "NOUN"
  ],
  "hidalgo": [
    "PROPN"
  ],
  "prosthetic": [
    "ADJ"
  ],
  "firewood": [
    "NOUN"
  ],
  "serenade": [
    "NOUN"
  ],
  "weathered": [
    "VERB"
  ],
  "aural": [
    "PROPN"
  ],
  "gatekeeper": [
    "NOUN",
    "PROPN"
  ],
  "lawless": [
    "ADV"
  ],
  "gestion": [
    "NOUN"
  ],
  "thermodynamic": [
    "ADJ"
  ],
  "patrice": [
    "NOUN"
  ],
  "bittersweet": [
    "VERB"
  ],
  "inhuman": [
    "VERB"
  ],
  "isolating": [
    "VERB"
  ],
  "mycobacterium": [
    "NOUN"
  ],
  "despise": [
    "NOUN"
  ],
  "fresco": [
    "PROPN"
  ],
  "custard": [
    "NOUN"
  ],
  "prius": [
    "NOUN"
  ],
  "hasan": [
    "NOUN"
  ],
  "branched": [
    "VERB"
  ],
  "shipbuilding": [
    "VERB"
  ],
  "mildew": [
    "NOUN"
  ],
  "frown": [
    "VERB"
  ],
  "privy": [
    "PROPN"
  ],
  "caretaker": [
    "NOUN"
  ],
  "antonia": [
    "PROPN"
  ],
  "feeble": [
    "ADJ"
  ],
  "gentile": [
    "NOUN"
  ],
  "trouser": [
    "NOUN"
  ],
  "sepia": [
    "NOUN"
  ],
  "champlain": [
    "NOUN"
  ],
  "valence": [
    "NOUN"
  ],
  "brava": [
    "PROPN"
  ],
  "disobedience": [
    "NOUN"
  ],
  "unpack": [
    "VERB"
  ],
  "divination": [
    "NOUN"
  ],
  "russel": [
    "NOUN"
  ],
  "nephrology": [
    "NOUN"
  ],
  "squamous": [
    "ADJ"
  ],
  "triumphant": [
    "ADJ"
  ],
  "superbly": [
    "ADV"
  ],
  "chianti": [
    "VERB"
  ],
  "domestically": [
    "ADV"
  ],
  "constrain": [
    "VERB"
  ],
  "brandi": [
    "NOUN"
  ],
  "nazarene": [
    "ADJ"
  ],
  "whomever": [
    "PROPN"
  ],
  "genevieve": [
    "VERB"
  ],
  "shiloh": [
    "PROPN"
  ],
  "damper": [
    "NOUN"
  ],
  "kenai": [
    "VERB"
  ],
  "forgiving": [
    "VERB"
  ],
  "unplanned": [
    "ADJ"
  ],
  "yahweh": [
    "INTJ"
  ],
  "madman": [
    "NOUN"
  ],
  "slumber": [
    "VERB"
  ],
  "shimmering": [
    "VERB"
  ],
  "rigidity": [
    "NOUN"
  ],
  "chipped": [
    "VERB"
  ],
  "pelvis": [
    "PROPN"
  ],
  "potluck": [
    "NOUN"
  ],
  "creamer": [
    "NOUN"
  ],
  "tumbling": [
    "VERB"
  ],
  "columbine": [
    "PROPN"
  ],
  "surat": [
    "PROPN"
  ],
  "hourglass": [
    "VERB"
  ],
  "dormitory": [
    "NOUN"
  ],
  "discharging": [
    "VERB"
  ],
  "lockport": [
    "NOUN"
  ],
  "pollack": [
    "NOUN"
  ],
  "hoyle": [
    "PROPN"
  ],
  "arousal": [
    "NOUN"
  ],
  "unnoticed": [
    "ADJ"
  ],
  "ridicule": [
    "NOUN"
  ],
  "darien": [
    "PROPN"
  ],
  "intersect": [
    "ADJ"
  ],
  "mammary": [
    "NOUN"
  ],
  "hillman": [
    "PROPN"
  ],
  "garnish": [
    "ADJ"
  ],
  "peeling": [
    "VERB"
  ],
  "levis": [
    "PROPN"
  ],
  "blindly": [
    "ADV"
  ],
  "unintentional": [
    "ADJ"
  ],
  "durant": [
    "ADJ"
  ],
  "repertory": [
    "NOUN"
  ],
  "diddy": [
    "VERB"
  ],
  "conveyancing": [
    "VERB"
  ],
  "echinacea": [
    "NOUN"
  ],
  "frigidaire": [
    "NOUN"
  ],
  "halibut": [
    "PROPN"
  ],
  "silverware": [
    "VERB"
  ],
  "goody": [
    "NOUN"
  ],
  "dugout": [
    "PROPN"
  ],
  "battleship": [
    "NOUN"
  ],
  "talisman": [
    "NOUN"
  ],
  "rebuttal": [
    "NOUN"
  ],
  "underside": [
    "ADJ"
  ],
  "blackwood": [
    "NOUN"
  ],
  "alumnus": [
    "VERB"
  ],
  "giggle": [
    "VERB"
  ],
  "hyperactivity": [
    "NOUN"
  ],
  "worden": [
    "NOUN"
  ],
  "polos": [
    "VERB"
  ],
  "deforestation": [
    "NOUN"
  ],
  "roderick": [
    "NOUN"
  ],
  "corinth": [
    "ADJ"
  ],
  "perverse": [
    "VERB"
  ],
  "glittering": [
    "VERB"
  ],
  "casket": [
    "NOUN"
  ],
  "dickey": [
    "NOUN"
  ],
  "detour": [
    "NOUN"
  ],
  "carpeting": [
    "VERB"
  ],
  "husbandry": [
    "NOUN"
  ],
  "visibly": [
    "ADV"
  ],
  "defunct": [
    "ADJ"
  ],
  "resection": [
    "NOUN"
  ],
  "islamist": [
    "NOUN"
  ],
  "unveil": [
    "PROPN"
  ],
  "brant": [
    "NOUN"
  ],
  "layoff": [
    "VERB"
  ],
  "dodger": [
    "PROPN"
  ],
  "merciful": [
    "ADJ"
  ],
  "kinship": [
    "NOUN"
  ],
  "springtime": [
    "NOUN"
  ],
  "euphoria": [
    "NOUN"
  ],
  "acuity": [
    "NOUN"
  ],
  "popper": [
    "NOUN"
  ],
  "transmittal": [
    "NOUN"
  ],
  "equilibria": [
    "NOUN"
  ],
  "requester": [
    "PROPN"
  ],
  "hemlock": [
    "NOUN"
  ],
  "sniffing": [
    "VERB"
  ],
  "uncanny": [
    "ADV"
  ],
  "stringer": [
    "PROPN"
  ],
  "snohomish": [
    "PROPN"
  ],
  "stork": [
    "NOUN"
  ],
  "intramural": [
    "ADJ"
  ],
  "concede": [
    "VERB"
  ],
  "combustible": [
    "VERB"
  ],
  "fallacy": [
    "NOUN"
  ],
  "tania": [
    "PROPN"
  ],
  "waistband": [
    "NOUN"
  ],
  "noxious": [
    "ADJ"
  ],
  "tunic": [
    "NOUN"
  ],
  "farce": [
    "NOUN"
  ],
  "drowsiness": [
    "NOUN"
  ],
  "metastasis": [
    "NOUN"
  ],
  "lunatic": [
    "ADJ"
  ],
  "reachable": [
    "ADJ"
  ],
  "radioactivity": [
    "NOUN"
  ],
  "auctioneer": [
    "VERB"
  ],
  "howdy": [
    "PROPN"
  ],
  "gregorian": [
    "PROPN"
  ],
  "haggard": [
    "PROPN"
  ],
  "reorder": [
    "NOUN"
  ],
  "manger": [
    "NOUN"
  ],
  "logarithmic": [
    "VERB"
  ],
  "yearning": [
    "VERB"
  ],
  "sandalwood": [
    "NOUN"
  ],
  "whack": [
    "VERB"
  ],
  "drone": [
    "NOUN"
  ],
  "godly": [
    "ADV"
  ],
  "spire": [
    "NOUN"
  ],
  "distillation": [
    "NOUN"
  ],
  "edging": [
    "VERB"
  ],
  "decontamination": [
    "NOUN"
  ],
  "euclidean": [
    "PROPN"
  ],
  "salina": [
    "NOUN"
  ],
  "antidote": [
    "VERB"
  ],
  "caricature": [
    "NOUN"
  ],
  "formalism": [
    "NOUN"
  ],
  "shroud": [
    "NOUN"
  ],
  "aching": [
    "VERB"
  ],
  "stead": [
    "ADJ"
  ],
  "recoil": [
    "NOUN"
  ],
  "eyepiece": [
    "NOUN"
  ],
  "raisin": [
    "NOUN"
  ],
  "bobcat": [
    "ADJ"
  ],
  "freehand": [
    "NOUN"
  ],
  "killeen": [
    "VERB"
  ],
  "applicator": [
    "NOUN"
  ],
  "mezzanine": [
    "PROPN"
  ],
  "nameless": [
    "NOUN"
  ],
  "humidifier": [
    "NOUN"
  ],
  "susanne": [
    "PROPN"
  ],
  "musically": [
    "ADV"
  ],
  "intensify": [
    "VERB"
  ],
  "mainstay": [
    "VERB"
  ],
  "indebted": [
    "ADJ"
  ],
  "breathed": [
    "VERB"
  ],
  "mucosa": [
    "PROPN"
  ],
  "dachshund": [
    "NOUN"
  ],
  "syringes": [
    "NOUN"
  ],
  "misled": [
    "VERB"
  ],
  "culprit": [
    "NOUN"
  ],
  "transact": [
    "VERB"
  ],
  "nepali": [
    "VERB"
  ],
  "slicing": [
    "VERB"
  ],
  "reproducible": [
    "ADJ"
  ],
  "spiced": [
    "VERB"
  ],
  "berne": [
    "NOUN"
  ],
  "bogota": [
    "PROPN"
  ],
  "puncture": [
    "PROPN"
  ],
  "lighten": [
    "VERB"
  ],
  "pamper": [
    "NOUN"
  ],
  "canteen": [
    "VERB"
  ],
  "hysterical": [
    "ADJ"
  ],
  "disinfection": [
    "NOUN"
  ],
  "perfusion": [
    "NOUN"
  ],
  "requisition": [
    "NOUN",
    "PROPN"
  ],
  "postseason": [
    "NOUN"
  ],
  "shrug": [
    "NOUN"
  ],
  "enchantment": [
    "NOUN"
  ],
  "greta": [
    "NOUN"
  ],
  "covey": [
    "VERB"
  ],
  "punisher": [
    "NOUN"
  ],
  "donne": [
    "VERB"
  ],
  "coquitlam": [
    "VERB"
  ],
  "loathing": [
    "VERB"
  ],
  "enhydra": [
    "PROPN"
  ],
  "bianchi": [
    "PROPN"
  ],
  "ominous": [
    "ADJ"
  ],
  "quieter": [
    "NOUN"
  ],
  "poking": [
    "VERB"
  ],
  "adrenergic": [
    "ADJ"
  ],
  "bottling": [
    "VERB"
  ],
  "baseman": [
    "NOUN"
  ],
  "wrestle": [
    "VERB"
  ],
  "rectify": [
    "VERB"
  ],
  "virtuous": [
    "ADJ"
  ],
  "aster": [
    "NOUN"
  ],
  "snails": [
    "NOUN"
  ],
  "decipher": [
    "ADV"
  ],
  "incapacity": [
    "NOUN"
  ],
  "effortless": [
    "VERB"
  ],
  "hydroelectric": [
    "PROPN"
  ],
  "cranial": [
    "NOUN"
  ],
  "hindsight": [
    "VERB"
  ],
  "wince": [
    "PROPN"
  ],
  "friendliness": [
    "PROPN"
  ],
  "invincible": [
    "ADJ"
  ],
  "prometheus": [
    "PROPN"
  ],
  "comanche": [
    "PROPN"
  ],
  "trickle": [
    "VERB"
  ],
  "disapprove": [
    "VERB"
  ],
  "erratic": [
    "ADJ"
  ],
  "familiarize": [
    "VERB",
    "PROPN"
  ],
  "spousal": [
    "NOUN"
  ],
  "insufficiency": [
    "NOUN"
  ],
  "mallard": [
    "PROPN"
  ],
  "airman": [
    "NOUN"
  ],
  "chien": [
    "PROPN"
  ],
  "mitre": [
    "NOUN"
  ],
  "tonnage": [
    "NOUN"
  ],
  "circulatory": [
    "ADJ"
  ],
  "mille": [
    "PROPN"
  ],
  "portlet": [
    "NOUN"
  ],
  "continuance": [
    "NOUN"
  ],
  "histone": [
    "NOUN"
  ],
  "unrecognized": [
    "VERB"
  ],
  "affectionate": [
    "VERB"
  ],
  "translational": [
    "ADJ"
  ],
  "unimportant": [
    "ADJ"
  ],
  "ferrara": [
    "NOUN"
  ],
  "greener": [
    "NOUN"
  ],
  "grudge": [
    "VERB"
  ],
  "interstitial": [
    "NOUN"
  ],
  "zoological": [
    "ADJ"
  ],
  "helical": [
    "ADJ"
  ],
  "fondue": [
    "NOUN"
  ],
  "norse": [
    "ADJ"
  ],
  "windscreen": [
    "ADJ"
  ],
  "wetting": [
    "VERB"
  ],
  "othello": [
    "PROPN"
  ],
  "supersonic": [
    "ADJ"
  ],
  "bosom": [
    "NOUN"
  ],
  "foothill": [
    "NOUN"
  ],
  "uncheck": [
    "VERB"
  ],
  "blackbird": [
    "PROPN"
  ],
  "causation": [
    "NOUN"
  ],
  "deciduous": [
    "ADJ"
  ],
  "photosynthesis": [
    "NOUN"
  ],
  "straighten": [
    "VERB"
  ],
  "convocation": [
    "NOUN"
  ],
  "precaution": [
    "NOUN"
  ],
  "fascia": [
    "NOUN"
  ],
  "philanthropic": [
    "NOUN"
  ],
  "geriatrics": [
    "NOUN"
  ],
  "stratified": [
    "VERB"
  ],
  "picky": [
    "ADJ"
  ],
  "barth": [
    "VERB"
  ],
  "mooring": [
    "VERB"
  ],
  "perla": [
    "PROPN"
  ],
  "micheal": [
    "NOUN"
  ],
  "endoscopy": [
    "PROPN"
  ],
  "cutaneous": [
    "ADJ"
  ],
  "lumen": [
    "NOUN"
  ],
  "jagger": [
    "PROPN"
  ],
  "forgery": [
    "NOUN"
  ],
  "pereira": [
    "PROPN"
  ],
  "drawstring": [
    "VERB"
  ],
  "infrequent": [
    "NOUN"
  ],
  "midrange": [
    "NOUN"
  ],
  "superpower": [
    "NOUN"
  ],
  "recliner": [
    "NOUN"
  ],
  "brandenburg": [
    "PROPN"
  ],
  "incision": [
    "NOUN"
  ],
  "adjuster": [
    "NOUN"
  ],
  "jumble": [
    "ADJ"
  ],
  "impeccable": [
    "ADJ"
  ],
  "shari": [
    "NOUN"
  ],
  "cognac": [
    "PROPN"
  ],
  "wading": [
    "VERB"
  ],
  "imitate": [
    "VERB"
  ],
  "grasping": [
    "VERB"
  ],
  "cyclist": [
    "NOUN"
  ],
  "borneo": [
    "NOUN"
  ],
  "mortuary": [
    "NOUN"
  ],
  "magneto": [
    "VERB"
  ],
  "crunchy": [
    "ADJ"
  ],
  "sealant": [
    "NOUN"
  ],
  "rightful": [
    "ADJ"
  ],
  "scarecrow": [
    "NOUN"
  ],
  "extracurricular": [
    "ADJ"
  ],
  "pious": [
    "ADJ"
  ],
  "utterance": [
    "NOUN"
  ],
  "undeveloped": [
    "ADJ"
  ],
  "basalt": [
    "NOUN"
  ],
  "undisputed": [
    "VERB"
  ],
  "tonal": [
    "ADJ"
  ],
  "brocade": [
    "PROPN"
  ],
  "seaweed": [
    "VERB"
  ],
  "psychoanalysis": [
    "NOUN"
  ],
  "hesitant": [
    "ADJ"
  ],
  "candlelight": [
    "NOUN"
  ],
  "votive": [
    "ADJ"
  ],
  "susquehanna": [
    "PROPN"
  ],
  "modulo": [
    "PROPN"
  ],
  "antler": [
    "VERB"
  ],
  "cuthbert": [
    "PROPN"
  ],
  "nance": [
    "NOUN"
  ],
  "nikolai": [
    "PROPN"
  ],
  "babble": [
    "ADJ"
  ],
  "pretreatment": [
    "NOUN"
  ],
  "pessimistic": [
    "NOUN"
  ],
  "untill": [
    "NOUN"
  ],
  "winnebago": [
    "PROPN"
  ],
  "diversify": [
    "VERB"
  ],
  "quaternary": [
    "NOUN"
  ],
  "hugging": [
    "VERB"
  ],
  "postman": [
    "PROPN",
    "NOUN"
  ],
  "overboard": [
    "ADV"
  ],
  "faithless": [
    "VERB"
  ],
  "ephraim": [
    "NOUN"
  ],
  "preheat": [
    "VERB"
  ],
  "microdrive": [
    "ADJ"
  ],
  "foggy": [
    "ADJ"
  ],
  "shone": [
    "VERB"
  ],
  "potpourri": [
    "NOUN"
  ],
  "leafy": [
    "PROPN"
  ],
  "passionately": [
    "ADV"
  ],
  "stroking": [
    "VERB"
  ],
  "uzbek": [
    "ADJ"
  ],
  "signatory": [
    "NOUN"
  ],
  "dolor": [
    "PROPN"
  ],
  "disallow": [
    "NOUN"
  ],
  "excellency": [
    "NOUN"
  ],
  "justifying": [
    "VERB"
  ],
  "trove": [
    "VERB"
  ],
  "deprive": [
    "ADJ"
  ],
  "kremlin": [
    "PROPN"
  ],
  "filer": [
    "PROPN"
  ],
  "apologetics": [
    "NOUN"
  ],
  "threonine": [
    "NOUN"
  ],
  "encephalitis": [
    "NOUN"
  ],
  "virtuoso": [
    "ADV"
  ],
  "buzzing": [
    "VERB"
  ],
  "dauphin": [
    "VERB"
  ],
  "steed": [
    "VERB"
  ],
  "paraffin": [
    "PROPN"
  ],
  "kenner": [
    "NOUN"
  ],
  "stimulant": [
    "VERB"
  ],
  "anamorphic": [
    "NOUN"
  ],
  "subspace": [
    "PROPN"
  ],
  "millet": [
    "PROPN"
  ],
  "invert": [
    "NOUN"
  ],
  "zionism": [
    "PUNCT"
  ],
  "retin": [
    "PROPN"
  ],
  "vermilion": [
    "NOUN"
  ],
  "disjoint": [
    "VERB"
  ],
  "checkbook": [
    "PROPN"
  ],
  "enlightening": [
    "VERB"
  ],
  "endlessly": [
    "ADV"
  ],
  "hasty": [
    "ADJ"
  ],
  "dexterity": [
    "NOUN"
  ],
  "puzzling": [
    "VERB"
  ],
  "reincarnation": [
    "NOUN"
  ],
  "sumatra": [
    "PROPN"
  ],
  "tunisian": [
    "ADJ"
  ],
  "macular": [
    "NOUN"
  ],
  "scrape": [
    "VERB"
  ],
  "leyland": [
    "NOUN"
  ],
  "arresting": [
    "VERB"
  ],
  "munch": [
    "NOUN"
  ],
  "resumption": [
    "NOUN"
  ],
  "bidirectional": [
    "NOUN"
  ],
  "traitor": [
    "NOUN"
  ],
  "clove": [
    "VERB"
  ],
  "illiterate": [
    "ADJ"
  ],
  "starfish": [
    "ADJ"
  ],
  "kurdistan": [
    "PROPN"
  ],
  "heartbreak": [
    "VERB"
  ],
  "bordered": [
    "VERB"
  ],
  "mallet": [
    "NOUN"
  ],
  "leech": [
    "NOUN"
  ],
  "giver": [
    "NOUN"
  ],
  "discontent": [
    "NOUN"
  ],
  "congestive": [
    "NOUN"
  ],
  "schilling": [
    "VERB"
  ],
  "battleground": [
    "NOUN"
  ],
  "tectonic": [
    "NOUN"
  ],
  "equate": [
    "NOUN"
  ],
  "seedling": [
    "VERB"
  ],
  "pathologist": [
    "NOUN"
  ],
  "mouthpiece": [
    "NOUN"
  ],
  "nymph": [
    "NOUN"
  ],
  "reassuring": [
    "VERB"
  ],
  "gujarati": [
    "PROPN"
  ],
  "astor": [
    "NOUN"
  ],
  "predictability": [
    "NOUN"
  ],
  "pajama": [
    "X"
  ],
  "adenocarcinoma": [
    "PROPN"
  ],
  "gestational": [
    "ADJ"
  ],
  "snowball": [
    "ADJ"
  ],
  "prematurely": [
    "ADV"
  ],
  "frail": [
    "VERB"
  ],
  "adventurer": [
    "NOUN"
  ],
  "irradiated": [
    "VERB"
  ],
  "awfully": [
    "ADV"
  ],
  "mayflower": [
    "ADV"
  ],
  "arched": [
    "VERB"
  ],
  "curfew": [
    "NOUN"
  ],
  "enlist": [
    "PROPN"
  ],
  "vedic": [
    "NOUN"
  ],
  "stylistic": [
    "ADJ"
  ],
  "corneal": [
    "VERB"
  ],
  "profane": [
    "NOUN"
  ],
  "crusher": [
    "PROPN"
  ],
  "cornelia": [
    "ADV"
  ],
  "romney": [
    "NOUN"
  ],
  "macaroni": [
    "PROPN"
  ],
  "dictation": [
    "NOUN"
  ],
  "swank": [
    "PROPN"
  ],
  "robber": [
    "VERB"
  ],
  "evacuate": [
    "VERB"
  ],
  "roving": [
    "VERB"
  ],
  "drinker": [
    "NOUN"
  ],
  "modeler": [
    "NOUN"
  ],
  "peking": [
    "VERB"
  ],
  "linger": [
    "VERB"
  ],
  "fillet": [
    "PROPN"
  ],
  "creationism": [
    "NOUN"
  ],
  "churn": [
    "NOUN",
    "PROPN"
  ],
  "nimbus": [
    "PROPN"
  ],
  "psychosis": [
    "VERB"
  ],
  "firsthand": [
    "ADV"
  ],
  "impart": [
    "ADJ"
  ],
  "turbidity": [
    "NOUN"
  ],
  "mountable": [
    "NOUN"
  ],
  "concomitant": [
    "ADJ"
  ],
  "oceanographic": [
    "ADJ"
  ],
  "scaffold": [
    "NOUN"
  ],
  "millie": [
    "VERB"
  ],
  "nonzero": [
    "NOUN"
  ],
  "leisurely": [
    "ADV"
  ],
  "mayonnaise": [
    "NOUN"
  ],
  "scavenger": [
    "PROPN"
  ],
  "candace": [
    "VERB"
  ],
  "adjuvant": [
    "ADJ"
  ],
  "limitless": [
    "NOUN"
  ],
  "preventable": [
    "ADJ"
  ],
  "hangman": [
    "PROPN"
  ],
  "bumpy": [
    "PROPN"
  ],
  "aleph": [
    "NOUN"
  ],
  "mastermind": [
    "NOUN"
  ],
  "sloping": [
    "VERB"
  ],
  "acceptability": [
    "NOUN"
  ],
  "constitutionally": [
    "ADV"
  ],
  "disapproval": [
    "NOUN"
  ],
  "bavarian": [
    "PROPN"
  ],
  "crucified": [
    "VERB"
  ],
  "chapin": [
    "NOUN"
  ],
  "permutation": [
    "NOUN"
  ],
  "mulligan": [
    "VERB"
  ],
  "unlucky": [
    "ADJ"
  ],
  "distort": [
    "PROPN"
  ],
  "ketchup": [
    "NOUN"
  ],
  "alimony": [
    "PROPN"
  ],
  "viscous": [
    "ADJ"
  ],
  "unambiguous": [
    "ADJ"
  ],
  "loosing": [
    "VERB"
  ],
  "handicraft": [
    "NOUN"
  ],
  "emphysema": [
    "PROPN"
  ],
  "epistemology": [
    "NOUN"
  ],
  "piling": [
    "VERB"
  ],
  "soloist": [
    "PROPN"
  ],
  "rejuvenation": [
    "NOUN"
  ],
  "anaconda": [
    "PROPN"
  ],
  "basilica": [
    "PROPN"
  ],
  "amine": [
    "VERB"
  ],
  "carfax": [
    "NOUN"
  ],
  "burley": [
    "NOUN"
  ],
  "woofer": [
    "PROPN"
  ],
  "juliana": [
    "PROPN"
  ],
  "millimeter": [
    "VERB"
  ],
  "snape": [
    "NOUN"
  ],
  "lowland": [
    "PROPN"
  ],
  "awoke": [
    "VERB"
  ],
  "parka": [
    "NOUN"
  ],
  "unheard": [
    "ADJ"
  ],
  "prune": [
    "NOUN"
  ],
  "scouse": [
    "NOUN"
  ],
  "endanger": [
    "VERB"
  ],
  "cairn": [
    "ADJ"
  ],
  "nomadic": [
    "ADJ"
  ],
  "spock": [
    "NOUN"
  ],
  "decompression": [
    "NOUN"
  ],
  "disgusted": [
    "VERB"
  ],
  "draco": [
    "PROPN"
  ],
  "galena": [
    "PROPN"
  ],
  "inactivation": [
    "NOUN"
  ],
  "lymphatic": [
    "ADJ"
  ],
  "olfactory": [
    "NOUN"
  ],
  "prolong": [
    "PROPN"
  ],
  "kroon": [
    "PROPN"
  ],
  "thinly": [
    "ADV"
  ],
  "rollback": [
    "NOUN",
    "PROPN"
  ],
  "garnett": [
    "PROPN"
  ],
  "galen": [
    "PROPN"
  ],
  "snowshoe": [
    "VERB"
  ],
  "arable": [
    "ADJ"
  ],
  "backside": [
    "NOUN"
  ],
  "parallelism": [
    "NOUN"
  ],
  "candlewood": [
    "NOUN"
  ],
  "vernacular": [
    "ADJ"
  ],
  "alkali": [
    "PROPN"
  ],
  "mowing": [
    "VERB"
  ],
  "painkiller": [
    "VERB"
  ],
  "nutty": [
    "PROPN"
  ],
  "sever": [
    "VERB"
  ],
  "myeloma": [
    "NOUN"
  ],
  "expend": [
    "VERB"
  ],
  "auntie": [
    "NOUN"
  ],
  "osteopathic": [
    "ADJ"
  ],
  "vividly": [
    "ADV"
  ],
  "happiest": [
    "ADJ"
  ],
  "merino": [
    "NOUN"
  ],
  "indented": [
    "VERB"
  ],
  "barium": [
    "NOUN"
  ],
  "toric": [
    "ADV"
  ],
  "humming": [
    "VERB"
  ],
  "disclaim": [
    "VERB"
  ],
  "shearer": [
    "NOUN"
  ],
  "hydrophobic": [
    "NOUN"
  ],
  "returnable": [
    "VERB"
  ],
  "resuscitation": [
    "NOUN"
  ],
  "stratification": [
    "NOUN"
  ],
  "regenerate": [
    "VERB"
  ],
  "cahill": [
    "NOUN"
  ],
  "titre": [
    "NOUN"
  ],
  "tumbler": [
    "ADJ"
  ],
  "adagio": [
    "NOUN"
  ],
  "sunburst": [
    "NOUN"
  ],
  "ranting": [
    "VERB"
  ],
  "fling": [
    "VERB"
  ],
  "comrade": [
    "NOUN"
  ],
  "piccolo": [
    "NOUN"
  ],
  "porcupine": [
    "NOUN"
  ],
  "verifiable": [
    "ADJ"
  ],
  "chopping": [
    "VERB"
  ],
  "bacterium": [
    "NOUN"
  ],
  "sideline": [
    "PROPN"
  ],
  "stabbing": [
    "VERB"
  ],
  "metamorphosis": [
    "NOUN"
  ],
  "bushing": [
    "VERB"
  ],
  "ligament": [
    "NOUN"
  ],
  "translocation": [
    "NOUN"
  ],
  "serialization": [
    "NOUN"
  ],
  "hilda": [
    "PROPN"
  ],
  "wanderer": [
    "NOUN"
  ],
  "spitting": [
    "VERB"
  ],
  "eigenvalue": [
    "ADJ"
  ],
  "inconvenient": [
    "NOUN"
  ],
  "seacoast": [
    "VERB"
  ],
  "conductance": [
    "NOUN"
  ],
  "chancery": [
    "NOUN"
  ],
  "raving": [
    "VERB"
  ],
  "niels": [
    "NOUN"
  ],
  "panzer": [
    "NOUN"
  ],
  "tweeter": [
    "VERB"
  ],
  "executor": [
    "NOUN",
    "PROPN"
  ],
  "poncho": [
    "PROPN"
  ],
  "faerie": [
    "PROPN"
  ],
  "stinger": [
    "PROPN"
  ],
  "tasteless": [
    "ADJ"
  ],
  "tomahawk": [
    "PROPN"
  ],
  "instructive": [
    "ADJ"
  ],
  "mathematically": [
    "ADV"
  ],
  "godwin": [
    "PROPN"
  ],
  "drier": [
    "NOUN"
  ],
  "cubicle": [
    "NOUN"
  ],
  "avanti": [
    "VERB"
  ],
  "papaya": [
    "PROPN"
  ],
  "auger": [
    "NOUN"
  ],
  "mongoose": [
    "VERB"
  ],
  "iconic": [
    "ADJ"
  ],
  "chromatic": [
    "ADJ"
  ],
  "gambit": [
    "NOUN"
  ],
  "enoch": [
    "PROPN"
  ],
  "polled": [
    "VERB"
  ],
  "agnostic": [
    "ADJ",
    "PROPN"
  ],
  "delusion": [
    "NOUN"
  ],
  "jogger": [
    "NOUN"
  ],
  "occlusion": [
    "NOUN"
  ],
  "verity": [
    "NOUN"
  ],
  "covent": [
    "NOUN"
  ],
  "turret": [
    "VERB"
  ],
  "reinvestment": [
    "NOUN"
  ],
  "chatterbox": [
    "NOUN"
  ],
  "precede": [
    "VERB"
  ],
  "polystyrene": [
    "NOUN"
  ],
  "intelligencer": [
    "NOUN"
  ],
  "pluralism": [
    "NOUN"
  ],
  "tetanus": [
    "VERB"
  ],
  "neuromuscular": [
    "NOUN"
  ],
  "hiker": [
    "PROPN"
  ],
  "strategist": [
    "PROPN"
  ],
  "zloty": [
    "ADV"
  ],
  "osmosis": [
    "NOUN"
  ],
  "priming": [
    "VERB"
  ],
  "sulphate": [
    "VERB"
  ],
  "soothe": [
    "ADV"
  ],
  "clandestine": [
    "ADJ"
  ],
  "hovering": [
    "VERB"
  ],
  "slurry": [
    "NOUN"
  ],
  "tamper": [
    "PROPN"
  ],
  "chiropractor": [
    "NOUN"
  ],
  "vibrational": [
    "ADJ"
  ],
  "heathen": [
    "ADV"
  ],
  "obsidian": [
    "PROPN"
  ],
  "unduly": [
    "ADV"
  ],
  "winger": [
    "PROPN"
  ],
  "argonne": [
    "ADV"
  ],
  "domicile": [
    "VERB"
  ],
  "chargeable": [
    "ADJ"
  ],
  "fanning": [
    "VERB"
  ],
  "spurred": [
    "VERB"
  ],
  "osage": [
    "NOUN"
  ],
  "peregrine": [
    "NOUN"
  ],
  "tabitha": [
    "PROPN"
  ],
  "crumb": [
    "ADJ"
  ],
  "culmination": [
    "NOUN"
  ],
  "guilder": [
    "NOUN"
  ],
  "comparator": [
    "NOUN"
  ],
  "theoretic": [
    "ADJ"
  ],
  "sealer": [
    "NOUN"
  ],
  "softening": [
    "VERB"
  ],
  "waterproofing": [
    "VERB"
  ],
  "pinky": [
    "NOUN"
  ],
  "hattie": [
    "PROPN"
  ],
  "invertebrate": [
    "VERB"
  ],
  "rebellious": [
    "ADJ"
  ],
  "tastefully": [
    "ADV"
  ],
  "grate": [
    "NOUN"
  ],
  "exorcism": [
    "NOUN"
  ],
  "cultivar": [
    "NOUN"
  ],
  "orson": [
    "NOUN"
  ],
  "teammate": [
    "NOUN"
  ],
  "diseased": [
    "VERB"
  ],
  "sequencer": [
    "NOUN"
  ],
  "grandparent": [
    "NOUN"
  ],
  "demonic": [
    "ADJ"
  ],
  "margot": [
    "PROPN"
  ],
  "collaboratively": [
    "ADV"
  ],
  "unmanned": [
    "ADJ"
  ],
  "gunnar": [
    "NOUN"
  ],
  "eunice": [
    "NOUN"
  ],
  "bountiful": [
    "ADJ"
  ],
  "lossless": [
    "NOUN"
  ],
  "mesopotamia": [
    "NOUN"
  ],
  "andean": [
    "ADJ"
  ],
  "poseidon": [
    "PROPN"
  ],
  "spectroscopic": [
    "NOUN"
  ],
  "armpit": [
    "NOUN"
  ],
  "ratify": [
    "VERB"
  ],
  "worsening": [
    "VERB"
  ],
  "metalworking": [
    "VERB"
  ],
  "ginkgo": [
    "NOUN"
  ],
  "fiend": [
    "NOUN"
  ],
  "drapery": [
    "NOUN"
  ],
  "bernice": [
    "PROPN"
  ],
  "decedent": [
    "VERB"
  ],
  "dimethyl": [
    "PROPN"
  ],
  "muzzle": [
    "VERB"
  ],
  "entrant": [
    "ADJ"
  ],
  "schoolhouse": [
    "NOUN"
  ],
  "telescopic": [
    "NOUN"
  ],
  "vespa": [
    "VERB"
  ],
  "lactate": [
    "NOUN"
  ],
  "monorail": [
    "NOUN"
  ],
  "retribution": [
    "NOUN"
  ],
  "bookworm": [
    "NOUN"
  ],
  "sabbatical": [
    "ADJ"
  ],
  "stallman": [
    "NOUN"
  ],
  "skeptic": [
    "ADJ"
  ],
  "slander": [
    "VERB"
  ],
  "fireside": [
    "ADV"
  ],
  "onshore": [
    "ADJ"
  ],
  "suffrage": [
    "NOUN"
  ],
  "fortifying": [
    "VERB"
  ],
  "sleepless": [
    "VERB"
  ],
  "kinesiology": [
    "NOUN"
  ],
  "storybook": [
    "PROPN",
    "NOUN"
  ],
  "watered": [
    "VERB"
  ],
  "taupe": [
    "PROPN"
  ],
  "hookup": [
    "PROPN"
  ],
  "recite": [
    "PROPN"
  ],
  "myron": [
    "PROPN"
  ],
  "kneeling": [
    "VERB"
  ],
  "negation": [
    "NOUN"
  ],
  "dismay": [
    "PROPN"
  ],
  "smelled": [
    "VERB"
  ],
  "reconstructive": [
    "NOUN"
  ],
  "trespass": [
    "VERB"
  ],
  "conciliation": [
    "NOUN"
  ],
  "glycerol": [
    "NOUN"
  ],
  "wiseman": [
    "PROPN"
  ],
  "compasses": [
    "NOUN"
  ],
  "leaping": [
    "VERB"
  ],
  "impunity": [
    "NOUN"
  ],
  "sunken": [
    "VERB"
  ],
  "infernal": [
    "ADJ"
  ],
  "defamatory": [
    "NOUN"
  ],
  "pampered": [
    "VERB"
  ],
  "pyrex": [
    "PROPN"
  ],
  "inquiring": [
    "VERB"
  ],
  "numero": [
    "NOUN"
  ],
  "praising": [
    "VERB"
  ],
  "momentary": [
    "ADJ"
  ],
  "commemoration": [
    "NOUN"
  ],
  "psychologically": [
    "ADV"
  ],
  "holstein": [
    "NOUN"
  ],
  "interdependence": [
    "NOUN"
  ],
  "serpentine": [
    "VERB"
  ],
  "conor": [
    "NOUN"
  ],
  "sundry": [
    "ADV"
  ],
  "therefrom": [
    "ADP"
  ],
  "hydrological": [
    "ADJ"
  ],
  "wrecking": [
    "VERB"
  ],
  "pique": [
    "NOUN"
  ],
  "forecaster": [
    "NOUN"
  ],
  "quickie": [
    "PROPN"
  ],
  "stephane": [
    "NOUN"
  ],
  "swore": [
    "VERB"
  ],
  "parabolic": [
    "ADJ"
  ],
  "boreal": [
    "NOUN"
  ],
  "interventional": [
    "ADJ"
  ],
  "tabulation": [
    "NOUN"
  ],
  "journeyman": [
    "PROPN"
  ],
  "enlighten": [
    "VERB"
  ],
  "trier": [
    "NOUN"
  ],
  "flashy": [
    "ADJ"
  ],
  "prowess": [
    "NOUN"
  ],
  "enriching": [
    "VERB"
  ],
  "dogwood": [
    "NOUN"
  ],
  "signet": [
    "NOUN"
  ],
  "iroquois": [
    "NOUN"
  ],
  "convergent": [
    "NOUN"
  ],
  "digested": [
    "VERB"
  ],
  "equivalency": [
    "NOUN"
  ],
  "messe": [
    "PROPN"
  ],
  "sedation": [
    "NOUN"
  ],
  "manhood": [
    "NOUN"
  ],
  "cannibal": [
    "ADJ"
  ],
  "oblivious": [
    "ADJ"
  ],
  "harmonics": [
    "NOUN"
  ],
  "lavatory": [
    "NOUN"
  ],
  "roughness": [
    "NOUN"
  ],
  "destructor": [
    "NOUN"
  ],
  "snapping": [
    "VERB"
  ],
  "jethro": [
    "PROPN"
  ],
  "cauliflower": [
    "VERB"
  ],
  "feudal": [
    "ADJ"
  ],
  "unbearable": [
    "ADJ"
  ],
  "olympian": [
    "PROPN"
  ],
  "syllabi": [
    "PROPN"
  ],
  "livre": [
    "NOUN"
  ],
  "sectarian": [
    "ADJ"
  ],
  "fathom": [
    "PROPN"
  ],
  "republish": [
    "VERB"
  ],
  "endoscopic": [
    "PROPN"
  ],
  "appreciative": [
    "VERB"
  ],
  "innumerable": [
    "ADJ"
  ],
  "disproportionately": [
    "ADV"
  ],
  "noticeably": [
    "ADV"
  ],
  "synchrotron": [
    "NOUN"
  ],
  "memorize": [
    "VERB"
  ],
  "volumetric": [
    "NOUN"
  ],
  "atonement": [
    "NOUN"
  ],
  "extant": [
    "ADJ"
  ],
  "unmask": [
    "VERB"
  ],
  "chisel": [
    "NOUN"
  ],
  "hyperplasia": [
    "NOUN"
  ],
  "mysteriously": [
    "ADV"
  ],
  "wayward": [
    "ADJ"
  ],
  "legit": [
    "VERB"
  ],
  "redness": [
    "NOUN"
  ],
  "dreamland": [
    "PROPN"
  ],
  "scrapped": [
    "VERB"
  ],
  "illustrious": [
    "ADJ"
  ],
  "erasure": [
    "NOUN"
  ],
  "fishy": [
    "ADJ"
  ],
  "intoxication": [
    "NOUN"
  ],
  "glimmer": [
    "PROPN"
  ],
  "materiel": [
    "NOUN"
  ],
  "blooded": [
    "VERB"
  ],
  "upsilon": [
    "PROPN"
  ],
  "sizable": [
    "ADJ"
  ],
  "coenzyme": [
    "PROPN"
  ],
  "filmy": [
    "NOUN"
  ],
  "timid": [
    "ADJ"
  ],
  "afterlife": [
    "NOUN"
  ],
  "counterpoint": [
    "NOUN"
  ],
  "magically": [
    "ADV"
  ],
  "thyself": [
    "PRON"
  ],
  "wristband": [
    "NOUN"
  ],
  "chiller": [
    "ADV"
  ],
  "pretended": [
    "VERB"
  ],
  "barra": [
    "VERB"
  ],
  "therewith": [
    "ADP"
  ],
  "interment": [
    "NOUN"
  ],
  "partitioned": [
    "VERB"
  ],
  "aller": [
    "VERB"
  ],
  "sucrose": [
    "VERB"
  ],
  "populous": [
    "ADJ"
  ],
  "filipina": [
    "PROPN"
  ],
  "modesty": [
    "NOUN"
  ],
  "banshee": [
    "NOUN"
  ],
  "sumptuous": [
    "ADJ"
  ],
  "chronically": [
    "ADV"
  ],
  "unenforceable": [
    "ADJ"
  ],
  "fisheye": [
    "PROPN"
  ],
  "wayside": [
    "ADV"
  ],
  "spotless": [
    "VERB"
  ],
  "gerontology": [
    "NOUN"
  ],
  "predation": [
    "NOUN"
  ],
  "infestation": [
    "NOUN"
  ],
  "linearity": [
    "NOUN"
  ],
  "stylist": [
    "NOUN"
  ],
  "porosity": [
    "NOUN"
  ],
  "sprayer": [
    "PROPN"
  ],
  "barbed": [
    "VERB"
  ],
  "prognostic": [
    "PROPN"
  ],
  "unregulated": [
    "VERB"
  ],
  "hadith": [
    "PROPN"
  ],
  "ecstatic": [
    "ADJ"
  ],
  "reportable": [
    "ADJ"
  ],
  "carotene": [
    "NOUN"
  ],
  "blasphemy": [
    "NOUN"
  ],
  "countenance": [
    "NOUN"
  ],
  "skinning": [
    "VERB"
  ],
  "sanjay": [
    "PROPN"
  ],
  "compaction": [
    "NOUN"
  ],
  "methionine": [
    "NOUN"
  ],
  "delimiter": [
    "NOUN"
  ],
  "forsaken": [
    "VERB"
  ],
  "hangout": [
    "VERB"
  ],
  "amnesia": [
    "PROPN"
  ],
  "bigotry": [
    "NOUN"
  ],
  "leaky": [
    "PROPN"
  ],
  "capote": [
    "VERB"
  ],
  "molar": [
    "NOUN"
  ],
  "sunglass": [
    "NOUN"
  ],
  "afloat": [
    "VERB"
  ],
  "flattering": [
    "VERB"
  ],
  "engrossed": [
    "VERB"
  ],
  "accretion": [
    "NOUN"
  ],
  "impeach": [
    "ADV"
  ],
  "atrophy": [
    "NOUN"
  ],
  "dysplasia": [
    "NOUN"
  ],
  "utopian": [
    "ADJ"
  ],
  "totality": [
    "NOUN"
  ],
  "circumvent": [
    "NOUN"
  ],
  "epidermal": [
    "ADJ"
  ],
  "autopilot": [
    "NOUN"
  ],
  "batik": [
    "NOUN"
  ],
  "negotiator": [
    "NOUN"
  ],
  "crain": [
    "NOUN"
  ],
  "sonja": [
    "PROPN"
  ],
  "replaceable": [
    "ADJ"
  ],
  "forint": [
    "NOUN"
  ],
  "nudism": [
    "NOUN"
  ],
  "formulary": [
    "ADJ"
  ],
  "irvin": [
    "NOUN"
  ],
  "gulch": [
    "NOUN"
  ],
  "irrevocable": [
    "ADJ"
  ],
  "graciously": [
    "ADV"
  ],
  "roxbury": [
    "NOUN"
  ],
  "whiplash": [
    "NOUN"
  ],
  "radiated": [
    "VERB"
  ],
  "wiggle": [
    "VERB"
  ],
  "henna": [
    "PROPN"
  ],
  "cartesian": [
    "PROPN"
  ],
  "bribe": [
    "NOUN"
  ],
  "outspoken": [
    "ADJ"
  ],
  "asymmetrical": [
    "ADJ"
  ],
  "verily": [
    "ADV"
  ],
  "headband": [
    "NOUN"
  ],
  "ardent": [
    "ADJ"
  ],
  "outperform": [
    "NOUN"
  ],
  "harmonization": [
    "NOUN"
  ],
  "forcibly": [
    "ADV"
  ],
  "konrad": [
    "PROPN"
  ],
  "shimmer": [
    "NOUN"
  ],
  "tremor": [
    "NOUN"
  ],
  "aerodynamic": [
    "ADJ"
  ],
  "evaluative": [
    "ADJ"
  ],
  "extravagant": [
    "PROPN"
  ],
  "ghent": [
    "NOUN"
  ],
  "astute": [
    "VERB"
  ],
  "logbook": [
    "VERB"
  ],
  "inflict": [
    "VERB"
  ],
  "invalidate": [
    "VERB"
  ],
  "ridiculously": [
    "ADV"
  ],
  "legible": [
    "ADJ"
  ],
  "salted": [
    "VERB"
  ],
  "causality": [
    "NOUN"
  ],
  "tiling": [
    "VERB"
  ],
  "ethnographic": [
    "NOUN"
  ],
  "attractiveness": [
    "NOUN"
  ],
  "doubly": [
    "ADV"
  ],
  "calamity": [
    "NOUN"
  ],
  "fandango": [
    "PROPN"
  ],
  "catalysis": [
    "NOUN"
  ],
  "lisle": [
    "NOUN"
  ],
  "fiance": [
    "NOUN"
  ],
  "sprawling": [
    "VERB"
  ],
  "vulture": [
    "ADJ"
  ],
  "mislead": [
    "VERB"
  ],
  "wrongdoing": [
    "VERB"
  ],
  "ventral": [
    "ADJ"
  ],
  "gunter": [
    "NOUN"
  ],
  "medio": [
    "PROPN"
  ],
  "canto": [
    "ADP"
  ],
  "germanic": [
    "ADJ"
  ],
  "repeatable": [
    "ADJ"
  ],
  "weekender": [
    "NOUN"
  ],
  "milner": [
    "PROPN"
  ],
  "cavendish": [
    "PROPN"
  ],
  "quantization": [
    "NOUN"
  ],
  "surfacing": [
    "VERB"
  ],
  "revered": [
    "VERB"
  ],
  "gottlieb": [
    "PROPN"
  ],
  "dislocation": [
    "NOUN"
  ],
  "shingle": [
    "VERB"
  ],
  "guatemalan": [
    "PROPN"
  ],
  "iguana": [
    "PROPN"
  ],
  "glaring": [
    "VERB"
  ],
  "choker": [
    "PROPN"
  ],
  "tilting": [
    "VERB"
  ],
  "ecologically": [
    "ADV"
  ],
  "conquering": [
    "VERB"
  ],
  "spaceship": [
    "NOUN"
  ],
  "harass": [
    "NOUN"
  ],
  "meditate": [
    "NOUN"
  ],
  "tunica": [
    "PROPN"
  ],
  "aorta": [
    "PROPN"
  ],
  "unconfirmed": [
    "VERB"
  ],
  "degenerative": [
    "ADJ"
  ],
  "delve": [
    "VERB"
  ],
  "ostensibly": [
    "ADV"
  ],
  "crimp": [
    "VERB"
  ],
  "cretaceous": [
    "ADJ"
  ],
  "fished": [
    "VERB"
  ],
  "drizzle": [
    "VERB"
  ],
  "bracing": [
    "VERB"
  ],
  "blackmail": [
    "VERB"
  ],
  "playtime": [
    "ADJ"
  ],
  "criticality": [
    "NOUN"
  ],
  "remorse": [
    "NOUN"
  ],
  "clout": [
    "NOUN"
  ],
  "jours": [
    "NOUN"
  ],
  "deferral": [
    "ADJ"
  ],
  "feces": [
    "NOUN"
  ],
  "mountaineer": [
    "VERB"
  ],
  "pondering": [
    "VERB"
  ],
  "quintessential": [
    "ADJ"
  ],
  "stockpile": [
    "VERB"
  ],
  "psychics": [
    "NOUN"
  ],
  "hetero": [
    "PROPN"
  ],
  "meteorite": [
    "VERB"
  ],
  "purposely": [
    "ADV"
  ],
  "lucifer": [
    "VERB"
  ],
  "unholy": [
    "ADJ"
  ],
  "phage": [
    "NOUN"
  ],
  "spectacles": [
    "NOUN"
  ],
  "aquila": [
    "PROPN"
  ],
  "knitwear": [
    "NOUN"
  ],
  "apocalyptic": [
    "ADJ"
  ],
  "henceforth": [
    "ADV"
  ],
  "estuarine": [
    "NOUN"
  ],
  "strapping": [
    "VERB"
  ],
  "socialization": [
    "NOUN"
  ],
  "expedient": [
    "NOUN"
  ],
  "unconditionally": [
    "ADV"
  ],
  "caving": [
    "VERB"
  ],
  "alkyl": [
    "PROPN"
  ],
  "artichoke": [
    "VERB"
  ],
  "leasehold": [
    "ADV"
  ],
  "livery": [
    "NOUN"
  ],
  "recapture": [
    "PROPN"
  ],
  "chevalier": [
    "NOUN"
  ],
  "hairdressing": [
    "VERB"
  ],
  "incompatibility": [
    "NOUN"
  ],
  "navigable": [
    "ADJ"
  ],
  "biomechanics": [
    "NOUN"
  ],
  "milieu": [
    "NOUN"
  ],
  "discipleship": [
    "NOUN"
  ],
  "stonehenge": [
    "PROPN"
  ],
  "magnifier": [
    "PROPN"
  ],
  "injure": [
    "NOUN"
  ],
  "intermission": [
    "NOUN"
  ],
  "ablation": [
    "NOUN"
  ],
  "nutcracker": [
    "PROPN"
  ],
  "amazement": [
    "NOUN"
  ],
  "medusa": [
    "VERB"
  ],
  "pagoda": [
    "PROPN"
  ],
  "indentation": [
    "NOUN"
  ],
  "justly": [
    "ADV"
  ],
  "retardant": [
    "VERB"
  ],
  "shankar": [
    "PROPN"
  ],
  "barrage": [
    "VERB"
  ],
  "buoyancy": [
    "NOUN"
  ],
  "curled": [
    "VERB"
  ],
  "dermal": [
    "ADJ"
  ],
  "sizeable": [
    "ADJ"
  ],
  "tenderloin": [
    "NOUN"
  ],
  "oliva": [
    "NOUN"
  ],
  "margie": [
    "NOUN"
  ],
  "esplanade": [
    "NOUN"
  ],
  "conical": [
    "ADJ"
  ],
  "etymology": [
    "NOUN"
  ],
  "raccoon": [
    "NOUN"
  ],
  "shrinkage": [
    "NOUN"
  ],
  "cheaply": [
    "ADV"
  ],
  "allege": [
    "VERB"
  ],
  "subtly": [
    "ADV"
  ],
  "manslaughter": [
    "NOUN"
  ],
  "calibrate": [
    "VERB"
  ],
  "rambo": [
    "PROPN"
  ],
  "consort": [
    "NOUN"
  ],
  "serrano": [
    "VERB"
  ],
  "niacin": [
    "NOUN"
  ],
  "ormond": [
    "ADV"
  ],
  "bibliographical": [
    "ADJ"
  ],
  "fleeting": [
    "VERB"
  ],
  "glyph": [
    "NOUN"
  ],
  "marinated": [
    "VERB"
  ],
  "marko": [
    "PROPN"
  ],
  "urbanization": [
    "NOUN"
  ],
  "unwired": [
    "VERB"
  ],
  "skyscraper": [
    "NOUN"
  ],
  "plumb": [
    "NOUN"
  ],
  "needlework": [
    "NOUN"
  ],
  "submersible": [
    "ADJ"
  ],
  "condensate": [
    "NOUN"
  ],
  "undefeated": [
    "ADJ"
  ],
  "bacchus": [
    "PROPN"
  ],
  "chuckle": [
    "VERB"
  ],
  "unfolded": [
    "VERB"
  ],
  "unify": [
    "VERB"
  ],
  "dissident": [
    "ADJ"
  ],
  "briar": [
    "ADJ"
  ],
  "stent": [
    "NOUN"
  ],
  "angiography": [
    "NOUN"
  ],
  "dunst": [
    "ADJ"
  ],
  "bloated": [
    "ADJ"
  ],
  "plasticity": [
    "NOUN"
  ],
  "mantel": [
    "NOUN"
  ],
  "fatima": [
    "PROPN"
  ],
  "disordered": [
    "VERB"
  ],
  "belated": [
    "VERB"
  ],
  "stemmed": [
    "VERB"
  ],
  "cartoonist": [
    "NOUN"
  ],
  "englishman": [
    "NOUN"
  ],
  "flotation": [
    "NOUN"
  ],
  "winder": [
    "NOUN"
  ],
  "deterrence": [
    "NOUN"
  ],
  "junta": [
    "PROPN"
  ],
  "cardin": [
    "VERB"
  ],
  "shrunk": [
    "NOUN"
  ],
  "aardvark": [
    "PROPN"
  ],
  "cosmological": [
    "ADJ"
  ],
  "isotopic": [
    "ADJ"
  ],
  "hatchet": [
    "NOUN"
  ],
  "unsuspecting": [
    "ADJ"
  ],
  "amphetamine": [
    "NOUN"
  ],
  "grout": [
    "NOUN"
  ],
  "windfall": [
    "PROPN"
  ],
  "jocelyn": [
    "PROPN"
  ],
  "companionship": [
    "NOUN"
  ],
  "creeper": [
    "VERB"
  ],
  "illegitimate": [
    "VERB"
  ],
  "curie": [
    "PROPN"
  ],
  "undisturbed": [
    "ADJ"
  ],
  "transcendental": [
    "NOUN"
  ],
  "paola": [
    "NOUN"
  ],
  "elwood": [
    "NOUN"
  ],
  "prerelease": [
    "VERB"
  ],
  "femoral": [
    "ADJ"
  ],
  "visceral": [
    "ADJ"
  ],
  "fructose": [
    "NOUN"
  ],
  "complicate": [
    "VERB"
  ],
  "indistinguishable": [
    "ADJ"
  ],
  "extinguisher": [
    "NOUN"
  ],
  "rincon": [
    "PROPN"
  ],
  "fledgling": [
    "VERB"
  ],
  "traversal": [
    "NOUN"
  ],
  "erick": [
    "NOUN"
  ],
  "skillful": [
    "ADJ"
  ],
  "hypersensitivity": [
    "NOUN"
  ],
  "groot": [
    "NOUN"
  ],
  "compensating": [
    "VERB"
  ],
  "prosthesis": [
    "NOUN"
  ],
  "reasonableness": [
    "VERB"
  ],
  "knuckle": [
    "NOUN"
  ],
  "taker": [
    "NOUN"
  ],
  "bastion": [
    "NOUN"
  ],
  "scraping": [
    "VERB"
  ],
  "tupelo": [
    "PUNCT"
  ],
  "concurring": [
    "VERB"
  ],
  "assemblage": [
    "NOUN"
  ],
  "watery": [
    "ADJ"
  ],
  "aylesbury": [
    "NOUN"
  ],
  "coiled": [
    "VERB"
  ],
  "chondroitin": [
    "NOUN"
  ],
  "beatrix": [
    "VERB"
  ],
  "sandpiper": [
    "NOUN"
  ],
  "cheerfully": [
    "ADV"
  ],
  "paleontology": [
    "NOUN"
  ],
  "sledge": [
    "PROPN"
  ],
  "stepper": [
    "NOUN"
  ],
  "gilded": [
    "VERB"
  ],
  "murdering": [
    "VERB"
  ],
  "unbroken": [
    "VERB"
  ],
  "tropic": [
    "NOUN"
  ],
  "capella": [
    "PROPN"
  ],
  "condemning": [
    "VERB"
  ],
  "urethane": [
    "NOUN"
  ],
  "entourage": [
    "NOUN"
  ],
  "familia": [
    "X"
  ],
  "realist": [
    "VERB"
  ],
  "geochemistry": [
    "NOUN"
  ],
  "reflectivity": [
    "NOUN"
  ],
  "linea": [
    "VERB"
  ],
  "scorn": [
    "VERB"
  ],
  "whirl": [
    "PROPN"
  ],
  "pervert": [
    "PROPN"
  ],
  "asymptomatic": [
    "PROPN"
  ],
  "humiliating": [
    "ADJ"
  ],
  "circled": [
    "VERB"
  ],
  "withers": [
    "NOUN"
  ],
  "sprout": [
    "PROPN"
  ],
  "minot": [
    "NOUN"
  ],
  "evidentiary": [
    "ADJ"
  ],
  "clinging": [
    "VERB"
  ],
  "bagged": [
    "VERB"
  ],
  "synthesize": [
    "NOUN"
  ],
  "deviate": [
    "VERB"
  ],
  "whereupon": [
    "ADV"
  ],
  "racially": [
    "ADV"
  ],
  "expertly": [
    "ADV"
  ],
  "muriel": [
    "VERB"
  ],
  "atelier": [
    "PROPN"
  ],
  "colloidal": [
    "NOUN"
  ],
  "guarantor": [
    "NOUN"
  ],
  "imperialist": [
    "NOUN"
  ],
  "tibia": [
    "PROPN"
  ],
  "conte": [
    "PROPN"
  ],
  "tulare": [
    "PROPN"
  ],
  "sundries": [
    "NOUN"
  ],
  "horatio": [
    "NOUN"
  ],
  "cheered": [
    "VERB"
  ],
  "danzig": [
    "PROPN"
  ],
  "irreducible": [
    "ADJ"
  ],
  "trixie": [
    "ADV"
  ],
  "ridgeway": [
    "NOUN"
  ],
  "verifier": [
    "NOUN"
  ],
  "eurasian": [
    "PROPN"
  ],
  "solace": [
    "NOUN"
  ],
  "pesky": [
    "ADJ"
  ],
  "salvia": [
    "ADJ"
  ],
  "unloaded": [
    "VERB"
  ],
  "projectile": [
    "NOUN"
  ],
  "stucco": [
    "NOUN"
  ],
  "tiburon": [
    "NOUN"
  ],
  "intrinsically": [
    "ADV"
  ],
  "impervious": [
    "ADJ"
  ],
  "andaman": [
    "NOUN"
  ],
  "reauthorization": [
    "NOUN"
  ],
  "poolside": [
    "NOUN"
  ],
  "flourishing": [
    "VERB"
  ],
  "palatine": [
    "NOUN"
  ],
  "motorist": [
    "NOUN"
  ],
  "peritoneal": [
    "VERB"
  ],
  "carnation": [
    "NOUN"
  ],
  "publicize": [
    "VERB"
  ],
  "bulimia": [
    "NOUN"
  ],
  "ladybug": [
    "PROPN"
  ],
  "analyser": [
    "NOUN"
  ],
  "ruffle": [
    "VERB"
  ],
  "algorithmic": [
    "ADJ"
  ],
  "rectifier": [
    "ADV"
  ],
  "bassoon": [
    "NOUN"
  ],
  "knack": [
    "VERB"
  ],
  "rivet": [
    "NOUN"
  ],
  "aggie": [
    "NOUN"
  ],
  "tilly": [
    "ADV"
  ],
  "denominational": [
    "ADJ"
  ],
  "grunt": [
    "VERB"
  ],
  "talmud": [
    "NOUN"
  ],
  "spreader": [
    "NOUN"
  ],
  "otolaryngology": [
    "NOUN"
  ],
  "overalls": [
    "NOUN"
  ],
  "lagrangian": [
    "PROPN"
  ],
  "whistling": [
    "VERB"
  ],
  "ailing": [
    "VERB"
  ],
  "ghostly": [
    "ADV"
  ],
  "hippocampus": [
    "PROPN"
  ],
  "mutiny": [
    "PROPN"
  ],
  "foresee": [
    "VERB"
  ],
  "bitterly": [
    "ADV"
  ],
  "perpetrator": [
    "VERB"
  ],
  "actionable": [
    "ADJ",
    "PROPN"
  ],
  "cornea": [
    "NOUN"
  ],
  "overfull": [
    "INTJ"
  ],
  "cleverly": [
    "ADV"
  ],
  "kitchenette": [
    "NOUN"
  ],
  "liberian": [
    "PROPN"
  ],
  "numerology": [
    "NOUN"
  ],
  "normalize": [
    "VERB"
  ],
  "sisterhood": [
    "NOUN"
  ],
  "lightening": [
    "VERB"
  ],
  "overturn": [
    "NOUN"
  ],
  "thoughtfully": [
    "ADV"
  ],
  "kieran": [
    "PROPN"
  ],
  "triplet": [
    "NOUN"
  ],
  "rencontre": [
    "NOUN"
  ],
  "lotta": [
    "PROPN"
  ],
  "ingress": [
    "NOUN",
    "PROPN"
  ],
  "tentacle": [
    "NOUN"
  ],
  "salespeople": [
    "NOUN"
  ],
  "motility": [
    "NOUN"
  ],
  "dengue": [
    "NOUN"
  ],
  "commotion": [
    "NOUN"
  ],
  "incineration": [
    "NOUN"
  ],
  "deduce": [
    "NOUN"
  ],
  "unbreakable": [
    "ADJ"
  ],
  "materialism": [
    "NOUN"
  ],
  "eternally": [
    "ADV"
  ],
  "senseless": [
    "NOUN"
  ],
  "rabid": [
    "VERB"
  ],
  "reassure": [
    "VERB"
  ],
  "cumin": [
    "NOUN"
  ],
  "inertial": [
    "ADJ"
  ],
  "unwritten": [
    "VERB"
  ],
  "payee": [
    "NOUN"
  ],
  "cinematographer": [
    "PROPN"
  ],
  "preorder": [
    "NOUN"
  ],
  "ventilator": [
    "NOUN"
  ],
  "housekeeper": [
    "NOUN"
  ],
  "pediatrician": [
    "NOUN"
  ],
  "cymbal": [
    "PROPN"
  ],
  "convective": [
    "ADJ"
  ],
  "haymarket": [
    "NOUN"
  ],
  "agrarian": [
    "PROPN"
  ],
  "nosed": [
    "ADJ"
  ],
  "shogun": [
    "NOUN"
  ],
  "microbiological": [
    "ADJ"
  ],
  "lovable": [
    "ADJ"
  ],
  "pseudoephedrine": [
    "NOUN"
  ],
  "stockholder": [
    "NOUN"
  ],
  "quanta": [
    "PROPN"
  ],
  "synapse": [
    "NOUN"
  ],
  "sawmill": [
    "ADV"
  ],
  "abram": [
    "VERB"
  ],
  "catharine": [
    "NOUN"
  ],
  "uppers": [
    "NOUN"
  ],
  "pitman": [
    "NOUN"
  ],
  "embossing": [
    "VERB"
  ],
  "congested": [
    "VERB"
  ],
  "meticulous": [
    "ADJ"
  ],
  "buttermilk": [
    "NOUN"
  ],
  "dendritic": [
    "ADJ"
  ],
  "minima": [
    "PROPN"
  ],
  "mikael": [
    "PROPN"
  ],
  "conceptually": [
    "ADV"
  ],
  "flurry": [
    "VERB"
  ],
  "capping": [
    "VERB"
  ],
  "parisian": [
    "PROPN"
  ],
  "humanism": [
    "NOUN"
  ],
  "unusable": [
    "ADJ"
  ],
  "tigger": [
    "NOUN"
  ],
  "bertram": [
    "PROPN"
  ],
  "skylight": [
    "NOUN"
  ],
  "periodontal": [
    "ADJ"
  ],
  "uncredited": [
    "ADJ"
  ],
  "gemma": [
    "NOUN"
  ],
  "rupiah": [
    "PROPN"
  ],
  "bullish": [
    "ADJ"
  ],
  "hippy": [
    "ADJ"
  ],
  "northerner": [
    "NOUN"
  ],
  "mackintosh": [
    "PROPN"
  ],
  "layne": [
    "PROPN"
  ],
  "moonstone": [
    "NOUN"
  ],
  "sheng": [
    "PROPN"
  ],
  "unsolved": [
    "VERB"
  ],
  "strenuous": [
    "ADJ"
  ],
  "roost": [
    "VERB"
  ],
  "unreasonably": [
    "ADV"
  ],
  "shuffling": [
    "VERB"
  ],
  "ludicrous": [
    "ADJ"
  ],
  "amyloid": [
    "NOUN"
  ],
  "understandably": [
    "ADV"
  ],
  "icarus": [
    "NOUN"
  ],
  "steadfast": [
    "ADJ"
  ],
  "niall": [
    "PROPN"
  ],
  "promissory": [
    "NOUN"
  ],
  "fuchsia": [
    "NOUN"
  ],
  "muscat": [
    "NOUN"
  ],
  "squarely": [
    "ADV"
  ],
  "softness": [
    "VERB"
  ],
  "crayon": [
    "NOUN"
  ],
  "rotting": [
    "VERB"
  ],
  "salamander": [
    "ADV"
  ],
  "exhilarating": [
    "VERB"
  ],
  "lukas": [
    "NOUN"
  ],
  "aswell": [
    "ADJ"
  ],
  "skippy": [
    "ADJ"
  ],
  "marque": [
    "NOUN"
  ],
  "evade": [
    "VERB"
  ],
  "systematics": [
    "NOUN"
  ],
  "renderer": [
    "NOUN",
    "PROPN"
  ],
  "rework": [
    "NOUN"
  ],
  "scourge": [
    "VERB"
  ],
  "bandage": [
    "NOUN"
  ],
  "detach": [
    "PROPN"
  ],
  "webby": [
    "PROPN"
  ],
  "virginity": [
    "NOUN"
  ],
  "apogee": [
    "VERB"
  ],
  "doctrinal": [
    "ADJ"
  ],
  "worsen": [
    "VERB"
  ],
  "adaptability": [
    "NOUN"
  ],
  "cramped": [
    "VERB"
  ],
  "whopping": [
    "ADJ"
  ],
  "racking": [
    "VERB"
  ],
  "shunt": [
    "VERB"
  ],
  "synch": [
    "NOUN"
  ],
  "patten": [
    "VERB"
  ],
  "obedient": [
    "NOUN"
  ],
  "outrigger": [
    "NOUN"
  ],
  "enclave": [
    "VERB"
  ],
  "anxiously": [
    "ADV"
  ],
  "fibrillation": [
    "NOUN"
  ],
  "licorice": [
    "PROPN"
  ],
  "statically": [
    "ADV"
  ],
  "developmentally": [
    "ADV"
  ],
  "optimist": [
    "PROPN"
  ],
  "gratification": [
    "NOUN"
  ],
  "seashore": [
    "NOUN"
  ],
  "automaton": [
    "PROPN"
  ],
  "unskilled": [
    "VERB"
  ],
  "marinade": [
    "NOUN"
  ],
  "brigadier": [
    "NOUN"
  ],
  "stratosphere": [
    "NOUN"
  ],
  "consonant": [
    "ADJ"
  ],
  "acetic": [
    "ADJ"
  ],
  "nicaraguan": [
    "PROPN"
  ],
  "unarmed": [
    "ADJ"
  ],
  "dyeing": [
    "VERB"
  ],
  "intolerable": [
    "ADJ"
  ],
  "tawny": [
    "NOUN"
  ],
  "insulator": [
    "NOUN"
  ],
  "endometrial": [
    "ADJ"
  ],
  "absinthe": [
    "ADP"
  ],
  "hegemony": [
    "NOUN"
  ],
  "tryptophan": [
    "ADP"
  ],
  "hygienic": [
    "ADJ"
  ],
  "extensibility": [
    "NOUN",
    "PROPN"
  ],
  "tahitian": [
    "PROPN"
  ],
  "bianco": [
    "PROPN"
  ],
  "salma": [
    "NOUN"
  ],
  "layman": [
    "NOUN"
  ],
  "bungee": [
    "NOUN"
  ],
  "vellum": [
    "NOUN"
  ],
  "ignatius": [
    "NOUN"
  ],
  "stanza": [
    "PROPN"
  ],
  "mucus": [
    "NOUN"
  ],
  "suspenders": [
    "NOUN"
  ],
  "londres": [
    "NOUN"
  ],
  "dismantle": [
    "VERB"
  ],
  "pharos": [
    "NOUN"
  ],
  "bequest": [
    "VERB"
  ],
  "eavesdropping": [
    "VERB"
  ],
  "redeemer": [
    "NOUN"
  ],
  "numerator": [
    "PROPN"
  ],
  "florin": [
    "PROPN"
  ],
  "quixote": [
    "VERB"
  ],
  "resurgence": [
    "NOUN"
  ],
  "chaise": [
    "VERB"
  ],
  "paternal": [
    "ADJ"
  ],
  "carburetor": [
    "NOUN"
  ],
  "indigent": [
    "ADJ"
  ],
  "trellis": [
    "NOUN"
  ],
  "jeopardize": [
    "VERB"
  ],
  "hydrolase": [
    "NOUN"
  ],
  "crystallization": [
    "NOUN"
  ],
  "someplace": [
    "NOUN"
  ],
  "antibacterial": [
    "ADJ"
  ],
  "extremism": [
    "NOUN"
  ],
  "fluctuate": [
    "NOUN"
  ],
  "recitation": [
    "NOUN"
  ],
  "macrophage": [
    "VERB"
  ],
  "aptly": [
    "ADV"
  ],
  "alleviation": [
    "NOUN"
  ],
  "liege": [
    "NOUN"
  ],
  "councilor": [
    "NOUN"
  ],
  "jellyfish": [
    "PROPN"
  ],
  "papyrus": [
    "NOUN"
  ],
  "candlestick": [
    "VERB"
  ],
  "writable": [
    "ADJ"
  ],
  "reflectance": [
    "NOUN"
  ],
  "circling": [
    "VERB"
  ],
  "sheik": [
    "NOUN"
  ],
  "coliform": [
    "NOUN"
  ],
  "selena": [
    "NOUN"
  ],
  "realignment": [
    "NOUN"
  ],
  "girdle": [
    "NOUN"
  ],
  "siamese": [
    "PROPN"
  ],
  "veiled": [
    "VERB"
  ],
  "blotting": [
    "VERB"
  ],
  "javelin": [
    "NOUN"
  ],
  "bouncer": [
    "VERB"
  ],
  "phenol": [
    "NOUN"
  ],
  "grundy": [
    "ADJ"
  ],
  "eastward": [
    "ADV"
  ],
  "histamine": [
    "ADV"
  ],
  "bedlam": [
    "VERB"
  ],
  "entree": [
    "ADV"
  ],
  "synergistic": [
    "ADJ"
  ],
  "desist": [
    "VERB"
  ],
  "grasshopper": [
    "VERB"
  ],
  "rheumatic": [
    "ADJ"
  ],
  "autobiographical": [
    "ADJ"
  ],
  "piety": [
    "NOUN"
  ],
  "embody": [
    "VERB"
  ],
  "handball": [
    "NOUN"
  ],
  "soiled": [
    "VERB"
  ],
  "froze": [
    "VERB"
  ],
  "superfluous": [
    "ADJ"
  ],
  "plexus": [
    "NOUN"
  ],
  "systolic": [
    "ADJ"
  ],
  "unreachable": [
    "ADJ"
  ],
  "disarm": [
    "NOUN"
  ],
  "tacit": [
    "NOUN"
  ],
  "modernist": [
    "NOUN"
  ],
  "waring": [
    "VERB"
  ],
  "parenthesis": [
    "NOUN"
  ],
  "daybreak": [
    "NOUN"
  ],
  "pentecost": [
    "PROPN"
  ],
  "weathering": [
    "VERB"
  ],
  "totalitarian": [
    "PROPN"
  ],
  "interrelated": [
    "VERB"
  ],
  "beulah": [
    "VERB"
  ],
  "southbound": [
    "VERB"
  ],
  "unveiling": [
    "VERB"
  ],
  "astray": [
    "INTJ"
  ],
  "infirmary": [
    "NOUN"
  ],
  "firebox": [
    "PROPN"
  ],
  "synopses": [
    "NOUN"
  ],
  "sanctity": [
    "NOUN"
  ],
  "pedantic": [
    "ADJ"
  ],
  "notoriously": [
    "ADV"
  ],
  "lucius": [
    "PROPN"
  ],
  "deadwood": [
    "NOUN"
  ],
  "kirsty": [
    "PROPN"
  ],
  "caustic": [
    "ADJ"
  ],
  "emporia": [
    "PROPN"
  ],
  "gleaming": [
    "VERB"
  ],
  "parochial": [
    "ADJ"
  ],
  "bertie": [
    "ADJ"
  ],
  "sledding": [
    "VERB"
  ],
  "excision": [
    "NOUN"
  ],
  "traceability": [
    "NOUN"
  ],
  "lemony": [
    "PROPN"
  ],
  "basset": [
    "VERB"
  ],
  "limiter": [
    "NOUN"
  ],
  "pretext": [
    "VERB"
  ],
  "comprehensively": [
    "ADV"
  ],
  "whisk": [
    "NOUN"
  ],
  "deference": [
    "NOUN"
  ],
  "limelight": [
    "ADJ"
  ],
  "artful": [
    "ADJ"
  ],
  "criss": [
    "VERB"
  ],
  "glynn": [
    "PROPN"
  ],
  "audacity": [
    "NOUN"
  ],
  "unmet": [
    "ADJ"
  ],
  "compositional": [
    "ADJ"
  ],
  "catawba": [
    "NOUN"
  ],
  "ordinal": [
    "ADJ"
  ],
  "inasmuch": [
    "ADJ"
  ],
  "caress": [
    "NOUN"
  ],
  "wilfred": [
    "VERB"
  ],
  "mauve": [
    "NOUN"
  ],
  "twitch": [
    "VERB"
  ],
  "polluting": [
    "VERB"
  ],
  "combed": [
    "VERB"
  ],
  "pedicure": [
    "NOUN"
  ],
  "spore": [
    "VERB"
  ],
  "unrealized": [
    "VERB"
  ],
  "paraphrase": [
    "NOUN"
  ],
  "flounder": [
    "NOUN"
  ],
  "crept": [
    "VERB"
  ],
  "fibrous": [
    "ADJ"
  ],
  "epilogue": [
    "VERB"
  ],
  "epistle": [
    "NOUN"
  ],
  "acetone": [
    "NOUN"
  ],
  "alanine": [
    "NOUN"
  ],
  "clapping": [
    "VERB"
  ],
  "finesse": [
    "PROPN"
  ],
  "blitzkrieg": [
    "NOUN"
  ],
  "cordelia": [
    "NOUN"
  ],
  "infrequently": [
    "ADV"
  ],
  "banbury": [
    "NOUN"
  ],
  "favoring": [
    "VERB"
  ],
  "converging": [
    "VERB"
  ],
  "choctaw": [
    "NOUN"
  ],
  "inquisition": [
    "NOUN"
  ],
  "reputed": [
    "VERB"
  ],
  "dinah": [
    "PROPN"
  ],
  "kimono": [
    "PROPN"
  ],
  "underpinning": [
    "VERB"
  ],
  "resistivity": [
    "NOUN"
  ],
  "impossibility": [
    "NOUN"
  ],
  "ceylon": [
    "NOUN"
  ],
  "conformal": [
    "PROPN"
  ],
  "courant": [
    "NOUN"
  ],
  "sherri": [
    "PROPN"
  ],
  "eminence": [
    "NOUN"
  ],
  "canna": [
    "PROPN"
  ],
  "liberate": [
    "VERB"
  ],
  "bombardier": [
    "ADJ"
  ],
  "cytotoxic": [
    "ADJ"
  ],
  "gunther": [
    "NOUN"
  ],
  "colophon": [
    "PROPN"
  ],
  "morin": [
    "PROPN"
  ],
  "flatter": [
    "VERB"
  ],
  "unforgiven": [
    "ADJ"
  ],
  "thesauri": [
    "X"
  ],
  "dimmer": [
    "NOUN"
  ],
  "relais": [
    "PROPN"
  ],
  "dredge": [
    "VERB"
  ],
  "tingling": [
    "VERB"
  ],
  "cordial": [
    "ADJ"
  ],
  "reassurance": [
    "NOUN"
  ],
  "unannotated": [
    "VERB"
  ],
  "nervousness": [
    "NOUN"
  ],
  "patchy": [
    "ADJ"
  ],
  "quarrel": [
    "NOUN"
  ],
  "millennia": [
    "NOUN"
  ],
  "frith": [
    "PROPN"
  ],
  "transitive": [
    "ADJ"
  ],
  "connoisseur": [
    "PROPN"
  ],
  "idealism": [
    "NOUN"
  ],
  "separable": [
    "ADJ"
  ],
  "positron": [
    "X"
  ],
  "metallurgical": [
    "ADJ"
  ],
  "molybdenum": [
    "NOUN"
  ],
  "liqueur": [
    "PROPN"
  ],
  "pastime": [
    "NOUN"
  ],
  "hexagonal": [
    "ADJ"
  ],
  "throated": [
    "VERB"
  ],
  "contravention": [
    "NOUN"
  ],
  "bugle": [
    "VERB"
  ],
  "disperse": [
    "VERB"
  ],
  "binomial": [
    "ADJ"
  ],
  "incoherent": [
    "ADJ"
  ],
  "mullet": [
    "NOUN"
  ],
  "canfield": [
    "VERB"
  ],
  "renovate": [
    "PROPN",
    "NOUN"
  ],
  "devout": [
    "ADJ"
  ],
  "strom": [
    "PROPN"
  ],
  "actuary": [
    "ADJ"
  ],
  "purdy": [
    "VERB"
  ],
  "unfurnished": [
    "VERB"
  ],
  "rattus": [
    "PROPN"
  ],
  "blinding": [
    "VERB"
  ],
  "cosmetology": [
    "NOUN"
  ],
  "emitter": [
    "NOUN"
  ],
  "inaction": [
    "NOUN"
  ],
  "northward": [
    "PROPN"
  ],
  "trotter": [
    "NOUN"
  ],
  "subversive": [
    "NOUN"
  ],
  "breathless": [
    "VERB"
  ],
  "steen": [
    "NOUN"
  ],
  "devolution": [
    "NOUN"
  ],
  "corkscrew": [
    "VERB"
  ],
  "reunification": [
    "NOUN"
  ],
  "izumi": [
    "PROPN"
  ],
  "purgatory": [
    "NOUN"
  ],
  "dooley": [
    "NOUN"
  ],
  "comer": [
    "NOUN"
  ],
  "unsaturated": [
    "VERB"
  ],
  "tillage": [
    "NOUN"
  ],
  "nonexistent": [
    "ADJ"
  ],
  "easterly": [
    "ADV"
  ],
  "jackman": [
    "PROPN"
  ],
  "lagged": [
    "VERB"
  ],
  "biophysical": [
    "ADJ"
  ],
  "belton": [
    "PROPN"
  ],
  "tapas": [
    "PROPN"
  ],
  "hawker": [
    "PROPN"
  ],
  "calla": [
    "NOUN"
  ],
  "toughness": [
    "NOUN"
  ],
  "disrespect": [
    "ADJ"
  ],
  "exclusivity": [
    "NOUN"
  ],
  "lifeguard": [
    "PROPN"
  ],
  "lagging": [
    "VERB"
  ],
  "indeterminate": [
    "VERB"
  ],
  "kilmarnock": [
    "NOUN"
  ],
  "refreshment": [
    "NOUN"
  ],
  "momentarily": [
    "ADV"
  ],
  "rosette": [
    "NOUN"
  ],
  "licensor": [
    "NOUN"
  ],
  "changeable": [
    "ADJ"
  ],
  "tragically": [
    "ADV"
  ],
  "coexistence": [
    "NOUN"
  ],
  "amritsar": [
    "VERB"
  ],
  "justifiable": [
    "ADJ"
  ],
  "twofold": [
    "ADV"
  ],
  "sicilian": [
    "PROPN"
  ],
  "anesthetic": [
    "ADJ"
  ],
  "anisotropy": [
    "VERB"
  ],
  "unearned": [
    "ADJ"
  ],
  "thwart": [
    "VERB"
  ],
  "potted": [
    "VERB"
  ],
  "chanson": [
    "PROPN"
  ],
  "redox": [
    "PROPN"
  ],
  "cladding": [
    "VERB"
  ],
  "retransmission": [
    "NOUN"
  ],
  "meticulously": [
    "ADV"
  ],
  "convalescent": [
    "NOUN"
  ],
  "sitka": [
    "PROPN"
  ],
  "mackerel": [
    "NOUN"
  ],
  "clinch": [
    "NOUN"
  ],
  "provident": [
    "ADJ"
  ],
  "leprosy": [
    "NOUN"
  ],
  "fitter": [
    "NOUN"
  ],
  "fasten": [
    "VERB"
  ],
  "locksmith": [
    "PROPN"
  ],
  "interrupting": [
    "VERB"
  ],
  "sulla": [
    "NOUN"
  ],
  "daggers": [
    "NOUN"
  ],
  "jamboree": [
    "NOUN"
  ],
  "multicolor": [
    "NOUN"
  ],
  "moors": [
    "NOUN"
  ],
  "geranium": [
    "NOUN"
  ],
  "tritium": [
    "NOUN"
  ],
  "revolve": [
    "VERB"
  ],
  "isomorphism": [
    "NOUN"
  ],
  "waged": [
    "VERB"
  ],
  "stockbridge": [
    "NOUN"
  ],
  "concourse": [
    "VERB"
  ],
  "confine": [
    "NOUN"
  ],
  "jaded": [
    "VERB"
  ],
  "mingle": [
    "PROPN"
  ],
  "yardage": [
    "VERB"
  ],
  "purify": [
    "VERB"
  ],
  "radii": [
    "NOUN"
  ],
  "desolate": [
    "VERB"
  ],
  "expander": [
    "NOUN"
  ],
  "whereof": [
    "NOUN"
  ],
  "electrolysis": [
    "NOUN"
  ],
  "gruesome": [
    "ADJ"
  ],
  "peroxidase": [
    "NOUN"
  ],
  "rahul": [
    "PROPN"
  ],
  "perished": [
    "VERB"
  ],
  "pringle": [
    "NOUN"
  ],
  "outcast": [
    "NOUN"
  ],
  "faraday": [
    "NOUN"
  ],
  "oblong": [
    "PROPN"
  ],
  "macabre": [
    "NOUN"
  ],
  "ophelia": [
    "INTJ"
  ],
  "popeye": [
    "NOUN"
  ],
  "wearer": [
    "NOUN"
  ],
  "spotter": [
    "NOUN"
  ],
  "propriety": [
    "NOUN"
  ],
  "declarative": [
    "VERB"
  ],
  "semaphore": [
    "ADJ"
  ],
  "attainable": [
    "ADJ"
  ],
  "hearsay": [
    "VERB"
  ],
  "tristate": [
    "ADJ"
  ],
  "standardize": [
    "VERB"
  ],
  "knickers": [
    "NOUN"
  ],
  "roomy": [
    "NOUN"
  ],
  "brutus": [
    "PROPN"
  ],
  "angioplasty": [
    "VERB"
  ],
  "obscurity": [
    "NOUN"
  ],
  "deseret": [
    "PROPN"
  ],
  "matting": [
    "VERB"
  ],
  "overflowing": [
    "VERB"
  ],
  "androgen": [
    "VERB"
  ],
  "entice": [
    "NOUN"
  ],
  "kilogram": [
    "PROPN"
  ],
  "pacemaker": [
    "NOUN"
  ],
  "lasso": [
    "NOUN"
  ],
  "yonder": [
    "PROPN"
  ],
  "virulence": [
    "NOUN"
  ],
  "standout": [
    "VERB"
  ],
  "heretic": [
    "ADJ"
  ],
  "comparability": [
    "NOUN"
  ],
  "industrialization": [
    "NOUN"
  ],
  "cabana": [
    "PROPN"
  ],
  "draught": [
    "VERB"
  ],
  "comical": [
    "ADJ"
  ],
  "catwalk": [
    "NOUN"
  ],
  "homesite": [
    "PROPN"
  ],
  "boarder": [
    "PROPN"
  ],
  "pecos": [
    "NOUN"
  ],
  "blurry": [
    "PROPN"
  ],
  "minibus": [
    "PROPN"
  ],
  "bumping": [
    "VERB"
  ],
  "unfunded": [
    "ADJ"
  ],
  "ballooning": [
    "VERB"
  ],
  "amplify": [
    "VERB"
  ],
  "bevel": [
    "NOUN"
  ],
  "straining": [
    "VERB"
  ],
  "strapless": [
    "NOUN"
  ],
  "qualitatively": [
    "ADV"
  ],
  "whitefish": [
    "PROPN"
  ],
  "ejection": [
    "NOUN"
  ],
  "puyallup": [
    "PROPN"
  ],
  "dodgy": [
    "VERB"
  ],
  "parasitology": [
    "NOUN"
  ],
  "thymus": [
    "NOUN"
  ],
  "lesbianism": [
    "NOUN"
  ],
  "angrily": [
    "ADV"
  ],
  "belive": [
    "NOUN"
  ],
  "croquet": [
    "VERB"
  ],
  "vacate": [
    "VERB"
  ],
  "phytoplankton": [
    "PROPN"
  ],
  "neath": [
    "NOUN"
  ],
  "soundness": [
    "NOUN"
  ],
  "generational": [
    "ADJ"
  ],
  "marquise": [
    "NOUN"
  ],
  "burrito": [
    "PROPN"
  ],
  "coriander": [
    "NOUN"
  ],
  "protracted": [
    "VERB"
  ],
  "siegfried": [
    "VERB"
  ],
  "manipulative": [
    "ADJ"
  ],
  "hypnotize": [
    "VERB"
  ],
  "eyelid": [
    "ADJ"
  ],
  "evocative": [
    "ADJ"
  ],
  "undeniable": [
    "ADJ"
  ],
  "repressed": [
    "VERB"
  ],
  "perforce": [
    "NOUN"
  ],
  "boundless": [
    "VERB"
  ],
  "hopelessly": [
    "ADV"
  ],
  "amphibian": [
    "PROPN"
  ],
  "grandchild": [
    "ADJ"
  ],
  "substation": [
    "NOUN"
  ],
  "optically": [
    "ADV"
  ],
  "sucre": [
    "NOUN"
  ],
  "pasteur": [
    "NOUN"
  ],
  "affine": [
    "NOUN"
  ],
  "indignation": [
    "NOUN"
  ],
  "sprinkled": [
    "VERB"
  ],
  "antichrist": [
    "NOUN"
  ],
  "subcutaneous": [
    "ADJ"
  ],
  "creatinine": [
    "NOUN"
  ],
  "factorization": [
    "NOUN"
  ],
  "reiterate": [
    "VERB"
  ],
  "reliever": [
    "PROPN"
  ],
  "ender": [
    "PROPN"
  ],
  "indenture": [
    "NOUN"
  ],
  "shocker": [
    "NOUN"
  ],
  "sowing": [
    "VERB"
  ],
  "refrigerant": [
    "ADJ"
  ],
  "shearing": [
    "PROPN"
  ],
  "presidio": [
    "NOUN"
  ],
  "pinion": [
    "NOUN"
  ],
  "windward": [
    "NOUN"
  ],
  "brawl": [
    "NOUN"
  ],
  "delirium": [
    "NOUN"
  ],
  "collaborator": [
    "NOUN",
    "PROPN"
  ],
  "unfounded": [
    "VERB"
  ],
  "heroism": [
    "NOUN"
  ],
  "xenopus": [
    "PROPN"
  ],
  "kiwanis": [
    "PROPN"
  ],
  "barrister": [
    "NOUN"
  ],
  "assertive": [
    "ADJ"
  ],
  "weirdness": [
    "NOUN"
  ],
  "saxony": [
    "PROPN"
  ],
  "karel": [
    "PROPN"
  ],
  "glycogen": [
    "PROPN"
  ],
  "hoosier": [
    "ADV"
  ],
  "balearic": [
    "VERB"
  ],
  "toluene": [
    "ADV"
  ],
  "tubal": [
    "PROPN"
  ],
  "entangled": [
    "VERB"
  ],
  "taupo": [
    "NOUN"
  ],
  "possum": [
    "NOUN"
  ],
  "tonneau": [
    "PROPN"
  ],
  "cynicism": [
    "NOUN"
  ],
  "bayonet": [
    "NOUN"
  ],
  "considerate": [
    "VERB"
  ],
  "toxicological": [
    "ADJ"
  ],
  "extraneous": [
    "ADJ"
  ],
  "janitor": [
    "NOUN"
  ],
  "environs": [
    "NOUN"
  ],
  "platypus": [
    "PROPN"
  ],
  "thereunder": [
    "VERB"
  ],
  "holla": [
    "NOUN"
  ],
  "reunite": [
    "NOUN"
  ],
  "mohair": [
    "PROPN"
  ],
  "chore": [
    "NOUN"
  ],
  "hawkeye": [
    "NOUN"
  ],
  "crockery": [
    "NOUN"
  ],
  "presidente": [
    "VERB"
  ],
  "pertussis": [
    "NOUN"
  ],
  "concentrator": [
    "NOUN"
  ],
  "astrophysical": [
    "ADJ"
  ],
  "pairwise": [
    "NOUN"
  ],
  "enticing": [
    "VERB"
  ],
  "embankment": [
    "NOUN"
  ],
  "quadruple": [
    "NOUN"
  ],
  "crazed": [
    "VERB"
  ],
  "filmstrip": [
    "PROPN"
  ],
  "shortcake": [
    "VERB"
  ],
  "fondly": [
    "ADV"
  ],
  "whither": [
    "NOUN"
  ],
  "chilliwack": [
    "NOUN"
  ],
  "counteract": [
    "VERB"
  ],
  "discouraging": [
    "VERB"
  ],
  "paramilitary": [
    "ADJ"
  ],
  "flipper": [
    "NOUN"
  ],
  "eyeball": [
    "NOUN"
  ],
  "outfitter": [
    "VERB"
  ],
  "immunological": [
    "ADJ"
  ],
  "phenyl": [
    "NOUN"
  ],
  "preservative": [
    "ADJ"
  ],
  "famously": [
    "ADV"
  ],
  "tribulation": [
    "NOUN"
  ],
  "falco": [
    "NOUN"
  ],
  "controllable": [
    "ADJ"
  ],
  "surfactant": [
    "NOUN"
  ],
  "culvert": [
    "NOUN"
  ],
  "prescriptive": [
    "ADJ"
  ],
  "salaried": [
    "VERB"
  ],
  "spanner": [
    "NOUN"
  ],
  "firehouse": [
    "NOUN"
  ],
  "intolerant": [
    "ADJ"
  ],
  "battled": [
    "VERB"
  ],
  "orthodontic": [
    "ADJ"
  ],
  "lithography": [
    "NOUN"
  ],
  "proofreading": [
    "VERB"
  ],
  "discredit": [
    "NOUN"
  ],
  "grotesque": [
    "VERB"
  ],
  "reinhard": [
    "ADJ"
  ],
  "suburbia": [
    "PROPN"
  ],
  "crucible": [
    "PROPN"
  ],
  "modena": [
    "PROPN"
  ],
  "generalize": [
    "VERB"
  ],
  "hasta": [
    "NOUN"
  ],
  "embryology": [
    "NOUN"
  ],
  "styrene": [
    "ADJ"
  ],
  "alumnae": [
    "NOUN"
  ],
  "inducible": [
    "NOUN"
  ],
  "misconception": [
    "NOUN"
  ],
  "rudimentary": [
    "ADJ"
  ],
  "riesling": [
    "VERB"
  ],
  "triage": [
    "PROPN",
    "NOUN"
  ],
  "protege": [
    "NOUN"
  ],
  "settler": [
    "VERB"
  ],
  "silencer": [
    "NOUN"
  ],
  "rabble": [
    "ADJ"
  ],
  "allergen": [
    "VERB"
  ],
  "piped": [
    "VERB"
  ],
  "orpheus": [
    "PROPN"
  ],
  "retour": [
    "ADJ"
  ],
  "insurgent": [
    "NOUN"
  ],
  "crystallography": [
    "NOUN"
  ],
  "frosting": [
    "VERB"
  ],
  "rightfully": [
    "ADV"
  ],
  "nightwear": [
    "VERB"
  ],
  "sconce": [
    "NOUN"
  ],
  "medici": [
    "VERB"
  ],
  "impressionist": [
    "NOUN"
  ],
  "stagnant": [
    "ADJ"
  ],
  "tekken": [
    "VERB"
  ],
  "lactic": [
    "ADJ"
  ],
  "cleanly": [
    "ADV"
  ],
  "unclean": [
    "ADJ"
  ],
  "seizing": [
    "VERB"
  ],
  "molasses": [
    "VERB"
  ],
  "tablecloth": [
    "VERB"
  ],
  "milled": [
    "VERB"
  ],
  "delineation": [
    "NOUN"
  ],
  "schooner": [
    "NOUN"
  ],
  "analgesic": [
    "ADJ"
  ],
  "dignified": [
    "VERB"
  ],
  "numbness": [
    "NOUN"
  ],
  "machinist": [
    "NOUN"
  ],
  "anima": [
    "NOUN"
  ],
  "acetylcholine": [
    "NOUN"
  ],
  "enlight": [
    "ADV"
  ],
  "grotto": [
    "NOUN"
  ],
  "politique": [
    "NOUN"
  ],
  "photometric": [
    "NOUN"
  ],
  "buzzer": [
    "NOUN"
  ],
  "hatching": [
    "VERB"
  ],
  "vickie": [
    "NOUN"
  ],
  "tinnitus": [
    "NOUN"
  ],
  "corinne": [
    "NOUN"
  ],
  "collusion": [
    "NOUN"
  ],
  "rawhide": [
    "NOUN"
  ],
  "sequestration": [
    "NOUN"
  ],
  "inositol": [
    "PROPN"
  ],
  "follicle": [
    "NOUN"
  ],
  "knotted": [
    "VERB"
  ],
  "inspectorate": [
    "ADJ"
  ],
  "sorter": [
    "VERB"
  ],
  "linguist": [
    "PROPN"
  ],
  "rigorously": [
    "ADV"
  ],
  "erroneously": [
    "ADV"
  ],
  "centrifuge": [
    "PROPN"
  ],
  "especial": [
    "ADJ"
  ],
  "betray": [
    "VERB"
  ],
  "marla": [
    "NOUN"
  ],
  "projective": [
    "NOUN"
  ],
  "fandom": [
    "NOUN"
  ],
  "debacle": [
    "NOUN"
  ],
  "bennet": [
    "NOUN"
  ],
  "proclaiming": [
    "VERB"
  ],
  "purposeful": [
    "ADJ"
  ],
  "undress": [
    "ADJ"
  ],
  "procrastination": [
    "NOUN"
  ],
  "gauze": [
    "NOUN"
  ],
  "unpossible": [
    "NOUN"
  ],
  "bronchial": [
    "ADJ"
  ],
  "forceful": [
    "ADJ"
  ],
  "unilaterally": [
    "ADV"
  ],
  "hypoglycemia": [
    "NOUN"
  ],
  "sodomy": [
    "NOUN"
  ],
  "revaluation": [
    "NOUN"
  ],
  "conditionally": [
    "ADV"
  ],
  "moira": [
    "PROPN"
  ],
  "rehoboth": [
    "VERB"
  ],
  "subterranean": [
    "PROPN"
  ],
  "amuse": [
    "VERB"
  ],
  "villager": [
    "NOUN"
  ],
  "fixer": [
    "PROPN"
  ],
  "brodie": [
    "PROPN"
  ],
  "untimely": [
    "ADV"
  ],
  "baguette": [
    "PROPN"
  ],
  "grantor": [
    "NOUN"
  ],
  "idiom": [
    "PROPN"
  ],
  "tangle": [
    "NOUN"
  ],
  "legitimately": [
    "ADV"
  ],
  "resubmit": [
    "VERB"
  ],
  "saggy": [
    "ADJ"
  ],
  "unwelcome": [
    "VERB"
  ],
  "merch": [
    "NOUN"
  ],
  "northbound": [
    "ADV"
  ],
  "confederacy": [
    "NOUN"
  ],
  "matinee": [
    "PROPN"
  ],
  "snatched": [
    "VERB"
  ],
  "plunder": [
    "NOUN"
  ],
  "midweek": [
    "VERB"
  ],
  "impromptu": [
    "PROPN"
  ],
  "bustle": [
    "NOUN"
  ],
  "trawl": [
    "NOUN"
  ],
  "shredding": [
    "VERB"
  ],
  "reiner": [
    "NOUN"
  ],
  "gamut": [
    "NOUN"
  ],
  "unedited": [
    "ADJ"
  ],
  "shattering": [
    "VERB"
  ],
  "inhaler": [
    "NOUN"
  ],
  "refute": [
    "VERB"
  ],
  "granularity": [
    "NOUN",
    "PROPN"
  ],
  "albatross": [
    "NOUN"
  ],
  "amphibious": [
    "ADJ"
  ],
  "spicer": [
    "NOUN"
  ],
  "shudder": [
    "NOUN"
  ],
  "surfboard": [
    "PROPN"
  ],
  "eyesight": [
    "ADJ"
  ],
  "parson": [
    "NOUN"
  ],
  "infidelity": [
    "NOUN"
  ],
  "ideograph": [
    "NOUN"
  ],
  "papillon": [
    "NOUN"
  ],
  "stingray": [
    "VERB"
  ],
  "slinky": [
    "ADJ"
  ],
  "weatherproof": [
    "PROPN"
  ],
  "precarious": [
    "ADJ"
  ],
  "hodder": [
    "NOUN"
  ],
  "topographical": [
    "ADJ"
  ],
  "dreary": [
    "ADJ"
  ],
  "crispin": [
    "NOUN"
  ],
  "horrid": [
    "VERB"
  ],
  "scraper": [
    "NOUN"
  ],
  "dryness": [
    "NOUN"
  ],
  "wreckage": [
    "NOUN"
  ],
  "relist": [
    "NOUN"
  ],
  "conqueror": [
    "NOUN"
  ],
  "manta": [
    "NOUN"
  ],
  "unprepared": [
    "ADJ"
  ],
  "deteriorate": [
    "NOUN"
  ],
  "compo": [
    "VERB"
  ],
  "treacherous": [
    "ADJ"
  ],
  "filet": [
    "PROPN"
  ],
  "infidel": [
    "PROPN"
  ],
  "volley": [
    "PROPN"
  ],
  "carnal": [
    "ADJ"
  ],
  "larceny": [
    "VERB"
  ],
  "malagasy": [
    "VERB"
  ],
  "versed": [
    "VERB"
  ],
  "polymorphic": [
    "ADJ"
  ],
  "phenomenology": [
    "NOUN"
  ],
  "lorry": [
    "VERB"
  ],
  "resolver": [
    "NOUN",
    "PROPN"
  ],
  "youngster": [
    "NOUN"
  ],
  "enigmatic": [
    "ADJ"
  ],
  "anthropologist": [
    "NOUN"
  ],
  "bridle": [
    "PROPN"
  ],
  "revamp": [
    "PROPN",
    "NOUN"
  ],
  "herbarium": [
    "NOUN"
  ],
  "stretcher": [
    "ADV"
  ],
  "arista": [
    "ADV"
  ],
  "leila": [
    "PROPN"
  ],
  "berliner": [
    "NOUN"
  ],
  "methylation": [
    "NOUN"
  ],
  "unravel": [
    "VERB"
  ],
  "prostatic": [
    "ADJ"
  ],
  "intimidate": [
    "ADJ"
  ],
  "android": [
    "PROPN",
    "NOUN"
  ],
  "galilee": [
    "PROPN"
  ],
  "frenchman": [
    "PROPN"
  ],
  "lation": [
    "NOUN"
  ],
  "anisotropic": [
    "NOUN"
  ],
  "tiller": [
    "NOUN"
  ],
  "ambrosia": [
    "PROPN"
  ],
  "springboard": [
    "PROPN"
  ],
  "orifice": [
    "NOUN"
  ],
  "rubella": [
    "NOUN"
  ],
  "constitutive": [
    "ADJ"
  ],
  "bragging": [
    "VERB"
  ],
  "sapphic": [
    "VERB"
  ],
  "beryl": [
    "PROPN"
  ],
  "forerunner": [
    "NOUN"
  ],
  "grinning": [
    "VERB"
  ],
  "billionaire": [
    "NOUN"
  ],
  "leucine": [
    "VERB"
  ],
  "jobless": [
    "ADJ"
  ],
  "slingshot": [
    "ADJ"
  ],
  "cutout": [
    "NOUN"
  ],
  "slashed": [
    "VERB"
  ],
  "coker": [
    "NOUN"
  ],
  "watchful": [
    "ADJ"
  ],
  "silenced": [
    "VERB"
  ],
  "democratization": [
    "NOUN"
  ],
  "affliction": [
    "NOUN"
  ],
  "biostatistics": [
    "NOUN"
  ],
  "garvey": [
    "NOUN"
  ],
  "saute": [
    "VERB"
  ],
  "idyllic": [
    "ADJ"
  ],
  "certiorari": [
    "PROPN"
  ],
  "satchel": [
    "PROPN"
  ],
  "contributory": [
    "PROPN"
  ],
  "peruse": [
    "NOUN"
  ],
  "revel": [
    "NOUN"
  ],
  "crucifixion": [
    "NOUN"
  ],
  "suture": [
    "NOUN"
  ],
  "madly": [
    "ADV"
  ],
  "stiller": [
    "ADV"
  ],
  "experimented": [
    "VERB"
  ],
  "calipers": [
    "NOUN"
  ],
  "pyruvate": [
    "VERB"
  ],
  "gripe": [
    "NOUN"
  ],
  "choreographer": [
    "NOUN"
  ],
  "impressionism": [
    "NOUN"
  ],
  "thereupon": [
    "ADV"
  ],
  "bubbling": [
    "VERB"
  ],
  "disdain": [
    "NOUN"
  ],
  "exhausting": [
    "ADJ"
  ],
  "absurdity": [
    "NOUN"
  ],
  "alabaster": [
    "NOUN"
  ],
  "abnormality": [
    "NOUN"
  ],
  "georgie": [
    "NOUN"
  ],
  "varicose": [
    "VERB"
  ],
  "newtonian": [
    "PROPN"
  ],
  "kidnap": [
    "NOUN"
  ],
  "coercive": [
    "ADJ"
  ],
  "romanticism": [
    "NOUN"
  ],
  "forme": [
    "VERB"
  ],
  "urination": [
    "NOUN"
  ],
  "cautionary": [
    "ADJ"
  ],
  "escalate": [
    "VERB",
    "NOUN"
  ],
  "sider": [
    "NOUN"
  ],
  "reinstate": [
    "VERB"
  ],
  "mitral": [
    "ADJ"
  ],
  "unthinkable": [
    "ADJ"
  ],
  "lowly": [
    "VERB"
  ],
  "antisocial": [
    "ADJ"
  ],
  "outburst": [
    "PROPN"
  ],
  "foundational": [
    "PROPN",
    "ADJ"
  ],
  "scant": [
    "ADJ"
  ],
  "fitzroy": [
    "NOUN"
  ],
  "sorely": [
    "ADV"
  ],
  "isotropic": [
    "ADJ"
  ],
  "obtainable": [
    "ADJ"
  ],
  "elvira": [
    "PROPN"
  ],
  "flier": [
    "NOUN"
  ],
  "mastiff": [
    "NOUN"
  ],
  "carcinogenic": [
    "ADJ"
  ],
  "reformer": [
    "PROPN"
  ],
  "solemnly": [
    "ADV"
  ],
  "supercharged": [
    "VERB"
  ],
  "liberally": [
    "ADV"
  ],
  "dahlia": [
    "NOUN"
  ],
  "primavera": [
    "PROPN"
  ],
  "concentric": [
    "NOUN"
  ],
  "perle": [
    "PROPN"
  ],
  "unwarranted": [
    "ADJ"
  ],
  "marmalade": [
    "NOUN"
  ],
  "terminally": [
    "ADV"
  ],
  "ravine": [
    "VERB"
  ],
  "revitalize": [
    "VERB"
  ],
  "permeable": [
    "ADJ"
  ],
  "riveting": [
    "VERB"
  ],
  "valhalla": [
    "NOUN"
  ],
  "biweekly": [
    "ADJ"
  ],
  "adoration": [
    "NOUN"
  ],
  "amity": [
    "NOUN"
  ],
  "decanter": [
    "VERB"
  ],
  "starve": [
    "VERB"
  ],
  "shortness": [
    "ADJ"
  ],
  "subspecies": [
    "NOUN"
  ],
  "fronted": [
    "VERB"
  ],
  "compulsion": [
    "NOUN"
  ],
  "prerogative": [
    "ADJ"
  ],
  "broiler": [
    "NOUN"
  ],
  "abscess": [
    "VERB"
  ],
  "paraphernalia": [
    "NOUN"
  ],
  "heretofore": [
    "ADP"
  ],
  "skimpy": [
    "PROPN"
  ],
  "memento": [
    "PROPN"
  ],
  "reflexive": [
    "VERB"
  ],
  "tumbled": [
    "VERB"
  ],
  "masterful": [
    "ADJ"
  ],
  "insoluble": [
    "ADJ"
  ],
  "drool": [
    "NOUN"
  ],
  "sepsis": [
    "NOUN"
  ],
  "choline": [
    "NOUN"
  ],
  "diffuser": [
    "NOUN"
  ],
  "postnatal": [
    "ADJ"
  ],
  "repressive": [
    "ADJ"
  ],
  "gondola": [
    "NOUN"
  ],
  "elizabethan": [
    "PROPN"
  ],
  "willfully": [
    "ADV"
  ],
  "reiter": [
    "NOUN"
  ],
  "podiatry": [
    "NOUN"
  ],
  "truffle": [
    "PROPN"
  ],
  "stupendous": [
    "ADJ"
  ],
  "flutter": [
    "NOUN"
  ],
  "acumen": [
    "NOUN"
  ],
  "blockage": [
    "NOUN"
  ],
  "shiver": [
    "VERB"
  ],
  "shatter": [
    "NOUN"
  ],
  "cliche": [
    "NOUN"
  ],
  "hades": [
    "PROPN"
  ],
  "superimposed": [
    "VERB"
  ],
  "zonal": [
    "NOUN"
  ],
  "unsustainable": [
    "ADJ"
  ],
  "interdependent": [
    "ADJ"
  ],
  "rockwood": [
    "NOUN"
  ],
  "civics": [
    "NOUN"
  ],
  "unanticipated": [
    "ADJ"
  ],
  "randal": [
    "ADJ"
  ],
  "tabulated": [
    "VERB"
  ],
  "dandelion": [
    "NOUN"
  ],
  "nuance": [
    "NOUN"
  ],
  "rotator": [
    "NOUN"
  ],
  "myosin": [
    "PROPN"
  ],
  "classmate": [
    "NOUN"
  ],
  "catechism": [
    "NOUN"
  ],
  "driftwood": [
    "NOUN"
  ],
  "rosalind": [
    "VERB"
  ],
  "carsten": [
    "VERB"
  ],
  "mythological": [
    "ADJ"
  ],
  "horseman": [
    "NOUN"
  ],
  "oscilloscope": [
    "NOUN"
  ],
  "nervously": [
    "ADV"
  ],
  "chaparral": [
    "ADJ"
  ],
  "hillel": [
    "ADJ"
  ],
  "slacker": [
    "NOUN"
  ],
  "padlock": [
    "NOUN"
  ],
  "classed": [
    "VERB"
  ],
  "informer": [
    "NOUN"
  ],
  "pentecostal": [
    "VERB"
  ],
  "freer": [
    "ADJ"
  ],
  "extrapolation": [
    "NOUN"
  ],
  "fennel": [
    "NOUN"
  ],
  "telemark": [
    "ADJ"
  ],
  "exertion": [
    "NOUN"
  ],
  "solidly": [
    "ADV"
  ],
  "flywheel": [
    "PROPN",
    "NOUN"
  ],
  "chimera": [
    "NOUN"
  ],
  "handkerchief": [
    "NOUN"
  ],
  "foaming": [
    "VERB"
  ],
  "oskar": [
    "PROPN"
  ],
  "tassel": [
    "VERB"
  ],
  "admiring": [
    "VERB"
  ],
  "nondiscrimination": [
    "NOUN"
  ],
  "leith": [
    "ADP"
  ],
  "wasteful": [
    "ADJ"
  ],
  "golgi": [
    "PROPN"
  ],
  "channeling": [
    "VERB"
  ],
  "tripoli": [
    "PROPN"
  ],
  "subscript": [
    "PROPN"
  ],
  "refraction": [
    "NOUN"
  ],
  "substandard": [
    "VERB"
  ],
  "convener": [
    "NOUN"
  ],
  "retract": [
    "NOUN"
  ],
  "inaudible": [
    "PROPN"
  ],
  "frantically": [
    "ADV"
  ],
  "tinting": [
    "NOUN"
  ],
  "burnie": [
    "PROPN"
  ],
  "disintegration": [
    "NOUN"
  ],
  "theologian": [
    "PROPN"
  ],
  "sigmund": [
    "VERB"
  ],
  "individualism": [
    "NOUN"
  ],
  "starboard": [
    "NOUN"
  ],
  "burdensome": [
    "ADV"
  ],
  "helly": [
    "ADV"
  ],
  "renown": [
    "NOUN"
  ],
  "murky": [
    "ADJ"
  ],
  "truthfully": [
    "ADV"
  ],
  "tongs": [
    "VERB"
  ],
  "perpetuate": [
    "NOUN"
  ],
  "hematopoietic": [
    "ADJ"
  ],
  "cabal": [
    "ADJ"
  ],
  "inflationary": [
    "ADJ"
  ],
  "interwoven": [
    "VERB"
  ],
  "beggar": [
    "ADJ"
  ],
  "cuddle": [
    "PROPN"
  ],
  "fallback": [
    "NOUN",
    "VERB"
  ],
  "extinguished": [
    "VERB"
  ],
  "downer": [
    "NOUN"
  ],
  "abelian": [
    "PROPN"
  ],
  "transferee": [
    "NUM"
  ],
  "quantitatively": [
    "ADV"
  ],
  "abundantly": [
    "ADV"
  ],
  "declination": [
    "NOUN"
  ],
  "cameraman": [
    "NOUN"
  ],
  "mucous": [
    "ADJ"
  ],
  "poked": [
    "VERB"
  ],
  "cakewalk": [
    "NOUN"
  ],
  "blackfoot": [
    "ADJ"
  ],
  "artiste": [
    "NOUN"
  ],
  "slicer": [
    "NOUN"
  ],
  "joshi": [
    "PROPN"
  ],
  "repose": [
    "VERB"
  ],
  "hasten": [
    "PROPN"
  ],
  "temperance": [
    "NOUN"
  ],
  "risque": [
    "NOUN"
  ],
  "operable": [
    "ADJ"
  ],
  "helpfulness": [
    "VERB"
  ],
  "anzac": [
    "PROPN"
  ],
  "kulkarni": [
    "NOUN"
  ],
  "earthy": [
    "ADJ"
  ],
  "feathered": [
    "VERB"
  ],
  "aggrieved": [
    "VERB"
  ],
  "investigational": [
    "ADJ"
  ],
  "aggravating": [
    "VERB"
  ],
  "centaur": [
    "NOUN"
  ],
  "climatology": [
    "NOUN"
  ],
  "pinhole": [
    "NOUN"
  ],
  "alveolar": [
    "NOUN"
  ],
  "passe": [
    "NOUN"
  ],
  "anecdote": [
    "VERB"
  ],
  "exorcist": [
    "NOUN"
  ],
  "honduran": [
    "PROPN"
  ],
  "partake": [
    "VERB"
  ],
  "pseudonym": [
    "NOUN"
  ],
  "resistive": [
    "NOUN"
  ],
  "snooper": [
    "NOUN"
  ],
  "strikingly": [
    "ADV"
  ],
  "firepower": [
    "NOUN"
  ],
  "unmodified": [
    "ADJ"
  ],
  "rancher": [
    "VERB"
  ],
  "flathead": [
    "PROPN"
  ],
  "castellano": [
    "NOUN"
  ],
  "vesting": [
    "VERB"
  ],
  "panache": [
    "NOUN"
  ],
  "hallelujah": [
    "PROPN"
  ],
  "cayuga": [
    "PROPN"
  ],
  "bodyguard": [
    "PROPN"
  ],
  "gubernatorial": [
    "NOUN"
  ],
  "goran": [
    "PROPN"
  ],
  "solon": [
    "NOUN"
  ],
  "detract": [
    "NOUN"
  ],
  "sparky": [
    "ADJ"
  ],
  "wirelessly": [
    "ADV"
  ],
  "pitted": [
    "VERB"
  ],
  "enlarging": [
    "VERB"
  ],
  "polymeric": [
    "VERB"
  ],
  "bombardment": [
    "NOUN"
  ],
  "salivary": [
    "PROPN"
  ],
  "dares": [
    "VERB"
  ],
  "kristian": [
    "PROPN"
  ],
  "siesta": [
    "PROPN"
  ],
  "prakash": [
    "VERB"
  ],
  "satirical": [
    "ADJ"
  ],
  "phenotypic": [
    "NOUN"
  ],
  "pelagic": [
    "NOUN"
  ],
  "agronomy": [
    "VERB"
  ],
  "antoinette": [
    "PROPN"
  ],
  "cynic": [
    "ADJ"
  ],
  "amenable": [
    "ADJ"
  ],
  "audiophile": [
    "ADJ"
  ],
  "fingerprinting": [
    "PROPN"
  ],
  "checkered": [
    "VERB"
  ],
  "phonological": [
    "ADJ"
  ],
  "sketching": [
    "VERB"
  ],
  "snappy": [
    "ADJ"
  ],
  "hypocritical": [
    "ADJ"
  ],
  "trample": [
    "ADV"
  ],
  "colonic": [
    "NOUN"
  ],
  "courtship": [
    "NOUN"
  ],
  "zircon": [
    "PROPN"
  ],
  "tolerable": [
    "ADJ"
  ],
  "canopus": [
    "X"
  ],
  "alonzo": [
    "NOUN"
  ],
  "wattage": [
    "NOUN"
  ],
  "inefficiency": [
    "NOUN"
  ],
  "expeditionary": [
    "NOUN"
  ],
  "humanistic": [
    "ADJ"
  ],
  "travelogue": [
    "NOUN"
  ],
  "swipe": [
    "NOUN"
  ],
  "demented": [
    "VERB"
  ],
  "upkeep": [
    "VERB"
  ],
  "truncation": [
    "NOUN"
  ],
  "downgrade": [
    "NOUN",
    "VERB"
  ],
  "biliary": [
    "NOUN"
  ],
  "universalist": [
    "NOUN"
  ],
  "japonica": [
    "PROPN"
  ],
  "grapple": [
    "PROPN"
  ],
  "inseam": [
    "NOUN"
  ],
  "greenery": [
    "PROPN"
  ],
  "proverbial": [
    "ADJ"
  ],
  "histological": [
    "ADJ"
  ],
  "honeycomb": [
    "VERB"
  ],
  "tranquillity": [
    "NOUN"
  ],
  "denier": [
    "VERB"
  ],
  "monastic": [
    "ADJ"
  ],
  "nestor": [
    "PROPN"
  ],
  "nitrite": [
    "ADJ"
  ],
  "mouser": [
    "NOUN"
  ],
  "impediment": [
    "NOUN"
  ],
  "whoops": [
    "NOUN"
  ],
  "perilous": [
    "ADJ"
  ],
  "devonshire": [
    "VERB"
  ],
  "catamaran": [
    "NOUN"
  ],
  "preoperative": [
    "NOUN"
  ],
  "nether": [
    "NOUN"
  ],
  "helios": [
    "NOUN"
  ],
  "monomer": [
    "NOUN"
  ],
  "refueling": [
    "VERB"
  ],
  "biennium": [
    "NOUN"
  ],
  "ramble": [
    "ADJ"
  ],
  "quartile": [
    "NOUN"
  ],
  "hexagon": [
    "PROPN"
  ],
  "geodetic": [
    "ADJ"
  ],
  "consensual": [
    "ADJ"
  ],
  "altimeter": [
    "NOUN"
  ],
  "idiotic": [
    "ADJ"
  ],
  "sharpener": [
    "PROPN"
  ],
  "cerberus": [
    "PROPN"
  ],
  "ascorbic": [
    "NOUN"
  ],
  "dichotomy": [
    "NOUN"
  ],
  "covalent": [
    "NOUN"
  ],
  "tarpon": [
    "VERB"
  ],
  "bough": [
    "NOUN"
  ],
  "herewith": [
    "ADP"
  ],
  "radix": [
    "PROPN"
  ],
  "borealis": [
    "PROPN"
  ],
  "grist": [
    "NOUN"
  ],
  "racecourse": [
    "NOUN"
  ],
  "extraterrestrial": [
    "ADJ"
  ],
  "duster": [
    "NOUN"
  ],
  "pronoun": [
    "NOUN"
  ],
  "phylogeny": [
    "VERB"
  ],
  "signer": [
    "NOUN"
  ],
  "plankton": [
    "PROPN"
  ],
  "sloth": [
    "VERB"
  ],
  "steely": [
    "ADV"
  ],
  "seamus": [
    "VERB"
  ],
  "unthreaded": [
    "ADJ"
  ],
  "tacky": [
    "ADJ"
  ],
  "nourishment": [
    "NOUN"
  ],
  "gravitation": [
    "NOUN"
  ],
  "antiwar": [
    "VERB"
  ],
  "loophole": [
    "NOUN"
  ],
  "menopausal": [
    "ADJ"
  ],
  "retrograde": [
    "VERB"
  ],
  "relive": [
    "VERB"
  ],
  "exaggeration": [
    "NOUN"
  ],
  "shadowy": [
    "PROPN"
  ],
  "reproducibility": [
    "NOUN"
  ],
  "archangel": [
    "NOUN"
  ],
  "abalone": [
    "PROPN"
  ],
  "primordial": [
    "NOUN"
  ],
  "nourish": [
    "VERB"
  ],
  "uplifted": [
    "VERB"
  ],
  "bundy": [
    "ADJ"
  ],
  "acceptor": [
    "NOUN"
  ],
  "precondition": [
    "NOUN"
  ],
  "percival": [
    "NOUN"
  ],
  "gingham": [
    "PROPN"
  ],
  "gossamer": [
    "NOUN"
  ],
  "beveled": [
    "VERB"
  ],
  "hairdresser": [
    "VERB"
  ],
  "plover": [
    "NOUN"
  ],
  "boneless": [
    "NOUN"
  ],
  "impurity": [
    "NOUN"
  ],
  "intracranial": [
    "NOUN"
  ],
  "solute": [
    "VERB"
  ],
  "mumps": [
    "NOUN"
  ],
  "chasm": [
    "NOUN"
  ],
  "haggis": [
    "ADV"
  ],
  "electromechanical": [
    "ADJ"
  ],
  "greenish": [
    "PROPN"
  ],
  "rockaway": [
    "NOUN"
  ],
  "exhibitionist": [
    "PROPN"
  ],
  "selfishness": [
    "NOUN"
  ],
  "reactionary": [
    "ADJ"
  ],
  "adriatic": [
    "ADJ"
  ],
  "godiva": [
    "NOUN"
  ],
  "grappling": [
    "VERB"
  ],
  "hammering": [
    "VERB"
  ],
  "masculinity": [
    "NOUN"
  ],
  "earnestly": [
    "ADV"
  ],
  "rucker": [
    "PROPN"
  ],
  "monologue": [
    "NOUN"
  ],
  "amphitheater": [
    "NOUN"
  ],
  "acutely": [
    "ADV"
  ],
  "profess": [
    "ADJ"
  ],
  "masse": [
    "PROPN"
  ],
  "rearrange": [
    "VERB"
  ],
  "rohan": [
    "PROPN"
  ],
  "inflate": [
    "VERB"
  ],
  "worded": [
    "VERB"
  ],
  "quant": [
    "ADJ"
  ],
  "fleshy": [
    "ADJ"
  ],
  "devonport": [
    "NOUN"
  ],
  "desirability": [
    "NOUN"
  ],
  "bodybuilder": [
    "NOUN"
  ],
  "sundown": [
    "PROPN"
  ],
  "ravel": [
    "NOUN"
  ],
  "flycatcher": [
    "VERB"
  ],
  "persistently": [
    "ADV"
  ],
  "decoy": [
    "VERB"
  ],
  "balsam": [
    "PROPN"
  ],
  "bombshell": [
    "VERB"
  ],
  "baruch": [
    "ADJ"
  ],
  "horrendous": [
    "ADJ"
  ],
  "outcry": [
    "NOUN"
  ],
  "eyeglass": [
    "VERB"
  ],
  "waterside": [
    "NOUN"
  ],
  "grime": [
    "ADV"
  ],
  "extortion": [
    "NOUN"
  ],
  "schnauzer": [
    "PROPN"
  ],
  "cordon": [
    "PROPN"
  ],
  "colorless": [
    "PROPN"
  ],
  "rabin": [
    "PROPN"
  ],
  "idealistic": [
    "ADJ"
  ],
  "workday": [
    "PROPN",
    "NOUN"
  ],
  "eared": [
    "VERB"
  ],
  "earphone": [
    "NOUN"
  ],
  "cutlass": [
    "VERB"
  ],
  "illiteracy": [
    "NOUN"
  ],
  "rigor": [
    "VERB"
  ],
  "addressee": [
    "PROPN"
  ],
  "amalgamation": [
    "NOUN"
  ],
  "sublimation": [
    "NOUN"
  ],
  "preponderance": [
    "NOUN"
  ],
  "cowardly": [
    "ADV"
  ],
  "pretentious": [
    "ADJ"
  ],
  "fishman": [
    "NOUN"
  ],
  "gusto": [
    "PROPN"
  ],
  "messianic": [
    "ADJ"
  ],
  "generalist": [
    "NOUN"
  ],
  "humbly": [
    "ADV"
  ],
  "gastronomy": [
    "NOUN"
  ],
  "huckleberry": [
    "PROPN"
  ],
  "unworthy": [
    "ADJ"
  ],
  "expectant": [
    "ADJ"
  ],
  "azerbaijani": [
    "VERB"
  ],
  "footy": [
    "NOUN"
  ],
  "joinery": [
    "NOUN"
  ],
  "wasatch": [
    "VERB"
  ],
  "octagon": [
    "PROPN"
  ],
  "azalea": [
    "ADJ"
  ],
  "jeannette": [
    "PROPN"
  ],
  "fruition": [
    "NOUN"
  ],
  "florentine": [
    "NOUN"
  ],
  "dwelt": [
    "NOUN"
  ],
  "oberon": [
    "PROPN"
  ],
  "magnetics": [
    "NOUN"
  ],
  "halide": [
    "NOUN"
  ],
  "cathay": [
    "PROPN"
  ],
  "metabolite": [
    "PROPN"
  ],
  "headgear": [
    "VERB"
  ],
  "insole": [
    "NOUN"
  ],
  "thurrock": [
    "VERB"
  ],
  "cardstock": [
    "NOUN"
  ],
  "correspondingly": [
    "ADV"
  ],
  "predicament": [
    "NOUN"
  ],
  "hilly": [
    "ADV"
  ],
  "trusty": [
    "ADJ"
  ],
  "subtropical": [
    "ADJ"
  ],
  "gratuitous": [
    "ADJ"
  ],
  "fatally": [
    "ADV"
  ],
  "caged": [
    "VERB"
  ],
  "ephemeral": [
    "ADJ"
  ],
  "radium": [
    "NOUN"
  ],
  "dissimilar": [
    "ADJ"
  ],
  "ramesh": [
    "PROPN"
  ],
  "mutilation": [
    "PROPN"
  ],
  "prawn": [
    "NOUN"
  ],
  "phylum": [
    "NOUN"
  ],
  "mephisto": [
    "PROPN"
  ],
  "algal": [
    "PROPN"
  ],
  "overwhelm": [
    "VERB"
  ],
  "injectable": [
    "ADJ"
  ],
  "cognizant": [
    "ADJ"
  ],
  "rowdy": [
    "PROPN"
  ],
  "bravely": [
    "ADV"
  ],
  "ethically": [
    "ADV"
  ],
  "puffin": [
    "NOUN"
  ],
  "shaper": [
    "VERB"
  ],
  "cheater": [
    "NOUN"
  ],
  "clematis": [
    "NOUN"
  ],
  "slashing": [
    "VERB"
  ],
  "leger": [
    "PROPN"
  ],
  "torus": [
    "VERB"
  ],
  "cotta": [
    "VERB"
  ],
  "incomprehensible": [
    "NOUN"
  ],
  "gabriella": [
    "PROPN"
  ],
  "demeanor": [
    "NOUN"
  ],
  "waxman": [
    "PROPN"
  ],
  "shipboard": [
    "VERB"
  ],
  "oryza": [
    "NOUN"
  ],
  "paganism": [
    "NOUN"
  ],
  "sounder": [
    "NOUN"
  ],
  "practicality": [
    "NOUN"
  ],
  "winer": [
    "NOUN"
  ],
  "caledonian": [
    "PROPN"
  ],
  "pancreatitis": [
    "VERB"
  ],
  "filigree": [
    "ADJ"
  ],
  "stench": [
    "NOUN"
  ],
  "chock": [
    "PROPN"
  ],
  "wickedness": [
    "NOUN"
  ],
  "crouching": [
    "VERB"
  ],
  "trigonometry": [
    "NOUN"
  ],
  "campanile": [
    "VERB"
  ],
  "regress": [
    "VERB"
  ],
  "ebenezer": [
    "NOUN"
  ],
  "closeness": [
    "NOUN"
  ],
  "polity": [
    "NOUN"
  ],
  "celiac": [
    "ADJ"
  ],
  "hough": [
    "PROPN"
  ],
  "hypothyroidism": [
    "NOUN"
  ],
  "scriptural": [
    "NOUN"
  ],
  "cybernetics": [
    "NOUN"
  ],
  "discontinuation": [
    "NOUN"
  ],
  "obscenity": [
    "NOUN"
  ],
  "cumulus": [
    "NOUN"
  ],
  "heartache": [
    "NOUN"
  ],
  "exacting": [
    "VERB"
  ],
  "wanton": [
    "PROPN"
  ],
  "bookmaker": [
    "PROPN"
  ],
  "curio": [
    "PROPN"
  ],
  "hookers": [
    "NOUN"
  ],
  "amalgam": [
    "PROPN"
  ],
  "necessitate": [
    "VERB"
  ],
  "locket": [
    "NOUN"
  ],
  "notional": [
    "ADJ"
  ],
  "reconciling": [
    "VERB"
  ],
  "desolation": [
    "NOUN"
  ],
  "gander": [
    "NOUN"
  ],
  "bastille": [
    "PROPN"
  ],
  "magnetometer": [
    "NOUN"
  ],
  "populist": [
    "NOUN"
  ],
  "traceable": [
    "ADJ"
  ],
  "hesperia": [
    "PROPN"
  ],
  "chautauqua": [
    "NOUN"
  ],
  "mnemonic": [
    "X"
  ],
  "invariance": [
    "NOUN"
  ],
  "aspartate": [
    "VERB"
  ],
  "savor": [
    "NOUN"
  ],
  "aramis": [
    "PROPN"
  ],
  "darkly": [
    "PROPN"
  ],
  "faithfulness": [
    "NOUN"
  ],
  "resourceful": [
    "ADJ"
  ],
  "pleural": [
    "ADJ"
  ],
  "mediating": [
    "VERB"
  ],
  "heraldry": [
    "VERB"
  ],
  "incomparable": [
    "ADJ"
  ],
  "resonator": [
    "NOUN"
  ],
  "dilated": [
    "VERB"
  ],
  "condone": [
    "NOUN"
  ],
  "finisher": [
    "PROPN"
  ],
  "anthropogenic": [
    "ADJ"
  ],
  "constitutionality": [
    "NOUN"
  ],
  "thermos": [
    "PROPN"
  ],
  "macroscopic": [
    "ADJ"
  ],
  "viscount": [
    "NOUN"
  ],
  "geopolitical": [
    "ADJ"
  ],
  "varietal": [
    "ADJ"
  ],
  "adamant": [
    "ADJ"
  ],
  "pontoon": [
    "NOUN"
  ],
  "epidural": [
    "ADJ"
  ],
  "teardrop": [
    "PROPN"
  ],
  "tableau": [
    "PROPN",
    "NOUN"
  ],
  "anion": [
    "NOUN"
  ],
  "numeral": [
    "ADJ"
  ],
  "orthodontics": [
    "NOUN"
  ],
  "vernal": [
    "ADJ"
  ],
  "tabby": [
    "NOUN"
  ],
  "therm": [
    "NOUN"
  ],
  "myeloid": [
    "VERB"
  ],
  "napoleonic": [
    "PROPN"
  ],
  "rubicon": [
    "NOUN"
  ],
  "sprocket": [
    "NOUN"
  ],
  "disorderly": [
    "ADV"
  ],
  "ansel": [
    "NOUN"
  ],
  "frigate": [
    "VERB"
  ],
  "dazed": [
    "VERB"
  ],
  "bicentennial": [
    "ADJ"
  ],
  "radiologic": [
    "ADJ"
  ],
  "mineralogy": [
    "NOUN"
  ],
  "harrier": [
    "ADJ"
  ],
  "oireachtas": [
    "NOUN"
  ],
  "sentient": [
    "NOUN"
  ],
  "olympiad": [
    "VERB"
  ],
  "entrust": [
    "VERB"
  ],
  "strainer": [
    "NOUN"
  ],
  "whitetail": [
    "NOUN"
  ],
  "astrid": [
    "PROPN"
  ],
  "overpayment": [
    "NOUN"
  ],
  "faeroe": [
    "NOUN"
  ],
  "burying": [
    "VERB"
  ],
  "blatantly": [
    "ADV"
  ],
  "fleer": [
    "NOUN"
  ],
  "cyclops": [
    "NOUN"
  ],
  "gunfire": [
    "NOUN"
  ],
  "veritable": [
    "ADJ"
  ],
  "posterity": [
    "NOUN"
  ],
  "percutaneous": [
    "ADJ"
  ],
  "keenly": [
    "ADV"
  ],
  "healthful": [
    "ADJ"
  ],
  "gourd": [
    "PROPN"
  ],
  "metronome": [
    "VERB"
  ],
  "ferocious": [
    "ADJ"
  ],
  "voicing": [
    "VERB"
  ],
  "grouper": [
    "VERB"
  ],
  "negate": [
    "VERB"
  ],
  "sacrificial": [
    "ADJ"
  ],
  "intrastate": [
    "VERB"
  ],
  "abnormally": [
    "ADV"
  ],
  "bruising": [
    "VERB"
  ],
  "refrigerate": [
    "VERB"
  ],
  "flogging": [
    "VERB"
  ],
  "religiously": [
    "ADV"
  ],
  "encroachment": [
    "NOUN"
  ],
  "cochlear": [
    "VERB"
  ],
  "seaboard": [
    "PROPN"
  ],
  "foldable": [
    "ADJ"
  ],
  "hydroponics": [
    "NOUN"
  ],
  "precast": [
    "NOUN"
  ],
  "southerly": [
    "ADV"
  ],
  "unearthed": [
    "VERB"
  ],
  "kelty": [
    "PROPN"
  ],
  "volunteerism": [
    "NOUN"
  ],
  "radiographic": [
    "ADJ"
  ],
  "kinematics": [
    "NOUN"
  ],
  "vagabond": [
    "NOUN"
  ],
  "isobaric": [
    "PROPN"
  ],
  "consecrated": [
    "VERB"
  ],
  "oscillating": [
    "VERB"
  ],
  "bodice": [
    "NOUN"
  ],
  "foray": [
    "VERB"
  ],
  "unmistakable": [
    "ADJ"
  ],
  "filly": [
    "ADV"
  ],
  "rhubarb": [
    "VERB"
  ],
  "ragtime": [
    "NOUN"
  ],
  "posey": [
    "NOUN"
  ],
  "minuteman": [
    "NOUN"
  ],
  "zinfandel": [
    "PROPN"
  ],
  "mayoral": [
    "ADJ"
  ],
  "fortis": [
    "NOUN"
  ],
  "tidings": [
    "NOUN"
  ],
  "sneaking": [
    "VERB"
  ],
  "pinus": [
    "NOUN"
  ],
  "interlink": [
    "NOUN"
  ],
  "unassisted": [
    "ADJ"
  ],
  "greening": [
    "VERB"
  ],
  "insidious": [
    "ADJ"
  ],
  "immutable": [
    "ADJ"
  ],
  "silvery": [
    "NOUN"
  ],
  "croton": [
    "PROPN"
  ],
  "nodding": [
    "VERB"
  ],
  "overtake": [
    "VERB"
  ],
  "semicolon": [
    "NOUN"
  ],
  "bubbly": [
    "ADV"
  ],
  "substantiate": [
    "VERB"
  ],
  "nodal": [
    "NOUN"
  ],
  "templar": [
    "ADJ"
  ],
  "unbeaten": [
    "ADJ"
  ],
  "fortitude": [
    "NOUN"
  ],
  "aloft": [
    "ADV"
  ],
  "sheeting": [
    "VERB"
  ],
  "snooze": [
    "VERB"
  ],
  "hollander": [
    "NOUN"
  ],
  "kestrel": [
    "NOUN"
  ],
  "nonpartisan": [
    "ADJ"
  ],
  "ruffled": [
    "VERB"
  ],
  "armament": [
    "VERB"
  ],
  "fairer": [
    "PROPN"
  ],
  "hoppers": [
    "NOUN"
  ],
  "enterprising": [
    "VERB"
  ],
  "hypertensive": [
    "NOUN"
  ],
  "chinchilla": [
    "NOUN"
  ],
  "arrhythmia": [
    "VERB"
  ],
  "grafting": [
    "VERB"
  ],
  "smoothness": [
    "ADJ"
  ],
  "trinket": [
    "NOUN"
  ],
  "asperger": [
    "X"
  ],
  "transpose": [
    "VERB"
  ],
  "neutralize": [
    "VERB"
  ],
  "kafka": [
    "PROPN"
  ],
  "grandstand": [
    "NOUN"
  ],
  "slurp": [
    "NOUN"
  ],
  "wishful": [
    "ADJ"
  ],
  "allocator": [
    "NOUN"
  ],
  "westland": [
    "PROPN"
  ],
  "habitation": [
    "NOUN"
  ],
  "speechless": [
    "NOUN"
  ],
  "expanse": [
    "VERB"
  ],
  "blackwater": [
    "NOUN"
  ],
  "preside": [
    "VERB"
  ],
  "larkspur": [
    "PROPN"
  ],
  "arles": [
    "NOUN"
  ],
  "delightfully": [
    "ADV"
  ],
  "mussel": [
    "NOUN"
  ],
  "concealment": [
    "NOUN"
  ],
  "unruly": [
    "ADJ"
  ],
  "stapler": [
    "NOUN"
  ],
  "uncompromising": [
    "VERB"
  ],
  "obstruct": [
    "VERB"
  ],
  "unbounded": [
    "ADJ"
  ],
  "quinton": [
    "PROPN"
  ],
  "undertaker": [
    "VERB"
  ],
  "flickering": [
    "VERB"
  ],
  "tempt": [
    "VERB"
  ],
  "geochemical": [
    "ADJ"
  ],
  "organically": [
    "ADV"
  ],
  "bathe": [
    "VERB"
  ],
  "scarred": [
    "VERB"
  ],
  "spearhead": [
    "NOUN"
  ],
  "leonid": [
    "PROPN"
  ],
  "reticulum": [
    "PROPN"
  ],
  "dulcimer": [
    "PROPN"
  ],
  "coronal": [
    "NOUN"
  ],
  "transparently": [
    "ADV"
  ],
  "tantric": [
    "NOUN"
  ],
  "woodhouse": [
    "PROPN"
  ],
  "lifter": [
    "NOUN"
  ],
  "scrooge": [
    "NOUN"
  ],
  "aeroplane": [
    "NOUN"
  ],
  "nagging": [
    "VERB"
  ],
  "fatherhood": [
    "NOUN"
  ],
  "contemporaneous": [
    "ADJ"
  ],
  "precipitated": [
    "VERB"
  ],
  "vadim": [
    "PROPN"
  ],
  "bellow": [
    "VERB"
  ],
  "magnetization": [
    "NOUN"
  ],
  "girth": [
    "ADV"
  ],
  "inlaid": [
    "VERB"
  ],
  "notched": [
    "VERB"
  ],
  "underpin": [
    "VERB"
  ],
  "baldness": [
    "NOUN"
  ],
  "dumbledore": [
    "VERB"
  ],
  "didactic": [
    "ADJ"
  ],
  "vinny": [
    "NOUN"
  ],
  "delicately": [
    "ADV"
  ],
  "irritability": [
    "NOUN"
  ],
  "provocation": [
    "NOUN"
  ],
  "lustrous": [
    "ADJ"
  ],
  "birdhouse": [
    "NOUN"
  ],
  "solent": [
    "ADJ"
  ],
  "propylene": [
    "NOUN"
  ],
  "slapping": [
    "VERB"
  ],
  "toffee": [
    "NOUN"
  ],
  "slaying": [
    "VERB"
  ],
  "mahatma": [
    "NOUN"
  ],
  "chiron": [
    "VERB"
  ],
  "pippin": [
    "NOUN"
  ],
  "tauranga": [
    "NOUN"
  ],
  "inadvertent": [
    "NOUN"
  ],
  "boardman": [
    "NOUN"
  ],
  "thundering": [
    "VERB"
  ],
  "remus": [
    "NOUN"
  ],
  "succulent": [
    "NOUN"
  ],
  "heartily": [
    "ADV"
  ],
  "shader": [
    "VERB"
  ],
  "yellowish": [
    "VERB"
  ],
  "unsuccessfully": [
    "ADV"
  ],
  "hillbilly": [
    "ADV"
  ],
  "carina": [
    "PROPN"
  ],
  "balsamic": [
    "PROPN"
  ],
  "classically": [
    "ADV"
  ],
  "eventful": [
    "ADJ"
  ],
  "calorimeter": [
    "NOUN"
  ],
  "necked": [
    "VERB"
  ],
  "idiopathic": [
    "ADJ"
  ],
  "stiletto": [
    "NOUN"
  ],
  "unidirectional": [
    "ADJ"
  ],
  "westbound": [
    "VERB"
  ],
  "teacup": [
    "VERB"
  ],
  "rebekah": [
    "PROPN"
  ],
  "cabinetry": [
    "NOUN"
  ],
  "secession": [
    "NOUN"
  ],
  "instinctively": [
    "ADV"
  ],
  "sinusitis": [
    "NOUN"
  ],
  "brunt": [
    "VERB"
  ],
  "infraction": [
    "NOUN"
  ],
  "stagnation": [
    "NOUN"
  ],
  "displace": [
    "VERB"
  ],
  "rodman": [
    "NOUN"
  ],
  "iterate": [
    "VERB",
    "ADJ"
  ],
  "ember": [
    "PROPN"
  ],
  "neolithic": [
    "ADJ"
  ],
  "perishable": [
    "ADJ"
  ],
  "uruguayan": [
    "ADJ"
  ],
  "proteus": [
    "NOUN"
  ],
  "simian": [
    "PROPN"
  ],
  "atmos": [
    "PROPN"
  ],
  "apiece": [
    "ADV"
  ],
  "jeanie": [
    "PROPN"
  ],
  "gammon": [
    "PROPN"
  ],
  "storming": [
    "VERB"
  ],
  "islet": [
    "NOUN"
  ],
  "ganglia": [
    "NOUN"
  ],
  "headway": [
    "NOUN"
  ],
  "subjectivity": [
    "NOUN"
  ],
  "alluring": [
    "ADJ"
  ],
  "cobble": [
    "ADJ"
  ],
  "spode": [
    "NOUN"
  ],
  "buzzard": [
    "VERB"
  ],
  "bucky": [
    "ADJ"
  ],
  "plunger": [
    "NOUN"
  ],
  "halting": [
    "VERB"
  ],
  "lowery": [
    "NOUN"
  ],
  "reviving": [
    "VERB"
  ],
  "frasier": [
    "NOUN"
  ],
  "burrow": [
    "NOUN"
  ],
  "universality": [
    "NOUN"
  ],
  "veranda": [
    "NOUN"
  ],
  "mosul": [
    "VERB"
  ],
  "chordata": [
    "NOUN"
  ],
  "hyphen": [
    "PROPN"
  ],
  "insatiable": [
    "ADJ"
  ],
  "exquisitely": [
    "ADV"
  ],
  "unsorted": [
    "ADJ"
  ],
  "unfriendly": [
    "ADJ"
  ],
  "christened": [
    "VERB"
  ],
  "actuality": [
    "NOUN"
  ],
  "detain": [
    "PROPN"
  ],
  "swordfish": [
    "PROPN"
  ],
  "flatten": [
    "VERB"
  ],
  "homogeneity": [
    "NOUN"
  ],
  "savant": [
    "NOUN"
  ],
  "leaded": [
    "VERB"
  ],
  "stinging": [
    "VERB"
  ],
  "vinaigrette": [
    "NOUN"
  ],
  "sultry": [
    "NOUN"
  ],
  "globular": [
    "NOUN"
  ],
  "asiatic": [
    "ADJ"
  ],
  "unreadable": [
    "ADJ"
  ],
  "balsa": [
    "VERB"
  ],
  "fanatical": [
    "ADJ"
  ],
  "caper": [
    "NOUN"
  ],
  "pecuniary": [
    "NOUN"
  ],
  "montezuma": [
    "PROPN"
  ],
  "mucosal": [
    "NOUN"
  ],
  "prehistory": [
    "PROPN"
  ],
  "histidine": [
    "NOUN"
  ],
  "quack": [
    "INTJ"
  ],
  "drape": [
    "NOUN"
  ],
  "tectonics": [
    "NOUN"
  ],
  "distributive": [
    "ADJ"
  ],
  "sharps": [
    "PROPN"
  ],
  "doomsday": [
    "NOUN"
  ],
  "gervais": [
    "PROPN"
  ],
  "scarring": [
    "VERB"
  ],
  "daydream": [
    "NOUN"
  ],
  "gooding": [
    "VERB"
  ],
  "snicket": [
    "NOUN"
  ],
  "bicarbonate": [
    "VERB"
  ],
  "grocer": [
    "NOUN"
  ],
  "dietitian": [
    "PROPN"
  ],
  "speedily": [
    "ADV"
  ],
  "paprika": [
    "NOUN"
  ],
  "mezzo": [
    "VERB"
  ],
  "adelphi": [
    "VERB"
  ],
  "incarnate": [
    "VERB"
  ],
  "novella": [
    "PROPN"
  ],
  "preoccupied": [
    "VERB"
  ],
  "hither": [
    "CCONJ"
  ],
  "shortstop": [
    "VERB"
  ],
  "giddy": [
    "PROPN"
  ],
  "denounce": [
    "NOUN"
  ],
  "permissive": [
    "ADJ"
  ],
  "bloodshed": [
    "VERB"
  ],
  "odometer": [
    "NOUN"
  ],
  "upsetting": [
    "VERB"
  ],
  "rodger": [
    "NOUN"
  ],
  "griddle": [
    "NOUN"
  ],
  "nascent": [
    "NOUN"
  ],
  "precept": [
    "VERB"
  ],
  "rehabilitate": [
    "VERB"
  ],
  "patina": [
    "PROPN"
  ],
  "quadra": [
    "VERB"
  ],
  "violinist": [
    "VERB"
  ],
  "phonology": [
    "NOUN"
  ],
  "plasmodium": [
    "NOUN"
  ],
  "himalaya": [
    "PROPN"
  ],
  "gibbon": [
    "VERB"
  ],
  "gratifying": [
    "VERB"
  ],
  "undersea": [
    "NOUN"
  ],
  "delirious": [
    "ADJ"
  ],
  "excepting": [
    "VERB"
  ],
  "unlawfully": [
    "ADV"
  ],
  "vanadium": [
    "NOUN"
  ],
  "urchin": [
    "VERB"
  ],
  "polygamy": [
    "NOUN"
  ],
  "gynecologic": [
    "ADJ"
  ],
  "unstoppable": [
    "ADJ"
  ],
  "pedometer": [
    "NOUN"
  ],
  "barbershop": [
    "PROPN"
  ],
  "woodman": [
    "NOUN"
  ],
  "gravely": [
    "ADV"
  ],
  "idiosyncratic": [
    "PROPN"
  ],
  "kilowatt": [
    "PROPN"
  ],
  "impulsive": [
    "ADJ"
  ],
  "commutative": [
    "ADJ"
  ],
  "rationally": [
    "ADV"
  ],
  "lansdowne": [
    "PROPN"
  ],
  "uproar": [
    "VERB"
  ],
  "angiogenesis": [
    "VERB"
  ],
  "nematode": [
    "ADJ"
  ],
  "administratively": [
    "ADV"
  ],
  "mockery": [
    "INTJ"
  ],
  "paulina": [
    "NOUN"
  ],
  "northerly": [
    "ADV"
  ],
  "cancerous": [
    "ADJ"
  ],
  "quench": [
    "NOUN"
  ],
  "passer": [
    "NOUN"
  ],
  "secretory": [
    "ADJ"
  ],
  "reassessment": [
    "NOUN"
  ],
  "broil": [
    "NOUN"
  ],
  "hurrah": [
    "PROPN"
  ],
  "elbert": [
    "VERB"
  ],
  "modestly": [
    "ADV"
  ],
  "epitaph": [
    "NOUN"
  ],
  "sunil": [
    "NOUN"
  ],
  "insurrection": [
    "NOUN"
  ],
  "periodicity": [
    "NOUN"
  ],
  "trypsin": [
    "PROPN"
  ],
  "bursary": [
    "ADJ"
  ],
  "dependability": [
    "NOUN"
  ],
  "overdraft": [
    "NOUN"
  ],
  "deirdre": [
    "PROPN"
  ],
  "cacti": [
    "ADV"
  ],
  "bugaboo": [
    "NOUN"
  ],
  "aeration": [
    "NOUN"
  ],
  "antennae": [
    "NOUN"
  ],
  "chowder": [
    "PROPN"
  ],
  "headmaster": [
    "NOUN"
  ],
  "walrus": [
    "PROPN"
  ],
  "secretive": [
    "VERB"
  ],
  "grievous": [
    "ADJ"
  ],
  "generative": [
    "ADJ",
    "PROPN"
  ],
  "hippocampal": [
    "PROPN"
  ],
  "assyrian": [
    "PROPN"
  ],
  "vineland": [
    "ADV"
  ],
  "pensioner": [
    "PROPN"
  ],
  "stuttering": [
    "VERB"
  ],
  "forcefully": [
    "ADV"
  ],
  "spellbound": [
    "VERB"
  ],
  "conundrum": [
    "NOUN"
  ],
  "comedic": [
    "PROPN"
  ],
  "apical": [
    "ADJ"
  ],
  "synoptic": [
    "ADJ"
  ],
  "beryllium": [
    "NOUN"
  ],
  "disinfectant": [
    "NOUN"
  ],
  "piglet": [
    "NOUN"
  ],
  "intoxicating": [
    "VERB"
  ],
  "crumble": [
    "ADJ"
  ],
  "sketchbook": [
    "NOUN"
  ],
  "magdalene": [
    "VERB"
  ],
  "spatula": [
    "NOUN"
  ],
  "drifter": [
    "PROPN"
  ],
  "netted": [
    "VERB"
  ],
  "youve": [
    "PRON"
  ],
  "stardom": [
    "NOUN"
  ],
  "dispel": [
    "VERB"
  ],
  "jiffy": [
    "PROPN"
  ],
  "woodbine": [
    "NOUN"
  ],
  "immerse": [
    "VERB"
  ],
  "envious": [
    "ADJ"
  ],
  "colic": [
    "NOUN"
  ],
  "adolph": [
    "PROPN"
  ],
  "farthest": [
    "ADJ"
  ],
  "hirsute": [
    "VERB"
  ],
  "iniquity": [
    "NOUN"
  ],
  "prelim": [
    "NOUN"
  ],
  "fooling": [
    "VERB"
  ],
  "neverland": [
    "ADV"
  ],
  "vaulted": [
    "VERB"
  ],
  "vertebral": [
    "ADJ"
  ],
  "ectopic": [
    "NOUN"
  ],
  "resounding": [
    "VERB"
  ],
  "coulomb": [
    "NOUN"
  ],
  "restatement": [
    "NOUN"
  ],
  "unscheduled": [
    "ADJ"
  ],
  "saucy": [
    "PROPN"
  ],
  "blistering": [
    "VERB"
  ],
  "thermocouple": [
    "DET"
  ],
  "masque": [
    "PROPN"
  ],
  "decomposed": [
    "VERB"
  ],
  "flowery": [
    "NOUN"
  ],
  "scandalous": [
    "ADJ"
  ],
  "sunburn": [
    "NOUN"
  ],
  "pleistocene": [
    "NOUN"
  ],
  "menacing": [
    "VERB"
  ],
  "elector": [
    "NOUN"
  ],
  "solvency": [
    "NOUN"
  ],
  "lynette": [
    "NOUN"
  ],
  "neurotic": [
    "ADJ"
  ],
  "fielded": [
    "VERB"
  ],
  "bituminous": [
    "ADJ"
  ],
  "askew": [
    "PROPN"
  ],
  "blowfish": [
    "VERB"
  ],
  "groan": [
    "PROPN"
  ],
  "dusting": [
    "VERB"
  ],
  "uncontrollable": [
    "ADJ"
  ],
  "bridged": [
    "VERB"
  ],
  "rajesh": [
    "VERB"
  ],
  "unjustified": [
    "ADJ"
  ],
  "consenting": [
    "VERB"
  ],
  "torturing": [
    "VERB"
  ],
  "ukulele": [
    "PROPN"
  ],
  "relentlessly": [
    "ADV"
  ],
  "paperboard": [
    "NOUN"
  ],
  "bracken": [
    "PROPN"
  ],
  "decadence": [
    "NOUN"
  ],
  "girlie": [
    "NOUN"
  ],
  "antes": [
    "NOUN"
  ],
  "nourishing": [
    "VERB"
  ],
  "arduous": [
    "ADJ"
  ],
  "sidewinder": [
    "NOUN"
  ],
  "slugger": [
    "NOUN"
  ],
  "streetcar": [
    "NOUN"
  ],
  "stoker": [
    "PROPN"
  ],
  "fulcrum": [
    "VERB"
  ],
  "sadistic": [
    "ADJ"
  ],
  "cassiopeia": [
    "NOUN"
  ],
  "martingale": [
    "NOUN"
  ],
  "unscrupulous": [
    "ADJ"
  ],
  "reclassification": [
    "NOUN"
  ],
  "woohoo": [
    "PROPN"
  ],
  "unsettled": [
    "VERB"
  ],
  "inseparable": [
    "ADJ"
  ],
  "jurist": [
    "PROPN"
  ],
  "vestal": [
    "ADJ"
  ],
  "multimodal": [
    "ADJ"
  ],
  "variously": [
    "ADV"
  ],
  "recenter": [
    "VERB"
  ],
  "hematite": [
    "PROPN"
  ],
  "unintentionally": [
    "ADV"
  ],
  "dashing": [
    "VERB"
  ],
  "shipman": [
    "NOUN"
  ],
  "tiring": [
    "VERB"
  ],
  "incinerator": [
    "NOUN"
  ],
  "abate": [
    "VERB"
  ],
  "unorthodox": [
    "ADJ"
  ],
  "fibroblast": [
    "NOUN"
  ],
  "carrick": [
    "VERB"
  ],
  "piloting": [
    "VERB"
  ],
  "immersive": [
    "ADJ"
  ],
  "reinvent": [
    "VERB"
  ],
  "bellied": [
    "VERB"
  ],
  "mossy": [
    "ADJ"
  ],
  "addenda": [
    "NOUN"
  ],
  "balinese": [
    "NOUN"
  ],
  "keyhole": [
    "NOUN"
  ],
  "cardiopulmonary": [
    "PROPN"
  ],
  "biologic": [
    "VERB"
  ],
  "bowels": [
    "VERB"
  ],
  "cornet": [
    "NOUN"
  ],
  "schizophrenic": [
    "ADJ"
  ],
  "reversion": [
    "NOUN"
  ],
  "unplug": [
    "NOUN"
  ],
  "pressroom": [
    "NOUN"
  ],
  "greenbrier": [
    "NOUN"
  ],
  "superoxide": [
    "PROPN"
  ],
  "porcine": [
    "NOUN"
  ],
  "understatement": [
    "NOUN"
  ],
  "tormented": [
    "VERB"
  ],
  "immanuel": [
    "PROPN"
  ],
  "lodger": [
    "NOUN"
  ],
  "inshore": [
    "NOUN"
  ],
  "kettler": [
    "NOUN"
  ],
  "reducer": [
    "NOUN"
  ],
  "santee": [
    "NOUN"
  ],
  "thunderbolt": [
    "NOUN"
  ],
  "claudius": [
    "PROPN"
  ],
  "spina": [
    "NOUN"
  ],
  "apropos": [
    "NOUN"
  ],
  "tightness": [
    "NOUN"
  ],
  "pitiful": [
    "ADJ"
  ],
  "concatenation": [
    "NOUN"
  ],
  "seascape": [
    "NOUN"
  ],
  "winkel": [
    "NOUN"
  ],
  "bleached": [
    "VERB"
  ],
  "cortina": [
    "PROPN"
  ],
  "arbiter": [
    "NOUN"
  ],
  "hazelnut": [
    "NOUN"
  ],
  "chaco": [
    "PROPN"
  ],
  "reintegration": [
    "VERB"
  ],
  "locomotion": [
    "NOUN"
  ],
  "antimony": [
    "NOUN"
  ],
  "hater": [
    "NOUN"
  ],
  "buoyant": [
    "ADJ"
  ],
  "surrealism": [
    "NOUN"
  ],
  "expel": [
    "VERB"
  ],
  "clamshell": [
    "NOUN"
  ],
  "luminance": [
    "NOUN"
  ],
  "combatant": [
    "NOUN"
  ],
  "suresh": [
    "ADJ"
  ],
  "minnow": [
    "ADV"
  ],
  "swoop": [
    "NOUN"
  ],
  "gumbo": [
    "NOUN"
  ],
  "neuter": [
    "NOUN"
  ],
  "prejudicial": [
    "ADJ"
  ],
  "melamine": [
    "VERB"
  ],
  "episodic": [
    "ADJ"
  ],
  "introspection": [
    "NOUN"
  ],
  "lated": [
    "VERB"
  ],
  "divisive": [
    "ADJ"
  ],
  "benedictine": [
    "NOUN"
  ],
  "inappropriately": [
    "ADV"
  ],
  "vitally": [
    "ADV"
  ],
  "mavis": [
    "PROPN"
  ],
  "undivided": [
    "ADJ"
  ],
  "hurling": [
    "VERB"
  ],
  "brevity": [
    "NOUN"
  ],
  "visage": [
    "NOUN"
  ],
  "prickly": [
    "ADV"
  ],
  "graff": [
    "NOUN"
  ],
  "astonishment": [
    "NOUN"
  ],
  "whittle": [
    "VERB"
  ],
  "reworked": [
    "VERB"
  ],
  "catapult": [
    "NOUN"
  ],
  "meritorious": [
    "ADJ"
  ],
  "convoluted": [
    "VERB"
  ],
  "iberian": [
    "PROPN"
  ],
  "beheld": [
    "VERB"
  ],
  "martyrdom": [
    "NOUN"
  ],
  "stimulator": [
    "NOUN"
  ],
  "manna": [
    "NOUN"
  ],
  "tweezers": [
    "NOUN"
  ],
  "kinematic": [
    "ADJ"
  ],
  "housework": [
    "NOUN"
  ],
  "gunpowder": [
    "NOUN"
  ],
  "undressed": [
    "VERB"
  ],
  "southward": [
    "PROPN"
  ],
  "unsupervised": [
    "VERB"
  ],
  "copycat": [
    "NOUN"
  ],
  "prussian": [
    "PROPN"
  ],
  "adorn": [
    "VERB"
  ],
  "contemplative": [
    "ADJ"
  ],
  "awkwardly": [
    "ADV"
  ],
  "lifeless": [
    "VERB"
  ],
  "baffle": [
    "VERB"
  ],
  "thermally": [
    "ADV"
  ],
  "sobriety": [
    "NOUN"
  ],
  "albino": [
    "NOUN"
  ],
  "sprinter": [
    "NOUN"
  ],
  "isomorphic": [
    "ADJ"
  ],
  "burnet": [
    "NOUN"
  ],
  "conjugation": [
    "NOUN"
  ],
  "impasse": [
    "PROPN"
  ],
  "intensively": [
    "ADV"
  ],
  "successively": [
    "ADV"
  ],
  "squaw": [
    "NOUN"
  ],
  "pomegranate": [
    "VERB"
  ],
  "murmur": [
    "PROPN"
  ],
  "cotter": [
    "NOUN"
  ],
  "peptidase": [
    "PROPN"
  ],
  "bookkeeper": [
    "NOUN"
  ],
  "squeaky": [
    "ADJ"
  ],
  "silicate": [
    "VERB"
  ],
  "attache": [
    "VERB"
  ],
  "predictably": [
    "ADV"
  ],
  "chemise": [
    "NOUN"
  ],
  "flanking": [
    "VERB"
  ],
  "disconnection": [
    "NOUN"
  ],
  "prejudiced": [
    "VERB"
  ],
  "larva": [
    "PROPN"
  ],
  "laziness": [
    "INTJ"
  ],
  "obstetric": [
    "ADJ"
  ],
  "marigold": [
    "PROPN"
  ],
  "martel": [
    "NOUN"
  ],
  "typesetting": [
    "VERB"
  ],
  "tireless": [
    "ADJ"
  ],
  "chroma": [
    "PROPN"
  ],
  "leander": [
    "NOUN"
  ],
  "growl": [
    "NOUN"
  ],
  "lollipop": [
    "VERB"
  ],
  "brash": [
    "NOUN"
  ],
  "declaratory": [
    "ADJ"
  ],
  "hydrate": [
    "VERB"
  ],
  "diurnal": [
    "ADJ"
  ],
  "coolness": [
    "PROPN"
  ],
  "negativity": [
    "NOUN"
  ],
  "recumbent": [
    "NOUN"
  ],
  "shipwreck": [
    "NOUN"
  ],
  "fader": [
    "NOUN"
  ],
  "unconsciously": [
    "ADV"
  ],
  "doorbell": [
    "VERB"
  ],
  "dissolving": [
    "VERB"
  ],
  "osmond": [
    "VERB"
  ],
  "unsettling": [
    "VERB"
  ],
  "bugger": [
    "PROPN"
  ],
  "embolism": [
    "NOUN"
  ],
  "roebuck": [
    "NOUN"
  ],
  "highness": [
    "NOUN"
  ],
  "abstracted": [
    "VERB"
  ],
  "starling": [
    "VERB"
  ],
  "typhoid": [
    "NOUN"
  ],
  "perfecting": [
    "VERB"
  ],
  "adrenalin": [
    "PROPN"
  ],
  "afghani": [
    "ADJ"
  ],
  "furtherance": [
    "NOUN"
  ],
  "energize": [
    "VERB"
  ],
  "prohibitive": [
    "ADJ"
  ],
  "teague": [
    "NOUN"
  ],
  "phantasy": [
    "PROPN"
  ],
  "rotisserie": [
    "VERB"
  ],
  "scallop": [
    "VERB"
  ],
  "crusty": [
    "NOUN"
  ],
  "stillness": [
    "NOUN"
  ],
  "precipitate": [
    "VERB"
  ],
  "underlie": [
    "VERB"
  ],
  "chard": [
    "ADV"
  ],
  "singlet": [
    "NOUN"
  ],
  "minster": [
    "NOUN"
  ],
  "collapsible": [
    "ADJ"
  ],
  "sully": [
    "ADV"
  ],
  "prophylactic": [
    "ADJ"
  ],
  "cityscape": [
    "NOUN"
  ],
  "instill": [
    "NOUN"
  ],
  "inept": [
    "PROPN"
  ],
  "fraught": [
    "ADV"
  ],
  "perplexed": [
    "VERB"
  ],
  "replenish": [
    "VERB"
  ],
  "droplet": [
    "ADJ"
  ],
  "lakota": [
    "PROPN"
  ],
  "unwillingness": [
    "NOUN"
  ],
  "parlay": [
    "VERB"
  ],
  "divan": [
    "PROPN"
  ],
  "coexist": [
    "VERB"
  ],
  "advisement": [
    "NOUN"
  ],
  "metra": [
    "ADJ"
  ],
  "triangulation": [
    "NOUN"
  ],
  "eloquence": [
    "NOUN"
  ],
  "anarchism": [
    "NOUN"
  ],
  "definitively": [
    "ADV"
  ],
  "natchez": [
    "PROPN"
  ],
  "strewn": [
    "VERB"
  ],
  "terrance": [
    "NOUN"
  ],
  "belling": [
    "VERB"
  ],
  "representational": [
    "ADJ"
  ],
  "snark": [
    "VERB"
  ],
  "bewildered": [
    "VERB"
  ],
  "malignancy": [
    "NOUN"
  ],
  "copious": [
    "ADJ"
  ],
  "tremble": [
    "NOUN"
  ],
  "instantaneously": [
    "ADV"
  ],
  "thump": [
    "VERB"
  ],
  "pompeii": [
    "NOUN"
  ],
  "sojourn": [
    "VERB"
  ],
  "stateroom": [
    "NOUN"
  ],
  "caloric": [
    "VERB"
  ],
  "daniele": [
    "PROPN"
  ],
  "nucleoside": [
    "NOUN"
  ],
  "buttercup": [
    "VERB"
  ],
  "admissibility": [
    "NOUN"
  ],
  "sleuth": [
    "PROPN"
  ],
  "trudy": [
    "VERB"
  ],
  "herbaceous": [
    "ADJ"
  ],
  "distinguishable": [
    "ADJ"
  ],
  "immaterial": [
    "ADJ"
  ],
  "surging": [
    "VERB"
  ],
  "ethnography": [
    "NOUN"
  ],
  "contraband": [
    "VERB"
  ],
  "bulkhead": [
    "NOUN"
  ],
  "flagging": [
    "VERB"
  ],
  "willed": [
    "VERB"
  ],
  "replenishment": [
    "NOUN"
  ],
  "wounding": [
    "VERB"
  ],
  "inclement": [
    "NOUN"
  ],
  "yoghurt": [
    "NOUN"
  ],
  "definable": [
    "ADJ"
  ],
  "bruin": [
    "PROPN"
  ],
  "psychoanalytic": [
    "ADJ"
  ],
  "magpie": [
    "ADJ"
  ],
  "robbing": [
    "VERB"
  ],
  "dimer": [
    "NOUN"
  ],
  "impartiality": [
    "NOUN"
  ],
  "stemware": [
    "NOUN"
  ],
  "harpsichord": [
    "NOUN"
  ],
  "capes": [
    "NOUN"
  ],
  "impersonal": [
    "ADJ"
  ],
  "proposer": [
    "NOUN"
  ],
  "kerri": [
    "NOUN"
  ],
  "democratically": [
    "ADV"
  ],
  "salvo": [
    "NOUN"
  ],
  "furiously": [
    "ADV"
  ],
  "epitome": [
    "VERB"
  ],
  "nicol": [
    "NOUN"
  ],
  "camara": [
    "PROPN"
  ],
  "degas": [
    "PROPN"
  ],
  "lilian": [
    "PROPN"
  ],
  "glancing": [
    "VERB"
  ],
  "parenteral": [
    "ADJ"
  ],
  "fleck": [
    "VERB"
  ],
  "delicatessen": [
    "VERB"
  ],
  "kidderminster": [
    "NOUN"
  ],
  "inflamed": [
    "VERB"
  ],
  "promulgate": [
    "VERB"
  ],
  "clough": [
    "VERB"
  ],
  "unlink": [
    "NOUN"
  ],
  "shadowing": [
    "NOUN",
    "VERB"
  ],
  "regimental": [
    "ADJ"
  ],
  "rectified": [
    "VERB"
  ],
  "flanked": [
    "VERB"
  ],
  "crandall": [
    "NOUN"
  ],
  "primacy": [
    "NOUN"
  ],
  "pointy": [
    "ADJ"
  ],
  "centrale": [
    "NOUN"
  ],
  "recompile": [
    "NOUN"
  ],
  "insolvent": [
    "NOUN"
  ],
  "carmine": [
    "VERB"
  ],
  "relinquish": [
    "PROPN"
  ],
  "stover": [
    "NOUN"
  ],
  "succinct": [
    "ADJ"
  ],
  "palpable": [
    "ADJ"
  ],
  "compressive": [
    "PROPN"
  ],
  "wombat": [
    "VERB"
  ],
  "zippy": [
    "VERB"
  ],
  "odeon": [
    "NOUN"
  ],
  "inhale": [
    "NOUN"
  ],
  "dreamt": [
    "VERB"
  ],
  "chipper": [
    "VERB"
  ],
  "modulate": [
    "VERB"
  ],
  "fiancee": [
    "NOUN"
  ],
  "mediocrity": [
    "NOUN"
  ],
  "transcendent": [
    "NOUN"
  ],
  "lichen": [
    "PROPN"
  ],
  "lapsed": [
    "VERB"
  ],
  "marathi": [
    "PROPN"
  ],
  "newscast": [
    "NOUN"
  ],
  "gallop": [
    "PROPN"
  ],
  "unsatisfied": [
    "VERB"
  ],
  "barrio": [
    "NOUN"
  ],
  "exercisable": [
    "ADJ"
  ],
  "minstrel": [
    "NOUN"
  ],
  "contentment": [
    "VERB"
  ],
  "ontological": [
    "ADJ"
  ],
  "cranium": [
    "NOUN"
  ],
  "politic": [
    "NOUN"
  ],
  "reimbursable": [
    "ADJ"
  ],
  "exchequer": [
    "PROPN"
  ],
  "archaeologist": [
    "NOUN"
  ],
  "mitotic": [
    "ADJ"
  ],
  "falsehood": [
    "NOUN"
  ],
  "semifinal": [
    "ADJ"
  ],
  "deactivate": [
    "PROPN",
    "VERB"
  ],
  "falciparum": [
    "NOUN"
  ],
  "undetected": [
    "ADJ"
  ],
  "caries": [
    "NOUN"
  ],
  "microstructure": [
    "NOUN"
  ],
  "pleaser": [
    "NOUN"
  ],
  "disassembly": [
    "ADV"
  ],
  "miter": [
    "NOUN"
  ],
  "propositional": [
    "ADJ"
  ],
  "talkie": [
    "PROPN"
  ],
  "rosalie": [
    "PROPN"
  ],
  "metazoa": [
    "VERB"
  ],
  "indulgent": [
    "VERB"
  ],
  "wholeheartedly": [
    "ADV"
  ],
  "avast": [
    "VERB"
  ],
  "inelastic": [
    "ADJ"
  ],
  "neckline": [
    "NOUN"
  ],
  "aerodynamics": [
    "NOUN"
  ],
  "vertebrae": [
    "NOUN"
  ],
  "aristocracy": [
    "NOUN"
  ],
  "leviathan": [
    "NOUN"
  ],
  "eaves": [
    "NOUN"
  ],
  "wrinkled": [
    "VERB"
  ],
  "popularly": [
    "ADV"
  ],
  "bifurcation": [
    "NOUN"
  ],
  "falconer": [
    "NOUN"
  ],
  "watchman": [
    "PROPN"
  ],
  "poetics": [
    "NOUN"
  ],
  "entitle": [
    "NOUN"
  ],
  "alibi": [
    "PROPN"
  ],
  "ulcerative": [
    "VERB"
  ],
  "postponement": [
    "NOUN"
  ],
  "airlift": [
    "NOUN"
  ],
  "brooding": [
    "VERB"
  ],
  "endothelium": [
    "NOUN"
  ],
  "appointee": [
    "NOUN"
  ],
  "juncture": [
    "PROPN"
  ],
  "borehole": [
    "NOUN"
  ],
  "tunable": [
    "NOUN"
  ],
  "meager": [
    "PROPN"
  ],
  "panelist": [
    "NOUN"
  ],
  "commandant": [
    "NOUN"
  ],
  "bourgeoisie": [
    "NOUN"
  ],
  "plucked": [
    "VERB"
  ],
  "medalist": [
    "NOUN"
  ],
  "recessive": [
    "ADJ"
  ],
  "inflexible": [
    "ADJ"
  ],
  "flowered": [
    "VERB"
  ],
  "discord": [
    "PROPN"
  ],
  "redefinition": [
    "NOUN"
  ],
  "infield": [
    "VERB"
  ],
  "atchison": [
    "PROPN"
  ],
  "mindfulness": [
    "NOUN"
  ],
  "injurious": [
    "ADJ"
  ],
  "synapses": [
    "NOUN"
  ],
  "unmounted": [
    "ADJ"
  ],
  "utilitarian": [
    "PROPN"
  ],
  "behemoth": [
    "VERB"
  ],
  "compacted": [
    "VERB"
  ],
  "thrower": [
    "NOUN"
  ],
  "prana": [
    "PROPN"
  ],
  "trike": [
    "ADJ"
  ],
  "distillery": [
    "NOUN"
  ],
  "reread": [
    "NOUN"
  ],
  "disengagement": [
    "ADJ"
  ],
  "iodide": [
    "NOUN"
  ],
  "crucifix": [
    "VERB"
  ],
  "fistula": [
    "NOUN"
  ],
  "irreverent": [
    "ADJ"
  ],
  "censure": [
    "NOUN"
  ],
  "carbine": [
    "NOUN"
  ],
  "crawfish": [
    "PROPN"
  ],
  "credo": [
    "PROPN",
    "NOUN"
  ],
  "ecuadorian": [
    "PROPN"
  ],
  "heartless": [
    "NOUN"
  ],
  "natick": [
    "PROPN"
  ],
  "centrist": [
    "NOUN"
  ],
  "contented": [
    "VERB"
  ],
  "femur": [
    "NOUN"
  ],
  "separatist": [
    "NOUN"
  ],
  "forcible": [
    "ADJ"
  ],
  "lifeboat": [
    "NOUN"
  ],
  "bushy": [
    "ADJ"
  ],
  "tuskegee": [
    "NOUN"
  ],
  "thickening": [
    "VERB"
  ],
  "programma": [
    "PROPN"
  ],
  "eastbound": [
    "VERB"
  ],
  "grits": [
    "NOUN"
  ],
  "pulldown": [
    "ADJ"
  ],
  "inoculation": [
    "NOUN"
  ],
  "glorify": [
    "VERB"
  ],
  "abner": [
    "PROPN"
  ],
  "lineman": [
    "NOUN"
  ],
  "cleaver": [
    "NOUN"
  ],
  "overuse": [
    "NOUN"
  ],
  "newsprint": [
    "NOUN"
  ],
  "maris": [
    "PROPN"
  ],
  "admixture": [
    "NOUN"
  ],
  "haulage": [
    "NOUN"
  ],
  "heredity": [
    "NOUN"
  ],
  "nominally": [
    "ADV"
  ],
  "convolution": [
    "NOUN"
  ],
  "chloroform": [
    "NOUN"
  ],
  "nettle": [
    "ADJ"
  ],
  "mismanagement": [
    "NOUN"
  ],
  "convincingly": [
    "ADV"
  ],
  "abbie": [
    "PROPN"
  ],
  "galician": [
    "PROPN"
  ],
  "golem": [
    "NOUN"
  ],
  "evangeline": [
    "NOUN"
  ],
  "conifer": [
    "PROPN"
  ],
  "phenylalanine": [
    "VERB"
  ],
  "nonpublic": [
    "ADJ"
  ],
  "mischievous": [
    "ADJ"
  ],
  "inversely": [
    "ADV"
  ],
  "fateful": [
    "ADJ"
  ],
  "eyelet": [
    "NOUN"
  ],
  "immunologic": [
    "PROPN"
  ],
  "complacency": [
    "NOUN"
  ],
  "beeswax": [
    "NOUN"
  ],
  "crosswalk": [
    "NOUN"
  ],
  "insular": [
    "ADJ"
  ],
  "sensuality": [
    "NOUN"
  ],
  "banyan": [
    "PROPN"
  ],
  "affix": [
    "VERB"
  ],
  "opinionated": [
    "ADJ",
    "VERB"
  ],
  "quirk": [
    "NOUN"
  ],
  "professed": [
    "VERB"
  ],
  "blinks": [
    "VERB"
  ],
  "sensuous": [
    "ADJ"
  ],
  "sawing": [
    "VERB"
  ],
  "herding": [
    "VERB"
  ],
  "mammalia": [
    "NOUN"
  ],
  "hopped": [
    "VERB"
  ],
  "goldeneye": [
    "NOUN"
  ],
  "halcyon": [
    "VERB"
  ],
  "bowing": [
    "VERB"
  ],
  "unfiltered": [
    "VERB"
  ],
  "cogent": [
    "NOUN"
  ],
  "traversing": [
    "VERB"
  ],
  "communique": [
    "NOUN"
  ],
  "uninformed": [
    "VERB"
  ],
  "cantina": [
    "NOUN"
  ],
  "polyamide": [
    "NOUN"
  ],
  "necromancer": [
    "NOUN"
  ],
  "subcontinent": [
    "NOUN"
  ],
  "balmoral": [
    "ADJ"
  ],
  "aberration": [
    "NOUN"
  ],
  "specifier": [
    "ADV"
  ],
  "mollie": [
    "NOUN"
  ],
  "subsidize": [
    "VERB"
  ],
  "conclusively": [
    "ADV"
  ],
  "calcareous": [
    "ADJ"
  ],
  "crippling": [
    "ADJ"
  ],
  "sundial": [
    "ADJ"
  ],
  "tufted": [
    "VERB"
  ],
  "flaky": [
    "ADJ",
    "PROPN"
  ],
  "typology": [
    "NOUN"
  ],
  "hydrangea": [
    "VERB"
  ],
  "chieftain": [
    "NOUN"
  ],
  "aesthetically": [
    "ADV"
  ],
  "gestalt": [
    "VERB"
  ],
  "honeysuckle": [
    "NOUN"
  ],
  "unspoken": [
    "VERB"
  ],
  "ishmael": [
    "PROPN"
  ],
  "rhoda": [
    "PROPN"
  ],
  "flite": [
    "NOUN"
  ],
  "jammer": [
    "NOUN"
  ],
  "forbidding": [
    "VERB"
  ],
  "sparring": [
    "VERB"
  ],
  "adonis": [
    "NOUN"
  ],
  "distressing": [
    "VERB"
  ],
  "ethnically": [
    "ADV"
  ],
  "gelding": [
    "VERB"
  ],
  "mastectomy": [
    "NOUN"
  ],
  "jaundice": [
    "NOUN"
  ],
  "aspergillus": [
    "ADP"
  ],
  "variational": [
    "ADJ"
  ],
  "crankshaft": [
    "NOUN"
  ],
  "dainty": [
    "NOUN"
  ],
  "airframe": [
    "NOUN"
  ],
  "beater": [
    "NOUN"
  ],
  "dietetic": [
    "ADJ"
  ],
  "crackle": [
    "VERB"
  ],
  "stereotypical": [
    "ADJ"
  ],
  "victimization": [
    "NOUN"
  ],
  "parallax": [
    "NOUN"
  ],
  "zante": [
    "NOUN"
  ],
  "nonresidential": [
    "ADJ"
  ],
  "alban": [
    "PROPN"
  ],
  "carcinogen": [
    "NOUN"
  ],
  "orville": [
    "PROPN"
  ],
  "belcher": [
    "VERB"
  ],
  "sedentary": [
    "ADJ"
  ],
  "extermination": [
    "NOUN"
  ],
  "watchtower": [
    "NOUN"
  ],
  "unmanaged": [
    "VERB"
  ],
  "transposition": [
    "NOUN"
  ],
  "crossbow": [
    "NOUN"
  ],
  "speciation": [
    "NOUN"
  ],
  "betta": [
    "NOUN"
  ],
  "repel": [
    "PROPN"
  ],
  "emmet": [
    "PROPN"
  ],
  "statistician": [
    "PROPN"
  ],
  "fungicide": [
    "ADV"
  ],
  "onerous": [
    "ADJ"
  ],
  "litas": [
    "NOUN"
  ],
  "hakim": [
    "PROPN"
  ],
  "tenderly": [
    "ADV"
  ],
  "puree": [
    "ADJ"
  ],
  "bonny": [
    "PROPN"
  ],
  "haddock": [
    "NOUN"
  ],
  "tachycardia": [
    "NOUN"
  ],
  "virginian": [
    "PROPN"
  ],
  "cosine": [
    "NOUN"
  ],
  "oftentimes": [
    "VERB"
  ],
  "entanglement": [
    "NOUN"
  ],
  "swath": [
    "NOUN"
  ],
  "miserably": [
    "ADV"
  ],
  "meehan": [
    "VERB"
  ],
  "infiltrate": [
    "VERB"
  ],
  "argosy": [
    "NOUN"
  ],
  "renounce": [
    "NOUN"
  ],
  "jesper": [
    "PROPN"
  ],
  "copilot": [
    "PROPN",
    "NOUN"
  ],
  "nutritionist": [
    "NOUN"
  ],
  "clouded": [
    "ADJ"
  ],
  "effector": [
    "NOUN"
  ],
  "diverting": [
    "VERB"
  ],
  "derogatory": [
    "ADJ"
  ],
  "discontinuous": [
    "ADJ"
  ],
  "uncorrected": [
    "VERB"
  ],
  "stillman": [
    "PROPN"
  ],
  "bighorn": [
    "VERB"
  ],
  "inaccuracy": [
    "NOUN"
  ],
  "assimilate": [
    "VERB"
  ],
  "heartbreaking": [
    "VERB"
  ],
  "gimmick": [
    "PROPN"
  ],
  "laine": [
    "NOUN"
  ],
  "moniker": [
    "NOUN"
  ],
  "gottfried": [
    "VERB"
  ],
  "credence": [
    "NOUN"
  ],
  "welling": [
    "VERB"
  ],
  "georgette": [
    "PROPN"
  ],
  "incite": [
    "VERB"
  ],
  "divulge": [
    "PROPN"
  ],
  "unreported": [
    "VERB"
  ],
  "guarani": [
    "PROPN"
  ],
  "laughable": [
    "ADJ"
  ],
  "momentous": [
    "ADJ"
  ],
  "footpath": [
    "NOUN"
  ],
  "elkhorn": [
    "NOUN"
  ],
  "sublet": [
    "NOUN"
  ],
  "chiltern": [
    "ADJ"
  ],
  "antares": [
    "NOUN"
  ],
  "peaking": [
    "VERB"
  ],
  "harem": [
    "PROPN"
  ],
  "fussy": [
    "ADJ"
  ],
  "civility": [
    "NOUN"
  ],
  "seltzer": [
    "NOUN"
  ],
  "homeostasis": [
    "VERB"
  ],
  "deluge": [
    "NOUN"
  ],
  "ventricle": [
    "NOUN"
  ],
  "thrasher": [
    "NOUN"
  ],
  "unshaved": [
    "VERB"
  ],
  "softwood": [
    "NOUN"
  ],
  "croupier": [
    "PROPN"
  ],
  "hausa": [
    "PROPN"
  ],
  "fluted": [
    "VERB"
  ],
  "rhinitis": [
    "VERB"
  ],
  "venison": [
    "NOUN"
  ],
  "shoal": [
    "NOUN"
  ],
  "catheterization": [
    "NOUN"
  ],
  "blushing": [
    "VERB"
  ],
  "reseal": [
    "NOUN"
  ],
  "babylonian": [
    "PROPN"
  ],
  "biota": [
    "PROPN"
  ],
  "deflation": [
    "NOUN"
  ],
  "skillfully": [
    "ADV"
  ],
  "heady": [
    "ADJ"
  ],
  "badlands": [
    "NOUN"
  ],
  "backstroke": [
    "VERB"
  ],
  "cortes": [
    "NOUN"
  ],
  "spooner": [
    "NOUN"
  ],
  "intractable": [
    "ADJ"
  ],
  "speckled": [
    "VERB"
  ],
  "enumerate": [
    "VERB"
  ],
  "onondaga": [
    "NOUN"
  ],
  "brandywine": [
    "VERB"
  ],
  "resonate": [
    "VERB"
  ],
  "fives": [
    "NOUN"
  ],
  "diphtheria": [
    "NOUN"
  ],
  "hazelwood": [
    "NOUN"
  ],
  "outfield": [
    "VERB"
  ],
  "carcinogenesis": [
    "NOUN"
  ],
  "phenolic": [
    "ADJ"
  ],
  "hoard": [
    "VERB"
  ],
  "petrie": [
    "VERB"
  ],
  "legalization": [
    "NOUN"
  ],
  "lading": [
    "VERB"
  ],
  "modernize": [
    "VERB",
    "PROPN"
  ],
  "woodcock": [
    "NOUN"
  ],
  "churning": [
    "VERB"
  ],
  "brookside": [
    "NOUN"
  ],
  "streamer": [
    "NOUN"
  ],
  "accumulator": [
    "NOUN"
  ],
  "unquestionably": [
    "ADV"
  ],
  "crocus": [
    "PROPN"
  ],
  "citizenry": [
    "VERB"
  ],
  "reproach": [
    "VERB"
  ],
  "redeemable": [
    "ADJ"
  ],
  "maxillofacial": [
    "ADJ"
  ],
  "vishnu": [
    "ADJ"
  ],
  "chimpanzee": [
    "PROPN"
  ],
  "meson": [
    "NOUN"
  ],
  "parathyroid": [
    "VERB"
  ],
  "analgesia": [
    "PROPN"
  ],
  "cherub": [
    "PROPN"
  ],
  "trumpeter": [
    "NOUN"
  ],
  "theyre": [
    "PRON"
  ],
  "serrated": [
    "VERB"
  ],
  "emphatically": [
    "ADV"
  ],
  "pawtucket": [
    "NOUN"
  ],
  "reassured": [
    "VERB"
  ],
  "bimonthly": [
    "ADV"
  ],
  "senna": [
    "NOUN"
  ],
  "perceiving": [
    "VERB"
  ],
  "commendation": [
    "NOUN"
  ],
  "surgically": [
    "ADV"
  ],
  "nongovernmental": [
    "ADJ"
  ],
  "hydrostatic": [
    "ADJ"
  ],
  "contending": [
    "VERB"
  ],
  "patriarchal": [
    "PROPN"
  ],
  "spelt": [
    "VERB"
  ],
  "clostridium": [
    "NOUN"
  ],
  "archetype": [
    "NOUN",
    "PROPN"
  ],
  "antiseptic": [
    "ADJ"
  ],
  "shamanism": [
    "NOUN"
  ],
  "roussillon": [
    "NOUN"
  ],
  "upheaval": [
    "NOUN"
  ],
  "rationalize": [
    "VERB"
  ],
  "cringe": [
    "VERB"
  ],
  "unearth": [
    "ADJ"
  ],
  "inconclusive": [
    "ADJ"
  ],
  "mouthful": [
    "ADJ"
  ],
  "gazelle": [
    "PROPN"
  ],
  "subclause": [
    "VERB"
  ],
  "gauche": [
    "NOUN"
  ],
  "minion": [
    "NOUN"
  ],
  "complicity": [
    "NOUN"
  ],
  "unstrung": [
    "PROPN"
  ],
  "drivel": [
    "NOUN"
  ],
  "cantilever": [
    "PROPN"
  ],
  "penchant": [
    "NOUN"
  ],
  "prospector": [
    "NOUN"
  ],
  "unwise": [
    "ADJ"
  ],
  "financier": [
    "NOUN"
  ],
  "allegory": [
    "NOUN"
  ],
  "konstantin": [
    "PROPN"
  ],
  "acropolis": [
    "PROPN"
  ],
  "stifle": [
    "VERB"
  ],
  "lymphoid": [
    "ADJ"
  ],
  "tiberius": [
    "ADJ"
  ],
  "paradoxical": [
    "PROPN"
  ],
  "stateless": [
    "NOUN"
  ],
  "rousing": [
    "VERB"
  ],
  "cerebellum": [
    "PROPN"
  ],
  "statehood": [
    "NOUN"
  ],
  "knelt": [
    "VERB"
  ],
  "devour": [
    "NOUN"
  ],
  "insanely": [
    "ADV"
  ],
  "treachery": [
    "NOUN"
  ],
  "aidable": [
    "ADJ"
  ],
  "taxidermy": [
    "NOUN"
  ],
  "portraiture": [
    "NOUN"
  ],
  "juergen": [
    "NOUN"
  ],
  "pashmina": [
    "PROPN"
  ],
  "undercut": [
    "VERB"
  ],
  "roaster": [
    "NOUN"
  ],
  "overcrowded": [
    "VERB"
  ],
  "hypertrophy": [
    "NOUN"
  ],
  "arouse": [
    "VERB"
  ],
  "wobble": [
    "VERB"
  ],
  "ticked": [
    "VERB"
  ],
  "counterstrike": [
    "ADJ"
  ],
  "hinterland": [
    "VERB"
  ],
  "housewarming": [
    "VERB"
  ],
  "regenerative": [
    "ADJ"
  ],
  "repulsive": [
    "ADJ"
  ],
  "bacteriophage": [
    "NOUN"
  ],
  "seclusion": [
    "NOUN"
  ],
  "transect": [
    "PROPN"
  ],
  "elucidate": [
    "VERB"
  ],
  "fated": [
    "VERB"
  ],
  "frighten": [
    "VERB"
  ],
  "amputation": [
    "NOUN"
  ],
  "sinusoidal": [
    "NOUN"
  ],
  "hauler": [
    "NOUN"
  ],
  "headroom": [
    "NOUN"
  ],
  "fortnightly": [
    "ADV"
  ],
  "yerba": [
    "NOUN"
  ],
  "subtlety": [
    "NOUN"
  ],
  "creditable": [
    "ADJ"
  ],
  "appreciable": [
    "ADJ"
  ],
  "delicacy": [
    "NOUN"
  ],
  "cinch": [
    "VERB"
  ],
  "futility": [
    "NOUN"
  ],
  "enlistment": [
    "ADJ"
  ],
  "blissful": [
    "ADJ"
  ],
  "dinky": [
    "ADJ"
  ],
  "platonic": [
    "ADJ"
  ],
  "injunctive": [
    "VERB"
  ],
  "coincidentally": [
    "ADV"
  ],
  "pollination": [
    "NOUN"
  ],
  "synchro": [
    "NOUN"
  ],
  "chutney": [
    "PROPN"
  ],
  "averse": [
    "ADV"
  ],
  "naturopathic": [
    "ADJ"
  ],
  "afield": [
    "ADV"
  ],
  "dermatologist": [
    "NOUN"
  ],
  "casein": [
    "NOUN"
  ],
  "endearing": [
    "VERB"
  ],
  "mishap": [
    "NOUN"
  ],
  "lackey": [
    "NOUN"
  ],
  "whooping": [
    "VERB"
  ],
  "scrum": [
    "PROPN",
    "NOUN"
  ],
  "everyman": [
    "PROPN"
  ],
  "musing": [
    "VERB"
  ],
  "masai": [
    "VERB"
  ],
  "barricade": [
    "VERB"
  ],
  "inquest": [
    "NOUN"
  ],
  "snipe": [
    "NOUN"
  ],
  "eastland": [
    "NOUN"
  ],
  "metropole": [
    "NOUN"
  ],
  "hapless": [
    "ADJ"
  ],
  "sagebrush": [
    "VERB"
  ],
  "radiologist": [
    "NOUN"
  ],
  "mirza": [
    "PROPN"
  ],
  "britten": [
    "VERB"
  ],
  "beaux": [
    "PROPN"
  ],
  "gunman": [
    "NOUN"
  ],
  "traversed": [
    "VERB"
  ],
  "sparsely": [
    "ADV"
  ],
  "mitra": [
    "PROPN"
  ],
  "indexer": [
    "NOUN",
    "PROPN"
  ],
  "innkeeper": [
    "ADV"
  ],
  "mistrust": [
    "NOUN"
  ],
  "lordship": [
    "NOUN"
  ],
  "athabasca": [
    "PROPN"
  ],
  "unbuffered": [
    "VERB"
  ],
  "egregious": [
    "ADJ"
  ],
  "sperma": [
    "PROPN"
  ],
  "legato": [
    "PROPN"
  ],
  "conventionally": [
    "ADV"
  ],
  "perceptive": [
    "ADJ"
  ],
  "darwinism": [
    "NOUN"
  ],
  "lecithin": [
    "X"
  ],
  "destitute": [
    "VERB"
  ],
  "singly": [
    "ADV"
  ],
  "abuser": [
    "NOUN"
  ],
  "headless": [
    "NOUN"
  ],
  "anatomic": [
    "ADJ"
  ],
  "petrified": [
    "VERB"
  ],
  "litho": [
    "PROPN"
  ],
  "rattling": [
    "VERB"
  ],
  "thane": [
    "NOUN"
  ],
  "salve": [
    "VERB"
  ],
  "marseilles": [
    "NOUN"
  ],
  "fissure": [
    "NOUN"
  ],
  "curtail": [
    "NOUN"
  ],
  "legalize": [
    "NOUN"
  ],
  "epinephrine": [
    "NOUN"
  ],
  "transom": [
    "NOUN"
  ],
  "talker": [
    "NOUN"
  ],
  "picayune": [
    "NOUN"
  ],
  "bestow": [
    "VERB"
  ],
  "autologous": [
    "ADJ"
  ],
  "homespun": [
    "ADJ"
  ],
  "enraged": [
    "VERB"
  ],
  "blotter": [
    "NOUN"
  ],
  "intonation": [
    "NOUN"
  ],
  "dissecting": [
    "VERB"
  ],
  "humpback": [
    "NOUN"
  ],
  "bartending": [
    "VERB"
  ],
  "retracted": [
    "VERB"
  ],
  "fantastico": [
    "NOUN"
  ],
  "friar": [
    "ADJ"
  ],
  "hospitable": [
    "ADJ"
  ],
  "melodrama": [
    "NOUN"
  ],
  "preclinical": [
    "ADJ"
  ],
  "preparer": [
    "NOUN"
  ],
  "deductive": [
    "ADJ"
  ],
  "trapper": [
    "VERB"
  ],
  "makeshift": [
    "VERB"
  ],
  "pygmy": [
    "NOUN"
  ],
  "tattered": [
    "VERB"
  ],
  "tachometer": [
    "NOUN"
  ],
  "embarrass": [
    "NOUN"
  ],
  "orchestration": [
    "PROPN",
    "NOUN"
  ],
  "adipose": [
    "VERB"
  ],
  "potting": [
    "VERB"
  ],
  "uncomplicated": [
    "ADJ"
  ],
  "wenzel": [
    "NOUN"
  ],
  "clemency": [
    "NOUN"
  ],
  "woolly": [
    "ADV"
  ],
  "ligation": [
    "NOUN"
  ],
  "blemish": [
    "PROPN"
  ],
  "inductance": [
    "NOUN"
  ],
  "reallocation": [
    "NOUN"
  ],
  "rehabilitative": [
    "VERB"
  ],
  "pansy": [
    "ADJ"
  ],
  "reassignment": [
    "NOUN"
  ],
  "hydrodynamic": [
    "ADJ"
  ],
  "huntsman": [
    "NOUN"
  ],
  "unlabeled": [
    "VERB"
  ],
  "perpetually": [
    "ADV"
  ],
  "divisible": [
    "ADJ"
  ],
  "tabla": [
    "NOUN"
  ],
  "celluloid": [
    "NOUN"
  ],
  "identically": [
    "ADV"
  ],
  "lightness": [
    "NOUN"
  ],
  "saddlery": [
    "NOUN"
  ],
  "whiteside": [
    "NOUN"
  ],
  "dingo": [
    "PROPN"
  ],
  "marcello": [
    "INTJ"
  ],
  "sessional": [
    "ADJ"
  ],
  "pagination": [
    "NOUN",
    "PROPN"
  ],
  "harbinger": [
    "PROPN"
  ],
  "mustache": [
    "NOUN"
  ],
  "truncate": [
    "VERB"
  ],
  "polygraph": [
    "PROPN"
  ],
  "digress": [
    "NOUN"
  ],
  "overseen": [
    "VERB"
  ],
  "revolutionize": [
    "VERB"
  ],
  "beaker": [
    "NOUN"
  ],
  "baggy": [
    "PROPN"
  ],
  "childbearing": [
    "VERB"
  ],
  "crayfish": [
    "VERB"
  ],
  "minotaur": [
    "INTJ"
  ],
  "rejoicing": [
    "VERB"
  ],
  "repaint": [
    "NOUN"
  ],
  "ariadne": [
    "PROPN"
  ],
  "spastic": [
    "ADJ"
  ],
  "quiver": [
    "NOUN"
  ],
  "illuminati": [
    "PROPN"
  ],
  "piezoelectric": [
    "NOUN"
  ],
  "coronet": [
    "NOUN"
  ],
  "prodigal": [
    "ADJ"
  ],
  "wield": [
    "VERB"
  ],
  "resolute": [
    "ADJ"
  ],
  "adage": [
    "NOUN"
  ],
  "getter": [
    "NOUN"
  ],
  "aftercare": [
    "VERB"
  ],
  "wetter": [
    "NOUN"
  ],
  "bonaventure": [
    "NOUN"
  ],
  "diastolic": [
    "ADJ"
  ],
  "conjure": [
    "NOUN"
  ],
  "discoloration": [
    "NOUN"
  ],
  "morel": [
    "NOUN"
  ],
  "adrift": [
    "VERB"
  ],
  "kashmiri": [
    "PROPN"
  ],
  "confiscation": [
    "NOUN"
  ],
  "enabler": [
    "NOUN"
  ],
  "budge": [
    "VERB"
  ],
  "piotr": [
    "NOUN"
  ],
  "chairmanship": [
    "NOUN"
  ],
  "malformed": [
    "VERB"
  ],
  "dumbbell": [
    "NOUN"
  ],
  "stine": [
    "VERB"
  ],
  "fringed": [
    "VERB"
  ],
  "citric": [
    "NOUN"
  ],
  "delineate": [
    "VERB"
  ],
  "nitride": [
    "ADJ"
  ],
  "organist": [
    "NOUN"
  ],
  "unbonded": [
    "VERB"
  ],
  "kneel": [
    "NOUN"
  ],
  "rehearing": [
    "VERB"
  ],
  "depositary": [
    "NOUN"
  ],
  "furthest": [
    "ADJ"
  ],
  "virulent": [
    "NOUN"
  ],
  "garret": [
    "NOUN"
  ],
  "pathologic": [
    "PROPN"
  ],
  "commendable": [
    "ADJ"
  ],
  "inadequacy": [
    "NOUN"
  ],
  "barbaric": [
    "ADJ"
  ],
  "otitis": [
    "NOUN"
  ],
  "deliciously": [
    "ADV"
  ],
  "persephone": [
    "NOUN"
  ],
  "eatery": [
    "ADV"
  ],
  "peony": [
    "PROPN"
  ],
  "glycerin": [
    "VERB"
  ],
  "tailings": [
    "NOUN"
  ],
  "shirtless": [
    "NOUN"
  ],
  "lifelike": [
    "ADV"
  ],
  "crumpler": [
    "NOUN"
  ],
  "nucleon": [
    "PROPN"
  ],
  "presbytery": [
    "VERB"
  ],
  "calcite": [
    "NOUN"
  ],
  "gunshot": [
    "NOUN"
  ],
  "supposing": [
    "VERB"
  ],
  "calicut": [
    "NOUN"
  ],
  "unverified": [
    "VERB"
  ],
  "untapped": [
    "ADJ"
  ],
  "batty": [
    "PROPN"
  ],
  "castilla": [
    "NOUN"
  ],
  "zealous": [
    "ADJ"
  ],
  "ocarina": [
    "NOUN"
  ],
  "camus": [
    "VERB"
  ],
  "rattlesnake": [
    "VERB"
  ],
  "iridescent": [
    "NOUN"
  ],
  "defrost": [
    "VERB"
  ],
  "consecutively": [
    "ADV"
  ],
  "twine": [
    "NOUN"
  ],
  "peres": [
    "NOUN"
  ],
  "assemblyman": [
    "NOUN"
  ],
  "enforcer": [
    "NOUN"
  ],
  "judicious": [
    "ADJ"
  ],
  "unaltered": [
    "ADJ"
  ],
  "customarily": [
    "ADV"
  ],
  "collation": [
    "NOUN"
  ],
  "diction": [
    "NOUN"
  ],
  "unoccupied": [
    "ADJ"
  ],
  "tigris": [
    "PROPN"
  ],
  "piscataway": [
    "PROPN"
  ],
  "scrubber": [
    "NOUN"
  ],
  "sabina": [
    "NOUN"
  ],
  "logarithm": [
    "PROPN"
  ],
  "monocular": [
    "ADJ"
  ],
  "tandy": [
    "PROPN"
  ],
  "ferrite": [
    "PROPN"
  ],
  "buckwheat": [
    "ADJ"
  ],
  "yearling": [
    "VERB"
  ],
  "agape": [
    "VERB"
  ],
  "undifferentiated": [
    "ADJ"
  ],
  "damnation": [
    "NOUN"
  ],
  "reaffirm": [
    "VERB"
  ],
  "rapidity": [
    "NOUN"
  ],
  "deleterious": [
    "ADJ"
  ],
  "sportsmanship": [
    "NOUN"
  ],
  "lampoon": [
    "NOUN"
  ],
  "garibaldi": [
    "PROPN"
  ],
  "airtight": [
    "NOUN"
  ],
  "annular": [
    "ADJ"
  ],
  "sparking": [
    "VERB"
  ],
  "alluvial": [
    "ADJ"
  ],
  "incisive": [
    "ADJ"
  ],
  "tenement": [
    "NOUN"
  ],
  "discernment": [
    "ADJ"
  ],
  "chalice": [
    "NOUN"
  ],
  "hypocrite": [
    "NOUN"
  ],
  "obsolescence": [
    "NOUN"
  ],
  "recode": [
    "ADJ"
  ],
  "harrowing": [
    "ADJ"
  ],
  "prefect": [
    "VERB"
  ],
  "sweetly": [
    "ADV"
  ],
  "cleave": [
    "NOUN"
  ],
  "flimsy": [
    "ADJ"
  ],
  "rearrangement": [
    "NOUN"
  ],
  "delilah": [
    "PROPN"
  ],
  "kingpin": [
    "NOUN"
  ],
  "bedded": [
    "VERB"
  ],
  "shivering": [
    "VERB"
  ],
  "overlord": [
    "ADV"
  ],
  "daffodil": [
    "NOUN"
  ],
  "formality": [
    "NOUN"
  ],
  "lymphocytic": [
    "ADJ"
  ],
  "tigre": [
    "VERB"
  ],
  "undetectable": [
    "ADJ"
  ],
  "vermeil": [
    "VERB"
  ],
  "ultimo": [
    "ADJ"
  ],
  "silage": [
    "NOUN"
  ],
  "statuary": [
    "PROPN"
  ],
  "goudy": [
    "NOUN"
  ],
  "bilge": [
    "PROPN"
  ],
  "moraine": [
    "NOUN"
  ],
  "prolactin": [
    "PROPN"
  ],
  "moravian": [
    "PROPN"
  ],
  "intermittently": [
    "ADV"
  ],
  "chewy": [
    "NOUN"
  ],
  "decimation": [
    "NOUN"
  ],
  "hypotension": [
    "NOUN"
  ],
  "stateful": [
    "ADJ"
  ],
  "busby": [
    "PROPN"
  ],
  "patterning": [
    "VERB"
  ],
  "inapplicable": [
    "ADJ"
  ],
  "cheep": [
    "VERB"
  ],
  "superconductivity": [
    "NOUN"
  ],
  "pasha": [
    "PROPN"
  ],
  "amygdala": [
    "ADV"
  ],
  "corrie": [
    "NOUN"
  ],
  "scour": [
    "VERB"
  ],
  "motionless": [
    "NOUN"
  ],
  "dueling": [
    "VERB"
  ],
  "galant": [
    "NOUN"
  ],
  "fallow": [
    "ADJ"
  ],
  "reshape": [
    "NOUN"
  ],
  "aileen": [
    "NUM"
  ],
  "electrolytic": [
    "ADJ"
  ],
  "leapt": [
    "VERB"
  ],
  "widower": [
    "NOUN"
  ],
  "quagmire": [
    "NOUN"
  ],
  "riyal": [
    "NOUN"
  ],
  "taffy": [
    "NOUN"
  ],
  "purging": [
    "VERB"
  ],
  "cerebellar": [
    "NOUN"
  ],
  "fainting": [
    "VERB"
  ],
  "theorist": [
    "NOUN"
  ],
  "serviceable": [
    "ADJ"
  ],
  "strider": [
    "NOUN"
  ],
  "indigestion": [
    "NOUN"
  ],
  "eastlake": [
    "VERB"
  ],
  "jackal": [
    "PROPN"
  ],
  "curative": [
    "ADJ"
  ],
  "igneous": [
    "ADJ"
  ],
  "patently": [
    "ADV"
  ],
  "delectable": [
    "ADJ"
  ],
  "proletariat": [
    "NOUN"
  ],
  "analytically": [
    "ADV"
  ],
  "aramaic": [
    "ADJ"
  ],
  "publicist": [
    "NOUN"
  ],
  "fanciful": [
    "ADJ"
  ],
  "tempera": [
    "NOUN"
  ],
  "intermediation": [
    "NOUN"
  ],
  "lacing": [
    "VERB"
  ],
  "soundboard": [
    "ADV"
  ],
  "consummate": [
    "VERB"
  ],
  "titration": [
    "NOUN"
  ],
  "boney": [
    "NOUN"
  ],
  "oxidoreductase": [
    "NOUN"
  ],
  "skimmer": [
    "NOUN"
  ],
  "technic": [
    "VERB"
  ],
  "extrinsic": [
    "ADJ"
  ],
  "sketchy": [
    "ADJ"
  ],
  "gooseneck": [
    "NOUN"
  ],
  "tiffin": [
    "NOUN"
  ],
  "pacer": [
    "NOUN"
  ],
  "dismayed": [
    "VERB"
  ],
  "bitty": [
    "VERB"
  ],
  "miraculously": [
    "ADV"
  ],
  "stethoscope": [
    "NOUN"
  ],
  "monotonic": [
    "ADJ"
  ],
  "freemasonry": [
    "NOUN"
  ],
  "penitentiary": [
    "ADJ"
  ],
  "kahuna": [
    "PROPN"
  ],
  "shrewd": [
    "ADJ"
  ],
  "washroom": [
    "NOUN"
  ],
  "jacoby": [
    "PROPN"
  ],
  "intercity": [
    "NOUN"
  ],
  "flack": [
    "NOUN"
  ],
  "tonite": [
    "PROPN"
  ],
  "teething": [
    "VERB"
  ],
  "impatience": [
    "NOUN"
  ],
  "mechanistic": [
    "ADJ"
  ],
  "flawlessly": [
    "ADV"
  ],
  "whatnot": [
    "ADV"
  ],
  "tripartite": [
    "PROPN"
  ],
  "crass": [
    "VERB"
  ],
  "cartographic": [
    "NOUN"
  ],
  "gardenia": [
    "PROPN"
  ],
  "linwood": [
    "PROPN"
  ],
  "biotic": [
    "PROPN"
  ],
  "benevolence": [
    "NOUN"
  ],
  "suspiciously": [
    "ADV"
  ],
  "eugenia": [
    "PROPN"
  ],
  "reprimand": [
    "NOUN"
  ],
  "crowder": [
    "NOUN"
  ],
  "staunch": [
    "ADJ"
  ],
  "socialize": [
    "VERB"
  ],
  "deepwater": [
    "ADV"
  ],
  "shaven": [
    "ADV"
  ],
  "viscose": [
    "VERB"
  ],
  "occupier": [
    "NOUN"
  ],
  "euchre": [
    "PROPN"
  ],
  "molestation": [
    "NOUN"
  ],
  "mitosis": [
    "NOUN"
  ],
  "paisa": [
    "NOUN"
  ],
  "blindfolded": [
    "VERB"
  ],
  "hemorrhagic": [
    "ADJ"
  ],
  "wraith": [
    "VERB"
  ],
  "nimble": [
    "ADJ"
  ],
  "hyacinth": [
    "ADJ"
  ],
  "neutralization": [
    "NOUN"
  ],
  "durst": [
    "NOUN"
  ],
  "derelict": [
    "VERB"
  ],
  "skylark": [
    "ADJ"
  ],
  "shrouded": [
    "VERB"
  ],
  "clarissa": [
    "PROPN"
  ],
  "brazen": [
    "NOUN"
  ],
  "brahma": [
    "NOUN"
  ],
  "prion": [
    "NOUN"
  ],
  "diphosphate": [
    "VERB"
  ],
  "veracity": [
    "NOUN"
  ],
  "butane": [
    "NOUN"
  ],
  "angers": [
    "NOUN"
  ],
  "gustavus": [
    "PROPN"
  ],
  "bluebonnet": [
    "NOUN"
  ],
  "unwittingly": [
    "ADV"
  ],
  "kamikaze": [
    "NOUN"
  ],
  "juggernaut": [
    "PROPN"
  ],
  "antecedent": [
    "ADJ"
  ],
  "latrobe": [
    "VERB"
  ],
  "matty": [
    "NOUN"
  ],
  "dorothea": [
    "PROPN"
  ],
  "lilith": [
    "PROPN"
  ],
  "gargoyle": [
    "NOUN"
  ],
  "legislate": [
    "VERB"
  ],
  "voluptuous": [
    "ADJ"
  ],
  "complacent": [
    "NOUN"
  ],
  "bodega": [
    "ADJ"
  ],
  "germania": [
    "PROPN"
  ],
  "fiddling": [
    "VERB"
  ],
  "panamanian": [
    "PROPN"
  ],
  "unaccompanied": [
    "ADJ"
  ],
  "superclass": [
    "NOUN"
  ],
  "schooled": [
    "VERB"
  ],
  "kingwood": [
    "NOUN"
  ],
  "maximization": [
    "NOUN"
  ],
  "absenteeism": [
    "NOUN"
  ],
  "quantifiable": [
    "ADJ"
  ],
  "sliver": [
    "PROPN",
    "NOUN"
  ],
  "bummer": [
    "NOUN"
  ],
  "isometric": [
    "PROPN"
  ],
  "retraction": [
    "NOUN"
  ],
  "grinch": [
    "NOUN"
  ],
  "loveless": [
    "VERB"
  ],
  "shouldnt": [
    "AUX"
  ],
  "cambrian": [
    "PROPN"
  ],
  "cerebrospinal": [
    "ADJ"
  ],
  "impure": [
    "NOUN"
  ],
  "gridiron": [
    "PROPN"
  ],
  "innermost": [
    "ADV"
  ],
  "yesteryear": [
    "VERB"
  ],
  "pilate": [
    "PROPN"
  ],
  "pinning": [
    "VERB"
  ],
  "propellant": [
    "VERB"
  ],
  "confocal": [
    "ADJ"
  ],
  "jochen": [
    "PROPN"
  ],
  "caddo": [
    "PROPN"
  ],
  "stung": [
    "VERB"
  ],
  "retort": [
    "NOUN"
  ],
  "congregate": [
    "NOUN"
  ],
  "meditative": [
    "ADJ"
  ],
  "smirking": [
    "VERB"
  ],
  "exacerbate": [
    "NOUN"
  ],
  "begotten": [
    "ADV"
  ],
  "anemone": [
    "NOUN"
  ],
  "equivalently": [
    "ADV"
  ],
  "milla": [
    "NOUN"
  ],
  "incase": [
    "NOUN"
  ],
  "collared": [
    "ADJ"
  ],
  "stringed": [
    "VERB"
  ],
  "barnabas": [
    "PROPN"
  ],
  "regula": [
    "NOUN"
  ],
  "evasive": [
    "ADJ"
  ],
  "smirk": [
    "PROPN"
  ],
  "ancora": [
    "PROPN"
  ],
  "guesswork": [
    "NOUN"
  ],
  "replete": [
    "ADJ"
  ],
  "irritant": [
    "ADJ"
  ],
  "inconceivable": [
    "ADJ"
  ],
  "monolith": [
    "PROPN",
    "NOUN"
  ],
  "kanawha": [
    "PROPN"
  ],
  "pawnee": [
    "NOUN"
  ],
  "mandala": [
    "PROPN"
  ],
  "bristle": [
    "VERB"
  ],
  "uriah": [
    "PROPN"
  ],
  "oblige": [
    "VERB"
  ],
  "nonfarm": [
    "VERB"
  ],
  "anklet": [
    "NOUN"
  ],
  "visite": [
    "NOUN"
  ],
  "determinism": [
    "NOUN"
  ],
  "panacea": [
    "PROPN"
  ],
  "vibrate": [
    "NOUN"
  ],
  "normality": [
    "NOUN"
  ],
  "deflect": [
    "VERB"
  ],
  "taoism": [
    "VERB"
  ],
  "liber": [
    "NOUN"
  ],
  "samara": [
    "VERB"
  ],
  "unsung": [
    "PROPN"
  ],
  "nubian": [
    "PROPN"
  ],
  "aerodrome": [
    "NOUN"
  ],
  "intensification": [
    "NOUN"
  ],
  "cramp": [
    "VERB"
  ],
  "vincenzo": [
    "NOUN"
  ],
  "mistletoe": [
    "PROPN"
  ],
  "perforation": [
    "NOUN"
  ],
  "tryout": [
    "VERB"
  ],
  "hallowed": [
    "VERB"
  ],
  "manageability": [
    "NOUN"
  ],
  "appease": [
    "NOUN"
  ],
  "furlong": [
    "PROPN"
  ],
  "homogenous": [
    "ADJ"
  ],
  "policyholder": [
    "VERB"
  ],
  "distributional": [
    "ADJ"
  ],
  "tidewater": [
    "NOUN"
  ],
  "follicular": [
    "ADJ"
  ],
  "gonorrhea": [
    "NOUN"
  ],
  "listeria": [
    "NOUN"
  ],
  "lawmaker": [
    "NOUN"
  ],
  "flavorful": [
    "ADJ"
  ],
  "supersede": [
    "NOUN"
  ],
  "moissanite": [
    "VERB"
  ],
  "phrasing": [
    "NOUN"
  ],
  "standish": [
    "VERB"
  ],
  "conus": [
    "NOUN"
  ],
  "sensibly": [
    "ADV"
  ],
  "mouthed": [
    "VERB"
  ],
  "backspace": [
    "NOUN"
  ],
  "fugue": [
    "NOUN"
  ],
  "dissonance": [
    "NOUN"
  ],
  "milder": [
    "NOUN"
  ],
  "inexplicable": [
    "ADJ"
  ],
  "hypothermia": [
    "NOUN"
  ],
  "expeditious": [
    "ADJ"
  ],
  "carman": [
    "NOUN"
  ],
  "intently": [
    "ADV"
  ],
  "chrysalis": [
    "PROPN"
  ],
  "speer": [
    "VERB"
  ],
  "refillable": [
    "ADJ"
  ],
  "hoary": [
    "PROPN"
  ],
  "tricycle": [
    "NOUN"
  ],
  "corse": [
    "ADV"
  ],
  "trillium": [
    "NOUN"
  ],
  "andante": [
    "VERB"
  ],
  "overtly": [
    "ADV"
  ],
  "ronde": [
    "VERB"
  ],
  "deceiving": [
    "VERB"
  ],
  "oedipus": [
    "PROPN"
  ],
  "beamed": [
    "VERB"
  ],
  "bannister": [
    "NOUN"
  ],
  "humanoid": [
    "VERB"
  ],
  "scraped": [
    "VERB"
  ],
  "chagrin": [
    "NOUN"
  ],
  "tiredness": [
    "VERB"
  ],
  "panning": [
    "VERB"
  ],
  "wasabi": [
    "NOUN"
  ],
  "breather": [
    "PROPN"
  ],
  "methylene": [
    "NOUN"
  ],
  "wholeness": [
    "NOUN"
  ],
  "tickled": [
    "VERB"
  ],
  "hindrance": [
    "NOUN"
  ],
  "discreetly": [
    "ADV"
  ],
  "sparing": [
    "VERB"
  ],
  "preoccupation": [
    "NOUN"
  ],
  "vertebrata": [
    "PROPN"
  ],
  "lockable": [
    "NOUN"
  ],
  "evaporator": [
    "NOUN"
  ],
  "airliner": [
    "NOUN"
  ],
  "unwrapped": [
    "ADJ"
  ],
  "sateen": [
    "ADV"
  ],
  "autosomal": [
    "ADJ"
  ],
  "restful": [
    "ADJ"
  ],
  "rhododendron": [
    "NOUN"
  ],
  "aristocratic": [
    "ADJ"
  ],
  "scouring": [
    "VERB"
  ],
  "profitably": [
    "ADV"
  ],
  "pinched": [
    "VERB"
  ],
  "underlay": [
    "NOUN"
  ],
  "granule": [
    "PROPN"
  ],
  "purport": [
    "NOUN"
  ],
  "plunging": [
    "VERB"
  ],
  "marten": [
    "VERB"
  ],
  "admittance": [
    "NOUN"
  ],
  "ageless": [
    "ADV"
  ],
  "stinking": [
    "VERB"
  ],
  "howler": [
    "NOUN"
  ],
  "carded": [
    "VERB"
  ],
  "internment": [
    "NOUN"
  ],
  "porridge": [
    "NOUN"
  ],
  "dominick": [
    "VERB"
  ],
  "symbolize": [
    "NOUN"
  ],
  "standstill": [
    "NOUN"
  ],
  "swaying": [
    "VERB"
  ],
  "igloo": [
    "ADJ"
  ],
  "ambler": [
    "NOUN"
  ],
  "voyeurism": [
    "NOUN"
  ],
  "unattractive": [
    "ADJ"
  ],
  "referential": [
    "ADJ"
  ],
  "repressor": [
    "NOUN"
  ],
  "diffused": [
    "VERB"
  ],
  "firmer": [
    "ADJ"
  ],
  "arcana": [
    "PROPN"
  ],
  "quinnipiac": [
    "PROPN"
  ],
  "promulgation": [
    "NOUN"
  ],
  "mannequin": [
    "PROPN"
  ],
  "malloy": [
    "NOUN"
  ],
  "unshaven": [
    "ADJ"
  ],
  "betsey": [
    "NOUN"
  ],
  "incognito": [
    "PROPN"
  ],
  "silliness": [
    "NOUN"
  ],
  "burgh": [
    "PROPN"
  ],
  "giggling": [
    "VERB"
  ],
  "proviso": [
    "NOUN"
  ],
  "oldenburg": [
    "NOUN"
  ],
  "bazooka": [
    "VERB"
  ],
  "gerbera": [
    "NOUN"
  ],
  "barnyard": [
    "NOUN"
  ],
  "camellia": [
    "PROPN"
  ],
  "rescind": [
    "VERB"
  ],
  "donal": [
    "ADJ"
  ],
  "artifice": [
    "NOUN"
  ],
  "excavator": [
    "NOUN"
  ],
  "allot": [
    "NOUN"
  ],
  "progenitor": [
    "NOUN"
  ],
  "abomination": [
    "NOUN"
  ],
  "gymnast": [
    "NOUN"
  ],
  "inexpensively": [
    "ADV"
  ],
  "hazen": [
    "NOUN"
  ],
  "forceps": [
    "VERB"
  ],
  "argumentation": [
    "NOUN"
  ],
  "passively": [
    "ADV"
  ],
  "hurled": [
    "VERB"
  ],
  "adjoint": [
    "VERB"
  ],
  "vesta": [
    "PROPN"
  ],
  "jacky": [
    "PROPN"
  ],
  "splint": [
    "VERB"
  ],
  "multifaceted": [
    "VERB"
  ],
  "deranged": [
    "VERB"
  ],
  "darwinian": [
    "PROPN"
  ],
  "touchy": [
    "ADJ"
  ],
  "unintelligible": [
    "ADJ"
  ],
  "pariah": [
    "PROPN"
  ],
  "meaty": [
    "PROPN"
  ],
  "infantile": [
    "VERB"
  ],
  "unspeakable": [
    "ADJ"
  ],
  "egret": [
    "VERB"
  ],
  "demolish": [
    "PROPN"
  ],
  "guildhall": [
    "NOUN"
  ],
  "piney": [
    "NOUN"
  ],
  "unbundled": [
    "VERB"
  ],
  "disgraceful": [
    "ADJ"
  ],
  "servitude": [
    "VERB"
  ],
  "fractionation": [
    "NOUN"
  ],
  "aqueduct": [
    "NOUN"
  ],
  "retouching": [
    "VERB"
  ],
  "jerez": [
    "PROPN"
  ],
  "marcella": [
    "PROPN"
  ],
  "radiate": [
    "VERB"
  ],
  "playroom": [
    "NOUN"
  ],
  "dandruff": [
    "VERB"
  ],
  "stipulate": [
    "NOUN"
  ],
  "leaved": [
    "VERB"
  ],
  "proximate": [
    "NOUN"
  ],
  "gallus": [
    "PROPN"
  ],
  "armadillo": [
    "INTJ"
  ],
  "perturbed": [
    "VERB"
  ],
  "pacifier": [
    "PROPN"
  ],
  "vivek": [
    "VERB"
  ],
  "unprofessional": [
    "ADJ"
  ],
  "bettina": [
    "PROPN"
  ],
  "hydrographic": [
    "ADJ"
  ],
  "blunder": [
    "VERB"
  ],
  "appalachia": [
    "VERB"
  ],
  "marist": [
    "NOUN"
  ],
  "relativism": [
    "NOUN"
  ],
  "schweizer": [
    "PROPN"
  ],
  "belted": [
    "VERB"
  ],
  "ananda": [
    "ADV"
  ],
  "headstone": [
    "NOUN"
  ],
  "felon": [
    "NOUN"
  ],
  "underlining": [
    "ADJ"
  ],
  "doubting": [
    "VERB"
  ],
  "differentially": [
    "ADV"
  ],
  "inductor": [
    "NOUN"
  ],
  "encephalopathy": [
    "NOUN"
  ],
  "dunkirk": [
    "PROPN"
  ],
  "libretto": [
    "PROPN"
  ],
  "debatable": [
    "ADJ"
  ],
  "prowler": [
    "NOUN"
  ],
  "sizzle": [
    "VERB"
  ],
  "copolymer": [
    "NOUN"
  ],
  "nontraditional": [
    "ADJ"
  ],
  "marcasite": [
    "NOUN"
  ],
  "scoliosis": [
    "NOUN"
  ],
  "artie": [
    "NOUN"
  ],
  "decisively": [
    "ADV"
  ],
  "carport": [
    "NOUN"
  ],
  "dubbing": [
    "VERB"
  ],
  "wayback": [
    "NOUN"
  ],
  "undeniably": [
    "ADV"
  ],
  "zander": [
    "NOUN"
  ],
  "spasm": [
    "NOUN"
  ],
  "samir": [
    "PROPN"
  ],
  "eminently": [
    "ADV"
  ],
  "snorting": [
    "VERB"
  ],
  "mercilessly": [
    "ADV"
  ],
  "loyalist": [
    "NOUN"
  ],
  "evaporative": [
    "ADJ"
  ],
  "cobbler": [
    "NOUN"
  ],
  "invigorating": [
    "VERB"
  ],
  "heinous": [
    "ADJ"
  ],
  "dusky": [
    "NOUN"
  ],
  "manhole": [
    "NOUN"
  ],
  "tabasco": [
    "ADV"
  ],
  "purebred": [
    "VERB"
  ],
  "masochism": [
    "NOUN"
  ],
  "bergamot": [
    "NOUN"
  ],
  "infallible": [
    "ADJ"
  ],
  "shutout": [
    "NOUN"
  ],
  "prosthetics": [
    "NOUN"
  ],
  "heeled": [
    "VERB"
  ],
  "quibble": [
    "VERB"
  ],
  "bakelite": [
    "VERB"
  ],
  "intermountain": [
    "VERB"
  ],
  "incessant": [
    "ADJ"
  ],
  "klondike": [
    "VERB"
  ],
  "blick": [
    "PROPN"
  ],
  "reeder": [
    "PROPN"
  ],
  "neoplastic": [
    "ADJ"
  ],
  "applesauce": [
    "NOUN"
  ],
  "cheery": [
    "NOUN"
  ],
  "curbing": [
    "VERB"
  ],
  "harshly": [
    "ADV"
  ],
  "betterment": [
    "NOUN"
  ],
  "feisty": [
    "PROPN"
  ],
  "nonverbal": [
    "ADJ"
  ],
  "ladybird": [
    "PROPN"
  ],
  "slush": [
    "NOUN"
  ],
  "mutton": [
    "PROPN"
  ],
  "congruent": [
    "PROPN"
  ],
  "blinked": [
    "VERB"
  ],
  "selva": [
    "PROPN"
  ],
  "aphis": [
    "INTJ"
  ],
  "tarantula": [
    "NOUN"
  ],
  "snuggle": [
    "VERB"
  ],
  "zigzag": [
    "NOUN"
  ],
  "shang": [
    "PROPN"
  ],
  "batten": [
    "VERB"
  ],
  "lough": [
    "NOUN"
  ],
  "dragoon": [
    "NOUN"
  ],
  "benefactor": [
    "NOUN"
  ],
  "merrily": [
    "ADV"
  ],
  "vouch": [
    "ADV"
  ],
  "pompey": [
    "NOUN"
  ],
  "blackness": [
    "NOUN"
  ],
  "transitory": [
    "NOUN"
  ],
  "wether": [
    "PROPN"
  ],
  "larynx": [
    "NOUN"
  ],
  "griffon": [
    "PROPN"
  ],
  "paperweight": [
    "NOUN"
  ],
  "dilation": [
    "NOUN"
  ],
  "bedspread": [
    "ADJ"
  ],
  "knudsen": [
    "PROPN"
  ],
  "kiowa": [
    "PROPN"
  ],
  "ancona": [
    "PROPN"
  ],
  "pragmatism": [
    "NOUN"
  ],
  "springing": [
    "VERB"
  ],
  "nocturne": [
    "VERB"
  ],
  "fabricate": [
    "VERB"
  ],
  "pendragon": [
    "PROPN"
  ],
  "altruism": [
    "NOUN"
  ],
  "dutchman": [
    "NOUN"
  ],
  "capricious": [
    "ADJ"
  ],
  "angelique": [
    "PROPN"
  ],
  "harmonize": [
    "VERB"
  ],
  "crescendo": [
    "PROPN"
  ],
  "eyelash": [
    "NOUN"
  ],
  "antifreeze": [
    "PROPN"
  ],
  "beamer": [
    "NOUN"
  ],
  "clicker": [
    "NOUN"
  ],
  "dalmatian": [
    "PROPN"
  ],
  "hemodynamic": [
    "PROPN"
  ],
  "frederik": [
    "PROPN"
  ],
  "stagecoach": [
    "VERB"
  ],
  "ruddy": [
    "VERB"
  ],
  "academe": [
    "NOUN"
  ],
  "knockoff": [
    "PROPN"
  ],
  "gosling": [
    "VERB"
  ],
  "subsidence": [
    "NOUN"
  ],
  "plastering": [
    "VERB"
  ],
  "promiscuous": [
    "ADJ"
  ],
  "fouling": [
    "VERB"
  ],
  "basso": [
    "NOUN"
  ],
  "duction": [
    "NOUN"
  ],
  "parentage": [
    "NOUN"
  ],
  "mutter": [
    "NOUN"
  ],
  "brothel": [
    "NOUN"
  ],
  "shelled": [
    "VERB"
  ],
  "outlandish": [
    "PROPN"
  ],
  "chitty": [
    "ADV"
  ],
  "goldwater": [
    "NOUN"
  ],
  "sneezing": [
    "VERB"
  ],
  "ataxia": [
    "PROPN"
  ],
  "sancho": [
    "NOUN"
  ],
  "camaraderie": [
    "VERB"
  ],
  "variegated": [
    "VERB"
  ],
  "abysmal": [
    "ADJ"
  ],
  "termini": [
    "PROPN"
  ],
  "bourse": [
    "VERB"
  ],
  "tenacity": [
    "NOUN"
  ],
  "denture": [
    "NOUN"
  ],
  "moslem": [
    "PROPN"
  ],
  "permanence": [
    "NOUN"
  ],
  "boliviano": [
    "NOUN"
  ],
  "wagoner": [
    "NOUN"
  ],
  "coincident": [
    "PROPN"
  ],
  "rajiv": [
    "PROPN"
  ],
  "minding": [
    "VERB"
  ],
  "quercus": [
    "VERB"
  ],
  "amara": [
    "NOUN"
  ],
  "microcosm": [
    "PROPN"
  ],
  "enviable": [
    "ADJ"
  ],
  "christos": [
    "NOUN"
  ],
  "categorically": [
    "ADV"
  ],
  "catnip": [
    "VERB"
  ],
  "boned": [
    "VERB"
  ],
  "eloquently": [
    "ADV"
  ],
  "subheading": [
    "VERB"
  ],
  "extinguish": [
    "PROPN"
  ],
  "dirge": [
    "VERB"
  ],
  "bluish": [
    "ADJ"
  ],
  "pusher": [
    "NOUN"
  ],
  "tingle": [
    "ADJ"
  ],
  "gnostic": [
    "ADJ"
  ],
  "ambivalent": [
    "ADJ"
  ],
  "typist": [
    "NOUN"
  ],
  "lamented": [
    "VERB"
  ],
  "bruise": [
    "VERB"
  ],
  "cesare": [
    "NOUN"
  ],
  "perfumed": [
    "VERB"
  ],
  "lamination": [
    "NOUN"
  ],
  "scottie": [
    "ADJ"
  ],
  "fistful": [
    "ADJ"
  ],
  "staffer": [
    "NOUN"
  ],
  "cornucopia": [
    "NOUN"
  ],
  "catan": [
    "PROPN"
  ],
  "unfettered": [
    "VERB"
  ],
  "imogen": [
    "PROPN"
  ],
  "appraise": [
    "PROPN"
  ],
  "runny": [
    "ADJ"
  ],
  "thither": [
    "NOUN"
  ],
  "rebuke": [
    "VERB"
  ],
  "swayed": [
    "VERB"
  ],
  "collocation": [
    "NOUN"
  ],
  "assuredly": [
    "ADV"
  ],
  "vesicle": [
    "NOUN"
  ],
  "shadowed": [
    "VERB"
  ],
  "vigilante": [
    "VERB"
  ],
  "gauging": [
    "VERB"
  ],
  "lipase": [
    "NOUN"
  ],
  "constabulary": [
    "NOUN"
  ],
  "cricketer": [
    "NOUN"
  ],
  "intelligible": [
    "PROPN"
  ],
  "overlaid": [
    "VERB"
  ],
  "shakespearean": [
    "ADJ"
  ],
  "demonstrator": [
    "NOUN"
  ],
  "edict": [
    "PROPN"
  ],
  "octavia": [
    "PROPN"
  ],
  "hondo": [
    "PROPN"
  ],
  "hysteresis": [
    "NOUN"
  ],
  "boyhood": [
    "NOUN"
  ],
  "sustenance": [
    "VERB"
  ],
  "campion": [
    "NOUN"
  ],
  "shrew": [
    "PROPN"
  ],
  "sculpt": [
    "PROPN"
  ],
  "freya": [
    "NOUN"
  ],
  "disrespectful": [
    "ADJ"
  ],
  "confounding": [
    "VERB"
  ],
  "dispensation": [
    "NOUN"
  ],
  "bagpipes": [
    "NOUN"
  ],
  "devaluation": [
    "NOUN"
  ],
  "mineralization": [
    "NOUN"
  ],
  "diagonally": [
    "ADV"
  ],
  "cased": [
    "VERB"
  ],
  "stedman": [
    "NOUN"
  ],
  "laterally": [
    "ADV"
  ],
  "wizardry": [
    "ADJ"
  ],
  "nonce": [
    "NOUN"
  ],
  "fervent": [
    "NOUN"
  ],
  "headrest": [
    "ADJ"
  ],
  "elevating": [
    "VERB"
  ],
  "chaperone": [
    "NOUN"
  ],
  "augustin": [
    "NOUN"
  ],
  "eurythmics": [
    "NOUN"
  ],
  "delusional": [
    "ADJ"
  ],
  "unneeded": [
    "ADJ"
  ],
  "hydride": [
    "VERB"
  ],
  "plage": [
    "NOUN"
  ],
  "firmness": [
    "NOUN"
  ],
  "unequivocally": [
    "ADV"
  ],
  "karst": [
    "PROPN"
  ],
  "selfless": [
    "ADJ"
  ],
  "perspiration": [
    "NOUN"
  ],
  "liquidator": [
    "NOUN"
  ],
  "mirth": [
    "PROPN"
  ],
  "stowaway": [
    "ADP"
  ],
  "brainer": [
    "NOUN"
  ],
  "pauper": [
    "NOUN"
  ],
  "channeled": [
    "VERB"
  ],
  "factorial": [
    "ADJ"
  ],
  "librarianship": [
    "NOUN"
  ],
  "livable": [
    "ADJ"
  ],
  "catskill": [
    "NOUN"
  ],
  "scorched": [
    "VERB"
  ],
  "environmentalism": [
    "NOUN"
  ],
  "instep": [
    "NOUN"
  ],
  "septum": [
    "PROPN"
  ],
  "piezo": [
    "X"
  ],
  "escudo": [
    "NOUN"
  ],
  "petter": [
    "NOUN"
  ],
  "adenine": [
    "VERB"
  ],
  "lysis": [
    "NOUN"
  ],
  "kiley": [
    "PROPN"
  ],
  "yoruba": [
    "PROPN"
  ],
  "alexia": [
    "ADV"
  ],
  "checkup": [
    "NOUN"
  ],
  "mignon": [
    "NOUN"
  ],
  "houseboat": [
    "NOUN"
  ],
  "lifesaving": [
    "VERB"
  ],
  "clementine": [
    "NOUN"
  ],
  "smokeless": [
    "NOUN"
  ],
  "stanhope": [
    "VERB"
  ],
  "thorax": [
    "PROPN"
  ],
  "placental": [
    "ADJ"
  ],
  "warship": [
    "NOUN"
  ],
  "metamorphic": [
    "ADJ"
  ],
  "corinthian": [
    "PROPN"
  ],
  "rattles": [
    "NOUN"
  ],
  "garten": [
    "VERB"
  ],
  "trophic": [
    "NOUN"
  ],
  "dislocated": [
    "VERB"
  ],
  "reversi": [
    "ADJ"
  ],
  "insemination": [
    "NOUN"
  ],
  "booby": [
    "VERB"
  ],
  "conceivably": [
    "ADV"
  ],
  "quetzal": [
    "PROPN"
  ],
  "linder": [
    "PROPN"
  ],
  "conch": [
    "NOUN"
  ],
  "crunching": [
    "VERB"
  ],
  "weevil": [
    "NOUN"
  ],
  "morgue": [
    "PROPN"
  ],
  "unpatched": [
    "VERB"
  ],
  "exuberant": [
    "ADJ"
  ],
  "electrification": [
    "NOUN"
  ],
  "peninsular": [
    "VERB"
  ],
  "juggle": [
    "NOUN"
  ],
  "composure": [
    "NOUN"
  ],
  "yeshiva": [
    "PROPN"
  ],
  "sociologist": [
    "NOUN"
  ],
  "finitely": [
    "ADV"
  ],
  "birthright": [
    "VERB"
  ],
  "corny": [
    "VERB"
  ],
  "errant": [
    "NOUN"
  ],
  "proofread": [
    "NOUN"
  ],
  "heifer": [
    "VERB"
  ],
  "earthen": [
    "ADV"
  ],
  "sulfuric": [
    "ADJ"
  ],
  "bulleted": [
    "VERB"
  ],
  "acupressure": [
    "PROPN"
  ],
  "portcullis": [
    "VERB"
  ],
  "noose": [
    "VERB"
  ],
  "ugandan": [
    "PROPN"
  ],
  "stratigraphy": [
    "VERB"
  ],
  "recur": [
    "VERB"
  ],
  "desirous": [
    "ADJ"
  ],
  "agarwal": [
    "PROPN"
  ],
  "exemplar": [
    "ADJ"
  ],
  "smitten": [
    "VERB"
  ],
  "dunstable": [
    "ADJ"
  ],
  "macadamia": [
    "NOUN"
  ],
  "takin": [
    "PROPN"
  ],
  "disqualify": [
    "VERB"
  ],
  "averted": [
    "VERB"
  ],
  "dissipated": [
    "VERB"
  ],
  "unionist": [
    "ADJ"
  ],
  "clocked": [
    "VERB"
  ],
  "discernible": [
    "ADJ"
  ],
  "looser": [
    "ADJ"
  ],
  "bookie": [
    "NOUN"
  ],
  "ptolemy": [
    "NOUN"
  ],
  "demarcation": [
    "NOUN"
  ],
  "miocene": [
    "PROPN"
  ],
  "diamondback": [
    "NOUN"
  ],
  "steeple": [
    "ADJ"
  ],
  "lumberjack": [
    "NOUN"
  ],
  "concussion": [
    "NOUN"
  ],
  "nailing": [
    "VERB"
  ],
  "epidermis": [
    "PROPN"
  ],
  "rhinoplasty": [
    "NOUN"
  ],
  "peptic": [
    "ADJ"
  ],
  "sparingly": [
    "ADV"
  ],
  "penance": [
    "NOUN"
  ],
  "tilley": [
    "VERB"
  ],
  "hypothalamus": [
    "PROPN"
  ],
  "priestly": [
    "ADV"
  ],
  "curtailed": [
    "VERB"
  ],
  "manipulator": [
    "NOUN"
  ],
  "rollo": [
    "VERB"
  ],
  "conspicuously": [
    "ADV"
  ],
  "eagerness": [
    "NOUN"
  ],
  "peacemaker": [
    "NOUN"
  ],
  "pearly": [
    "ADV"
  ],
  "halal": [
    "NOUN"
  ],
  "kirsch": [
    "PROPN"
  ],
  "roadhouse": [
    "VERB"
  ],
  "recklessly": [
    "ADV"
  ],
  "apothecary": [
    "ADJ"
  ],
  "transformative": [
    "ADJ"
  ],
  "anhydrous": [
    "ADJ"
  ],
  "parkin": [
    "PROPN"
  ],
  "canis": [
    "X"
  ],
  "ravioli": [
    "PROPN"
  ],
  "walling": [
    "VERB"
  ],
  "marblehead": [
    "ADV"
  ],
  "jointed": [
    "VERB"
  ],
  "heyday": [
    "NOUN"
  ],
  "topsoil": [
    "NOUN"
  ],
  "beaming": [
    "VERB"
  ],
  "balancer": [
    "NOUN",
    "PROPN"
  ],
  "underhill": [
    "VERB"
  ],
  "chooser": [
    "NOUN"
  ],
  "argentinian": [
    "PROPN"
  ],
  "taint": [
    "NOUN"
  ],
  "lounging": [
    "VERB"
  ],
  "athenian": [
    "PROPN"
  ],
  "predisposition": [
    "NOUN"
  ],
  "outwardly": [
    "ADV"
  ],
  "tumultuous": [
    "ADJ"
  ],
  "symbiotic": [
    "PROPN"
  ],
  "nomic": [
    "NOUN"
  ],
  "wishbone": [
    "NOUN"
  ],
  "overseer": [
    "NOUN"
  ],
  "chine": [
    "VERB"
  ],
  "crier": [
    "NOUN"
  ],
  "squirter": [
    "NOUN"
  ],
  "protea": [
    "PROPN"
  ],
  "polyvinyl": [
    "VERB"
  ],
  "ganglion": [
    "NOUN"
  ],
  "decompose": [
    "VERB"
  ],
  "unimaginable": [
    "ADJ"
  ],
  "lipper": [
    "PROPN"
  ],
  "briton": [
    "PROPN"
  ],
  "glistening": [
    "VERB"
  ],
  "hamza": [
    "VERB"
  ],
  "moonshine": [
    "PROPN"
  ],
  "meeks": [
    "NOUN"
  ],
  "centimeter": [
    "NOUN"
  ],
  "scribble": [
    "ADJ"
  ],
  "anselm": [
    "VERB"
  ],
  "firework": [
    "NOUN"
  ],
  "localize": [
    "NOUN"
  ],
  "beset": [
    "VERB"
  ],
  "romain": [
    "VERB"
  ],
  "involuntarily": [
    "ADV"
  ],
  "swede": [
    "NOUN"
  ],
  "hydrothermal": [
    "NOUN"
  ],
  "discoverer": [
    "NOUN"
  ],
  "coleoptera": [
    "NOUN"
  ],
  "adoptee": [
    "NOUN"
  ],
  "historiography": [
    "PROPN"
  ],
  "scrapping": [
    "VERB"
  ],
  "plowing": [
    "VERB"
  ],
  "militarism": [
    "NOUN"
  ],
  "glassy": [
    "NOUN"
  ],
  "bullhead": [
    "ADV"
  ],
  "mimosa": [
    "PROPN"
  ],
  "shrill": [
    "ADV"
  ],
  "halved": [
    "VERB"
  ],
  "headland": [
    "NOUN"
  ],
  "bergamo": [
    "NOUN"
  ],
  "hobbyist": [
    "NOUN"
  ],
  "agitator": [
    "NOUN"
  ],
  "homozygous": [
    "ADJ"
  ],
  "torsten": [
    "VERB"
  ],
  "utensil": [
    "PROPN"
  ],
  "puller": [
    "NOUN"
  ],
  "heighten": [
    "VERB"
  ],
  "surpassing": [
    "VERB"
  ],
  "misfit": [
    "NOUN"
  ],
  "ladle": [
    "VERB"
  ],
  "quotable": [
    "ADJ"
  ],
  "zirconium": [
    "NOUN"
  ],
  "naturalistic": [
    "ADJ"
  ],
  "dogmatic": [
    "ADJ"
  ],
  "tristram": [
    "VERB"
  ],
  "rectification": [
    "NOUN"
  ],
  "keeler": [
    "NOUN"
  ],
  "surly": [
    "ADV"
  ],
  "stratospheric": [
    "ADJ"
  ],
  "mistral": [
    "ADJ"
  ],
  "admirer": [
    "NOUN"
  ],
  "divisor": [
    "NOUN"
  ],
  "wanderlust": [
    "ADV"
  ],
  "cleat": [
    "VERB"
  ],
  "immediacy": [
    "NOUN"
  ],
  "indra": [
    "NOUN"
  ],
  "candor": [
    "PROPN"
  ],
  "casco": [
    "PROPN"
  ],
  "olivet": [
    "NOUN"
  ],
  "gasification": [
    "NOUN"
  ],
  "vibrio": [
    "PROPN"
  ],
  "casebook": [
    "NOUN"
  ],
  "searing": [
    "VERB"
  ],
  "detonation": [
    "NOUN"
  ],
  "wigwam": [
    "ADJ"
  ],
  "postmark": [
    "PROPN"
  ],
  "tangential": [
    "PROPN"
  ],
  "muskogee": [
    "PROPN"
  ],
  "glebe": [
    "NOUN"
  ],
  "motte": [
    "NOUN"
  ],
  "softener": [
    "NOUN"
  ],
  "maelstrom": [
    "ADP"
  ],
  "affectionately": [
    "ADV"
  ],
  "seraphim": [
    "PROPN"
  ],
  "uneducated": [
    "ADJ"
  ],
  "munity": [
    "NOUN"
  ],
  "alopecia": [
    "NOUN"
  ],
  "proportionately": [
    "ADV"
  ],
  "marbled": [
    "VERB"
  ],
  "bothersome": [
    "ADJ"
  ],
  "draconian": [
    "ADJ"
  ],
  "approver": [
    "PROPN",
    "NOUN"
  ],
  "srinivasan": [
    "NOUN"
  ],
  "articular": [
    "PROPN"
  ],
  "holler": [
    "VERB"
  ],
  "guanine": [
    "NOUN"
  ],
  "cruelly": [
    "ADV"
  ],
  "hamel": [
    "PROPN"
  ],
  "tapioca": [
    "PROPN"
  ],
  "furrow": [
    "PROPN"
  ],
  "semantically": [
    "ADV"
  ],
  "valkyrie": [
    "PROPN"
  ],
  "drowsy": [
    "NOUN"
  ],
  "cashew": [
    "VERB"
  ],
  "unproven": [
    "ADJ"
  ],
  "bushel": [
    "PROPN"
  ],
  "myocardium": [
    "NOUN"
  ],
  "beholder": [
    "VERB"
  ],
  "cursive": [
    "ADJ"
  ],
  "hydrated": [
    "ADJ"
  ],
  "forties": [
    "NOUN"
  ],
  "sedition": [
    "NOUN"
  ],
  "photosynthetic": [
    "NOUN"
  ],
  "examen": [
    "NOUN"
  ],
  "tongued": [
    "VERB"
  ],
  "ghastly": [
    "ADV"
  ],
  "vaudeville": [
    "PROPN"
  ],
  "succumb": [
    "NOUN"
  ],
  "unapproved": [
    "VERB"
  ],
  "bolero": [
    "NOUN"
  ],
  "ricochet": [
    "VERB"
  ],
  "aberrant": [
    "NOUN"
  ],
  "inquisitive": [
    "ADJ"
  ],
  "wyandotte": [
    "PROPN"
  ],
  "ruptured": [
    "VERB"
  ],
  "starlet": [
    "NOUN"
  ],
  "earner": [
    "NOUN"
  ],
  "menagerie": [
    "PROPN"
  ],
  "thrombin": [
    "NOUN"
  ],
  "laminar": [
    "NOUN"
  ],
  "forked": [
    "VERB"
  ],
  "apprehensive": [
    "VERB"
  ],
  "camber": [
    "NOUN"
  ],
  "colliery": [
    "NOUN"
  ],
  "landfall": [
    "VERB"
  ],
  "borderless": [
    "ADJ"
  ],
  "laity": [
    "NOUN"
  ],
  "birkenhead": [
    "PROPN"
  ],
  "prefixed": [
    "VERB"
  ],
  "purposefully": [
    "ADV"
  ],
  "arming": [
    "VERB"
  ],
  "itinerant": [
    "ADJ"
  ],
  "multithreaded": [
    "VERB"
  ],
  "rutter": [
    "VERB"
  ],
  "vitreous": [
    "ADJ"
  ],
  "countable": [
    "ADJ"
  ],
  "dolomite": [
    "NOUN"
  ],
  "afterglow": [
    "NOUN"
  ],
  "millwork": [
    "VERB"
  ],
  "takedown": [
    "ADJ"
  ],
  "colostrum": [
    "PROPN"
  ],
  "dearth": [
    "NOUN"
  ],
  "palatable": [
    "ADJ"
  ],
  "unmasked": [
    "ADJ"
  ],
  "tarmac": [
    "PROPN"
  ],
  "conservator": [
    "NOUN"
  ],
  "artefact": [
    "NOUN"
  ],
  "expository": [
    "VERB"
  ],
  "instinctive": [
    "NOUN"
  ],
  "restlessness": [
    "NOUN"
  ],
  "stalling": [
    "VERB"
  ],
  "aliso": [
    "NOUN"
  ],
  "burlesque": [
    "ADJ"
  ],
  "rickey": [
    "PROPN"
  ],
  "beefy": [
    "VERB"
  ],
  "acquaint": [
    "ADJ"
  ],
  "kootenay": [
    "PROPN"
  ],
  "ethnology": [
    "NOUN"
  ],
  "havelock": [
    "NOUN"
  ],
  "tajik": [
    "VERB"
  ],
  "romulus": [
    "NOUN"
  ],
  "charade": [
    "NOUN"
  ],
  "bobbin": [
    "PROPN"
  ],
  "doings": [
    "NOUN"
  ],
  "bursa": [
    "PROPN"
  ],
  "foolishness": [
    "NOUN"
  ],
  "centrifugation": [
    "NOUN"
  ],
  "unequivocal": [
    "ADJ"
  ],
  "coptic": [
    "NOUN"
  ],
  "dumper": [
    "VERB"
  ],
  "arriba": [
    "PROPN"
  ],
  "spiny": [
    "ADJ"
  ],
  "silken": [
    "VERB"
  ],
  "elastomer": [
    "NOUN"
  ],
  "wahoo": [
    "PROPN"
  ],
  "anagram": [
    "PROPN"
  ],
  "fogdog": [
    "PROPN"
  ],
  "stringing": [
    "VERB"
  ],
  "newsworthy": [
    "ADJ"
  ],
  "sensitization": [
    "NOUN"
  ],
  "hyperactive": [
    "ADJ"
  ],
  "thrusting": [
    "VERB"
  ],
  "antenatal": [
    "ADJ"
  ],
  "pluggable": [
    "ADJ"
  ],
  "hemophilia": [
    "PROPN"
  ],
  "clung": [
    "PROPN"
  ],
  "seepage": [
    "NOUN"
  ],
  "nonviolence": [
    "NOUN"
  ],
  "baume": [
    "NOUN"
  ],
  "brushless": [
    "VERB"
  ],
  "technicolor": [
    "NOUN"
  ],
  "needlessly": [
    "ADV"
  ],
  "squatting": [
    "VERB"
  ],
  "cordially": [
    "ADV"
  ],
  "expendable": [
    "ADJ"
  ],
  "ponca": [
    "PROPN"
  ],
  "spangled": [
    "VERB"
  ],
  "rectory": [
    "NOUN"
  ],
  "multum": [
    "PROPN"
  ],
  "palomino": [
    "NOUN"
  ],
  "pomeranian": [
    "PROPN"
  ],
  "diptera": [
    "NOUN"
  ],
  "iliad": [
    "VERB"
  ],
  "graze": [
    "PROPN"
  ],
  "erythrocyte": [
    "PROPN"
  ],
  "unobtrusive": [
    "ADJ"
  ],
  "myelin": [
    "NOUN"
  ],
  "fragility": [
    "NOUN"
  ],
  "drucken": [
    "VERB"
  ],
  "hangul": [
    "PROPN"
  ],
  "currant": [
    "ADJ"
  ],
  "montauk": [
    "ADJ"
  ],
  "brownian": [
    "PROPN"
  ],
  "herringbone": [
    "NOUN"
  ],
  "afoot": [
    "ADJ"
  ],
  "oddity": [
    "NOUN"
  ],
  "cornered": [
    "ADJ"
  ],
  "auspicious": [
    "ADJ"
  ],
  "splashing": [
    "VERB"
  ],
  "hotly": [
    "ADV"
  ],
  "cutthroat": [
    "ADJ"
  ],
  "coincidental": [
    "ADJ"
  ],
  "lepidoptera": [
    "NOUN"
  ],
  "puffed": [
    "VERB"
  ],
  "interlaced": [
    "VERB"
  ],
  "vaseline": [
    "VERB"
  ],
  "strontium": [
    "NOUN"
  ],
  "presumptive": [
    "VERB"
  ],
  "crustal": [
    "NOUN"
  ],
  "hackman": [
    "PROPN"
  ],
  "comprehensible": [
    "ADJ"
  ],
  "albicans": [
    "NOUN"
  ],
  "unambiguously": [
    "ADV"
  ],
  "sawdust": [
    "VERB"
  ],
  "ariana": [
    "PROPN"
  ],
  "metaphorical": [
    "ADJ"
  ],
  "alertness": [
    "VERB"
  ],
  "anubis": [
    "PROPN"
  ],
  "peseta": [
    "NOUN"
  ],
  "searchlight": [
    "NOUN"
  ],
  "proportionality": [
    "NOUN"
  ],
  "stave": [
    "VERB"
  ],
  "sordid": [
    "VERB"
  ],
  "mentorship": [
    "NOUN"
  ],
  "semblance": [
    "NOUN"
  ],
  "pneumococcal": [
    "ADJ"
  ],
  "avenge": [
    "NOUN"
  ],
  "yarrow": [
    "NOUN"
  ],
  "fickle": [
    "ADJ"
  ],
  "cursus": [
    "PROPN"
  ],
  "lukewarm": [
    "VERB"
  ],
  "rotunda": [
    "NOUN"
  ],
  "asymptotically": [
    "ADV"
  ],
  "crick": [
    "NOUN"
  ],
  "faintly": [
    "ADV"
  ],
  "indiscriminate": [
    "VERB"
  ],
  "thalia": [
    "NOUN"
  ],
  "alphonse": [
    "NOUN"
  ],
  "reforestation": [
    "NOUN"
  ],
  "paradoxically": [
    "ADV"
  ],
  "wacker": [
    "PROPN"
  ],
  "accolade": [
    "PROPN"
  ],
  "interpretative": [
    "ADJ"
  ],
  "roping": [
    "VERB"
  ],
  "oxymoron": [
    "NOUN"
  ],
  "pentagram": [
    "NOUN"
  ],
  "idolatry": [
    "NOUN"
  ],
  "decked": [
    "VERB"
  ],
  "choppy": [
    "ADJ"
  ],
  "introspective": [
    "ADJ"
  ],
  "bahamian": [
    "PROPN"
  ],
  "aggravation": [
    "NOUN"
  ],
  "sedge": [
    "NOUN"
  ],
  "caerphilly": [
    "ADV"
  ],
  "pinching": [
    "VERB"
  ],
  "riboflavin": [
    "PROPN"
  ],
  "ubiquity": [
    "NOUN"
  ],
  "vandal": [
    "NOUN"
  ],
  "romper": [
    "NOUN"
  ],
  "dweller": [
    "NOUN"
  ],
  "bitumen": [
    "NOUN"
  ],
  "diabolic": [
    "ADJ"
  ],
  "demonstrable": [
    "ADJ"
  ],
  "priestess": [
    "ADJ"
  ],
  "rummy": [
    "VERB"
  ],
  "pinscher": [
    "NOUN"
  ],
  "constructively": [
    "ADV"
  ],
  "irritate": [
    "VERB"
  ],
  "repeatability": [
    "NOUN"
  ],
  "gunning": [
    "VERB"
  ],
  "churchyard": [
    "ADJ"
  ],
  "tadpole": [
    "NOUN"
  ],
  "despicable": [
    "ADJ"
  ],
  "canter": [
    "NOUN"
  ],
  "berserk": [
    "PROPN"
  ],
  "wellman": [
    "NOUN"
  ],
  "cardiologist": [
    "PROPN"
  ],
  "stoop": [
    "VERB"
  ],
  "curvy": [
    "ADJ"
  ],
  "envisage": [
    "VERB"
  ],
  "crucially": [
    "ADV"
  ],
  "facile": [
    "VERB"
  ],
  "christiana": [
    "PROPN"
  ],
  "carrara": [
    "ADV"
  ],
  "environmentalist": [
    "NOUN"
  ],
  "sneeze": [
    "VERB"
  ],
  "mistreatment": [
    "NOUN"
  ],
  "shona": [
    "ADJ"
  ],
  "somber": [
    "VERB"
  ],
  "infective": [
    "ADJ"
  ],
  "acadian": [
    "PROPN"
  ],
  "overgrown": [
    "ADJ"
  ],
  "phonetics": [
    "NOUN"
  ],
  "carboxylic": [
    "ADJ"
  ],
  "bessemer": [
    "PROPN"
  ],
  "iceman": [
    "NOUN"
  ],
  "pegged": [
    "VERB"
  ],
  "tithe": [
    "DET"
  ],
  "liberator": [
    "NOUN"
  ],
  "rediscover": [
    "VERB"
  ],
  "subordination": [
    "NOUN"
  ],
  "meningococcal": [
    "ADJ"
  ],
  "ketone": [
    "INTJ"
  ],
  "glazer": [
    "NOUN"
  ],
  "geodesic": [
    "NOUN"
  ],
  "disinterested": [
    "VERB"
  ],
  "forsake": [
    "VERB"
  ],
  "congruence": [
    "NOUN"
  ],
  "unresponsive": [
    "ADJ"
  ],
  "baboon": [
    "NOUN"
  ],
  "omani": [
    "ADJ"
  ],
  "tenuous": [
    "ADJ"
  ],
  "epicenter": [
    "NOUN"
  ],
  "elated": [
    "ADJ"
  ],
  "phenomenological": [
    "ADJ"
  ],
  "buttered": [
    "VERB"
  ],
  "lentil": [
    "PROPN"
  ],
  "backer": [
    "NOUN"
  ],
  "albedo": [
    "PROPN"
  ],
  "danner": [
    "NOUN"
  ],
  "angora": [
    "PROPN"
  ],
  "stuffy": [
    "ADJ"
  ],
  "cocky": [
    "PROPN"
  ],
  "pitchfork": [
    "NOUN"
  ],
  "depress": [
    "VERB"
  ],
  "mohegan": [
    "PROPN"
  ],
  "eccentricity": [
    "NOUN"
  ],
  "beano": [
    "NOUN"
  ],
  "toiletry": [
    "NOUN"
  ],
  "transgression": [
    "NOUN"
  ],
  "flamboyant": [
    "ADJ"
  ],
  "memoria": [
    "PROPN"
  ],
  "exchangeable": [
    "ADJ"
  ],
  "stretchy": [
    "ADJ"
  ],
  "neurologist": [
    "NOUN"
  ],
  "clergyman": [
    "NOUN"
  ],
  "sociales": [
    "NOUN"
  ],
  "scape": [
    "NOUN"
  ],
  "neuropsychological": [
    "ADJ"
  ],
  "genitalia": [
    "NOUN"
  ],
  "mausoleum": [
    "NOUN"
  ],
  "idler": [
    "ADV"
  ],
  "generale": [
    "PROPN"
  ],
  "carelessly": [
    "ADV"
  ],
  "seidel": [
    "NOUN"
  ],
  "holocene": [
    "PROPN"
  ],
  "narcissus": [
    "NOUN"
  ],
  "polygram": [
    "PROPN"
  ],
  "distillate": [
    "NOUN"
  ],
  "unweighted": [
    "VERB"
  ],
  "skimming": [
    "VERB"
  ],
  "bayard": [
    "PROPN"
  ],
  "escalator": [
    "NOUN"
  ],
  "periwinkle": [
    "VERB"
  ],
  "namesake": [
    "NOUN"
  ],
  "farrow": [
    "NOUN"
  ],
  "annulment": [
    "PROPN"
  ],
  "gratuity": [
    "NOUN"
  ],
  "reorganize": [
    "VERB"
  ],
  "spate": [
    "NOUN"
  ],
  "foothold": [
    "NOUN"
  ],
  "belladonna": [
    "PROPN"
  ],
  "sobering": [
    "VERB"
  ],
  "semis": [
    "PROPN"
  ],
  "dingle": [
    "VERB"
  ],
  "madge": [
    "VERB"
  ],
  "gleam": [
    "ADJ"
  ],
  "hydroponic": [
    "NOUN"
  ],
  "recalculate": [
    "VERB"
  ],
  "maltreatment": [
    "ADJ"
  ],
  "supposition": [
    "NOUN"
  ],
  "sprinkling": [
    "VERB"
  ],
  "besieged": [
    "VERB"
  ],
  "malaise": [
    "NOUN"
  ],
  "biceps": [
    "NOUN"
  ],
  "hydrant": [
    "ADJ"
  ],
  "hamstring": [
    "NOUN"
  ],
  "tinderbox": [
    "ADV"
  ],
  "streetwise": [
    "PROPN"
  ],
  "rococo": [
    "PROPN"
  ],
  "nucleation": [
    "NOUN"
  ],
  "brabant": [
    "ADJ"
  ],
  "superlative": [
    "PROPN"
  ],
  "presser": [
    "NOUN"
  ],
  "tetrahedron": [
    "NOUN"
  ],
  "materialize": [
    "VERB"
  ],
  "fondness": [
    "NOUN"
  ],
  "chamois": [
    "NOUN"
  ],
  "merchandiser": [
    "NOUN"
  ],
  "multiplicative": [
    "NOUN"
  ],
  "metis": [
    "NOUN"
  ],
  "urethra": [
    "VERB"
  ],
  "retroactively": [
    "ADV"
  ],
  "seared": [
    "VERB"
  ],
  "tinged": [
    "VERB"
  ],
  "professorship": [
    "NOUN"
  ],
  "scran": [
    "PROPN"
  ],
  "leeward": [
    "PROPN"
  ],
  "mercator": [
    "NOUN"
  ],
  "fruitless": [
    "VERB"
  ],
  "tamer": [
    "ADV"
  ],
  "lyricist": [
    "NOUN"
  ],
  "ticklish": [
    "NOUN"
  ],
  "alienate": [
    "VERB"
  ],
  "beneficially": [
    "ADV"
  ],
  "tugrik": [
    "PROPN"
  ],
  "monotype": [
    "NOUN"
  ],
  "athenaeum": [
    "NOUN"
  ],
  "displeasure": [
    "NOUN"
  ],
  "endoplasmic": [
    "ADJ"
  ],
  "usefully": [
    "ADV"
  ],
  "moyen": [
    "NOUN"
  ],
  "threefold": [
    "PROPN"
  ],
  "innocently": [
    "ADV"
  ],
  "creat": [
    "NOUN"
  ],
  "integrable": [
    "ADJ"
  ],
  "regarder": [
    "PROPN"
  ],
  "unranked": [
    "VERB"
  ],
  "anaemia": [
    "NOUN"
  ],
  "trice": [
    "NOUN"
  ],
  "pretense": [
    "NOUN"
  ],
  "permian": [
    "PROPN"
  ],
  "unaffiliated": [
    "ADJ"
  ],
  "starbuck": [
    "NOUN"
  ],
  "turkmen": [
    "NOUN"
  ],
  "globulin": [
    "NOUN"
  ],
  "violator": [
    "NOUN"
  ],
  "boxcar": [
    "VERB"
  ],
  "aviso": [
    "NOUN"
  ],
  "pounder": [
    "NOUN"
  ],
  "kronor": [
    "NOUN"
  ],
  "archway": [
    "NOUN"
  ],
  "tocopherol": [
    "VERB"
  ],
  "tirelessly": [
    "ADV"
  ],
  "penta": [
    "VERB"
  ],
  "ultimatum": [
    "NOUN"
  ],
  "shelling": [
    "VERB"
  ],
  "visita": [
    "PROPN"
  ],
  "pilar": [
    "ADJ"
  ],
  "observant": [
    "ADJ"
  ],
  "unhappiness": [
    "NOUN"
  ],
  "cinder": [
    "NOUN"
  ],
  "viaduct": [
    "NOUN"
  ],
  "methodical": [
    "ADJ"
  ],
  "secularism": [
    "NOUN"
  ],
  "trekker": [
    "NOUN"
  ],
  "monotonous": [
    "ADJ"
  ],
  "neuroblastoma": [
    "ADJ"
  ],
  "thorp": [
    "PROPN"
  ],
  "glandular": [
    "ADJ"
  ],
  "rejuvenate": [
    "NOUN"
  ],
  "operatic": [
    "ADJ"
  ],
  "malevolent": [
    "ADJ"
  ],
  "stile": [
    "VERB"
  ],
  "xenia": [
    "PROPN"
  ],
  "nadir": [
    "INTJ"
  ],
  "recoup": [
    "NOUN"
  ],
  "naught": [
    "ADV"
  ],
  "backfill": [
    "NOUN",
    "PROPN"
  ],
  "kedar": [
    "NOUN"
  ],
  "adjacency": [
    "NOUN"
  ],
  "antagonism": [
    "NOUN"
  ],
  "debby": [
    "PROPN"
  ],
  "coinage": [
    "NOUN"
  ],
  "unproductive": [
    "ADJ"
  ],
  "planer": [
    "NOUN"
  ],
  "hermaphrodite": [
    "PROPN"
  ],
  "gavel": [
    "NOUN"
  ],
  "nefarious": [
    "ADJ"
  ],
  "stoppage": [
    "VERB"
  ],
  "defray": [
    "VERB"
  ],
  "berkowitz": [
    "PROPN"
  ],
  "weighty": [
    "PROPN"
  ],
  "sahib": [
    "NOUN"
  ],
  "notifier": [
    "ADV"
  ],
  "gasping": [
    "VERB"
  ],
  "valerian": [
    "PROPN"
  ],
  "idiocy": [
    "PROPN"
  ],
  "frenzied": [
    "VERB"
  ],
  "postulate": [
    "VERB"
  ],
  "enrollee": [
    "PROPN"
  ],
  "wheatland": [
    "NOUN"
  ],
  "revisor": [
    "NOUN"
  ],
  "hammerhead": [
    "PROPN"
  ],
  "pendent": [
    "NOUN"
  ],
  "edifice": [
    "VERB"
  ],
  "facia": [
    "NOUN"
  ],
  "vermin": [
    "NOUN"
  ],
  "stalemate": [
    "VERB"
  ],
  "feist": [
    "NOUN"
  ],
  "dialectic": [
    "ADJ"
  ],
  "rationalization": [
    "NOUN"
  ],
  "rhinoceros": [
    "PROPN"
  ],
  "adjutant": [
    "PROPN"
  ],
  "spitz": [
    "VERB"
  ],
  "sickening": [
    "VERB"
  ],
  "splat": [
    "ADJ"
  ],
  "nostradamus": [
    "NOUN"
  ],
  "gallium": [
    "PROPN"
  ],
  "mannered": [
    "VERB"
  ],
  "steeper": [
    "ADJ"
  ],
  "stalwart": [
    "VERB"
  ],
  "sharia": [
    "PROPN"
  ],
  "topiary": [
    "NOUN"
  ],
  "buttery": [
    "NOUN"
  ],
  "deformity": [
    "NOUN"
  ],
  "optometrist": [
    "NOUN"
  ],
  "bogey": [
    "PROPN"
  ],
  "pipette": [
    "NOUN"
  ],
  "invalidity": [
    "NOUN"
  ],
  "coveralls": [
    "NOUN"
  ],
  "soundly": [
    "ADV"
  ],
  "wicking": [
    "VERB"
  ],
  "umatilla": [
    "NOUN"
  ],
  "pinkerton": [
    "PROPN"
  ],
  "austral": [
    "ADJ"
  ],
  "interferometer": [
    "ADV"
  ],
  "barbican": [
    "ADJ"
  ],
  "paulus": [
    "PROPN"
  ],
  "criminally": [
    "ADV"
  ],
  "lariat": [
    "PROPN"
  ],
  "redraw": [
    "PROPN"
  ],
  "mahesh": [
    "PROPN"
  ],
  "pursuance": [
    "NOUN"
  ],
  "scapegoat": [
    "NOUN"
  ],
  "faceless": [
    "NOUN"
  ],
  "aftershock": [
    "NOUN"
  ],
  "spiro": [
    "PROPN"
  ],
  "hydrotherapy": [
    "NOUN"
  ],
  "marionette": [
    "PROPN"
  ],
  "anathema": [
    "NOUN"
  ],
  "islay": [
    "NOUN"
  ],
  "nitty": [
    "ADJ"
  ],
  "quintile": [
    "VERB"
  ],
  "dehumidifier": [
    "NOUN"
  ],
  "trifle": [
    "VERB"
  ],
  "preferentially": [
    "ADV"
  ],
  "diuretic": [
    "ADJ"
  ],
  "unexpired": [
    "ADJ"
  ],
  "shaikh": [
    "PROPN"
  ],
  "refractor": [
    "NOUN"
  ],
  "bouldering": [
    "VERB"
  ],
  "dysphagia": [
    "PROPN"
  ],
  "inadmissible": [
    "ADJ"
  ],
  "milken": [
    "PROPN"
  ],
  "zooplankton": [
    "PROPN"
  ],
  "philatelic": [
    "ADJ"
  ],
  "innocuous": [
    "ADJ"
  ],
  "retake": [
    "VERB"
  ],
  "unpacked": [
    "ADJ"
  ],
  "marengo": [
    "NOUN"
  ],
  "gonzalo": [
    "PROPN"
  ],
  "quiche": [
    "NOUN"
  ],
  "maduro": [
    "PROPN"
  ],
  "evaporate": [
    "VERB"
  ],
  "transcriber": [
    "NOUN"
  ],
  "midwinter": [
    "VERB"
  ],
  "undoing": [
    "VERB"
  ],
  "vying": [
    "VERB"
  ],
  "pooch": [
    "NOUN"
  ],
  "gripper": [
    "NOUN"
  ],
  "glace": [
    "NOUN"
  ],
  "musicianship": [
    "NOUN"
  ],
  "purview": [
    "VERB"
  ],
  "overpass": [
    "NOUN"
  ],
  "inwardly": [
    "ADV"
  ],
  "speedometer": [
    "NOUN"
  ],
  "adeline": [
    "VERB"
  ],
  "smothered": [
    "VERB"
  ],
  "eulogy": [
    "NOUN"
  ],
  "bottomed": [
    "ADJ"
  ],
  "superscript": [
    "NOUN"
  ],
  "proteinase": [
    "NOUN"
  ],
  "pernicious": [
    "ADJ"
  ],
  "discriminant": [
    "NOUN"
  ],
  "babbitt": [
    "PROPN"
  ],
  "scrimmage": [
    "NOUN"
  ],
  "stade": [
    "NOUN"
  ],
  "carnivore": [
    "NOUN"
  ],
  "egalitarian": [
    "PROPN"
  ],
  "pombe": [
    "NOUN"
  ],
  "yamato": [
    "PROPN"
  ],
  "jenson": [
    "PROPN"
  ],
  "mortgagee": [
    "NOUN"
  ],
  "skirmish": [
    "VERB"
  ],
  "anyplace": [
    "NOUN"
  ],
  "ventilating": [
    "VERB"
  ],
  "retreating": [
    "VERB"
  ],
  "mohave": [
    "VERB"
  ],
  "nonsensical": [
    "ADJ"
  ],
  "gallows": [
    "VERB"
  ],
  "rheumatism": [
    "NOUN"
  ],
  "devotee": [
    "NOUN"
  ],
  "cowardice": [
    "NOUN"
  ],
  "fabled": [
    "VERB"
  ],
  "trichy": [
    "NOUN"
  ],
  "animosity": [
    "NOUN"
  ],
  "dosimetry": [
    "NOUN"
  ],
  "smelter": [
    "NOUN"
  ],
  "dynamism": [
    "NOUN"
  ],
  "rabat": [
    "NOUN"
  ],
  "ensue": [
    "NOUN"
  ],
  "conto": [
    "NOUN"
  ],
  "sagging": [
    "VERB"
  ],
  "statics": [
    "NOUN"
  ],
  "rucksack": [
    "VERB"
  ],
  "sybil": [
    "VERB"
  ],
  "cupcake": [
    "NOUN"
  ],
  "pekin": [
    "PROPN"
  ],
  "hopelessness": [
    "NOUN"
  ],
  "errand": [
    "PROPN"
  ],
  "yeoman": [
    "NOUN"
  ],
  "polycystic": [
    "ADJ"
  ],
  "slimy": [
    "PROPN"
  ],
  "krzysztof": [
    "PROPN"
  ],
  "raggedy": [
    "VERB"
  ],
  "coerce": [
    "NOUN"
  ],
  "overhang": [
    "NOUN"
  ],
  "stunningly": [
    "ADV"
  ],
  "sobbing": [
    "VERB"
  ],
  "muslin": [
    "NOUN"
  ],
  "hugger": [
    "NOUN"
  ],
  "deliberative": [
    "ADJ"
  ],
  "tattooing": [
    "VERB"
  ],
  "estoppel": [
    "PROPN"
  ],
  "emigrant": [
    "NOUN"
  ],
  "supercool": [
    "NOUN"
  ],
  "contaminate": [
    "VERB"
  ],
  "bassinet": [
    "NOUN"
  ],
  "thorny": [
    "ADJ"
  ],
  "hibernation": [
    "NOUN"
  ],
  "interplanetary": [
    "ADJ"
  ],
  "interbank": [
    "ADV"
  ],
  "hullabaloo": [
    "PROPN"
  ],
  "erratum": [
    "NOUN"
  ],
  "anthracite": [
    "VERB"
  ],
  "meditating": [
    "VERB"
  ],
  "trunking": [
    "VERB"
  ],
  "patchouli": [
    "PROPN"
  ],
  "merciless": [
    "PROPN"
  ],
  "borer": [
    "PROPN"
  ],
  "oriole": [
    "NOUN"
  ],
  "clump": [
    "VERB"
  ],
  "mensa": [
    "PROPN"
  ],
  "shiner": [
    "NOUN"
  ],
  "rhesus": [
    "PROPN"
  ],
  "streptomyces": [
    "NOUN"
  ],
  "transcribe": [
    "VERB"
  ],
  "atrocity": [
    "NOUN"
  ],
  "elinor": [
    "NOUN"
  ],
  "proportionally": [
    "ADV"
  ],
  "untrained": [
    "VERB"
  ],
  "billable": [
    "ADJ"
  ],
  "tiresome": [
    "VERB"
  ],
  "splashed": [
    "VERB"
  ],
  "faraway": [
    "ADV"
  ],
  "ingest": [
    "VERB",
    "ADJ"
  ],
  "sirloin": [
    "VERB"
  ],
  "parthenon": [
    "PROPN"
  ],
  "tilde": [
    "NOUN"
  ],
  "potash": [
    "VERB"
  ],
  "lapping": [
    "VERB"
  ],
  "chivalry": [
    "VERB"
  ],
  "commonality": [
    "NOUN"
  ],
  "regrettably": [
    "ADV"
  ],
  "playbook": [
    "PROPN",
    "NOUN"
  ],
  "frustrate": [
    "ADJ"
  ],
  "sideboard": [
    "PROPN"
  ],
  "muffled": [
    "VERB"
  ],
  "laryngeal": [
    "ADJ"
  ],
  "outfielder": [
    "NOUN"
  ],
  "nonattainment": [
    "NOUN"
  ],
  "slapstick": [
    "VERB"
  ],
  "connaught": [
    "NOUN"
  ],
  "subculture": [
    "NOUN"
  ],
  "roselle": [
    "NOUN"
  ],
  "tether": [
    "VERB"
  ],
  "hyperbole": [
    "PROPN"
  ],
  "skeet": [
    "VERB"
  ],
  "toucan": [
    "PROPN"
  ],
  "borghese": [
    "PROPN"
  ],
  "oxidizing": [
    "VERB"
  ],
  "kennebec": [
    "PROPN"
  ],
  "brahman": [
    "NOUN"
  ],
  "phosphorous": [
    "ADJ"
  ],
  "obligor": [
    "NOUN"
  ],
  "matcher": [
    "VERB"
  ],
  "sterility": [
    "NOUN"
  ],
  "prowl": [
    "NOUN"
  ],
  "bridger": [
    "PROPN"
  ],
  "amiable": [
    "ADJ"
  ],
  "piecewise": [
    "NOUN"
  ],
  "undulating": [
    "VERB"
  ],
  "grosso": [
    "PROPN"
  ],
  "rockfish": [
    "PROPN"
  ],
  "duodenal": [
    "ADJ"
  ],
  "uninstalled": [
    "VERB",
    "ADJ"
  ],
  "irrevocably": [
    "ADV"
  ],
  "lactobacillus": [
    "NOUN"
  ],
  "unrelenting": [
    "ADJ"
  ],
  "neuropsychology": [
    "NOUN"
  ],
  "expeditiously": [
    "ADV"
  ],
  "antiquated": [
    "VERB"
  ],
  "sputtering": [
    "VERB"
  ],
  "femininity": [
    "NOUN"
  ],
  "opulent": [
    "NOUN"
  ],
  "deferment": [
    "NOUN"
  ],
  "dimly": [
    "ADV"
  ],
  "squall": [
    "VERB"
  ],
  "nothingness": [
    "NOUN"
  ],
  "antagonistic": [
    "ADJ"
  ],
  "cinque": [
    "NOUN"
  ],
  "bowery": [
    "NOUN"
  ],
  "immovable": [
    "ADJ"
  ],
  "outlier": [
    "NOUN"
  ],
  "rhein": [
    "PROPN"
  ],
  "fervor": [
    "NOUN"
  ],
  "camshaft": [
    "NOUN"
  ],
  "scooped": [
    "VERB"
  ],
  "bijou": [
    "PROPN"
  ],
  "innervation": [
    "NOUN"
  ],
  "hibernia": [
    "NOUN"
  ],
  "constraining": [
    "VERB"
  ],
  "lepton": [
    "PROPN"
  ],
  "cursory": [
    "NOUN"
  ],
  "razer": [
    "PROPN"
  ],
  "dissipate": [
    "VERB"
  ],
  "batsman": [
    "NOUN"
  ],
  "desorption": [
    "NOUN"
  ],
  "bellflower": [
    "NOUN"
  ],
  "watertight": [
    "NOUN"
  ],
  "ionian": [
    "PROPN"
  ],
  "stevia": [
    "PROPN"
  ],
  "americanism": [
    "NOUN"
  ],
  "photocopier": [
    "PROPN"
  ],
  "pessimism": [
    "NOUN"
  ],
  "vehemently": [
    "ADV"
  ],
  "velvety": [
    "NOUN"
  ],
  "mononuclear": [
    "VERB"
  ],
  "ternary": [
    "ADJ"
  ],
  "footballer": [
    "NOUN"
  ],
  "sisyphus": [
    "NOUN"
  ],
  "foolproof": [
    "NOUN"
  ],
  "lakshmi": [
    "NOUN"
  ],
  "teeming": [
    "VERB"
  ],
  "foolishly": [
    "ADV"
  ],
  "inanimate": [
    "VERB"
  ],
  "panting": [
    "VERB"
  ],
  "depositor": [
    "NOUN"
  ],
  "defensively": [
    "ADV"
  ],
  "romaine": [
    "VERB"
  ],
  "forgo": [
    "VERB"
  ],
  "effusion": [
    "NOUN"
  ],
  "lunacy": [
    "NOUN"
  ],
  "dimensionality": [
    "NOUN"
  ],
  "loathe": [
    "PROPN"
  ],
  "unprocessed": [
    "ADJ"
  ],
  "notoriety": [
    "NOUN"
  ],
  "hydroxyl": [
    "PROPN"
  ],
  "huddle": [
    "NOUN"
  ],
  "numismatic": [
    "ADJ"
  ],
  "avoidable": [
    "ADJ"
  ],
  "adenoma": [
    "ADV"
  ],
  "flammability": [
    "NOUN"
  ],
  "truancy": [
    "NOUN"
  ],
  "taxicab": [
    "NOUN"
  ],
  "confounded": [
    "VERB"
  ],
  "flatiron": [
    "NOUN"
  ],
  "unavailability": [
    "NOUN"
  ],
  "rooter": [
    "NOUN"
  ],
  "widener": [
    "NOUN"
  ],
  "faery": [
    "NOUN"
  ],
  "eloise": [
    "ADV"
  ],
  "onetime": [
    "NOUN"
  ],
  "gating": [
    "VERB",
    "NOUN"
  ],
  "omnipotent": [
    "NOUN"
  ],
  "poise": [
    "VERB"
  ],
  "ringed": [
    "VERB"
  ],
  "slaughterhouse": [
    "VERB"
  ],
  "bagging": [
    "VERB"
  ],
  "unsteady": [
    "ADJ"
  ],
  "brainwashing": [
    "VERB"
  ],
  "duchy": [
    "ADJ"
  ],
  "malacca": [
    "PROPN"
  ],
  "wilmer": [
    "NOUN"
  ],
  "carrion": [
    "NOUN"
  ],
  "summarily": [
    "ADV"
  ],
  "sphincter": [
    "ADV"
  ],
  "infill": [
    "NOUN"
  ],
  "etude": [
    "NOUN"
  ],
  "stereotyping": [
    "VERB"
  ],
  "programmatically": [
    "ADV"
  ],
  "sanctified": [
    "VERB"
  ],
  "handicapper": [
    "ADV"
  ],
  "plantar": [
    "NOUN"
  ],
  "excitedly": [
    "ADV"
  ],
  "quarrying": [
    "VERB"
  ],
  "approachable": [
    "ADJ"
  ],
  "braced": [
    "VERB"
  ],
  "sweetener": [
    "NOUN"
  ],
  "gaunt": [
    "VERB"
  ],
  "spigot": [
    "VERB"
  ],
  "skilling": [
    "NOUN"
  ],
  "nailer": [
    "PROPN"
  ],
  "cornstarch": [
    "NOUN"
  ],
  "effie": [
    "NOUN"
  ],
  "chloroplast": [
    "VERB"
  ],
  "boden": [
    "ADJ"
  ],
  "pollute": [
    "VERB"
  ],
  "pistachio": [
    "NOUN"
  ],
  "riverbank": [
    "PROPN"
  ],
  "predominately": [
    "ADV"
  ],
  "metalware": [
    "NOUN"
  ],
  "pretzel": [
    "PROPN"
  ],
  "warping": [
    "VERB"
  ],
  "yardstick": [
    "NOUN"
  ],
  "supernatant": [
    "NOUN"
  ],
  "segmental": [
    "ADJ"
  ],
  "imperium": [
    "NOUN"
  ],
  "supercharger": [
    "NOUN"
  ],
  "sprouting": [
    "VERB"
  ],
  "vestibular": [
    "NOUN"
  ],
  "deceleration": [
    "NOUN"
  ],
  "consignee": [
    "NOUN"
  ],
  "aldehyde": [
    "NOUN"
  ],
  "pronged": [
    "VERB"
  ],
  "baring": [
    "VERB"
  ],
  "annabel": [
    "PROPN"
  ],
  "tartar": [
    "VERB"
  ],
  "brownish": [
    "PROPN"
  ],
  "cropland": [
    "VERB"
  ],
  "rejoin": [
    "VERB"
  ],
  "stratigraphic": [
    "ADJ"
  ],
  "gosport": [
    "VERB"
  ],
  "volition": [
    "NOUN"
  ],
  "suave": [
    "NOUN"
  ],
  "riddance": [
    "NOUN"
  ],
  "greaves": [
    "VERB"
  ],
  "lottie": [
    "ADJ"
  ],
  "smudge": [
    "VERB"
  ],
  "tulle": [
    "PROPN"
  ],
  "gabby": [
    "NOUN"
  ],
  "helplessness": [
    "NOUN"
  ],
  "circumstantial": [
    "ADJ"
  ],
  "ironwood": [
    "NOUN"
  ],
  "adiabatic": [
    "ADJ"
  ],
  "naturalism": [
    "NOUN"
  ],
  "sabian": [
    "PROPN"
  ],
  "accelerometer": [
    "NOUN"
  ],
  "galloping": [
    "VERB"
  ],
  "indestructible": [
    "ADJ"
  ],
  "principality": [
    "NOUN"
  ],
  "penobscot": [
    "PROPN"
  ],
  "micky": [
    "ADJ"
  ],
  "johnathan": [
    "PROPN"
  ],
  "gambier": [
    "ADJ"
  ],
  "indulging": [
    "VERB"
  ],
  "allusion": [
    "NOUN"
  ],
  "samaria": [
    "PROPN"
  ],
  "smeared": [
    "VERB"
  ],
  "quadrature": [
    "NOUN"
  ],
  "summerland": [
    "VERB"
  ],
  "herder": [
    "NOUN"
  ],
  "cinematical": [
    "ADJ"
  ],
  "outfall": [
    "NOUN"
  ],
  "winifred": [
    "VERB"
  ],
  "parasol": [
    "NOUN"
  ],
  "interchangeably": [
    "ADV"
  ],
  "nonspecific": [
    "ADJ"
  ],
  "atopic": [
    "NOUN"
  ],
  "coloration": [
    "NOUN"
  ],
  "culling": [
    "VERB"
  ],
  "stingy": [
    "ADJ"
  ],
  "zealot": [
    "NOUN"
  ],
  "succinctly": [
    "ADV"
  ],
  "sisley": [
    "PROPN"
  ],
  "turmeric": [
    "NOUN"
  ],
  "carnelian": [
    "PROPN"
  ],
  "parietal": [
    "ADJ"
  ],
  "underpants": [
    "NOUN"
  ],
  "prequalification": [
    "NOUN"
  ],
  "bidet": [
    "NOUN"
  ],
  "illegible": [
    "ADJ"
  ],
  "didst": [
    "VERB"
  ],
  "ductile": [
    "NOUN"
  ],
  "dimensionless": [
    "NOUN"
  ],
  "carex": [
    "PROPN"
  ],
  "wither": [
    "VERB"
  ],
  "contractually": [
    "ADV"
  ],
  "flattening": [
    "VERB"
  ],
  "insulate": [
    "VERB"
  ],
  "cobblestone": [
    "NOUN"
  ],
  "seamed": [
    "VERB"
  ],
  "meteorologist": [
    "NOUN"
  ],
  "colonoscopy": [
    "NOUN"
  ],
  "babbling": [
    "VERB"
  ],
  "centrality": [
    "NOUN"
  ],
  "admirably": [
    "ADV"
  ],
  "twinning": [
    "ADJ"
  ],
  "taster": [
    "NOUN"
  ],
  "nightfall": [
    "NOUN"
  ],
  "warrantless": [
    "NOUN"
  ],
  "croat": [
    "NOUN"
  ],
  "dropper": [
    "NOUN"
  ],
  "sarkar": [
    "NOUN"
  ],
  "surinam": [
    "PROPN"
  ],
  "xenophobia": [
    "PROPN"
  ],
  "krypton": [
    "PROPN"
  ],
  "chucky": [
    "ADJ"
  ],
  "bushman": [
    "PROPN"
  ],
  "forego": [
    "PROPN"
  ],
  "edelweiss": [
    "VERB"
  ],
  "humidor": [
    "PROPN"
  ],
  "irreparable": [
    "ADJ"
  ],
  "naturalizer": [
    "NOUN"
  ],
  "superstitious": [
    "ADJ"
  ],
  "tangy": [
    "VERB"
  ],
  "sedative": [
    "NOUN"
  ],
  "farina": [
    "PROPN"
  ],
  "cutaway": [
    "PROPN"
  ],
  "defraud": [
    "VERB"
  ],
  "toothed": [
    "VERB"
  ],
  "transferor": [
    "NOUN"
  ],
  "bygone": [
    "NOUN"
  ],
  "intercession": [
    "NOUN"
  ],
  "lettered": [
    "VERB"
  ],
  "darkening": [
    "VERB"
  ],
  "toothpick": [
    "VERB"
  ],
  "exhale": [
    "NOUN"
  ],
  "likable": [
    "ADJ"
  ],
  "shoestring": [
    "NOUN"
  ],
  "whirling": [
    "NOUN"
  ],
  "doghouse": [
    "NOUN"
  ],
  "grebe": [
    "NOUN"
  ],
  "flexion": [
    "NOUN"
  ],
  "kinsman": [
    "NOUN"
  ],
  "geomagnetic": [
    "ADJ"
  ],
  "designator": [
    "NOUN"
  ],
  "causative": [
    "VERB"
  ],
  "payed": [
    "VERB"
  ],
  "uncontested": [
    "ADJ"
  ],
  "cecile": [
    "VERB"
  ],
  "mutable": [
    "ADJ"
  ],
  "militarily": [
    "ADV"
  ],
  "barometric": [
    "PROPN"
  ],
  "regrowth": [
    "NOUN"
  ],
  "banca": [
    "VERB"
  ],
  "doughnut": [
    "PROPN"
  ],
  "scorching": [
    "VERB"
  ],
  "cribbage": [
    "NOUN"
  ],
  "rondo": [
    "NOUN"
  ],
  "typescript": [
    "PROPN",
    "NOUN"
  ],
  "jewry": [
    "PROPN"
  ],
  "barfly": [
    "NOUN"
  ],
  "vegetarianism": [
    "NOUN"
  ],
  "dictaphone": [
    "VERB"
  ],
  "flexibly": [
    "ADV"
  ],
  "whoop": [
    "NOUN"
  ],
  "reposition": [
    "NOUN"
  ],
  "cacao": [
    "PROPN"
  ],
  "soggy": [
    "ADJ"
  ],
  "ecologist": [
    "NOUN"
  ],
  "ducted": [
    "VERB"
  ],
  "heiress": [
    "NOUN"
  ],
  "dressy": [
    "PROPN"
  ],
  "authenticator": [
    "NOUN",
    "PROPN"
  ],
  "godhead": [
    "VERB"
  ],
  "portia": [
    "NOUN"
  ],
  "shyness": [
    "VERB"
  ],
  "angelus": [
    "PROPN"
  ],
  "unsightly": [
    "ADV"
  ],
  "linoleum": [
    "NOUN"
  ],
  "shearling": [
    "VERB"
  ],
  "frayed": [
    "VERB"
  ],
  "criminality": [
    "NOUN"
  ],
  "woolen": [
    "VERB"
  ],
  "cuticle": [
    "NOUN"
  ],
  "spunky": [
    "ADJ"
  ],
  "shrapnel": [
    "NOUN"
  ],
  "arthurian": [
    "PROPN"
  ],
  "deuterium": [
    "NOUN"
  ],
  "litany": [
    "NOUN"
  ],
  "totalitarianism": [
    "NOUN"
  ],
  "trigonometric": [
    "ADJ"
  ],
  "nutter": [
    "NOUN"
  ],
  "verbosity": [
    "NOUN"
  ],
  "larder": [
    "NOUN"
  ],
  "beret": [
    "NOUN"
  ],
  "nonstandard": [
    "PROPN"
  ],
  "truthfulness": [
    "ADJ"
  ],
  "atrocious": [
    "ADJ"
  ],
  "obelisk": [
    "NOUN"
  ],
  "valeria": [
    "VERB"
  ],
  "claret": [
    "VERB"
  ],
  "consecration": [
    "NOUN"
  ],
  "forbearance": [
    "NOUN"
  ],
  "chromatographic": [
    "ADJ"
  ],
  "golly": [
    "ADV"
  ],
  "shahid": [
    "PROPN"
  ],
  "apostrophe": [
    "PROPN"
  ],
  "wobbly": [
    "ADV"
  ],
  "stepmother": [
    "PROPN"
  ],
  "lapland": [
    "NOUN"
  ],
  "illuminator": [
    "NOUN"
  ],
  "symbolically": [
    "ADV"
  ],
  "randle": [
    "VERB"
  ],
  "unsubstantiated": [
    "ADJ"
  ],
  "centroid": [
    "PROPN"
  ],
  "monogrammed": [
    "VERB"
  ],
  "colville": [
    "NOUN"
  ],
  "voluminous": [
    "ADJ"
  ],
  "mottled": [
    "VERB"
  ],
  "lockup": [
    "NOUN"
  ],
  "cholinergic": [
    "ADJ"
  ],
  "estella": [
    "NOUN"
  ],
  "sangha": [
    "VERB"
  ],
  "resiliency": [
    "PROPN",
    "NOUN"
  ],
  "scrip": [
    "NOUN"
  ],
  "inhumane": [
    "ADJ"
  ],
  "rocher": [
    "PROPN"
  ],
  "inadequately": [
    "ADV"
  ],
  "arabella": [
    "NOUN"
  ],
  "panicked": [
    "VERB"
  ],
  "matti": [
    "NOUN"
  ],
  "throng": [
    "PROPN"
  ],
  "crump": [
    "NOUN"
  ],
  "randomization": [
    "NOUN"
  ],
  "rinsing": [
    "VERB"
  ],
  "reschedule": [
    "NOUN"
  ],
  "phosphor": [
    "NOUN"
  ],
  "unscented": [
    "VERB"
  ],
  "roosters": [
    "NOUN"
  ],
  "ionosphere": [
    "ADV"
  ],
  "airworthiness": [
    "NOUN"
  ],
  "turnip": [
    "NOUN"
  ],
  "juxtaposition": [
    "NOUN"
  ],
  "marci": [
    "NOUN"
  ],
  "willey": [
    "ADJ"
  ],
  "foreshore": [
    "VERB"
  ],
  "carnivorous": [
    "ADJ"
  ],
  "berber": [
    "NOUN"
  ],
  "gusset": [
    "NOUN"
  ],
  "mince": [
    "NOUN"
  ],
  "banish": [
    "VERB"
  ],
  "metalwork": [
    "NOUN"
  ],
  "schism": [
    "NOUN"
  ],
  "sculptured": [
    "VERB"
  ],
  "tidbit": [
    "NOUN"
  ],
  "jemima": [
    "NOUN"
  ],
  "impoundment": [
    "NOUN"
  ],
  "dogged": [
    "VERB"
  ],
  "apparition": [
    "NOUN"
  ],
  "fluor": [
    "ADV"
  ],
  "inoperable": [
    "ADJ"
  ],
  "thrashing": [
    "VERB"
  ],
  "salome": [
    "VERB"
  ],
  "cyclonic": [
    "ADJ"
  ],
  "unsubscribing": [
    "VERB"
  ],
  "thumping": [
    "VERB"
  ],
  "eugenics": [
    "NOUN"
  ],
  "hunch": [
    "VERB"
  ],
  "amaryllis": [
    "VERB"
  ],
  "sandpaper": [
    "NOUN"
  ],
  "perdition": [
    "NOUN"
  ],
  "wintering": [
    "VERB"
  ],
  "topple": [
    "NOUN"
  ],
  "hardiness": [
    "ADJ"
  ],
  "chickasaw": [
    "NOUN"
  ],
  "pungent": [
    "ADJ"
  ],
  "discontinuance": [
    "NOUN"
  ],
  "headliner": [
    "NOUN"
  ],
  "unbridled": [
    "VERB"
  ],
  "superposition": [
    "NOUN"
  ],
  "astrologer": [
    "NOUN"
  ],
  "laney": [
    "PROPN"
  ],
  "antigenic": [
    "ADJ"
  ],
  "dietetics": [
    "VERB"
  ],
  "benzo": [
    "NOUN"
  ],
  "chairwoman": [
    "NOUN"
  ],
  "canvass": [
    "NOUN"
  ],
  "radish": [
    "PROPN"
  ],
  "manifestly": [
    "ADV"
  ],
  "checkmate": [
    "VERB"
  ],
  "emphatic": [
    "ADJ"
  ],
  "tabula": [
    "VERB"
  ],
  "outgrowth": [
    "NOUN"
  ],
  "homeward": [
    "PROPN"
  ],
  "withered": [
    "VERB"
  ],
  "sandstorm": [
    "NOUN"
  ],
  "taoist": [
    "ADV"
  ],
  "mothering": [
    "VERB"
  ],
  "chrysanthemum": [
    "PROPN"
  ],
  "sunspot": [
    "NOUN"
  ],
  "fluorine": [
    "VERB"
  ],
  "retype": [
    "NOUN"
  ],
  "fortification": [
    "NOUN"
  ],
  "mingo": [
    "PROPN"
  ],
  "spurt": [
    "VERB"
  ],
  "elation": [
    "NOUN"
  ],
  "creationist": [
    "NOUN"
  ],
  "artistically": [
    "ADV"
  ],
  "cowbell": [
    "NOUN"
  ],
  "rater": [
    "PROPN"
  ],
  "epileptic": [
    "ADJ"
  ],
  "feller": [
    "NOUN"
  ],
  "earpiece": [
    "ADV"
  ],
  "enmity": [
    "NOUN"
  ],
  "sanctum": [
    "NOUN"
  ],
  "unconstrained": [
    "VERB"
  ],
  "souter": [
    "NOUN"
  ],
  "osteopathy": [
    "ADJ"
  ],
  "materialistic": [
    "ADJ"
  ],
  "boater": [
    "VERB"
  ],
  "congresswoman": [
    "NOUN"
  ],
  "eucharistic": [
    "ADJ"
  ],
  "oncoming": [
    "ADJ"
  ],
  "cloister": [
    "NOUN"
  ],
  "hygienist": [
    "NOUN"
  ],
  "dartmoor": [
    "NOUN"
  ],
  "stapled": [
    "VERB"
  ],
  "butternut": [
    "PROPN"
  ],
  "fancied": [
    "VERB"
  ],
  "spoilt": [
    "VERB"
  ],
  "predisposed": [
    "VERB"
  ],
  "hydrochloric": [
    "PROPN"
  ],
  "filippo": [
    "PROPN"
  ],
  "hainan": [
    "PROPN"
  ],
  "cockroach": [
    "NOUN"
  ],
  "computable": [
    "PROPN"
  ],
  "strode": [
    "PROPN"
  ],
  "disassemble": [
    "VERB"
  ],
  "littoral": [
    "ADJ"
  ],
  "anise": [
    "NOUN"
  ],
  "grainy": [
    "NOUN"
  ],
  "aggressor": [
    "PROPN"
  ],
  "pepperoni": [
    "VERB"
  ],
  "boathouse": [
    "NOUN"
  ],
  "consummation": [
    "NOUN"
  ],
  "fronting": [
    "VERB"
  ],
  "refreshingly": [
    "ADV"
  ],
  "sculptural": [
    "ADJ"
  ],
  "neurophysiology": [
    "NOUN"
  ],
  "annexure": [
    "VERB"
  ],
  "unfaithful": [
    "ADJ"
  ],
  "executioner": [
    "NOUN"
  ],
  "asthmatic": [
    "ADJ"
  ],
  "guillemot": [
    "NOUN"
  ],
  "linguistically": [
    "ADV"
  ],
  "reconstitution": [
    "NOUN"
  ],
  "interviewee": [
    "VERB"
  ],
  "titular": [
    "ADJ"
  ],
  "diminutive": [
    "VERB"
  ],
  "transcendence": [
    "VERB"
  ],
  "surah": [
    "VERB"
  ],
  "trapeze": [
    "VERB"
  ],
  "sunbird": [
    "PROPN"
  ],
  "cellophane": [
    "ADJ"
  ],
  "paring": [
    "VERB"
  ],
  "damning": [
    "VERB"
  ],
  "matrimony": [
    "NOUN"
  ],
  "humbug": [
    "PROPN"
  ],
  "rolfe": [
    "PROPN"
  ],
  "granulated": [
    "VERB"
  ],
  "bulldozer": [
    "NOUN"
  ],
  "ailment": [
    "NOUN"
  ],
  "homely": [
    "ADV"
  ],
  "sharpie": [
    "VERB"
  ],
  "perpetuity": [
    "NOUN"
  ],
  "stepfather": [
    "VERB"
  ],
  "currier": [
    "NOUN"
  ],
  "taproot": [
    "NOUN"
  ],
  "disprove": [
    "VERB"
  ],
  "urbanism": [
    "NOUN"
  ],
  "colloquia": [
    "PROPN"
  ],
  "dinero": [
    "NOUN"
  ],
  "incurable": [
    "VERB"
  ],
  "dixit": [
    "NOUN"
  ],
  "mountainside": [
    "VERB"
  ],
  "menthol": [
    "PROPN"
  ],
  "corinna": [
    "PROPN"
  ],
  "inescapable": [
    "ADJ"
  ],
  "supremely": [
    "ADV"
  ],
  "froggy": [
    "ADJ"
  ],
  "bagpipe": [
    "NOUN"
  ],
  "prostrate": [
    "VERB"
  ],
  "excitatory": [
    "NOUN"
  ],
  "provisionally": [
    "ADV"
  ],
  "cocked": [
    "VERB"
  ],
  "dribble": [
    "ADJ"
  ],
  "hosta": [
    "PROPN"
  ],
  "singularly": [
    "ADV"
  ],
  "gobble": [
    "NOUN"
  ],
  "preposterous": [
    "ADJ"
  ],
  "lazar": [
    "PROPN"
  ],
  "mythos": [
    "PROPN"
  ],
  "colloid": [
    "VERB"
  ],
  "breech": [
    "NOUN"
  ],
  "ripening": [
    "VERB"
  ],
  "oxidant": [
    "ADJ"
  ],
  "pyramidal": [
    "NOUN"
  ],
  "umbra": [
    "NOUN"
  ],
  "poppin": [
    "VERB"
  ],
  "trebuchet": [
    "NOUN"
  ],
  "pyrite": [
    "NOUN"
  ],
  "mahdi": [
    "PROPN"
  ],
  "kidder": [
    "PROPN"
  ],
  "phosphoric": [
    "PROPN"
  ],
  "parquet": [
    "NOUN"
  ],
  "reparation": [
    "NOUN"
  ],
  "amply": [
    "ADV"
  ],
  "damask": [
    "PROPN"
  ],
  "nighthawk": [
    "NOUN"
  ],
  "urologic": [
    "ADJ"
  ],
  "impotent": [
    "NOUN"
  ],
  "chaka": [
    "PROPN"
  ],
  "emotive": [
    "NOUN"
  ],
  "papacy": [
    "PROPN"
  ],
  "curmudgeon": [
    "PROPN"
  ],
  "freshener": [
    "ADJ"
  ],
  "thimble": [
    "ADJ"
  ],
  "ablaze": [
    "ADJ"
  ],
  "gramophone": [
    "NOUN"
  ],
  "spotty": [
    "ADV"
  ],
  "nettie": [
    "PROPN"
  ],
  "senatorial": [
    "NOUN"
  ],
  "unexplored": [
    "ADJ"
  ],
  "undeliverable": [
    "ADJ"
  ],
  "beechwood": [
    "NOUN"
  ],
  "epistemological": [
    "ADJ"
  ],
  "cloaking": [
    "VERB"
  ],
  "unannounced": [
    "ADJ"
  ],
  "deactivation": [
    "NOUN"
  ],
  "dichroic": [
    "VERB"
  ],
  "loafer": [
    "VERB"
  ],
  "retinol": [
    "NOUN"
  ],
  "insurmountable": [
    "ADJ"
  ],
  "fairing": [
    "VERB"
  ],
  "invisibility": [
    "NOUN"
  ],
  "haystack": [
    "NOUN"
  ],
  "swisher": [
    "VERB"
  ],
  "hotspur": [
    "NOUN"
  ],
  "phare": [
    "NOUN"
  ],
  "confining": [
    "VERB"
  ],
  "loony": [
    "NOUN"
  ],
  "impenetrable": [
    "ADJ"
  ],
  "collate": [
    "VERB"
  ],
  "encapsulate": [
    "VERB"
  ],
  "kabel": [
    "NOUN"
  ],
  "gymnastic": [
    "ADJ"
  ],
  "triglyceride": [
    "ADJ"
  ],
  "undistributed": [
    "VERB"
  ],
  "stifling": [
    "VERB"
  ],
  "dipper": [
    "NOUN"
  ],
  "luminescent": [
    "VERB"
  ],
  "percolation": [
    "NOUN"
  ],
  "sockeye": [
    "NOUN"
  ],
  "exemplify": [
    "VERB"
  ],
  "attractor": [
    "NOUN"
  ],
  "inane": [
    "NOUN"
  ],
  "becket": [
    "NOUN"
  ],
  "justus": [
    "PROPN"
  ],
  "bluntly": [
    "ADV"
  ],
  "ribble": [
    "NOUN"
  ],
  "corky": [
    "VERB"
  ],
  "defensible": [
    "ADJ"
  ],
  "derail": [
    "NOUN"
  ],
  "spinster": [
    "NOUN"
  ],
  "crappie": [
    "VERB"
  ],
  "clonal": [
    "ADJ"
  ],
  "anticancer": [
    "NOUN"
  ],
  "spook": [
    "NOUN"
  ],
  "geometrically": [
    "ADV"
  ],
  "diorama": [
    "NOUN"
  ],
  "undamaged": [
    "ADJ"
  ],
  "snoqualmie": [
    "PROPN"
  ],
  "brimming": [
    "VERB"
  ],
  "consolidator": [
    "NOUN"
  ],
  "prater": [
    "ADJ"
  ],
  "olden": [
    "VERB"
  ],
  "cyclotron": [
    "NOUN"
  ],
  "herne": [
    "PROPN"
  ],
  "unending": [
    "VERB"
  ],
  "tatar": [
    "VERB"
  ],
  "headquarter": [
    "ADV"
  ],
  "spiffy": [
    "ADJ"
  ],
  "acker": [
    "NOUN"
  ],
  "abominable": [
    "ADJ"
  ],
  "rattled": [
    "VERB"
  ],
  "tambourine": [
    "NOUN"
  ],
  "roughing": [
    "VERB"
  ],
  "tramway": [
    "PROPN"
  ],
  "coinsurance": [
    "NOUN"
  ],
  "venomous": [
    "ADJ"
  ],
  "impressively": [
    "ADV"
  ],
  "reapply": [
    "VERB"
  ],
  "patriarchy": [
    "NOUN"
  ],
  "inextricably": [
    "ADV"
  ],
  "tapering": [
    "VERB"
  ],
  "aleutian": [
    "PROPN"
  ],
  "dampen": [
    "VERB"
  ],
  "luminescence": [
    "NOUN"
  ],
  "llano": [
    "PROPN"
  ],
  "interdepartmental": [
    "ADJ"
  ],
  "unjustly": [
    "ADV"
  ],
  "rhizome": [
    "NOUN"
  ],
  "leprechaun": [
    "ADJ"
  ],
  "fokker": [
    "PROPN"
  ],
  "unknowingly": [
    "ADV"
  ],
  "rehearse": [
    "VERB"
  ],
  "seducing": [
    "VERB"
  ],
  "screeching": [
    "VERB"
  ],
  "reedy": [
    "VERB"
  ],
  "amide": [
    "VERB"
  ],
  "fearsome": [
    "ADJ"
  ],
  "psychometric": [
    "ADJ"
  ],
  "bureaux": [
    "PROPN"
  ],
  "christendom": [
    "ADV"
  ],
  "expressionism": [
    "NOUN"
  ],
  "biographer": [
    "NOUN"
  ],
  "wreak": [
    "NOUN"
  ],
  "tarragona": [
    "X"
  ],
  "penultimate": [
    "NOUN"
  ],
  "planta": [
    "NOUN"
  ],
  "leotard": [
    "PROPN"
  ],
  "constructivist": [
    "NOUN"
  ],
  "bridegroom": [
    "NOUN"
  ],
  "swarming": [
    "VERB"
  ],
  "threadless": [
    "ADJ"
  ],
  "accomplice": [
    "NOUN"
  ],
  "straightener": [
    "NOUN"
  ],
  "capra": [
    "ADJ"
  ],
  "shakti": [
    "VERB"
  ],
  "looper": [
    "PROPN"
  ],
  "morphogenesis": [
    "VERB"
  ],
  "irregularity": [
    "NOUN"
  ],
  "grayling": [
    "VERB"
  ],
  "bloat": [
    "NOUN"
  ],
  "gravestone": [
    "NOUN"
  ],
  "pompous": [
    "ADJ"
  ],
  "backwater": [
    "NOUN"
  ],
  "subvert": [
    "VERB"
  ],
  "summative": [
    "ADJ"
  ],
  "seder": [
    "VERB"
  ],
  "muscled": [
    "VERB"
  ],
  "instrumentality": [
    "NOUN"
  ],
  "insomniac": [
    "NOUN"
  ],
  "cowichan": [
    "VERB"
  ],
  "barnaby": [
    "NOUN"
  ],
  "addie": [
    "VERB"
  ],
  "electrophysiology": [
    "NOUN"
  ],
  "impassioned": [
    "VERB"
  ],
  "decrement": [
    "ADJ"
  ],
  "productively": [
    "ADV"
  ],
  "desperado": [
    "VERB"
  ],
  "solidify": [
    "VERB"
  ],
  "takings": [
    "NOUN"
  ],
  "triplex": [
    "NOUN"
  ],
  "flavoring": [
    "VERB"
  ],
  "mouton": [
    "PROPN"
  ],
  "contagion": [
    "NOUN"
  ],
  "conformant": [
    "PROPN"
  ],
  "archimedes": [
    "NOUN"
  ],
  "abutting": [
    "VERB"
  ],
  "desecration": [
    "NOUN"
  ],
  "venturer": [
    "NOUN"
  ],
  "lackluster": [
    "ADJ"
  ],
  "juniata": [
    "NOUN"
  ],
  "pocketbook": [
    "VERB"
  ],
  "sparkly": [
    "ADV"
  ],
  "sputum": [
    "NOUN"
  ],
  "ornithology": [
    "NOUN"
  ],
  "atlassian": [
    "PROPN",
    "ADJ"
  ],
  "users": [
    "NOUN",
    "PROPN"
  ],
  "customers": [
    "NOUN",
    "PROPN"
  ],
  "issues": [
    "NOUN",
    "PROPN"
  ],
  "teams": [
    "NOUN",
    "PROPN"
  ],
  "services": [
    "NOUN",
    "PROPN"
  ],
  "using": [
    "VERB"
  ],
  "changes": [
    "NOUN",
    "PROPN"
  ],
  "actions": [
    "NOUN",
    "PROPN"
  ],
  "questions": [
    "NOUN",
    "PROPN"
  ],
  "points": [
    "NOUN",
    "VERB"
  ],
  "tickets": [
    "NOUN",
    "PROPN"
  ],
  "remaining": [
    "VERB",
    "PROPN"
  ],
  "products": [
    "NOUN",
    "PROPN"
  ],
  "details": [
    "NOUN",
    "PROPN"
  ],
  "micros": [
    "PROPN",
    "NOUN"
  ],
  "software": [
    "PROPN",
    "NOUN"
  ],
  "completed": [
    "VERB",
    "PROPN"
  ],
  "events": [
    "NOUN",
    "PROPN"
  ],
  "created": [
    "VERB",
    "PROPN"
  ],
  "required": [
    "VERB",
    "PROPN"
  ],
  "bitbucket": [
    "PROPN",
    "NOUN"
  ],
  "existing": [
    "VERB",
    "ADJ"
  ],
  "email": [
    "NOUN",
    "PROPN"
  ],
  "results": [
    "NOUN",
    "PROPN"
  ],
  "projects": [
    "NOUN",
    "PROPN"
  ],
  "admin": [
    "PROPN",
    "NOUN"
  ],
  "incidents": [
    "NOUN",
    "PROPN"
  ],
  "requests": [
    "NOUN",
    "PROPN"
  ],
  "tasks": [
    "NOUN",
    "PROPN"
  ],
  "reporting": [
    "NOUN",
    "VERB"
  ],
  "started": [
    "VERB"
  ],
  "resources": [
    "NOUN",
    "PROPN"
  ],
  "needed": [
    "VERB",
    "PROPN"
  ],
  "features": [
    "NOUN",
    "VERB"
  ],
  "flags": [
    "NOUN",
    "PROPN"
  ],
  "pages": [
    "NOUN",
    "PROPN"
  ],
  "goals": [
    "NOUN",
    "PROPN"
  ],
  "alerts": [
    "NOUN",
    "PROPN"
  ],
  "instances": [
    "NOUN",
    "VERB"
  ],
  "monitoring": [
    "VERB",
    "NOUN"
  ],
  "tools": [
    "NOUN",
    "PROPN"
  ],
  "automation": [
    "NOUN",
    "PROPN"
  ],
  "rollout": [
    "NOUN",
    "PROPN"
  ],
  "fields": [
    "NOUN",
    "PROPN"
  ],
  "capabilities": [
    "NOUN",
    "PROPN"
  ],
  "updated": [
    "VERB",
    "PROPN"
  ],
  "sales": [
    "NOUN",
    "PROPN"
  ],
  "updates": [
    "NOUN",
    "PROPN"
  ],
  "months": [
    "NOUN",
    "PROPN"
  ],
  "requirements": [
    "NOUN",
    "PROPN"
  ],
  "partners": [
    "NOUN",
    "PROPN"
  ],
  "trello": [
    "PROPN",
    "NOUN"
  ],
  "including": [
    "VERB"
  ],
  "techops": [
    "PROPN",
    "NOUN"
  ],
  "approved": [
    "VERB",
    "PROPN"
  ],
  "breaching": [
    "VERB"
  ],
  "components": [
    "NOUN",
    "PROPN"
  ],
  "failed": [
    "VERB",
    "PROPN"
  ],
  "shared": [
    "VERB",
    "PROPN"
  ],
  "weeks": [
    "NOUN",
    "PROPN"
  ],
  "minutes": [
    "NOUN",
    "PROPN"
  ],
  "statsig": [
    "PROPN",
    "NOUN"
  ],
  "migrations": [
    "NOUN",
    "PROPN"
  ],
  "errors": [
    "NOUN",
    "PROPN"
  ],
  "solutions": [
    "NOUN",
    "PROPN"
  ],
  "detected": [
    "VERB"
  ],
  "types": [
    "NOUN",
    "PROPN"
  ],
  "pollinator": [
    "PROPN",
    "NOUN"
  ],
  "opsgenie": [
    "PROPN",
    "NOUN"
  ],
  "timeline": [
    "NOUN",
    "PROPN"
  ],
  "operations": [
    "NOUN",
    "PROPN"
  ],
  "risks": [
    "NOUN",
    "PROPN"
  ],
  "insights": [
    "NOUN",
    "PROPN"
  ],
  "enabled": [
    "VERB",
    "ADJ"
  ],
  "marketplace": [
    "PROPN",
    "NOUN"
  ],
  "members": [
    "NOUN",
    "PROPN"
  ],
  "hours": [
    "NOUN",
    "PROPN"
  ],
  "expected": [
    "VERB",
    "ADJ"
  ],
  "permissions": [
    "NOUN",
    "PROPN"
  ],
  "planning": [
    "NOUN",
    "VERB"
  ],
  "costs": [
    "NOUN",
    "VERB"
  ],
  "systems": [
    "NOUN",
    "PROPN"
  ],
  "instructions": [
    "NOUN",
    "PROPN"
  ],
  "violations": [
    "NOUN",
    "PROPN"
  ],
  "options": [
    "NOUN",
    "PROPN"
  ],
  "splunk": [
    "NOUN",
    "PROPN"
  ],
  "recommendations": [
    "NOUN",
    "PROPN"
  ],
  "groups": [
    "NOUN",
    "PROPN"
  ],
  "generated": [
    "VERB",
    "PROPN"
  ],
  "tests": [
    "NOUN",
    "VERB"
  ],
  "comments": [
    "NOUN",
    "PROPN"
  ],
  "managed": [
    "VERB",
    "PROPN"
  ],
  "osquery": [
    "NOUN",
    "PROPN"
  ],
  "creating": [
    "VERB",
    "PROPN"
  ],
  "accounts": [
    "NOUN",
    "VERB"
  ],
  "windows": [
    "PROPN",
    "NOUN"
  ],
  "processes": [
    "NOUN",
    "VERB"
  ],
  "settings": [
    "NOUN",
    "PROPN"
  ],
  "values": [
    "NOUN",
    "PROPN"
  ],
  "fedramp": [
    "NOUN",
    "PROPN"
  ],
  "streamhub": [
    "PROPN",
    "NOUN"
  ],
  "signalfx": [
    "PROPN",
    "NOUN"
  ],
  "areas": [
    "NOUN",
    "PROPN"
  ],
  "plans": [
    "NOUN",
    "VERB"
  ],
  "workflow": [
    "NOUN",
    "ADJ"
  ],
  "admins": [
    "NOUN",
    "PROPN"
  ],
  "stakeholders": [
    "NOUN",
    "PROPN"
  ],
  "skills": [
    "NOUN",
    "PROPN"
  ],
  "roadmap": [
    "NOUN",
    "PROPN"
  ],
  "onboarding": [
    "NOUN",
    "PROPN"
  ],
  "divisions": [
    "NOUN"
  ],
  "frontend": [
    "NOUN",
    "PROPN"
  ],
  "google": [
    "PROPN",
    "NOUN"
  ],
  "opportunities": [
    "NOUN",
    "PROPN"
  ],
  "means": [
    "VERB",
    "NOUN"
  ],
  "controls": [
    "NOUN",
    "PROPN"
  ],
  "dependencies": [
    "NOUN",
    "PROPN"
  ],
  "practices": [
    "NOUN",
    "PROPN"
  ],
  "filtered": [
    "VERB"
  ],
  "identified": [
    "VERB"
  ],
  "notifications": [
    "NOUN",
    "PROPN"
  ],
  "experiences": [
    "NOUN",
    "PROPN"
  ],
  "files": [
    "NOUN",
    "PROPN"
  ],
  "pricing": [
    "NOUN",
    "PROPN"
  ],
  "decisions": [
    "NOUN",
    "PROPN"
  ],
  "passed": [
    "VERB",
    "PROPN"
  ],
  "roles": [
    "NOUN",
    "PROPN"
  ],
  "dashboards": [
    "NOUN",
    "PROPN"
  ],
  "activities": [
    "NOUN",
    "PROPN"
  ],
  "priorities": [
    "NOUN",
    "PROPN"
  ],
  "scorecard": [
    "NOUN",
    "PROPN"
  ],
  "slauth": [
    "PROPN",
    "NOUN"
  ],
  "database": [
    "NOUN",
    "PROPN"
  ],
  "configured": [
    "VERB",
    "PROPN"
  ],
  "checks": [
    "NOUN",
    "PROPN"
  ],
  "proposed": [
    "VERB",
    "PROPN"
  ],
  "tracking": [
    "NOUN",
    "VERB"
  ],
  "challenges": [
    "NOUN",
    "PROPN"
  ],
  "adding": [
    "VERB"
  ],
  "comms": [
    "NOUN",
    "PROPN"
  ],
  "automated": [
    "VERB",
    "PROPN"
  ],
  "allows": [
    "VERB"
  ],
  "owned": [
    "VERB"
  ],
  "improvements": [
    "NOUN",
    "PROPN"
  ],
  "integrations": [
    "NOUN",
    "PROPN"
  ],
  "cloudwatch": [
    "PROPN",
    "NOUN"
  ],
  "images": [
    "NOUN",
    "PROPN"
  ],
  "config": [
    "NOUN",
    "PROPN"
  ],
  "changed": [
    "VERB"
  ],
  "years": [
    "NOUN"
  ],
  "topics": [
    "NOUN",
    "PROPN"
  ],
  "provides": [
    "VERB"
  ],
  "problems": [
    "NOUN"
  ],
  "deployments": [
    "NOUN",
    "PROPN"
  ],
  "examples": [
    "NOUN",
    "PROPN"
  ],
  "others": [
    "NOUN",
    "PROPN"
  ],
  "pipelines": [
    "NOUN",
    "PROPN"
  ],
  "rules": [
    "NOUN",
    "PROPN"
  ],
  "votes": [
    "NOUN"
  ],
  "queries": [
    "NOUN",
    "VERB"
  ],
  "terms": [
    "NOUN",
    "PROPN"
  ],
  "levels": [
    "NOUN",
    "PROPN"
  ],
  "calls": [
    "NOUN",
    "VERB"
  ],
  "profiles": [
    "NOUN",
    "PROPN"
  ],
  "reports": [
    "NOUN",
    "PROPN"
  ],
  "templates": [
    "NOUN",
    "PROPN"
  ],
  "developers": [
    "NOUN",
    "PROPN"
  ],
  "endpoint": [
    "NOUN",
    "PROPN"
  ],
  "supported": [
    "VERB"
  ],
  "requires": [
    "VERB"
  ],
  "messages": [
    "NOUN",
    "PROPN"
  ],
  "emails": [
    "NOUN",
    "PROPN"
  ],
  "participants": [
    "NOUN",
    "PROPN"
  ],
  "policies": [
    "NOUN",
    "PROPN"
  ],
  "engineers": [
    "NOUN",
    "PROPN"
  ],
  "ideas": [
    "NOUN",
    "PROPN"
  ],
  "expectations": [
    "NOUN",
    "PROPN"
  ],
  "includes": [
    "VERB"
  ],
  "vulnerabilities": [
    "NOUN",
    "PROPN"
  ],
  "owners": [
    "NOUN",
    "PROPN"
  ],
  "deployed": [
    "VERB",
    "PROPN"
  ],
  "benefits": [
    "NOUN",
    "PROPN"
  ],
  "graphql": [
    "PROPN",
    "NOUN"
  ],
  "workspace": [
    "NOUN",
    "PROPN"
  ],
  "milestones": [
    "NOUN",
    "PROPN"
  ],
  "scheduled": [
    "VERB",
    "ADJ"
  ],
  "attachments": [
    "NOUN",
    "PROPN"
  ],
  "managers": [
    "NOUN",
    "PROPN"
  ],
  "migrated": [
    "VERB"
  ],
  "backend": [
    "NOUN",
    "ADJ"
  ],
  "workflows": [
    "NOUN",
    "PROPN"
  ],
  "employees": [
    "NOUN",
    "PROPN"
  ],
  "enablement": [
    "NOUN",
    "PROPN"
  ],
  "multi": [
    "ADJ",
    "PROPN"
  ],
  "cookies": [
    "PROPN",
    "NOUN"
  ],
  "agents": [
    "NOUN",
    "PROPN"
  ],
  "makes": [
    "VERB"
  ],
  "breached": [
    "VERB",
    "PROPN"
  ],
  "compared": [
    "VERB"
  ],
  "exists": [
    "VERB",
    "NOUN"
  ],
  "meetings": [
    "NOUN",
    "PROPN"
  ],
  "models": [
    "NOUN",
    "PROPN"
  ],
  "devops": [
    "PROPN",
    "NOUN"
  ],
  "looks": [
    "VERB",
    "NOUN"
  ],
  "targeting": [
    "VERB",
    "PROPN"
  ],
  "applications": [
    "NOUN",
    "PROPN"
  ],
  "planned": [
    "VERB",
    "PROPN"
  ],
  "focused": [
    "VERB",
    "ADJ"
  ],
  "recommended": [
    "VERB",
    "PROPN"
  ],
  "tenants": [
    "NOUN",
    "PROPN"
  ],
  "shows": [
    "VERB",
    "NOUN"
  ],
  "sites": [
    "NOUN",
    "PROPN"
  ],
  "shard": [
    "NOUN",
    "PROPN"
  ],
  "published": [
    "VERB"
  ],
  "metadata": [
    "PROPN",
    "NOUN"
  ],
  "docker": [
    "NOUN",
    "PROPN"
  ],
  "channels": [
    "NOUN",
    "PROPN"
  ],
  "initiatives": [
    "NOUN",
    "PROPN"
  ],
  "dedicated": [
    "ADJ",
    "VERB"
  ],
  "scenarios": [
    "NOUN",
    "PROPN"
  ],
  "versions": [
    "NOUN",
    "PROPN"
  ],
  "guidelines": [
    "NOUN",
    "PROPN"
  ],
  "experiments": [
    "NOUN",
    "PROPN"
  ],
  "socrates": [
    "PROPN",
    "NOUN"
  ],
  "returns": [
    "VERB",
    "NOUN"
  ],
  "deleted": [
    "VERB"
  ],
  "concerns": [
    "NOUN",
    "PROPN"
  ],
  "sharing": [
    "VERB",
    "NOUN"
  ],
  "helps": [
    "VERB"
  ],
  "entities": [
    "NOUN",
    "PROPN"
  ],
  "outcomes": [
    "NOUN",
    "PROPN"
  ],
  "environments": [
    "NOUN",
    "PROPN"
  ],
  "escalation": [
    "NOUN",
    "PROPN"
  ],
  "improved": [
    "VERB",
    "ADJ"
  ],
  "ensuring": [
    "VERB",
    "PROPN"
  ],
  "migrating": [
    "VERB",
    "NOUN"
  ],
  "traduki": [
    "PROPN",
    "NOUN"
  ],
  "reviews": [
    "NOUN",
    "PROPN"
  ],
  "licenses": [
    "NOUN",
    "PROPN"
  ],
  "filters": [
    "NOUN",
    "PROPN"
  ],
  "managing": [
    "VERB",
    "NOUN"
  ],
  "views": [
    "NOUN",
    "PROPN"
  ],
  "mapping": [
    "NOUN",
    "PROPN"
  ],
  "cancelled": [
    "VERB",
    "ADJ"
  ],
  "failures": [
    "NOUN",
    "PROPN"
  ],
  "provisioning": [
    "PROPN",
    "NOUN"
  ],
  "nodes": [
    "NOUN",
    "PROPN"
  ],
  "objectives": [
    "NOUN",
    "PROPN"
  ],
  "hiring": [
    "VERB",
    "NOUN"
  ],
  "regions": [
    "NOUN",
    "PROPN"
  ],
  "mentioned": [
    "VERB"
  ],
  "processing": [
    "NOUN",
    "VERB"
  ],
  "implemented": [
    "VERB"
  ],
  "vendors": [
    "NOUN",
    "PROPN"
  ],
  "changing": [
    "VERB"
  ],
  "organizations": [
    "NOUN",
    "PROPN"
  ],
  "contains": [
    "VERB"
  ],
  "leaders": [
    "NOUN",
    "PROPN"
  ],
  "lifecycle": [
    "NOUN",
    "PROPN"
  ],
  "reviewed": [
    "VERB"
  ],
  "packages": [
    "NOUN",
    "PROPN"
  ],
  "attributes": [
    "NOUN",
    "PROPN"
  ],
  "breaches": [
    "NOUN",
    "VERB"
  ],
  "plugin": [
    "NOUN",
    "ADJ"
  ],
  "seems": [
    "VERB"
  ],
  "boards": [
    "NOUN",
    "PROPN"
  ],
  "flagged": [
    "VERB",
    "ADJ"
  ],
  "called": [
    "VERB"
  ],
  "takes": [
    "VERB"
  ],
  "dates": [
    "NOUN",
    "VERB"
  ],
  "charts": [
    "PROPN",
    "NOUN"
  ],
  "assignees": [
    "NOUN",
    "PROPN"
  ],
  "responses": [
    "NOUN",
    "PROPN"
  ],
  "moved": [
    "VERB"
  ],
  "increased": [
    "VERB"
  ],
  "contributors": [
    "NOUN",
    "PROPN"
  ],
  "methods": [
    "NOUN",
    "PROPN"
  ],
  "launchdarkly": [
    "PROPN",
    "ADJ"
  ],
  "caused": [
    "VERB"
  ],
  "async": [
    "NOUN",
    "PROPN"
  ],
  "sonarqube": [
    "PROPN",
    "NOUN"
  ],
  "bugfix": [
    "PROPN",
    "NOUN"
  ],
  "updating": [
    "VERB",
    "NOUN"
  ],
  "names": [
    "NOUN",
    "PROPN"
  ],
  "contacts": [
    "NOUN",
    "PROPN"
  ],
  "checklist": [
    "NOUN",
    "PROPN"
  ],
  "positions": [
    "NOUN",
    "PROPN"
  ],
  "standards": [
    "NOUN",
    "PROPN"
  ],
  "aligned": [
    "VERB",
    "PROPN"
  ],
  "strategies": [
    "NOUN",
    "PROPN"
  ],
  "spaces": [
    "NOUN",
    "PROPN"
  ],
  "domains": [
    "NOUN",
    "PROPN"
  ],
  "creates": [
    "VERB"
  ],
  "conditions": [
    "NOUN",
    "PROPN"
  ],
  "requested": [
    "VERB"
  ],
  "vulns": [
    "NOUN",
    "PROPN"
  ],
  "efforts": [
    "NOUN",
    "PROPN"
  ],
  "companies": [
    "NOUN",
    "PROPN"
  ],
  "stats": [
    "NOUN",
    "PROPN"
  ],
  "happened": [
    "VERB"
  ],
  "endpoints": [
    "NOUN",
    "PROPN"
  ],
  "delivered": [
    "VERB"
  ],
  "responsibilities": [
    "NOUN",
    "PROPN"
  ],
  "elements": [
    "NOUN",
    "PROPN"
  ],
  "documents": [
    "NOUN",
    "PROPN"
  ],
  "roadmaps": [
    "PROPN",
    "NOUN"
  ],
  "databricks": [
    "PROPN",
    "NOUN"
  ],
  "stored": [
    "VERB"
  ],
  "measures": [
    "NOUN",
    "VERB"
  ],
  "campaigns": [
    "NOUN",
    "PROPN"
  ],
  "microsoft": [
    "PROPN"
  ],
  "programs": [
    "NOUN",
    "PROPN"
  ],
  "responders": [
    "NOUN",
    "PROPN"
  ],
  "asked": [
    "VERB"
  ],
  "records": [
    "NOUN",
    "PROPN"
  ],
  "properties": [
    "NOUN",
    "PROPN"
  ],
  "scorecards": [
    "NOUN",
    "PROPN"
  ],
  "seats": [
    "NOUN",
    "PROPN"
  ],
  "offerings": [
    "NOUN",
    "PROPN"
  ],
  "communications": [
    "NOUN",
    "PROPN"
  ],
  "trends": [
    "NOUN",
    "PROPN"
  ],
  "oauth": [
    "PROPN",
    "NOUN"
  ],
  "installed": [
    "VERB",
    "PROPN"
  ],
  "alarms": [
    "NOUN",
    "PROPN"
  ],
  "commits": [
    "NOUN",
    "PROPN"
  ],
  "runbook": [
    "PROPN",
    "NOUN"
  ],
  "repcom": [
    "PROPN"
  ],
  "messaging": [
    "VERB",
    "NOUN"
  ],
  "references": [
    "NOUN",
    "PROPN"
  ],
  "numbers": [
    "NOUN",
    "PROPN"
  ],
  "broader": [
    "ADJ",
    "PROPN"
  ],
  "specified": [
    "VERB",
    "ADJ"
  ],
  "consumers": [
    "NOUN",
    "PROPN"
  ],
  "findings": [
    "NOUN",
    "PROPN"
  ],
  "observability": [
    "PROPN",
    "NOUN"
  ],
  "salesforce": [
    "PROPN",
    "NOUN"
  ],
  "deprecated": [
    "VERB",
    "PROPN"
  ],
  "reported": [
    "VERB"
  ],
  "alerting": [
    "VERB",
    "ADJ"
  ],
  "committed": [
    "VERB",
    "ADJ"
  ],
  "objects": [
    "NOUN",
    "VERB"
  ],
  "attributed": [
    "VERB"
  ],
  "stories": [
    "NOUN",
    "PROPN"
  ],
  "baseline": [
    "NOUN",
    "PROPN"
  ],
  "learnings": [
    "NOUN",
    "PROPN"
  ],
  "reasons": [
    "NOUN",
    "PROPN"
  ],
  "exemptions": [
    "NOUN",
    "PROPN"
  ],
  "conversations": [
    "NOUN",
    "PROPN"
  ],
  "functions": [
    "NOUN",
    "PROPN"
  ],
  "limits": [
    "NOUN",
    "VERB"
  ],
  "seconds": [
    "NOUN"
  ],
  "merged": [
    "VERB",
    "PROPN"
  ],
  "suggestions": [
    "NOUN",
    "PROPN"
  ],
  "enabling": [
    "VERB",
    "PROPN"
  ],
  "modules": [
    "NOUN",
    "PROPN"
  ],
  "happens": [
    "VERB"
  ],
  "totals": [
    "VERB",
    "NOUN"
  ],
  "relationships": [
    "NOUN",
    "PROPN"
  ],
  "asking": [
    "VERB"
  ],
  "repositories": [
    "NOUN",
    "PROPN"
  ],
  "labels": [
    "NOUN",
    "PROPN"
  ],
  "payload": [
    "NOUN",
    "PROPN"
  ],
  "databases": [
    "NOUN",
    "VERB"
  ],
  "prioritize": [
    "VERB",
    "PROPN"
  ],
  "offers": [
    "VERB",
    "NOUN"
  ],
  "builds": [
    "NOUN",
    "VERB"
  ],
  "onboarded": [
    "VERB"
  ],
  "statuspage": [
    "PROPN",
    "NOUN"
  ],
  "tokens": [
    "NOUN",
    "PROPN"
  ],
  "blockers": [
    "NOUN",
    "PROPN"
  ],
  "viewed": [
    "VERB"
  ],
  "integrated": [
    "VERB",
    "ADJ"
  ],
  "whiteboards": [
    "PROPN",
    "NOUN"
  ],
  "larger": [
    "ADJ",
    "PROPN"
  ],
  "embedded": [
    "VERB",
    "PROPN"
  ],
  "redeployed": [
    "VERB"
  ],
  "lessons": [
    "PROPN",
    "NOUN"
  ],
  "sources": [
    "NOUN",
    "PROPN"
  ],
  "allowed": [
    "VERB"
  ],
  "parameters": [
    "NOUN",
    "PROPN"
  ],
  "tagging": [
    "VERB",
    "NOUN"
  ],
  "website": [
    "NOUN",
    "PROPN"
  ],
  "firefox": [
    "PROPN",
    "NOUN"
  ],
  "connections": [
    "NOUN",
    "PROPN"
  ],
  "estimated": [
    "VERB",
    "PROPN"
  ],
  "impacts": [
    "NOUN",
    "VERB"
  ],
  "implementing": [
    "VERB"
  ],
  "impacting": [
    "VERB",
    "NOUN"
  ],
  "workspaces": [
    "NOUN",
    "PROPN"
  ],
  "descriptor": [
    "NOUN",
    "PROPN"
  ],
  "streams": [
    "NOUN",
    "PROPN"
  ],
  "backups": [
    "NOUN",
    "PROPN"
  ],
  "clients": [
    "NOUN"
  ],
  "patterns": [
    "NOUN",
    "PROPN"
  ],
  "platforms": [
    "NOUN",
    "PROPN"
  ],
  "maintaining": [
    "VERB"
  ],
  "categories": [
    "NOUN",
    "PROPN"
  ],
  "excluded": [
    "VERB"
  ],
  "sydney": [
    "PROPN",
    "NOUN"
  ],
  "runtime": [
    "NOUN",
    "PROPN"
  ],
  "download": [
    "PROPN",
    "VERB"
  ],
  "fundamentals": [
    "PROPN",
    "NOUN"
  ],
  "enables": [
    "VERB"
  ],
  "controlled": [
    "VERB"
  ],
  "forms": [
    "NOUN",
    "PROPN"
  ],
  "supports": [
    "VERB",
    "PROPN"
  ],
  "queues": [
    "NOUN",
    "PROPN"
  ],
  "subscriptions": [
    "NOUN",
    "PROPN"
  ],
  "exceptions": [
    "NOUN",
    "PROPN"
  ],
  "gives": [
    "VERB"
  ],
  "targets": [
    "NOUN",
    "VERB"
  ],
  "checking": [
    "VERB",
    "NOUN"
  ],
  "organisation": [
    "NOUN",
    "PROPN"
  ],
  "intro": [
    "PROPN",
    "NOUN"
  ],
  "finops": [
    "PROPN"
  ],
  "discussed": [
    "VERB"
  ],
  "rates": [
    "NOUN",
    "PROPN"
  ],
  "linkedin": [
    "PROPN",
    "NOUN"
  ],
  "allowing": [
    "VERB"
  ],
  "github": [
    "PROPN"
  ],
  "candidates": [
    "NOUN",
    "PROPN"
  ],
  "kamino": [
    "PROPN",
    "NOUN"
  ],
  "sidecar": [
    "NOUN",
    "PROPN"
  ],
  "answers": [
    "NOUN",
    "PROPN"
  ],
  "columns": [
    "NOUN",
    "PROPN"
  ],
  "champions": [
    "PROPN",
    "NOUN"
  ],
  "atlassians": [
    "PROPN",
    "NOUN"
  ],
  "agreements": [
    "NOUN",
    "PROPN"
  ],
  "adjusted": [
    "VERB"
  ],
  "providers": [
    "NOUN",
    "PROPN"
  ],
  "cookie": [
    "NOUN",
    "PROPN"
  ],
  "quotes": [
    "NOUN",
    "PROPN"
  ],
  "states": [
    "NOUN",
    "PROPN"
  ],
  "wanted": [
    "VERB"
  ],
  "designs": [
    "NOUN",
    "VERB"
  ],
  "linux": [
    "PROPN"
  ],
  "discussions": [
    "NOUN"
  ],
  "figma": [
    "PROPN",
    "ADJ"
  ],
  "cards": [
    "NOUN",
    "PROPN"
  ],
  "introduced": [
    "VERB"
  ],
  "inline": [
    "NOUN",
    "PROPN"
  ],
  "upload": [
    "VERB",
    "NOUN"
  ],
  "timelines": [
    "NOUN",
    "PROPN"
  ],
  "flows": [
    "NOUN",
    "VERB"
  ],
  "webhooks": [
    "PROPN",
    "NOUN"
  ],
  "plugins": [
    "NOUN",
    "PROPN"
  ],
  "attendees": [
    "NOUN",
    "PROPN"
  ],
  "releases": [
    "NOUN",
    "PROPN"
  ],
  "dialog": [
    "NOUN",
    "PROPN"
  ],
  "perms": [
    "NOUN",
    "PROPN"
  ],
  "euwest": [
    "ADJ"
  ],
  "netsuite": [
    "PROPN"
  ],
  "eucentral": [
    "ADJ",
    "NOUN"
  ],
  "foundations": [
    "PROPN",
    "NOUN"
  ],
  "suggested": [
    "VERB",
    "PROPN"
  ],
  "credentials": [
    "NOUN",
    "PROPN"
  ],
  "microservices": [
    "NOUN",
    "PROPN"
  ],
  "focusing": [
    "VERB"
  ],
  "hosted": [
    "VERB",
    "PROPN"
  ],
  "artifacts": [
    "NOUN",
    "PROPN"
  ],
  "artifactory": [
    "PROPN",
    "ADJ"
  ],
  "followed": [
    "VERB"
  ],
  "editing": [
    "VERB",
    "NOUN"
  ],
  "savings": [
    "NOUN",
    "PROPN"
  ],
  "dropdown": [
    "ADJ",
    "PROPN"
  ],
  "principles": [
    "NOUN",
    "PROPN"
  ],
  "reached": [
    "VERB"
  ],
  "helped": [
    "VERB"
  ],
  "configurations": [
    "NOUN",
    "PROPN"
  ],
  "spinnaker": [
    "PROPN",
    "NOUN"
  ],
  "resolving": [
    "VERB"
  ],
  "lists": [
    "NOUN",
    "VERB"
  ],
  "performed": [
    "VERB"
  ],
  "identifying": [
    "VERB",
    "NOUN"
  ],
  "shards": [
    "NOUN"
  ],
  "segments": [
    "NOUN",
    "PROPN"
  ],
  "interviews": [
    "NOUN",
    "PROPN"
  ],
  "processed": [
    "VERB",
    "PROPN"
  ],
  "starts": [
    "VERB",
    "NOUN"
  ],
  "wants": [
    "VERB"
  ],
  "counts": [
    "NOUN",
    "VERB"
  ],
  "retro": [
    "NOUN",
    "PROPN"
  ],
  "observed": [
    "VERB",
    "ADJ"
  ],
  "escalations": [
    "NOUN",
    "PROPN"
  ],
  "addressed": [
    "VERB"
  ],
  "articles": [
    "NOUN",
    "PROPN"
  ],
  "released": [
    "VERB"
  ],
  "accessed": [
    "VERB"
  ],
  "definitions": [
    "NOUN",
    "PROPN"
  ],
  "videos": [
    "NOUN",
    "PROPN"
  ],
  "sprints": [
    "NOUN",
    "PROPN"
  ],
  "const": [
    "NOUN",
    "VERB"
  ],
  "drivers": [
    "NOUN",
    "PROPN"
  ],
  "sections": [
    "NOUN",
    "PROPN"
  ],
  "scores": [
    "NOUN",
    "PROPN"
  ],
  "technologies": [
    "NOUN",
    "PROPN"
  ],
  "documented": [
    "VERB"
  ],
  "parts": [
    "NOUN"
  ],
  "lines": [
    "NOUN",
    "PROPN"
  ],
  "delivering": [
    "VERB"
  ],
  "timestamp": [
    "NOUN",
    "PROPN"
  ],
  "variables": [
    "NOUN",
    "PROPN"
  ],
  "linter": [
    "PROPN",
    "NOUN"
  ],
  "timezone": [
    "NOUN",
    "PROPN"
  ],
  "fixes": [
    "NOUN",
    "VERB"
  ],
  "screenshot": [
    "NOUN",
    "PROPN"
  ],
  "performing": [
    "VERB"
  ],
  "aspects": [
    "NOUN"
  ],
  "genai": [
    "PROPN"
  ],
  "modified": [
    "VERB",
    "PROPN"
  ],
  "servers": [
    "NOUN",
    "PROPN"
  ],
  "auditing": [
    "NOUN",
    "PROPN"
  ],
  "approvals": [
    "NOUN",
    "PROPN"
  ],
  "scalability": [
    "NOUN",
    "PROPN"
  ],
  "signup": [
    "ADJ",
    "PROPN"
  ],
  "captured": [
    "VERB"
  ],
  "scripts": [
    "NOUN",
    "PROPN"
  ],
  "purposes": [
    "NOUN"
  ],
  "triggers": [
    "NOUN",
    "VERB"
  ],
  "upgrades": [
    "NOUN",
    "PROPN"
  ],
  "sidecars": [
    "NOUN"
  ],
  "concepts": [
    "NOUN",
    "PROPN"
  ],
  "addressing": [
    "VERB"
  ],
  "launched": [
    "VERB"
  ],
  "userid": [
    "ADJ",
    "PROPN"
  ],
  "assumptions": [
    "NOUN",
    "PROPN"
  ],
  "passcode": [
    "PROPN"
  ],
  "factors": [
    "NOUN"
  ],
  "bifrost": [
    "PROPN",
    "NOUN"
  ],
  "themes": [
    "NOUN",
    "PROPN"
  ],
  "archived": [
    "VERB",
    "ADJ"
  ],
  "detectors": [
    "PROPN",
    "NOUN"
  ],
  "reviewing": [
    "VERB",
    "PROPN"
  ],
  "verified": [
    "VERB",
    "PROPN"
  ],
  "catalog": [
    "NOUN",
    "PROPN"
  ],
  "solving": [
    "VERB",
    "NOUN"
  ],
  "editions": [
    "PROPN",
    "NOUN"
  ],
  "developing": [
    "VERB",
    "PROPN"
  ],
  "words": [
    "NOUN"
  ],
  "dynamodb": [
    "PROPN",
    "NOUN"
  ],
  "stargate": [
    "PROPN",
    "VERB"
  ],
  "appears": [
    "VERB"
  ],
  "signed": [
    "VERB"
  ],
  "monitors": [
    "NOUN",
    "VERB"
  ],
  "deliverables": [
    "NOUN",
    "PROPN"
  ],
  "timeout": [
    "NOUN",
    "PROPN"
  ],
  "restrictions": [
    "NOUN",
    "PROPN"
  ],
  "differences": [
    "NOUN",
    "PROPN"
  ],
  "licensing": [
    "NOUN",
    "PROPN"
  ],
  "secrets": [
    "NOUN",
    "PROPN"
  ],
  "materials": [
    "NOUN",
    "PROPN"
  ],
  "online": [
    "ADJ",
    "PROPN"
  ],
  "clicks": [
    "NOUN",
    "VERB"
  ],
  "entitlements": [
    "NOUN",
    "PROPN"
  ],
  "clicked": [
    "VERB"
  ],
  "containers": [
    "NOUN",
    "PROPN"
  ],
  "webinar": [
    "NOUN",
    "PROPN"
  ],
  "golang": [
    "PROPN"
  ],
  "expertise": [
    "NOUN",
    "PROPN"
  ],
  "developed": [
    "VERB"
  ],
  "headers": [
    "NOUN",
    "PROPN"
  ],
  "sends": [
    "VERB",
    "NOUN"
  ],
  "occurred": [
    "VERB"
  ],
  "translations": [
    "NOUN"
  ],
  "diagrams": [
    "NOUN",
    "PROPN"
  ],
  "thoughts": [
    "NOUN",
    "PROPN"
  ],
  "commands": [
    "NOUN",
    "VERB"
  ],
  "cloudid": [
    "PROPN",
    "NOUN"
  ],
  "strings": [
    "NOUN"
  ],
  "codebase": [
    "NOUN",
    "PROPN"
  ],
  "redeploy": [
    "VERB",
    "NOUN"
  ],
  "checkpoint": [
    "PROPN",
    "NOUN"
  ],
  "designers": [
    "NOUN",
    "PROPN"
  ],
  "defining": [
    "VERB"
  ],
  "crowdstrike": [
    "PROPN"
  ],
  "individuals": [
    "NOUN"
  ],
  "handles": [
    "VERB",
    "NOUN"
  ],
  "proactive": [
    "ADJ",
    "PROPN"
  ],
  "plato": [
    "PROPN",
    "NOUN"
  ],
  "interactions": [
    "NOUN",
    "PROPN"
  ],
  "nested": [
    "VERB",
    "PROPN"
  ],
  "boolean": [
    "ADJ",
    "PROPN"
  ],
  "renewals": [
    "NOUN",
    "PROPN"
  ],
  "kanban": [
    "PROPN",
    "ADJ"
  ],
  "mechanisms": [
    "NOUN",
    "PROPN"
  ],
  "repos": [
    "NOUN",
    "PROPN"
  ],
  "downtime": [
    "NOUN",
    "PROPN"
  ],
  "username": [
    "ADJ",
    "NOUN"
  ],
  "volumes": [
    "NOUN",
    "PROPN"
  ],
  "limitations": [
    "NOUN",
    "PROPN"
  ],
  "periods": [
    "NOUN"
  ],
  "fails": [
    "VERB"
  ],
  "statuses": [
    "NOUN",
    "PROPN"
  ],
  "rollouts": [
    "NOUN",
    "PROPN"
  ],
  "competitors": [
    "NOUN",
    "PROPN"
  ],
  "bundler": [
    "NOUN"
  ],
  "advocates": [
    "NOUN",
    "PROPN"
  ],
  "servicedesk": [
    "NOUN",
    "PROPN"
  ],
  "elasticsearch": [
    "PROPN",
    "NOUN"
  ],
  "trending": [
    "VERB"
  ],
  "clusters": [
    "NOUN",
    "PROPN"
  ],
  "largest": [
    "ADJ"
  ],
  "depends": [
    "VERB"
  ],
  "epics": [
    "NOUN",
    "PROPN"
  ],
  "networking": [
    "PROPN",
    "NOUN"
  ],
  "missed": [
    "VERB"
  ],
  "enghealth": [
    "PROPN"
  ],
  "increases": [
    "NOUN",
    "VERB"
  ],
  "submitted": [
    "VERB",
    "PROPN"
  ],
  "tracks": [
    "NOUN",
    "VERB"
  ],
  "filename": [
    "NOUN",
    "PROPN"
  ],
  "described": [
    "VERB"
  ],
  "addresses": [
    "NOUN",
    "VERB"
  ],
  "considerations": [
    "NOUN",
    "PROPN"
  ],
  "joined": [
    "VERB"
  ],
  "troubleshooting": [
    "NOUN",
    "PROPN"
  ],
  "introducing": [
    "VERB"
  ],
  "scheduling": [
    "NOUN",
    "VERB"
  ],
  "named": [
    "VERB"
  ],
  "threads": [
    "NOUN",
    "PROPN"
  ],
  "entries": [
    "NOUN"
  ],
  "indicates": [
    "VERB"
  ],
  "highlights": [
    "NOUN",
    "VERB"
  ],
  "deals": [
    "NOUN",
    "VERB"
  ],
  "onboard": [
    "VERB",
    "PROPN"
  ],
  "invoices": [
    "NOUN",
    "PROPN"
  ],
  "macros": [
    "NOUN",
    "PROPN"
  ],
  "paths": [
    "NOUN"
  ],
  "estimates": [
    "NOUN",
    "VERB"
  ],
  "places": [
    "NOUN",
    "VERB"
  ],
  "cassi": [
    "PROPN",
    "ADJ"
  ],
  "pushed": [
    "VERB"
  ],
  "inputs": [
    "NOUN",
    "PROPN"
  ],
  "typeerror": [
    "PROPN"
  ],
  "webhook": [
    "NOUN",
    "PROPN"
  ],
  "screenshots": [
    "NOUN",
    "PROPN"
  ],
  "deploying": [
    "VERB",
    "PROPN"
  ],
  "screens": [
    "NOUN",
    "PROPN"
  ],
  "consumed": [
    "VERB"
  ],
  "answering": [
    "VERB"
  ],
  "leveraging": [
    "VERB"
  ],
  "triaged": [
    "PROPN",
    "VERB"
  ],
  "hipaa": [
    "PROPN",
    "ADJ"
  ],
  "checkout": [
    "VERB",
    "NOUN"
  ],
  "personas": [
    "NOUN",
    "PROPN"
  ],
  "improves": [
    "VERB"
  ],
  "frameworks": [
    "NOUN",
    "PROPN"
  ],
  "gates": [
    "NOUN",
    "PROPN"
  ],
  "constraints": [
    "NOUN",
    "PROPN"
  ],
  "panels": [
    "NOUN",
    "PROPN"
  ],
  "cryptor": [
    "PROPN",
    "NOUN"
  ],
  "shipit": [
    "PROPN",
    "NOUN"
  ],
  "automate": [
    "VERB",
    "ADJ"
  ],
  "provisioned": [
    "VERB",
    "ADJ"
  ],
  "roadmapped": [
    "VERB"
  ],
  "approaches": [
    "NOUN",
    "VERB"
  ],
  "emoji": [
    "PROPN",
    "NOUN"
  ],
  "datetime": [
    "PROPN"
  ],
  "barriers": [
    "NOUN",
    "PROPN"
  ],
  "journeys": [
    "NOUN",
    "PROPN"
  ],
  "stages": [
    "NOUN"
  ],
  "signals": [
    "NOUN",
    "PROPN"
  ],
  "extensions": [
    "NOUN",
    "PROPN"
  ],
  "governator": [
    "PROPN",
    "NOUN"
  ],
  "coding": [
    "VERB",
    "PROPN"
  ],
  "thresholds": [
    "NOUN",
    "PROPN"
  ],
  "assessments": [
    "NOUN",
    "VERB"
  ],
  "starters": [
    "NOUN",
    "PROPN"
  ],
  "stores": [
    "NOUN",
    "VERB"
  ],
  "represents": [
    "VERB"
  ],
  "actioned": [
    "VERB"
  ],
  "applying": [
    "VERB"
  ],
  "matches": [
    "VERB",
    "NOUN"
  ],
  "uploaded": [
    "VERB",
    "ADJ"
  ],
  "workers": [
    "NOUN",
    "PROPN"
  ],
  "receiving": [
    "VERB"
  ],
  "folks": [
    "NOUN"
  ],
  "runbooks": [
    "NOUN",
    "PROPN"
  ],
  "categorized": [
    "VERB"
  ],
  "follows": [
    "VERB"
  ],
  "trusted": [
    "VERB",
    "PROPN"
  ],
  "rejected": [
    "VERB",
    "PROPN"
  ],
  "workaround": [
    "NOUN",
    "PROPN"
  ],
  "requesting": [
    "VERB"
  ],
  "libraries": [
    "NOUN",
    "VERB"
  ],
  "causes": [
    "VERB",
    "NOUN"
  ],
  "tenantid": [
    "ADJ",
    "PROPN"
  ],
  "owning": [
    "PROPN",
    "VERB"
  ],
  "identifies": [
    "VERB",
    "PROPN"
  ],
  "internet": [
    "NOUN",
    "PROPN"
  ],
  "conducting": [
    "VERB"
  ],
  "contributing": [
    "VERB",
    "PROPN"
  ],
  "reviewers": [
    "NOUN",
    "PROPN"
  ],
  "continues": [
    "VERB"
  ],
  "validated": [
    "VERB"
  ],
  "deleting": [
    "VERB",
    "PROPN"
  ],
  "prioritise": [
    "VERB",
    "ADJ"
  ],
  "awaiting": [
    "VERB"
  ],
  "kubernetes": [
    "PROPN",
    "NOUN"
  ],
  "sidebar": [
    "NOUN",
    "PROPN"
  ],
  "handover": [
    "NOUN",
    "PROPN"
  ],
  "tooltip": [
    "NOUN",
    "PROPN"
  ],
  "namespace": [
    "NOUN",
    "PROPN"
  ],
  "challenging": [
    "VERB",
    "ADJ"
  ],
  "replacing": [
    "VERB"
  ],
  "switcheroo": [
    "PROPN",
    "NOUN"
  ],
  "healthcheck": [
    "PROPN",
    "NOUN"
  ],
  "jswdd": [
    "NOUN"
  ],
  "involves": [
    "VERB"
  ],
  "achieved": [
    "VERB"
  ],
  "populated": [
    "VERB",
    "ADJ"
  ],
  "granted": [
    "VERB"
  ],
  "delayed": [
    "VERB",
    "PROPN"
  ],
  "deprecation": [
    "NOUN",
    "PROPN"
  ],
  "located": [
    "VERB"
  ],
  "announcements": [
    "NOUN",
    "PROPN"
  ],
  "mapped": [
    "VERB",
    "PROPN"
  ],
  "closing": [
    "VERB",
    "NOUN"
  ],
  "offline": [
    "ADJ",
    "PROPN"
  ],
  "optimisation": [
    "PROPN",
    "NOUN"
  ],
  "expired": [
    "VERB",
    "PROPN"
  ],
  "enhancements": [
    "NOUN",
    "PROPN"
  ],
  "oregon": [
    "PROPN"
  ],
  "signups": [
    "NOUN",
    "PROPN"
  ],
  "wargames": [
    "NOUN"
  ],
  "cronman": [
    "NOUN",
    "PROPN"
  ],
  "authz": [
    "NOUN",
    "PROPN"
  ],
  "debug": [
    "ADJ",
    "PROPN"
  ],
  "transactions": [
    "NOUN",
    "PROPN"
  ],
  "preferences": [
    "NOUN",
    "PROPN"
  ],
  "adjustments": [
    "NOUN"
  ],
  "completing": [
    "VERB"
  ],
  "packaging": [
    "NOUN",
    "PROPN"
  ],
  "pillars": [
    "NOUN",
    "PROPN"
  ],
  "bookings": [
    "NOUN",
    "PROPN"
  ],
  "executing": [
    "VERB"
  ],
  "teammates": [
    "NOUN"
  ],
  "gartner": [
    "PROPN"
  ],
  "provisioner": [
    "PROPN",
    "NOUN"
  ],
  "highlighted": [
    "VERB"
  ],
  "prioritization": [
    "NOUN",
    "PROPN"
  ],
  "evaluating": [
    "VERB"
  ],
  "producers": [
    "NOUN"
  ],
  "enterprises": [
    "NOUN",
    "PROPN"
  ],
  "upsell": [
    "PROPN",
    "ADJ"
  ],
  "presented": [
    "VERB"
  ],
  "initiated": [
    "VERB",
    "PROPN"
  ],
  "collab": [
    "PROPN",
    "NOUN"
  ],
  "noticed": [
    "VERB"
  ],
  "europe": [
    "PROPN"
  ],
  "networks": [
    "PROPN",
    "NOUN"
  ],
  "malware": [
    "NOUN",
    "PROPN"
  ],
  "rollups": [
    "NOUN"
  ],
  "storing": [
    "VERB"
  ],
  "rituals": [
    "NOUN",
    "PROPN"
  ],
  "offered": [
    "VERB"
  ],
  "userbase": [
    "NOUN",
    "PROPN"
  ],
  "writes": [
    "VERB",
    "NOUN"
  ],
  "feels": [
    "VERB"
  ],
  "toolchain": [
    "PROPN",
    "NOUN"
  ],
  "units": [
    "NOUN",
    "PROPN"
  ],
  "automations": [
    "NOUN",
    "PROPN"
  ],
  "hands": [
    "NOUN",
    "PROPN"
  ],
  "experts": [
    "NOUN",
    "PROPN"
  ],
  "plays": [
    "VERB",
    "NOUN"
  ],
  "whiteboard": [
    "NOUN",
    "PROPN"
  ],
  "aligns": [
    "VERB",
    "NOUN"
  ],
  "requiring": [
    "VERB"
  ],
  "bringing": [
    "VERB"
  ],
  "implications": [
    "NOUN"
  ],
  "servicenow": [
    "PROPN"
  ],
  "rendered": [
    "VERB"
  ],
  "returning": [
    "VERB"
  ],
  "mentions": [
    "NOUN",
    "VERB"
  ],
  "rollup": [
    "NOUN",
    "PROPN"
  ],
  "involving": [
    "VERB"
  ],
  "publishing": [
    "VERB",
    "NOUN"
  ],
  "ensures": [
    "VERB"
  ],
  "applies": [
    "VERB"
  ],
  "highlighting": [
    "VERB",
    "NOUN"
  ],
  "downloads": [
    "VERB",
    "NOUN"
  ],
  "procedures": [
    "NOUN",
    "PROPN"
  ],
  "emerging": [
    "VERB",
    "PROPN"
  ],
  "cohorts": [
    "NOUN",
    "PROPN"
  ],
  "characters": [
    "NOUN",
    "PROPN"
  ],
  "discounts": [
    "NOUN",
    "PROPN"
  ],
  "caching": [
    "VERB",
    "PROPN"
  ],
  "conducted": [
    "VERB"
  ],
  "difficulties": [
    "NOUN"
  ],
  "asana": [
    "PROPN"
  ],
  "intel": [
    "PROPN"
  ],
  "funding": [
    "NOUN",
    "PROPN"
  ],
  "delays": [
    "NOUN"
  ],
  "purchased": [
    "VERB"
  ],
  "pieces": [
    "NOUN"
  ],
  "integrating": [
    "VERB",
    "PROPN"
  ],
  "shares": [
    "NOUN",
    "VERB"
  ],
  "covers": [
    "VERB"
  ],
  "indicating": [
    "VERB"
  ],
  "rights": [
    "NOUN",
    "PROPN"
  ],
  "encrypted": [
    "VERB"
  ],
  "deeper": [
    "ADJ",
    "PROPN"
  ],
  "investments": [
    "NOUN",
    "PROPN"
  ],
  "replaced": [
    "VERB"
  ],
  "techniques": [
    "NOUN",
    "PROPN"
  ],
  "manages": [
    "VERB"
  ],
  "impactful": [
    "ADJ"
  ],
  "tiers": [
    "NOUN",
    "PROPN"
  ],
  "parties": [
    "NOUN"
  ],
  "transp": [
    "NOUN"
  ],
  "displays": [
    "VERB",
    "NOUN"
  ],
  "orders": [
    "NOUN",
    "PROPN"
  ],
  "valiantys": [
    "PROPN"
  ],
  "edited": [
    "VERB",
    "ADJ"
  ],
  "buckets": [
    "NOUN"
  ],
  "recorded": [
    "VERB",
    "ADJ"
  ],
  "assessing": [
    "VERB"
  ],
  "opened": [
    "VERB"
  ],
  "gadgets": [
    "NOUN"
  ],
  "blogs": [
    "NOUN",
    "PROPN"
  ],
  "branches": [
    "NOUN",
    "PROPN"
  ],
  "viewing": [
    "VERB",
    "NOUN"
  ],
  "newer": [
    "ADJ"
  ],
  "opens": [
    "VERB",
    "NOUN"
  ],
  "postgres": [
    "NOUN",
    "PROPN"
  ],
  "approvers": [
    "PROPN",
    "NOUN"
  ],
  "redis": [
    "PROPN",
    "NOUN"
  ],
  "debugging": [
    "NOUN",
    "VERB"
  ],
  "describes": [
    "VERB"
  ],
  "adopting": [
    "VERB"
  ],
  "workato": [
    "PROPN",
    "NOUN"
  ],
  "solved": [
    "VERB"
  ],
  "contracts": [
    "NOUN",
    "PROPN"
  ],
  "calendars": [
    "PROPN",
    "NOUN"
  ],
  "deactivated": [
    "VERB"
  ],
  "upgrading": [
    "VERB",
    "NOUN"
  ],
  "containing": [
    "VERB"
  ],
  "cloudformation": [
    "NOUN",
    "PROPN"
  ],
  "contributions": [
    "NOUN"
  ],
  "batches": [
    "NOUN"
  ],
  "checkbox": [
    "NOUN",
    "PROPN"
  ],
  "homepage": [
    "NOUN",
    "PROPN"
  ],
  "customization": [
    "NOUN",
    "PROPN"
  ],
  "faila": [
    "PROPN"
  ],
  "failover": [
    "ADJ",
    "NOUN"
  ],
  "industries": [
    "NOUN",
    "PROPN"
  ],
  "outputs": [
    "NOUN",
    "PROPN"
  ],
  "trials": [
    "NOUN",
    "PROPN"
  ],
  "customize": [
    "VERB",
    "NOUN"
  ],
  "maintained": [
    "VERB"
  ],
  "demux": [
    "NOUN",
    "PROPN"
  ],
  "adhoc": [
    "NOUN",
    "PROPN"
  ],
  "scoped": [
    "VERB"
  ],
  "coordination": [
    "NOUN",
    "PROPN"
  ],
  "keyword": [
    "NOUN",
    "PROPN"
  ],
  "paused": [
    "PROPN",
    "VERB"
  ],
  "centralized": [
    "ADJ",
    "VERB"
  ],
  "outlines": [
    "VERB"
  ],
  "designated": [
    "VERB"
  ],
  "looked": [
    "VERB"
  ],
  "indicators": [
    "NOUN",
    "PROPN"
  ],
  "meets": [
    "VERB"
  ],
  "pulled": [
    "VERB"
  ],
  "kinesis": [
    "PROPN",
    "NOUN"
  ],
  "markets": [
    "NOUN",
    "PROPN"
  ],
  "suggests": [
    "VERB"
  ],
  "executions": [
    "NOUN"
  ],
  "achieving": [
    "VERB"
  ],
  "reads": [
    "NOUN",
    "VERB"
  ],
  "requestor": [
    "NOUN",
    "PROPN"
  ],
  "answered": [
    "VERB",
    "PROPN"
  ],
  "devices": [
    "NOUN"
  ],
  "accessing": [
    "VERB",
    "PROPN"
  ],
  "reactions": [
    "NOUN",
    "PROPN"
  ],
  "commitments": [
    "NOUN",
    "PROPN"
  ],
  "posts": [
    "NOUN",
    "PROPN"
  ],
  "locations": [
    "NOUN"
  ],
  "holidays": [
    "NOUN",
    "PROPN"
  ],
  "connecting": [
    "VERB"
  ],
  "schemas": [
    "NOUN",
    "PROPN"
  ],
  "monetization": [
    "PROPN",
    "NOUN"
  ],
  "adminhub": [
    "PROPN"
  ],
  "timeouts": [
    "NOUN",
    "PROPN"
  ],
  "workforce": [
    "NOUN",
    "PROPN"
  ],
  "courses": [
    "NOUN",
    "PROPN"
  ],
  "bento": [
    "PROPN"
  ],
  "dropped": [
    "VERB"
  ],
  "colleagues": [
    "NOUN"
  ],
  "evolving": [
    "VERB",
    "PROPN"
  ],
  "resulted": [
    "VERB"
  ],
  "merging": [
    "VERB",
    "NOUN"
  ],
  "vmware": [
    "PROPN"
  ],
  "credits": [
    "NOUN",
    "PROPN"
  ],
  "scopes": [
    "NOUN"
  ],
  "workshops": [
    "NOUN",
    "PROPN"
  ],
  "contentful": [
    "PROPN",
    "ADJ"
  ],
  "spikes": [
    "NOUN"
  ],
  "mitigated": [
    "VERB",
    "PROPN"
  ],
  "regressions": [
    "NOUN"
  ],
  "searches": [
    "NOUN",
    "VERB"
  ],
  "encountered": [
    "VERB"
  ],
  "lives": [
    "VERB",
    "NOUN"
  ],
  "peers": [
    "NOUN"
  ],
  "referenced": [
    "VERB"
  ],
  "kubectl": [
    "NOUN"
  ],
  "webserver": [
    "PROPN",
    "NOUN"
  ],
  "formatting": [
    "VERB",
    "NOUN"
  ],
  "triggering": [
    "VERB",
    "NOUN"
  ],
  "protected": [
    "VERB"
  ],
  "javascript": [
    "PROPN",
    "NOUN"
  ],
  "guides": [
    "NOUN",
    "PROPN"
  ],
  "scans": [
    "NOUN",
    "VERB"
  ],
  "authors": [
    "PROPN",
    "NOUN"
  ],
  "kinds": [
    "NOUN"
  ],
  "determining": [
    "VERB"
  ],
  "validations": [
    "NOUN",
    "PROPN"
  ],
  "performs": [
    "VERB"
  ],
  "moves": [
    "NOUN",
    "VERB"
  ],
  "desktop": [
    "NOUN",
    "PROPN"
  ],
  "occurs": [
    "VERB"
  ],
  "friends": [
    "NOUN",
    "PROPN"
  ],
  "reduces": [
    "VERB"
  ],
  "explored": [
    "VERB"
  ],
  "enhancing": [
    "VERB"
  ],
  "evaluated": [
    "VERB"
  ],
  "loads": [
    "NOUN",
    "VERB"
  ],
  "prompts": [
    "NOUN",
    "VERB"
  ],
  "smarts": [
    "NOUN",
    "PROPN"
  ],
  "confusing": [
    "ADJ",
    "VERB"
  ],
  "prodsec": [
    "PROPN"
  ],
  "takeaways": [
    "NOUN",
    "PROPN"
  ],
  "configuring": [
    "VERB",
    "PROPN"
  ],
  "standalone": [
    "ADJ",
    "PROPN"
  ],
  "explanations": [
    "NOUN"
  ],
  "payments": [
    "NOUN",
    "PROPN"
  ],
  "partnerships": [
    "NOUN",
    "PROPN"
  ],
  "interviewers": [
    "PROPN",
    "NOUN"
  ],
  "collecting": [
    "VERB"
  ],
  "entered": [
    "VERB"
  ],
  "putting": [
    "VERB"
  ],
  "exceeded": [
    "VERB"
  ],
  "preventing": [
    "VERB"
  ],
  "optimisations": [
    "NOUN"
  ],
  "makers": [
    "NOUN"
  ],
  "imports": [
    "NOUN",
    "PROPN"
  ],
  "timeframe": [
    "NOUN",
    "PROPN"
  ],
  "surveys": [
    "NOUN",
    "PROPN"
  ],
  "gitlab": [
    "PROPN",
    "NOUN"
  ],
  "receives": [
    "VERB"
  ],
  "schemes": [
    "NOUN",
    "PROPN"
  ],
  "transitions": [
    "NOUN",
    "PROPN"
  ],
  "mappings": [
    "NOUN",
    "PROPN"
  ],
  "callback": [
    "NOUN",
    "PROPN"
  ],
  "serves": [
    "VERB"
  ],
  "greentick": [
    "NOUN"
  ],
  "activated": [
    "VERB"
  ],
  "revpro": [
    "PROPN"
  ],
  "gained": [
    "VERB"
  ],
  "purchases": [
    "NOUN",
    "PROPN"
  ],
  "knows": [
    "VERB"
  ],
  "workload": [
    "NOUN",
    "PROPN"
  ],
  "departments": [
    "NOUN"
  ],
  "aligning": [
    "VERB"
  ],
  "namespaces": [
    "VERB",
    "NOUN"
  ],
  "guiding": [
    "VERB"
  ],
  "unblock": [
    "VERB",
    "PROPN"
  ],
  "orchestrator": [
    "NOUN",
    "PROPN"
  ],
  "began": [
    "VERB"
  ],
  "children": [
    "NOUN"
  ],
  "redash": [
    "PROPN",
    "NOUN"
  ],
  "descriptions": [
    "NOUN",
    "PROPN"
  ],
  "focuses": [
    "VERB"
  ],
  "tailored": [
    "VERB",
    "ADJ"
  ],
  "purchasing": [
    "VERB",
    "NOUN"
  ],
  "violated": [
    "VERB"
  ],
  "orphaned": [
    "VERB"
  ],
  "maven": [
    "PROPN",
    "VERB"
  ],
  "walkthrough": [
    "NOUN",
    "PROPN"
  ],
  "slides": [
    "NOUN",
    "PROPN"
  ],
  "codes": [
    "NOUN",
    "PROPN"
  ],
  "invites": [
    "VERB",
    "PROPN"
  ],
  "quoting": [
    "VERB",
    "PROPN"
  ],
  "heard": [
    "VERB"
  ],
  "workstream": [
    "NOUN",
    "PROPN"
  ],
  "programming": [
    "NOUN",
    "PROPN"
  ],
  "appearing": [
    "VERB"
  ],
  "offsite": [
    "PROPN",
    "ADJ"
  ],
  "proforma": [
    "PROPN"
  ],
  "positioning": [
    "NOUN",
    "VERB"
  ],
  "touchpoints": [
    "NOUN"
  ],
  "administrators": [
    "NOUN",
    "PROPN"
  ],
  "fewer": [
    "ADJ"
  ],
  "sexual": [
    "ADJ"
  ],
  "invited": [
    "VERB"
  ],
  "organisations": [
    "NOUN"
  ],
  "xpsearch": [
    "NOUN"
  ],
  "contractors": [
    "NOUN"
  ],
  "titles": [
    "NOUN",
    "PROPN"
  ],
  "statements": [
    "NOUN"
  ],
  "directories": [
    "NOUN"
  ],
  "attempts": [
    "NOUN",
    "VERB"
  ],
  "popup": [
    "NOUN",
    "PROPN"
  ],
  "strengths": [
    "NOUN",
    "PROPN"
  ],
  "escalated": [
    "VERB"
  ],
  "brings": [
    "VERB"
  ],
  "penetration": [
    "NOUN",
    "PROPN"
  ],
  "placed": [
    "VERB"
  ],
  "drives": [
    "VERB",
    "NOUN"
  ],
  "conflicts": [
    "NOUN"
  ],
  "discussing": [
    "VERB"
  ],
  "nebulae": [
    "PROPN",
    "ADJ"
  ],
  "zones": [
    "NOUN",
    "PROPN"
  ],
  "continuing": [
    "VERB"
  ],
  "affects": [
    "VERB"
  ],
  "trainings": [
    "NOUN",
    "PROPN"
  ],
  "aimed": [
    "VERB"
  ],
  "completes": [
    "VERB",
    "NOUN"
  ],
  "investigated": [
    "VERB"
  ],
  "functionalities": [
    "NOUN"
  ],
  "onsite": [
    "ADJ",
    "PROPN"
  ],
  "understands": [
    "VERB"
  ],
  "upgraded": [
    "VERB"
  ],
  "patches": [
    "NOUN"
  ],
  "anticipated": [
    "VERB",
    "ADJ"
  ],
  "nginx": [
    "PROPN",
    "NOUN"
  ],
  "deadlines": [
    "NOUN",
    "PROPN"
  ],
  "submitting": [
    "VERB"
  ],
  "avatar": [
    "NOUN",
    "PROPN"
  ],
  "layers": [
    "NOUN"
  ],
  "scheduler": [
    "NOUN",
    "PROPN"
  ],
  "airflow": [
    "PROPN",
    "NOUN"
  ],
  "collaborating": [
    "VERB"
  ],
  "centre": [
    "PROPN",
    "NOUN"
  ],
  "collects": [
    "VERB"
  ],
  "establishing": [
    "VERB"
  ],
  "oncall": [
    "NOUN",
    "PROPN"
  ],
  "hires": [
    "NOUN"
  ],
  "retrieved": [
    "VERB"
  ],
  "spreadsheet": [
    "NOUN",
    "PROPN"
  ],
  "prioritizing": [
    "VERB",
    "PROPN"
  ],
  "passwords": [
    "NOUN",
    "PROPN"
  ],
  "expecting": [
    "VERB"
  ],
  "utilise": [
    "VERB"
  ],
  "contained": [
    "VERB"
  ],
  "backlogs": [
    "NOUN"
  ],
  "blocks": [
    "NOUN",
    "VERB"
  ],
  "startup": [
    "NOUN",
    "PROPN"
  ],
  "likes": [
    "VERB",
    "NOUN"
  ],
  "snapshots": [
    "NOUN"
  ],
  "schedules": [
    "NOUN",
    "PROPN"
  ],
  "actioning": [
    "VERB"
  ],
  "outages": [
    "NOUN"
  ],
  "analyzed": [
    "VERB"
  ],
  "signing": [
    "VERB",
    "NOUN"
  ],
  "claims": [
    "NOUN",
    "PROPN"
  ],
  "basics": [
    "NOUN",
    "PROPN"
  ],
  "terraform": [
    "NOUN",
    "PROPN"
  ],
  "defines": [
    "VERB"
  ],
  "summaries": [
    "NOUN",
    "PROPN"
  ],
  "coordinate": [
    "VERB",
    "PROPN"
  ],
  "earlier": [
    "ADJ"
  ],
  "placeholder": [
    "NOUN",
    "PROPN"
  ],
  "keeps": [
    "VERB"
  ],
  "validates": [
    "VERB"
  ],
  "prioritized": [
    "VERB",
    "ADJ"
  ],
  "communicated": [
    "VERB"
  ],
  "triaging": [
    "NOUN",
    "VERB"
  ],
  "allocated": [
    "VERB"
  ],
  "navigating": [
    "VERB"
  ],
  "deletes": [
    "VERB",
    "NOUN"
  ],
  "projected": [
    "VERB",
    "PROPN"
  ],
  "aggregated": [
    "VERB",
    "ADJ"
  ],
  "coordinating": [
    "VERB"
  ],
  "wider": [
    "ADJ"
  ],
  "ubuntu": [
    "PROPN"
  ],
  "atlaskit": [
    "PROPN",
    "ADJ"
  ],
  "launching": [
    "VERB"
  ],
  "iphone": [
    "PROPN"
  ],
  "connectors": [
    "NOUN",
    "PROPN"
  ],
  "represented": [
    "VERB"
  ],
  "games": [
    "NOUN",
    "PROPN"
  ],
  "indicated": [
    "VERB"
  ],
  "responding": [
    "VERB"
  ],
  "postgresql": [
    "NOUN",
    "PROPN"
  ],
  "camunda": [
    "PROPN"
  ],
  "threats": [
    "NOUN",
    "PROPN"
  ],
  "protocols": [
    "NOUN"
  ],
  "macos": [
    "PROPN",
    "NOUN"
  ],
  "promotions": [
    "NOUN",
    "PROPN"
  ],
  "opensearch": [
    "PROPN"
  ],
  "languages": [
    "NOUN"
  ],
  "countries": [
    "NOUN"
  ],
  "competencies": [
    "NOUN",
    "PROPN"
  ],
  "apsouth": [
    "NOUN",
    "PROPN"
  ],
  "monorepo": [
    "NOUN",
    "PROPN"
  ],
  "copies": [
    "NOUN"
  ],
  "vnext": [
    "PROPN",
    "NOUN"
  ],
  "dropbox": [
    "PROPN"
  ],
  "certifications": [
    "NOUN",
    "PROPN"
  ],
  "mitigations": [
    "NOUN",
    "PROPN"
  ],
  "lucene": [
    "PROPN"
  ],
  "youtube": [
    "PROPN",
    "NOUN"
  ],
  "attending": [
    "VERB"
  ],
  "prioritisation": [
    "NOUN",
    "PROPN"
  ],
  "callouts": [
    "PROPN",
    "NOUN"
  ],
  "calculations": [
    "NOUN",
    "PROPN"
  ],
  "showed": [
    "VERB"
  ],
  "drills": [
    "NOUN"
  ],
  "routes": [
    "NOUN",
    "VERB"
  ],
  "situations": [
    "NOUN"
  ],
  "brainstorm": [
    "NOUN",
    "PROPN"
  ],
  "reminders": [
    "NOUN",
    "PROPN"
  ],
  "dogfooding": [
    "VERB",
    "PROPN"
  ],
  "exempted": [
    "VERB",
    "PROPN"
  ],
  "discrepancies": [
    "NOUN"
  ],
  "businesses": [
    "NOUN"
  ],
  "hitting": [
    "VERB"
  ],
  "bottlenecks": [
    "NOUN"
  ],
  "resourcing": [
    "VERB",
    "NOUN"
  ],
  "experiencing": [
    "VERB"
  ],
  "allowlist": [
    "NOUN",
    "VERB"
  ],
  "personalized": [
    "ADJ",
    "VERB"
  ],
  "preparing": [
    "VERB"
  ],
  "audiences": [
    "NOUN"
  ],
  "alternatives": [
    "NOUN",
    "PROPN"
  ],
  "dunning": [
    "ADJ"
  ],
  "scoping": [
    "VERB",
    "PROPN"
  ],
  "generates": [
    "VERB"
  ],
  "engagements": [
    "NOUN",
    "PROPN"
  ],
  "capturing": [
    "VERB",
    "NOUN"
  ],
  "embedding": [
    "VERB"
  ],
  "computed": [
    "VERB"
  ],
  "debrief": [
    "PROPN",
    "NOUN"
  ],
  "anomalies": [
    "NOUN"
  ],
  "pulling": [
    "VERB"
  ],
  "readers": [
    "NOUN"
  ],
  "matters": [
    "VERB",
    "NOUN"
  ],
  "paged": [
    "VERB"
  ],
  "relations": [
    "NOUN",
    "PROPN"
  ],
  "delivers": [
    "VERB"
  ],
  "evolved": [
    "VERB"
  ],
  "exported": [
    "VERB"
  ],
  "icons": [
    "NOUN"
  ],
  "prioritised": [
    "VERB"
  ],
  "executives": [
    "NOUN",
    "PROPN"
  ],
  "sourced": [
    "VERB",
    "ADJ"
  ],
  "assesses": [
    "VERB"
  ],
  "suited": [
    "VERB",
    "ADJ"
  ],
  "observations": [
    "NOUN",
    "PROPN"
  ],
  "sandboxes": [
    "NOUN",
    "PROPN"
  ],
  "relates": [
    "VERB"
  ],
  "collaborators": [
    "NOUN"
  ],
  "regulations": [
    "NOUN"
  ],
  "expenses": [
    "NOUN"
  ],
  "invitations": [
    "NOUN"
  ],
  "promoted": [
    "VERB"
  ],
  "iterations": [
    "NOUN",
    "PROPN"
  ],
  "launches": [
    "NOUN",
    "PROPN"
  ],
  "validator": [
    "NOUN",
    "PROPN"
  ],
  "implementations": [
    "NOUN"
  ],
  "obligations": [
    "NOUN"
  ],
  "relating": [
    "VERB"
  ],
  "dataset": [
    "NOUN",
    "PROPN"
  ],
  "creators": [
    "NOUN",
    "PROPN"
  ],
  "samples": [
    "NOUN"
  ],
  "silos": [
    "NOUN",
    "PROPN"
  ],
  "reflects": [
    "VERB"
  ],
  "categorised": [
    "VERB"
  ],
  "investigations": [
    "NOUN"
  ],
  "addon": [
    "PROPN"
  ],
  "explorations": [
    "NOUN",
    "PROPN"
  ],
  "playing": [
    "VERB"
  ],
  "accenture": [
    "PROPN"
  ],
  "orgid": [
    "PROPN",
    "NOUN"
  ],
  "carahsoft": [
    "PROPN"
  ],
  "keywords": [
    "NOUN",
    "PROPN"
  ],
  "toolkit": [
    "NOUN",
    "PROPN"
  ],
  "visitors": [
    "NOUN"
  ],
  "downloaded": [
    "VERB"
  ],
  "grants": [
    "NOUN",
    "VERB"
  ],
  "ranking": [
    "VERB",
    "NOUN"
  ],
  "displaying": [
    "VERB"
  ],
  "duplicated": [
    "VERB"
  ],
  "modifications": [
    "NOUN"
  ],
  "skipped": [
    "VERB"
  ],
  "twitter": [
    "PROPN",
    "NOUN"
  ],
  "subnet": [
    "NOUN",
    "PROPN"
  ],
  "breaks": [
    "NOUN",
    "VERB"
  ],
  "contributed": [
    "VERB"
  ],
  "collections": [
    "NOUN",
    "PROPN"
  ],
  "patched": [
    "VERB"
  ],
  "moments": [
    "NOUN",
    "PROPN"
  ],
  "remained": [
    "VERB"
  ],
  "hipchat": [
    "PROPN"
  ],
  "ordering": [
    "VERB",
    "NOUN"
  ],
  "women": [
    "NOUN",
    "PROPN"
  ],
  "aiops": [
    "PROPN"
  ],
  "comparing": [
    "VERB"
  ],
  "thousands": [
    "NOUN"
  ],
  "dimensions": [
    "NOUN"
  ],
  "cleaned": [
    "VERB"
  ],
  "overrides": [
    "NOUN",
    "VERB"
  ],
  "hostname": [
    "NOUN",
    "PROPN"
  ],
  "benchmark": [
    "NOUN",
    "PROPN"
  ],
  "revisions": [
    "NOUN",
    "PROPN"
  ],
  "edits": [
    "NOUN",
    "VERB"
  ],
  "copying": [
    "VERB",
    "NOUN"
  ],
  "refreshed": [
    "VERB"
  ],
  "lookup": [
    "NOUN",
    "PROPN"
  ],
  "analysts": [
    "NOUN"
  ],
  "ironclad": [
    "PROPN"
  ],
  "bangalore": [
    "PROPN"
  ],
  "announced": [
    "VERB"
  ],
  "recordings": [
    "NOUN",
    "PROPN"
  ],
  "bundles": [
    "NOUN"
  ],
  "guardrails": [
    "NOUN",
    "PROPN"
  ],
  "sheets": [
    "NOUN",
    "PROPN"
  ],
  "validating": [
    "VERB"
  ],
  "detecting": [
    "VERB"
  ],
  "xxxxx": [
    "NOUN",
    "PROPN"
  ],
  "sourcing": [
    "VERB",
    "PROPN"
  ],
  "customized": [
    "VERB",
    "ADJ"
  ],
  "investing": [
    "VERB"
  ],
  "coupa": [
    "PROPN"
  ],
  "served": [
    "VERB"
  ],
  "optimizing": [
    "VERB"
  ],
  "redeployments": [
    "NOUN"
  ],
  "demonstrated": [
    "VERB"
  ],
  "params": [
    "NOUN",
    "PROPN"
  ],
  "intellij": [
    "PROPN"
  ],
  "redeployment": [
    "NOUN"
  ],
  "optimized": [
    "VERB"
  ],
  "evaluations": [
    "NOUN"
  ],
  "milliseconds": [
    "NOUN"
  ],
  "finalized": [
    "VERB"
  ],
  "eventtype": [
    "ADJ",
    "NOUN"
  ],
  "refers": [
    "VERB"
  ],
  "routed": [
    "VERB"
  ],
  "relies": [
    "VERB"
  ],
  "discoverability": [
    "NOUN"
  ],
  "explained": [
    "VERB"
  ],
  "slated": [
    "VERB"
  ],
  "modes": [
    "NOUN",
    "PROPN"
  ],
  "mindset": [
    "NOUN",
    "PROPN"
  ],
  "consequences": [
    "NOUN"
  ],
  "shifted": [
    "VERB"
  ],
  "tesseract": [
    "ADJ",
    "PROPN"
  ],
  "partitions": [
    "NOUN"
  ],
  "talks": [
    "NOUN",
    "PROPN"
  ],
  "bundling": [
    "VERB",
    "NOUN"
  ],
  "france": [
    "PROPN"
  ],
  "sorting": [
    "VERB",
    "PROPN"
  ],
  "warns": [
    "VERB"
  ],
  "guardrail": [
    "NOUN",
    "PROPN"
  ],
  "msteams": [
    "NOUN",
    "PROPN"
  ],
  "untagged": [
    "ADJ"
  ],
  "utils": [
    "NOUN"
  ],
  "explains": [
    "VERB"
  ],
  "slower": [
    "ADJ"
  ],
  "hofund": [
    "PROPN",
    "NOUN"
  ],
  "buying": [
    "VERB",
    "NOUN"
  ],
  "hosts": [
    "NOUN"
  ],
  "phased": [
    "VERB",
    "PROPN"
  ],
  "webapp": [
    "NOUN"
  ],
  "backgrounds": [
    "NOUN",
    "PROPN"
  ],
  "utilized": [
    "VERB"
  ],
  "inbox": [
    "NOUN",
    "PROPN"
  ],
  "amounts": [
    "NOUN",
    "VERB"
  ],
  "transformations": [
    "NOUN",
    "PROPN"
  ],
  "synced": [
    "VERB"
  ],
  "widget": [
    "NOUN",
    "PROPN"
  ],
  "avatars": [
    "NOUN",
    "PROPN"
  ],
  "forrester": [
    "PROPN"
  ],
  "styles": [
    "NOUN"
  ],
  "troubleshoot": [
    "VERB",
    "NOUN"
  ],
  "studies": [
    "NOUN"
  ],
  "contexts": [
    "NOUN",
    "PROPN"
  ],
  "kicked": [
    "VERB"
  ],
  "headcount": [
    "NOUN",
    "PROPN"
  ],
  "relying": [
    "VERB"
  ],
  "folders": [
    "NOUN",
    "PROPN"
  ],
  "crossflow": [
    "NOUN",
    "PROPN"
  ],
  "demonstrates": [
    "VERB"
  ],
  "sharding": [
    "PROPN",
    "NOUN"
  ],
  "lowest": [
    "ADJ"
  ],
  "subtasks": [
    "NOUN"
  ],
  "blackline": [
    "PROPN"
  ],
  "flaws": [
    "NOUN",
    "PROPN"
  ],
  "laptop": [
    "NOUN",
    "PROPN"
  ],
  "stacks": [
    "NOUN",
    "PROPN"
  ],
  "defaults": [
    "NOUN"
  ],
  "premises": [
    "NOUN"
  ],
  "ideation": [
    "NOUN",
    "PROPN"
  ],
  "claimed": [
    "VERB"
  ],
  "exports": [
    "NOUN"
  ],
  "subproduct": [
    "NOUN"
  ],
  "circumstances": [
    "NOUN"
  ],
  "prices": [
    "NOUN"
  ],
  "inquiries": [
    "NOUN"
  ],
  "scrolling": [
    "VERB",
    "NOUN"
  ],
  "became": [
    "VERB"
  ],
  "budgets": [
    "NOUN",
    "PROPN"
  ],
  "representing": [
    "VERB"
  ],
  "bandwidth": [
    "ADJ",
    "NOUN"
  ],
  "germany": [
    "PROPN"
  ],
  "organise": [
    "VERB",
    "NOUN"
  ],
  "speakers": [
    "NOUN",
    "PROPN"
  ],
  "graphs": [
    "NOUN",
    "PROPN"
  ],
  "captures": [
    "VERB"
  ],
  "modelling": [
    "NOUN",
    "VERB"
  ],
  "congratulations": [
    "NOUN",
    "PROPN"
  ],
  "bundled": [
    "VERB",
    "PROPN"
  ],
  "authenticated": [
    "VERB",
    "ADJ"
  ],
  "formats": [
    "NOUN"
  ],
  "dummy": [
    "ADJ"
  ],
  "jplat": [
    "PROPN"
  ],
  "centers": [
    "NOUN",
    "PROPN"
  ],
  "resizing": [
    "NOUN"
  ],
  "assignments": [
    "NOUN"
  ],
  "paginated": [
    "ADJ",
    "VERB"
  ],
  "enforces": [
    "VERB",
    "NOUN"
  ],
  "attendee": [
    "PROPN",
    "NOUN"
  ],
  "holds": [
    "VERB"
  ],
  "junit": [
    "PROPN"
  ],
  "competing": [
    "VERB"
  ],
  "utilisation": [
    "NOUN"
  ],
  "cycles": [
    "NOUN"
  ],
  "facts": [
    "NOUN"
  ],
  "positives": [
    "NOUN"
  ],
  "supplied": [
    "VERB"
  ],
  "consists": [
    "VERB"
  ],
  "presenting": [
    "VERB"
  ],
  "attacks": [
    "NOUN"
  ],
  "datasets": [
    "NOUN"
  ],
  "microservice": [
    "NOUN",
    "PROPN"
  ],
  "exclusions": [
    "PROPN",
    "NOUN"
  ],
  "facebook": [
    "PROPN"
  ],
  "heimdall": [
    "PROPN"
  ],
  "arguments": [
    "NOUN"
  ],
  "boundaries": [
    "NOUN"
  ],
  "stronger": [
    "ADJ"
  ],
  "editable": [
    "ADJ",
    "PROPN"
  ],
  "releasing": [
    "VERB"
  ],
  "automating": [
    "VERB",
    "PROPN"
  ],
  "memberships": [
    "NOUN"
  ],
  "occurring": [
    "VERB"
  ],
  "monitored": [
    "VERB"
  ],
  "sustainability": [
    "NOUN",
    "PROPN"
  ],
  "cacentral": [
    "ADJ"
  ],
  "marketo": [
    "PROPN"
  ],
  "interfaces": [
    "NOUN"
  ],
  "authorisation": [
    "NOUN",
    "PROPN"
  ],
  "attempting": [
    "VERB"
  ],
  "cleared": [
    "VERB"
  ],
  "configurable": [
    "ADJ"
  ],
  "toolbar": [
    "NOUN"
  ],
  "expands": [
    "VERB",
    "NOUN"
  ],
  "begins": [
    "VERB"
  ],
  "extracting": [
    "VERB"
  ],
  "staying": [
    "VERB"
  ],
  "issued": [
    "VERB"
  ],
  "choices": [
    "NOUN"
  ],
  "responded": [
    "VERB"
  ],
  "cloudsec": [
    "NOUN",
    "PROPN"
  ],
  "convo": [
    "PROPN"
  ],
  "leveraged": [
    "VERB"
  ],
  "ignored": [
    "VERB"
  ],
  "gathered": [
    "VERB"
  ],
  "elapsed": [
    "VERB"
  ],
  "treated": [
    "VERB"
  ],
  "perspectives": [
    "NOUN"
  ],
  "checklists": [
    "NOUN",
    "PROPN"
  ],
  "advantages": [
    "NOUN"
  ],
  "websites": [
    "NOUN"
  ],
  "chunks": [
    "NOUN"
  ],
  "occurrences": [
    "NOUN"
  ],
  "redirected": [
    "VERB"
  ],
  "removes": [
    "VERB"
  ],
  "struggled": [
    "VERB"
  ],
  "rooms": [
    "NOUN"
  ],
  "amsterdam": [
    "PROPN"
  ],
  "cardinality": [
    "NOUN"
  ],
  "worklog": [
    "NOUN",
    "PROPN"
  ],
  "inconsistencies": [
    "NOUN"
  ],
  "breadcrumbs": [
    "NOUN"
  ],
  "changelog": [
    "NOUN",
    "PROPN"
  ],
  "assistants": [
    "NOUN",
    "PROPN"
  ],
  "kotlin": [
    "PROPN"
  ],
  "archiving": [
    "VERB",
    "NOUN"
  ],
  "decoupling": [
    "PROPN",
    "VERB"
  ],
  "recovering": [
    "VERB"
  ],
  "behaviors": [
    "NOUN"
  ],
  "iframe": [
    "ADJ",
    "NOUN"
  ],
  "throws": [
    "VERB"
  ],
  "visited": [
    "VERB"
  ],
  "holdout": [
    "NOUN",
    "PROPN"
  ],
  "firewall": [
    "NOUN",
    "PROPN"
  ],
  "xflow": [
    "PROPN",
    "NOUN"
  ],
  "utilizing": [
    "VERB"
  ],
  "actors": [
    "NOUN"
  ],
  "researchers": [
    "NOUN"
  ],
  "falls": [
    "VERB"
  ],
  "contributes": [
    "VERB"
  ],
  "entrances": [
    "NOUN"
  ],
  "timezones": [
    "NOUN"
  ],
  "icims": [
    "PROPN",
    "NOUN"
  ],
  "belongs": [
    "VERB"
  ],
  "duplicates": [
    "NOUN"
  ],
  "utilities": [
    "NOUN",
    "PROPN"
  ],
  "followup": [
    "NOUN",
    "PROPN"
  ],
  "analyzing": [
    "VERB"
  ],
  "proud": [
    "ADJ"
  ],
  "brainstorming": [
    "VERB",
    "NOUN"
  ],
  "traits": [
    "NOUN"
  ],
  "decreased": [
    "VERB"
  ],
  "visuals": [
    "NOUN",
    "PROPN"
  ],
  "reactivation": [
    "NOUN",
    "PROPN"
  ],
  "realtime": [
    "ADJ",
    "NOUN"
  ],
  "smartling": [
    "PROPN"
  ],
  "minimise": [
    "VERB"
  ],
  "customizations": [
    "NOUN"
  ],
  "downloading": [
    "VERB"
  ],
  "hooks": [
    "NOUN",
    "PROPN"
  ],
  "profiling": [
    "NOUN",
    "PROPN"
  ],
  "encouraged": [
    "VERB",
    "ADJ"
  ],
  "autogenerated": [
    "VERB"
  ],
  "participating": [
    "VERB"
  ],
  "defects": [
    "NOUN",
    "PROPN"
  ],
  "variations": [
    "NOUN"
  ],
  "sampled": [
    "VERB"
  ],
  "signs": [
    "NOUN",
    "VERB"
  ],
  "openai": [
    "PROPN"
  ],
  "changeboarding": [
    "VERB"
  ],
  "disabling": [
    "VERB"
  ],
  "passes": [
    "VERB",
    "NOUN"
  ],
  "variants": [
    "NOUN"
  ],
  "deviations": [
    "NOUN"
  ],
  "uptime": [
    "PROPN",
    "NOUN"
  ],
  "quicker": [
    "ADJ"
  ],
  "organisational": [
    "ADJ",
    "PROPN"
  ],
  "talked": [
    "VERB"
  ],
  "usages": [
    "NOUN"
  ],
  "restored": [
    "VERB"
  ],
  "varying": [
    "VERB"
  ],
  "interests": [
    "NOUN",
    "PROPN"
  ],
  "deemed": [
    "VERB"
  ],
  "replicas": [
    "PROPN",
    "NOUN"
  ],
  "tells": [
    "VERB"
  ],
  "detailing": [
    "VERB"
  ],
  "connects": [
    "VERB"
  ],
  "reindex": [
    "NOUN"
  ],
  "embeds": [
    "VERB",
    "NOUN"
  ],
  "versioning": [
    "NOUN",
    "VERB"
  ],
  "attended": [
    "VERB"
  ],
  "healthcare": [
    "NOUN",
    "PROPN"
  ],
  "watchers": [
    "NOUN",
    "PROPN"
  ],
  "assigning": [
    "VERB"
  ],
  "handoff": [
    "NOUN",
    "PROPN"
  ],
  "obtaining": [
    "VERB"
  ],
  "obtained": [
    "VERB"
  ],
  "occured": [
    "VERB"
  ],
  "recruiters": [
    "NOUN",
    "PROPN"
  ],
  "branding": [
    "NOUN",
    "PROPN"
  ],
  "humans": [
    "NOUN"
  ],
  "syncing": [
    "VERB",
    "PROPN"
  ],
  "boxes": [
    "NOUN"
  ],
  "specifics": [
    "NOUN"
  ],
  "describing": [
    "VERB"
  ],
  "questionnaires": [
    "NOUN"
  ],
  "addons": [
    "NOUN"
  ],
  "traceid": [
    "PROPN",
    "NOUN"
  ],
  "tries": [
    "VERB"
  ],
  "presentations": [
    "NOUN"
  ],
  "behaviours": [
    "NOUN"
  ],
  "determines": [
    "VERB"
  ],
  "cloudfront": [
    "PROPN"
  ],
  "perceived": [
    "VERB"
  ],
  "interviewing": [
    "VERB"
  ],
  "interacting": [
    "VERB"
  ],
  "devai": [
    "PROPN"
  ],
  "resumed": [
    "VERB"
  ],
  "pagerduty": [
    "PROPN"
  ],
  "annotations": [
    "NOUN"
  ],
  "invalidation": [
    "NOUN"
  ],
  "shortcuts": [
    "NOUN",
    "PROPN"
  ],
  "deploys": [
    "NOUN",
    "VERB"
  ],
  "transitioning": [
    "VERB",
    "NOUN"
  ],
  "modifying": [
    "VERB"
  ],
  "heads": [
    "NOUN"
  ],
  "evolves": [
    "NOUN",
    "VERB"
  ],
  "bytes": [
    "NOUN"
  ],
  "promoting": [
    "VERB"
  ],
  "recovered": [
    "VERB"
  ],
  "workstreams": [
    "NOUN",
    "VERB"
  ],
  "imported": [
    "VERB"
  ],
  "hoping": [
    "VERB"
  ],
  "warnings": [
    "NOUN"
  ],
  "refactor": [
    "NOUN",
    "PROPN"
  ],
  "performant": [
    "ADJ"
  ],
  "touchpoint": [
    "NOUN"
  ],
  "centralised": [
    "ADJ",
    "VERB"
  ],
  "standup": [
    "NOUN",
    "PROPN"
  ],
  "disruptions": [
    "NOUN"
  ],
  "detections": [
    "NOUN",
    "PROPN"
  ],
  "staffing": [
    "NOUN",
    "VERB"
  ],
  "reusable": [
    "ADJ"
  ],
  "presents": [
    "VERB"
  ],
  "refactoring": [
    "NOUN",
    "PROPN"
  ],
  "structures": [
    "NOUN"
  ],
  "referred": [
    "VERB"
  ],
  "oriented": [
    "VERB"
  ],
  "deprecate": [
    "VERB",
    "NOUN"
  ],
  "retrieving": [
    "VERB"
  ],
  "prevented": [
    "VERB"
  ],
  "documenting": [
    "VERB",
    "NOUN"
  ],
  "renders": [
    "VERB",
    "NOUN"
  ],
  "redirects": [
    "NOUN",
    "VERB"
  ],
  "singapore": [
    "PROPN"
  ],
  "recognized": [
    "VERB"
  ],
  "retries": [
    "NOUN"
  ],
  "sounds": [
    "VERB"
  ],
  "matched": [
    "VERB"
  ],
  "separated": [
    "VERB"
  ],
  "whitelist": [
    "NOUN",
    "PROPN"
  ],
  "payloads": [
    "NOUN"
  ],
  "exceeds": [
    "VERB"
  ],
  "surfaces": [
    "NOUN",
    "VERB"
  ],
  "gmail": [
    "PROPN",
    "NOUN"
  ],
  "crafted": [
    "VERB"
  ],
  "loops": [
    "NOUN"
  ],
  "solves": [
    "VERB"
  ],
  "importing": [
    "VERB"
  ],
  "books": [
    "NOUN"
  ],
  "execops": [
    "PROPN"
  ],
  "cannot": [
    "PROPN"
  ],
  "typing": [
    "VERB"
  ],
  "mitigating": [
    "VERB"
  ],
  "supplies": [
    "VERB"
  ],
  "snippets": [
    "NOUN"
  ],
  "demands": [
    "NOUN",
    "VERB"
  ],
  "attempted": [
    "VERB"
  ],
  "federated": [
    "VERB",
    "PROPN"
  ],
  "installations": [
    "NOUN"
  ],
  "consolidating": [
    "VERB"
  ],
  "stands": [
    "VERB"
  ],
  "synchrony": [
    "PROPN"
  ],
  "webinars": [
    "PROPN",
    "NOUN"
  ],
  "browsers": [
    "NOUN"
  ],
  "saves": [
    "VERB"
  ],
  "accountid": [
    "PROPN"
  ],
  "secured": [
    "VERB"
  ],
  "loved": [
    "VERB"
  ],
  "installing": [
    "VERB"
  ],
  "drafts": [
    "NOUN"
  ],
  "empowered": [
    "VERB"
  ],
  "expires": [
    "VERB"
  ],
  "dmarc": [
    "PROPN"
  ],
  "joins": [
    "VERB",
    "NOUN"
  ],
  "identifiers": [
    "NOUN"
  ],
  "compromised": [
    "VERB"
  ],
  "markdown": [
    "ADJ",
    "PROPN"
  ],
  "characteristics": [
    "NOUN"
  ],
  "filestore": [
    "NOUN"
  ],
  "pollinators": [
    "NOUN",
    "PROPN"
  ],
  "airtrack": [
    "PROPN"
  ],
  "playbooks": [
    "NOUN",
    "PROPN"
  ],
  "squads": [
    "NOUN"
  ],
  "differs": [
    "VERB"
  ],
  "prerequisites": [
    "NOUN",
    "PROPN"
  ],
  "applinks": [
    "PROPN",
    "NOUN"
  ],
  "arising": [
    "VERB"
  ],
  "cached": [
    "VERB"
  ],
  "lacks": [
    "VERB"
  ],
  "facilitating": [
    "VERB"
  ],
  "sponsored": [
    "VERB",
    "PROPN"
  ],
  "london": [
    "PROPN"
  ],
  "edges": [
    "NOUN"
  ],
  "intents": [
    "NOUN"
  ],
  "grows": [
    "VERB"
  ],
  "methodologies": [
    "NOUN"
  ],
  "exposing": [
    "VERB"
  ],
  "allowlisting": [
    "NOUN",
    "PROPN"
  ],
  "integrates": [
    "VERB",
    "NOUN"
  ],
  "concluded": [
    "VERB"
  ],
  "lacking": [
    "VERB"
  ],
  "lauren": [
    "PROPN"
  ],
  "descriptors": [
    "NOUN"
  ],
  "poland": [
    "PROPN"
  ],
  "seemed": [
    "VERB"
  ],
  "indexes": [
    "NOUN"
  ],
  "influenced": [
    "VERB"
  ],
  "charged": [
    "VERB"
  ],
  "referring": [
    "VERB"
  ],
  "middleware": [
    "NOUN",
    "PROPN"
  ],
  "execs": [
    "NOUN"
  ],
  "played": [
    "VERB"
  ],
  "overlapping": [
    "VERB"
  ],
  "operates": [
    "VERB"
  ],
  "caches": [
    "NOUN",
    "PROPN"
  ],
  "spork": [
    "PROPN",
    "NOUN"
  ],
  "healthchecks": [
    "NOUN"
  ],
  "cheers": [
    "PROPN",
    "NOUN"
  ],
  "duties": [
    "NOUN"
  ],
  "coded": [
    "VERB"
  ],
  "installs": [
    "NOUN",
    "VERB"
  ],
  "archetypes": [
    "NOUN"
  ],
  "facilities": [
    "NOUN",
    "PROPN"
  ],
  "zealand": [
    "PROPN"
  ],
  "adaptavist": [
    "PROPN"
  ],
  "players": [
    "NOUN",
    "PROPN"
  ],
  "directions": [
    "NOUN"
  ],
  "customizable": [
    "ADJ",
    "VERB"
  ],
  "prompted": [
    "VERB"
  ],
  "sharepoint": [
    "PROPN"
  ],
  "avoiding": [
    "VERB"
  ],
  "suppliers": [
    "NOUN"
  ],
  "uploading": [
    "VERB",
    "NOUN"
  ],
  "finalised": [
    "VERB"
  ],
  "visualisation": [
    "NOUN",
    "PROPN"
  ],
  "privileges": [
    "NOUN"
  ],
  "filed": [
    "VERB"
  ],
  "deloitte": [
    "PROPN"
  ],
  "nicole": [
    "PROPN"
  ],
  "grooming": [
    "VERB",
    "PROPN"
  ],
  "avalara": [
    "PROPN"
  ],
  "cameron": [
    "PROPN"
  ],
  "deciding": [
    "VERB"
  ],
  "migrators": [
    "NOUN"
  ],
  "overarching": [
    "VERB",
    "NOUN"
  ],
  "claiming": [
    "VERB"
  ],
  "restoring": [
    "VERB"
  ],
  "opted": [
    "VERB"
  ],
  "sharded": [
    "VERB",
    "PROPN"
  ],
  "apdex": [
    "PROPN"
  ],
  "datadog": [
    "PROPN"
  ],
  "adjusting": [
    "VERB"
  ],
  "prevents": [
    "VERB"
  ],
  "ranges": [
    "VERB",
    "NOUN"
  ],
  "sentences": [
    "NOUN"
  ],
  "recommends": [
    "VERB"
  ],
  "acquisitions": [
    "NOUN"
  ],
  "inserting": [
    "VERB"
  ],
  "corex": [
    "PROPN"
  ],
  "counted": [
    "VERB"
  ],
  "specialists": [
    "NOUN"
  ],
  "invested": [
    "VERB"
  ],
  "unknowns": [
    "NOUN"
  ],
  "approx": [
    "PROPN"
  ],
  "greatest": [
    "ADJ"
  ],
  "customise": [
    "NOUN",
    "VERB"
  ],
  "registrations": [
    "NOUN"
  ],
  "emojis": [
    "NOUN"
  ],
  "appeared": [
    "VERB"
  ],
  "interns": [
    "NOUN"
  ],
  "hundreds": [
    "NOUN"
  ],
  "configs": [
    "NOUN"
  ],
  "mistakes": [
    "NOUN"
  ],
  "progressing": [
    "VERB"
  ],
  "possibilities": [
    "NOUN"
  ],
  "innovations": [
    "NOUN"
  ],
  "issuetype": [
    "NOUN"
  ],
  "visits": [
    "NOUN",
    "VERB"
  ],
  "subtask": [
    "NOUN",
    "PROPN"
  ],
  "encoded": [
    "VERB"
  ],
  "standardised": [
    "ADJ",
    "VERB"
  ],
  "devprod": [
    "PROPN"
  ],
  "predefined": [
    "VERB"
  ],
  "brahmos": [
    "PROPN"
  ],
  "korea": [
    "PROPN"
  ],
  "realized": [
    "VERB"
  ],
  "selects": [
    "VERB",
    "NOUN"
  ],
  "shifts": [
    "NOUN"
  ],
  "syncs": [
    "NOUN"
  ],
  "billings": [
    "NOUN"
  ],
  "startups": [
    "NOUN"
  ],
  "spreadsheets": [
    "NOUN"
  ],
  "guided": [
    "VERB"
  ],
  "finds": [
    "VERB"
  ],
  "ireland": [
    "PROPN"
  ],
  "licences": [
    "NOUN"
  ],
  "unblocked": [
    "VERB",
    "ADJ"
  ],
  "weaknesses": [
    "NOUN",
    "PROPN"
  ],
  "photos": [
    "NOUN"
  ],
  "realities": [
    "NOUN"
  ],
  "handoffs": [
    "NOUN"
  ],
  "finalise": [
    "PROPN",
    "VERB"
  ],
  "guaranteed": [
    "VERB"
  ],
  "expects": [
    "VERB"
  ],
  "persons": [
    "NOUN"
  ],
  "optimised": [
    "VERB"
  ],
  "gainsight": [
    "PROPN"
  ],
  "ratings": [
    "NOUN"
  ],
  "suzie": [
    "PROPN"
  ],
  "operators": [
    "NOUN"
  ],
  "guests": [
    "NOUN"
  ],
  "motions": [
    "NOUN"
  ],
  "upfront": [
    "ADJ",
    "PROPN"
  ],
  "autoscaling": [
    "VERB",
    "NOUN"
  ],
  "amadeus": [
    "PROPN"
  ],
  "optimise": [
    "VERB",
    "ADJ"
  ],
  "abhorrent": [
    "ADJ",
    "PROPN"
  ],
  "minimizing": [
    "VERB"
  ],
  "architects": [
    "NOUN",
    "PROPN"
  ],
  "contacted": [
    "VERB"
  ],
  "contactr": [
    "PROPN"
  ],
  "restarts": [
    "NOUN"
  ],
  "americas": [
    "PROPN"
  ],
  "chats": [
    "NOUN"
  ],
  "salestech": [
    "PROPN"
  ],
  "completions": [
    "NOUN"
  ],
  "letting": [
    "VERB"
  ],
  "adminx": [
    "PROPN"
  ],
  "verifying": [
    "VERB",
    "NOUN"
  ],
  "complexities": [
    "NOUN"
  ],
  "bootcamp": [
    "PROPN",
    "NOUN"
  ],
  "netherlands": [
    "PROPN"
  ],
  "charges": [
    "NOUN"
  ],
  "acronyms": [
    "NOUN",
    "PROPN"
  ],
  "layouts": [
    "NOUN"
  ],
  "combo": [
    "NOUN"
  ],
  "offices": [
    "NOUN"
  ],
  "invoked": [
    "VERB"
  ],
  "rewards": [
    "NOUN",
    "PROPN"
  ],
  "mentioning": [
    "VERB"
  ],
  "proposes": [
    "VERB"
  ],
  "phishing": [
    "VERB"
  ],
  "nouns": [
    "NOUN",
    "PROPN"
  ],
  "aliases": [
    "NOUN",
    "PROPN"
  ],
  "quantified": [
    "VERB"
  ],
  "delegated": [
    "VERB",
    "PROPN"
  ],
  "lambdas": [
    "PROPN",
    "NOUN"
  ],
  "transitioned": [
    "VERB"
  ],
  "picking": [
    "VERB"
  ],
  "conventions": [
    "NOUN"
  ],
  "noting": [
    "VERB"
  ],
  "weights": [
    "NOUN"
  ],
  "reaches": [
    "VERB"
  ],
  "essentials": [
    "PROPN",
    "NOUN"
  ],
  "downgraded": [
    "VERB"
  ],
  "handlers": [
    "NOUN"
  ],
  "referencing": [
    "VERB"
  ],
  "combinations": [
    "NOUN"
  ],
  "prospects": [
    "NOUN"
  ],
  "entitlementid": [
    "PROPN"
  ],
  "certificates": [
    "NOUN"
  ],
  "coordinated": [
    "VERB",
    "ADJ"
  ],
  "tenable": [
    "ADJ"
  ],
  "drops": [
    "VERB",
    "NOUN"
  ],
  "grafana": [
    "PROPN"
  ],
  "mulesoft": [
    "PROPN"
  ],
  "varies": [
    "VERB",
    "NOUN"
  ],
  "testers": [
    "NOUN"
  ],
  "implements": [
    "VERB"
  ],
  "architectures": [
    "NOUN",
    "VERB"
  ],
  "stops": [
    "VERB",
    "NOUN"
  ],
  "decides": [
    "VERB"
  ],
  "demonstrating": [
    "VERB"
  ],
  "empowers": [
    "VERB",
    "NOUN"
  ],
  "buyers": [
    "NOUN"
  ],
  "pitfalls": [
    "NOUN"
  ],
  "audits": [
    "NOUN"
  ],
  "seeks": [
    "VERB"
  ],
  "resellers": [
    "NOUN"
  ],
  "enjoyed": [
    "VERB"
  ],
  "benchmarking": [
    "VERB",
    "NOUN"
  ],
  "reevaluate": [
    "VERB"
  ],
  "additions": [
    "NOUN"
  ],
  "meantime": [
    "NOUN"
  ],
  "professionals": [
    "NOUN"
  ],
  "leverages": [
    "VERB",
    "NOUN"
  ],
  "cpuutilization": [
    "PROPN"
  ],
  "compiled": [
    "VERB"
  ],
  "consulted": [
    "VERB"
  ],
  "partnering": [
    "NOUN",
    "VERB"
  ],
  "assumes": [
    "VERB"
  ],
  "samsung": [
    "PROPN"
  ],
  "tecton": [
    "PROPN"
  ],
  "algorithms": [
    "NOUN"
  ],
  "recommending": [
    "VERB"
  ],
  "suites": [
    "NOUN"
  ],
  "perks": [
    "PROPN",
    "NOUN"
  ],
  "publishes": [
    "VERB"
  ],
  "subnets": [
    "NOUN"
  ],
  "aditya": [
    "PROPN"
  ],
  "renewed": [
    "VERB"
  ],
  "extends": [
    "VERB"
  ],
  "committing": [
    "VERB"
  ],
  "datacenter": [
    "PROPN",
    "NOUN"
  ],
  "unblocking": [
    "VERB",
    "ADJ"
  ],
  "scanned": [
    "VERB"
  ],
  "minimized": [
    "VERB"
  ],
  "atlasdesk": [
    "PROPN"
  ],
  "motivated": [
    "VERB",
    "ADJ"
  ],
  "ansible": [
    "PROPN",
    "ADJ"
  ],
  "artefacts": [
    "NOUN"
  ],
  "resolutions": [
    "NOUN"
  ],
  "specifying": [
    "VERB"
  ],
  "portfolios": [
    "NOUN"
  ],
  "ashley": [
    "PROPN"
  ],
  "deepcheck": [
    "PROPN",
    "NOUN"
  ],
  "students": [
    "NOUN"
  ],
  "packets": [
    "NOUN"
  ],
  "introduces": [
    "VERB"
  ],
  "readme": [
    "PROPN",
    "NOUN"
  ],
  "rocks": [
    "NOUN",
    "PROPN"
  ],
  "transformers": [
    "NOUN"
  ],
  "sysadmin": [
    "PROPN"
  ],
  "redacted": [
    "VERB"
  ],
  "transfers": [
    "NOUN"
  ],
  "idaptive": [
    "ADJ",
    "PROPN"
  ],
  "equipping": [
    "VERB"
  ],
  "unfurl": [
    "ADJ"
  ],
  "labelled": [
    "VERB"
  ],
  "appreciated": [
    "VERB"
  ],
  "benchmarks": [
    "NOUN"
  ],
  "zendesk": [
    "PROPN"
  ],
  "ingested": [
    "VERB"
  ],
  "createdat": [
    "PROPN"
  ],
  "cprime": [
    "PROPN"
  ],
  "accepts": [
    "VERB"
  ],
  "margins": [
    "NOUN"
  ],
  "responds": [
    "VERB"
  ],
  "exposures": [
    "NOUN"
  ],
  "realised": [
    "VERB"
  ],
  "holders": [
    "NOUN"
  ],
  "portals": [
    "NOUN",
    "VERB"
  ],
  "accelerating": [
    "VERB"
  ],
  "obstacles": [
    "NOUN"
  ],
  "devloop": [
    "PROPN",
    "NOUN"
  ],
  "mentoring": [
    "VERB",
    "PROPN"
  ],
  "liked": [
    "VERB"
  ],
  "exporting": [
    "VERB"
  ],
  "participated": [
    "VERB"
  ],
  "deletions": [
    "NOUN"
  ],
  "mentors": [
    "NOUN"
  ],
  "rotations": [
    "NOUN"
  ],
  "influencer": [
    "PROPN",
    "NOUN"
  ],
  "selectors": [
    "NOUN"
  ],
  "commented": [
    "VERB"
  ],
  "maintains": [
    "VERB"
  ],
  "preflight": [
    "ADJ"
  ],
  "fintech": [
    "PROPN"
  ],
  "enforcing": [
    "VERB"
  ],
  "negotiations": [
    "NOUN"
  ],
  "throttling": [
    "NOUN",
    "VERB"
  ],
  "blameless": [
    "PROPN"
  ],
  "autodev": [
    "PROPN"
  ],
  "acknowledgment": [
    "NOUN"
  ],
  "itops": [
    "PROPN"
  ],
  "hotfix": [
    "NOUN",
    "PROPN"
  ],
  "pairing": [
    "VERB",
    "NOUN"
  ],
  "workloads": [
    "NOUN"
  ],
  "shortcut": [
    "NOUN",
    "VERB"
  ],
  "tricks": [
    "NOUN",
    "PROPN"
  ],
  "queried": [
    "VERB"
  ],
  "producing": [
    "VERB"
  ],
  "interfacing": [
    "VERB"
  ],
  "closest": [
    "ADJ"
  ],
  "takeaway": [
    "PROPN",
    "NOUN"
  ],
  "representatives": [
    "NOUN"
  ],
  "emitted": [
    "VERB"
  ],
  "cells": [
    "NOUN"
  ],
  "chatops": [
    "PROPN"
  ],
  "overlaps": [
    "NOUN",
    "VERB"
  ],
  "modals": [
    "NOUN"
  ],
  "streamlining": [
    "VERB"
  ],
  "cyber": [
    "NOUN",
    "PROPN"
  ],
  "quotas": [
    "NOUN"
  ],
  "pools": [
    "NOUN"
  ],
  "preempt": [
    "VERB"
  ],
  "repeating": [
    "VERB"
  ],
  "houses": [
    "VERB"
  ],
  "desks": [
    "NOUN"
  ],
  "slowing": [
    "VERB"
  ],
  "newlassian": [
    "PROPN"
  ],
  "vegas": [
    "PROPN"
  ],
  "empanada": [
    "PROPN"
  ],
  "associations": [
    "NOUN"
  ],
  "accepting": [
    "VERB"
  ],
  "favourite": [
    "ADJ"
  ],
  "haves": [
    "NOUN"
  ],
  "accounted": [
    "VERB"
  ],
  "lightbulb": [
    "NOUN"
  ],
  "clarifying": [
    "VERB"
  ],
  "cybersecurity": [
    "NOUN",
    "PROPN"
  ],
  "tradeoffs": [
    "NOUN"
  ],
  "quickstart": [
    "PROPN"
  ],
  "requestid": [
    "PROPN"
  ],
  "aggregates": [
    "VERB",
    "NOUN"
  ],
  "secondment": [
    "NOUN"
  ],
  "figuring": [
    "VERB"
  ],
  "incorporating": [
    "VERB"
  ],
  "communities": [
    "NOUN"
  ],
  "togetherness": [
    "PROPN",
    "NOUN"
  ],
  "considers": [
    "VERB"
  ],
  "drafted": [
    "VERB"
  ],
  "volunteering": [
    "NOUN",
    "VERB"
  ],
  "informing": [
    "VERB"
  ],
  "lands": [
    "NOUN",
    "VERB"
  ],
  "saiyans": [
    "PROPN"
  ],
  "announcing": [
    "VERB"
  ],
  "reused": [
    "VERB"
  ],
  "rollbacks": [
    "NOUN"
  ],
  "ports": [
    "NOUN"
  ],
  "congrats": [
    "PROPN",
    "NOUN"
  ],
  "pursuing": [
    "VERB"
  ],
  "hardcoded": [
    "VERB"
  ],
  "portions": [
    "NOUN"
  ],
  "sectors": [
    "NOUN"
  ],
  "paging": [
    "VERB"
  ],
  "primitives": [
    "NOUN",
    "PROPN"
  ],
  "optimizations": [
    "NOUN"
  ],
  "tokyo": [
    "PROPN"
  ],
  "callout": [
    "NOUN"
  ],
  "scanners": [
    "NOUN"
  ],
  "remarks": [
    "PROPN",
    "NOUN"
  ],
  "lozenge": [
    "PROPN",
    "NOUN"
  ],
  "introductions": [
    "PROPN",
    "NOUN"
  ],
  "jenkins": [
    "PROPN"
  ],
  "makeup": [
    "NOUN"
  ],
  "functioning": [
    "VERB"
  ],
  "sagemaker": [
    "PROPN"
  ],
  "illustrations": [
    "NOUN"
  ],
  "scriptrunner": [
    "PROPN"
  ],
  "renaming": [
    "VERB"
  ],
  "opinions": [
    "NOUN"
  ],
  "cascading": [
    "VERB"
  ],
  "playasateam": [
    "NOUN"
  ],
  "swimlane": [
    "ADJ",
    "PROPN"
  ],
  "uploads": [
    "NOUN",
    "VERB"
  ],
  "quantifying": [
    "VERB"
  ],
  "greetings": [
    "PROPN"
  ],
  "kumar": [
    "PROPN"
  ],
  "parents": [
    "NOUN"
  ],
  "translated": [
    "VERB"
  ],
  "accesses": [
    "NOUN",
    "VERB"
  ],
  "workarounds": [
    "NOUN"
  ],
  "measurements": [
    "NOUN"
  ],
  "curated": [
    "VERB"
  ],
  "founders": [
    "NOUN",
    "PROPN"
  ],
  "uipath": [
    "PROPN"
  ],
  "succeeded": [
    "VERB"
  ],
  "refunds": [
    "NOUN"
  ],
  "utilised": [
    "VERB"
  ],
  "seekers": [
    "NOUN"
  ],
  "inefficiencies": [
    "NOUN"
  ],
  "fetches": [
    "VERB"
  ],
  "roadblocks": [
    "NOUN"
  ],
  "directors": [
    "NOUN",
    "PROPN"
  ],
  "spotify": [
    "VERB",
    "PROPN"
  ],
  "terminated": [
    "VERB"
  ],
  "labeled": [
    "VERB"
  ],
  "caveats": [
    "NOUN",
    "PROPN"
  ],
  "conversions": [
    "NOUN"
  ],
  "canceled": [
    "VERB"
  ],
  "intros": [
    "PROPN",
    "NOUN"
  ],
  "licence": [
    "NOUN"
  ],
  "pushes": [
    "VERB",
    "NOUN"
  ],
  "manufacturing": [
    "NOUN"
  ],
  "delegates": [
    "NOUN"
  ],
  "parsing": [
    "VERB"
  ],
  "respondents": [
    "NOUN"
  ],
  "excludes": [
    "NOUN",
    "VERB"
  ],
  "influencing": [
    "VERB"
  ],
  "communicates": [
    "VERB",
    "NOUN"
  ],
  "allocations": [
    "NOUN"
  ],
  "evaluators": [
    "NOUN"
  ],
  "memcached": [
    "PROPN",
    "VERB"
  ],
  "crafting": [
    "VERB"
  ],
  "weekends": [
    "NOUN"
  ],
  "exercises": [
    "NOUN"
  ],
  "spiking": [
    "VERB"
  ],
  "tradeoff": [
    "NOUN"
  ],
  "pictures": [
    "NOUN"
  ],
  "denied": [
    "VERB"
  ],
  "proposing": [
    "VERB"
  ],
  "classifications": [
    "NOUN"
  ],
  "datapoints": [
    "NOUN"
  ],
  "revoked": [
    "VERB"
  ],
  "dovetail": [
    "PROPN"
  ],
  "devtools": [
    "PROPN",
    "NOUN"
  ],
  "processors": [
    "NOUN"
  ],
  "gradle": [
    "NOUN",
    "PROPN"
  ],
  "retained": [
    "VERB"
  ],
  "summarise": [
    "VERB"
  ],
  "confirms": [
    "VERB"
  ],
  "instenv": [
    "PROPN"
  ],
  "outlining": [
    "VERB"
  ],
  "frankfurt": [
    "PROPN"
  ],
  "swagger": [
    "PROPN",
    "NOUN"
  ],
  "impressions": [
    "NOUN"
  ],
  "transformed": [
    "VERB"
  ],
  "productkey": [
    "ADJ"
  ],
  "onprem": [
    "PROPN"
  ],
  "consultants": [
    "NOUN"
  ],
  "canva": [
    "PROPN"
  ],
  "looker": [
    "PROPN"
  ],
  "symptoms": [
    "NOUN"
  ],
  "interacted": [
    "VERB"
  ],
  "faces": [
    "VERB",
    "NOUN"
  ],
  "buildeng": [
    "PROPN"
  ],
  "achievements": [
    "NOUN"
  ],
  "searched": [
    "VERB"
  ],
  "synchronisation": [
    "NOUN"
  ],
  "movements": [
    "NOUN"
  ],
  "smartlinks": [
    "PROPN",
    "NOUN"
  ],
  "controllers": [
    "NOUN"
  ],
  "headings": [
    "NOUN"
  ],
  "locks": [
    "NOUN"
  ],
  "forwarded": [
    "VERB"
  ],
  "martech": [
    "PROPN"
  ],
  "disha": [
    "PROPN"
  ],
  "listens": [
    "VERB"
  ],
  "sourcetree": [
    "PROPN"
  ],
  "tintin": [
    "PROPN"
  ],
  "budgeting": [
    "NOUN"
  ],
  "exiting": [
    "VERB"
  ],
  "narrowing": [
    "PROPN",
    "VERB"
  ],
  "implies": [
    "VERB"
  ],
  "sponsors": [
    "NOUN"
  ],
  "pairs": [
    "NOUN"
  ],
  "docusign": [
    "PROPN"
  ],
  "pulls": [
    "VERB"
  ],
  "customfield": [
    "PROPN",
    "NOUN"
  ],
  "codebases": [
    "NOUN"
  ],
  "investors": [
    "NOUN"
  ],
  "restarted": [
    "VERB"
  ],
  "sellers": [
    "NOUN"
  ],
  "phrases": [
    "NOUN"
  ],
  "ratios": [
    "NOUN"
  ],
  "traces": [
    "NOUN"
  ],
  "focussed": [
    "VERB"
  ],
  "notifying": [
    "VERB"
  ],
  "chances": [
    "NOUN"
  ],
  "dollars": [
    "NOUN"
  ],
  "hallucinations": [
    "NOUN"
  ],
  "covid": [
    "PROPN",
    "ADJ"
  ],
  "customisation": [
    "NOUN"
  ],
  "macquarie": [
    "PROPN"
  ],
  "incentives": [
    "NOUN"
  ],
  "utilizes": [
    "VERB"
  ],
  "prioritising": [
    "VERB"
  ],
  "realise": [
    "VERB"
  ],
  "destinations": [
    "NOUN"
  ],
  "newest": [
    "ADJ"
  ],
  "assisted": [
    "VERB"
  ],
  "forces": [
    "NOUN",
    "VERB"
  ],
  "adapting": [
    "VERB"
  ],
  "conclusions": [
    "NOUN",
    "PROPN"
  ],
  "encompasses": [
    "VERB"
  ],
  "champs": [
    "NOUN"
  ],
  "letters": [
    "NOUN"
  ],
  "promo": [
    "ADJ",
    "PROPN"
  ],
  "gordian": [
    "PROPN"
  ],
  "johnson": [
    "PROPN"
  ],
  "thinks": [
    "VERB"
  ],
  "fires": [
    "NOUN",
    "VERB"
  ],
  "subsidiaries": [
    "NOUN"
  ],
  "principals": [
    "NOUN"
  ],
  "anaplan": [
    "PROPN"
  ],
  "bounces": [
    "NOUN"
  ],
  "pronouns": [
    "NOUN"
  ],
  "devex": [
    "PROPN"
  ],
  "detects": [
    "VERB",
    "NOUN"
  ],
  "powers": [
    "NOUN",
    "VERB"
  ],
  "siloed": [
    "VERB"
  ],
  "proposals": [
    "NOUN"
  ],
  "grads": [
    "NOUN"
  ],
  "empowering": [
    "VERB"
  ],
  "standardisation": [
    "NOUN"
  ],
  "roundtable": [
    "ADJ",
    "PROPN"
  ],
  "activationid": [
    "NOUN"
  ],
  "netflix": [
    "PROPN"
  ],
  "commenting": [
    "VERB"
  ],
  "efficiencies": [
    "NOUN"
  ],
  "frustrating": [
    "ADJ"
  ],
  "specifications": [
    "NOUN"
  ],
  "entityid": [
    "PROPN"
  ],
  "clickup": [
    "PROPN",
    "ADJ"
  ],
  "recipes": [
    "NOUN"
  ],
  "egencia": [
    "PROPN"
  ],
  "dismissed": [
    "VERB"
  ],
  "persisted": [
    "VERB"
  ],
  "prompting": [
    "VERB"
  ],
  "decryption": [
    "NOUN"
  ],
  "analysing": [
    "VERB"
  ],
  "machines": [
    "NOUN"
  ],
  "jumping": [
    "VERB"
  ],
  "financials": [
    "NOUN"
  ],
  "intervals": [
    "NOUN"
  ],
  "viewers": [
    "NOUN"
  ],
  "submissions": [
    "NOUN"
  ],
  "finances": [
    "NOUN"
  ],
  "verticals": [
    "NOUN"
  ],
  "appfire": [
    "PROPN"
  ],
  "servlet": [
    "NOUN"
  ],
  "estimating": [
    "VERB"
  ],
  "organizing": [
    "VERB"
  ],
  "forecasts": [
    "NOUN"
  ],
  "marks": [
    "NOUN",
    "VERB"
  ],
  "subscribed": [
    "VERB"
  ],
  "chatbot": [
    "NOUN"
  ],
  "earliest": [
    "ADJ"
  ],
  "roadshow": [
    "PROPN",
    "NOUN"
  ],
  "ukraine": [
    "PROPN"
  ],
  "churned": [
    "VERB"
  ],
  "frustrated": [
    "VERB",
    "ADJ"
  ],
  "combines": [
    "VERB"
  ],
  "sequences": [
    "NOUN"
  ],
  "compares": [
    "VERB"
  ],
  "pains": [
    "NOUN"
  ],
  "developments": [
    "NOUN"
  ],
  "praecipio": [
    "PROPN"
  ],
  "objections": [
    "NOUN"
  ],
  "placing": [
    "VERB"
  ],
  "makkuro": [
    "PROPN"
  ],
  "migrator": [
    "NOUN",
    "PROPN"
  ],
  "intranet": [
    "NOUN",
    "PROPN"
  ],
  "enhances": [
    "VERB"
  ],
  "recognise": [
    "VERB"
  ],
  "uninstall": [
    "ADJ",
    "PROPN"
  ],
  "worklogs": [
    "NOUN"
  ],
  "oppty": [
    "ADJ",
    "PROPN"
  ],
  "renamed": [
    "VERB"
  ],
  "approves": [
    "VERB"
  ],
  "finishes": [
    "VERB",
    "NOUN"
  ],
  "experimenting": [
    "VERB"
  ],
  "discovering": [
    "VERB"
  ],
  "corresponds": [
    "VERB"
  ],
  "agencies": [
    "NOUN"
  ],
  "negotiated": [
    "VERB"
  ],
  "melbourne": [
    "PROPN"
  ],
  "bootstraps": [
    "NOUN"
  ],
  "produces": [
    "VERB"
  ],
  "rounds": [
    "NOUN"
  ],
  "drinks": [
    "NOUN"
  ],
  "batching": [
    "VERB"
  ],
  "checkpoints": [
    "NOUN"
  ],
  "taxes": [
    "NOUN"
  ],
  "computing": [
    "NOUN",
    "VERB"
  ],
  "wargame": [
    "NOUN",
    "PROPN"
  ],
  "pressed": [
    "VERB"
  ],
  "collaborated": [
    "VERB"
  ],
  "adapted": [
    "VERB"
  ],
  "successes": [
    "NOUN"
  ],
  "assisting": [
    "VERB"
  ],
  "organised": [
    "VERB"
  ],
  "slowed": [
    "VERB"
  ],
  "projectid": [
    "PROPN"
  ],
  "alerted": [
    "VERB"
  ],
  "vectors": [
    "NOUN"
  ],
  "heatmap": [
    "PROPN"
  ],
  "planview": [
    "PROPN"
  ],
  "arises": [
    "VERB"
  ],
  "doors": [
    "NOUN"
  ],
  "shapes": [
    "NOUN"
  ],
  "dacis": [
    "NOUN"
  ],
  "invoicing": [
    "NOUN",
    "PROPN"
  ],
  "jumpstart": [
    "PROPN"
  ],
  "megacloud": [
    "PROPN"
  ],
  "wellbeing": [
    "PROPN",
    "NOUN"
  ],
  "initialization": [
    "NOUN"
  ],
  "converts": [
    "VERB",
    "NOUN"
  ],
  "ranks": [
    "VERB",
    "NOUN"
  ],
  "endeavour": [
    "PROPN"
  ],
  "cloned": [
    "VERB"
  ],
  "megan": [
    "PROPN"
  ],
  "increments": [
    "NOUN"
  ],
  "enters": [
    "VERB"
  ],
  "selections": [
    "NOUN"
  ],
  "colours": [
    "NOUN"
  ],
  "longest": [
    "ADJ"
  ],
  "acquiring": [
    "VERB"
  ],
  "carebear": [
    "PROPN"
  ],
  "superseded": [
    "VERB",
    "PROPN"
  ],
  "actuals": [
    "NOUN"
  ],
  "simplifies": [
    "NOUN",
    "VERB"
  ],
  "maintainability": [
    "NOUN",
    "PROPN"
  ],
  "qualifying": [
    "NOUN",
    "VERB"
  ],
  "scenes": [
    "NOUN"
  ],
  "multipliers": [
    "PROPN",
    "NOUN"
  ],
  "mirrors": [
    "NOUN"
  ],
  "beans": [
    "NOUN"
  ],
  "reactivate": [
    "VERB"
  ],
  "activating": [
    "VERB"
  ],
  "hiding": [
    "VERB",
    "NOUN"
  ],
  "spans": [
    "NOUN",
    "VERB"
  ],
  "cutover": [
    "NOUN",
    "PROPN"
  ],
  "elearning": [
    "PROPN"
  ],
  "feelings": [
    "NOUN"
  ],
  "eliminating": [
    "VERB"
  ],
  "interacts": [
    "VERB"
  ],
  "africa": [
    "PROPN"
  ],
  "tenanted": [
    "ADJ",
    "VERB"
  ],
  "visualise": [
    "VERB",
    "PROPN"
  ],
  "decreases": [
    "VERB",
    "NOUN"
  ],
  "submits": [
    "VERB"
  ],
  "hobbies": [
    "NOUN",
    "PROPN"
  ],
  "classify": [
    "VERB"
  ],
  "hierarchies": [
    "NOUN"
  ],
  "translates": [
    "VERB"
  ],
  "surprised": [
    "ADJ",
    "VERB"
  ],
  "expressions": [
    "NOUN"
  ],
  "spanning": [
    "VERB"
  ],
  "cheaper": [
    "ADJ"
  ],
  "userbases": [
    "NOUN"
  ],
  "masters": [
    "NOUN",
    "PROPN"
  ],
  "incorporates": [
    "VERB"
  ],
  "qualtrics": [
    "PROPN"
  ],
  "badges": [
    "NOUN"
  ],
  "closes": [
    "VERB"
  ],
  "organising": [
    "VERB"
  ],
  "deprecating": [
    "VERB"
  ],
  "spots": [
    "NOUN"
  ],
  "entitytype": [
    "ADJ"
  ],
  "nesting": [
    "NOUN",
    "ADJ"
  ],
  "flink": [
    "PROPN"
  ],
  "executes": [
    "VERB"
  ],
  "replies": [
    "NOUN"
  ],
  "misalignment": [
    "NOUN"
  ],
  "coordinator": [
    "PROPN"
  ],
  "supportability": [
    "NOUN",
    "PROPN"
  ],
  "restores": [
    "VERB",
    "NOUN"
  ],
  "approving": [
    "VERB"
  ],
  "cherwell": [
    "PROPN"
  ],
  "statsd": [
    "NOUN"
  ],
  "gupta": [
    "PROPN"
  ],
  "flights": [
    "NOUN"
  ],
  "restricting": [
    "VERB"
  ],
  "simplest": [
    "ADJ"
  ],
  "percept": [
    "PROPN"
  ],
  "datasource": [
    "NOUN"
  ],
  "sourcegraph": [
    "PROPN"
  ],
  "timings": [
    "NOUN"
  ],
  "escalating": [
    "VERB"
  ],
  "retried": [
    "VERB"
  ],
  "timestamps": [
    "NOUN"
  ],
  "banners": [
    "NOUN"
  ],
  "seperate": [
    "ADJ"
  ],
  "comparisons": [
    "NOUN"
  ],
  "visualizations": [
    "NOUN"
  ],
  "relied": [
    "VERB"
  ],
  "succeeds": [
    "VERB"
  ],
  "declining": [
    "VERB"
  ],
  "facilitates": [
    "VERB"
  ],
  "partnered": [
    "VERB"
  ],
  "spotlights": [
    "NOUN",
    "PROPN"
  ],
  "chicago": [
    "PROPN"
  ],
  "missions": [
    "NOUN"
  ],
  "serverless": [
    "NOUN"
  ],
  "decks": [
    "NOUN"
  ],
  "avoided": [
    "VERB"
  ],
  "thrilled": [
    "ADJ"
  ],
  "sophie": [
    "PROPN"
  ],
  "figures": [
    "NOUN"
  ],
  "simplifying": [
    "VERB"
  ],
  "prototypes": [
    "NOUN"
  ],
  "tutorials": [
    "NOUN"
  ],
  "looms": [
    "PROPN",
    "NOUN"
  ],
  "cooperation": [
    "NOUN"
  ],
  "decouple": [
    "VERB",
    "PROPN"
  ],
  "touches": [
    "VERB",
    "NOUN"
  ],
  "showcasing": [
    "VERB"
  ],
  "ventures": [
    "PROPN"
  ],
  "whitepaper": [
    "NOUN",
    "PROPN"
  ],
  "nextgen": [
    "PROPN"
  ],
  "overwritten": [
    "VERB"
  ],
  "exposes": [
    "VERB"
  ],
  "retrospectives": [
    "NOUN",
    "PROPN"
  ],
  "toggled": [
    "VERB"
  ],
  "mithril": [
    "PROPN"
  ],
  "funnels": [
    "NOUN"
  ],
  "abilities": [
    "NOUN"
  ],
  "researching": [
    "VERB"
  ],
  "smartsheet": [
    "PROPN"
  ],
  "chartio": [
    "PROPN"
  ],
  "discoverable": [
    "ADJ"
  ],
  "binaries": [
    "NOUN"
  ],
  "percentages": [
    "NOUN"
  ],
  "smartlink": [
    "PROPN"
  ],
  "guarantees": [
    "NOUN"
  ],
  "softserve": [
    "PROPN"
  ],
  "behaves": [
    "VERB",
    "NOUN"
  ],
  "mysql": [
    "PROPN"
  ],
  "addressable": [
    "ADJ"
  ],
  "leaked": [
    "VERB"
  ],
  "expansions": [
    "NOUN"
  ],
  "decoupled": [
    "VERB"
  ],
  "misses": [
    "NOUN"
  ],
  "granting": [
    "VERB"
  ],
  "surveyed": [
    "VERB"
  ],
  "collapsed": [
    "VERB"
  ],
  "differentiator": [
    "NOUN"
  ],
  "summarizes": [
    "VERB"
  ],
  "estimations": [
    "NOUN"
  ],
  "chatbots": [
    "NOUN"
  ],
  "raises": [
    "VERB"
  ],
  "bengaluru": [
    "PROPN"
  ],
  "losses": [
    "NOUN"
  ],
  "gryffindor": [
    "PROPN"
  ],
  "specifies": [
    "VERB"
  ],
  "nvidia": [
    "PROPN"
  ],
  "timechart": [
    "NOUN"
  ],
  "localhost": [
    "NOUN"
  ],
  "outliers": [
    "NOUN"
  ],
  "resolvers": [
    "NOUN"
  ],
  "existed": [
    "VERB"
  ],
  "merges": [
    "NOUN",
    "VERB"
  ],
  "iterating": [
    "VERB"
  ],
  "containerid": [
    "PROPN"
  ],
  "dated": [
    "VERB"
  ],
  "emcee": [
    "PROPN"
  ],
  "meatball": [
    "NOUN"
  ],
  "timeframes": [
    "NOUN"
  ],
  "optimising": [
    "VERB"
  ],
  "regex": [
    "NOUN"
  ],
  "reverted": [
    "VERB"
  ],
  "mocks": [
    "NOUN"
  ],
  "fonts": [
    "NOUN"
  ],
  "packaged": [
    "VERB"
  ],
  "consumes": [
    "VERB"
  ],
  "reindexing": [
    "VERB"
  ],
  "retrieves": [
    "VERB"
  ],
  "advancements": [
    "NOUN"
  ],
  "kicks": [
    "NOUN",
    "VERB"
  ],
  "queued": [
    "VERB"
  ],
  "featuring": [
    "VERB"
  ],
  "diffs": [
    "NOUN"
  ],
  "redirecting": [
    "VERB"
  ],
  "poses": [
    "VERB"
  ],
  "discusses": [
    "VERB"
  ],
  "backfilled": [
    "VERB"
  ],
  "utilising": [
    "VERB"
  ],
  "lastpass": [
    "PROPN"
  ],
  "brands": [
    "NOUN"
  ],
  "unauthorised": [
    "ADJ"
  ],
  "summarized": [
    "VERB"
  ],
  "inherited": [
    "VERB"
  ],
  "equals": [
    "VERB"
  ],
  "equipped": [
    "VERB"
  ],
  "emerged": [
    "VERB"
  ],
  "eficode": [
    "PROPN"
  ],
  "persists": [
    "VERB"
  ],
  "reactivated": [
    "VERB"
  ],
  "smarter": [
    "ADJ"
  ],
  "reassign": [
    "VERB"
  ],
  "unstructured": [
    "ADJ"
  ],
  "cloudflare": [
    "PROPN"
  ],
  "travelling": [
    "VERB"
  ],
  "carousel": [
    "NOUN"
  ],
  "helpseeker": [
    "NOUN"
  ],
  "complaints": [
    "NOUN"
  ],
  "subjects": [
    "NOUN"
  ],
  "propagated": [
    "VERB"
  ],
  "invocations": [
    "NOUN"
  ],
  "reverting": [
    "VERB"
  ],
  "rivian": [
    "PROPN"
  ],
  "uptick": [
    "NOUN"
  ],
  "marketers": [
    "NOUN"
  ],
  "attestation": [
    "NOUN"
  ],
  "encourages": [
    "VERB"
  ],
  "projections": [
    "NOUN"
  ],
  "cloning": [
    "NOUN",
    "VERB"
  ],
  "latencies": [
    "NOUN"
  ],
  "frames": [
    "NOUN"
  ],
  "ensured": [
    "VERB"
  ],
  "howto": [
    "PROPN"
  ],
  "bills": [
    "NOUN"
  ],
  "autocomplete": [
    "ADJ"
  ],
  "achieves": [
    "VERB"
  ],
  "judgement": [
    "NOUN"
  ],
  "revisited": [
    "VERB"
  ],
  "seattle": [
    "PROPN"
  ],
  "editors": [
    "NOUN"
  ],
  "updatedat": [
    "PROPN"
  ],
  "trialing": [
    "VERB"
  ],
  "sharma": [
    "PROPN"
  ],
  "blogpost": [
    "NOUN",
    "VERB"
  ],
  "autoreview": [
    "PROPN"
  ],
  "slots": [
    "NOUN"
  ],
  "wallboard": [
    "NOUN"
  ],
  "decommissioned": [
    "VERB"
  ],
  "wildcard": [
    "ADJ"
  ],
  "fivetran": [
    "PROPN"
  ],
  "discarded": [
    "VERB"
  ],
  "pathways": [
    "NOUN"
  ],
  "facilitators": [
    "NOUN"
  ],
  "undertaken": [
    "VERB"
  ],
  "remediate": [
    "VERB"
  ],
  "fastest": [
    "ADJ"
  ],
  "steph": [
    "PROPN"
  ],
  "borders": [
    "NOUN"
  ],
  "fragments": [
    "NOUN"
  ],
  "fecru": [
    "PROPN"
  ],
  "emailed": [
    "VERB"
  ],
  "roadmapping": [
    "NOUN"
  ],
  "differentiated": [
    "VERB"
  ],
  "summarizing": [
    "VERB"
  ],
  "resides": [
    "VERB"
  ],
  "exams": [
    "NOUN"
  ],
  "voted": [
    "VERB"
  ],
  "replaces": [
    "VERB"
  ],
  "highspot": [
    "PROPN"
  ],
  "builders": [
    "NOUN"
  ],
  "evaluator": [
    "NOUN"
  ],
  "simulations": [
    "NOUN"
  ],
  "impersonation": [
    "NOUN"
  ],
  "histograms": [
    "NOUN"
  ],
  "mondays": [
    "PROPN"
  ],
  "avoids": [
    "VERB"
  ],
  "oldest": [
    "ADJ"
  ],
  "qualifications": [
    "NOUN"
  ],
  "townhall": [
    "PROPN",
    "NOUN"
  ],
  "agrees": [
    "VERB"
  ],
  "drawbacks": [
    "NOUN"
  ],
  "bumped": [
    "VERB"
  ],
  "cherenkov": [
    "PROPN"
  ],
  "feeds": [
    "VERB",
    "NOUN"
  ],
  "listings": [
    "NOUN"
  ],
  "callbacks": [
    "NOUN"
  ],
  "replayed": [
    "VERB"
  ],
  "emotions": [
    "NOUN"
  ],
  "accomplishments": [
    "NOUN"
  ],
  "representations": [
    "NOUN"
  ],
  "lightstep": [
    "PROPN"
  ],
  "cname": [
    "PROPN"
  ],
  "discounted": [
    "VERB"
  ],
  "lasted": [
    "VERB"
  ],
  "walks": [
    "VERB"
  ],
  "fulfilled": [
    "VERB"
  ],
  "refunded": [
    "VERB"
  ],
  "implied": [
    "VERB"
  ],
  "forums": [
    "NOUN"
  ],
  "tweaks": [
    "NOUN"
  ],
  "overwatch": [
    "PROPN"
  ],
  "distributing": [
    "VERB"
  ],
  "operated": [
    "VERB"
  ],
  "emphasizing": [
    "VERB"
  ],
  "exploited": [
    "VERB"
  ],
  "cities": [
    "NOUN"
  ],
  "struggles": [
    "VERB",
    "NOUN"
  ],
  "reusing": [
    "VERB"
  ],
  "slowness": [
    "NOUN"
  ],
  "theming": [
    "VERB"
  ],
  "instrumented": [
    "VERB"
  ],
  "menus": [
    "NOUN"
  ],
  "townsquare": [
    "ADJ"
  ],
  "paved": [
    "ADJ"
  ],
  "offeringid": [
    "PROPN"
  ],
  "zurich": [
    "PROPN"
  ],
  "ivanti": [
    "PROPN"
  ],
  "suits": [
    "VERB"
  ],
  "forecasted": [
    "VERB"
  ],
  "nullable": [
    "ADJ"
  ],
  "laptops": [
    "NOUN"
  ],
  "standups": [
    "NOUN"
  ],
  "safer": [
    "ADJ"
  ],
  "believes": [
    "VERB"
  ],
  "attackers": [
    "NOUN"
  ],
  "locating": [
    "VERB"
  ],
  "subscribers": [
    "NOUN"
  ],
  "rolls": [
    "VERB"
  ],
  "toolset": [
    "NOUN"
  ],
  "recognised": [
    "VERB"
  ],
  "overseeing": [
    "VERB"
  ],
  "revamping": [
    "VERB"
  ],
  "computers": [
    "NOUN"
  ],
  "switzerland": [
    "PROPN"
  ],
  "jurisdictions": [
    "NOUN"
  ],
  "adopters": [
    "NOUN"
  ],
  "analysed": [
    "VERB"
  ],
  "careers": [
    "NOUN"
  ],
  "proxies": [
    "NOUN"
  ],
  "disciplines": [
    "NOUN"
  ],
  "appended": [
    "VERB"
  ],
  "ingesting": [
    "VERB"
  ],
  "glean": [
    "PROPN"
  ],
  "ragnarok": [
    "PROPN"
  ],
  "recipients": [
    "NOUN"
  ],
  "mutations": [
    "NOUN"
  ],
  "sponsoring": [
    "VERB"
  ],
  "setups": [
    "NOUN"
  ],
  "progressed": [
    "VERB"
  ],
  "takeover": [
    "NOUN"
  ],
  "bullets": [
    "NOUN"
  ],
  "trees": [
    "NOUN"
  ],
  "cares": [
    "VERB"
  ],
  "referrals": [
    "NOUN"
  ],
  "deduplication": [
    "NOUN"
  ],
  "influencers": [
    "NOUN"
  ],
  "standardise": [
    "VERB"
  ],
  "controlling": [
    "VERB"
  ],
  "issuers": [
    "NOUN"
  ],
  "plaintext": [
    "NOUN"
  ],
  "standardizing": [
    "VERB"
  ],
  "typed": [
    "VERB"
  ],
  "snoopr": [
    "PROPN"
  ],
  "engines": [
    "NOUN"
  ],
  "eventbridge": [
    "PROPN"
  ],
  "normalized": [
    "VERB"
  ],
  "speaks": [
    "VERB"
  ],
  "subhead": [
    "PROPN"
  ],
  "clarified": [
    "VERB"
  ],
  "arrives": [
    "VERB"
  ],
  "smallest": [
    "ADJ"
  ],
  "powering": [
    "VERB"
  ],
  "conferences": [
    "NOUN"
  ],
  "initiating": [
    "VERB"
  ],
  "ignoring": [
    "VERB"
  ],
  "arriving": [
    "VERB"
  ],
  "optimizer": [
    "PROPN",
    "NOUN"
  ],
  "restarting": [
    "VERB"
  ],
  "registering": [
    "VERB"
  ],
  "bootstrapping": [
    "VERB"
  ],
  "mumbai": [
    "PROPN"
  ],
  "partha": [
    "PROPN"
  ],
  "eliminates": [
    "VERB"
  ],
  "paulo": [
    "PROPN"
  ],
  "writers": [
    "NOUN"
  ],
  "tunnels": [
    "NOUN"
  ],
  "chars": [
    "NOUN"
  ],
  "formatted": [
    "VERB"
  ],
  "icebreaker": [
    "NOUN",
    "PROPN"
  ],
  "amendments": [
    "NOUN"
  ],
  "deficiencies": [
    "NOUN"
  ],
  "downn": [
    "NOUN"
  ],
  "worthwhile": [
    "ADJ"
  ],
  "aggregating": [
    "VERB"
  ],
  "timers": [
    "NOUN"
  ],
  "renewing": [
    "VERB"
  ],
  "shaun": [
    "PROPN"
  ],
  "labeling": [
    "NOUN"
  ],
  "constructed": [
    "VERB"
  ],
  "findability": [
    "NOUN"
  ],
  "paypal": [
    "PROPN"
  ],
  "quoted": [
    "VERB"
  ],
  "rajeev": [
    "PROPN"
  ],
  "embeddable": [
    "ADJ"
  ],
  "jumpbox": [
    "PROPN"
  ],
  "canceling": [
    "VERB"
  ],
  "volunteers": [
    "NOUN"
  ],
  "downgrades": [
    "NOUN",
    "VERB"
  ],
  "reconciled": [
    "VERB"
  ],
  "injecting": [
    "VERB"
  ],
  "finalizing": [
    "VERB"
  ],
  "attaching": [
    "VERB"
  ],
  "informs": [
    "VERB"
  ],
  "revisiting": [
    "VERB"
  ],
  "allison": [
    "PROPN"
  ],
  "posters": [
    "NOUN",
    "PROPN"
  ],
  "grimlock": [
    "PROPN"
  ],
  "differentiators": [
    "NOUN"
  ],
  "jetbrains": [
    "PROPN"
  ],
  "errormessage": [
    "NOUN"
  ],
  "revamped": [
    "VERB"
  ],
  "arrived": [
    "VERB"
  ],
  "pickers": [
    "NOUN"
  ],
  "contacting": [
    "VERB"
  ],
  "encountering": [
    "VERB"
  ],
  "carries": [
    "VERB"
  ],
  "validators": [
    "NOUN"
  ],
  "intellum": [
    "PROPN"
  ],
  "aspirations": [
    "NOUN"
  ],
  "celebrating": [
    "VERB"
  ],
  "symbols": [
    "NOUN"
  ],
  "scientists": [
    "NOUN"
  ],
  "predictions": [
    "NOUN"
  ],
  "zhang": [
    "PROPN"
  ],
  "tends": [
    "VERB"
  ],
  "overwhelmed": [
    "ADJ"
  ],
  "nuances": [
    "NOUN"
  ],
  "distributions": [
    "NOUN"
  ],
  "powerpoint": [
    "PROPN"
  ],
  "reacting": [
    "VERB"
  ],
  "probing": [
    "VERB"
  ],
  "remembered": [
    "VERB"
  ],
  "sorts": [
    "NOUN"
  ],
  "lowlights": [
    "PROPN"
  ],
  "briefings": [
    "PROPN"
  ],
  "accommodations": [
    "NOUN"
  ],
  "allocating": [
    "VERB"
  ],
  "stating": [
    "VERB"
  ],
  "recaptcha": [
    "PROPN"
  ],
  "hypercare": [
    "PROPN"
  ],
  "productid": [
    "PROPN"
  ],
  "splits": [
    "NOUN"
  ],
  "auditors": [
    "NOUN"
  ],
  "changelogs": [
    "NOUN"
  ],
  "narratives": [
    "NOUN"
  ],
  "pinged": [
    "VERB"
  ],
  "headquartered": [
    "VERB"
  ],
  "necessitating": [
    "VERB"
  ],
  "originating": [
    "VERB"
  ],
  "thurs": [
    "PROPN"
  ],
  "modeled": [
    "VERB"
  ],
  "injected": [
    "VERB"
  ],
  "dives": [
    "NOUN"
  ],
  "dumps": [
    "NOUN"
  ],
  "downs": [
    "NOUN"
  ],
  "misconfigured": [
    "ADJ"
  ],
  "chooses": [
    "VERB"
  ],
  "bumblebee": [
    "PROPN"
  ],
  "pleased": [
    "ADJ"
  ],
  "unencrypted": [
    "ADJ"
  ],
  "serviceproxy": [
    "PROPN"
  ],
  "leaks": [
    "NOUN"
  ],
  "nicht": [
    "PROPN"
  ],
  "clearvision": [
    "PROPN"
  ],
  "predicted": [
    "VERB"
  ],
  "spain": [
    "PROPN"
  ],
  "mailing": [
    "NOUN"
  ],
  "mexico": [
    "PROPN"
  ],
  "encoding": [
    "NOUN"
  ],
  "tasked": [
    "VERB"
  ],
  "motivations": [
    "NOUN"
  ],
  "deducted": [
    "VERB"
  ],
  "localized": [
    "VERB"
  ],
  "refactored": [
    "VERB"
  ],
  "migrates": [
    "VERB"
  ],
  "vetted": [
    "VERB"
  ],
  "accelerates": [
    "VERB"
  ],
  "handing": [
    "VERB"
  ],
  "provisions": [
    "NOUN"
  ],
  "templating": [
    "NOUN"
  ],
  "attracting": [
    "VERB"
  ],
  "triads": [
    "NOUN"
  ],
  "digits": [
    "NOUN"
  ],
  "educating": [
    "VERB"
  ],
  "postponed": [
    "VERB"
  ],
  "calculates": [
    "VERB"
  ],
  "balances": [
    "NOUN"
  ],
  "followers": [
    "NOUN"
  ],
  "recreated": [
    "VERB"
  ],
  "calibrations": [
    "NOUN"
  ],
  "aforementioned": [
    "ADJ"
  ],
  "cloudtrail": [
    "PROPN"
  ],
  "realms": [
    "NOUN"
  ],
  "clientid": [
    "PROPN"
  ],
  "formulas": [
    "NOUN"
  ],
  "lights": [
    "NOUN"
  ],
  "fills": [
    "VERB"
  ],
  "scripting": [
    "NOUN"
  ],
  "openapi": [
    "PROPN"
  ],
  "decommissioning": [
    "NOUN",
    "VERB"
  ],
  "loves": [
    "VERB"
  ],
  "negotiating": [
    "VERB"
  ],
  "sefcon": [
    "PROPN"
  ],
  "slices": [
    "NOUN"
  ],
  "widgets": [
    "NOUN"
  ],
  "rebalancing": [
    "NOUN"
  ],
  "geographies": [
    "NOUN"
  ],
  "batched": [
    "VERB"
  ],
  "believed": [
    "VERB"
  ],
  "numbered": [
    "VERB"
  ],
  "remediated": [
    "VERB"
  ],
  "founded": [
    "VERB"
  ],
  "airbnb": [
    "PROPN"
  ],
  "interruptions": [
    "NOUN"
  ],
  "doubts": [
    "NOUN"
  ],
  "termed": [
    "VERB"
  ],
  "cancelling": [
    "VERB"
  ],
  "eslint": [
    "ADJ"
  ],
  "directing": [
    "VERB"
  ],
  "preserved": [
    "VERB"
  ],
  "nullpointerexception": [
    "NOUN"
  ],
  "governed": [
    "VERB"
  ],
  "labelling": [
    "NOUN"
  ],
  "brownbag": [
    "NOUN",
    "PROPN"
  ],
  "adhering": [
    "VERB"
  ],
  "untrusted": [
    "ADJ"
  ],
  "nodejs": [
    "PROPN"
  ],
  "diminishing": [
    "VERB"
  ],
  "illustrates": [
    "VERB"
  ],
  "statlas": [
    "PROPN"
  ],
  "minds": [
    "NOUN"
  ],
  "dozens": [
    "NOUN"
  ],
  "requisites": [
    "NOUN"
  ],
  "clari": [
    "PROPN"
  ],
  "originated": [
    "VERB"
  ],
  "fridays": [
    "PROPN"
  ],
  "spath": [
    "NOUN"
  ],
  "pilots": [
    "NOUN"
  ],
  "productionisation": [
    "NOUN"
  ],
  "securing": [
    "VERB"
  ],
  "stricter": [
    "ADJ"
  ],
  "reopened": [
    "VERB"
  ],
  "stickies": [
    "NOUN"
  ],
  "bypassing": [
    "VERB"
  ],
  "eliminated": [
    "VERB"
  ],
  "summarization": [
    "NOUN"
  ],
  "emphasizes": [
    "VERB"
  ],
  "boarded": [
    "VERB"
  ],
  "evals": [
    "NOUN"
  ],
  "faults": [
    "NOUN"
  ],
  "parsed": [
    "VERB"
  ],
  "centralize": [
    "VERB"
  ],
  "scrollable": [
    "ADJ"
  ],
  "identities": [
    "NOUN"
  ],
  "baselines": [
    "NOUN"
  ],
  "arjun": [
    "PROPN"
  ],
  "normalised": [
    "VERB"
  ],
  "focussing": [
    "VERB"
  ],
  "propositions": [
    "NOUN"
  ],
  "transforms": [
    "VERB"
  ],
  "slido": [
    "PROPN"
  ],
  "biases": [
    "NOUN"
  ],
  "audited": [
    "VERB"
  ],
  "customisable": [
    "ADJ"
  ],
  "families": [
    "NOUN"
  ],
  "disrupting": [
    "VERB"
  ],
  "signatures": [
    "NOUN"
  ],
  "ramped": [
    "VERB"
  ],
  "stakes": [
    "NOUN"
  ],
  "strongest": [
    "ADJ"
  ],
  "tooltips": [
    "NOUN"
  ],
  "takeout": [
    "PROPN"
  ],
  "stars": [
    "NOUN"
  ],
  "maximise": [
    "VERB"
  ],
  "markers": [
    "NOUN"
  ],
  "uninstallation": [
    "NOUN"
  ],
  "picks": [
    "VERB"
  ],
  "unlocks": [
    "VERB"
  ],
  "hyperlinks": [
    "NOUN"
  ],
  "seasonality": [
    "NOUN"
  ],
  "perez": [
    "PROPN"
  ],
  "melanie": [
    "PROPN"
  ],
  "opting": [
    "VERB"
  ],
  "orchestrating": [
    "VERB"
  ],
  "obfuscation": [
    "NOUN"
  ],
  "underrepresented": [
    "ADJ"
  ],
  "demandbase": [
    "PROPN"
  ],
  "linting": [
    "VERB"
  ],
  "richer": [
    "ADJ"
  ],
  "interconnected": [
    "VERB"
  ],
  "siemens": [
    "PROPN"
  ],
  "mockups": [
    "NOUN"
  ],
  "traced": [
    "VERB"
  ],
  "thumbs": [
    "NOUN"
  ],
  "spends": [
    "VERB"
  ],
  "webdriver": [
    "PROPN"
  ],
  "mocking": [
    "VERB"
  ],
  "whitelisted": [
    "VERB"
  ],
  "summarised": [
    "VERB"
  ],
  "clarifications": [
    "NOUN"
  ],
  "differentiating": [
    "VERB"
  ],
  "keynotes": [
    "NOUN"
  ],
  "banks": [
    "NOUN"
  ],
  "prolonged": [
    "VERB"
  ],
  "promotes": [
    "VERB"
  ],
  "invokes": [
    "VERB"
  ],
  "degrees": [
    "NOUN"
  ],
  "imposed": [
    "VERB"
  ],
  "redesigned": [
    "VERB"
  ],
  "spiff": [
    "PROPN"
  ],
  "swimlanes": [
    "NOUN"
  ],
  "initialized": [
    "VERB"
  ],
  "identitynow": [
    "PROPN"
  ],
  "maximizing": [
    "VERB"
  ],
  "obsdeck": [
    "PROPN"
  ],
  "activations": [
    "NOUN"
  ],
  "bafin": [
    "PROPN"
  ],
  "previews": [
    "NOUN"
  ],
  "overheads": [
    "NOUN"
  ],
  "boosting": [
    "VERB"
  ],
  "reflections": [
    "NOUN"
  ],
  "unhandled": [
    "ADJ"
  ],
  "behavioural": [
    "ADJ"
  ],
  "disrupted": [
    "VERB"
  ],
  "distractions": [
    "NOUN"
  ],
  "newsletters": [
    "NOUN"
  ],
  "gsheet": [
    "PROPN"
  ],
  "backoff": [
    "NOUN"
  ],
  "dockerfile": [
    "PROPN"
  ],
  "appdynamics": [
    "PROPN"
  ],
  "creds": [
    "NOUN"
  ],
  "intentions": [
    "NOUN"
  ],
  "invoking": [
    "VERB"
  ],
  "overlooked": [
    "VERB"
  ],
  "inclined": [
    "ADJ"
  ],
  "modelled": [
    "VERB"
  ],
  "persisting": [
    "VERB"
  ],
  "subdomain": [
    "NOUN"
  ],
  "detractors": [
    "NOUN"
  ],
  "facilitated": [
    "VERB"
  ],
  "sequencing": [
    "VERB"
  ],
  "crafts": [
    "NOUN"
  ],
  "vikram": [
    "PROPN"
  ],
  "bigint": [
    "NOUN"
  ],
  "researched": [
    "VERB"
  ],
  "tours": [
    "NOUN"
  ],
  "constitutes": [
    "VERB"
  ],
  "themed": [
    "VERB"
  ],
  "earned": [
    "VERB"
  ],
  "firms": [
    "NOUN"
  ],
  "decades": [
    "NOUN"
  ],
  "counters": [
    "NOUN"
  ],
  "natwest": [
    "PROPN"
  ],
  "importers": [
    "NOUN"
  ],
  "misconfiguration": [
    "NOUN"
  ],
  "envisioned": [
    "VERB"
  ],
  "purged": [
    "VERB"
  ],
  "disco": [
    "PROPN"
  ],
  "learns": [
    "VERB"
  ],
  "yoshi": [
    "PROPN"
  ],
  "emitting": [
    "VERB"
  ],
  "displayname": [
    "NOUN"
  ],
  "favour": [
    "NOUN"
  ],
  "customizing": [
    "VERB"
  ],
  "revenues": [
    "NOUN"
  ],
  "helpdesk": [
    "NOUN"
  ],
  "hotels": [
    "NOUN"
  ],
  "notifies": [
    "NOUN"
  ],
  "mismatches": [
    "NOUN"
  ],
  "chimp": [
    "PROPN"
  ],
  "develops": [
    "VERB"
  ],
  "hyperlink": [
    "NOUN"
  ],
  "jumped": [
    "VERB"
  ],
  "challenged": [
    "VERB"
  ],
  "specializations": [
    "NOUN"
  ],
  "skillset": [
    "NOUN"
  ],
  "unauthenticated": [
    "ADJ"
  ],
  "citizens": [
    "NOUN"
  ],
  "shubham": [
    "PROPN"
  ],
  "surprises": [
    "NOUN"
  ],
  "overcoming": [
    "VERB"
  ],
  "curate": [
    "VERB"
  ],
  "lacked": [
    "VERB"
  ],
  "navigates": [
    "VERB"
  ],
  "shoutout": [
    "NOUN"
  ],
  "interpreted": [
    "VERB"
  ],
  "smartbear": [
    "PROPN"
  ],
  "shoplassian": [
    "PROPN"
  ],
  "overriding": [
    "VERB"
  ],
  "centrify": [
    "PROPN"
  ],
  "meals": [
    "NOUN"
  ],
  "elasticache": [
    "PROPN"
  ],
  "joiners": [
    "NOUN"
  ],
  "entrypoint": [
    "NOUN"
  ],
  "degreed": [
    "PROPN"
  ],
  "movies": [
    "NOUN"
  ],
  "packed": [
    "VERB"
  ],
  "orchestrate": [
    "VERB"
  ],
  "mobilekit": [
    "PROPN"
  ],
  "customised": [
    "VERB"
  ],
  "similarities": [
    "NOUN"
  ],
  "predicting": [
    "VERB"
  ],
  "acknowledging": [
    "VERB"
  ],
  "complicating": [
    "VERB"
  ],
  "tweaked": [
    "VERB"
  ],
  "translating": [
    "VERB"
  ],
  "buddies": [
    "NOUN"
  ],
  "dependant": [
    "ADJ"
  ],
  "brandfolder": [
    "PROPN"
  ],
  "throttled": [
    "VERB"
  ],
  "resourced": [
    "VERB"
  ],
  "approached": [
    "VERB"
  ],
  "clauses": [
    "NOUN"
  ],
  "constructs": [
    "NOUN"
  ],
  "instagram": [
    "PROPN"
  ],
  "aggregations": [
    "NOUN"
  ],
  "venkatesh": [
    "PROPN"
  ],
  "prohibited": [
    "VERB"
  ],
  "atleast": [
    "ADJ"
  ],
  "delegating": [
    "VERB"
  ],
  "acknowledgement": [
    "NOUN"
  ],
  "hardest": [
    "ADJ"
  ],
  "reorg": [
    "NOUN"
  ],
  "performers": [
    "NOUN"
  ],
  "firewalls": [
    "NOUN"
  ],
  "hopes": [
    "NOUN"
  ],
  "overviews": [
    "NOUN"
  ],
  "initialised": [
    "VERB"
  ],
  "mongodb": [
    "NOUN"
  ],
  "destroyed": [
    "VERB"
  ],
  "bandana": [
    "PROPN"
  ],
  "retains": [
    "VERB"
  ],
  "harmonisation": [
    "PROPN"
  ],
  "issueid": [
    "PROPN"
  ],
  "recognizing": [
    "VERB"
  ],
  "monetize": [
    "VERB"
  ],
  "versioned": [
    "VERB"
  ],
  "assigns": [
    "VERB"
  ],
  "seniors": [
    "NOUN"
  ],
  "pendo": [
    "PROPN"
  ],
  "webpage": [
    "NOUN"
  ],
  "observers": [
    "NOUN"
  ],
  "hurdles": [
    "NOUN"
  ],
  "initiates": [
    "VERB"
  ],
  "stretched": [
    "VERB"
  ],
  "deutsche": [
    "PROPN"
  ],
  "fedex": [
    "PROPN"
  ],
  "retrying": [
    "VERB"
  ],
  "memories": [
    "NOUN"
  ],
  "catchup": [
    "NOUN"
  ],
  "welcomed": [
    "VERB"
  ],
  "anticipating": [
    "VERB"
  ],
  "gsync": [
    "PROPN"
  ],
  "looped": [
    "VERB"
  ],
  "scared": [
    "ADJ"
  ],
  "violates": [
    "VERB"
  ],
  "breakdowns": [
    "NOUN"
  ],
  "gliffy": [
    "PROPN"
  ],
  "institutions": [
    "NOUN"
  ],
  "rewriting": [
    "VERB"
  ],
  "executors": [
    "NOUN"
  ],
  "complications": [
    "NOUN"
  ],
  "overridden": [
    "ADJ"
  ],
  "disadvantages": [
    "NOUN"
  ],
  "encompassing": [
    "VERB"
  ],
  "hostnames": [
    "NOUN"
  ],
  "revolves": [
    "VERB"
  ],
  "descoped": [
    "VERB"
  ],
  "ondemand": [
    "PROPN"
  ],
  "testable": [
    "ADJ"
  ],
  "affordance": [
    "NOUN"
  ],
  "entitled": [
    "VERB"
  ],
  "interventions": [
    "NOUN"
  ],
  "prospecting": [
    "VERB"
  ],
  "decommission": [
    "NOUN"
  ],
  "mandated": [
    "VERB"
  ],
  "promises": [
    "NOUN"
  ],
  "usecase": [
    "NOUN"
  ],
  "minimising": [
    "VERB"
  ],
  "overloaded": [
    "VERB"
  ],
  "invoiced": [
    "VERB"
  ],
  "disappeared": [
    "VERB"
  ],
  "duplo": [
    "PROPN"
  ],
  "checkboxes": [
    "NOUN"
  ],
  "budgeted": [
    "VERB"
  ],
  "ramping": [
    "VERB"
  ],
  "podcast": [
    "NOUN"
  ],
  "evaluates": [
    "VERB"
  ],
  "disables": [
    "VERB"
  ],
  "protections": [
    "NOUN"
  ],
  "recreating": [
    "VERB"
  ],
  "roundtables": [
    "NOUN"
  ],
  "deliveries": [
    "NOUN"
  ],
  "logins": [
    "NOUN"
  ],
  "influences": [
    "VERB"
  ],
  "refapp": [
    "PROPN"
  ],
  "hindering": [
    "VERB"
  ],
  "lengths": [
    "NOUN"
  ],
  "acted": [
    "VERB"
  ],
  "numeric": [
    "ADJ"
  ],
  "sunsetting": [
    "VERB"
  ],
  "reassigned": [
    "VERB"
  ],
  "habits": [
    "NOUN"
  ],
  "replaying": [
    "VERB"
  ],
  "monetisation": [
    "PROPN"
  ],
  "fears": [
    "NOUN"
  ],
  "angeles": [
    "PROPN"
  ],
  "connectedness": [
    "NOUN"
  ],
  "reddit": [
    "PROPN"
  ],
  "launchpad": [
    "PROPN"
  ],
  "flakiness": [
    "NOUN"
  ],
  "aspirational": [
    "ADJ"
  ],
  "stacked": [
    "VERB"
  ],
  "marketplaces": [
    "NOUN"
  ],
  "hubspot": [
    "PROPN"
  ],
  "wikipedia": [
    "PROPN"
  ],
  "rosters": [
    "NOUN"
  ],
  "voices": [
    "NOUN"
  ],
  "bullshit": [
    "NOUN"
  ],
  "accomplishing": [
    "VERB"
  ],
  "animations": [
    "NOUN"
  ],
  "stickiness": [
    "NOUN"
  ],
  "inspecting": [
    "VERB"
  ],
  "mates": [
    "NOUN"
  ],
  "resonates": [
    "VERB"
  ],
  "resets": [
    "VERB"
  ],
  "tweet": [
    "NOUN"
  ],
  "risking": [
    "VERB"
  ],
  "curation": [
    "NOUN"
  ],
  "counterparts": [
    "NOUN"
  ],
  "hacks": [
    "NOUN"
  ],
  "interviewed": [
    "VERB"
  ],
  "nudges": [
    "NOUN"
  ],
  "routines": [
    "NOUN"
  ],
  "chapters": [
    "NOUN"
  ],
  "stems": [
    "VERB"
  ],
  "coaches": [
    "NOUN"
  ],
  "bwhab": [
    "PROPN"
  ],
  "evidenced": [
    "VERB"
  ],
  "wells": [
    "PROPN"
  ],
  "ladders": [
    "VERB"
  ],
  "acknowledges": [
    "VERB"
  ],
  "clunky": [
    "ADJ"
  ],
  "articulates": [
    "VERB"
  ],
  "sanfrancisco": [
    "NOUN"
  ],
  "swoogo": [
    "PROPN"
  ],
  "contracting": [
    "NOUN"
  ],
  "enriched": [
    "VERB"
  ],
  "administering": [
    "VERB"
  ],
  "configurability": [
    "NOUN"
  ],
  "occasions": [
    "NOUN"
  ],
  "catered": [
    "VERB"
  ],
  "learners": [
    "NOUN"
  ],
  "jlove": [
    "PROPN"
  ],
  "assertions": [
    "NOUN"
  ],
  "studying": [
    "VERB"
  ],
  "populating": [
    "VERB"
  ],
  "verifies": [
    "NOUN"
  ],
  "deprioritized": [
    "VERB"
  ],
  "crashed": [
    "VERB"
  ],
  "decrypt": [
    "VERB"
  ],
  "mongo": [
    "PROPN"
  ],
  "worries": [
    "NOUN"
  ],
  "constants": [
    "NOUN"
  ],
  "dropdowns": [
    "NOUN"
  ],
  "prefers": [
    "VERB"
  ],
  "pings": [
    "NOUN"
  ],
  "rejecting": [
    "VERB"
  ],
  "practitioners": [
    "NOUN"
  ],
  "omitted": [
    "VERB"
  ],
  "testimonials": [
    "NOUN"
  ],
  "maintainable": [
    "ADJ"
  ],
  "misunderstandings": [
    "NOUN"
  ],
  "respected": [
    "VERB"
  ],
  "diagnosing": [
    "VERB"
  ],
  "coworkers": [
    "NOUN"
  ],
  "cultures": [
    "NOUN"
  ],
  "ambitions": [
    "NOUN"
  ],
  "resuming": [
    "VERB"
  ],
  "agendas": [
    "NOUN"
  ],
  "reproducing": [
    "VERB"
  ],
  "explores": [
    "VERB"
  ],
  "whiteboarding": [
    "VERB"
  ],
  "activates": [
    "VERB"
  ],
  "filesystem": [
    "NOUN"
  ],
  "pertains": [
    "VERB"
  ],
  "idempotency": [
    "NOUN"
  ],
  "replicating": [
    "VERB"
  ],
  "cerebro": [
    "PROPN"
  ],
  "hashed": [
    "VERB"
  ],
  "puppeteer": [
    "NOUN"
  ],
  "dialogs": [
    "NOUN"
  ],
  "promised": [
    "VERB"
  ],
  "shots": [
    "NOUN"
  ],
  "paragraphs": [
    "NOUN"
  ],
  "navigated": [
    "VERB"
  ],
  "sketches": [
    "NOUN"
  ],
  "snacks": [
    "NOUN"
  ],
  "showcases": [
    "VERB"
  ],
  "synchronised": [
    "VERB"
  ],
  "accruals": [
    "NOUN"
  ],
  "stressed": [
    "VERB"
  ],
  "davis": [
    "PROPN"
  ],
  "instrumenting": [
    "VERB"
  ],
  "incentivize": [
    "VERB"
  ],
  "perfhammer": [
    "PROPN"
  ],
  "defaulting": [
    "VERB"
  ],
  "headlines": [
    "NOUN"
  ],
  "garcia": [
    "PROPN"
  ],
  "sentiments": [
    "NOUN"
  ],
  "abstractions": [
    "NOUN"
  ],
  "pressures": [
    "NOUN"
  ],
  "sitename": [
    "PROPN"
  ],
  "moderated": [
    "ADJ"
  ],
  "operationalize": [
    "VERB"
  ],
  "fulfilling": [
    "VERB"
  ],
  "compiling": [
    "VERB"
  ],
  "frustrations": [
    "NOUN"
  ],
  "nuanced": [
    "VERB"
  ],
  "annotated": [
    "VERB"
  ],
  "placeholders": [
    "NOUN"
  ],
  "reveals": [
    "VERB"
  ],
  "housed": [
    "VERB"
  ],
  "checkin": [
    "PROPN"
  ],
  "resourcetype": [
    "NOUN"
  ],
  "texts": [
    "NOUN"
  ],
  "atlasbow": [
    "VERB"
  ],
  "backfilling": [
    "NOUN"
  ],
  "siblings": [
    "NOUN"
  ],
  "talents": [
    "NOUN"
  ],
  "qualifies": [
    "VERB"
  ],
  "heuristics": [
    "NOUN"
  ],
  "winners": [
    "NOUN"
  ],
  "fargo": [
    "PROPN"
  ],
  "disney": [
    "PROPN"
  ],
  "bounced": [
    "VERB"
  ],
  "worlds": [
    "NOUN"
  ],
  "allthethings": [
    "NOUN"
  ],
  "intends": [
    "VERB"
  ],
  "taskid": [
    "NOUN"
  ],
  "nurtures": [
    "NOUN"
  ],
  "authn": [
    "PROPN"
  ],
  "loses": [
    "VERB"
  ],
  "directs": [
    "VERB"
  ],
  "strengthened": [
    "VERB"
  ],
  "ingredients": [
    "NOUN"
  ],
  "modifies": [
    "VERB"
  ],
  "retros": [
    "PROPN"
  ],
  "appending": [
    "VERB"
  ],
  "backfills": [
    "NOUN"
  ],
  "assembled": [
    "VERB"
  ],
  "commenced": [
    "VERB"
  ],
  "consenthub": [
    "PROPN"
  ],
  "deactivations": [
    "NOUN"
  ],
  "idempotent": [
    "ADJ"
  ],
  "unifying": [
    "VERB"
  ],
  "consisting": [
    "VERB"
  ],
  "perceptions": [
    "NOUN"
  ],
  "accomodate": [
    "VERB"
  ],
  "leaking": [
    "VERB"
  ],
  "workings": [
    "NOUN"
  ],
  "comprises": [
    "VERB"
  ],
  "engages": [
    "VERB"
  ],
  "progresses": [
    "VERB"
  ],
  "accumulated": [
    "VERB"
  ],
  "sauron": [
    "PROPN"
  ],
  "prioritizes": [
    "VERB"
  ],
  "unleashing": [
    "VERB"
  ],
  "mocked": [
    "VERB"
  ],
  "defaulted": [
    "VERB"
  ],
  "bumps": [
    "NOUN"
  ],
  "disclaimers": [
    "NOUN"
  ],
  "ignores": [
    "VERB"
  ],
  "anand": [
    "PROPN"
  ],
  "mayank": [
    "PROPN"
  ],
  "affiliated": [
    "VERB"
  ],
  "embraced": [
    "VERB"
  ],
  "recency": [
    "NOUN"
  ],
  "skillsets": [
    "NOUN"
  ],
  "shortcomings": [
    "NOUN"
  ],
  "replied": [
    "VERB"
  ],
  "differing": [
    "VERB"
  ],
  "duplicating": [
    "VERB"
  ],
  "maintainers": [
    "NOUN"
  ],
  "permutations": [
    "NOUN"
  ],
  "jokes": [
    "NOUN"
  ],
  "datasources": [
    "NOUN"
  ],
  "alterations": [
    "NOUN"
  ],
  "usecases": [
    "NOUN"
  ],
  "specialised": [
    "VERB"
  ],
  "relocated": [
    "VERB"
  ],
  "openings": [
    "NOUN"
  ],
  "breakers": [
    "NOUN"
  ],
  "communardo": [
    "PROPN"
  ],
  "encrypts": [
    "VERB"
  ],
  "terminating": [
    "VERB"
  ],
  "whitelisting": [
    "NOUN"
  ],
  "jiras": [
    "PROPN"
  ],
  "inbuilt": [
    "ADJ"
  ],
  "origins": [
    "NOUN"
  ],
  "magnifying": [
    "NOUN"
  ],
  "interpreting": [
    "VERB"
  ],
  "relatable": [
    "ADJ"
  ],
  "roots": [
    "NOUN"
  ],
  "encrypting": [
    "VERB"
  ],
  "norms": [
    "NOUN"
  ],
  "complaining": [
    "VERB"
  ],
  "lifted": [
    "VERB"
  ],
  "motivating": [
    "VERB"
  ],
  "hannah": [
    "PROPN"
  ],
  "statham": [
    "NOUN"
  ],
  "groupings": [
    "NOUN"
  ],
  "chargeelement": [
    "NOUN"
  ],
  "doable": [
    "ADJ"
  ],
  "updation": [
    "NOUN"
  ],
  "initials": [
    "NOUN"
  ],
  "rhythms": [
    "NOUN"
  ],
  "incurred": [
    "VERB"
  ],
  "django": [
    "PROPN"
  ],
  "figjam": [
    "PROPN"
  ],
  "iterated": [
    "VERB"
  ],
  "clickable": [
    "ADJ"
  ],
  "correlates": [
    "VERB"
  ],
  "blueprints": [
    "NOUN"
  ],
  "collectors": [
    "NOUN"
  ],
  "participates": [
    "VERB"
  ],
  "transmitted": [
    "VERB"
  ],
  "centralizing": [
    "VERB"
  ],
  "repurpose": [
    "VERB"
  ],
  "administered": [
    "VERB"
  ],
  "logout": [
    "PROPN"
  ],
  "listeners": [
    "NOUN"
  ],
  "trustworthiness": [
    "NOUN"
  ],
  "benefited": [
    "VERB"
  ],
  "finalising": [
    "VERB"
  ],
  "altered": [
    "VERB"
  ],
  "alyssa": [
    "PROPN"
  ],
  "socialise": [
    "VERB"
  ],
  "subscribing": [
    "VERB"
  ],
  "fluctuations": [
    "NOUN"
  ],
  "templated": [
    "VERB"
  ],
  "facets": [
    "NOUN"
  ],
  "monoliths": [
    "NOUN"
  ],
  "microsite": [
    "NOUN"
  ],
  "thursdays": [
    "PROPN"
  ],
  "arrangements": [
    "NOUN"
  ],
  "reactivating": [
    "VERB"
  ],
  "handovers": [
    "NOUN"
  ],
  "bharadwaj": [
    "PROPN"
  ],
  "warned": [
    "VERB"
  ],
  "gifts": [
    "NOUN"
  ],
  "complying": [
    "VERB"
  ],
  "emphasise": [
    "VERB"
  ],
  "lowered": [
    "VERB"
  ],
  "strip": [
    "VERB"
  ],
  "refreshes": [
    "NOUN"
  ],
  "bethechange": [
    "NOUN"
  ],
  "stalled": [
    "VERB"
  ],
  "tighter": [
    "ADJ"
  ],
  "trialed": [
    "VERB"
  ],
  "personalised": [
    "ADJ"
  ],
  "hashing": [
    "VERB"
  ],
  "heightened": [
    "VERB"
  ],
  "preconfigured": [
    "VERB"
  ],
  "preparations": [
    "NOUN"
  ],
  "abhishek": [
    "PROPN"
  ],
  "lookups": [
    "NOUN"
  ],
  "switches": [
    "NOUN"
  ],
  "establishes": [
    "VERB"
  ],
  "todos": [
    "NOUN"
  ],
  "mergers": [
    "NOUN"
  ],
  "prepares": [
    "VERB"
  ],
  "reputational": [
    "ADJ"
  ],
  "arranged": [
    "VERB"
  ],
  "breakouts": [
    "NOUN"
  ],
  "innovating": [
    "VERB"
  ],
  "shirts": [
    "NOUN"
  ],
  "durations": [
    "NOUN"
  ],
  "reminded": [
    "VERB"
  ],
  "huang": [
    "PROPN"
  ],
  "automates": [
    "VERB"
  ],
  "vehicles": [
    "NOUN"
  ],
  "fleshed": [
    "VERB"
  ],
  "walked": [
    "VERB"
  ],
  "staffid": [
    "PROPN"
  ],
  "restructuring": [
    "NOUN"
  ],
  "excerpts": [
    "NOUN"
  ],
  "behaving": [
    "VERB"
  ],
  "shoes": [
    "NOUN"
  ],
  "inaccuracies": [
    "NOUN"
  ],
  "mixing": [
    "VERB"
  ],
  "replying": [
    "VERB"
  ],
  "afaik": [
    "PROPN"
  ],
  "creations": [
    "NOUN"
  ],
  "bookmarks": [
    "NOUN"
  ],
  "upskilling": [
    "VERB"
  ],
  "exacerbated": [
    "VERB"
  ],
  "swapped": [
    "VERB"
  ],
  "sells": [
    "VERB"
  ],
  "williams": [
    "PROPN"
  ],
  "suffered": [
    "VERB"
  ],
  "akshay": [
    "PROPN"
  ],
  "detractor": [
    "NOUN"
  ],
  "categorizing": [
    "VERB"
  ],
  "shortened": [
    "VERB"
  ],
  "manipulating": [
    "VERB"
  ],
  "gears": [
    "NOUN"
  ],
  "sherif": [
    "PROPN"
  ],
  "duplicative": [
    "ADJ"
  ],
  "recognizes": [
    "VERB"
  ],
  "advising": [
    "VERB"
  ],
  "crashes": [
    "NOUN"
  ],
  "customisations": [
    "NOUN"
  ],
  "convos": [
    "PROPN"
  ],
  "macbook": [
    "PROPN"
  ],
  "hacky": [
    "ADJ"
  ],
  "avenues": [
    "NOUN"
  ],
  "overlays": [
    "NOUN"
  ],
  "justified": [
    "VERB"
  ],
  "declaring": [
    "VERB"
  ],
  "agrawal": [
    "PROPN"
  ],
  "consultancy": [
    "NOUN"
  ],
  "patching": [
    "VERB"
  ],
  "contegix": [
    "PROPN"
  ],
  "nurturing": [
    "VERB"
  ],
  "accompanied": [
    "VERB"
  ],
  "descope": [
    "VERB"
  ],
  "balancers": [
    "NOUN"
  ],
  "deliveroo": [
    "PROPN"
  ],
  "feedbacks": [
    "NOUN"
  ],
  "flakes": [
    "NOUN"
  ],
  "indications": [
    "NOUN"
  ],
  "voltron": [
    "PROPN"
  ],
  "awarded": [
    "VERB"
  ],
  "ruled": [
    "VERB"
  ],
  "walls": [
    "NOUN"
  ],
  "conducts": [
    "VERB"
  ],
  "associating": [
    "VERB"
  ],
  "generations": [
    "NOUN"
  ],
  "preserving": [
    "VERB"
  ],
  "goodbye": [
    "NOUN"
  ],
  "meanings": [
    "NOUN"
  ],
  "architecting": [
    "VERB"
  ],
  "headshot": [
    "PROPN"
  ],
  "regressing": [
    "VERB"
  ],
  "benevity": [
    "PROPN"
  ],
  "flowchart": [
    "NOUN"
  ],
  "discouraged": [
    "VERB"
  ],
  "collated": [
    "VERB"
  ],
  "authorities": [
    "NOUN"
  ],
  "usernames": [
    "NOUN"
  ],
  "adventures": [
    "NOUN"
  ],
  "jumps": [
    "VERB"
  ],
  "frictionless": [
    "ADJ"
  ],
  "factored": [
    "VERB"
  ],
  "collaborations": [
    "NOUN"
  ],
  "rebrand": [
    "PROPN"
  ],
  "hydrating": [
    "VERB"
  ],
  "narrowed": [
    "VERB"
  ],
  "personalisation": [
    "NOUN"
  ],
  "illustrated": [
    "VERB"
  ],
  "outsized": [
    "ADJ"
  ],
  "revising": [
    "VERB"
  ],
  "employs": [
    "VERB"
  ],
  "employing": [
    "VERB"
  ],
  "jquery": [
    "PROPN"
  ],
  "documentations": [
    "NOUN"
  ],
  "presenters": [
    "NOUN"
  ],
  "adopts": [
    "VERB"
  ],
  "textarea": [
    "NOUN"
  ],
  "favourable": [
    "ADJ"
  ],
  "socials": [
    "NOUN"
  ],
  "extracts": [
    "VERB"
  ],
  "offboarding": [
    "VERB"
  ],
  "shareholders": [
    "NOUN"
  ],
  "fulfil": [
    "VERB"
  ],
  "wondered": [
    "VERB"
  ],
  "notebooks": [
    "NOUN"
  ],
  "orchestrates": [
    "VERB"
  ],
  "memes": [
    "NOUN"
  ],
  "digestible": [
    "ADJ"
  ],
  "pivoted": [
    "VERB"
  ],
  "encounters": [
    "VERB"
  ],
  "emits": [
    "VERB"
  ],
  "reimagining": [
    "VERB"
  ],
  "paginate": [
    "VERB"
  ],
  "altering": [
    "VERB"
  ],
  "tweaking": [
    "VERB"
  ],
  "corrections": [
    "NOUN"
  ],
  "showcased": [
    "VERB"
  ],
  "spins": [
    "VERB"
  ],
  "incurring": [
    "VERB"
  ],
  "waves": [
    "NOUN"
  ],
  "whitespace": [
    "NOUN"
  ],
  "posed": [
    "VERB"
  ],
  "wireframes": [
    "NOUN"
  ],
  "thompson": [
    "PROPN"
  ],
  "resolves": [
    "NOUN"
  ],
  "streamlines": [
    "VERB"
  ],
  "muted": [
    "VERB"
  ],
  "renderers": [
    "NOUN"
  ],
  "gaurav": [
    "PROPN"
  ],
  "pushback": [
    "NOUN"
  ],
  "intricacies": [
    "NOUN"
  ],
  "wrappers": [
    "NOUN"
  ],
  "deferring": [
    "VERB"
  ],
  "annualized": [
    "VERB"
  ],
  "farquhar": [
    "PROPN"
  ],
  "disabilities": [
    "NOUN"
  ],
  "miscommunication": [
    "NOUN"
  ],
  "nasdaq": [
    "PROPN"
  ],
  "ingests": [
    "VERB"
  ],
  "resetting": [
    "VERB"
  ],
  "hiking": [
    "NOUN"
  ],
  "strides": [
    "NOUN"
  ],
  "nearing": [
    "VERB"
  ],
  "truths": [
    "NOUN"
  ],
  "championing": [
    "VERB"
  ],
  "desires": [
    "NOUN"
  ],
  "advisors": [
    "NOUN"
  ],
  "ecosystems": [
    "NOUN"
  ],
  "exisiting": [
    "VERB"
  ],
  "instruments": [
    "NOUN"
  ],
  "optimizes": [
    "VERB"
  ],
  "clears": [
    "VERB"
  ],
  "visualizing": [
    "VERB"
  ],
  "wishes": [
    "VERB"
  ],
  "laderman": [
    "PROPN"
  ],
  "equivalents": [
    "NOUN"
  ],
  "badpokerface": [
    "NOUN"
  ],
  "tenured": [
    "ADJ"
  ],
  "cracks": [
    "NOUN"
  ],
  "motivates": [
    "VERB"
  ],
  "overloading": [
    "VERB"
  ],
  "outsourced": [
    "VERB"
  ],
  "consolidates": [
    "VERB"
  ],
  "tuesdays": [
    "PROPN"
  ],
  "expressing": [
    "VERB"
  ],
  "aiding": [
    "VERB"
  ],
  "rails": [
    "NOUN"
  ],
  "reinforces": [
    "VERB"
  ],
  "pausing": [
    "VERB"
  ],
  "travels": [
    "NOUN"
  ],
  "averaging": [
    "VERB"
  ],
  "paradigms": [
    "NOUN"
  ],
  "italy": [
    "PROPN"
  ],
  "embodies": [
    "VERB"
  ],
  "mountains": [
    "NOUN"
  ],
  "servicing": [
    "VERB"
  ],
  "subsets": [
    "NOUN"
  ],
  "halls": [
    "PROPN"
  ],
  "prepping": [
    "VERB"
  ],
  "hiccups": [
    "NOUN"
  ],
  "interoperability": [
    "NOUN"
  ],
  "yubikey": [
    "PROPN"
  ],
  "inferred": [
    "VERB"
  ],
  "necessitates": [
    "VERB"
  ],
  "reloading": [
    "VERB"
  ],
  "instantiate": [
    "VERB"
  ],
  "vibes": [
    "NOUN"
  ],
  "offload": [
    "VERB"
  ],
  "abbreviated": [
    "VERB"
  ],
  "schools": [
    "NOUN"
  ],
  "reusability": [
    "NOUN"
  ],
  "bugfixes": [
    "NOUN"
  ],
  "verifications": [
    "NOUN"
  ],
  "replicates": [
    "VERB"
  ],
  "emphasized": [
    "VERB"
  ],
  "downsides": [
    "NOUN"
  ],
  "dictates": [
    "VERB"
  ],
  "requestors": [
    "NOUN"
  ],
  "productionized": [
    "VERB"
  ],
  "engineered": [
    "VERB"
  ],
  "reorgs": [
    "NOUN"
  ],
  "clipboard": [
    "NOUN"
  ],
  "wanna": [
    "VERB"
  ],
  "gdansk": [
    "PROPN"
  ],
  "expandable": [
    "ADJ"
  ],
  "permits": [
    "VERB"
  ],
  "capitalized": [
    "VERB"
  ],
  "authored": [
    "VERB"
  ],
  "overwriting": [
    "VERB"
  ],
  "invitees": [
    "NOUN"
  ],
  "assurances": [
    "NOUN"
  ],
  "hindered": [
    "VERB"
  ],
  "pointers": [
    "NOUN"
  ],
  "gotchas": [
    "NOUN"
  ],
  "frees": [
    "VERB"
  ],
  "proves": [
    "VERB"
  ],
  "assists": [
    "VERB"
  ],
  "rebuilding": [
    "VERB"
  ],
  "redesigning": [
    "VERB"
  ],
  "hinders": [
    "VERB"
  ],
  "matures": [
    "NOUN"
  ],
  "aways": [
    "NOUN"
  ],
  "chatted": [
    "VERB"
  ],
  "auditable": [
    "ADJ"
  ],
  "immersed": [
    "VERB"
  ],
  "volunteered": [
    "VERB"
  ],
  "interpretations": [
    "NOUN"
  ],
  "concatenated": [
    "VERB"
  ],
  "accompanying": [
    "VERB"
  ],
  "concludes": [
    "VERB"
  ],
  "signifies": [
    "VERB"
  ],
  "fosters": [
    "NOUN"
  ],
  "reinforced": [
    "VERB"
  ],
  "reassess": [
    "VERB"
  ],
  "guessed": [
    "VERB"
  ],
  "styled": [
    "VERB"
  ],
  "entails": [
    "VERB"
  ],
  "catering": [
    "VERB"
  ],
  "noticing": [
    "VERB"
  ],
  "forks": [
    "NOUN"
  ],
  "visualising": [
    "VERB"
  ],
  "constructing": [
    "VERB"
  ],
  "suppressions": [
    "NOUN"
  ],
  "reimbursed": [
    "VERB"
  ],
  "popped": [
    "VERB"
  ],
  "solutioning": [
    "VERB"
  ],
  "computations": [
    "NOUN"
  ],
  "shareable": [
    "ADJ"
  ],
  "encapsulated": [
    "VERB"
  ],
  "bounds": [
    "NOUN"
  ],
  "popping": [
    "VERB"
  ],
  "meetingnotes": [
    "NOUN"
  ],
  "passions": [
    "NOUN"
  ],
  "cadences": [
    "NOUN"
  ],
  "mandating": [
    "VERB"
  ],
  "quickest": [
    "ADJ"
  ],
  "speeds": [
    "VERB"
  ],
  "allotted": [
    "VERB"
  ],
  "celebrations": [
    "NOUN"
  ],
  "rewritten": [
    "VERB"
  ],
  "formalize": [
    "VERB"
  ],
  "multiselect": [
    "NOUN"
  ],
  "peoples": [
    "NOUN"
  ],
  "vacations": [
    "NOUN"
  ],
  "apologies": [
    "NOUN"
  ],
  "remembering": [
    "VERB"
  ],
  "boxed": [
    "VERB"
  ],
  "penalties": [
    "NOUN"
  ],
  "dogfood": [
    "NOUN"
  ],
  "phones": [
    "NOUN"
  ],
  "kickstart": [
    "VERB"
  ],
  "authenticating": [
    "VERB"
  ]
}